(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref931"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref931"] = parcelRequire;
}
parcelRequire.register("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRequire.register("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRequire.register("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1ObTH = parcelRequire("1ObTH");
var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function forEach(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});
parcelRequire.register("1ObTH", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $1513b08bb76c1101$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $1513b08bb76c1101$export$5f0017c582d45a2d; });
function $1513b08bb76c1101$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRequire.register("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $1ObTH = parcelRequire("1ObTH");
var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $1ObTH._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $1ObTH._)(c)));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function get() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function onError(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    var b = function b(_b) {
        return $e8dfc29dafb3bbd7$var$ad(_b, a);
    };
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    var b = function b(_b, d, e, f, g) {
        this._reactName = _b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (_b = a[c], this[c] = _b ? _b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    };
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $1ObTH._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $1ObTH._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function persist() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var _$d = f, _$e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $e8dfc29dafb3bbd7$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = _$d ? $e8dfc29dafb3bbd7$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = _$d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, _$e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = _$e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(_$d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) _$d = $e8dfc29dafb3bbd7$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function Jf(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $e8dfc29dafb3bbd7$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    var b = function b(_b, c) {
        if (a) {
            var d = _b.deletions;
            null === d ? (_b.deletions = [
                c
            ], _b.flags |= 16) : d.push(c);
        }
    };
    var c = function c(_c, d) {
        if (!a) return null;
        for(; null !== d;)b(_c, d), d = d.sibling;
        return null;
    };
    var d = function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    };
    var e = function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    };
    var f = function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    };
    var g = function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    };
    var h = function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var k = function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    };
    var l = function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    };
    var m = function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var n = function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    };
    var t = function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    };
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function useCallback(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function useState() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function useState() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function Bj() {};
$e8dfc29dafb3bbd7$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a), ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(_$a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function Hc() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function Ic(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRequire.register("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function S() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function S() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function S() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRequire.register("7KkEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = module.exports.BrowserLocalStorageKeyStore = module.exports.InMemoryKeyStore = module.exports.KeyStore = void 0;

var $eJ8Lr = parcelRequire("eJ8Lr");
Object.defineProperty(module.exports, "KeyStore", {
    enumerable: true,
    get: function get() {
        return $eJ8Lr.KeyStore;
    }
});

var $5u7wK = parcelRequire("5u7wK");
Object.defineProperty(module.exports, "InMemoryKeyStore", {
    enumerable: true,
    get: function get() {
        return $5u7wK.InMemoryKeyStore;
    }
});

var $3dAWg = parcelRequire("3dAWg");
Object.defineProperty(module.exports, "BrowserLocalStorageKeyStore", {
    enumerable: true,
    get: function get() {
        return $3dAWg.BrowserLocalStorageKeyStore;
    }
});

var $llqmF = parcelRequire("llqmF");
Object.defineProperty(module.exports, "MergeKeyStore", {
    enumerable: true,
    get: function get() {
        return $llqmF.MergeKeyStore;
    }
});

});
parcelRequire.register("eJ8Lr", function(module, exports) {

var $978gY = parcelRequire("978gY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyStore = void 0;
/**
 * KeyStores are passed to {@link Near} via {@link NearConfig}
 * and are used by the {@link InMemorySigner} to sign transactions.
 *
 * @example {@link connect}
 */ var $ab8c11088422d1da$var$KeyStore = function KeyStore() {
    (0, $978gY._)(this, KeyStore);
};
module.exports.KeyStore = $ab8c11088422d1da$var$KeyStore;

});
parcelRequire.register("978gY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6a2b2f5024d4ec83$export$2996f80ef42b8419; });
function $6a2b2f5024d4ec83$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});


parcelRequire.register("5u7wK", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryKeyStore = void 0;

var $eJ8Lr = parcelRequire("eJ8Lr");

var $8pTGX = parcelRequire("8pTGX");
/**
 * Simple in-memory keystore for mainly for testing purposes.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store}
 * @example
 * ```js
 * import { connect, keyStores, utils } from 'near-api-js';
 *
 * const privateKey = '.......';
 * const keyPair = utils.KeyPair.fromString(privateKey);
 *
 * const keyStore = new keyStores.InMemoryKeyStore();
 * keyStore.setKey('testnet', 'example-account.testnet', keyPair);
 *
 * const config = {
 *   keyStore, // instance of InMemoryKeyStore
 *   networkId: 'testnet',
 *   nodeUrl: 'https://rpc.testnet.near.org',
 *   walletUrl: 'https://wallet.testnet.near.org',
 *   helperUrl: 'https://helper.testnet.near.org',
 *   explorerUrl: 'https://explorer.testnet.near.org'
 * };
 *
 * // inside an async function
 * const near = await connect(config)
 * ```
 */ var $3fe597db642ab0b1$var$InMemoryKeyStore = /*#__PURE__*/ function(_keystore_1_KeyStore) {
    (0, $ftJVG._)(InMemoryKeyStore, _keystore_1_KeyStore);
    var _super = (0, $6OZAO._)(InMemoryKeyStore);
    function InMemoryKeyStore() {
        (0, $978gY._)(this, InMemoryKeyStore);
        var _this;
        _this = _super.call(this);
        _this.keys = {};
        return _this;
    }
    (0, $kry2a._)(InMemoryKeyStore, [
        {
            key: "setKey",
            value: /**
     * Stores a {@KeyPair} in in-memory storage item
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ function setKey(networkId, accountId, keyPair) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.keys["".concat(accountId, ":").concat(networkId)] = keyPair.toString();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getKey",
            value: /**
     * Gets a {@link KeyPair} from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ function getKey(networkId, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var value;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        value = _this.keys["".concat(accountId, ":").concat(networkId)];
                        if (!value) return [
                            2,
                            null
                        ];
                        return [
                            2,
                            $8pTGX.KeyPair.fromString(value)
                        ];
                    });
                })();
            }
        },
        {
            key: "removeKey",
            value: /**
     * Removes a {@link KeyPair} from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ function removeKey(networkId, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        delete _this.keys["".concat(accountId, ":").concat(networkId)];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "clear",
            value: /**
     * Removes all {@link KeyPairs} from in-memory storage
     */ function clear() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.keys = {};
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getNetworks",
            value: /**
     * Get the network(s) from in-memory storage
     * @returns {Promise<string[]>}
     */ function getNetworks() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        result = new Set();
                        Object.keys(_this.keys).forEach(function(key) {
                            var parts = key.split(":");
                            result.add(parts[1]);
                        });
                        return [
                            2,
                            Array.from(result.values())
                        ];
                    });
                })();
            }
        },
        {
            key: "getAccounts",
            value: /**
     * Gets the account(s) from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns{Promise<string[]>}
     */ function getAccounts(networkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        result = new Array();
                        Object.keys(_this.keys).forEach(function(key) {
                            var parts = key.split(":");
                            if (parts[parts.length - 1] === networkId) result.push(parts.slice(0, parts.length - 1).join(":"));
                        });
                        return [
                            2,
                            result
                        ];
                    });
                })();
            }
        },
        {
            /** @hidden */ key: "toString",
            value: function toString() {
                return "InMemoryKeyStore";
            }
        }
    ]);
    return InMemoryKeyStore;
}($eJ8Lr.KeyStore);
module.exports.InMemoryKeyStore = $3fe597db642ab0b1$var$InMemoryKeyStore;

});
parcelRequire.register("byzP8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $869ea882f885334a$export$7c398597f8905a1; });
function $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $869ea882f885334a$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRequire.register("kry2a", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee20bab046a9ef96$export$d60067ff2358eee8; });
function $ee20bab046a9ef96$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee20bab046a9ef96$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ee20bab046a9ef96$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee20bab046a9ef96$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("ftJVG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b44d311756de33f4$export$7e4530ad35d3bb8; });

var $azwGX = parcelRequire("azwGX");
function $b44d311756de33f4$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $azwGX._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("azwGX", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $7b26882fd1cd0ac2$export$c2c98ac76e997b63; });
function $7b26882fd1cd0ac2$export$c2c98ac76e997b63(o, p) {
    $7b26882fd1cd0ac2$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7b26882fd1cd0ac2$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("6OZAO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f7730a4a64324ea$export$8dd05c13f5255580; });

var $g3d7z = parcelRequire("g3d7z");

var $1vcmW = parcelRequire("1vcmW");

var $ho5gk = parcelRequire("ho5gk");
function $4f7730a4a64324ea$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $1vcmW._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $g3d7z._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $g3d7z._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ho5gk._possible_constructor_return)(this, result);
    };
}

});
parcelRequire.register("g3d7z", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $baf71ab6cd4d51b1$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $baf71ab6cd4d51b1$export$f09211a7d3c496a1; });
function $baf71ab6cd4d51b1$export$f09211a7d3c496a1(o) {
    $baf71ab6cd4d51b1$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $baf71ab6cd4d51b1$export$f09211a7d3c496a1(o);
}

});

parcelRequire.register("1vcmW", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $118247e7c3dd6008$export$685354647fba1516; });
function $118247e7c3dd6008$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("ho5gk", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $ca88c28e2dc74ceb$export$ef97c660ca164e52; });

var $3vWwE = parcelRequire("3vWwE");

var $1ObTH = parcelRequire("1ObTH");
function $ca88c28e2dc74ceb$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $1ObTH._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $3vWwE._assert_this_initialized)(self);
}

});
parcelRequire.register("3vWwE", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8; });
function $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRequire.register("7UAGh", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $5c2a37736a53c5f6$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $5c2a37736a53c5f6$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $5c2a37736a53c5f6$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $5c2a37736a53c5f6$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $5c2a37736a53c5f6$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $5c2a37736a53c5f6$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $5c2a37736a53c5f6$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $1ObTH = parcelRequire("1ObTH");
var $5c2a37736a53c5f6$var$extendStatics = function extendStatics1(d, b) {
    $5c2a37736a53c5f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c2a37736a53c5f6$var$extendStatics(d, b);
};
function $5c2a37736a53c5f6$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c2a37736a53c5f6$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c2a37736a53c5f6$export$18ce0697a983be9b = function __assign1() {
    $5c2a37736a53c5f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c2a37736a53c5f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c2a37736a53c5f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c2a37736a53c5f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c2a37736a53c5f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c2a37736a53c5f6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c2a37736a53c5f6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c2a37736a53c5f6$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $1ObTH._)(x)) === "symbol" ? x : "".concat(x);
}
function $5c2a37736a53c5f6$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $1ObTH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c2a37736a53c5f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c2a37736a53c5f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c2a37736a53c5f6$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $5c2a37736a53c5f6$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c2a37736a53c5f6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c2a37736a53c5f6$export$45d3717a4c69092e(o, m, p);
}
function $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c2a37736a53c5f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c2a37736a53c5f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c2a37736a53c5f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c2a37736a53c5f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c2a37736a53c5f6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c2a37736a53c5f6$export$10c90e4f7922046c(v) {
    return this instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? (this.v = v, this) : new $5c2a37736a53c5f6$export$10c90e4f7922046c(v);
}
function $5c2a37736a53c5f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $5c2a37736a53c5f6$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c2a37736a53c5f6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $5c2a37736a53c5f6$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c2a37736a53c5f6$export$19a8beecd37a4c45 === "function" ? $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $5c2a37736a53c5f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c2a37736a53c5f6$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c2a37736a53c5f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c2a37736a53c5f6$export$45d3717a4c69092e(result, mod, k);
    }
    $5c2a37736a53c5f6$var$__setModuleDefault(result, mod);
    return result;
}
function $5c2a37736a53c5f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c2a37736a53c5f6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c2a37736a53c5f6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c2a37736a53c5f6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c2a37736a53c5f6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c2a37736a53c5f6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c2a37736a53c5f6$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $5c2a37736a53c5f6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c2a37736a53c5f6$export$2e2bcd8739ae039 = {
    __extends: $5c2a37736a53c5f6$export$a8ba968b8961cb8a,
    __assign: $5c2a37736a53c5f6$export$18ce0697a983be9b,
    __rest: $5c2a37736a53c5f6$export$3c9a16f847548506,
    __decorate: $5c2a37736a53c5f6$export$29e00dfd3077644b,
    __param: $5c2a37736a53c5f6$export$d5ad3fd78186038f,
    __metadata: $5c2a37736a53c5f6$export$f1db080c865becb9,
    __awaiter: $5c2a37736a53c5f6$export$1050f835b63b671e,
    __generator: $5c2a37736a53c5f6$export$67ebef60e6f28a6,
    __createBinding: $5c2a37736a53c5f6$export$45d3717a4c69092e,
    __exportStar: $5c2a37736a53c5f6$export$f33643c0debef087,
    __values: $5c2a37736a53c5f6$export$19a8beecd37a4c45,
    __read: $5c2a37736a53c5f6$export$8d051b38c9118094,
    __spread: $5c2a37736a53c5f6$export$afc72e2116322959,
    __spreadArrays: $5c2a37736a53c5f6$export$6388937ca91ccae8,
    __spreadArray: $5c2a37736a53c5f6$export$1216008129fb82ed,
    __await: $5c2a37736a53c5f6$export$10c90e4f7922046c,
    __asyncGenerator: $5c2a37736a53c5f6$export$e427f37a30a4de9b,
    __asyncDelegator: $5c2a37736a53c5f6$export$bbd80228419bb833,
    __asyncValues: $5c2a37736a53c5f6$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c2a37736a53c5f6$export$4fb47efe1390b86f,
    __importStar: $5c2a37736a53c5f6$export$c21735bcef00d192,
    __importDefault: $5c2a37736a53c5f6$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c2a37736a53c5f6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c2a37736a53c5f6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c2a37736a53c5f6$export$81fdc39f203e4e04,
    __addDisposableResource: $5c2a37736a53c5f6$export$88ac25d8e944e405,
    __disposeResources: $5c2a37736a53c5f6$export$8f076105dc360e92
};

});

parcelRequire.register("8pTGX", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
var $620bdbc5cdd7a03d$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyPairEd25519 = module.exports.KeyPair = module.exports.PublicKey = module.exports.KeyType = void 0;

var $620bdbc5cdd7a03d$var$tweetnacl_1 = $620bdbc5cdd7a03d$var$__importDefault((parcelRequire("44JIq")));

var $2RCX3 = parcelRequire("2RCX3");

var $5dmHG = parcelRequire("5dmHG");
/** All supported key types */ var $620bdbc5cdd7a03d$var$KeyType;
(function(KeyType) {
    KeyType[KeyType["ED25519"] = 0] = "ED25519";
})($620bdbc5cdd7a03d$var$KeyType = module.exports.KeyType || (module.exports.KeyType = {}));
function $620bdbc5cdd7a03d$var$key_type_to_str(keyType) {
    switch(keyType){
        case $620bdbc5cdd7a03d$var$KeyType.ED25519:
            return "ed25519";
        default:
            throw new Error("Unknown key type ".concat(keyType));
    }
}
function $620bdbc5cdd7a03d$var$str_to_key_type(keyType) {
    switch(keyType.toLowerCase()){
        case "ed25519":
            return $620bdbc5cdd7a03d$var$KeyType.ED25519;
        default:
            throw new Error("Unknown key type ".concat(keyType));
    }
}
/**
 * PublicKey representation that has type and bytes of the key.
 */ var $620bdbc5cdd7a03d$var$PublicKey = /*#__PURE__*/ function(_enums_1_Assignable) {
    (0, $ftJVG._)(PublicKey, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(PublicKey);
    function PublicKey() {
        (0, $978gY._)(this, PublicKey);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(PublicKey, [
        {
            key: "toString",
            value: function toString() {
                return "".concat($620bdbc5cdd7a03d$var$key_type_to_str(this.keyType), ":").concat($2RCX3.base_encode(this.data));
            }
        },
        {
            key: "verify",
            value: function verify(message, signature) {
                switch(this.keyType){
                    case $620bdbc5cdd7a03d$var$KeyType.ED25519:
                        return $620bdbc5cdd7a03d$var$tweetnacl_1.default.sign.detached.verify(message, signature, this.data);
                    default:
                        throw new Error("Unknown key type ".concat(this.keyType));
                }
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return PublicKey.fromString(value);
                return value;
            }
        },
        {
            key: "fromString",
            value: function fromString(encodedKey) {
                var parts = encodedKey.split(":");
                if (parts.length === 1) return new PublicKey({
                    keyType: $620bdbc5cdd7a03d$var$KeyType.ED25519,
                    data: $2RCX3.base_decode(parts[0])
                });
                else if (parts.length === 2) return new PublicKey({
                    keyType: $620bdbc5cdd7a03d$var$str_to_key_type(parts[0]),
                    data: $2RCX3.base_decode(parts[1])
                });
                else throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
            }
        }
    ]);
    return PublicKey;
}($5dmHG.Assignable);
module.exports.PublicKey = $620bdbc5cdd7a03d$var$PublicKey;
var $620bdbc5cdd7a03d$var$KeyPair = /*#__PURE__*/ function() {
    function KeyPair() {
        (0, $978gY._)(this, KeyPair);
    }
    (0, $kry2a._)(KeyPair, null, [
        {
            key: "fromRandom",
            value: /**
     * @param curve Name of elliptical curve, case-insensitive
     * @returns Random KeyPair based on the curve
     */ function fromRandom(curve) {
                switch(curve.toUpperCase()){
                    case "ED25519":
                        return $620bdbc5cdd7a03d$var$KeyPairEd25519.fromRandom();
                    default:
                        throw new Error("Unknown curve ".concat(curve));
                }
            }
        },
        {
            key: "fromString",
            value: function fromString(encodedKey) {
                var parts = encodedKey.split(":");
                if (parts.length === 1) return new $620bdbc5cdd7a03d$var$KeyPairEd25519(parts[0]);
                else if (parts.length === 2) switch(parts[0].toUpperCase()){
                    case "ED25519":
                        return new $620bdbc5cdd7a03d$var$KeyPairEd25519(parts[1]);
                    default:
                        throw new Error("Unknown curve: ".concat(parts[0]));
                }
                else throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
            }
        }
    ]);
    return KeyPair;
}();
module.exports.KeyPair = $620bdbc5cdd7a03d$var$KeyPair;
/**
 * This class provides key pair functionality for Ed25519 curve:
 * generating key pairs, encoding key pairs, signing and verifying.
 */ var $620bdbc5cdd7a03d$var$KeyPairEd25519 = /*#__PURE__*/ function(KeyPair) {
    (0, $ftJVG._)(KeyPairEd25519, KeyPair);
    var _super = (0, $6OZAO._)(KeyPairEd25519);
    function KeyPairEd25519(secretKey) {
        (0, $978gY._)(this, KeyPairEd25519);
        var _this;
        _this = _super.call(this);
        var keyPair = $620bdbc5cdd7a03d$var$tweetnacl_1.default.sign.keyPair.fromSecretKey($2RCX3.base_decode(secretKey));
        _this.publicKey = new $620bdbc5cdd7a03d$var$PublicKey({
            keyType: $620bdbc5cdd7a03d$var$KeyType.ED25519,
            data: keyPair.publicKey
        });
        _this.secretKey = secretKey;
        return _this;
    }
    (0, $kry2a._)(KeyPairEd25519, [
        {
            key: "sign",
            value: function sign(message) {
                var signature = $620bdbc5cdd7a03d$var$tweetnacl_1.default.sign.detached(message, $2RCX3.base_decode(this.secretKey));
                return {
                    signature: signature,
                    publicKey: this.publicKey
                };
            }
        },
        {
            key: "verify",
            value: function verify(message, signature) {
                return this.publicKey.verify(message, signature);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "ed25519:".concat(this.secretKey);
            }
        },
        {
            key: "getPublicKey",
            value: function getPublicKey() {
                return this.publicKey;
            }
        }
    ], [
        {
            key: "fromRandom",
            value: /**
     * Generate a new random keypair.
     * @example
     * const keyRandom = KeyPair.fromRandom();
     * keyRandom.publicKey
     * // returns [PUBLIC_KEY]
     *
     * keyRandom.secretKey
     * // returns [SECRET_KEY]
     */ function fromRandom() {
                var newKeyPair = $620bdbc5cdd7a03d$var$tweetnacl_1.default.sign.keyPair();
                return new KeyPairEd25519($2RCX3.base_encode(newKeyPair.secretKey));
            }
        }
    ]);
    return KeyPairEd25519;
}($620bdbc5cdd7a03d$var$KeyPair);
module.exports.KeyPairEd25519 = $620bdbc5cdd7a03d$var$KeyPairEd25519;

});
parcelRequire.register("44JIq", function(module, exports) {

(function(nacl) {
    "use strict";
    var ts64 = function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    };
    var vn = function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    };
    var crypto_verify_16 = function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    };
    var crypto_verify_32 = function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    };
    var core_salsa20 = function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    };
    var core_hsalsa20 = function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    };
    var crypto_core_salsa20 = function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    };
    var crypto_core_hsalsa20 = function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    };
    var crypto_stream_salsa20_xor = // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    };
    var crypto_stream_salsa20 = function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    };
    var crypto_stream = function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    };
    var crypto_stream_xor = function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    };
    var crypto_onetimeauth = function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    };
    var crypto_onetimeauth_verify = function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    };
    var crypto_secretbox = function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    };
    var crypto_secretbox_open = function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    };
    var set25519 = function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    };
    var car25519 = function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    };
    var sel25519 = function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    };
    var pack25519 = function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    };
    var neq25519 = function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    };
    var par25519 = function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    };
    var unpack25519 = function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    };
    var A = function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    };
    var Z = function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    };
    var M = function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    };
    var S = function S(o, a) {
        M(o, a, a);
    };
    var inv25519 = function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    };
    var pow2523 = function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    };
    var crypto_scalarmult = function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    };
    var crypto_scalarmult_base = function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    };
    var crypto_box_keypair = function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    };
    var crypto_box_beforenm = function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    };
    var crypto_box = function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    };
    var crypto_box_open = function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    };
    var crypto_hashblocks_hl = function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    };
    var crypto_hash = function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    };
    var add = function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    };
    var cswap = function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    };
    var pack = function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    };
    var scalarmult = function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    };
    var scalarbase = function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    };
    var crypto_sign_keypair = function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    };
    var modL = function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    };
    var reduce = function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    };
    var crypto_sign = // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    };
    var unpackneg = function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    };
    var crypto_sign_open = function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    };
    var checkLengths = /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    };
    var checkBoxLengths = function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    };
    var checkArrayTypes = function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    };
    var cleanup = function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    };
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function gf(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function randombytes() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function poly1305(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = (parcelRequire("aqbQf"));
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

});
parcelRequire.register("aqbQf", function(module, exports) {
"use strict";

});


parcelRequire.register("2RCX3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2HPkT = parcelRequire("2HPkT");
Object.defineProperty(module.exports, "base_encode", {
    enumerable: true,
    get: function get() {
        return $2HPkT.baseEncode;
    }
});
Object.defineProperty(module.exports, "base_decode", {
    enumerable: true,
    get: function get() {
        return $2HPkT.baseDecode;
    }
});
Object.defineProperty(module.exports, "serialize", {
    enumerable: true,
    get: function get() {
        return $2HPkT.serialize;
    }
});
Object.defineProperty(module.exports, "deserialize", {
    enumerable: true,
    get: function get() {
        return $2HPkT.deserialize;
    }
});
Object.defineProperty(module.exports, "BorshError", {
    enumerable: true,
    get: function get() {
        return $2HPkT.BorshError;
    }
});
Object.defineProperty(module.exports, "BinaryWriter", {
    enumerable: true,
    get: function get() {
        return $2HPkT.BinaryWriter;
    }
});
Object.defineProperty(module.exports, "BinaryReader", {
    enumerable: true,
    get: function get() {
        return $2HPkT.BinaryReader;
    }
});

});
parcelRequire.register("2HPkT", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $gzLuY = parcelRequire("gzLuY");
var $1f876b2d27fa1bad$require$Buffer = $gzLuY.Buffer;
"use strict";
var $1f876b2d27fa1bad$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1f876b2d27fa1bad$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1f876b2d27fa1bad$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1f876b2d27fa1bad$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $1f876b2d27fa1bad$var$__createBinding(result, mod, k);
    }
    $1f876b2d27fa1bad$var$__setModuleDefault(result, mod);
    return result;
};
var $1f876b2d27fa1bad$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

var $1f876b2d27fa1bad$var$bn_js_1 = $1f876b2d27fa1bad$var$__importDefault((parcelRequire("jlWHo")));

var $1f876b2d27fa1bad$var$bs58_1 = $1f876b2d27fa1bad$var$__importDefault((parcelRequire("5m7wF")));

// TODO: Make sure this polyfill not included when not required
var $1f876b2d27fa1bad$var$encoding = $1f876b2d27fa1bad$var$__importStar((parcelRequire("7fpPy")));
var $1f876b2d27fa1bad$var$TextDecoder = typeof $parcel$global.TextDecoder !== "function" ? $1f876b2d27fa1bad$var$encoding.TextDecoder : $parcel$global.TextDecoder;
var $1f876b2d27fa1bad$var$textDecoder = new $1f876b2d27fa1bad$var$TextDecoder("utf-8", {
    fatal: true
});
function $1f876b2d27fa1bad$var$baseEncode(value) {
    if (typeof value === "string") value = $1f876b2d27fa1bad$require$Buffer.from(value, "utf8");
    return $1f876b2d27fa1bad$var$bs58_1.default.encode($1f876b2d27fa1bad$require$Buffer.from(value));
}
module.exports.baseEncode = $1f876b2d27fa1bad$var$baseEncode;
function $1f876b2d27fa1bad$var$baseDecode(value) {
    return $1f876b2d27fa1bad$require$Buffer.from($1f876b2d27fa1bad$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $1f876b2d27fa1bad$var$baseDecode;
var $1f876b2d27fa1bad$var$INITIAL_LENGTH = 1024;
var $1f876b2d27fa1bad$var$BorshError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(BorshError, Error1);
    var _super = (0, $6OZAO._)(BorshError);
    function BorshError(message) {
        (0, $978gY._)(this, BorshError);
        var _this;
        _this = _super.call(this, message);
        _this.fieldPath = [];
        _this.originalMessage = message;
        return _this;
    }
    (0, $kry2a._)(BorshError, [
        {
            key: "addToFieldPath",
            value: function addToFieldPath(fieldName) {
                this.fieldPath.splice(0, 0, fieldName);
                // NOTE: Modifying message directly as jest doesn't use .toString()
                this.message = this.originalMessage + ": " + this.fieldPath.join(".");
            }
        }
    ]);
    return BorshError;
}((0, $2TMdq._)(Error));
module.exports.BorshError = $1f876b2d27fa1bad$var$BorshError;
/// Binary encoder.
var $1f876b2d27fa1bad$var$BinaryWriter = /*#__PURE__*/ function() {
    "use strict";
    function BinaryWriter() {
        (0, $978gY._)(this, BinaryWriter);
        this.buf = $1f876b2d27fa1bad$require$Buffer.alloc($1f876b2d27fa1bad$var$INITIAL_LENGTH);
        this.length = 0;
    }
    (0, $kry2a._)(BinaryWriter, [
        {
            key: "maybeResize",
            value: function maybeResize() {
                if (this.buf.length < 16 + this.length) this.buf = $1f876b2d27fa1bad$require$Buffer.concat([
                    this.buf,
                    $1f876b2d27fa1bad$require$Buffer.alloc($1f876b2d27fa1bad$var$INITIAL_LENGTH)
                ]);
            }
        },
        {
            key: "writeU8",
            value: function writeU8(value) {
                this.maybeResize();
                this.buf.writeUInt8(value, this.length);
                this.length += 1;
            }
        },
        {
            key: "writeU16",
            value: function writeU16(value) {
                this.maybeResize();
                this.buf.writeUInt16LE(value, this.length);
                this.length += 2;
            }
        },
        {
            key: "writeU32",
            value: function writeU32(value) {
                this.maybeResize();
                this.buf.writeUInt32LE(value, this.length);
                this.length += 4;
            }
        },
        {
            key: "writeU64",
            value: function writeU64(value) {
                this.maybeResize();
                this.writeBuffer($1f876b2d27fa1bad$require$Buffer.from(new $1f876b2d27fa1bad$var$bn_js_1.default(value).toArray("le", 8)));
            }
        },
        {
            key: "writeU128",
            value: function writeU128(value) {
                this.maybeResize();
                this.writeBuffer($1f876b2d27fa1bad$require$Buffer.from(new $1f876b2d27fa1bad$var$bn_js_1.default(value).toArray("le", 16)));
            }
        },
        {
            key: "writeU256",
            value: function writeU256(value) {
                this.maybeResize();
                this.writeBuffer($1f876b2d27fa1bad$require$Buffer.from(new $1f876b2d27fa1bad$var$bn_js_1.default(value).toArray("le", 32)));
            }
        },
        {
            key: "writeU512",
            value: function writeU512(value) {
                this.maybeResize();
                this.writeBuffer($1f876b2d27fa1bad$require$Buffer.from(new $1f876b2d27fa1bad$var$bn_js_1.default(value).toArray("le", 64)));
            }
        },
        {
            key: "writeBuffer",
            value: function writeBuffer(buffer) {
                // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
                this.buf = $1f876b2d27fa1bad$require$Buffer.concat([
                    $1f876b2d27fa1bad$require$Buffer.from(this.buf.subarray(0, this.length)),
                    buffer,
                    $1f876b2d27fa1bad$require$Buffer.alloc($1f876b2d27fa1bad$var$INITIAL_LENGTH)
                ]);
                this.length += buffer.length;
            }
        },
        {
            key: "writeString",
            value: function writeString(str) {
                this.maybeResize();
                var b = $1f876b2d27fa1bad$require$Buffer.from(str, "utf8");
                this.writeU32(b.length);
                this.writeBuffer(b);
            }
        },
        {
            key: "writeFixedArray",
            value: function writeFixedArray(array) {
                this.writeBuffer($1f876b2d27fa1bad$require$Buffer.from(array));
            }
        },
        {
            key: "writeArray",
            value: function writeArray(array, fn) {
                this.maybeResize();
                this.writeU32(array.length);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var elem = _step.value;
                        this.maybeResize();
                        fn(elem);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.buf.subarray(0, this.length);
            }
        }
    ]);
    return BinaryWriter;
}();
module.exports.BinaryWriter = $1f876b2d27fa1bad$var$BinaryWriter;
function $1f876b2d27fa1bad$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    var originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                var code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $1f876b2d27fa1bad$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
var $1f876b2d27fa1bad$var$BinaryReader = /*#__PURE__*/ function() {
    "use strict";
    function BinaryReader(buf) {
        (0, $978gY._)(this, BinaryReader);
        this.buf = buf;
        this.offset = 0;
    }
    (0, $kry2a._)(BinaryReader, [
        {
            key: "readU8",
            value: function readU8() {
                var value = this.buf.readUInt8(this.offset);
                this.offset += 1;
                return value;
            }
        },
        {
            key: "readU16",
            value: function readU16() {
                var value = this.buf.readUInt16LE(this.offset);
                this.offset += 2;
                return value;
            }
        },
        {
            key: "readU32",
            value: function readU32() {
                var value = this.buf.readUInt32LE(this.offset);
                this.offset += 4;
                return value;
            }
        },
        {
            key: "readU64",
            value: function readU64() {
                var buf = this.readBuffer(8);
                return new $1f876b2d27fa1bad$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU128",
            value: function readU128() {
                var buf = this.readBuffer(16);
                return new $1f876b2d27fa1bad$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU256",
            value: function readU256() {
                var buf = this.readBuffer(32);
                return new $1f876b2d27fa1bad$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU512",
            value: function readU512() {
                var buf = this.readBuffer(64);
                return new $1f876b2d27fa1bad$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readBuffer",
            value: function readBuffer(len) {
                if (this.offset + len > this.buf.length) throw new $1f876b2d27fa1bad$var$BorshError("Expected buffer length ".concat(len, " isn't within bounds"));
                var result = this.buf.slice(this.offset, this.offset + len);
                this.offset += len;
                return result;
            }
        },
        {
            key: "readString",
            value: function readString() {
                var len = this.readU32();
                var buf = this.readBuffer(len);
                try {
                    // NOTE: Using TextDecoder to fail on invalid UTF-8
                    return $1f876b2d27fa1bad$var$textDecoder.decode(buf);
                } catch (e) {
                    throw new $1f876b2d27fa1bad$var$BorshError("Error decoding UTF-8 string: ".concat(e));
                }
            }
        },
        {
            key: "readFixedArray",
            value: function readFixedArray(len) {
                return new Uint8Array(this.readBuffer(len));
            }
        },
        {
            key: "readArray",
            value: function readArray(fn) {
                var len = this.readU32();
                var result = Array();
                for(var i = 0; i < len; ++i)result.push(fn());
                return result;
            }
        }
    ]);
    return BinaryReader;
}();
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU8", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU16", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU32", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU64", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU128", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU256", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readU512", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readString", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readFixedArray", null);
$1f876b2d27fa1bad$var$__decorate([
    $1f876b2d27fa1bad$var$handlingRangeError
], $1f876b2d27fa1bad$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $1f876b2d27fa1bad$var$BinaryReader;
function $1f876b2d27fa1bad$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $1f876b2d27fa1bad$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer["write".concat($1f876b2d27fa1bad$var$capitalizeFirstLetter(fieldType))](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $1f876b2d27fa1bad$var$BorshError("Expecting byte array of length ".concat(fieldType[0], ", but got ").concat(value.length, " bytes"));
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $1f876b2d27fa1bad$var$BorshError("Expecting byte array of length ".concat(fieldType[1], ", but got ").concat(value.length, " bytes"));
                for(var i = 0; i < fieldType[1]; i++)$1f876b2d27fa1bad$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, function(item) {
                $1f876b2d27fa1bad$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $1f876b2d27fa1bad$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            default:
                throw new $1f876b2d27fa1bad$var$BorshError("FieldType ".concat(fieldType, " unrecognized"));
        }
        else $1f876b2d27fa1bad$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $1f876b2d27fa1bad$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $1f876b2d27fa1bad$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    var structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $1f876b2d27fa1bad$var$BorshError("Class ".concat(obj.constructor.name, " is missing in schema"));
    if (structSchema.kind === "struct") structSchema.fields.map(function(param) {
        var _param = (0, $8GFUW._)(param, 2), fieldName = _param[0], fieldType = _param[1];
        $1f876b2d27fa1bad$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        var name = obj[structSchema.field];
        for(var idx = 0; idx < structSchema.values.length; ++idx){
            var _structSchema_values_idx = (0, $8GFUW._)(structSchema.values[idx], 2), fieldName = _structSchema_values_idx[0], fieldType = _structSchema_values_idx[1];
            if (fieldName === name) {
                writer.writeU8(idx);
                $1f876b2d27fa1bad$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $1f876b2d27fa1bad$var$BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(obj.constructor.name));
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $1f876b2d27fa1bad$var$serialize(schema, obj) {
    var Writer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $1f876b2d27fa1bad$var$BinaryWriter;
    var writer = new Writer();
    $1f876b2d27fa1bad$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $1f876b2d27fa1bad$var$serialize;
function $1f876b2d27fa1bad$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader["read".concat($1f876b2d27fa1bad$var$capitalizeFirstLetter(fieldType))]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                var arr = [];
                for(var i = 0; i < fieldType[1]; i++)arr.push($1f876b2d27fa1bad$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(function() {
                return $1f876b2d27fa1bad$var$deserializeField(schema, fieldName, fieldType[0], reader);
            });
        }
        if (fieldType.kind === "option") {
            var option = reader.readU8();
            if (option) return $1f876b2d27fa1bad$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        return $1f876b2d27fa1bad$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $1f876b2d27fa1bad$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $1f876b2d27fa1bad$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    var structSchema = schema.get(classType);
    if (!structSchema) throw new $1f876b2d27fa1bad$var$BorshError("Class ".concat(classType.name, " is missing in schema"));
    if (structSchema.kind === "struct") {
        var result = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = schema.get(classType).fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $8GFUW._)(_step.value, 2), fieldName = _step_value[0], fieldType = _step_value[1];
                result[fieldName] = $1f876b2d27fa1bad$var$deserializeField(schema, fieldName, fieldType, reader);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        var idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $1f876b2d27fa1bad$var$BorshError("Enum index: ".concat(idx, " is out of range"));
        var _structSchema_values_idx = (0, $8GFUW._)(structSchema.values[idx], 2), fieldName1 = _structSchema_values_idx[0], fieldType1 = _structSchema_values_idx[1];
        var fieldValue = $1f876b2d27fa1bad$var$deserializeField(schema, fieldName1, fieldType1, reader);
        return new classType((0, $dxWQo._)({}, fieldName1, fieldValue));
    }
    throw new $1f876b2d27fa1bad$var$BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(classType.constructor.name));
}
/// Deserializes object from bytes using schema.
function $1f876b2d27fa1bad$var$deserialize(schema, classType, buffer) {
    var Reader = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1f876b2d27fa1bad$var$BinaryReader;
    var reader = new Reader(buffer);
    var result = $1f876b2d27fa1bad$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $1f876b2d27fa1bad$var$BorshError("Unexpected ".concat(buffer.length - reader.offset, " bytes after deserialized data"));
    return result;
}
module.exports.deserialize = $1f876b2d27fa1bad$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $1f876b2d27fa1bad$var$deserializeUnchecked(schema, classType, buffer) {
    var Reader = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1f876b2d27fa1bad$var$BinaryReader;
    var reader = new Reader(buffer);
    return $1f876b2d27fa1bad$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $1f876b2d27fa1bad$var$deserializeUnchecked;

});
parcelRequire.register("dxWQo", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $9dcc00a39e7f7954$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $9dcc00a39e7f7954$export$1e71eb4bef00f6b0; });
function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRequire.register("8GFUW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6532c2e6670e28d1$export$fdf2a89c76341bbf; });

var $jbUp2 = parcelRequire("jbUp2");

var $6zrOq = parcelRequire("6zrOq");

var $4Tldu = parcelRequire("4Tldu");

var $imR8K = parcelRequire("imR8K");
function $6532c2e6670e28d1$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jbUp2._array_with_holes)(arr) || (0, $6zrOq._iterable_to_array_limit)(arr, i) || (0, $imR8K._unsupported_iterable_to_array)(arr, i) || (0, $4Tldu._non_iterable_rest)();
}

});
parcelRequire.register("jbUp2", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $df8acbd513f0a551$export$e6256bf45c68d561; });
function $df8acbd513f0a551$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("6zrOq", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $4c8b95e34bd7aafb$export$2fd15edff6687200; });
function $4c8b95e34bd7aafb$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("4Tldu", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $38fcc1ab263aa6c9$export$60dbc22abd7da546; });
function $38fcc1ab263aa6c9$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("imR8K", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $d5f380987878722e$export$a5be06335b3a083c; });

var $dkOJL = parcelRequire("dkOJL");
function $d5f380987878722e$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $dkOJL._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $dkOJL._array_like_to_array)(o, minLen);
}

});
parcelRequire.register("dkOJL", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $9b547ff733c97a35$export$79e617b1955a2616; });
function $9b547ff733c97a35$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRequire.register("2TMdq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $21c61e66a13e7076$export$2466d533fda16e33; });

var $34cAK = parcelRequire("34cAK");

var $g3d7z = parcelRequire("g3d7z");

var $cM94G = parcelRequire("cM94G");

var $azwGX = parcelRequire("azwGX");
function $21c61e66a13e7076$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $21c61e66a13e7076$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $cM94G._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $34cAK._construct)(Class, arguments, (0, $g3d7z._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $azwGX._set_prototype_of)(Wrapper, Class);
    };
    return $21c61e66a13e7076$export$2466d533fda16e33(Class);
}

});
parcelRequire.register("34cAK", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $23bb83417b6a52ec$export$2d841144c5f8c4ab; });

var $1vcmW = parcelRequire("1vcmW");

var $azwGX = parcelRequire("azwGX");
function $23bb83417b6a52ec$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $1vcmW._is_native_reflect_construct)()) $23bb83417b6a52ec$export$2d841144c5f8c4ab = Reflect.construct;
    else $23bb83417b6a52ec$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $azwGX._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $23bb83417b6a52ec$export$2d841144c5f8c4ab.apply(null, arguments);
}

});

parcelRequire.register("cM94G", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $94d101b80d8606f0$export$514eda94019f4334; });
function $94d101b80d8606f0$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRequire.register("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $c114c26e12685207$export$e4cf37d7f6fb9e0a; }, function (v) { return $c114c26e12685207$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $c114c26e12685207$export$599f31c3813fae4d; }, function (v) { return $c114c26e12685207$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");
var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
var $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
var $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)));
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        var len = $c114c26e12685207$var$checked(obj.length) | 0;
        var buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $1ObTH._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $1ObTH._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var read = function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    };
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $ftJVG._)(NodeError, Base);
        var _super = (0, $6OZAO._)(NodeError);
        function NodeError() {
            (0, $978gY._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $3vWwE._)(_this), "message", {
                value: getMessage.apply((0, $3vWwE._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $kry2a._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$c114c26e12685207$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c114c26e12685207$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $1ObTH._)(actual));
}, TypeError);
$c114c26e12685207$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $1ObTH._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $1ObTH._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c114c26e12685207$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("7LFKz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("jlWHo", function(module, exports) {

(function(module1, exports) {
    "use strict";
    var assert = // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    };
    var inherits = // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    };
    var parseHex4Bits = function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    };
    var parseHexByte = function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    };
    var parseBase = function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    };
    var move = function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    };
    var inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var toBitArray = function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    };
    var smallMulTo = function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    };
    var bigMulTo = function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    };
    var jumboMulTo = function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    };
    var FFTM = // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    };
    var MPrime = // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    };
    var K256 = function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    };
    var P224 = function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    };
    var P192 = function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    };
    var P25519 = function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    };
    var Red = //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    };
    var Mont = function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    };
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    inherits(P224, MPrime);
    inherits(P192, MPrime);
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("5m7wF", function(module, exports) {

var $jzxXn = parcelRequire("jzxXn");
var $3e64d84924d7d2b0$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $jzxXn($3e64d84924d7d2b0$var$ALPHABET);

});
parcelRequire.register("jzxXn", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $e3fba04c57c6fbb2$require$_Buffer = $eN0t8.Buffer;
function $e3fba04c57c6fbb2$var$base(ALPHABET) {
    var encode = function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $e3fba04c57c6fbb2$require$_Buffer.from(source);
        if (!$e3fba04c57c6fbb2$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    };
    var decodeUnsafe = function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $e3fba04c57c6fbb2$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $e3fba04c57c6fbb2$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    };
    var decode = function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    };
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $e3fba04c57c6fbb2$var$base;

});
parcelRequire.register("eN0t8", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $gzLuY = parcelRequire("gzLuY");
var $ac460165df72f91c$var$Buffer = $gzLuY.Buffer;
// alternative to using Object.keys for old browsers
function $ac460165df72f91c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ac460165df72f91c$var$Buffer.from && $ac460165df72f91c$var$Buffer.alloc && $ac460165df72f91c$var$Buffer.allocUnsafe && $ac460165df72f91c$var$Buffer.allocUnsafeSlow) module.exports = $gzLuY;
else {
    // Copy properties from require('buffer')
    $ac460165df72f91c$var$copyProps($gzLuY, module.exports);
    module.exports.Buffer = $ac460165df72f91c$var$SafeBuffer;
}
function $ac460165df72f91c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
}
$ac460165df72f91c$var$SafeBuffer.prototype = Object.create($ac460165df72f91c$var$Buffer.prototype);
// Copy static methods from Buffer
$ac460165df72f91c$var$copyProps($ac460165df72f91c$var$Buffer, $ac460165df72f91c$var$SafeBuffer);
$ac460165df72f91c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
};
$ac460165df72f91c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $ac460165df72f91c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ac460165df72f91c$var$Buffer(size);
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $gzLuY.SlowBuffer(size);
};

});



parcelRequire.register("7fpPy", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $546df882278ec527$export$88fb0cfd153261a7; }, function (v) { return $546df882278ec527$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $546df882278ec527$export$9c6b53e35bc51b5c; }, function (v) { return $546df882278ec527$export$9c6b53e35bc51b5c = v; });
var $546df882278ec527$export$88fb0cfd153261a7;
var $546df882278ec527$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $546df882278ec527$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $546df882278ec527$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $546df882278ec527$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $546df882278ec527$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $546df882278ec527$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $546df882278ec527$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$546df882278ec527$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function endOfStream() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function read() {
        if (!this.tokens.length) return $546df882278ec527$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function prepend(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function push(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $546df882278ec527$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $546df882278ec527$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $546df882278ec527$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $546df882278ec527$var$TextDecoder(encoding, options) {
    if (!(this instanceof $546df882278ec527$var$TextDecoder)) return new $546df882278ec527$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $546df882278ec527$var$DEFAULT_ENCODING;
    if (encoding !== $546df882278ec527$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $546df882278ec527$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$546df882278ec527$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $546df882278ec527$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $546df882278ec527$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $546df882278ec527$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $546df882278ec527$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $546df882278ec527$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $546df882278ec527$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $546df882278ec527$var$TextEncoder(encoding, options) {
    if (!(this instanceof $546df882278ec527$var$TextEncoder)) return new $546df882278ec527$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $546df882278ec527$var$DEFAULT_ENCODING;
    if (encoding !== $546df882278ec527$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $546df882278ec527$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$546df882278ec527$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $546df882278ec527$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $546df882278ec527$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $546df882278ec527$var$Stream($546df882278ec527$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $546df882278ec527$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $546df882278ec527$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $546df882278ec527$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $546df882278ec527$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $546df882278ec527$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $546df882278ec527$var$end_of_stream) return $546df882278ec527$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($546df882278ec527$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($546df882278ec527$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($546df882278ec527$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($546df882278ec527$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $546df882278ec527$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$546df882278ec527$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $546df882278ec527$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $546df882278ec527$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $546df882278ec527$var$end_of_stream) return $546df882278ec527$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($546df882278ec527$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($546df882278ec527$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($546df882278ec527$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($546df882278ec527$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$546df882278ec527$export$88fb0cfd153261a7 = $546df882278ec527$var$TextEncoder;
$546df882278ec527$export$9c6b53e35bc51b5c = $546df882278ec527$var$TextDecoder;

});



parcelRequire.register("5dmHG", function(module, exports) {

var $978gY = parcelRequire("978gY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Assignable = module.exports.Enum = void 0;
/** @hidden @module */ var $3cbfc720ccf12cb5$var$Enum = function Enum(properties) {
    var _this = this;
    (0, $978gY._)(this, Enum);
    if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
    Object.keys(properties).map(function(key) {
        _this[key] = properties[key];
        _this.enum = key;
    });
};
module.exports.Enum = $3cbfc720ccf12cb5$var$Enum;
var $3cbfc720ccf12cb5$var$Assignable = function Assignable(properties) {
    var _this = this;
    (0, $978gY._)(this, Assignable);
    Object.keys(properties).map(function(key) {
        _this[key] = properties[key];
    });
};
module.exports.Assignable = $3cbfc720ccf12cb5$var$Assignable;

});



parcelRequire.register("3dAWg", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserLocalStorageKeyStore = void 0;

var $eJ8Lr = parcelRequire("eJ8Lr");

var $8pTGX = parcelRequire("8pTGX");
var $257f3d44f4f4b660$var$LOCAL_STORAGE_KEY_PREFIX = "near-api-js:keystore:";
/**
 * This class is used to store keys in the browsers local storage.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store}
 * @example
 * ```js
 * import { connect, keyStores } from 'near-api-js';
 *
 * const keyStore = new keyStores.BrowserLocalStorageKeyStore();
 * const config = {
 *   keyStore, // instance of BrowserLocalStorageKeyStore
 *   networkId: 'testnet',
 *   nodeUrl: 'https://rpc.testnet.near.org',
 *   walletUrl: 'https://wallet.testnet.near.org',
 *   helperUrl: 'https://helper.testnet.near.org',
 *   explorerUrl: 'https://explorer.testnet.near.org'
 * };
 *
 * // inside an async function
 * const near = await connect(config)
 * ```
 */ var $257f3d44f4f4b660$var$BrowserLocalStorageKeyStore = /*#__PURE__*/ function(_keystore_1_KeyStore) {
    (0, $ftJVG._)(BrowserLocalStorageKeyStore, _keystore_1_KeyStore);
    var _super = (0, $6OZAO._)(BrowserLocalStorageKeyStore);
    function BrowserLocalStorageKeyStore() {
        var localStorage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.localStorage, prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $257f3d44f4f4b660$var$LOCAL_STORAGE_KEY_PREFIX;
        (0, $978gY._)(this, BrowserLocalStorageKeyStore);
        var _this;
        _this = _super.call(this);
        _this.localStorage = localStorage;
        _this.prefix = prefix;
        return _this;
    }
    (0, $kry2a._)(BrowserLocalStorageKeyStore, [
        {
            key: "setKey",
            value: /**
     * Stores a {@link KeyPair} in local storage.
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ function setKey(networkId, accountId, keyPair) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.localStorage.setItem(_this.storageKeyForSecretKey(networkId, accountId), keyPair.toString());
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getKey",
            value: /**
     * Gets a {@link KeyPair} from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ function getKey(networkId, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var value;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        value = _this.localStorage.getItem(_this.storageKeyForSecretKey(networkId, accountId));
                        if (!value) return [
                            2,
                            null
                        ];
                        return [
                            2,
                            $8pTGX.KeyPair.fromString(value)
                        ];
                    });
                })();
            }
        },
        {
            key: "removeKey",
            value: /**
     * Removes a {@link KeyPair} from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ function removeKey(networkId, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.localStorage.removeItem(_this.storageKeyForSecretKey(networkId, accountId));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "clear",
            value: /**
     * Removes all items that start with `prefix` from local storage
     */ function clear() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.storageKeys()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (key.startsWith(_this.prefix)) _this.localStorage.removeItem(key);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getNetworks",
            value: /**
     * Get the network(s) from local storage
     * @returns {Promise<string[]>}
     */ function getNetworks() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, parts;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        result = new Set();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.storageKeys()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (key.startsWith(_this.prefix)) {
                                    parts = key.substring(_this.prefix.length).split(":");
                                    result.add(parts[1]);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2,
                            Array.from(result.values())
                        ];
                    });
                })();
            }
        },
        {
            key: "getAccounts",
            value: /**
     * Gets the account(s) from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns{Promise<string[]>}
     */ function getAccounts(networkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, parts;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        result = new Array();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.storageKeys()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (key.startsWith(_this.prefix)) {
                                    parts = key.substring(_this.prefix.length).split(":");
                                    if (parts[1] === networkId) result.push(parts[0]);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2,
                            result
                        ];
                    });
                })();
            }
        },
        {
            /**
     * @hidden
     * Helper function to retrieve a local storage key
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the storage keythat's sought
     * @returns {string} An example might be: `near-api-js:keystore:near-friend:default`
     */ key: "storageKeyForSecretKey",
            value: function storageKeyForSecretKey(networkId, accountId) {
                return "".concat(this.prefix).concat(accountId, ":").concat(networkId);
            }
        },
        {
            key: "storageKeys",
            value: /** @hidden */ function storageKeys() {
                var i;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(i < this.localStorage.length)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.localStorage.key(i)
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            i++;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return BrowserLocalStorageKeyStore;
}($eJ8Lr.KeyStore);
module.exports.BrowserLocalStorageKeyStore = $257f3d44f4f4b660$var$BrowserLocalStorageKeyStore;

});

parcelRequire.register("llqmF", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = void 0;

var $eJ8Lr = parcelRequire("eJ8Lr");
var $f8a0029b0b9e7ac5$var$MergeKeyStore = /*#__PURE__*/ function(_keystore_1_KeyStore) {
    (0, $ftJVG._)(MergeKeyStore, _keystore_1_KeyStore);
    var _super = (0, $6OZAO._)(MergeKeyStore);
    function MergeKeyStore(keyStores) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            writeKeyStoreIndex: 0
        };
        (0, $978gY._)(this, MergeKeyStore);
        var _this;
        _this = _super.call(this);
        _this.options = options;
        _this.keyStores = keyStores;
        return _this;
    }
    (0, $kry2a._)(MergeKeyStore, [
        {
            key: "setKey",
            value: /**
     * Store a {@link KeyPain} to the first index of a key store array
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ function setKey(networkId, accountId, keyPair) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.keyStores[_this.options.writeKeyStoreIndex].setKey(networkId, accountId, keyPair)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getKey",
            value: /**
     * Gets a {@link KeyPair} from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ function getKey(networkId, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, keyStore, keyPair, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = _this.keyStores[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                keyStore = _step.value;
                                return [
                                    4,
                                    keyStore.getKey(networkId, accountId)
                                ];
                            case 3:
                                keyPair = _state.sent();
                                if (keyPair) return [
                                    2,
                                    keyPair
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeKey",
            value: /**
     * Removes a {@link KeyPair} from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ function removeKey(networkId, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, keyStore, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = _this.keyStores[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                keyStore = _step.value;
                                return [
                                    4,
                                    keyStore.removeKey(networkId, accountId)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clear",
            value: /**
     * Removes all items from each key store
     */ function clear() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, keyStore, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator = _this.keyStores[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                keyStore = _step.value;
                                return [
                                    4,
                                    keyStore.clear()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNetworks",
            value: /**
     * Get the network(s) from the array of key stores
     * @returns {Promise<string[]>}
     */ function getNetworks() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator, _step, keyStore, _iterator1, _step1, network, err, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    13,
                                    14
                                ]);
                                _iterator = _this.keyStores[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion1 = (_step = _iterator.next()).done)) return [
                                    3,
                                    11
                                ];
                                keyStore = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                return [
                                    4,
                                    keyStore.getNetworks()
                                ];
                            case 4:
                                _iterator1 = _state.sent()[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    7
                                ];
                                network = _step1.value;
                                result.add(network);
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    2
                                ];
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2,
                                    Array.from(result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccounts",
            value: /**
     * Gets the account(s) from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns{Promise<string[]>}
     */ function getAccounts(networkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator, _step, keyStore, _iterator1, _step1, account, err, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    13,
                                    14
                                ]);
                                _iterator = _this.keyStores[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion1 = (_step = _iterator.next()).done)) return [
                                    3,
                                    11
                                ];
                                keyStore = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                return [
                                    4,
                                    keyStore.getAccounts(networkId)
                                ];
                            case 4:
                                _iterator1 = _state.sent()[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    7
                                ];
                                account = _step1.value;
                                result.add(account);
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    2
                                ];
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2,
                                    Array.from(result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            /** @hidden */ key: "toString",
            value: function toString() {
                return "MergeKeyStore(".concat(this.keyStores.join(", "), ")");
            }
        }
    ]);
    return MergeKeyStore;
}($eJ8Lr.KeyStore);
module.exports.MergeKeyStore = $f8a0029b0b9e7ac5$var$MergeKeyStore;

});


parcelRequire.register("hHZrX", function(module, exports) {
"use strict";
var $ce461e7e230ec1f6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce461e7e230ec1f6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ce461e7e230ec1f6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $ce461e7e230ec1f6$var$__createBinding(result, mod, k);
    }
    $ce461e7e230ec1f6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletConnection = module.exports.WalletAccount = module.exports.ConnectedWalletAccount = module.exports.Near = module.exports.KeyPair = module.exports.Signer = module.exports.InMemorySigner = module.exports.Contract = module.exports.Connection = module.exports.Account = module.exports.multisig = module.exports.validators = module.exports.transactions = module.exports.utils = module.exports.providers = module.exports.accountCreator = void 0;

/** @hidden @module */ var $ce461e7e230ec1f6$var$providers = $ce461e7e230ec1f6$var$__importStar((parcelRequire("bMcUu")));
module.exports.providers = $ce461e7e230ec1f6$var$providers;

var $ce461e7e230ec1f6$var$utils = $ce461e7e230ec1f6$var$__importStar((parcelRequire("jSV3x")));
module.exports.utils = $ce461e7e230ec1f6$var$utils;

var $ce461e7e230ec1f6$var$transactions = $ce461e7e230ec1f6$var$__importStar((parcelRequire("7cM39")));
module.exports.transactions = $ce461e7e230ec1f6$var$transactions;

var $ce461e7e230ec1f6$var$validators = $ce461e7e230ec1f6$var$__importStar((parcelRequire("kfiwQ")));
module.exports.validators = $ce461e7e230ec1f6$var$validators;

var $gXWlL = parcelRequire("gXWlL");
Object.defineProperty(module.exports, "Account", {
    enumerable: true,
    get: function get() {
        return $gXWlL.Account;
    }
});

var $ce461e7e230ec1f6$var$multisig = $ce461e7e230ec1f6$var$__importStar((parcelRequire("staLo")));
module.exports.multisig = $ce461e7e230ec1f6$var$multisig;

var $ce461e7e230ec1f6$var$accountCreator = $ce461e7e230ec1f6$var$__importStar((parcelRequire("g5374")));
module.exports.accountCreator = $ce461e7e230ec1f6$var$accountCreator;

var $5YbZv = parcelRequire("5YbZv");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function get() {
        return $5YbZv.Connection;
    }
});

var $e29vo = parcelRequire("e29vo");
Object.defineProperty(module.exports, "Signer", {
    enumerable: true,
    get: function get() {
        return $e29vo.Signer;
    }
});
Object.defineProperty(module.exports, "InMemorySigner", {
    enumerable: true,
    get: function get() {
        return $e29vo.InMemorySigner;
    }
});

var $hRJ6X = parcelRequire("hRJ6X");
Object.defineProperty(module.exports, "Contract", {
    enumerable: true,
    get: function get() {
        return $hRJ6X.Contract;
    }
});

var $8pTGX = parcelRequire("8pTGX");
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function get() {
        return $8pTGX.KeyPair;
    }
});

var $kowPj = parcelRequire("kowPj");
Object.defineProperty(module.exports, "Near", {
    enumerable: true,
    get: function get() {
        return $kowPj.Near;
    }
});

var $k3l4B = parcelRequire("k3l4B");
Object.defineProperty(module.exports, "ConnectedWalletAccount", {
    enumerable: true,
    get: function get() {
        return $k3l4B.ConnectedWalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletAccount", {
    enumerable: true,
    get: function get() {
        return $k3l4B.WalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletConnection", {
    enumerable: true,
    get: function get() {
        return $k3l4B.WalletConnection;
    }
});

});
parcelRequire.register("bMcUu", function(module, exports) {
"use strict";
/** @hidden @module */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorContext = module.exports.TypedError = module.exports.getTransactionLastResult = module.exports.FinalExecutionStatusBasic = module.exports.JsonRpcProvider = module.exports.Provider = void 0;

var $iAzPz = parcelRequire("iAzPz");
Object.defineProperty(module.exports, "Provider", {
    enumerable: true,
    get: function get() {
        return $iAzPz.Provider;
    }
});
Object.defineProperty(module.exports, "getTransactionLastResult", {
    enumerable: true,
    get: function get() {
        return $iAzPz.getTransactionLastResult;
    }
});
Object.defineProperty(module.exports, "FinalExecutionStatusBasic", {
    enumerable: true,
    get: function get() {
        return $iAzPz.FinalExecutionStatusBasic;
    }
});

var $bRaG5 = parcelRequire("bRaG5");
Object.defineProperty(module.exports, "JsonRpcProvider", {
    enumerable: true,
    get: function get() {
        return $bRaG5.JsonRpcProvider;
    }
});
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function get() {
        return $bRaG5.TypedError;
    }
});
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function get() {
        return $bRaG5.ErrorContext;
    }
});

});
parcelRequire.register("iAzPz", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $gzLuY = parcelRequire("gzLuY");
var $d887620b83d1997d$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * NEAR RPC API request types and responses
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransactionLastResult = module.exports.Provider = module.exports.IdType = module.exports.FinalExecutionStatusBasic = module.exports.ExecutionStatusBasic = void 0;
var $d887620b83d1997d$var$ExecutionStatusBasic;
(function(ExecutionStatusBasic) {
    ExecutionStatusBasic["Unknown"] = "Unknown";
    ExecutionStatusBasic["Pending"] = "Pending";
    ExecutionStatusBasic["Failure"] = "Failure";
})($d887620b83d1997d$var$ExecutionStatusBasic = module.exports.ExecutionStatusBasic || (module.exports.ExecutionStatusBasic = {}));
var $d887620b83d1997d$var$FinalExecutionStatusBasic;
(function(FinalExecutionStatusBasic) {
    FinalExecutionStatusBasic["NotStarted"] = "NotStarted";
    FinalExecutionStatusBasic["Started"] = "Started";
    FinalExecutionStatusBasic["Failure"] = "Failure";
})($d887620b83d1997d$var$FinalExecutionStatusBasic = module.exports.FinalExecutionStatusBasic || (module.exports.FinalExecutionStatusBasic = {}));
var $d887620b83d1997d$var$IdType;
(function(IdType) {
    IdType["Transaction"] = "transaction";
    IdType["Receipt"] = "receipt";
})($d887620b83d1997d$var$IdType = module.exports.IdType || (module.exports.IdType = {}));
/** @hidden */ var $d887620b83d1997d$var$Provider = function Provider() {
    "use strict";
    (0, $978gY._)(this, Provider);
};
module.exports.Provider = $d887620b83d1997d$var$Provider;
/** @hidden */ function $d887620b83d1997d$var$getTransactionLastResult(txResult) {
    if (typeof txResult.status === "object" && typeof txResult.status.SuccessValue === "string") {
        var value = $d887620b83d1997d$require$Buffer.from(txResult.status.SuccessValue, "base64").toString();
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    return null;
}
module.exports.getTransactionLastResult = $d887620b83d1997d$var$getTransactionLastResult;

});

parcelRequire.register("bRaG5", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $8a1ced5cf73ddb91$require$Buffer = $gzLuY.Buffer;
"use strict";
var $8a1ced5cf73ddb91$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcProvider = module.exports.ErrorContext = module.exports.TypedError = void 0;

/**
 * This module contains the {@link JsonRpcProvider} client class
 * which can be used to interact with the NEAR RPC API.
 * @see {@link providers/provider} for a list of request and response types
 */ var $8a1ced5cf73ddb91$var$depd_1 = $8a1ced5cf73ddb91$var$__importDefault((parcelRequire("7kbiF")));

var $iAzPz = parcelRequire("iAzPz");

var $9Nstj = parcelRequire("9Nstj");

var $6vXKs = parcelRequire("6vXKs");
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function get() {
        return $6vXKs.TypedError;
    }
});
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function get() {
        return $6vXKs.ErrorContext;
    }
});

var $2HPkT = parcelRequire("2HPkT");

var $8a1ced5cf73ddb91$var$exponential_backoff_1 = $8a1ced5cf73ddb91$var$__importDefault((parcelRequire("dkG2P")));

var $2RlOX = parcelRequire("2RlOX");
// Default number of retries before giving up on a request.
var $8a1ced5cf73ddb91$var$REQUEST_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
var $8a1ced5cf73ddb91$var$REQUEST_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
var $8a1ced5cf73ddb91$var$REQUEST_RETRY_WAIT_BACKOFF = 1.5;
/// Keep ids unique across all connections.
var $8a1ced5cf73ddb91$var$_nextId = 123;
/**
 * Client class to interact with the NEAR RPC API.
 * @see {@link https://github.com/near/nearcore/tree/master/chain/jsonrpc}
 */ var $8a1ced5cf73ddb91$var$JsonRpcProvider = /*#__PURE__*/ function(_provider_1_Provider) {
    "use strict";
    (0, $ftJVG._)(JsonRpcProvider, _provider_1_Provider);
    var _super = (0, $6OZAO._)(JsonRpcProvider);
    function JsonRpcProvider(connectionInfoOrUrl) {
        (0, $978gY._)(this, JsonRpcProvider);
        var _this;
        _this = _super.call(this);
        if (connectionInfoOrUrl != null && typeof connectionInfoOrUrl == "object") _this.connection = connectionInfoOrUrl;
        else {
            var deprecate = $8a1ced5cf73ddb91$var$depd_1.default("JsonRpcProvider(url?: string)");
            deprecate("use `JsonRpcProvider(connectionInfo: ConnectionInfo)` instead");
            _this.connection = {
                url: connectionInfoOrUrl
            };
        }
        return _this;
    }
    (0, $kry2a._)(JsonRpcProvider, [
        {
            key: "status",
            value: /**
     * Gets the RPC's status
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#general-validator-status}
     */ function status() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.sendJsonRpc("status", [])
                        ];
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: /**
     * Sends a signed transaction to the RPC and waits until transaction is fully complete
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#send-transaction-await}
     *
     * @param signedTransaction The signed transaction being sent
     */ function sendTransaction(signedTransaction) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var bytes;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        bytes = signedTransaction.encode();
                        return [
                            2,
                            _this.sendJsonRpc("broadcast_tx_commit", [
                                $8a1ced5cf73ddb91$require$Buffer.from(bytes).toString("base64")
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "sendTransactionAsync",
            value: /**
     * Sends a signed transaction to the RPC and immediately returns transaction hash
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#send-transaction-async)
     * @param signedTransaction The signed transaction being sent
     * @returns {Promise<FinalExecutionOutcome>}
     */ function sendTransactionAsync(signedTransaction) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var bytes;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        bytes = signedTransaction.encode();
                        return [
                            2,
                            _this.sendJsonRpc("broadcast_tx_async", [
                                $8a1ced5cf73ddb91$require$Buffer.from(bytes).toString("base64")
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "txStatus",
            value: /**
     * Gets a transaction's status from the RPC
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#transaction-status}
     *
     * @param txHash A transaction hash as either a Uint8Array or a base58 encoded string
     * @param accountId The NEAR account that signed the transaction
     */ function txStatus(txHash, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (typeof txHash === "string") return [
                            2,
                            _this.txStatusString(txHash, accountId)
                        ];
                        else return [
                            2,
                            _this.txStatusUint8Array(txHash, accountId)
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "txStatusUint8Array",
            value: function txStatusUint8Array(txHash, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.sendJsonRpc("tx", [
                                $2HPkT.baseEncode(txHash),
                                accountId
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "txStatusString",
            value: function txStatusString(txHash, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.sendJsonRpc("tx", [
                                txHash,
                                accountId
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "txStatusReceipts",
            value: /**
     * Gets a transaction's status from the RPC with receipts
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#transaction-status-with-receipts)
     * @param txHash The hash of the transaction
     * @param accountId The NEAR account that signed the transaction
     * @returns {Promise<FinalExecutionOutcome>}
     */ function txStatusReceipts(txHash, accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_tx_status", [
                                $2HPkT.baseEncode(txHash),
                                accountId
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "query",
            value: /**
     * Query the RPC as [shown in the docs](https://docs.near.org/docs/develop/front-end/rpc#accounts--contracts)
     * Query the RPC by passing an {@link RpcQueryRequest}
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#accounts--contracts}
     *
     * @typeParam T the shape of the returned query response
     */ function query() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result, _args, path, data;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(args.length === 1)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.sendJsonRpc("query", args[0])
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                _args = (0, $8GFUW._)(args, 2), path = _args[0], data = _args[1];
                                return [
                                    4,
                                    _this.sendJsonRpc("query", [
                                        path,
                                        data
                                    ])
                                ];
                            case 3:
                                result = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (result && result.error) throw new $6vXKs.TypedError("Querying ".concat(args, " failed: ").concat(result.error, ".\n").concat(JSON.stringify(result, null, 2)), $2RlOX.getErrorTypeFromErrorMessage(result.error));
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "block",
            value: /**
     * Query for block info from the RPC
     * pass block_id OR finality as blockQuery, not both
     * @see {@link https://docs.near.org/docs/interaction/rpc#block}
     *
     * @param blockQuery {@link BlockReference} (passing a {@link BlockId} is deprecated)
     */ function block(blockQuery) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId, deprecate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        if (typeof blockQuery !== "object") {
                            deprecate = $8a1ced5cf73ddb91$var$depd_1.default("JsonRpcProvider.block(blockId)");
                            deprecate("use `block({ blockId })` or `block({ finality })` instead");
                            blockId = blockQuery;
                        }
                        return [
                            2,
                            _this.sendJsonRpc("block", {
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "blockChanges",
            value: /**
     * Query changes in block from the RPC
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#block-details)
     */ function blockChanges(blockQuery) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_changes_in_block", {
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "chunk",
            value: /**
     * Queries for details about a specific chunk appending details of receipts and transactions to the same chunk data provided by a block
     * @see {@link https://docs.near.org/docs/interaction/rpc#chunk}
     *
     * @param chunkId Hash of a chunk ID or shard ID
     */ function chunk(chunkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.sendJsonRpc("chunk", [
                                chunkId
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "validators",
            value: /**
     * Query validators of the epoch defined by the given block id.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#detailed-validator-status}
     *
     * @param blockId Block hash or height, or null for latest.
     */ function validators(blockId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.sendJsonRpc("validators", [
                                blockId
                            ])
                        ];
                    });
                })();
            }
        },
        {
            key: "experimental_genesisConfig",
            value: /**
     * @deprecated
     * Gets the genesis config from RPC
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#genesis-config}
     */ function experimental_genesisConfig() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var deprecate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                deprecate = $8a1ced5cf73ddb91$var$depd_1.default("JsonRpcProvider.experimental_protocolConfig()");
                                deprecate("use `experimental_protocolConfig({ sync_checkpoint: 'genesis' })` to fetch the up-to-date or genesis protocol config explicitly");
                                return [
                                    4,
                                    _this.sendJsonRpc("EXPERIMENTAL_protocol_config", {
                                        sync_checkpoint: "genesis"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "experimental_protocolConfig",
            value: /**
     * Gets the protocol config at a block from RPC
     * @see {@link }
     *
     * @param blockReference specifies the block to get the protocol config for
     */ function experimental_protocolConfig(blockReference) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.sendJsonRpc("EXPERIMENTAL_protocol_config", blockReference)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "experimental_lightClientProof",
            value: /**
     * @deprecated Use {@link lightClientProof} instead
     */ function experimental_lightClientProof(request) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var deprecate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                deprecate = $8a1ced5cf73ddb91$var$depd_1.default("JsonRpcProvider.experimental_lightClientProof(request)");
                                deprecate("use `lightClientProof` instead");
                                return [
                                    4,
                                    _this.lightClientProof(request)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "lightClientProof",
            value: /**
     * Gets a light client execution proof for verifying execution outcomes
     * @see {@link https://github.com/nearprotocol/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-proof}
     */ function lightClientProof(request) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.sendJsonRpc("EXPERIMENTAL_light_client_proof", request)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "accessKeyChanges",
            value: /**
     * Gets access key changes for a given array of accountIds
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-all)
     * @returns {Promise<ChangeResult>}
     */ function accessKeyChanges(accountIdArray, blockQuery) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_changes", {
                                changes_type: "all_access_key_changes",
                                account_ids: accountIdArray,
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "singleAccessKeyChanges",
            value: /**
     * Gets single access key changes for a given array of access keys
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-single)
     * @returns {Promise<ChangeResult>}
     */ function singleAccessKeyChanges(accessKeyArray, blockQuery) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_changes", {
                                changes_type: "single_access_key_changes",
                                keys: accessKeyArray,
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "accountChanges",
            value: /**
     * Gets account changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-account-changes)
     * @returns {Promise<ChangeResult>}
     */ function accountChanges(accountIdArray, blockQuery) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_changes", {
                                changes_type: "account_changes",
                                account_ids: accountIdArray,
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "contractStateChanges",
            value: /**
     * Gets contract state changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * Note: If you pass a keyPrefix it must be base64 encoded
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-state-changes)
     * @returns {Promise<ChangeResult>}
     */ function contractStateChanges(accountIdArray, blockQuery) {
                var keyPrefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_changes", {
                                changes_type: "data_changes",
                                account_ids: accountIdArray,
                                key_prefix_base64: keyPrefix,
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "contractCodeChanges",
            value: /**
     * Gets contract code changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * Note: Change is returned in a base64 encoded WASM file
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-code-changes)
     * @returns {Promise<ChangeResult>}
     */ function contractCodeChanges(accountIdArray, blockQuery) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var finality, blockId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        finality = blockQuery.finality;
                        blockId = blockQuery.blockId;
                        return [
                            2,
                            _this.sendJsonRpc("EXPERIMENTAL_changes", {
                                changes_type: "contract_code_changes",
                                account_ids: accountIdArray,
                                block_id: blockId,
                                finality: finality
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "gasPrice",
            value: /**
     * Returns gas price for a specific block_height or block_hash.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#gas-price}
     *
     * @param blockId Block hash or height, or null for latest.
     */ function gasPrice(blockId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.sendJsonRpc("gas_price", [
                                        blockId
                                    ])
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendJsonRpc",
            value: /**
     * Directly call the RPC specifying the method and params
     *
     * @param method RPC method
     * @param params Parameters to the method
     */ function sendJsonRpc(method, params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var response, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $8a1ced5cf73ddb91$var$exponential_backoff_1.default($8a1ced5cf73ddb91$var$REQUEST_RETRY_WAIT, $8a1ced5cf73ddb91$var$REQUEST_RETRY_NUMBER, $8a1ced5cf73ddb91$var$REQUEST_RETRY_WAIT_BACKOFF, /*#__PURE__*/ (0, $byzP8._)(function() {
                                        var request, response, errorMessage, error;
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    request = {
                                                        method: method,
                                                        params: params,
                                                        id: $8a1ced5cf73ddb91$var$_nextId++,
                                                        jsonrpc: "2.0"
                                                    };
                                                    return [
                                                        4,
                                                        $9Nstj.fetchJson(_this.connection, JSON.stringify(request))
                                                    ];
                                                case 1:
                                                    response = _state.sent();
                                                    if (response.error) {
                                                        if (typeof response.error.data === "object") {
                                                            if (typeof response.error.data.error_message === "string" && typeof response.error.data.error_type === "string") // if error data has error_message and error_type properties, we consider that node returned an error in the old format
                                                            throw new $6vXKs.TypedError(response.error.data.error_message, response.error.data.error_type);
                                                            throw $2RlOX.parseRpcError(response.error.data);
                                                        } else {
                                                            errorMessage = "[".concat(response.error.code, "] ").concat(response.error.message, ": ").concat(response.error.data);
                                                            // NOTE: All this hackery is happening because structured errors not implemented
                                                            // TODO: Fix when https://github.com/nearprotocol/nearcore/issues/1839 gets resolved
                                                            if (response.error.data === "Timeout" || errorMessage.includes("Timeout error") || errorMessage.includes("query has timed out")) throw new $6vXKs.TypedError(errorMessage, "TimeoutError");
                                                            throw new $6vXKs.TypedError(errorMessage, $2RlOX.getErrorTypeFromErrorMessage(response.error.data));
                                                        }
                                                    }
                                                    // Success when response.error is not exist
                                                    return [
                                                        2,
                                                        response
                                                    ];
                                                case 2:
                                                    error = _state.sent();
                                                    if (error.type === "TimeoutError") {
                                                        console.warn("Retrying request to ".concat(method, " as it has timed out"), params);
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    throw error;
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 1:
                                response = _state.sent();
                                result = response.result;
                                // From jsonrpc spec:
                                // result
                                //   This member is REQUIRED on success.
                                //   This member MUST NOT exist if there was an error invoking the method.
                                if (typeof result === "undefined") throw new $6vXKs.TypedError("Exceeded ".concat($8a1ced5cf73ddb91$var$REQUEST_RETRY_NUMBER, " attempts for request to ").concat(method, "."), "RetriesExceeded");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JsonRpcProvider;
}($iAzPz.Provider);
module.exports.JsonRpcProvider = $8a1ced5cf73ddb91$var$JsonRpcProvider;

});
parcelRequire.register("7kbiF", function(module, exports) {
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $55532a9fb305aba1$var$depd;
/**
 * Create deprecate for namespace in caller.
 */ function $55532a9fb305aba1$var$depd(namespace) {
    var deprecate = function deprecate(message) {
    // no-op in browser
    };
    if (!namespace) throw new TypeError("argument namespace is required");
    deprecate._file = undefined;
    deprecate._ignored = true;
    deprecate._namespace = namespace;
    deprecate._traced = false;
    deprecate._warned = Object.create(null);
    deprecate.function = $55532a9fb305aba1$var$wrapfunction;
    deprecate.property = $55532a9fb305aba1$var$wrapproperty;
    return deprecate;
}
/**
 * Return a wrapped function in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $55532a9fb305aba1$var$wrapfunction(fn, message) {
    if (typeof fn !== "function") throw new TypeError("argument fn must be a function");
    return fn;
}
/**
 * Wrap property in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $55532a9fb305aba1$var$wrapproperty(obj, prop, message) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new TypeError("argument obj must be object");
    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (!descriptor) throw new TypeError("must call property on owner object");
    if (!descriptor.configurable) throw new TypeError("property must be configurable");
}

});

parcelRequire.register("9Nstj", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $721ec695dedf7ec7$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJson = void 0;

var $721ec695dedf7ec7$var$http_errors_1 = $721ec695dedf7ec7$var$__importDefault((parcelRequire("4XLTY")));

var $721ec695dedf7ec7$var$exponential_backoff_1 = $721ec695dedf7ec7$var$__importDefault((parcelRequire("dkG2P")));

var $bMcUu = parcelRequire("bMcUu");

var $6vXKs = parcelRequire("6vXKs");
var $721ec695dedf7ec7$var$START_WAIT_TIME_MS = 1000;
var $721ec695dedf7ec7$var$BACKOFF_MULTIPLIER = 1.5;
var $721ec695dedf7ec7$var$RETRY_NUMBER = 10;
function $721ec695dedf7ec7$var$fetchJson(connectionInfoOrUrl, json) {
    return $721ec695dedf7ec7$var$_fetchJson.apply(this, arguments);
}
function $721ec695dedf7ec7$var$_fetchJson() {
    $721ec695dedf7ec7$var$_fetchJson = (0, $byzP8._)(function(connectionInfoOrUrl, json) {
        var connectionInfo, response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    connectionInfo = {
                        url: null
                    };
                    if (typeof connectionInfoOrUrl === "string") connectionInfo.url = connectionInfoOrUrl;
                    else connectionInfo = connectionInfoOrUrl;
                    return [
                        4,
                        $721ec695dedf7ec7$var$exponential_backoff_1.default($721ec695dedf7ec7$var$START_WAIT_TIME_MS, $721ec695dedf7ec7$var$RETRY_NUMBER, $721ec695dedf7ec7$var$BACKOFF_MULTIPLIER, /*#__PURE__*/ (0, $byzP8._)(function() {
                            var response, _, _tmp, error;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            4,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            fetch(connectionInfo.url, {
                                                method: json ? "POST" : "GET",
                                                body: json ? json : undefined,
                                                headers: (0, $8E768._)((0, $8OnJk._)({}, connectionInfo.headers), {
                                                    "Content-Type": "application/json"
                                                })
                                            })
                                        ];
                                    case 1:
                                        response = _state.sent();
                                        if (!!response.ok) return [
                                            3,
                                            3
                                        ];
                                        if (response.status === 503) {
                                            $6vXKs.logWarning("Retrying HTTP request for ".concat(connectionInfo.url, " as it's not available now"));
                                            return [
                                                2,
                                                null
                                            ];
                                        }
                                        _ = $721ec695dedf7ec7$var$http_errors_1.default;
                                        _tmp = [
                                            response.status
                                        ];
                                        return [
                                            4,
                                            response.text()
                                        ];
                                    case 2:
                                        throw _.apply($721ec695dedf7ec7$var$http_errors_1, _tmp.concat([
                                            _state.sent()
                                        ]));
                                    case 3:
                                        return [
                                            2,
                                            response
                                        ];
                                    case 4:
                                        error = _state.sent();
                                        if (error.toString().includes("FetchError") || error.toString().includes("Failed to fetch")) {
                                            $6vXKs.logWarning("Retrying HTTP request for ".concat(connectionInfo.url, " because of error: ").concat(error));
                                            return [
                                                2,
                                                null
                                            ];
                                        }
                                        throw error;
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response) throw new $bMcUu.TypedError("Exceeded ".concat($721ec695dedf7ec7$var$RETRY_NUMBER, " attempts for ").concat(connectionInfo.url, "."), "RetriesExceeded");
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $721ec695dedf7ec7$var$_fetchJson.apply(this, arguments);
}
module.exports.fetchJson = $721ec695dedf7ec7$var$fetchJson;

});
parcelRequire.register("8OnJk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $66a5668b38a29be4$export$581ff339ea0ba762; });

var $dxWQo = parcelRequire("dxWQo");
function $66a5668b38a29be4$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $dxWQo._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRequire.register("8E768", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $64b790ae24ac5be1$export$4fa2f4023c9cbda5; });
function $64b790ae24ac5be1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64b790ae24ac5be1$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $64b790ae24ac5be1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRequire.register("4XLTY", function(module, exports) {
/*!
 * http-errors
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ 
var $1ObTH = parcelRequire("1ObTH");
"use strict";

/**
 * Module dependencies.
 * @private
 */ var $39d1d46fff935637$var$deprecate = (parcelRequire("7QY2I"))("http-errors");

var $fzpDq = parcelRequire("fzpDq");

var $9Pe52 = parcelRequire("9Pe52");

var $kvFQ5 = parcelRequire("kvFQ5");

var $g14Bq = parcelRequire("g14Bq");
/**
 * Module exports.
 * @public
 */ module.exports = $39d1d46fff935637$var$createError;
module.exports.HttpError = $39d1d46fff935637$var$createHttpErrorConstructor();
module.exports.isHttpError = $39d1d46fff935637$var$createIsHttpErrorFunction(module.exports.HttpError);
// Populate exports for all constructors
$39d1d46fff935637$var$populateConstructorExports(module.exports, $9Pe52.codes, module.exports.HttpError);
/**
 * Get the code class of a status code.
 * @private
 */ function $39d1d46fff935637$var$codeClass(status) {
    return Number(String(status).charAt(0) + "00");
}
/**
 * Create a new HTTP Error.
 *
 * @returns {Error}
 * @public
 */ function $39d1d46fff935637$var$createError() {
    // so much arity going on ~_~
    var err;
    var msg;
    var status = 500;
    var props = {};
    for(var i = 0; i < arguments.length; i++){
        var arg = arguments[i];
        if (arg instanceof Error) {
            err = arg;
            status = err.status || err.statusCode || status;
            continue;
        }
        switch(typeof arg === "undefined" ? "undefined" : (0, $1ObTH._)(arg)){
            case "string":
                msg = arg;
                break;
            case "number":
                status = arg;
                if (i !== 0) $39d1d46fff935637$var$deprecate("non-first-argument status code; replace with createError(" + arg + ", ...)");
                break;
            case "object":
                props = arg;
                break;
        }
    }
    if (typeof status === "number" && (status < 400 || status >= 600)) $39d1d46fff935637$var$deprecate("non-error status code; use only 4xx or 5xx status codes");
    if (typeof status !== "number" || !$9Pe52[status] && (status < 400 || status >= 600)) status = 500;
    // constructor
    var HttpError = $39d1d46fff935637$var$createError[status] || $39d1d46fff935637$var$createError[$39d1d46fff935637$var$codeClass(status)];
    if (!err) {
        // create error
        err = HttpError ? new HttpError(msg) : new Error(msg || $9Pe52[status]);
        Error.captureStackTrace(err, $39d1d46fff935637$var$createError);
    }
    if (!HttpError || !(err instanceof HttpError) || err.status !== status) {
        // add properties to generic error
        err.expose = status < 500;
        err.status = err.statusCode = status;
    }
    for(var key in props)if (key !== "status" && key !== "statusCode") err[key] = props[key];
    return err;
}
/**
 * Create HTTP error abstract base class.
 * @private
 */ function $39d1d46fff935637$var$createHttpErrorConstructor() {
    var HttpError = function HttpError() {
        throw new TypeError("cannot construct abstract class");
    };
    $kvFQ5(HttpError, Error);
    return HttpError;
}
/**
 * Create a constructor for a client error.
 * @private
 */ function $39d1d46fff935637$var$createClientErrorConstructor(HttpError, name, code) {
    var className = $39d1d46fff935637$var$toClassName(name);
    function ClientError(message) {
        // create the error object
        var msg = message != null ? message : $9Pe52[code];
        var err = new Error(msg);
        // capture a stack trace to the construction point
        Error.captureStackTrace(err, ClientError);
        // adjust the [[Prototype]]
        $fzpDq(err, ClientError.prototype);
        // redefine the error message
        Object.defineProperty(err, "message", {
            enumerable: true,
            configurable: true,
            value: msg,
            writable: true
        });
        // redefine the error name
        Object.defineProperty(err, "name", {
            enumerable: false,
            configurable: true,
            value: className,
            writable: true
        });
        return err;
    }
    $kvFQ5(ClientError, HttpError);
    $39d1d46fff935637$var$nameFunc(ClientError, className);
    ClientError.prototype.status = code;
    ClientError.prototype.statusCode = code;
    ClientError.prototype.expose = true;
    return ClientError;
}
/**
 * Create function to test is a value is a HttpError.
 * @private
 */ function $39d1d46fff935637$var$createIsHttpErrorFunction(HttpError) {
    return function isHttpError(val) {
        if (!val || typeof val !== "object") return false;
        if (val instanceof HttpError) return true;
        return val instanceof Error && typeof val.expose === "boolean" && typeof val.statusCode === "number" && val.status === val.statusCode;
    };
}
/**
 * Create a constructor for a server error.
 * @private
 */ function $39d1d46fff935637$var$createServerErrorConstructor(HttpError, name, code) {
    var className = $39d1d46fff935637$var$toClassName(name);
    function ServerError(message) {
        // create the error object
        var msg = message != null ? message : $9Pe52[code];
        var err = new Error(msg);
        // capture a stack trace to the construction point
        Error.captureStackTrace(err, ServerError);
        // adjust the [[Prototype]]
        $fzpDq(err, ServerError.prototype);
        // redefine the error message
        Object.defineProperty(err, "message", {
            enumerable: true,
            configurable: true,
            value: msg,
            writable: true
        });
        // redefine the error name
        Object.defineProperty(err, "name", {
            enumerable: false,
            configurable: true,
            value: className,
            writable: true
        });
        return err;
    }
    $kvFQ5(ServerError, HttpError);
    $39d1d46fff935637$var$nameFunc(ServerError, className);
    ServerError.prototype.status = code;
    ServerError.prototype.statusCode = code;
    ServerError.prototype.expose = false;
    return ServerError;
}
/**
 * Set the name of a function, if possible.
 * @private
 */ function $39d1d46fff935637$var$nameFunc(func, name) {
    var desc = Object.getOwnPropertyDescriptor(func, "name");
    if (desc && desc.configurable) {
        desc.value = name;
        Object.defineProperty(func, "name", desc);
    }
}
/**
 * Populate the exports object with constructors for every error class.
 * @private
 */ function $39d1d46fff935637$var$populateConstructorExports(exports, codes, HttpError) {
    codes.forEach(function forEachCode(code) {
        var CodeError;
        var name = $g14Bq($9Pe52[code]);
        switch($39d1d46fff935637$var$codeClass(code)){
            case 400:
                CodeError = $39d1d46fff935637$var$createClientErrorConstructor(HttpError, name, code);
                break;
            case 500:
                CodeError = $39d1d46fff935637$var$createServerErrorConstructor(HttpError, name, code);
                break;
        }
        if (CodeError) {
            // export the constructor
            exports[code] = CodeError;
            exports[name] = CodeError;
        }
    });
    // backwards-compatibility
    exports["I'mateapot"] = $39d1d46fff935637$var$deprecate.function(exports.ImATeapot, '"I\'mateapot"; use "ImATeapot" instead');
}
/**
 * Get a class name from a name identifier.
 * @private
 */ function $39d1d46fff935637$var$toClassName(name) {
    return name.substr(-5) !== "Error" ? name + "Error" : name;
}

});
parcelRequire.register("7QY2I", function(module, exports) {
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $5b7bf6ffa9583087$var$depd;
/**
 * Create deprecate for namespace in caller.
 */ function $5b7bf6ffa9583087$var$depd(namespace) {
    var deprecate = function deprecate(message) {
    // no-op in browser
    };
    if (!namespace) throw new TypeError("argument namespace is required");
    deprecate._file = undefined;
    deprecate._ignored = true;
    deprecate._namespace = namespace;
    deprecate._traced = false;
    deprecate._warned = Object.create(null);
    deprecate.function = $5b7bf6ffa9583087$var$wrapfunction;
    deprecate.property = $5b7bf6ffa9583087$var$wrapproperty;
    return deprecate;
}
/**
 * Return a wrapped function in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $5b7bf6ffa9583087$var$wrapfunction(fn, message) {
    if (typeof fn !== "function") throw new TypeError("argument fn must be a function");
    return fn;
}
/**
 * Wrap property in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $5b7bf6ffa9583087$var$wrapproperty(obj, prop, message) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new TypeError("argument obj must be object");
    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (!descriptor) throw new TypeError("must call property on owner object");
    if (!descriptor.configurable) throw new TypeError("property must be configurable");
}

});

parcelRequire.register("fzpDq", function(module, exports) {
"use strict";
/* eslint no-proto: 0 */ module.exports = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $b55e027617e5ea63$var$setProtoOf : $b55e027617e5ea63$var$mixinProperties);
function $b55e027617e5ea63$var$setProtoOf(obj, proto) {
    obj.__proto__ = proto;
    return obj;
}
function $b55e027617e5ea63$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) obj[prop] = proto[prop];
    return obj;
}

});

parcelRequire.register("9Pe52", function(module, exports) {
/*!
 * statuses
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";

var $5ITrS = parcelRequire("5ITrS");
/**
 * Module exports.
 * @public
 */ module.exports = $7273cc83b556e227$var$status;
// status code to message map
$7273cc83b556e227$var$status.STATUS_CODES = $5ITrS;
// array of status codes
$7273cc83b556e227$var$status.codes = $7273cc83b556e227$var$populateStatusesMap($7273cc83b556e227$var$status, $5ITrS);
// status codes for redirects
$7273cc83b556e227$var$status.redirect = {
    300: true,
    301: true,
    302: true,
    303: true,
    305: true,
    307: true,
    308: true
};
// status codes for empty bodies
$7273cc83b556e227$var$status.empty = {
    204: true,
    205: true,
    304: true
};
// status codes for when you should retry the request
$7273cc83b556e227$var$status.retry = {
    502: true,
    503: true,
    504: true
};
/**
 * Populate the statuses map for given codes.
 * @private
 */ function $7273cc83b556e227$var$populateStatusesMap(statuses, codes) {
    var arr = [];
    Object.keys(codes).forEach(function forEachCode(code) {
        var message = codes[code];
        var _$status = Number(code);
        // Populate properties
        statuses[_$status] = message;
        statuses[message] = _$status;
        statuses[message.toLowerCase()] = _$status;
        // Add to array
        arr.push(_$status);
    });
    return arr;
}
/**
 * Get the status code.
 *
 * Given a number, this will throw if it is not a known status
 * code, otherwise the code will be returned. Given a string,
 * the string will be parsed for a number and return the code
 * if valid, otherwise will lookup the code assuming this is
 * the status message.
 *
 * @param {string|number} code
 * @returns {number}
 * @public
 */ function $7273cc83b556e227$var$status(code) {
    if (typeof code === "number") {
        if (!$7273cc83b556e227$var$status[code]) throw new Error("invalid status code: " + code);
        return code;
    }
    if (typeof code !== "string") throw new TypeError("code must be a number or string");
    // '403'
    var n = parseInt(code, 10);
    if (!isNaN(n)) {
        if (!$7273cc83b556e227$var$status[n]) throw new Error("invalid status code: " + n);
        return n;
    }
    n = $7273cc83b556e227$var$status[code.toLowerCase()];
    if (!n) throw new Error('invalid status message: "' + code + '"');
    return n;
}

});
parcelRequire.register("5ITrS", function(module, exports) {
module.exports = JSON.parse('{"100":"Continue","101":"Switching Protocols","102":"Processing","103":"Early Hints","200":"OK","201":"Created","202":"Accepted","203":"Non-Authoritative Information","204":"No Content","205":"Reset Content","206":"Partial Content","207":"Multi-Status","208":"Already Reported","226":"IM Used","300":"Multiple Choices","301":"Moved Permanently","302":"Found","303":"See Other","304":"Not Modified","305":"Use Proxy","306":"(Unused)","307":"Temporary Redirect","308":"Permanent Redirect","400":"Bad Request","401":"Unauthorized","402":"Payment Required","403":"Forbidden","404":"Not Found","405":"Method Not Allowed","406":"Not Acceptable","407":"Proxy Authentication Required","408":"Request Timeout","409":"Conflict","410":"Gone","411":"Length Required","412":"Precondition Failed","413":"Payload Too Large","414":"URI Too Long","415":"Unsupported Media Type","416":"Range Not Satisfiable","417":"Expectation Failed","418":"I\'m a teapot","421":"Misdirected Request","422":"Unprocessable Entity","423":"Locked","424":"Failed Dependency","425":"Unordered Collection","426":"Upgrade Required","428":"Precondition Required","429":"Too Many Requests","431":"Request Header Fields Too Large","451":"Unavailable For Legal Reasons","500":"Internal Server Error","501":"Not Implemented","502":"Bad Gateway","503":"Service Unavailable","504":"Gateway Timeout","505":"HTTP Version Not Supported","506":"Variant Also Negotiates","507":"Insufficient Storage","508":"Loop Detected","509":"Bandwidth Limit Exceeded","510":"Not Extended","511":"Network Authentication Required"}');

});


parcelRequire.register("kvFQ5", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRequire.register("g14Bq", function(module, exports) {
/*!
 * toidentifier
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $ba904f4f4ae0d929$var$toIdentifier;
/**
 * Trasform the given string into a JavaScript identifier
 *
 * @param {string} str
 * @returns {string}
 * @public
 */ function $ba904f4f4ae0d929$var$toIdentifier(str) {
    return str.split(" ").map(function(token) {
        return token.slice(0, 1).toUpperCase() + token.slice(1);
    }).join("").replace(/[^ _0-9a-z]/gi, "");
}

});


parcelRequire.register("dkG2P", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $9b4dc1ccff7c973d$var$exponentialBackoff(startWaitTime, retryNumber, waitBackoff, getResult) {
    return $9b4dc1ccff7c973d$var$_exponentialBackoff.apply(this, arguments);
}
function $9b4dc1ccff7c973d$var$_exponentialBackoff() {
    $9b4dc1ccff7c973d$var$_exponentialBackoff = (0, $byzP8._)(function(startWaitTime, retryNumber, waitBackoff, getResult) {
        var waitTime, i, result;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    waitTime = startWaitTime;
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < retryNumber)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        getResult()
                    ];
                case 2:
                    result = _state.sent();
                    if (result) return [
                        2,
                        result
                    ];
                    return [
                        4,
                        $9b4dc1ccff7c973d$var$sleep(waitTime)
                    ];
                case 3:
                    _state.sent();
                    waitTime *= waitBackoff;
                    _state.label = 4;
                case 4:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 5:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return $9b4dc1ccff7c973d$var$_exponentialBackoff.apply(this, arguments);
}
module.exports.default = $9b4dc1ccff7c973d$var$exponentialBackoff;
// Sleep given number of millis.
function $9b4dc1ccff7c973d$var$sleep(millis) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, millis);
    });
}

});

parcelRequire.register("6vXKs", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $ftJVG = parcelRequire("ftJVG");

var $fLnyw = parcelRequire("fLnyw");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logWarning = module.exports.ErrorContext = module.exports.TypedError = module.exports.ArgumentTypeError = module.exports.PositionalArgsError = void 0;
var $4be3fc150c5bb6ac$var$PositionalArgsError = /*#__PURE__*/ function(Error1) {
    (0, $ftJVG._)(PositionalArgsError, Error1);
    var _super = (0, $6OZAO._)(PositionalArgsError);
    function PositionalArgsError() {
        (0, $978gY._)(this, PositionalArgsError);
        return _super.call(this, "Contract method calls expect named arguments wrapped in object, e.g. { argName1: argValue1, argName2: argValue2 }");
    }
    return PositionalArgsError;
}((0, $2TMdq._)(Error));
module.exports.PositionalArgsError = $4be3fc150c5bb6ac$var$PositionalArgsError;
var $4be3fc150c5bb6ac$var$ArgumentTypeError = /*#__PURE__*/ function(Error1) {
    (0, $ftJVG._)(ArgumentTypeError, Error1);
    var _super = (0, $6OZAO._)(ArgumentTypeError);
    function ArgumentTypeError(argName, argType, argValue) {
        (0, $978gY._)(this, ArgumentTypeError);
        return _super.call(this, "Expected ".concat(argType, " for '").concat(argName, "' argument, but got '").concat(JSON.stringify(argValue), "'"));
    }
    return ArgumentTypeError;
}((0, $2TMdq._)(Error));
module.exports.ArgumentTypeError = $4be3fc150c5bb6ac$var$ArgumentTypeError;
var $4be3fc150c5bb6ac$var$TypedError = /*#__PURE__*/ function(Error1) {
    (0, $ftJVG._)(TypedError, Error1);
    var _super = (0, $6OZAO._)(TypedError);
    function TypedError(message, type, context) {
        (0, $978gY._)(this, TypedError);
        var _this;
        _this = _super.call(this, message);
        _this.type = type || "UntypedError";
        _this.context = context;
        return _this;
    }
    return TypedError;
}((0, $2TMdq._)(Error));
module.exports.TypedError = $4be3fc150c5bb6ac$var$TypedError;
var $4be3fc150c5bb6ac$var$ErrorContext = function ErrorContext(transactionHash) {
    (0, $978gY._)(this, ErrorContext);
    this.transactionHash = transactionHash;
};
module.exports.ErrorContext = $4be3fc150c5bb6ac$var$ErrorContext;
function $4be3fc150c5bb6ac$var$logWarning() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, (0, $fLnyw._)(args));
}
module.exports.logWarning = $4be3fc150c5bb6ac$var$logWarning;

});
parcelRequire.register("fLnyw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b79d847807e3ac29$export$1b5e630bc3aea29f; });

var $c1J0v = parcelRequire("c1J0v");

var $2uHzb = parcelRequire("2uHzb");

var $cKglA = parcelRequire("cKglA");

var $imR8K = parcelRequire("imR8K");
function $b79d847807e3ac29$export$1b5e630bc3aea29f(arr) {
    return (0, $c1J0v._array_without_holes)(arr) || (0, $2uHzb._iterable_to_array)(arr) || (0, $imR8K._unsupported_iterable_to_array)(arr) || (0, $cKglA._non_iterable_spread)();
}

});
parcelRequire.register("c1J0v", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $8c187d86836ebd16$export$7e0947b5ad3404e2; });

var $dkOJL = parcelRequire("dkOJL");
function $8c187d86836ebd16$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $dkOJL._array_like_to_array)(arr);
}

});

parcelRequire.register("2uHzb", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $1d102d83300b551e$export$1eb58a6e75231000; });
function $1d102d83300b551e$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("cKglA", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $9476761b01b79dcb$export$e6f3c4780d19eb2b; });
function $9476761b01b79dcb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRequire.register("2RlOX", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $6OZAO = parcelRequire("6OZAO");
"use strict";
var $2151753338b686b6$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getErrorTypeFromErrorMessage = module.exports.formatError = module.exports.parseResultError = module.exports.parseRpcError = module.exports.ServerError = void 0;

var $2151753338b686b6$var$mustache_1 = $2151753338b686b6$var$__importDefault((parcelRequire("kIkEy")));

var $2151753338b686b6$var$rpc_error_schema_json_1 = $2151753338b686b6$var$__importDefault((parcelRequire("4WO7v")));

var $2151753338b686b6$var$error_messages_json_1 = $2151753338b686b6$var$__importDefault((parcelRequire("7WUyz")));

var $hHZrX = parcelRequire("hHZrX");

var $6vXKs = parcelRequire("6vXKs");
var $2151753338b686b6$var$mustacheHelpers = {
    formatNear: function() {
        return function(n, render) {
            return $hHZrX.utils.format.formatNearAmount(render(n));
        };
    }
};
var $2151753338b686b6$var$ServerError = /*#__PURE__*/ function(_errors_1_TypedError) {
    (0, $ftJVG._)(ServerError, _errors_1_TypedError);
    var _super = (0, $6OZAO._)(ServerError);
    function ServerError() {
        (0, $978gY._)(this, ServerError);
        return _super.apply(this, arguments);
    }
    return ServerError;
}($6vXKs.TypedError);
module.exports.ServerError = $2151753338b686b6$var$ServerError;
var $2151753338b686b6$var$ServerTransactionError = /*#__PURE__*/ function(ServerError) {
    (0, $ftJVG._)(ServerTransactionError, ServerError);
    var _super = (0, $6OZAO._)(ServerTransactionError);
    function ServerTransactionError() {
        (0, $978gY._)(this, ServerTransactionError);
        return _super.apply(this, arguments);
    }
    return ServerTransactionError;
}($2151753338b686b6$var$ServerError);
function $2151753338b686b6$var$parseRpcError(errorObj) {
    var result = {};
    var errorClassName = $2151753338b686b6$var$walkSubtype(errorObj, $2151753338b686b6$var$rpc_error_schema_json_1.default.schema, result, "");
    // NOTE: This assumes that all errors extend TypedError
    var error = new $2151753338b686b6$var$ServerError($2151753338b686b6$var$formatError(errorClassName, result), errorClassName);
    Object.assign(error, result);
    return error;
}
module.exports.parseRpcError = $2151753338b686b6$var$parseRpcError;
function $2151753338b686b6$var$parseResultError(result) {
    var server_error = $2151753338b686b6$var$parseRpcError(result.status.Failure);
    var server_tx_error = new $2151753338b686b6$var$ServerTransactionError();
    Object.assign(server_tx_error, server_error);
    server_tx_error.type = server_error.type;
    server_tx_error.message = server_error.message;
    server_tx_error.transaction_outcome = result.transaction_outcome;
    return server_tx_error;
}
module.exports.parseResultError = $2151753338b686b6$var$parseResultError;
function $2151753338b686b6$var$formatError(errorClassName, errorData) {
    if (typeof $2151753338b686b6$var$error_messages_json_1.default[errorClassName] === "string") return $2151753338b686b6$var$mustache_1.default.render($2151753338b686b6$var$error_messages_json_1.default[errorClassName], (0, $8OnJk._)({}, errorData, $2151753338b686b6$var$mustacheHelpers));
    return JSON.stringify(errorData);
}
module.exports.formatError = $2151753338b686b6$var$formatError;
/**
 * Walks through defined schema returning error(s) recursively
 * @param errorObj The error to be parsed
 * @param schema A defined schema in JSON mapping to the RPC errors
 * @param result An object used in recursion or called directly
 * @param typeName The human-readable error type name as defined in the JSON mapping
 */ function $2151753338b686b6$var$walkSubtype(errorObj, schema, result, typeName) {
    var error;
    var type;
    var errorTypeName;
    for(var errorName in schema){
        if ($2151753338b686b6$var$isString(errorObj[errorName])) // Return early if error type is in a schema
        return errorObj[errorName];
        if ($2151753338b686b6$var$isObject(errorObj[errorName])) {
            error = errorObj[errorName];
            type = schema[errorName];
            errorTypeName = errorName;
        } else if ($2151753338b686b6$var$isObject(errorObj.kind) && $2151753338b686b6$var$isObject(errorObj.kind[errorName])) {
            error = errorObj.kind[errorName];
            type = schema[errorName];
            errorTypeName = errorName;
        } else continue;
    }
    if (error && type) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(type.props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var prop = _step.value;
                result[prop] = error[prop];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return $2151753338b686b6$var$walkSubtype(error, schema, result, errorTypeName);
    } else {
        // TODO: is this the right thing to do?
        result.kind = errorObj;
        return typeName;
    }
}
function $2151753338b686b6$var$getErrorTypeFromErrorMessage(errorMessage) {
    // This function should be removed when JSON RPC starts returning typed errors.
    switch(true){
        case /^account .*? does not exist while viewing$/.test(errorMessage):
            return "AccountDoesNotExist";
        case /^Account .*? doesn't exist$/.test(errorMessage):
            return "AccountDoesNotExist";
        case /^access key .*? does not exist while viewing$/.test(errorMessage):
            return "AccessKeyDoesNotExist";
        case /wasm execution failed with error: FunctionCallError\(CompilationError\(CodeDoesNotExist/.test(errorMessage):
            return "CodeDoesNotExist";
        case /Transaction nonce \d+ must be larger than nonce of the used access key \d+/.test(errorMessage):
            return "InvalidNonce";
        default:
            return "UntypedError";
    }
}
module.exports.getErrorTypeFromErrorMessage = $2151753338b686b6$var$getErrorTypeFromErrorMessage;
/**
 * Helper function determining if the argument is an object
 * @param n Value to check
 */ function $2151753338b686b6$var$isObject(n) {
    return Object.prototype.toString.call(n) === "[object Object]";
}
/**
 * Helper function determining if the argument is a string
 * @param n Value to check
 */ function $2151753338b686b6$var$isString(n) {
    return Object.prototype.toString.call(n) === "[object String]";
}

});
parcelRequire.register("kIkEy", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    "use strict";
    var isFunction = function isFunction(object) {
        return typeof object === "function";
    };
    var typeStr = /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    };
    var escapeRegExp = function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    };
    var hasProperty = /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    };
    var primitiveHasOwnProperty = /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    };
    var testRegExp = function testRegExp(re, string) {
        return regExpTest.call(re, string);
    };
    var isWhitespace = function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    };
    var escapeHtml = function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    };
    var parseTemplate = /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    };
    var squashTokens = /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    };
    var nestTokens = /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    };
    var Scanner = /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    };
    var Context = /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    };
    var Writer = /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    };
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    var nonSpaceRe = /\S/;
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var _$cache = this.cache;
        var value;
        if (_$cache.hasOwnProperty(name)) value = _$cache[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            _$cache[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var _$cache = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof _$cache !== "undefined";
        var tokens = isCacheEnabled ? _$cache.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && _$cache.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, config);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context, config);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var subRender = // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        };
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === "object") return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === "object" && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: "mustache.js",
        version: "4.2.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});

});

parcelRequire.register("4WO7v", function(module, exports) {
module.exports = JSON.parse('{"schema":{"BadUTF16":{"name":"BadUTF16","subtypes":[],"props":{}},"BadUTF8":{"name":"BadUTF8","subtypes":[],"props":{}},"BalanceExceeded":{"name":"BalanceExceeded","subtypes":[],"props":{}},"BreakpointTrap":{"name":"BreakpointTrap","subtypes":[],"props":{}},"CacheError":{"name":"CacheError","subtypes":["ReadError","WriteError","DeserializationError","SerializationError"],"props":{}},"CallIndirectOOB":{"name":"CallIndirectOOB","subtypes":[],"props":{}},"CannotAppendActionToJointPromise":{"name":"CannotAppendActionToJointPromise","subtypes":[],"props":{}},"CannotReturnJointPromise":{"name":"CannotReturnJointPromise","subtypes":[],"props":{}},"CodeDoesNotExist":{"name":"CodeDoesNotExist","subtypes":[],"props":{"account_id":""}},"CompilationError":{"name":"CompilationError","subtypes":["CodeDoesNotExist","PrepareError","WasmerCompileError"],"props":{}},"ContractSizeExceeded":{"name":"ContractSizeExceeded","subtypes":[],"props":{"limit":"","size":""}},"Deprecated":{"name":"Deprecated","subtypes":[],"props":{"method_name":""}},"Deserialization":{"name":"Deserialization","subtypes":[],"props":{}},"DeserializationError":{"name":"DeserializationError","subtypes":[],"props":{}},"EmptyMethodName":{"name":"EmptyMethodName","subtypes":[],"props":{}},"FunctionCallError":{"name":"FunctionCallError","subtypes":["CompilationError","LinkError","MethodResolveError","WasmTrap","WasmUnknownError","HostError","EvmError"],"props":{}},"GasExceeded":{"name":"GasExceeded","subtypes":[],"props":{}},"GasInstrumentation":{"name":"GasInstrumentation","subtypes":[],"props":{}},"GasLimitExceeded":{"name":"GasLimitExceeded","subtypes":[],"props":{}},"GenericTrap":{"name":"GenericTrap","subtypes":[],"props":{}},"GuestPanic":{"name":"GuestPanic","subtypes":[],"props":{"panic_msg":""}},"HostError":{"name":"HostError","subtypes":["BadUTF16","BadUTF8","GasExceeded","GasLimitExceeded","BalanceExceeded","EmptyMethodName","GuestPanic","IntegerOverflow","InvalidPromiseIndex","CannotAppendActionToJointPromise","CannotReturnJointPromise","InvalidPromiseResultIndex","InvalidRegisterId","IteratorWasInvalidated","MemoryAccessViolation","InvalidReceiptIndex","InvalidIteratorIndex","InvalidAccountId","InvalidMethodName","InvalidPublicKey","ProhibitedInView","NumberOfLogsExceeded","KeyLengthExceeded","ValueLengthExceeded","TotalLogLengthExceeded","NumberPromisesExceeded","NumberInputDataDependenciesExceeded","ReturnedValueLengthExceeded","ContractSizeExceeded","Deprecated"],"props":{}},"IllegalArithmetic":{"name":"IllegalArithmetic","subtypes":[],"props":{}},"IncorrectCallIndirectSignature":{"name":"IncorrectCallIndirectSignature","subtypes":[],"props":{}},"Instantiate":{"name":"Instantiate","subtypes":[],"props":{}},"IntegerOverflow":{"name":"IntegerOverflow","subtypes":[],"props":{}},"InternalMemoryDeclared":{"name":"InternalMemoryDeclared","subtypes":[],"props":{}},"InvalidAccountId":{"name":"InvalidAccountId","subtypes":[],"props":{"account_id":""}},"InvalidIteratorIndex":{"name":"InvalidIteratorIndex","subtypes":[],"props":{"iterator_index":""}},"InvalidMethodName":{"name":"InvalidMethodName","subtypes":[],"props":{}},"InvalidPromiseIndex":{"name":"InvalidPromiseIndex","subtypes":[],"props":{"promise_idx":""}},"InvalidPromiseResultIndex":{"name":"InvalidPromiseResultIndex","subtypes":[],"props":{"result_idx":""}},"InvalidPublicKey":{"name":"InvalidPublicKey","subtypes":[],"props":{}},"InvalidReceiptIndex":{"name":"InvalidReceiptIndex","subtypes":[],"props":{"receipt_index":""}},"InvalidRegisterId":{"name":"InvalidRegisterId","subtypes":[],"props":{"register_id":""}},"IteratorWasInvalidated":{"name":"IteratorWasInvalidated","subtypes":[],"props":{"iterator_index":""}},"KeyLengthExceeded":{"name":"KeyLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"LinkError":{"name":"LinkError","subtypes":[],"props":{"msg":""}},"Memory":{"name":"Memory","subtypes":[],"props":{}},"MemoryAccessViolation":{"name":"MemoryAccessViolation","subtypes":[],"props":{}},"MemoryOutOfBounds":{"name":"MemoryOutOfBounds","subtypes":[],"props":{}},"MethodEmptyName":{"name":"MethodEmptyName","subtypes":[],"props":{}},"MethodInvalidSignature":{"name":"MethodInvalidSignature","subtypes":[],"props":{}},"MethodNotFound":{"name":"MethodNotFound","subtypes":[],"props":{}},"MethodResolveError":{"name":"MethodResolveError","subtypes":["MethodEmptyName","MethodUTF8Error","MethodNotFound","MethodInvalidSignature"],"props":{}},"MethodUTF8Error":{"name":"MethodUTF8Error","subtypes":[],"props":{}},"MisalignedAtomicAccess":{"name":"MisalignedAtomicAccess","subtypes":[],"props":{}},"NumberInputDataDependenciesExceeded":{"name":"NumberInputDataDependenciesExceeded","subtypes":[],"props":{"limit":"","number_of_input_data_dependencies":""}},"NumberOfLogsExceeded":{"name":"NumberOfLogsExceeded","subtypes":[],"props":{"limit":""}},"NumberPromisesExceeded":{"name":"NumberPromisesExceeded","subtypes":[],"props":{"limit":"","number_of_promises":""}},"PrepareError":{"name":"PrepareError","subtypes":["Serialization","Deserialization","InternalMemoryDeclared","GasInstrumentation","StackHeightInstrumentation","Instantiate","Memory"],"props":{}},"ProhibitedInView":{"name":"ProhibitedInView","subtypes":[],"props":{"method_name":""}},"ReadError":{"name":"ReadError","subtypes":[],"props":{}},"ReturnedValueLengthExceeded":{"name":"ReturnedValueLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"Serialization":{"name":"Serialization","subtypes":[],"props":{}},"SerializationError":{"name":"SerializationError","subtypes":[],"props":{"hash":""}},"StackHeightInstrumentation":{"name":"StackHeightInstrumentation","subtypes":[],"props":{}},"StackOverflow":{"name":"StackOverflow","subtypes":[],"props":{}},"TotalLogLengthExceeded":{"name":"TotalLogLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"Unreachable":{"name":"Unreachable","subtypes":[],"props":{}},"ValueLengthExceeded":{"name":"ValueLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"WasmTrap":{"name":"WasmTrap","subtypes":["Unreachable","IncorrectCallIndirectSignature","MemoryOutOfBounds","CallIndirectOOB","IllegalArithmetic","MisalignedAtomicAccess","BreakpointTrap","StackOverflow","GenericTrap"],"props":{}},"WasmUnknownError":{"name":"WasmUnknownError","subtypes":[],"props":{}},"WasmerCompileError":{"name":"WasmerCompileError","subtypes":[],"props":{"msg":""}},"WriteError":{"name":"WriteError","subtypes":[],"props":{}},"AccessKeyNotFound":{"name":"AccessKeyNotFound","subtypes":[],"props":{"account_id":"","public_key":""}},"AccountAlreadyExists":{"name":"AccountAlreadyExists","subtypes":[],"props":{"account_id":""}},"AccountDoesNotExist":{"name":"AccountDoesNotExist","subtypes":[],"props":{"account_id":""}},"ActionError":{"name":"ActionError","subtypes":["AccountAlreadyExists","AccountDoesNotExist","CreateAccountOnlyByRegistrar","CreateAccountNotAllowed","ActorNoPermission","DeleteKeyDoesNotExist","AddKeyAlreadyExists","DeleteAccountStaking","LackBalanceForState","TriesToUnstake","TriesToStake","InsufficientStake","FunctionCallError","NewReceiptValidationError","OnlyImplicitAccountCreationAllowed"],"props":{"index":""}},"ActionsValidationError":{"name":"ActionsValidationError","subtypes":["DeleteActionMustBeFinal","TotalPrepaidGasExceeded","TotalNumberOfActionsExceeded","AddKeyMethodNamesNumberOfBytesExceeded","AddKeyMethodNameLengthExceeded","IntegerOverflow","InvalidAccountId","ContractSizeExceeded","FunctionCallMethodNameLengthExceeded","FunctionCallArgumentsLengthExceeded","UnsuitableStakingKey","FunctionCallZeroAttachedGas"],"props":{}},"ActorNoPermission":{"name":"ActorNoPermission","subtypes":[],"props":{"account_id":"","actor_id":""}},"AddKeyAlreadyExists":{"name":"AddKeyAlreadyExists","subtypes":[],"props":{"account_id":"","public_key":""}},"AddKeyMethodNameLengthExceeded":{"name":"AddKeyMethodNameLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"AddKeyMethodNamesNumberOfBytesExceeded":{"name":"AddKeyMethodNamesNumberOfBytesExceeded","subtypes":[],"props":{"limit":"","total_number_of_bytes":""}},"BalanceMismatchError":{"name":"BalanceMismatchError","subtypes":[],"props":{"final_accounts_balance":"","final_postponed_receipts_balance":"","incoming_receipts_balance":"","incoming_validator_rewards":"","initial_accounts_balance":"","initial_postponed_receipts_balance":"","new_delayed_receipts_balance":"","other_burnt_amount":"","outgoing_receipts_balance":"","processed_delayed_receipts_balance":"","slashed_burnt_amount":"","tx_burnt_amount":""}},"CostOverflow":{"name":"CostOverflow","subtypes":[],"props":{}},"CreateAccountNotAllowed":{"name":"CreateAccountNotAllowed","subtypes":[],"props":{"account_id":"","predecessor_id":""}},"CreateAccountOnlyByRegistrar":{"name":"CreateAccountOnlyByRegistrar","subtypes":[],"props":{"account_id":"","predecessor_id":"","registrar_account_id":""}},"DeleteAccountStaking":{"name":"DeleteAccountStaking","subtypes":[],"props":{"account_id":""}},"DeleteActionMustBeFinal":{"name":"DeleteActionMustBeFinal","subtypes":[],"props":{}},"DeleteKeyDoesNotExist":{"name":"DeleteKeyDoesNotExist","subtypes":[],"props":{"account_id":"","public_key":""}},"DepositWithFunctionCall":{"name":"DepositWithFunctionCall","subtypes":[],"props":{}},"Expired":{"name":"Expired","subtypes":[],"props":{}},"FunctionCallArgumentsLengthExceeded":{"name":"FunctionCallArgumentsLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"FunctionCallMethodNameLengthExceeded":{"name":"FunctionCallMethodNameLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"FunctionCallZeroAttachedGas":{"name":"FunctionCallZeroAttachedGas","subtypes":[],"props":{}},"InsufficientStake":{"name":"InsufficientStake","subtypes":[],"props":{"account_id":"","minimum_stake":"","stake":""}},"InvalidAccessKeyError":{"name":"InvalidAccessKeyError","subtypes":["AccessKeyNotFound","ReceiverMismatch","MethodNameMismatch","RequiresFullAccess","NotEnoughAllowance","DepositWithFunctionCall"],"props":{}},"InvalidChain":{"name":"InvalidChain","subtypes":[],"props":{}},"InvalidDataReceiverId":{"name":"InvalidDataReceiverId","subtypes":[],"props":{"account_id":""}},"InvalidNonce":{"name":"InvalidNonce","subtypes":[],"props":{"ak_nonce":"","tx_nonce":""}},"InvalidPredecessorId":{"name":"InvalidPredecessorId","subtypes":[],"props":{"account_id":""}},"InvalidReceiverId":{"name":"InvalidReceiverId","subtypes":[],"props":{"account_id":""}},"InvalidSignature":{"name":"InvalidSignature","subtypes":[],"props":{}},"InvalidSignerId":{"name":"InvalidSignerId","subtypes":[],"props":{"account_id":""}},"InvalidTxError":{"name":"InvalidTxError","subtypes":["InvalidAccessKeyError","InvalidSignerId","SignerDoesNotExist","InvalidNonce","InvalidReceiverId","InvalidSignature","NotEnoughBalance","LackBalanceForState","CostOverflow","InvalidChain","Expired","ActionsValidation"],"props":{}},"LackBalanceForState":{"name":"LackBalanceForState","subtypes":[],"props":{"account_id":"","amount":""}},"MethodNameMismatch":{"name":"MethodNameMismatch","subtypes":[],"props":{"method_name":""}},"NotEnoughAllowance":{"name":"NotEnoughAllowance","subtypes":[],"props":{"account_id":"","allowance":"","cost":"","public_key":""}},"NotEnoughBalance":{"name":"NotEnoughBalance","subtypes":[],"props":{"balance":"","cost":"","signer_id":""}},"OnlyImplicitAccountCreationAllowed":{"name":"OnlyImplicitAccountCreationAllowed","subtypes":[],"props":{"account_id":""}},"ReceiptValidationError":{"name":"ReceiptValidationError","subtypes":["InvalidPredecessorId","InvalidReceiverId","InvalidSignerId","InvalidDataReceiverId","ReturnedValueLengthExceeded","NumberInputDataDependenciesExceeded","ActionsValidation"],"props":{}},"ReceiverMismatch":{"name":"ReceiverMismatch","subtypes":[],"props":{"ak_receiver":"","tx_receiver":""}},"RequiresFullAccess":{"name":"RequiresFullAccess","subtypes":[],"props":{}},"SignerDoesNotExist":{"name":"SignerDoesNotExist","subtypes":[],"props":{"signer_id":""}},"TotalNumberOfActionsExceeded":{"name":"TotalNumberOfActionsExceeded","subtypes":[],"props":{"limit":"","total_number_of_actions":""}},"TotalPrepaidGasExceeded":{"name":"TotalPrepaidGasExceeded","subtypes":[],"props":{"limit":"","total_prepaid_gas":""}},"TriesToStake":{"name":"TriesToStake","subtypes":[],"props":{"account_id":"","balance":"","locked":"","stake":""}},"TriesToUnstake":{"name":"TriesToUnstake","subtypes":[],"props":{"account_id":""}},"TxExecutionError":{"name":"TxExecutionError","subtypes":["ActionError","InvalidTxError"],"props":{}},"UnsuitableStakingKey":{"name":"UnsuitableStakingKey","subtypes":[],"props":{"public_key":""}},"Closed":{"name":"Closed","subtypes":[],"props":{}},"InternalError":{"name":"InternalError","subtypes":[],"props":{}},"ServerError":{"name":"ServerError","subtypes":["TxExecutionError","Timeout","Closed","InternalError"],"props":{}},"Timeout":{"name":"Timeout","subtypes":[],"props":{}}}}');

});

parcelRequire.register("7WUyz", function(module, exports) {
module.exports = JSON.parse('{"GasLimitExceeded":"Exceeded the maximum amount of gas allowed to burn per contract","MethodEmptyName":"Method name is empty","WasmerCompileError":"Wasmer compilation error: {{msg}}","GuestPanic":"Smart contract panicked: {{panic_msg}}","Memory":"Error creating Wasm memory","GasExceeded":"Exceeded the prepaid gas","MethodUTF8Error":"Method name is not valid UTF8 string","BadUTF16":"String encoding is bad UTF-16 sequence","WasmTrap":"WebAssembly trap: {{msg}}","GasInstrumentation":"Gas instrumentation failed or contract has denied instructions.","InvalidPromiseIndex":"{{promise_idx}} does not correspond to existing promises","InvalidPromiseResultIndex":"Accessed invalid promise result index: {{result_idx}}","Deserialization":"Error happened while deserializing the module","MethodNotFound":"Contract method is not found","InvalidRegisterId":"Accessed invalid register id: {{register_id}}","InvalidReceiptIndex":"VM Logic returned an invalid receipt index: {{receipt_index}}","EmptyMethodName":"Method name is empty in contract call","CannotReturnJointPromise":"Returning joint promise is currently prohibited","StackHeightInstrumentation":"Stack instrumentation failed","CodeDoesNotExist":"Cannot find contract code for account {{account_id}}","MethodInvalidSignature":"Invalid method signature","IntegerOverflow":"Integer overflow happened during contract execution","MemoryAccessViolation":"MemoryAccessViolation","InvalidIteratorIndex":"Iterator index {{iterator_index}} does not exist","IteratorWasInvalidated":"Iterator {{iterator_index}} was invalidated after its creation by performing a mutable operation on trie","InvalidAccountId":"VM Logic returned an invalid account id","Serialization":"Error happened while serializing the module","CannotAppendActionToJointPromise":"Actions can only be appended to non-joint promise.","InternalMemoryDeclared":"Internal memory declaration has been found in the module","Instantiate":"Error happened during instantiation","ProhibitedInView":"{{method_name}} is not allowed in view calls","InvalidMethodName":"VM Logic returned an invalid method name","BadUTF8":"String encoding is bad UTF-8 sequence","BalanceExceeded":"Exceeded the account balance","LinkError":"Wasm contract link error: {{msg}}","InvalidPublicKey":"VM Logic provided an invalid public key","ActorNoPermission":"Actor {{actor_id}} doesn\'t have permission to account {{account_id}} to complete the action","LackBalanceForState":"The account {{account_id}} wouldn\'t have enough balance to cover storage, required to have {{amount}} yoctoNEAR more","ReceiverMismatch":"Wrong AccessKey used for transaction: transaction is sent to receiver_id={{tx_receiver}}, but is signed with function call access key that restricted to only use with receiver_id={{ak_receiver}}. Either change receiver_id in your transaction or switch to use a FullAccessKey.","CostOverflow":"Transaction gas or balance cost is too high","InvalidSignature":"Transaction is not signed with the given public key","AccessKeyNotFound":"Signer \\"{{account_id}}\\" doesn\'t have access key with the given public_key {{public_key}}","NotEnoughBalance":"Sender {{signer_id}} does not have enough balance {{#formatNear}}{{balance}}{{/formatNear}} for operation costing {{#formatNear}}{{cost}}{{/formatNear}}","NotEnoughAllowance":"Access Key {account_id}:{public_key} does not have enough balance {{#formatNear}}{{allowance}}{{/formatNear}} for transaction costing {{#formatNear}}{{cost}}{{/formatNear}}","Expired":"Transaction has expired","DeleteAccountStaking":"Account {{account_id}} is staking and can not be deleted","SignerDoesNotExist":"Signer {{signer_id}} does not exist","TriesToStake":"Account {{account_id}} tried to stake {{#formatNear}}{{stake}}{{/formatNear}}, but has staked {{#formatNear}}{{locked}}{{/formatNear}} and only has {{#formatNear}}{{balance}}{{/formatNear}}","AddKeyAlreadyExists":"The public key {{public_key}} is already used for an existing access key","InvalidSigner":"Invalid signer account ID {{signer_id}} according to requirements","CreateAccountNotAllowed":"The new account_id {{account_id}} can\'t be created by {{predecessor_id}}","RequiresFullAccess":"The transaction contains more then one action, but it was signed with an access key which allows transaction to apply only one specific action. To apply more then one actions TX must be signed with a full access key","TriesToUnstake":"Account {{account_id}} is not yet staked, but tried to unstake","InvalidNonce":"Transaction nonce {{tx_nonce}} must be larger than nonce of the used access key {{ak_nonce}}","AccountAlreadyExists":"Can\'t create a new account {{account_id}}, because it already exists","InvalidChain":"Transaction parent block hash doesn\'t belong to the current chain","AccountDoesNotExist":"Can\'t complete the action because account {{account_id}} doesn\'t exist","MethodNameMismatch":"Transaction method name {{method_name}} isn\'t allowed by the access key","DeleteAccountHasRent":"Account {{account_id}} can\'t be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover the rent","DeleteAccountHasEnoughBalance":"Account {{account_id}} can\'t be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover it\'s storage","InvalidReceiver":"Invalid receiver account ID {{receiver_id}} according to requirements","DeleteKeyDoesNotExist":"Account {{account_id}} tries to remove an access key that doesn\'t exist","Timeout":"Timeout exceeded","Closed":"Connection closed"}');

});




parcelRequire.register("jSV3x", function(module, exports) {
"use strict";
var $e79f519d1c032151$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e79f519d1c032151$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e79f519d1c032151$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $e79f519d1c032151$var$__createBinding(result, mod, k);
    }
    $e79f519d1c032151$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logWarning = module.exports.rpc_errors = module.exports.KeyPairEd25519 = module.exports.KeyPair = module.exports.PublicKey = module.exports.format = module.exports.enums = module.exports.web = module.exports.serialize = module.exports.key_pair = void 0;

var $e79f519d1c032151$var$key_pair = $e79f519d1c032151$var$__importStar((parcelRequire("8pTGX")));
module.exports.key_pair = $e79f519d1c032151$var$key_pair;

var $e79f519d1c032151$var$serialize = $e79f519d1c032151$var$__importStar((parcelRequire("2RCX3")));
module.exports.serialize = $e79f519d1c032151$var$serialize;

var $e79f519d1c032151$var$web = $e79f519d1c032151$var$__importStar((parcelRequire("9Nstj")));
module.exports.web = $e79f519d1c032151$var$web;

var $e79f519d1c032151$var$enums = $e79f519d1c032151$var$__importStar((parcelRequire("5dmHG")));
module.exports.enums = $e79f519d1c032151$var$enums;

var $e79f519d1c032151$var$format = $e79f519d1c032151$var$__importStar((parcelRequire("fbj1i")));
module.exports.format = $e79f519d1c032151$var$format;

var $e79f519d1c032151$var$rpc_errors = $e79f519d1c032151$var$__importStar((parcelRequire("2RlOX")));
module.exports.rpc_errors = $e79f519d1c032151$var$rpc_errors;

Object.defineProperty(module.exports, "PublicKey", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("8pTGX")).PublicKey;
    }
});
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("8pTGX")).KeyPair;
    }
});
Object.defineProperty(module.exports, "KeyPairEd25519", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("8pTGX")).KeyPairEd25519;
    }
});

var $6vXKs = parcelRequire("6vXKs");
Object.defineProperty(module.exports, "logWarning", {
    enumerable: true,
    get: function get() {
        return $6vXKs.logWarning;
    }
});

});
parcelRequire.register("fbj1i", function(module, exports) {
"use strict";
var $b0d6a30f0bb8fa95$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNearAmount = module.exports.formatNearAmount = module.exports.NEAR_NOMINATION = module.exports.NEAR_NOMINATION_EXP = void 0;

var $b0d6a30f0bb8fa95$var$bn_js_1 = $b0d6a30f0bb8fa95$var$__importDefault((parcelRequire("jkm5c")));
/**
 * Exponent for calculating how many indivisible units are there in one NEAR. See {@link NEAR_NOMINATION}.
 */ module.exports.NEAR_NOMINATION_EXP = 24;
/**
 * Number of indivisible units in one NEAR. Derived from {@link NEAR_NOMINATION_EXP}.
 */ module.exports.NEAR_NOMINATION = new $b0d6a30f0bb8fa95$var$bn_js_1.default("10", 10).pow(new $b0d6a30f0bb8fa95$var$bn_js_1.default(module.exports.NEAR_NOMINATION_EXP, 10));
// Pre-calculate offests used for rounding to different number of digits
var $b0d6a30f0bb8fa95$var$ROUNDING_OFFSETS = [];
var $b0d6a30f0bb8fa95$var$BN10 = new $b0d6a30f0bb8fa95$var$bn_js_1.default(10);
for(var $b0d6a30f0bb8fa95$var$i = 0, $b0d6a30f0bb8fa95$var$offset = new $b0d6a30f0bb8fa95$var$bn_js_1.default(5); $b0d6a30f0bb8fa95$var$i < module.exports.NEAR_NOMINATION_EXP; $b0d6a30f0bb8fa95$var$i++, $b0d6a30f0bb8fa95$var$offset = $b0d6a30f0bb8fa95$var$offset.mul($b0d6a30f0bb8fa95$var$BN10))$b0d6a30f0bb8fa95$var$ROUNDING_OFFSETS[$b0d6a30f0bb8fa95$var$i] = $b0d6a30f0bb8fa95$var$offset;
/**
 * Convert account balance value from internal indivisible units to NEAR. 1 NEAR is defined by {@link NEAR_NOMINATION}.
 * Effectively this divides given amount by {@link NEAR_NOMINATION}.
 *
 * @param balance decimal string representing balance in smallest non-divisible NEAR units (as specified by {@link NEAR_NOMINATION})
 * @param fracDigits number of fractional digits to preserve in formatted string. Balance is rounded to match given number of digits.
 * @returns Value in Ⓝ
 */ function $b0d6a30f0bb8fa95$var$formatNearAmount(balance) {
    var fracDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module.exports.NEAR_NOMINATION_EXP;
    var balanceBN = new $b0d6a30f0bb8fa95$var$bn_js_1.default(balance, 10);
    if (fracDigits !== module.exports.NEAR_NOMINATION_EXP) {
        // Adjust balance for rounding at given number of digits
        var roundingExp = module.exports.NEAR_NOMINATION_EXP - fracDigits - 1;
        if (roundingExp > 0) balanceBN.iadd($b0d6a30f0bb8fa95$var$ROUNDING_OFFSETS[roundingExp]);
    }
    balance = balanceBN.toString();
    var wholeStr = balance.substring(0, balance.length - module.exports.NEAR_NOMINATION_EXP) || "0";
    var fractionStr = balance.substring(balance.length - module.exports.NEAR_NOMINATION_EXP).padStart(module.exports.NEAR_NOMINATION_EXP, "0").substring(0, fracDigits);
    return $b0d6a30f0bb8fa95$var$trimTrailingZeroes("".concat($b0d6a30f0bb8fa95$var$formatWithCommas(wholeStr), ".").concat(fractionStr));
}
module.exports.formatNearAmount = $b0d6a30f0bb8fa95$var$formatNearAmount;
/**
 * Convert human readable NEAR amount to internal indivisible units.
 * Effectively this multiplies given amount by {@link NEAR_NOMINATION}.
 *
 * @param amt decimal string (potentially fractional) denominated in NEAR.
 * @returns The parsed yoctoⓃ amount or null if no amount was passed in
 */ function $b0d6a30f0bb8fa95$var$parseNearAmount(amt) {
    if (!amt) return null;
    amt = $b0d6a30f0bb8fa95$var$cleanupAmount(amt);
    var split = amt.split(".");
    var wholePart = split[0];
    var fracPart = split[1] || "";
    if (split.length > 2 || fracPart.length > module.exports.NEAR_NOMINATION_EXP) throw new Error("Cannot parse '".concat(amt, "' as NEAR amount"));
    return $b0d6a30f0bb8fa95$var$trimLeadingZeroes(wholePart + fracPart.padEnd(module.exports.NEAR_NOMINATION_EXP, "0"));
}
module.exports.parseNearAmount = $b0d6a30f0bb8fa95$var$parseNearAmount;
/**
 * Removes commas from the input
 * @param amount A value or amount that may contain commas
 * @returns string The cleaned value
 */ function $b0d6a30f0bb8fa95$var$cleanupAmount(amount) {
    return amount.replace(/,/g, "").trim();
}
/**
 * Removes .000… from an input
 * @param value A value that may contain trailing zeroes in the decimals place
 * @returns string The value without the trailing zeros
 */ function $b0d6a30f0bb8fa95$var$trimTrailingZeroes(value) {
    return value.replace(/\.?0*$/, "");
}
/**
 * Removes leading zeroes from an input
 * @param value A value that may contain leading zeroes
 * @returns string The value without the leading zeroes
 */ function $b0d6a30f0bb8fa95$var$trimLeadingZeroes(value) {
    value = value.replace(/^0+/, "");
    if (value === "") return "0";
    return value;
}
/**
 * Returns a human-readable value with commas
 * @param value A value that may not contain commas
 * @returns string A value with commas
 */ function $b0d6a30f0bb8fa95$var$formatWithCommas(value) {
    var pattern = /(-?\d+)(\d{3})/;
    while(pattern.test(value))value = value.replace(pattern, "$1,$2");
    return value;
}

});
parcelRequire.register("jkm5c", function(module, exports) {

(function(module1, exports) {
    "use strict";
    var assert = // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    };
    var inherits = // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    };
    var parseHex4Bits = function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    };
    var parseHexByte = function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    };
    var parseBase = function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    };
    var move = function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    };
    var inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var toBitArray = function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    };
    var smallMulTo = function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    };
    var bigMulTo = function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    };
    var jumboMulTo = function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    };
    var FFTM = // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    };
    var MPrime = // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    };
    var K256 = function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    };
    var P224 = function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    };
    var P192 = function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    };
    var P25519 = function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    };
    var Red = //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    };
    var Mont = function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    };
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    inherits(P224, MPrime);
    inherits(P192, MPrime);
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});



parcelRequire.register("7cM39", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $53eeed13bed24603$require$Buffer = $gzLuY.Buffer;
"use strict";
var $53eeed13bed24603$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signTransaction = module.exports.createTransaction = module.exports.SCHEMA = module.exports.Action = module.exports.SignedTransaction = module.exports.Transaction = module.exports.Signature = module.exports.deleteAccount = module.exports.deleteKey = module.exports.addKey = module.exports.stake = module.exports.transfer = module.exports.functionCall = module.exports.stringifyJsonOrBytes = module.exports.deployContract = module.exports.createAccount = module.exports.DeleteAccount = module.exports.DeleteKey = module.exports.AddKey = module.exports.Stake = module.exports.Transfer = module.exports.FunctionCall = module.exports.DeployContract = module.exports.CreateAccount = module.exports.IAction = module.exports.functionCallAccessKey = module.exports.fullAccessKey = module.exports.AccessKey = module.exports.AccessKeyPermission = module.exports.FullAccessPermission = module.exports.FunctionCallPermission = void 0;

var $53eeed13bed24603$var$js_sha256_1 = $53eeed13bed24603$var$__importDefault((parcelRequire("hRCvM")));

var $5dmHG = parcelRequire("5dmHG");

var $2HPkT = parcelRequire("2HPkT");

var $8pTGX = parcelRequire("8pTGX");
var $53eeed13bed24603$var$FunctionCallPermission = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(FunctionCallPermission, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(FunctionCallPermission);
    function FunctionCallPermission() {
        (0, $978gY._)(this, FunctionCallPermission);
        return _super.apply(this, arguments);
    }
    return FunctionCallPermission;
}($5dmHG.Assignable);
module.exports.FunctionCallPermission = $53eeed13bed24603$var$FunctionCallPermission;
var $53eeed13bed24603$var$FullAccessPermission = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(FullAccessPermission, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(FullAccessPermission);
    function FullAccessPermission() {
        (0, $978gY._)(this, FullAccessPermission);
        return _super.apply(this, arguments);
    }
    return FullAccessPermission;
}($5dmHG.Assignable);
module.exports.FullAccessPermission = $53eeed13bed24603$var$FullAccessPermission;
var $53eeed13bed24603$var$AccessKeyPermission = /*#__PURE__*/ function(_enums_1_Enum) {
    "use strict";
    (0, $ftJVG._)(AccessKeyPermission, _enums_1_Enum);
    var _super = (0, $6OZAO._)(AccessKeyPermission);
    function AccessKeyPermission() {
        (0, $978gY._)(this, AccessKeyPermission);
        return _super.apply(this, arguments);
    }
    return AccessKeyPermission;
}($5dmHG.Enum);
module.exports.AccessKeyPermission = $53eeed13bed24603$var$AccessKeyPermission;
var $53eeed13bed24603$var$AccessKey = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(AccessKey, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(AccessKey);
    function AccessKey() {
        (0, $978gY._)(this, AccessKey);
        return _super.apply(this, arguments);
    }
    return AccessKey;
}($5dmHG.Assignable);
module.exports.AccessKey = $53eeed13bed24603$var$AccessKey;
function $53eeed13bed24603$var$fullAccessKey() {
    return new $53eeed13bed24603$var$AccessKey({
        nonce: 0,
        permission: new $53eeed13bed24603$var$AccessKeyPermission({
            fullAccess: new $53eeed13bed24603$var$FullAccessPermission({})
        })
    });
}
module.exports.fullAccessKey = $53eeed13bed24603$var$fullAccessKey;
function $53eeed13bed24603$var$functionCallAccessKey(receiverId, methodNames, allowance) {
    return new $53eeed13bed24603$var$AccessKey({
        nonce: 0,
        permission: new $53eeed13bed24603$var$AccessKeyPermission({
            functionCall: new $53eeed13bed24603$var$FunctionCallPermission({
                receiverId: receiverId,
                allowance: allowance,
                methodNames: methodNames
            })
        })
    });
}
module.exports.functionCallAccessKey = $53eeed13bed24603$var$functionCallAccessKey;
var $53eeed13bed24603$var$IAction = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(IAction, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(IAction);
    function IAction() {
        (0, $978gY._)(this, IAction);
        return _super.apply(this, arguments);
    }
    return IAction;
}($5dmHG.Assignable);
module.exports.IAction = $53eeed13bed24603$var$IAction;
var $53eeed13bed24603$var$CreateAccount = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(CreateAccount, IAction);
    var _super = (0, $6OZAO._)(CreateAccount);
    function CreateAccount() {
        (0, $978gY._)(this, CreateAccount);
        return _super.apply(this, arguments);
    }
    return CreateAccount;
}($53eeed13bed24603$var$IAction);
module.exports.CreateAccount = $53eeed13bed24603$var$CreateAccount;
var $53eeed13bed24603$var$DeployContract = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(DeployContract, IAction);
    var _super = (0, $6OZAO._)(DeployContract);
    function DeployContract() {
        (0, $978gY._)(this, DeployContract);
        return _super.apply(this, arguments);
    }
    return DeployContract;
}($53eeed13bed24603$var$IAction);
module.exports.DeployContract = $53eeed13bed24603$var$DeployContract;
var $53eeed13bed24603$var$FunctionCall = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(FunctionCall, IAction);
    var _super = (0, $6OZAO._)(FunctionCall);
    function FunctionCall() {
        (0, $978gY._)(this, FunctionCall);
        return _super.apply(this, arguments);
    }
    return FunctionCall;
}($53eeed13bed24603$var$IAction);
module.exports.FunctionCall = $53eeed13bed24603$var$FunctionCall;
var $53eeed13bed24603$var$Transfer = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(Transfer, IAction);
    var _super = (0, $6OZAO._)(Transfer);
    function Transfer() {
        (0, $978gY._)(this, Transfer);
        return _super.apply(this, arguments);
    }
    return Transfer;
}($53eeed13bed24603$var$IAction);
module.exports.Transfer = $53eeed13bed24603$var$Transfer;
var $53eeed13bed24603$var$Stake = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(Stake, IAction);
    var _super = (0, $6OZAO._)(Stake);
    function Stake() {
        (0, $978gY._)(this, Stake);
        return _super.apply(this, arguments);
    }
    return Stake;
}($53eeed13bed24603$var$IAction);
module.exports.Stake = $53eeed13bed24603$var$Stake;
var $53eeed13bed24603$var$AddKey = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(AddKey, IAction);
    var _super = (0, $6OZAO._)(AddKey);
    function AddKey() {
        (0, $978gY._)(this, AddKey);
        return _super.apply(this, arguments);
    }
    return AddKey;
}($53eeed13bed24603$var$IAction);
module.exports.AddKey = $53eeed13bed24603$var$AddKey;
var $53eeed13bed24603$var$DeleteKey = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(DeleteKey, IAction);
    var _super = (0, $6OZAO._)(DeleteKey);
    function DeleteKey() {
        (0, $978gY._)(this, DeleteKey);
        return _super.apply(this, arguments);
    }
    return DeleteKey;
}($53eeed13bed24603$var$IAction);
module.exports.DeleteKey = $53eeed13bed24603$var$DeleteKey;
var $53eeed13bed24603$var$DeleteAccount = /*#__PURE__*/ function(IAction) {
    "use strict";
    (0, $ftJVG._)(DeleteAccount, IAction);
    var _super = (0, $6OZAO._)(DeleteAccount);
    function DeleteAccount() {
        (0, $978gY._)(this, DeleteAccount);
        return _super.apply(this, arguments);
    }
    return DeleteAccount;
}($53eeed13bed24603$var$IAction);
module.exports.DeleteAccount = $53eeed13bed24603$var$DeleteAccount;
function $53eeed13bed24603$var$createAccount() {
    return new $53eeed13bed24603$var$Action({
        createAccount: new $53eeed13bed24603$var$CreateAccount({})
    });
}
module.exports.createAccount = $53eeed13bed24603$var$createAccount;
function $53eeed13bed24603$var$deployContract(code) {
    return new $53eeed13bed24603$var$Action({
        deployContract: new $53eeed13bed24603$var$DeployContract({
            code: code
        })
    });
}
module.exports.deployContract = $53eeed13bed24603$var$deployContract;
function $53eeed13bed24603$var$stringifyJsonOrBytes(args) {
    var isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
    var serializedArgs = isUint8Array ? args : $53eeed13bed24603$require$Buffer.from(JSON.stringify(args));
    return serializedArgs;
}
module.exports.stringifyJsonOrBytes = $53eeed13bed24603$var$stringifyJsonOrBytes;
/**
 * Constructs {@link Action} instance representing contract method call.
 *
 * @param methodName the name of the method to call
 * @param args arguments to pass to method. Can be either plain JS object which gets serialized as JSON automatically
 *  or `Uint8Array` instance which represents bytes passed as is.
 * @param gas max amount of gas that method call can use
 * @param deposit amount of NEAR (in yoctoNEAR) to send together with the call
 * @param stringify Convert input arguments into bytes array.
 */ function $53eeed13bed24603$var$functionCall(methodName, args, gas, deposit) {
    var stringify = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $53eeed13bed24603$var$stringifyJsonOrBytes;
    return new $53eeed13bed24603$var$Action({
        functionCall: new $53eeed13bed24603$var$FunctionCall({
            methodName: methodName,
            args: stringify(args),
            gas: gas,
            deposit: deposit
        })
    });
}
module.exports.functionCall = $53eeed13bed24603$var$functionCall;
function $53eeed13bed24603$var$transfer(deposit) {
    return new $53eeed13bed24603$var$Action({
        transfer: new $53eeed13bed24603$var$Transfer({
            deposit: deposit
        })
    });
}
module.exports.transfer = $53eeed13bed24603$var$transfer;
function $53eeed13bed24603$var$stake(stake, publicKey) {
    return new $53eeed13bed24603$var$Action({
        stake: new $53eeed13bed24603$var$Stake({
            stake: stake,
            publicKey: publicKey
        })
    });
}
module.exports.stake = $53eeed13bed24603$var$stake;
function $53eeed13bed24603$var$addKey(publicKey, accessKey) {
    return new $53eeed13bed24603$var$Action({
        addKey: new $53eeed13bed24603$var$AddKey({
            publicKey: publicKey,
            accessKey: accessKey
        })
    });
}
module.exports.addKey = $53eeed13bed24603$var$addKey;
function $53eeed13bed24603$var$deleteKey(publicKey) {
    return new $53eeed13bed24603$var$Action({
        deleteKey: new $53eeed13bed24603$var$DeleteKey({
            publicKey: publicKey
        })
    });
}
module.exports.deleteKey = $53eeed13bed24603$var$deleteKey;
function $53eeed13bed24603$var$deleteAccount(beneficiaryId) {
    return new $53eeed13bed24603$var$Action({
        deleteAccount: new $53eeed13bed24603$var$DeleteAccount({
            beneficiaryId: beneficiaryId
        })
    });
}
module.exports.deleteAccount = $53eeed13bed24603$var$deleteAccount;
var $53eeed13bed24603$var$Signature = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(Signature, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(Signature);
    function Signature() {
        (0, $978gY._)(this, Signature);
        return _super.apply(this, arguments);
    }
    return Signature;
}($5dmHG.Assignable);
module.exports.Signature = $53eeed13bed24603$var$Signature;
var $53eeed13bed24603$var$Transaction = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(Transaction, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(Transaction);
    function Transaction() {
        (0, $978gY._)(this, Transaction);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(Transaction, [
        {
            key: "encode",
            value: function encode() {
                return $2HPkT.serialize(module.exports.SCHEMA, this);
            }
        }
    ], [
        {
            key: "decode",
            value: function decode(bytes) {
                return $2HPkT.deserialize(module.exports.SCHEMA, Transaction, bytes);
            }
        }
    ]);
    return Transaction;
}($5dmHG.Assignable);
module.exports.Transaction = $53eeed13bed24603$var$Transaction;
var $53eeed13bed24603$var$SignedTransaction = /*#__PURE__*/ function(_enums_1_Assignable) {
    "use strict";
    (0, $ftJVG._)(SignedTransaction, _enums_1_Assignable);
    var _super = (0, $6OZAO._)(SignedTransaction);
    function SignedTransaction() {
        (0, $978gY._)(this, SignedTransaction);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(SignedTransaction, [
        {
            key: "encode",
            value: function encode() {
                return $2HPkT.serialize(module.exports.SCHEMA, this);
            }
        }
    ], [
        {
            key: "decode",
            value: function decode(bytes) {
                return $2HPkT.deserialize(module.exports.SCHEMA, SignedTransaction, bytes);
            }
        }
    ]);
    return SignedTransaction;
}($5dmHG.Assignable);
module.exports.SignedTransaction = $53eeed13bed24603$var$SignedTransaction;
/**
 * Contains a list of the valid transaction Actions available with this API
 * @see {@link https://nomicon.io/RuntimeSpec/Actions.html | Actions Spec}
 */ var $53eeed13bed24603$var$Action = /*#__PURE__*/ function(_enums_1_Enum) {
    "use strict";
    (0, $ftJVG._)(Action, _enums_1_Enum);
    var _super = (0, $6OZAO._)(Action);
    function Action() {
        (0, $978gY._)(this, Action);
        return _super.apply(this, arguments);
    }
    return Action;
}($5dmHG.Enum);
module.exports.Action = $53eeed13bed24603$var$Action;
module.exports.SCHEMA = new Map([
    [
        $53eeed13bed24603$var$Signature,
        {
            kind: "struct",
            fields: [
                [
                    "keyType",
                    "u8"
                ],
                [
                    "data",
                    [
                        64
                    ]
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$SignedTransaction,
        {
            kind: "struct",
            fields: [
                [
                    "transaction",
                    $53eeed13bed24603$var$Transaction
                ],
                [
                    "signature",
                    $53eeed13bed24603$var$Signature
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$Transaction,
        {
            kind: "struct",
            fields: [
                [
                    "signerId",
                    "string"
                ],
                [
                    "publicKey",
                    $8pTGX.PublicKey
                ],
                [
                    "nonce",
                    "u64"
                ],
                [
                    "receiverId",
                    "string"
                ],
                [
                    "blockHash",
                    [
                        32
                    ]
                ],
                [
                    "actions",
                    [
                        $53eeed13bed24603$var$Action
                    ]
                ]
            ]
        }
    ],
    [
        $8pTGX.PublicKey,
        {
            kind: "struct",
            fields: [
                [
                    "keyType",
                    "u8"
                ],
                [
                    "data",
                    [
                        32
                    ]
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$AccessKey,
        {
            kind: "struct",
            fields: [
                [
                    "nonce",
                    "u64"
                ],
                [
                    "permission",
                    $53eeed13bed24603$var$AccessKeyPermission
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$AccessKeyPermission,
        {
            kind: "enum",
            field: "enum",
            values: [
                [
                    "functionCall",
                    $53eeed13bed24603$var$FunctionCallPermission
                ],
                [
                    "fullAccess",
                    $53eeed13bed24603$var$FullAccessPermission
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$FunctionCallPermission,
        {
            kind: "struct",
            fields: [
                [
                    "allowance",
                    {
                        kind: "option",
                        type: "u128"
                    }
                ],
                [
                    "receiverId",
                    "string"
                ],
                [
                    "methodNames",
                    [
                        "string"
                    ]
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$FullAccessPermission,
        {
            kind: "struct",
            fields: []
        }
    ],
    [
        $53eeed13bed24603$var$Action,
        {
            kind: "enum",
            field: "enum",
            values: [
                [
                    "createAccount",
                    $53eeed13bed24603$var$CreateAccount
                ],
                [
                    "deployContract",
                    $53eeed13bed24603$var$DeployContract
                ],
                [
                    "functionCall",
                    $53eeed13bed24603$var$FunctionCall
                ],
                [
                    "transfer",
                    $53eeed13bed24603$var$Transfer
                ],
                [
                    "stake",
                    $53eeed13bed24603$var$Stake
                ],
                [
                    "addKey",
                    $53eeed13bed24603$var$AddKey
                ],
                [
                    "deleteKey",
                    $53eeed13bed24603$var$DeleteKey
                ],
                [
                    "deleteAccount",
                    $53eeed13bed24603$var$DeleteAccount
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$CreateAccount,
        {
            kind: "struct",
            fields: []
        }
    ],
    [
        $53eeed13bed24603$var$DeployContract,
        {
            kind: "struct",
            fields: [
                [
                    "code",
                    [
                        "u8"
                    ]
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$FunctionCall,
        {
            kind: "struct",
            fields: [
                [
                    "methodName",
                    "string"
                ],
                [
                    "args",
                    [
                        "u8"
                    ]
                ],
                [
                    "gas",
                    "u64"
                ],
                [
                    "deposit",
                    "u128"
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$Transfer,
        {
            kind: "struct",
            fields: [
                [
                    "deposit",
                    "u128"
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$Stake,
        {
            kind: "struct",
            fields: [
                [
                    "stake",
                    "u128"
                ],
                [
                    "publicKey",
                    $8pTGX.PublicKey
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$AddKey,
        {
            kind: "struct",
            fields: [
                [
                    "publicKey",
                    $8pTGX.PublicKey
                ],
                [
                    "accessKey",
                    $53eeed13bed24603$var$AccessKey
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$DeleteKey,
        {
            kind: "struct",
            fields: [
                [
                    "publicKey",
                    $8pTGX.PublicKey
                ]
            ]
        }
    ],
    [
        $53eeed13bed24603$var$DeleteAccount,
        {
            kind: "struct",
            fields: [
                [
                    "beneficiaryId",
                    "string"
                ]
            ]
        }
    ]
]);
function $53eeed13bed24603$var$createTransaction(signerId, publicKey, receiverId, nonce, actions, blockHash) {
    return new $53eeed13bed24603$var$Transaction({
        signerId: signerId,
        publicKey: publicKey,
        nonce: nonce,
        receiverId: receiverId,
        actions: actions,
        blockHash: blockHash
    });
}
module.exports.createTransaction = $53eeed13bed24603$var$createTransaction;
function $53eeed13bed24603$var$signTransactionObject(transaction, signer, accountId, networkId) {
    return $53eeed13bed24603$var$_signTransactionObject.apply(this, arguments);
}
function $53eeed13bed24603$var$_signTransactionObject() {
    $53eeed13bed24603$var$_signTransactionObject = /**
 * Signs a given transaction from an account with given keys, applied to the given network
 * @param transaction The Transaction object to sign
 * @param signer The {Signer} object that assists with signing keys
 * @param accountId The human-readable NEAR account name
 * @param networkId The targeted network. (ex. default, betanet, etc…)
 */ (0, $byzP8._)(function(transaction, signer, accountId, networkId) {
        var message, hash, signature, signedTx;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    message = $2HPkT.serialize(module.exports.SCHEMA, transaction);
                    hash = new Uint8Array($53eeed13bed24603$var$js_sha256_1.default.sha256.array(message));
                    return [
                        4,
                        signer.signMessage(message, accountId, networkId)
                    ];
                case 1:
                    signature = _state.sent();
                    signedTx = new $53eeed13bed24603$var$SignedTransaction({
                        transaction: transaction,
                        signature: new $53eeed13bed24603$var$Signature({
                            keyType: transaction.publicKey.keyType,
                            data: signature.signature
                        })
                    });
                    return [
                        2,
                        [
                            hash,
                            signedTx
                        ]
                    ];
            }
        });
    });
    return $53eeed13bed24603$var$_signTransactionObject.apply(this, arguments);
}
function $53eeed13bed24603$var$signTransaction() {
    return $53eeed13bed24603$var$_signTransaction.apply(this, arguments);
}
function $53eeed13bed24603$var$_signTransaction() {
    $53eeed13bed24603$var$_signTransaction = (0, $byzP8._)(function() {
        var _len, args, _key, _args, transaction, signer, accountId, networkId, _args1, receiverId, nonce, actions, blockHash, signer1, accountId1, networkId1, publicKey, transaction1;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    if (!(args[0].constructor === $53eeed13bed24603$var$Transaction)) return [
                        3,
                        1
                    ];
                    _args = (0, $8GFUW._)(args, 4), transaction = _args[0], signer = _args[1], accountId = _args[2], networkId = _args[3];
                    return [
                        2,
                        $53eeed13bed24603$var$signTransactionObject(transaction, signer, accountId, networkId)
                    ];
                case 1:
                    _args1 = (0, $8GFUW._)(args, 7), receiverId = _args1[0], nonce = _args1[1], actions = _args1[2], blockHash = _args1[3], signer1 = _args1[4], accountId1 = _args1[5], networkId1 = _args1[6];
                    return [
                        4,
                        signer1.getPublicKey(accountId1, networkId1)
                    ];
                case 2:
                    publicKey = _state.sent();
                    transaction1 = $53eeed13bed24603$var$createTransaction(accountId1, publicKey, receiverId, nonce, actions, blockHash);
                    return [
                        2,
                        $53eeed13bed24603$var$signTransactionObject(transaction1, signer1, accountId1, networkId1)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $53eeed13bed24603$var$_signTransaction.apply(this, arguments);
}
module.exports.signTransaction = $53eeed13bed24603$var$signTransaction;

});
parcelRequire.register("hRCvM", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");

var $a8i8g = parcelRequire("a8i8g");
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var Sha256 = function Sha25611(is22411, sharedMemory11) {
        if (sharedMemory11) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is22411) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is22411;
    };
    var HmacSha256 = function HmacSha25611(key11, is22411, sharedMemory11) {
        var i11, type11 = typeof key11 === "undefined" ? "undefined" : (0, $1ObTH._)(key11);
        if (type11 === "string") {
            var bytes11 = [], length11 = key11.length, index11 = 0, code11;
            for(i11 = 0; i11 < length11; ++i11){
                code11 = key11.charCodeAt(i11);
                if (code11 < 0x80) bytes11[index11++] = code11;
                else if (code11 < 0x800) {
                    bytes11[index11++] = 0xc0 | code11 >> 6;
                    bytes11[index11++] = 0x80 | code11 & 0x3f;
                } else if (code11 < 0xd800 || code11 >= 0xe000) {
                    bytes11[index11++] = 0xe0 | code11 >> 12;
                    bytes11[index11++] = 0x80 | code11 >> 6 & 0x3f;
                    bytes11[index11++] = 0x80 | code11 & 0x3f;
                } else {
                    code11 = 0x10000 + ((code11 & 0x3ff) << 10 | key11.charCodeAt(++i11) & 0x3ff);
                    bytes11[index11++] = 0xf0 | code11 >> 18;
                    bytes11[index11++] = 0x80 | code11 >> 12 & 0x3f;
                    bytes11[index11++] = 0x80 | code11 >> 6 & 0x3f;
                    bytes11[index11++] = 0x80 | code11 & 0x3f;
                }
            }
            key11 = bytes11;
        } else {
            if (type11 === "object") {
                if (key11 === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key11.constructor === ArrayBuffer) key11 = new Uint8Array(key11);
                else if (!Array.isArray(key11)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key11)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key11.length > 64) key11 = new Sha256(is22411, true).update(key11).array();
        var oKeyPad11 = [], iKeyPad11 = [];
        for(i11 = 0; i11 < 64; ++i11){
            var b11 = key11[i11] || 0;
            oKeyPad11[i11] = 0x5c ^ b11;
            iKeyPad11[i11] = 0x36 ^ b11;
        }
        Sha256.call(this, is22411, sharedMemory11);
        this.update(iKeyPad11);
        this.oKeyPad = oKeyPad11;
        this.inner = true;
        this.sharedMemory = sharedMemory11;
    };
    var ERROR = "input is invalid type";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $a8i8g === "object" && $a8i8g.versions && $a8i8g.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj11) {
        return Object.prototype.toString.call(obj11) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj11) {
        return typeof obj11 === "object" && obj11.buffer && obj11.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function createOutputMethod11(outputType11, is22411) {
        return function(message11) {
            return new Sha256(is22411, true).update(message11)[outputType11]();
        };
    };
    var createMethod = function createMethod11(is22411) {
        var method11 = createOutputMethod("hex", is22411);
        if (NODE_JS) method11 = nodeWrap(method11, is22411);
        method11.create = function() {
            return new Sha256(is22411);
        };
        method11.update = function(message11) {
            return method11.create().update(message11);
        };
        for(var i11 = 0; i11 < OUTPUT_TYPES.length; ++i11){
            var type11 = OUTPUT_TYPES[i11];
            method11[type11] = createOutputMethod(type11, is22411);
        }
        return method11;
    };
    var nodeWrap = function nodeWrap(method, is224) {
        var crypto = eval("require('crypto')");
        var Buffer = eval("require('buffer').Buffer");
        var algorithm = is224 ? "sha224" : "sha256";
        var nodeMethod = function nodeMethod11(message11) {
            if (typeof message11 === "string") return crypto.createHash(algorithm).update(message11, "utf8").digest("hex");
            else {
                if (message11 === null || message11 === undefined) throw new Error(ERROR);
                else if (message11.constructor === ArrayBuffer) message11 = new Uint8Array(message11);
            }
            if (Array.isArray(message11) || ArrayBuffer.isView(message11) || message11.constructor === Buffer) return crypto.createHash(algorithm).update(new Buffer(message11)).digest("hex");
            else return method(message11);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function createHmacOutputMethod11(outputType11, is22411) {
        return function(key11, message11) {
            return new HmacSha256(key11, is22411, true).update(message11)[outputType11]();
        };
    };
    var createHmacMethod = function createHmacMethod11(is22411) {
        var method11 = createHmacOutputMethod("hex", is22411);
        method11.create = function(key11) {
            return new HmacSha256(key11, is22411);
        };
        method11.update = function(key11, message11) {
            return method11.create(key11).update(message11);
        };
        for(var i11 = 0; i11 < OUTPUT_TYPES.length; ++i11){
            var type11 = OUTPUT_TYPES[i11];
            method11[type11] = createHmacOutputMethod(type11, is22411);
        }
        return method11;
    };
    Sha256.prototype.update = function(message11) {
        if (this.finalized) return;
        var notString11, type11 = typeof message11 === "undefined" ? "undefined" : (0, $1ObTH._)(message11);
        if (type11 !== "string") {
            if (type11 === "object") {
                if (message11 === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message11.constructor === ArrayBuffer) message11 = new Uint8Array(message11);
                else if (!Array.isArray(message11)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message11)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString11 = true;
        }
        var code11, index11 = 0, i11, length11 = message11.length, blocks11 = this.blocks;
        while(index11 < length11){
            if (this.hashed) {
                this.hashed = false;
                blocks11[0] = this.block;
                blocks11[16] = blocks11[1] = blocks11[2] = blocks11[3] = blocks11[4] = blocks11[5] = blocks11[6] = blocks11[7] = blocks11[8] = blocks11[9] = blocks11[10] = blocks11[11] = blocks11[12] = blocks11[13] = blocks11[14] = blocks11[15] = 0;
            }
            if (notString11) for(i11 = this.start; index11 < length11 && i11 < 64; ++index11)blocks11[i11 >> 2] |= message11[index11] << SHIFT[i11++ & 3];
            else for(i11 = this.start; index11 < length11 && i11 < 64; ++index11){
                code11 = message11.charCodeAt(index11);
                if (code11 < 0x80) blocks11[i11 >> 2] |= code11 << SHIFT[i11++ & 3];
                else if (code11 < 0x800) {
                    blocks11[i11 >> 2] |= (0xc0 | code11 >> 6) << SHIFT[i11++ & 3];
                    blocks11[i11 >> 2] |= (0x80 | code11 & 0x3f) << SHIFT[i11++ & 3];
                } else if (code11 < 0xd800 || code11 >= 0xe000) {
                    blocks11[i11 >> 2] |= (0xe0 | code11 >> 12) << SHIFT[i11++ & 3];
                    blocks11[i11 >> 2] |= (0x80 | code11 >> 6 & 0x3f) << SHIFT[i11++ & 3];
                    blocks11[i11 >> 2] |= (0x80 | code11 & 0x3f) << SHIFT[i11++ & 3];
                } else {
                    code11 = 0x10000 + ((code11 & 0x3ff) << 10 | message11.charCodeAt(++index11) & 0x3ff);
                    blocks11[i11 >> 2] |= (0xf0 | code11 >> 18) << SHIFT[i11++ & 3];
                    blocks11[i11 >> 2] |= (0x80 | code11 >> 12 & 0x3f) << SHIFT[i11++ & 3];
                    blocks11[i11 >> 2] |= (0x80 | code11 >> 6 & 0x3f) << SHIFT[i11++ & 3];
                    blocks11[i11 >> 2] |= (0x80 | code11 & 0x3f) << SHIFT[i11++ & 3];
                }
            }
            this.lastByteIndex = i11;
            this.bytes += i11 - this.start;
            if (i11 >= 64) {
                this.block = blocks11[16];
                this.start = i11 - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i11;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks11 = this.blocks, i11 = this.lastByteIndex;
        blocks11[16] = this.block;
        blocks11[i11 >> 2] |= EXTRA[i11 & 3];
        this.block = blocks11[16];
        if (i11 >= 56) {
            if (!this.hashed) this.hash();
            blocks11[0] = this.block;
            blocks11[16] = blocks11[1] = blocks11[2] = blocks11[3] = blocks11[4] = blocks11[5] = blocks11[6] = blocks11[7] = blocks11[8] = blocks11[9] = blocks11[10] = blocks11[11] = blocks11[12] = blocks11[13] = blocks11[14] = blocks11[15] = 0;
        }
        blocks11[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks11[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a11 = this.h0, b11 = this.h1, c11 = this.h2, d11 = this.h3, e11 = this.h4, f11 = this.h5, g11 = this.h6, h81 = this.h7, blocks11 = this.blocks, j11, s011, s111, maj11, t111, t211, ch11, ab11, da11, cd11, bc11;
        for(j11 = 16; j11 < 64; ++j11){
            // rightrotate
            t111 = blocks11[j11 - 15];
            s011 = (t111 >>> 7 | t111 << 25) ^ (t111 >>> 18 | t111 << 14) ^ t111 >>> 3;
            t111 = blocks11[j11 - 2];
            s111 = (t111 >>> 17 | t111 << 15) ^ (t111 >>> 19 | t111 << 13) ^ t111 >>> 10;
            blocks11[j11] = blocks11[j11 - 16] + s011 + blocks11[j11 - 7] + s111 << 0;
        }
        bc11 = b11 & c11;
        for(j11 = 0; j11 < 64; j11 += 4){
            if (this.first) {
                if (this.is224) {
                    ab11 = 300032;
                    t111 = blocks11[0] - 1413257819;
                    h81 = t111 - 150054599 << 0;
                    d11 = t111 + 24177077 << 0;
                } else {
                    ab11 = 704751109;
                    t111 = blocks11[0] - 210244248;
                    h81 = t111 - 1521486534 << 0;
                    d11 = t111 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s011 = (a11 >>> 2 | a11 << 30) ^ (a11 >>> 13 | a11 << 19) ^ (a11 >>> 22 | a11 << 10);
                s111 = (e11 >>> 6 | e11 << 26) ^ (e11 >>> 11 | e11 << 21) ^ (e11 >>> 25 | e11 << 7);
                ab11 = a11 & b11;
                maj11 = ab11 ^ a11 & c11 ^ bc11;
                ch11 = e11 & f11 ^ ~e11 & g11;
                t111 = h81 + s111 + ch11 + K[j11] + blocks11[j11];
                t211 = s011 + maj11;
                h81 = d11 + t111 << 0;
                d11 = t111 + t211 << 0;
            }
            s011 = (d11 >>> 2 | d11 << 30) ^ (d11 >>> 13 | d11 << 19) ^ (d11 >>> 22 | d11 << 10);
            s111 = (h81 >>> 6 | h81 << 26) ^ (h81 >>> 11 | h81 << 21) ^ (h81 >>> 25 | h81 << 7);
            da11 = d11 & a11;
            maj11 = da11 ^ d11 & b11 ^ ab11;
            ch11 = h81 & e11 ^ ~h81 & f11;
            t111 = g11 + s111 + ch11 + K[j11 + 1] + blocks11[j11 + 1];
            t211 = s011 + maj11;
            g11 = c11 + t111 << 0;
            c11 = t111 + t211 << 0;
            s011 = (c11 >>> 2 | c11 << 30) ^ (c11 >>> 13 | c11 << 19) ^ (c11 >>> 22 | c11 << 10);
            s111 = (g11 >>> 6 | g11 << 26) ^ (g11 >>> 11 | g11 << 21) ^ (g11 >>> 25 | g11 << 7);
            cd11 = c11 & d11;
            maj11 = cd11 ^ c11 & a11 ^ da11;
            ch11 = g11 & h81 ^ ~g11 & e11;
            t111 = f11 + s111 + ch11 + K[j11 + 2] + blocks11[j11 + 2];
            t211 = s011 + maj11;
            f11 = b11 + t111 << 0;
            b11 = t111 + t211 << 0;
            s011 = (b11 >>> 2 | b11 << 30) ^ (b11 >>> 13 | b11 << 19) ^ (b11 >>> 22 | b11 << 10);
            s111 = (f11 >>> 6 | f11 << 26) ^ (f11 >>> 11 | f11 << 21) ^ (f11 >>> 25 | f11 << 7);
            bc11 = b11 & c11;
            maj11 = bc11 ^ b11 & d11 ^ cd11;
            ch11 = f11 & g11 ^ ~f11 & h81;
            t111 = e11 + s111 + ch11 + K[j11 + 3] + blocks11[j11 + 3];
            t211 = s011 + maj11;
            e11 = a11 + t111 << 0;
            a11 = t111 + t211 << 0;
        }
        this.h0 = this.h0 + a11 << 0;
        this.h1 = this.h1 + b11 << 0;
        this.h2 = this.h2 + c11 << 0;
        this.h3 = this.h3 + d11 << 0;
        this.h4 = this.h4 + e11 << 0;
        this.h5 = this.h5 + f11 << 0;
        this.h6 = this.h6 + g11 << 0;
        this.h7 = this.h7 + h81 << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h011 = this.h0, h111 = this.h1, h211 = this.h2, h311 = this.h3, h411 = this.h4, h511 = this.h5, h611 = this.h6, h711 = this.h7;
        var hex11 = HEX_CHARS[h011 >> 28 & 0x0F] + HEX_CHARS[h011 >> 24 & 0x0F] + HEX_CHARS[h011 >> 20 & 0x0F] + HEX_CHARS[h011 >> 16 & 0x0F] + HEX_CHARS[h011 >> 12 & 0x0F] + HEX_CHARS[h011 >> 8 & 0x0F] + HEX_CHARS[h011 >> 4 & 0x0F] + HEX_CHARS[h011 & 0x0F] + HEX_CHARS[h111 >> 28 & 0x0F] + HEX_CHARS[h111 >> 24 & 0x0F] + HEX_CHARS[h111 >> 20 & 0x0F] + HEX_CHARS[h111 >> 16 & 0x0F] + HEX_CHARS[h111 >> 12 & 0x0F] + HEX_CHARS[h111 >> 8 & 0x0F] + HEX_CHARS[h111 >> 4 & 0x0F] + HEX_CHARS[h111 & 0x0F] + HEX_CHARS[h211 >> 28 & 0x0F] + HEX_CHARS[h211 >> 24 & 0x0F] + HEX_CHARS[h211 >> 20 & 0x0F] + HEX_CHARS[h211 >> 16 & 0x0F] + HEX_CHARS[h211 >> 12 & 0x0F] + HEX_CHARS[h211 >> 8 & 0x0F] + HEX_CHARS[h211 >> 4 & 0x0F] + HEX_CHARS[h211 & 0x0F] + HEX_CHARS[h311 >> 28 & 0x0F] + HEX_CHARS[h311 >> 24 & 0x0F] + HEX_CHARS[h311 >> 20 & 0x0F] + HEX_CHARS[h311 >> 16 & 0x0F] + HEX_CHARS[h311 >> 12 & 0x0F] + HEX_CHARS[h311 >> 8 & 0x0F] + HEX_CHARS[h311 >> 4 & 0x0F] + HEX_CHARS[h311 & 0x0F] + HEX_CHARS[h411 >> 28 & 0x0F] + HEX_CHARS[h411 >> 24 & 0x0F] + HEX_CHARS[h411 >> 20 & 0x0F] + HEX_CHARS[h411 >> 16 & 0x0F] + HEX_CHARS[h411 >> 12 & 0x0F] + HEX_CHARS[h411 >> 8 & 0x0F] + HEX_CHARS[h411 >> 4 & 0x0F] + HEX_CHARS[h411 & 0x0F] + HEX_CHARS[h511 >> 28 & 0x0F] + HEX_CHARS[h511 >> 24 & 0x0F] + HEX_CHARS[h511 >> 20 & 0x0F] + HEX_CHARS[h511 >> 16 & 0x0F] + HEX_CHARS[h511 >> 12 & 0x0F] + HEX_CHARS[h511 >> 8 & 0x0F] + HEX_CHARS[h511 >> 4 & 0x0F] + HEX_CHARS[h511 & 0x0F] + HEX_CHARS[h611 >> 28 & 0x0F] + HEX_CHARS[h611 >> 24 & 0x0F] + HEX_CHARS[h611 >> 20 & 0x0F] + HEX_CHARS[h611 >> 16 & 0x0F] + HEX_CHARS[h611 >> 12 & 0x0F] + HEX_CHARS[h611 >> 8 & 0x0F] + HEX_CHARS[h611 >> 4 & 0x0F] + HEX_CHARS[h611 & 0x0F];
        if (!this.is224) hex11 += HEX_CHARS[h711 >> 28 & 0x0F] + HEX_CHARS[h711 >> 24 & 0x0F] + HEX_CHARS[h711 >> 20 & 0x0F] + HEX_CHARS[h711 >> 16 & 0x0F] + HEX_CHARS[h711 >> 12 & 0x0F] + HEX_CHARS[h711 >> 8 & 0x0F] + HEX_CHARS[h711 >> 4 & 0x0F] + HEX_CHARS[h711 & 0x0F];
        return hex11;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h011 = this.h0, h111 = this.h1, h211 = this.h2, h311 = this.h3, h411 = this.h4, h511 = this.h5, h611 = this.h6, h711 = this.h7;
        var arr11 = [
            h011 >> 24 & 0xFF,
            h011 >> 16 & 0xFF,
            h011 >> 8 & 0xFF,
            h011 & 0xFF,
            h111 >> 24 & 0xFF,
            h111 >> 16 & 0xFF,
            h111 >> 8 & 0xFF,
            h111 & 0xFF,
            h211 >> 24 & 0xFF,
            h211 >> 16 & 0xFF,
            h211 >> 8 & 0xFF,
            h211 & 0xFF,
            h311 >> 24 & 0xFF,
            h311 >> 16 & 0xFF,
            h311 >> 8 & 0xFF,
            h311 & 0xFF,
            h411 >> 24 & 0xFF,
            h411 >> 16 & 0xFF,
            h411 >> 8 & 0xFF,
            h411 & 0xFF,
            h511 >> 24 & 0xFF,
            h511 >> 16 & 0xFF,
            h511 >> 8 & 0xFF,
            h511 & 0xFF,
            h611 >> 24 & 0xFF,
            h611 >> 16 & 0xFF,
            h611 >> 8 & 0xFF,
            h611 & 0xFF
        ];
        if (!this.is224) arr11.push(h711 >> 24 & 0xFF, h711 >> 16 & 0xFF, h711 >> 8 & 0xFF, h711 & 0xFF);
        return arr11;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer11 = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView11 = new DataView(buffer11);
        dataView11.setUint32(0, this.h0);
        dataView11.setUint32(4, this.h1);
        dataView11.setUint32(8, this.h2);
        dataView11.setUint32(12, this.h3);
        dataView11.setUint32(16, this.h4);
        dataView11.setUint32(20, this.h5);
        dataView11.setUint32(24, this.h6);
        if (!this.is224) dataView11.setUint32(28, this.h7);
        return buffer11;
    };
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash11 = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash11);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});
parcelRequire.register("a8i8g", function(module, exports) {
// shim for using process in browser
var $7608b7726638efe3$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7608b7726638efe3$var$cachedSetTimeout;
var $7608b7726638efe3$var$cachedClearTimeout;
function $7608b7726638efe3$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $7608b7726638efe3$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        else $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    } catch (e) {
        $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        else $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    } catch (e) {
        $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    }
})();
function $7608b7726638efe3$var$runTimeout(fun) {
    if ($7608b7726638efe3$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedSetTimeout === $7608b7726638efe3$var$defaultSetTimout || !$7608b7726638efe3$var$cachedSetTimeout) && setTimeout) {
        $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7608b7726638efe3$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7608b7726638efe3$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7608b7726638efe3$var$runClearTimeout(marker) {
    if ($7608b7726638efe3$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedClearTimeout === $7608b7726638efe3$var$defaultClearTimeout || !$7608b7726638efe3$var$cachedClearTimeout) && clearTimeout) {
        $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7608b7726638efe3$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7608b7726638efe3$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7608b7726638efe3$var$queue = [];
var $7608b7726638efe3$var$draining = false;
var $7608b7726638efe3$var$currentQueue;
var $7608b7726638efe3$var$queueIndex = -1;
function $7608b7726638efe3$var$cleanUpNextTick() {
    if (!$7608b7726638efe3$var$draining || !$7608b7726638efe3$var$currentQueue) return;
    $7608b7726638efe3$var$draining = false;
    if ($7608b7726638efe3$var$currentQueue.length) $7608b7726638efe3$var$queue = $7608b7726638efe3$var$currentQueue.concat($7608b7726638efe3$var$queue);
    else $7608b7726638efe3$var$queueIndex = -1;
    if ($7608b7726638efe3$var$queue.length) $7608b7726638efe3$var$drainQueue();
}
function $7608b7726638efe3$var$drainQueue() {
    if ($7608b7726638efe3$var$draining) return;
    var timeout = $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$cleanUpNextTick);
    $7608b7726638efe3$var$draining = true;
    var len = $7608b7726638efe3$var$queue.length;
    while(len){
        $7608b7726638efe3$var$currentQueue = $7608b7726638efe3$var$queue;
        $7608b7726638efe3$var$queue = [];
        while(++$7608b7726638efe3$var$queueIndex < len)if ($7608b7726638efe3$var$currentQueue) $7608b7726638efe3$var$currentQueue[$7608b7726638efe3$var$queueIndex].run();
        $7608b7726638efe3$var$queueIndex = -1;
        len = $7608b7726638efe3$var$queue.length;
    }
    $7608b7726638efe3$var$currentQueue = null;
    $7608b7726638efe3$var$draining = false;
    $7608b7726638efe3$var$runClearTimeout(timeout);
}
$7608b7726638efe3$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7608b7726638efe3$var$queue.push(new $7608b7726638efe3$var$Item(fun, args));
    if ($7608b7726638efe3$var$queue.length === 1 && !$7608b7726638efe3$var$draining) $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$drainQueue);
};
// v8 likes predictible objects
function $7608b7726638efe3$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7608b7726638efe3$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7608b7726638efe3$var$process.title = "browser";
$7608b7726638efe3$var$process.browser = true;
$7608b7726638efe3$var$process.env = {};
$7608b7726638efe3$var$process.argv = [];
$7608b7726638efe3$var$process.version = ""; // empty string to avoid regexp issues
$7608b7726638efe3$var$process.versions = {};
function $7608b7726638efe3$var$noop() {}
$7608b7726638efe3$var$process.on = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.addListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.once = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.off = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeAllListeners = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.emit = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependOnceListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.listeners = function(name) {
    return [];
};
$7608b7726638efe3$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$7608b7726638efe3$var$process.cwd = function() {
    return "/";
};
$7608b7726638efe3$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$7608b7726638efe3$var$process.umask = function() {
    return 0;
};

});



parcelRequire.register("kfiwQ", function(module, exports) {
"use strict";
var $ebd394cdea3c3b73$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.diffEpochValidators = module.exports.findSeatPrice = void 0;

var $ebd394cdea3c3b73$var$bn_js_1 = $ebd394cdea3c3b73$var$__importDefault((parcelRequire("jkm5c")));

var $ebd394cdea3c3b73$var$depd_1 = $ebd394cdea3c3b73$var$__importDefault((parcelRequire("7kbiF")));
/** Finds seat price given validators stakes and number of seats.
 *  Calculation follow the spec: https://nomicon.io/Economics/README.html#validator-selection
 * @params validators: current or next epoch validators.
 * @params maxNumberOfSeats: maximum number of seats in the network.
 * @params minimumStakeRatio: minimum stake ratio
 * @params protocolVersion: version of the protocol from genesis config
 */ function $ebd394cdea3c3b73$var$findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio, protocolVersion) {
    if (protocolVersion && protocolVersion < 49) return $ebd394cdea3c3b73$var$findSeatPriceForProtocolBefore49(validators, maxNumberOfSeats);
    if (!minimumStakeRatio) {
        var deprecate = $ebd394cdea3c3b73$var$depd_1.default("findSeatPrice(validators, maxNumberOfSeats)");
        deprecate("`use `findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio)` instead");
        minimumStakeRatio = [
            1,
            6250
        ]; // harcoded minimumStakeRation from 12/7/21
    }
    return $ebd394cdea3c3b73$var$findSeatPriceForProtocolAfter49(validators, maxNumberOfSeats, minimumStakeRatio);
}
module.exports.findSeatPrice = $ebd394cdea3c3b73$var$findSeatPrice;
function $ebd394cdea3c3b73$var$findSeatPriceForProtocolBefore49(validators, numSeats) {
    var stakes = validators.map(function(v) {
        return new $ebd394cdea3c3b73$var$bn_js_1.default(v.stake, 10);
    }).sort(function(a, b) {
        return a.cmp(b);
    });
    var num = new $ebd394cdea3c3b73$var$bn_js_1.default(numSeats);
    var stakesSum = stakes.reduce(function(a, b) {
        return a.add(b);
    });
    if (stakesSum.lt(num)) throw new Error("Stakes are below seats");
    // assert stakesSum >= numSeats
    var left = new $ebd394cdea3c3b73$var$bn_js_1.default(1), right = stakesSum.add(new $ebd394cdea3c3b73$var$bn_js_1.default(1));
    while(!left.eq(right.sub(new $ebd394cdea3c3b73$var$bn_js_1.default(1)))){
        var mid = left.add(right).div(new $ebd394cdea3c3b73$var$bn_js_1.default(2));
        var found = false;
        var currentSum = new $ebd394cdea3c3b73$var$bn_js_1.default(0);
        for(var i = 0; i < stakes.length; ++i){
            currentSum = currentSum.add(stakes[i].div(mid));
            if (currentSum.gte(num)) {
                left = mid;
                found = true;
                break;
            }
        }
        if (!found) right = mid;
    }
    return left;
}
// nearcore reference: https://github.com/near/nearcore/blob/5a8ae263ec07930cd34d0dcf5bcee250c67c02aa/chain/epoch_manager/src/validator_selection.rs#L308;L315
function $ebd394cdea3c3b73$var$findSeatPriceForProtocolAfter49(validators, maxNumberOfSeats, minimumStakeRatio) {
    if (minimumStakeRatio.length != 2) throw Error("minimumStakeRatio should have 2 elements");
    var stakes = validators.map(function(v) {
        return new $ebd394cdea3c3b73$var$bn_js_1.default(v.stake, 10);
    }).sort(function(a, b) {
        return a.cmp(b);
    });
    var stakesSum = stakes.reduce(function(a, b) {
        return a.add(b);
    });
    if (validators.length < maxNumberOfSeats) return stakesSum.mul(new $ebd394cdea3c3b73$var$bn_js_1.default(minimumStakeRatio[0])).div(new $ebd394cdea3c3b73$var$bn_js_1.default(minimumStakeRatio[1]));
    else return stakes[0].add(new $ebd394cdea3c3b73$var$bn_js_1.default(1));
}
/** Diff validators between current and next epoch.
 * Returns additions, subtractions and changes to validator set.
 * @params currentValidators: list of current validators.
 * @params nextValidators: list of next validators.
 */ function $ebd394cdea3c3b73$var$diffEpochValidators(currentValidators, nextValidators) {
    var validatorsMap = new Map();
    currentValidators.forEach(function(v) {
        return validatorsMap.set(v.account_id, v);
    });
    var nextValidatorsSet = new Set(nextValidators.map(function(v) {
        return v.account_id;
    }));
    return {
        newValidators: nextValidators.filter(function(v) {
            return !validatorsMap.has(v.account_id);
        }),
        removedValidators: currentValidators.filter(function(v) {
            return !nextValidatorsSet.has(v.account_id);
        }),
        changedValidators: nextValidators.filter(function(v) {
            return validatorsMap.has(v.account_id) && validatorsMap.get(v.account_id).stake != v.stake;
        }).map(function(v) {
            return {
                current: validatorsMap.get(v.account_id),
                next: v
            };
        })
    };
}
module.exports.diffEpochValidators = $ebd394cdea3c3b73$var$diffEpochValidators;

});

parcelRequire.register("gXWlL", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $c59f6b1c2cef28b8$require$Buffer = $gzLuY.Buffer;
"use strict";
var $c59f6b1c2cef28b8$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

var $c59f6b1c2cef28b8$var$bn_js_1 = $c59f6b1c2cef28b8$var$__importDefault((parcelRequire("jkm5c")));

var $c59f6b1c2cef28b8$var$depd_1 = $c59f6b1c2cef28b8$var$__importDefault((parcelRequire("7kbiF")));

var $7cM39 = parcelRequire("7cM39");

var $bMcUu = parcelRequire("bMcUu");

var $2HPkT = parcelRequire("2HPkT");

var $8pTGX = parcelRequire("8pTGX");

var $6vXKs = parcelRequire("6vXKs");

var $2RlOX = parcelRequire("2RlOX");

var $NN8ep = parcelRequire("NN8ep");

var $c59f6b1c2cef28b8$var$exponential_backoff_1 = $c59f6b1c2cef28b8$var$__importDefault((parcelRequire("dkG2P")));
// Default number of retries with different nonce before giving up on a transaction.
var $c59f6b1c2cef28b8$var$TX_NONCE_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
var $c59f6b1c2cef28b8$var$TX_NONCE_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
var $c59f6b1c2cef28b8$var$TX_NONCE_RETRY_WAIT_BACKOFF = 1.5;
function $c59f6b1c2cef28b8$var$parseJsonFromRawResponse(response) {
    return JSON.parse($c59f6b1c2cef28b8$require$Buffer.from(response).toString());
}
function $c59f6b1c2cef28b8$var$bytesJsonStringify(input) {
    return $c59f6b1c2cef28b8$require$Buffer.from(JSON.stringify(input));
}
/**
 * This class provides common account related RPC calls including signing transactions with a {@link KeyPair}.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#account}
 * @hint Use {@link WalletConnection} in the browser to redirect to {@link https://docs.near.org/docs/tools/near-wallet | NEAR Wallet} for Account/key management using the {@link BrowserLocalStorageKeyStore}.
 * @see {@link https://nomicon.io/DataStructures/Account.html | Account Spec}
 */ var $c59f6b1c2cef28b8$var$Account = /*#__PURE__*/ function() {
    "use strict";
    function Account(connection, accountId) {
        (0, $978gY._)(this, Account);
        /** @hidden */ this.accessKeyByPublicKeyCache = {};
        this.connection = connection;
        this.accountId = accountId;
    }
    (0, $kry2a._)(Account, [
        {
            key: "ready",
            get: /** @hidden */ function get() {
                var deprecate = $c59f6b1c2cef28b8$var$depd_1.default("Account.ready()");
                deprecate("not needed anymore, always ready");
                return Promise.resolve();
            }
        },
        {
            key: "fetchState",
            value: function fetchState() {
                return (0, $byzP8._)(function() {
                    var deprecate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        deprecate = $c59f6b1c2cef28b8$var$depd_1.default("Account.fetchState()");
                        deprecate("use `Account.state()` instead");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "state",
            value: /**
     * Returns basic NEAR account information via the `view_account` RPC query method
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#view-account}
     */ function state() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.connection.provider.query({
                                request_type: "view_account",
                                account_id: _this.accountId,
                                finality: "optimistic"
                            })
                        ];
                    });
                })();
            }
        },
        {
            /** @hidden */ key: "printLogsAndFailures",
            value: function printLogsAndFailures(contractId, results) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var result = _step.value;
                        console.log("Receipt".concat(result.receiptIds.length > 1 ? "s" : "", ": ").concat(result.receiptIds.join(", ")));
                        this.printLogs(contractId, result.logs, "	");
                        if (result.failure) console.warn("	Failure [".concat(contractId, "]: ").concat(result.failure));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /** @hidden */ key: "printLogs",
            value: function printLogs(contractId, logs) {
                var prefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = logs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var log = _step.value;
                        console.log("".concat(prefix, "Log [").concat(contractId, "]: ").concat(log));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "signTransaction",
            value: /**
     * Create a signed transaction which can be broadcast to the network
     * @param receiverId NEAR account receiving the transaction
     * @param actions list of actions to perform as part of the transaction
     * @see {@link JsonRpcProvider.sendTransaction}
     */ function signTransaction(receiverId, actions) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accessKeyInfo, accessKey, block, blockHash, nonce;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.findAccessKey(receiverId, actions)
                                ];
                            case 1:
                                accessKeyInfo = _state.sent();
                                if (!accessKeyInfo) throw new $bMcUu.TypedError("Can not sign transactions for account ".concat(_this.accountId, " on network ").concat(_this.connection.networkId, ", no matching key pair found in ").concat(_this.connection.signer, "."), "KeyNotFound");
                                accessKey = accessKeyInfo.accessKey;
                                return [
                                    4,
                                    _this.connection.provider.block({
                                        finality: "final"
                                    })
                                ];
                            case 2:
                                block = _state.sent();
                                blockHash = block.header.hash;
                                nonce = ++accessKey.nonce;
                                return [
                                    4,
                                    $7cM39.signTransaction(receiverId, nonce, actions, $2HPkT.baseDecode(blockHash), _this.connection.signer, _this.accountId, _this.connection.networkId)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAndSendTransaction",
            value: function signAndSendTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (typeof args[0] === "string") return this.signAndSendTransactionV1(args[0], args[1]);
                else return this.signAndSendTransactionV2(args[0]);
            }
        },
        {
            key: "signAndSendTransactionV1",
            value: function signAndSendTransactionV1(receiverId, actions) {
                var deprecate = $c59f6b1c2cef28b8$var$depd_1.default("Account.signAndSendTransaction(receiverId, actions");
                deprecate("use `Account.signAndSendTransaction(SignAndSendTransactionOptions)` instead");
                return this.signAndSendTransactionV2({
                    receiverId: receiverId,
                    actions: actions
                });
            }
        },
        {
            key: "signAndSendTransactionV2",
            value: function signAndSendTransactionV2(param) {
                var receiverId = param.receiverId, actions = param.actions, returnError = param.returnError;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var txHash, signedTx, result, flatLogs;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $c59f6b1c2cef28b8$var$exponential_backoff_1.default($c59f6b1c2cef28b8$var$TX_NONCE_RETRY_WAIT, $c59f6b1c2cef28b8$var$TX_NONCE_RETRY_NUMBER, $c59f6b1c2cef28b8$var$TX_NONCE_RETRY_WAIT_BACKOFF, /*#__PURE__*/ (0, $byzP8._)(function() {
                                        var ref, publicKey, error;
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.signTransaction(receiverId, actions)
                                                    ];
                                                case 1:
                                                    ref = (0, $8GFUW._).apply(void 0, [
                                                        _state.sent(),
                                                        2
                                                    ]), txHash = ref[0], signedTx = ref[1], ref;
                                                    publicKey = signedTx.transaction.publicKey;
                                                    _state.label = 2;
                                                case 2:
                                                    _state.trys.push([
                                                        2,
                                                        4,
                                                        ,
                                                        5
                                                    ]);
                                                    return [
                                                        4,
                                                        _this.connection.provider.sendTransaction(signedTx)
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 4:
                                                    error = _state.sent();
                                                    if (error.type === "InvalidNonce") {
                                                        $6vXKs.logWarning("Retrying transaction ".concat(receiverId, ":").concat($2HPkT.baseEncode(txHash), " with new nonce."));
                                                        delete _this.accessKeyByPublicKeyCache[publicKey.toString()];
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    if (error.type === "Expired") {
                                                        $6vXKs.logWarning("Retrying transaction ".concat(receiverId, ":").concat($2HPkT.baseEncode(txHash), " due to expired block hash"));
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    error.context = new $bMcUu.ErrorContext($2HPkT.baseEncode(txHash));
                                                    throw error;
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) // TODO: This should have different code actually, as means "transaction not submitted for sure"
                                throw new $bMcUu.TypedError("nonce retries exceeded for transaction. This usually means there are too many parallel requests with the same access key.", "RetriesExceeded");
                                flatLogs = [
                                    result.transaction_outcome
                                ].concat((0, $fLnyw._)(result.receipts_outcome)).reduce(function(acc, it) {
                                    if (it.outcome.logs.length || typeof it.outcome.status === "object" && typeof it.outcome.status.Failure === "object") return acc.concat({
                                        "receiptIds": it.outcome.receipt_ids,
                                        "logs": it.outcome.logs,
                                        "failure": typeof it.outcome.status.Failure != "undefined" ? $2RlOX.parseRpcError(it.outcome.status.Failure) : null
                                    });
                                    else return acc;
                                }, []);
                                _this.printLogsAndFailures(signedTx.transaction.receiverId, flatLogs);
                                if (!returnError && typeof result.status === "object" && typeof result.status.Failure === "object") {
                                    // if error data has error_message and error_type properties, we consider that node returned an error in the old format
                                    if (result.status.Failure.error_message && result.status.Failure.error_type) throw new $bMcUu.TypedError("Transaction ".concat(result.transaction_outcome.id, " failed. ").concat(result.status.Failure.error_message), result.status.Failure.error_type);
                                    else throw $2RlOX.parseResultError(result);
                                }
                                // TODO: if Tx is Unknown or Started.
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findAccessKey",
            value: /**
     * Finds the {@link AccessKeyView} associated with the accounts {@link PublicKey} stored in the {@link KeyStore}.
     *
     * @todo Find matching access key based on transaction (i.e. receiverId and actions)
     *
     * @param receiverId currently unused (see todo)
     * @param actions currently unused (see todo)
     * @returns `{ publicKey PublicKey; accessKey: AccessKeyView }`
     */ function findAccessKey(receiverId, actions) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var publicKey, cachedAccessKey, accessKey, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.connection.signer.getPublicKey(_this.accountId, _this.connection.networkId)
                                ];
                            case 1:
                                publicKey = _state.sent();
                                if (!publicKey) return [
                                    2,
                                    null
                                ];
                                cachedAccessKey = _this.accessKeyByPublicKeyCache[publicKey.toString()];
                                if (cachedAccessKey !== undefined) return [
                                    2,
                                    {
                                        publicKey: publicKey,
                                        accessKey: cachedAccessKey
                                    }
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.connection.provider.query({
                                        request_type: "view_access_key",
                                        account_id: _this.accountId,
                                        public_key: publicKey.toString(),
                                        finality: "optimistic"
                                    })
                                ];
                            case 3:
                                accessKey = _state.sent();
                                // this function can be called multiple times and retrieve the same access key
                                // this checks to see if the access key was already retrieved and cached while
                                // the above network call was in flight. To keep nonce values in line, we return
                                // the cached access key.
                                if (_this.accessKeyByPublicKeyCache[publicKey.toString()]) return [
                                    2,
                                    {
                                        publicKey: publicKey,
                                        accessKey: _this.accessKeyByPublicKeyCache[publicKey.toString()]
                                    }
                                ];
                                _this.accessKeyByPublicKeyCache[publicKey.toString()] = accessKey;
                                return [
                                    2,
                                    {
                                        publicKey: publicKey,
                                        accessKey: accessKey
                                    }
                                ];
                            case 4:
                                e = _state.sent();
                                if (e.type == "AccessKeyDoesNotExist") return [
                                    2,
                                    null
                                ];
                                throw e;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createAndDeployContract",
            value: /**
     * Create a new account and deploy a contract to it
     *
     * @param contractId NEAR account where the contract is deployed
     * @param publicKey The public key to add to the created contract account
     * @param data The compiled contract code
     * @param amount of NEAR to transfer to the created contract account. Transfer enough to pay for storage https://docs.near.org/docs/concepts/storage-staking
     */ function createAndDeployContract(contractId, publicKey, data, amount) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accessKey, contractAccount;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accessKey = $7cM39.fullAccessKey();
                                return [
                                    4,
                                    _this.signAndSendTransaction({
                                        receiverId: contractId,
                                        actions: [
                                            $7cM39.createAccount(),
                                            $7cM39.transfer(amount),
                                            $7cM39.addKey($8pTGX.PublicKey.from(publicKey), accessKey),
                                            $7cM39.deployContract(data)
                                        ]
                                    })
                                ];
                            case 1:
                                _state.sent();
                                contractAccount = new Account(_this.connection, contractId);
                                return [
                                    2,
                                    contractAccount
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendMoney",
            value: /**
     * @param receiverId NEAR account receiving Ⓝ
     * @param amount Amount to send in yoctoⓃ
     */ function sendMoney(receiverId, amount) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: receiverId,
                                actions: [
                                    $7cM39.transfer(amount)
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "createAccount",
            value: /**
     * @param newAccountId NEAR account name to be created
     * @param publicKey A public key created from the masterAccount
     */ function createAccount(newAccountId, publicKey, amount) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accessKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        accessKey = $7cM39.fullAccessKey();
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: newAccountId,
                                actions: [
                                    $7cM39.createAccount(),
                                    $7cM39.transfer(amount),
                                    $7cM39.addKey($8pTGX.PublicKey.from(publicKey), accessKey)
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "deleteAccount",
            value: /**
     * @param beneficiaryId The NEAR account that will receive the remaining Ⓝ balance from the account being deleted
     */ function deleteAccount(beneficiaryId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: _this.accountId,
                                actions: [
                                    $7cM39.deleteAccount(beneficiaryId)
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "deployContract",
            value: /**
     * @param data The compiled contract code
     */ function deployContract(data) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: _this.accountId,
                                actions: [
                                    $7cM39.deployContract(data)
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "functionCall",
            value: function functionCall() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (typeof args[0] === "string") return [
                            2,
                            _this.functionCallV1(args[0], args[1], args[2], args[3], args[4])
                        ];
                        else return [
                            2,
                            _this.functionCallV2(args[0])
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "functionCallV1",
            value: function functionCallV1(contractId, methodName, args, gas, amount) {
                var deprecate = $c59f6b1c2cef28b8$var$depd_1.default("Account.functionCall(contractId, methodName, args, gas, amount)");
                deprecate("use `Account.functionCall(FunctionCallOptions)` instead");
                args = args || {};
                this.validateArgs(args);
                return this.signAndSendTransaction({
                    receiverId: contractId,
                    actions: [
                        $7cM39.functionCall(methodName, args, gas || $NN8ep.DEFAULT_FUNCTION_CALL_GAS, amount)
                    ]
                });
            }
        },
        {
            key: "functionCallV2",
            value: function functionCallV2(param) {
                var contractId = param.contractId, methodName = param.methodName, _param_args = param.args, args = _param_args === void 0 ? {} : _param_args, _param_gas = param.gas, gas = _param_gas === void 0 ? $NN8ep.DEFAULT_FUNCTION_CALL_GAS : _param_gas, attachedDeposit = param.attachedDeposit, walletMeta = param.walletMeta, walletCallbackUrl = param.walletCallbackUrl, stringify = param.stringify;
                this.validateArgs(args);
                var stringifyArg = stringify === undefined ? $7cM39.stringifyJsonOrBytes : stringify;
                return this.signAndSendTransaction({
                    receiverId: contractId,
                    actions: [
                        $7cM39.functionCall(methodName, args, gas, attachedDeposit, stringifyArg)
                    ],
                    walletMeta: walletMeta,
                    walletCallbackUrl: walletCallbackUrl
                });
            }
        },
        {
            key: "addKey",
            value: /**
     * @see {@link https://docs.near.org/docs/concepts/account#access-keys}
     * @todo expand this API to support more options.
     * @param publicKey A public key to be associated with the contract
     * @param contractId NEAR account where the contract is deployed
     * @param methodNames The method names on the contract that should be allowed to be called. Pass null for no method names and '' or [] for any method names.
     * @param amount Payment in yoctoⓃ that is sent to the contract during this function call
     */ function addKey(publicKey, contractId, methodNames, amount) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accessKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (!methodNames) methodNames = [];
                        if (!Array.isArray(methodNames)) methodNames = [
                            methodNames
                        ];
                        if (!contractId) accessKey = $7cM39.fullAccessKey();
                        else accessKey = $7cM39.functionCallAccessKey(contractId, methodNames, amount);
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: _this.accountId,
                                actions: [
                                    $7cM39.addKey($8pTGX.PublicKey.from(publicKey), accessKey)
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "deleteKey",
            value: /**
     * @param publicKey The public key to be deleted
     * @returns {Promise<FinalExecutionOutcome>}
     */ function deleteKey(publicKey) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: _this.accountId,
                                actions: [
                                    $7cM39.deleteKey($8pTGX.PublicKey.from(publicKey))
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "stake",
            value: /**
     * @see {@link https://docs.near.org/docs/validator/staking-overview}
     *
     * @param publicKey The public key for the account that's staking
     * @param amount The account to stake in yoctoⓃ
     */ function stake(publicKey, amount) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signAndSendTransaction({
                                receiverId: _this.accountId,
                                actions: [
                                    $7cM39.stake(amount, $8pTGX.PublicKey.from(publicKey))
                                ]
                            })
                        ];
                    });
                })();
            }
        },
        {
            /** @hidden */ key: "validateArgs",
            value: function validateArgs(args) {
                var isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
                if (isUint8Array) return;
                if (Array.isArray(args) || typeof args !== "object") throw new $6vXKs.PositionalArgsError();
            }
        },
        {
            key: "viewFunction",
            value: /**
     * Invoke a contract view function using the RPC API.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#call-a-contract-function}
     *
     * @param contractId NEAR account where the contract is deployed
     * @param methodName The view-only method (no state mutations) name on the contract as it is written in the contract code
     * @param args Any arguments to the view contract method, wrapped in JSON
     * @param options.parse Parse the result of the call. Receives a Buffer (bytes array) and converts it to any object. By default result will be treated as json.
     * @param options.stringify Convert input arguments into a bytes array. By default the input is treated as a JSON.
     * @returns {Promise<any>}
     */ function viewFunction(contractId, methodName) {
                var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_parse = _ref.parse, parse = _ref_parse === void 0 ? $c59f6b1c2cef28b8$var$parseJsonFromRawResponse : _ref_parse, _ref_stringify = _ref.stringify, stringify = _ref_stringify === void 0 ? $c59f6b1c2cef28b8$var$bytesJsonStringify : _ref_stringify;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var serializedArgs, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.validateArgs(args);
                                serializedArgs = stringify(args).toString("base64");
                                return [
                                    4,
                                    _this.connection.provider.query({
                                        request_type: "call_function",
                                        account_id: contractId,
                                        method_name: methodName,
                                        args_base64: serializedArgs,
                                        finality: "optimistic"
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.logs) _this.printLogs(contractId, result.logs);
                                return [
                                    2,
                                    result.result && result.result.length > 0 && parse($c59f6b1c2cef28b8$require$Buffer.from(result.result))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "viewState",
            value: /**
     * Returns the state (key value pairs) of this account's contract based on the key prefix.
     * Pass an empty string for prefix if you would like to return the entire state.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#view-contract-state}
     *
     * @param prefix allows to filter which keys should be returned. Empty prefix means all keys. String prefix is utf-8 encoded.
     * @param blockQuery specifies which block to query state at. By default returns last "optimistic" block (i.e. not necessarily finalized).
     */ function viewState(prefix) {
                var blockQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    finality: "optimistic"
                };
                var _this = this;
                return (0, $byzP8._)(function() {
                    var values;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.connection.provider.query((0, $8E768._)((0, $8OnJk._)({
                                        request_type: "view_state"
                                    }, blockQuery), {
                                        account_id: _this.accountId,
                                        prefix_base64: $c59f6b1c2cef28b8$require$Buffer.from(prefix).toString("base64")
                                    }))
                                ];
                            case 1:
                                values = _state.sent().values;
                                return [
                                    2,
                                    values.map(function(param) {
                                        var key = param.key, value = param.value;
                                        return {
                                            key: $c59f6b1c2cef28b8$require$Buffer.from(key, "base64"),
                                            value: $c59f6b1c2cef28b8$require$Buffer.from(value, "base64")
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccessKeys",
            value: /**
     * Get all access keys for the account
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#view-access-key-list}
     */ function getAccessKeys() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.connection.provider.query({
                                        request_type: "view_access_key_list",
                                        account_id: _this.accountId,
                                        finality: "optimistic"
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                // A breaking API change introduced extra information into the
                                // response, so it now returns an object with a `keys` field instead
                                // of an array: https://github.com/nearprotocol/nearcore/pull/1789
                                if (Array.isArray(response)) return [
                                    2,
                                    response
                                ];
                                return [
                                    2,
                                    response.keys
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountDetails",
            value: /**
     * Returns a list of authorized apps
     * @todo update the response value to return all the different keys, not just app keys.
     */ function getAccountDetails() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accessKeys, authorizedApps;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccessKeys()
                                ];
                            case 1:
                                accessKeys = _state.sent();
                                authorizedApps = accessKeys.filter(function(item) {
                                    return item.access_key.permission !== "FullAccess";
                                }).map(function(item) {
                                    var perm = item.access_key.permission;
                                    return {
                                        contractId: perm.FunctionCall.receiver_id,
                                        amount: perm.FunctionCall.allowance,
                                        publicKey: item.public_key
                                    };
                                });
                                return [
                                    2,
                                    {
                                        authorizedApps: authorizedApps
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountBalance",
            value: /**
     * Returns calculated account balance
     */ function getAccountBalance() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var protocolConfig, state, costPerByte, stateStaked, staked, totalBalance, availableBalance;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.connection.provider.experimental_protocolConfig({
                                        finality: "final"
                                    })
                                ];
                            case 1:
                                protocolConfig = _state.sent();
                                return [
                                    4,
                                    _this.state()
                                ];
                            case 2:
                                state = _state.sent();
                                costPerByte = new $c59f6b1c2cef28b8$var$bn_js_1.default(protocolConfig.runtime_config.storage_amount_per_byte);
                                stateStaked = new $c59f6b1c2cef28b8$var$bn_js_1.default(state.storage_usage).mul(costPerByte);
                                staked = new $c59f6b1c2cef28b8$var$bn_js_1.default(state.locked);
                                totalBalance = new $c59f6b1c2cef28b8$var$bn_js_1.default(state.amount).add(staked);
                                availableBalance = totalBalance.sub($c59f6b1c2cef28b8$var$bn_js_1.default.max(staked, stateStaked));
                                return [
                                    2,
                                    {
                                        total: totalBalance.toString(),
                                        stateStaked: stateStaked.toString(),
                                        staked: staked.toString(),
                                        available: availableBalance.toString()
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Account;
}();
module.exports.Account = $c59f6b1c2cef28b8$var$Account;

});
parcelRequire.register("NN8ep", function(module, exports) {
"use strict";
var $095ab04357b993d4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_FUNCTION_CALL_GAS = void 0;

var $095ab04357b993d4$var$bn_js_1 = $095ab04357b993d4$var$__importDefault((parcelRequire("jkm5c")));
// Default amount of gas to be sent with the function calls. Used to pay for the fees
// incurred while running the contract execution. The unused amount will be refunded back to
// the originator.
// Due to protocol changes that charge upfront for the maximum possible gas price inflation due to
// full blocks, the price of max_prepaid_gas is decreased to `300 * 10**12`.
// For discussion see https://github.com/nearprotocol/NEPs/issues/67
module.exports.DEFAULT_FUNCTION_CALL_GAS = new $095ab04357b993d4$var$bn_js_1.default("30000000000000");

});


parcelRequire.register("staLo", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $fLnyw = parcelRequire("fLnyw");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $05593eb604a25c4e$require$Buffer = $gzLuY.Buffer;
"use strict";
var $05593eb604a25c4e$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account2FA = module.exports.AccountMultisig = module.exports.MULTISIG_CONFIRM_METHODS = module.exports.MULTISIG_CHANGE_METHODS = module.exports.MULTISIG_DEPOSIT = module.exports.MULTISIG_GAS = module.exports.MULTISIG_ALLOWANCE = module.exports.MULTISIG_STORAGE_KEY = void 0;

var $05593eb604a25c4e$var$bn_js_1 = $05593eb604a25c4e$var$__importDefault((parcelRequire("jkm5c")));

var $05593eb604a25c4e$var$depd_1 = $05593eb604a25c4e$var$__importDefault((parcelRequire("7kbiF")));

var $gXWlL = parcelRequire("gXWlL");

var $fbj1i = parcelRequire("fbj1i");

var $8pTGX = parcelRequire("8pTGX");

var $7cM39 = parcelRequire("7cM39");

var $9Nstj = parcelRequire("9Nstj");
module.exports.MULTISIG_STORAGE_KEY = "__multisigRequest";
module.exports.MULTISIG_ALLOWANCE = new $05593eb604a25c4e$var$bn_js_1.default($fbj1i.parseNearAmount("1"));
// TODO: Different gas value for different requests (can reduce gas usage dramatically)
module.exports.MULTISIG_GAS = new $05593eb604a25c4e$var$bn_js_1.default("100000000000000");
module.exports.MULTISIG_DEPOSIT = new $05593eb604a25c4e$var$bn_js_1.default("0");
module.exports.MULTISIG_CHANGE_METHODS = [
    "add_request",
    "add_request_and_confirm",
    "delete_request",
    "confirm"
];
module.exports.MULTISIG_CONFIRM_METHODS = [
    "confirm"
];
// in memory request cache for node w/o localStorage
var $05593eb604a25c4e$var$storageFallback = (0, $dxWQo._)({}, module.exports.MULTISIG_STORAGE_KEY, null);
var $05593eb604a25c4e$var$AccountMultisig = /*#__PURE__*/ function(_account_1_Account) {
    "use strict";
    (0, $ftJVG._)(AccountMultisig, _account_1_Account);
    var _super = (0, $6OZAO._)(AccountMultisig);
    function AccountMultisig(connection, accountId, options) {
        (0, $978gY._)(this, AccountMultisig);
        var _this;
        _this = _super.call(this, connection, accountId);
        _this.storage = options.storage;
        _this.onAddRequestResult = options.onAddRequestResult;
        return _this;
    }
    (0, $kry2a._)(AccountMultisig, [
        {
            key: "signAndSendTransactionWithAccount",
            value: function signAndSendTransactionWithAccount(receiverId, actions) {
                var _this = this;
                var _this1 = this, _superprop_get_signAndSendTransaction = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(AccountMultisig.prototype), "signAndSendTransaction", _this);
                };
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _superprop_get_signAndSendTransaction().call(_this1, {
                                receiverId: receiverId,
                                actions: actions
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "signAndSendTransaction",
            value: function signAndSendTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (typeof args[0] === "string") return this._signAndSendTransaction({
                    receiverId: args[0],
                    actions: args[1]
                });
                return this._signAndSendTransaction(args[0]);
            }
        },
        {
            key: "_signAndSendTransaction",
            value: function _signAndSendTransaction(param) {
                var receiverId = param.receiverId, actions = param.actions;
                var _this = this;
                var _this1 = this, _superprop_get_signAndSendTransaction = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(AccountMultisig.prototype), "signAndSendTransaction", _this);
                };
                return (0, $byzP8._)(function() {
                    var accountId, args, result, e, status;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this1.accountId;
                                args = $05593eb604a25c4e$require$Buffer.from(JSON.stringify({
                                    request: {
                                        receiver_id: receiverId,
                                        actions: $05593eb604a25c4e$var$convertActions(actions, accountId, receiverId)
                                    }
                                }));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _superprop_get_signAndSendTransaction().call(_this1, {
                                        receiverId: accountId,
                                        actions: [
                                            $7cM39.functionCall("add_request_and_confirm", args, module.exports.MULTISIG_GAS, module.exports.MULTISIG_DEPOSIT)
                                        ]
                                    })
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                e = _state.sent();
                                if (!e.toString().includes("Account has too many active requests. Confirm or delete some")) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this1.deleteUnconfirmedRequests()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this1.signAndSendTransaction(receiverId, actions)
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                throw e;
                            case 7:
                                // TODO: Are following even needed? Seems like it throws on error already
                                if (!result.status) throw new Error("Request failed");
                                status = (0, $8OnJk._)({}, result.status);
                                if (!status.SuccessValue || typeof status.SuccessValue !== "string") throw new Error("Request failed");
                                _this1.setRequest({
                                    accountId: accountId,
                                    actions: actions,
                                    requestId: parseInt($05593eb604a25c4e$require$Buffer.from(status.SuccessValue, "base64").toString("ascii"), 10)
                                });
                                if (!_this1.onAddRequestResult) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _this1.onAddRequestResult(result)
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                // NOTE there is no await on purpose to avoid blocking for 2fa
                                _this1.deleteUnconfirmedRequests();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteUnconfirmedRequests",
            value: function deleteUnconfirmedRequests() {
                var _this = this;
                var _this1 = this, _superprop_get_signAndSendTransaction = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(AccountMultisig.prototype), "signAndSendTransaction", _this);
                };
                return (0, $byzP8._)(function() {
                    var request_ids, requestId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, requestIdToDelete, e, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this1.getRequestIds()
                                ];
                            case 1:
                                request_ids = _state.sent();
                                requestId = _this1.getRequest().requestId;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = request_ids[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                requestIdToDelete = _step.value;
                                if (requestIdToDelete == requestId) return [
                                    3,
                                    7
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _superprop_get_signAndSendTransaction().call(_this1, {
                                        receiverId: _this1.accountId,
                                        actions: [
                                            $7cM39.functionCall("delete_request", {
                                                request_id: requestIdToDelete
                                            }, module.exports.MULTISIG_GAS, module.exports.MULTISIG_DEPOSIT)
                                        ]
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                console.warn("Attempt to delete an earlier request before 15 minutes failed. Will try again.");
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRequestIds",
            value: // helpers
            function getRequestIds() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        // TODO: Read requests from state to allow filtering by expiration time
                        // TODO: https://github.com/near/core-contracts/blob/305d1db4f4f2cf5ce4c1ef3479f7544957381f11/multisig/src/lib.rs#L84
                        return [
                            2,
                            _this.viewFunction(_this.accountId, "list_request_ids")
                        ];
                    });
                })();
            }
        },
        {
            key: "getRequest",
            value: function getRequest() {
                if (this.storage) return JSON.parse(this.storage.getItem(module.exports.MULTISIG_STORAGE_KEY) || "{}");
                return $05593eb604a25c4e$var$storageFallback[module.exports.MULTISIG_STORAGE_KEY];
            }
        },
        {
            key: "setRequest",
            value: function setRequest(data) {
                if (this.storage) return this.storage.setItem(module.exports.MULTISIG_STORAGE_KEY, JSON.stringify(data));
                $05593eb604a25c4e$var$storageFallback[module.exports.MULTISIG_STORAGE_KEY] = data;
            }
        }
    ]);
    return AccountMultisig;
}($gXWlL.Account);
module.exports.AccountMultisig = $05593eb604a25c4e$var$AccountMultisig;
var $05593eb604a25c4e$var$Account2FA = /*#__PURE__*/ function(AccountMultisig) {
    "use strict";
    (0, $ftJVG._)(Account2FA, AccountMultisig);
    var _super = (0, $6OZAO._)(Account2FA);
    function Account2FA(connection, accountId, options) {
        (0, $978gY._)(this, Account2FA);
        var _this;
        _this = _super.call(this, connection, accountId, options);
        _this.helperUrl = "https://helper.testnet.near.org";
        _this.helperUrl = options.helperUrl || _this.helperUrl;
        _this.storage = options.storage;
        _this.sendCode = options.sendCode || _this.sendCodeDefault;
        _this.getCode = options.getCode || _this.getCodeDefault;
        _this.verifyCode = options.verifyCode || _this.verifyCodeDefault;
        _this.onConfirmResult = options.onConfirmResult;
        return _this;
    }
    (0, $kry2a._)(Account2FA, [
        {
            key: "signAndSendTransaction",
            value: function signAndSendTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                return (0, $byzP8._)(function() {
                    var deprecate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (typeof args[0] === "string") {
                            deprecate = $05593eb604a25c4e$var$depd_1.default("Account.signAndSendTransaction(receiverId, actions");
                            deprecate("use `Account2FA.signAndSendTransaction(SignAndSendTransactionOptions)` instead");
                            return [
                                2,
                                _this.__signAndSendTransaction({
                                    receiverId: args[0],
                                    actions: args[1]
                                })
                            ];
                        } else return [
                            2,
                            _this.__signAndSendTransaction(args[0])
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "__signAndSendTransaction",
            value: function __signAndSendTransaction(param) {
                var receiverId = param.receiverId, actions = param.actions;
                var _this = this;
                var _this1 = this, _superprop_get_signAndSendTransaction = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account2FA.prototype), "signAndSendTransaction", _this);
                };
                return (0, $byzP8._)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_signAndSendTransaction().call(_this1, {
                                        receiverId: receiverId,
                                        actions: actions
                                    })
                                ];
                            case 1:
                                _state.sent();
                                // TODO: Should following override onRequestResult in superclass instead of doing custom signAndSendTransaction?
                                return [
                                    4,
                                    _this1.sendCode()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this1.promptAndVerify()
                                ];
                            case 3:
                                result = _state.sent();
                                if (!_this1.onConfirmResult) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this1.onConfirmResult(result)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deployMultisig",
            value: // default helpers for CH deployments of multisig
            function deployMultisig(contractBytes) {
                var _this = this;
                var _this1 = this, _superprop_get_signAndSendTransactionWithAccount = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(Account2FA.prototype), "signAndSendTransactionWithAccount", _this);
                };
                return (0, $byzP8._)(function() {
                    var accountId, seedOrLedgerKey, fak2lak, confirmOnlyKey, newArgs, actions;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this1.accountId;
                                return [
                                    4,
                                    _this1.getRecoveryMethods()
                                ];
                            case 1:
                                seedOrLedgerKey = _state.sent().data.filter(function(param) {
                                    var kind = param.kind, publicKey = param.publicKey;
                                    return (kind === "phrase" || kind === "ledger") && publicKey !== null;
                                }).map(function(rm) {
                                    return rm.publicKey;
                                });
                                return [
                                    4,
                                    _this1.getAccessKeys()
                                ];
                            case 2:
                                fak2lak = _state.sent().filter(function(param) {
                                    var public_key = param.public_key, permission = param.access_key.permission;
                                    return permission === "FullAccess" && !seedOrLedgerKey.includes(public_key);
                                }).map(function(ak) {
                                    return ak.public_key;
                                }).map($05593eb604a25c4e$var$toPK);
                                return [
                                    4,
                                    _this1.postSignedJson("/2fa/getAccessKey", {
                                        accountId: accountId
                                    })
                                ];
                            case 3:
                                confirmOnlyKey = $05593eb604a25c4e$var$toPK.apply(void 0, [
                                    _state.sent().publicKey
                                ]);
                                newArgs = $05593eb604a25c4e$require$Buffer.from(JSON.stringify({
                                    "num_confirmations": 2
                                }));
                                actions = (0, $fLnyw._)(fak2lak.map(function(pk) {
                                    return $7cM39.deleteKey(pk);
                                })).concat((0, $fLnyw._)(fak2lak.map(function(pk) {
                                    return $7cM39.addKey(pk, $7cM39.functionCallAccessKey(accountId, module.exports.MULTISIG_CHANGE_METHODS, null));
                                })), [
                                    $7cM39.addKey(confirmOnlyKey, $7cM39.functionCallAccessKey(accountId, module.exports.MULTISIG_CONFIRM_METHODS, null)),
                                    $7cM39.deployContract(contractBytes)
                                ]);
                                return [
                                    4,
                                    _this1.state()
                                ];
                            case 4:
                                if (_state.sent().code_hash === "11111111111111111111111111111111") actions.push($7cM39.functionCall("new", newArgs, module.exports.MULTISIG_GAS, module.exports.MULTISIG_DEPOSIT));
                                console.log("deploying multisig contract for", accountId);
                                return [
                                    4,
                                    _superprop_get_signAndSendTransactionWithAccount().call(_this1, accountId, actions)
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disable",
            value: function disable(contractBytes) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accountId, accessKeys, lak2fak, confirmOnlyKey, _, _1, actions;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this.accountId;
                                return [
                                    4,
                                    _this.getAccessKeys()
                                ];
                            case 1:
                                accessKeys = _state.sent();
                                lak2fak = accessKeys.filter(function(param) {
                                    var access_key = param.access_key;
                                    return access_key.permission !== "FullAccess";
                                }).filter(function(param) {
                                    var access_key = param.access_key;
                                    var perm = access_key.permission.FunctionCall;
                                    return perm.receiver_id === accountId && perm.method_names.length === 4 && perm.method_names.includes("add_request_and_confirm");
                                });
                                _1 = (_ = $8pTGX.PublicKey).from;
                                return [
                                    4,
                                    _this.postSignedJson("/2fa/getAccessKey", {
                                        accountId: accountId
                                    })
                                ];
                            case 2:
                                confirmOnlyKey = _1.apply(_, [
                                    _state.sent().publicKey
                                ]);
                                actions = [
                                    $7cM39.deleteKey(confirmOnlyKey)
                                ].concat((0, $fLnyw._)(lak2fak.map(function(param) {
                                    var public_key = param.public_key;
                                    return $7cM39.deleteKey($8pTGX.PublicKey.from(public_key));
                                })), (0, $fLnyw._)(lak2fak.map(function(param) {
                                    var public_key = param.public_key;
                                    return $7cM39.addKey($8pTGX.PublicKey.from(public_key), null);
                                })), [
                                    $7cM39.deployContract(contractBytes)
                                ]);
                                console.log("disabling 2fa for", accountId);
                                return [
                                    4,
                                    _this.signAndSendTransaction({
                                        receiverId: accountId,
                                        actions: actions
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendCodeDefault",
            value: function sendCodeDefault() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accountId, requestId, method;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this.accountId;
                                requestId = _this.getRequest().requestId;
                                return [
                                    4,
                                    _this.get2faMethod()
                                ];
                            case 1:
                                method = _state.sent();
                                return [
                                    4,
                                    _this.postSignedJson("/2fa/send", {
                                        accountId: accountId,
                                        method: method,
                                        requestId: requestId
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    requestId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCodeDefault",
            value: function getCodeDefault(method) {
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        throw new Error('There is no getCode callback provided. Please provide your own in AccountMultisig constructor options. It has a parameter method where method.kind is "email" or "phone".');
                    });
                })();
            }
        },
        {
            key: "promptAndVerify",
            value: function promptAndVerify() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var method, securityCode, result, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.get2faMethod()
                                ];
                            case 1:
                                method = _state.sent();
                                return [
                                    4,
                                    _this.getCode(method)
                                ];
                            case 2:
                                securityCode = _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.verifyCode(securityCode)
                                ];
                            case 4:
                                result = _state.sent();
                                // TODO: Parse error from result for real (like in normal account.signAndSendTransaction)
                                return [
                                    2,
                                    result
                                ];
                            case 5:
                                e = _state.sent();
                                console.warn("Error validating security code:", e);
                                if (!(e.toString().includes("invalid 2fa code provided") || e.toString().includes("2fa code not valid"))) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.promptAndVerify()
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 7:
                                throw e;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyCodeDefault",
            value: function verifyCodeDefault(securityCode) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accountId, request, requestId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this.accountId;
                                request = _this.getRequest();
                                if (!request) throw new Error("no request pending");
                                requestId = request.requestId;
                                return [
                                    4,
                                    _this.postSignedJson("/2fa/verify", {
                                        accountId: accountId,
                                        securityCode: securityCode,
                                        requestId: requestId
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecoveryMethods",
            value: function getRecoveryMethods() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accountId, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this.accountId;
                                _tmp = {
                                    accountId: accountId
                                };
                                return [
                                    4,
                                    _this.postSignedJson("/account/recoveryMethods", {
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    (_tmp.data = _state.sent(), _tmp)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "get2faMethod",
            value: function get2faMethod() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var data, kind, detail;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getRecoveryMethods()
                                ];
                            case 1:
                                data = _state.sent().data;
                                if (data && data.length) data = data.find(function(m) {
                                    return m.kind.indexOf("2fa-") === 0;
                                });
                                if (!data) return [
                                    2,
                                    null
                                ];
                                kind = data.kind, detail = data.detail;
                                return [
                                    2,
                                    {
                                        kind: kind,
                                        detail: detail
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signatureFor",
            value: function signatureFor() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accountId, block, blockNumber, signed, blockNumberSignature;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountId = _this.accountId;
                                return [
                                    4,
                                    _this.connection.provider.block({
                                        finality: "final"
                                    })
                                ];
                            case 1:
                                block = _state.sent();
                                blockNumber = block.header.height.toString();
                                return [
                                    4,
                                    _this.connection.signer.signMessage($05593eb604a25c4e$require$Buffer.from(blockNumber), accountId, _this.connection.networkId)
                                ];
                            case 2:
                                signed = _state.sent();
                                blockNumberSignature = $05593eb604a25c4e$require$Buffer.from(signed.signature).toString("base64");
                                return [
                                    2,
                                    {
                                        blockNumber: blockNumber,
                                        blockNumberSignature: blockNumberSignature
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postSignedJson",
            value: function postSignedJson(path, body) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var _, _tmp, _1, _tmp1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = $9Nstj.fetchJson;
                                _tmp = [
                                    _this.helperUrl + path
                                ];
                                _1 = JSON.stringify;
                                _tmp1 = [
                                    {},
                                    body
                                ];
                                return [
                                    4,
                                    _this.signatureFor()
                                ];
                            case 1:
                                return [
                                    4,
                                    _.apply($9Nstj, _tmp.concat([
                                        _1.apply(JSON, [
                                            (0, $8OnJk._).apply(void 0, _tmp1.concat([
                                                _state.sent()
                                            ]))
                                        ])
                                    ]))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Account2FA;
}($05593eb604a25c4e$var$AccountMultisig);
module.exports.Account2FA = $05593eb604a25c4e$var$Account2FA;
// helpers
var $05593eb604a25c4e$var$toPK = function(pk) {
    return $8pTGX.PublicKey.from(pk);
};
var $05593eb604a25c4e$var$convertPKForContract = function(pk) {
    return pk.toString().replace("ed25519:", "");
};
var $05593eb604a25c4e$var$convertActions = function(actions, accountId, receiverId) {
    return actions.map(function(a) {
        var type = a.enum;
        var _a_type = a[type], gas = _a_type.gas, publicKey = _a_type.publicKey, methodName = _a_type.methodName, args = _a_type.args, deposit = _a_type.deposit, accessKey = _a_type.accessKey, code = _a_type.code;
        var action = {
            type: type[0].toUpperCase() + type.substr(1),
            gas: gas && gas.toString() || undefined,
            public_key: publicKey && $05593eb604a25c4e$var$convertPKForContract(publicKey) || undefined,
            method_name: methodName,
            args: args && $05593eb604a25c4e$require$Buffer.from(args).toString("base64") || undefined,
            code: code && $05593eb604a25c4e$require$Buffer.from(code).toString("base64") || undefined,
            amount: deposit && deposit.toString() || undefined,
            deposit: deposit && deposit.toString() || "0",
            permission: undefined
        };
        if (accessKey) {
            if (receiverId === accountId && accessKey.permission.enum !== "fullAccess") action.permission = {
                receiver_id: accountId,
                allowance: module.exports.MULTISIG_ALLOWANCE.toString(),
                method_names: module.exports.MULTISIG_CHANGE_METHODS
            };
            if (accessKey.permission.enum === "functionCall") {
                var _accessKey_permission_functionCall = accessKey.permission.functionCall, receiver_id = _accessKey_permission_functionCall.receiverId, method_names = _accessKey_permission_functionCall.methodNames, allowance = _accessKey_permission_functionCall.allowance;
                action.permission = {
                    receiver_id: receiver_id,
                    allowance: allowance && allowance.toString() || undefined,
                    method_names: method_names
                };
            }
        }
        return action;
    });
};

});
parcelRequire.register("3cct3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $253c29e4a8bc609b$export$afb3516d9d608401; });

var $i8pJC = parcelRequire("i8pJC");
function $253c29e4a8bc609b$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $253c29e4a8bc609b$export$afb3516d9d608401 = Reflect.get;
    else $253c29e4a8bc609b$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $i8pJC._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $253c29e4a8bc609b$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRequire.register("i8pJC", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $d33cefbe4adc536f$export$e4187255aefbc259; });

var $g3d7z = parcelRequire("g3d7z");
function $d33cefbe4adc536f$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $g3d7z._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});



parcelRequire.register("g5374", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlAccountCreator = module.exports.LocalAccountCreator = module.exports.AccountCreator = void 0;

var $9Nstj = parcelRequire("9Nstj");
/**
 * Account creator provides an interface for implementations to actually create accounts
 */ var $bb4f872188849eec$var$AccountCreator = function AccountCreator() {
    (0, $978gY._)(this, AccountCreator);
};
module.exports.AccountCreator = $bb4f872188849eec$var$AccountCreator;
var $bb4f872188849eec$var$LocalAccountCreator = /*#__PURE__*/ function(AccountCreator) {
    (0, $ftJVG._)(LocalAccountCreator, AccountCreator);
    var _super = (0, $6OZAO._)(LocalAccountCreator);
    function LocalAccountCreator(masterAccount, initialBalance) {
        (0, $978gY._)(this, LocalAccountCreator);
        var _this;
        _this = _super.call(this);
        _this.masterAccount = masterAccount;
        _this.initialBalance = initialBalance;
        return _this;
    }
    (0, $kry2a._)(LocalAccountCreator, [
        {
            key: "createAccount",
            value: /**
     * Creates an account using a masterAccount, meaning the new account is created from an existing account
     * @param newAccountId The name of the NEAR account to be created
     * @param publicKey The public key from the masterAccount used to create this account
     * @returns {Promise<void>}
     */ function createAccount(newAccountId, publicKey) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.masterAccount.createAccount(newAccountId, publicKey, _this.initialBalance)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return LocalAccountCreator;
}($bb4f872188849eec$var$AccountCreator);
module.exports.LocalAccountCreator = $bb4f872188849eec$var$LocalAccountCreator;
var $bb4f872188849eec$var$UrlAccountCreator = /*#__PURE__*/ function(AccountCreator) {
    (0, $ftJVG._)(UrlAccountCreator, AccountCreator);
    var _super = (0, $6OZAO._)(UrlAccountCreator);
    function UrlAccountCreator(connection, helperUrl) {
        (0, $978gY._)(this, UrlAccountCreator);
        var _this;
        _this = _super.call(this);
        _this.connection = connection;
        _this.helperUrl = helperUrl;
        return _this;
    }
    (0, $kry2a._)(UrlAccountCreator, [
        {
            key: "createAccount",
            value: /**
     * Creates an account using a helperUrl
     * This is [hosted here](https://helper.nearprotocol.com) or set up locally with the [near-contract-helper](https://github.com/nearprotocol/near-contract-helper) repository
     * @param newAccountId The name of the NEAR account to be created
     * @param publicKey The public key from the masterAccount used to create this account
     * @returns {Promise<void>}
     */ function createAccount(newAccountId, publicKey) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9Nstj.fetchJson("".concat(_this.helperUrl, "/account"), JSON.stringify({
                                        newAccountId: newAccountId,
                                        newAccountPublicKey: publicKey.toString()
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UrlAccountCreator;
}($bb4f872188849eec$var$AccountCreator);
module.exports.UrlAccountCreator = $bb4f872188849eec$var$UrlAccountCreator;

});

parcelRequire.register("5YbZv", function(module, exports) {

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8OnJk = parcelRequire("8OnJk");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $bMcUu = parcelRequire("bMcUu");

var $e29vo = parcelRequire("e29vo");
/**
 * @param config Contains connection info details
 * @returns {Provider}
 */ function $458bdb857ba52c8c$var$getProvider(config) {
    switch(config.type){
        case undefined:
            return config;
        case "JsonRpcProvider":
            return new $bMcUu.JsonRpcProvider((0, $8OnJk._)({}, config.args));
        default:
            throw new Error("Unknown provider type ".concat(config.type));
    }
}
/**
 * @param config Contains connection info details
 * @returns {Signer}
 */ function $458bdb857ba52c8c$var$getSigner(config) {
    switch(config.type){
        case undefined:
            return config;
        case "InMemorySigner":
            return new $e29vo.InMemorySigner(config.keyStore);
        default:
            throw new Error("Unknown signer type ".concat(config.type));
    }
}
/**
 * Connects an account to a given network via a given provider
 */ var $458bdb857ba52c8c$var$Connection = /*#__PURE__*/ function() {
    function Connection(networkId, provider, signer) {
        (0, $978gY._)(this, Connection);
        this.networkId = networkId;
        this.provider = provider;
        this.signer = signer;
    }
    (0, $kry2a._)(Connection, null, [
        {
            key: "fromConfig",
            value: /**
     * @param config Contains connection info details
     */ function fromConfig(config) {
                var provider = $458bdb857ba52c8c$var$getProvider(config.provider);
                var signer = $458bdb857ba52c8c$var$getSigner(config.signer);
                return new Connection(config.networkId, provider, signer);
            }
        }
    ]);
    return Connection;
}();
module.exports.Connection = $458bdb857ba52c8c$var$Connection;

});
parcelRequire.register("e29vo", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $a378a02b4a378201$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemorySigner = module.exports.Signer = void 0;

var $a378a02b4a378201$var$js_sha256_1 = $a378a02b4a378201$var$__importDefault((parcelRequire("hRCvM")));

var $8pTGX = parcelRequire("8pTGX");

var $5u7wK = parcelRequire("5u7wK");
/**
 * General signing interface, can be used for in memory signing, RPC singing, external wallet, HSM, etc.
 */ var $a378a02b4a378201$var$Signer = function Signer() {
    (0, $978gY._)(this, Signer);
};
module.exports.Signer = $a378a02b4a378201$var$Signer;
/**
 * Signs using in memory key store.
 */ var $a378a02b4a378201$var$InMemorySigner = /*#__PURE__*/ function(Signer) {
    (0, $ftJVG._)(InMemorySigner, Signer);
    var _super = (0, $6OZAO._)(InMemorySigner);
    function InMemorySigner(keyStore) {
        (0, $978gY._)(this, InMemorySigner);
        var _this;
        _this = _super.call(this);
        _this.keyStore = keyStore;
        return _this;
    }
    (0, $kry2a._)(InMemorySigner, [
        {
            key: "createKey",
            value: /**
     * Creates a public key for the account given
     * @param accountId The NEAR account to assign a public key to
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<PublicKey>}
     */ function createKey(accountId, networkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var keyPair;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                keyPair = $8pTGX.KeyPair.fromRandom("ed25519");
                                return [
                                    4,
                                    _this.keyStore.setKey(networkId, accountId, keyPair)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    keyPair.getPublicKey()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPublicKey",
            value: /**
     * Gets the existing public key for a given account
     * @param accountId The NEAR account to assign a public key to
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<PublicKey>} Returns the public key or null if not found
     */ function getPublicKey(accountId, networkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var keyPair;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.keyStore.getKey(networkId, accountId)
                                ];
                            case 1:
                                keyPair = _state.sent();
                                if (keyPair === null) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    keyPair.getPublicKey()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signMessage",
            value: /**
     * @param message A message to be signed, typically a serialized transaction
     * @param accountId the NEAR account signing the message
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<Signature>}
     */ function signMessage(message, accountId, networkId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var hash, keyPair;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                hash = new Uint8Array($a378a02b4a378201$var$js_sha256_1.default.sha256.array(message));
                                if (!accountId) throw new Error("InMemorySigner requires provided account id");
                                return [
                                    4,
                                    _this.keyStore.getKey(networkId, accountId)
                                ];
                            case 1:
                                keyPair = _state.sent();
                                if (keyPair === null) throw new Error("Key for ".concat(accountId, " not found in ").concat(networkId));
                                return [
                                    2,
                                    keyPair.sign(hash)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "InMemorySigner(".concat(this.keyStore, ")");
            }
        }
    ], [
        {
            key: "fromKeyPair",
            value: /**
     * Creates a single account Signer instance with account, network and keyPair provided.
     *
     * Intended to be useful for temporary keys (e.g. claiming a Linkdrop).
     *
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account to assign the key pair to
     * @param keyPair The keyPair to use for signing
     */ function fromKeyPair(networkId, accountId, keyPair) {
                return (0, $byzP8._)(function() {
                    var keyStore;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                keyStore = new $5u7wK.InMemoryKeyStore();
                                return [
                                    4,
                                    keyStore.setKey(networkId, accountId, keyPair)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    new InMemorySigner(keyStore)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return InMemorySigner;
}($a378a02b4a378201$var$Signer);
module.exports.InMemorySigner = $a378a02b4a378201$var$InMemorySigner;

});


parcelRequire.register("hRJ6X", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $d01a61128598fc80$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contract = void 0;

var $d01a61128598fc80$var$bn_js_1 = $d01a61128598fc80$var$__importDefault((parcelRequire("jkm5c")));

var $d01a61128598fc80$var$depd_1 = $d01a61128598fc80$var$__importDefault((parcelRequire("7kbiF")));

var $bMcUu = parcelRequire("bMcUu");

var $6vXKs = parcelRequire("6vXKs");
// Makes `function.name` return given name
function $d01a61128598fc80$var$nameFunction(name, body) {
    return (0, $dxWQo._)({}, name, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return body.apply(void 0, (0, $fLnyw._)(args));
    })[name];
}
var $d01a61128598fc80$var$isUint8Array = function(x) {
    return x && x.byteLength !== undefined && x.byteLength === x.length;
};
var $d01a61128598fc80$var$isObject = function(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
};
/**
 * Defines a smart contract on NEAR including the change (mutable) and view (non-mutable) methods
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#contract}
 * @example
 * ```js
 * import { Contract } from 'near-api-js';
 *
 * async function contractExample() {
 *   const methodOptions = {
 *     viewMethods: ['getMessageByAccountId'],
 *     changeMethods: ['addMessage']
 *   };
 *   const contract = new Contract(
 *     wallet.account(),
 *     'contract-id.testnet',
 *     methodOptions
 *   );
 *
 *   // use a contract view method
 *   const messages = await contract.getMessages({
 *     accountId: 'example-account.testnet'
 *   });
 *
 *   // use a contract change method
 *   await contract.addMessage({
 *      meta: 'some info',
 *      callbackUrl: 'https://example.com/callback',
 *      args: { text: 'my message' },
 *      amount: 1
 *   })
 * }
 * ```
 */ var $d01a61128598fc80$var$Contract = /*#__PURE__*/ function() {
    function Contract(account, contractId, options) {
        var _this = this;
        (0, $978gY._)(this, Contract);
        this.account = account;
        this.contractId = contractId;
        var _options_viewMethods = options.viewMethods, viewMethods = _options_viewMethods === void 0 ? [] : _options_viewMethods, _options_changeMethods = options.changeMethods, changeMethods = _options_changeMethods === void 0 ? [] : _options_changeMethods;
        viewMethods.forEach(function(methodName) {
            var _this1 = _this;
            Object.defineProperty(_this, methodName, {
                writable: false,
                enumerable: true,
                value: $d01a61128598fc80$var$nameFunction(methodName, /*#__PURE__*/ (0, $byzP8._)(function() {
                    var args, _$options, _len, ignored, _key;
                    var _arguments = arguments;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        args = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _$options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        for(_len = _arguments.length, ignored = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                            ignored[_key - 2] = _arguments[_key];
                        }
                        if (ignored.length || !($d01a61128598fc80$var$isObject(args) || $d01a61128598fc80$var$isUint8Array(args)) || !$d01a61128598fc80$var$isObject(_$options)) throw new $6vXKs.PositionalArgsError();
                        return [
                            2,
                            _this1.account.viewFunction(_this1.contractId, methodName, args, _$options)
                        ];
                    });
                }))
            });
        });
        changeMethods.forEach(function(methodName) {
            var _this1 = _this;
            Object.defineProperty(_this, methodName, {
                writable: false,
                enumerable: true,
                value: $d01a61128598fc80$var$nameFunction(methodName, /*#__PURE__*/ (0, $byzP8._)(function() {
                    var _len, args, _key, deprecate;
                    var _arguments = arguments;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        if (args.length && (args.length > 3 || !($d01a61128598fc80$var$isObject(args[0]) || $d01a61128598fc80$var$isUint8Array(args[0])))) throw new $6vXKs.PositionalArgsError();
                        if (args.length > 1 || !(args[0] && args[0].args)) {
                            deprecate = $d01a61128598fc80$var$depd_1.default("contract.methodName(args, gas, amount)");
                            deprecate("use `contract.methodName({ args, gas?, amount?, callbackUrl?, meta? })` instead");
                            return [
                                2,
                                _this1._changeMethod({
                                    methodName: methodName,
                                    args: args[0],
                                    gas: args[1],
                                    amount: args[2]
                                })
                            ];
                        }
                        return [
                            2,
                            _this1._changeMethod((0, $8OnJk._)({
                                methodName: methodName
                            }, args[0]))
                        ];
                    });
                }))
            });
        });
    }
    (0, $kry2a._)(Contract, [
        {
            key: "_changeMethod",
            value: function _changeMethod(param) {
                var args = param.args, methodName = param.methodName, gas = param.gas, amount = param.amount, meta = param.meta, callbackUrl = param.callbackUrl;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var rawResult;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $d01a61128598fc80$var$validateBNLike({
                                    gas: gas,
                                    amount: amount
                                });
                                return [
                                    4,
                                    _this.account.functionCall({
                                        contractId: _this.contractId,
                                        methodName: methodName,
                                        args: args,
                                        gas: gas,
                                        attachedDeposit: amount,
                                        walletMeta: meta,
                                        walletCallbackUrl: callbackUrl
                                    })
                                ];
                            case 1:
                                rawResult = _state.sent();
                                return [
                                    2,
                                    $bMcUu.getTransactionLastResult(rawResult)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Contract;
}();
module.exports.Contract = $d01a61128598fc80$var$Contract;
/**
 * Validation on arguments being a big number from bn.js
 * Throws if an argument is not in BN format or otherwise invalid
 * @param argMap
 */ function $d01a61128598fc80$var$validateBNLike(argMap) {
    var bnLike = "number, decimal string or BN";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(argMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var argName = _step.value;
            var argValue = argMap[argName];
            if (argValue && !$d01a61128598fc80$var$bn_js_1.default.isBN(argValue) && isNaN(argValue)) throw new $6vXKs.ArgumentTypeError(argName, bnLike, argValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});

parcelRequire.register("kowPj", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
var $ed8f8333a0f0cd0f$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Near = void 0;

/**
 * This module contains the main class developers will use to interact with NEAR.
 * The {@link Near} class is used to interact with {@link Account | Accounts} through the {@link JsonRpcProvider.JsonRpcProvider | JsonRpcProvider}.
 * It is configured via the {@link NearConfig}.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#account}
 *
 * @module near
 */ var $ed8f8333a0f0cd0f$var$bn_js_1 = $ed8f8333a0f0cd0f$var$__importDefault((parcelRequire("jkm5c")));

var $gXWlL = parcelRequire("gXWlL");

var $5YbZv = parcelRequire("5YbZv");

var $hRJ6X = parcelRequire("hRJ6X");

var $g5374 = parcelRequire("g5374");
/**
 * This is the main class developers should use to interact with NEAR.
 * @example
 * ```js
 * const near = new Near(config);
 * ```
 */ var $ed8f8333a0f0cd0f$var$Near = /*#__PURE__*/ function() {
    function Near(config) {
        (0, $978gY._)(this, Near);
        this.config = config;
        this.connection = $5YbZv.Connection.fromConfig({
            networkId: config.networkId,
            provider: {
                type: "JsonRpcProvider",
                args: {
                    url: config.nodeUrl,
                    headers: config.headers
                }
            },
            signer: config.signer || {
                type: "InMemorySigner",
                keyStore: config.keyStore || config.deps.keyStore
            }
        });
        if (config.masterAccount) {
            // TODO: figure out better way of specifiying initial balance.
            // Hardcoded number below must be enough to pay the gas cost to dev-deploy with near-shell for multiple times
            var initialBalance = config.initialBalance ? new $ed8f8333a0f0cd0f$var$bn_js_1.default(config.initialBalance) : new $ed8f8333a0f0cd0f$var$bn_js_1.default("500000000000000000000000000");
            this.accountCreator = new $g5374.LocalAccountCreator(new $gXWlL.Account(this.connection, config.masterAccount), initialBalance);
        } else if (config.helperUrl) this.accountCreator = new $g5374.UrlAccountCreator(this.connection, config.helperUrl);
        else this.accountCreator = null;
    }
    (0, $kry2a._)(Near, [
        {
            key: "account",
            value: /**
     * @param accountId near accountId used to interact with the network.
     */ function account(accountId) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var account;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        account = new $gXWlL.Account(_this.connection, accountId);
                        return [
                            2,
                            account
                        ];
                    });
                })();
            }
        },
        {
            key: "createAccount",
            value: /**
     * Create an account using the {@link AccountCreator}. Either:
     * * using a masterAccount with {@link LocalAccountCreator}
     * * using the helperUrl with {@link UrlAccountCreator}
     * @see {@link NearConfig.masterAccount} and {@link NearConfig.helperUrl}-
     *
     * @param accountId
     * @param publicKey
     */ function createAccount(accountId, publicKey) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.accountCreator) throw new Error("Must specify account creator, either via masterAccount or helperUrl configuration settings.");
                                return [
                                    4,
                                    _this.accountCreator.createAccount(accountId, publicKey)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    new $gXWlL.Account(_this.connection, accountId)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadContract",
            value: /**
     * @deprecated Use {@link Contract} instead.
     * @param contractId
     * @param options
     */ function loadContract(contractId, options) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var account;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        account = new $gXWlL.Account(_this.connection, options.sender);
                        return [
                            2,
                            new $hRJ6X.Contract(account, contractId, options)
                        ];
                    });
                })();
            }
        },
        {
            key: "sendTokens",
            value: /**
     * @deprecated Use {@link Account.sendMoney} instead.
     * @param amount
     * @param originator
     * @param receiver
     */ function sendTokens(amount, originator, receiver) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var account, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.warn("near.sendTokens is deprecated. Use `yourAccount.sendMoney` instead.");
                                account = new $gXWlL.Account(_this.connection, originator);
                                return [
                                    4,
                                    account.sendMoney(receiver, amount)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.transaction_outcome.id
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Near;
}();
module.exports.Near = $ed8f8333a0f0cd0f$var$Near;

});

parcelRequire.register("k3l4B", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $gzLuY = parcelRequire("gzLuY");
var $e9946f30836d12d1$require$Buffer = $gzLuY.Buffer;
"use strict";
var $e9946f30836d12d1$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectedWalletAccount = module.exports.WalletAccount = module.exports.WalletConnection = void 0;

/**
 * The classes in this module are used in conjunction with the {@link BrowserLocalStorageKeyStore}. This module exposes two classes:
 * * {@link WalletConnection} which redirects users to {@link https://docs.near.org/docs/tools/near-wallet | NEAR Wallet} for key management.
 * * {@link ConnectedWalletAccount} is an {@link Account} implementation that uses {@link WalletConnection} to get keys
 *
 * @module walletAccount
 */ var $e9946f30836d12d1$var$depd_1 = $e9946f30836d12d1$var$__importDefault((parcelRequire("7kbiF")));

var $gXWlL = parcelRequire("gXWlL");

var $7cM39 = parcelRequire("7cM39");

var $jSV3x = parcelRequire("jSV3x");

var $2HPkT = parcelRequire("2HPkT");

var $2HPkT = parcelRequire("2HPkT");
var $e9946f30836d12d1$var$LOGIN_WALLET_URL_SUFFIX = "/login/";
var $e9946f30836d12d1$var$MULTISIG_HAS_METHOD = "add_request_and_confirm";
var $e9946f30836d12d1$var$LOCAL_STORAGE_KEY_SUFFIX = "_wallet_auth_key";
var $e9946f30836d12d1$var$PENDING_ACCESS_KEY_PREFIX = "pending_key"; // browser storage key for a pending access key (i.e. key has been generated but we are not sure it was added yet)
/**
 * This class is used in conjunction with the {@link BrowserLocalStorageKeyStore}.
 * It redirects users to {@link https://docs.near.org/docs/tools/near-wallet | NEAR Wallet} for key management.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#wallet}
 * @example
 * ```js
 * // create new WalletConnection instance
 * const wallet = new WalletConnection(near, 'my-app');
 *
 * // If not signed in redirect to the NEAR wallet to sign in
 * // keys will be stored in the BrowserLocalStorageKeyStore
 * if(!wallet.isSingnedIn()) return wallet.requestSignIn()
 * ```
 */ var $e9946f30836d12d1$var$WalletConnection = /*#__PURE__*/ function() {
    "use strict";
    function WalletConnection(near, appKeyPrefix) {
        (0, $978gY._)(this, WalletConnection);
        this._near = near;
        var authDataKey = appKeyPrefix + $e9946f30836d12d1$var$LOCAL_STORAGE_KEY_SUFFIX;
        var authData = JSON.parse(window.localStorage.getItem(authDataKey));
        this._networkId = near.config.networkId;
        this._walletBaseUrl = near.config.walletUrl;
        appKeyPrefix = appKeyPrefix || near.config.contractName || "default";
        this._keyStore = near.connection.signer.keyStore;
        this._authData = authData || {
            allKeys: []
        };
        this._authDataKey = authDataKey;
        if (!this.isSignedIn()) this._completeSignInWithAccessKey();
    }
    (0, $kry2a._)(WalletConnection, [
        {
            /**
     * Returns true, if this WalletAccount is authorized with the wallet.
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.isSignedIn();
     * ```
     */ key: "isSignedIn",
            value: function isSignedIn() {
                return !!this._authData.accountId;
            }
        },
        {
            /**
     * Returns authorized Account ID.
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.getAccountId();
     * ```
     */ key: "getAccountId",
            value: function getAccountId() {
                return this._authData.accountId || "";
            }
        },
        {
            key: "requestSignIn",
            value: /**
     * Redirects current page to the wallet authentication page.
     * @param options An optional options object
     * @param options.contractId The NEAR account where the contract is deployed
     * @param options.successUrl URL to redirect upon success. Default: current url
     * @param options.failureUrl URL to redirect upon failure. Default: current url
     *
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * // redirects to the NEAR Wallet
     * wallet.requestSignIn({ contractId: 'account-with-deploy-contract.near' });
     * ```
     */ function requestSignIn() {
                var contractIdOrOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, title = arguments.length > 1 ? arguments[1] : void 0, successUrl = arguments.length > 2 ? arguments[2] : void 0, failureUrl = arguments.length > 3 ? arguments[3] : void 0;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var options, deprecate, currentUrl, newUrl, contractAccount, accessKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof contractIdOrOptions === "string") {
                                    deprecate = $e9946f30836d12d1$var$depd_1.default("requestSignIn(contractId, title)");
                                    deprecate("`title` ignored; use `requestSignIn({ contractId, methodNames, successUrl, failureUrl })` instead");
                                    options = {
                                        contractId: contractIdOrOptions,
                                        successUrl: successUrl,
                                        failureUrl: failureUrl
                                    };
                                } else options = contractIdOrOptions;
                                currentUrl = new URL(window.location.href);
                                newUrl = new URL(_this._walletBaseUrl + $e9946f30836d12d1$var$LOGIN_WALLET_URL_SUFFIX);
                                newUrl.searchParams.set("success_url", options.successUrl || currentUrl.href);
                                newUrl.searchParams.set("failure_url", options.failureUrl || currentUrl.href);
                                if (!options.contractId) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._near.account(options.contractId)
                                ];
                            case 1:
                                contractAccount = _state.sent();
                                return [
                                    4,
                                    contractAccount.state()
                                ];
                            case 2:
                                _state.sent();
                                newUrl.searchParams.set("contract_id", options.contractId);
                                accessKey = $jSV3x.KeyPair.fromRandom("ed25519");
                                newUrl.searchParams.set("public_key", accessKey.getPublicKey().toString());
                                return [
                                    4,
                                    _this._keyStore.setKey(_this._networkId, $e9946f30836d12d1$var$PENDING_ACCESS_KEY_PREFIX + accessKey.getPublicKey(), accessKey)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                if (options.methodNames) options.methodNames.forEach(function(methodName) {
                                    newUrl.searchParams.append("methodNames", methodName);
                                });
                                window.location.assign(newUrl.toString());
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestSignTransactions",
            value: function requestSignTransactions() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                return (0, $byzP8._)(function() {
                    var deprecate;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (Array.isArray(args[0])) {
                            deprecate = $e9946f30836d12d1$var$depd_1.default("WalletConnection.requestSignTransactions(transactions, callbackUrl, meta)");
                            deprecate("use `WalletConnection.requestSignTransactions(RequestSignTransactionsOptions)` instead");
                            return [
                                2,
                                _this._requestSignTransactions({
                                    transactions: args[0],
                                    callbackUrl: args[1],
                                    meta: args[2]
                                })
                            ];
                        }
                        return [
                            2,
                            _this._requestSignTransactions(args[0])
                        ];
                    });
                })();
            }
        },
        {
            key: "_requestSignTransactions",
            value: function _requestSignTransactions(param) {
                var transactions = param.transactions, meta = param.meta, callbackUrl = param.callbackUrl;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var currentUrl, newUrl;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        currentUrl = new URL(window.location.href);
                        newUrl = new URL("sign", _this._walletBaseUrl);
                        newUrl.searchParams.set("transactions", transactions.map(function(transaction) {
                            return $2HPkT.serialize($7cM39.SCHEMA, transaction);
                        }).map(function(serialized) {
                            return $e9946f30836d12d1$require$Buffer.from(serialized).toString("base64");
                        }).join(","));
                        newUrl.searchParams.set("callbackUrl", callbackUrl || currentUrl.href);
                        if (meta) newUrl.searchParams.set("meta", meta);
                        window.location.assign(newUrl.toString());
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_completeSignInWithAccessKey",
            value: /**
     * @hidden
     * Complete sign in for a given account id and public key. To be invoked by the app when getting a callback from the wallet.
     */ function _completeSignInWithAccessKey() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var currentUrl, publicKey, allKeys, accountId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                currentUrl = new URL(window.location.href);
                                publicKey = currentUrl.searchParams.get("public_key") || "";
                                allKeys = (currentUrl.searchParams.get("all_keys") || "").split(",");
                                accountId = currentUrl.searchParams.get("account_id") || "";
                                if (!accountId) return [
                                    3,
                                    2
                                ];
                                _this._authData = {
                                    accountId: accountId,
                                    allKeys: allKeys
                                };
                                window.localStorage.setItem(_this._authDataKey, JSON.stringify(_this._authData));
                                if (!publicKey) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._moveKeyFromTempToPermanent(accountId, publicKey)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                currentUrl.searchParams.delete("public_key");
                                currentUrl.searchParams.delete("all_keys");
                                currentUrl.searchParams.delete("account_id");
                                currentUrl.searchParams.delete("meta");
                                currentUrl.searchParams.delete("transactionHashes");
                                window.history.replaceState({}, document.title, currentUrl.toString());
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_moveKeyFromTempToPermanent",
            value: /**
     * @hidden
     * @param accountId The NEAR account owning the given public key
     * @param publicKey The public key being set to the key store
     */ function _moveKeyFromTempToPermanent(accountId, publicKey) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var keyPair;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._keyStore.getKey(_this._networkId, $e9946f30836d12d1$var$PENDING_ACCESS_KEY_PREFIX + publicKey)
                                ];
                            case 1:
                                keyPair = _state.sent();
                                return [
                                    4,
                                    _this._keyStore.setKey(_this._networkId, accountId, keyPair)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this._keyStore.removeKey(_this._networkId, $e9946f30836d12d1$var$PENDING_ACCESS_KEY_PREFIX + publicKey)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Sign out from the current account
     * @example
     * walletAccount.signOut();
     */ key: "signOut",
            value: function signOut() {
                this._authData = {};
                window.localStorage.removeItem(this._authDataKey);
            }
        },
        {
            /**
     * Returns the current connected wallet account
     */ key: "account",
            value: function account() {
                if (!this._connectedAccount) this._connectedAccount = new $e9946f30836d12d1$var$ConnectedWalletAccount(this, this._near.connection, this._authData.accountId);
                return this._connectedAccount;
            }
        }
    ]);
    return WalletConnection;
}();
module.exports.WalletConnection = $e9946f30836d12d1$var$WalletConnection;
module.exports.WalletAccount = $e9946f30836d12d1$var$WalletConnection;
/**
 * {@link Account} implementation which redirects to wallet using {@link WalletConnection} when no local key is available.
 */ var $e9946f30836d12d1$var$ConnectedWalletAccount = /*#__PURE__*/ function(_account_1_Account) {
    "use strict";
    (0, $ftJVG._)(ConnectedWalletAccount, _account_1_Account);
    var _super = (0, $6OZAO._)(ConnectedWalletAccount);
    function ConnectedWalletAccount(walletConnection, connection, accountId) {
        (0, $978gY._)(this, ConnectedWalletAccount);
        var _this;
        _this = _super.call(this, connection, accountId);
        _this.walletConnection = walletConnection;
        return _this;
    }
    (0, $kry2a._)(ConnectedWalletAccount, [
        {
            // Overriding Account methods
            /**
     * Sign a transaction by redirecting to the NEAR Wallet
     * @see {@link WalletConnection.requestSignTransactions}
     */ key: "signAndSendTransaction",
            value: function signAndSendTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (typeof args[0] === "string") return this._signAndSendTransaction({
                    receiverId: args[0],
                    actions: args[1]
                });
                return this._signAndSendTransaction(args[0]);
            }
        },
        {
            key: "_signAndSendTransaction",
            value: function _signAndSendTransaction(param) {
                var receiverId = param.receiverId, actions = param.actions, walletMeta = param.walletMeta, _param_walletCallbackUrl = param.walletCallbackUrl, walletCallbackUrl = _param_walletCallbackUrl === void 0 ? window.location.href : _param_walletCallbackUrl;
                var _this = this;
                var _this1 = this, _superprop_get_signAndSendTransaction = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(ConnectedWalletAccount.prototype), "signAndSendTransaction", _this);
                };
                return (0, $byzP8._)(function() {
                    var localKey, accessKey, e, block, blockHash, publicKey, nonce, transaction;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this1.connection.signer.getPublicKey(_this1.accountId, _this1.connection.networkId)
                                ];
                            case 1:
                                localKey = _state.sent();
                                return [
                                    4,
                                    _this1.accessKeyForTransaction(receiverId, actions, localKey)
                                ];
                            case 2:
                                accessKey = _state.sent();
                                if (!accessKey) throw new Error("Cannot find matching key for transaction sent to ".concat(receiverId));
                                if (!(localKey && localKey.toString() === accessKey.public_key)) return [
                                    3,
                                    9
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    _superprop_get_signAndSendTransaction().call(_this1, {
                                        receiverId: receiverId,
                                        actions: actions
                                    })
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                e = _state.sent();
                                if (!(e.type === "NotEnoughAllowance")) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this1.accessKeyForTransaction(receiverId, actions)
                                ];
                            case 6:
                                accessKey = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                throw e;
                            case 8:
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                return [
                                    4,
                                    _this1.connection.provider.block({
                                        finality: "final"
                                    })
                                ];
                            case 10:
                                block = _state.sent();
                                blockHash = $2HPkT.baseDecode(block.header.hash);
                                publicKey = $jSV3x.PublicKey.from(accessKey.public_key);
                                nonce = accessKey.access_key.nonce + 1;
                                transaction = $7cM39.createTransaction(_this1.accountId, publicKey, receiverId, nonce, actions, blockHash);
                                return [
                                    4,
                                    _this1.walletConnection.requestSignTransactions({
                                        transactions: [
                                            transaction
                                        ],
                                        meta: walletMeta,
                                        callbackUrl: walletCallbackUrl
                                    })
                                ];
                            case 11:
                                _state.sent();
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        setTimeout(function() {
                                            reject(new Error("Failed to redirect to sign transaction"));
                                        }, 1000);
                                    })
                                ];
                        }
                    });
                // TODO: Aggregate multiple transaction request with "debounce".
                // TODO: Introduce TrasactionQueue which also can be used to watch for status?
                })();
            }
        },
        {
            key: "accessKeyMatchesTransaction",
            value: /**
     * Check if given access key allows the function call or method attempted in transaction
     * @param accessKey Array of {access_key: AccessKey, public_key: PublicKey} items
     * @param receiverId The NEAR account attempting to have access
     * @param actions The action(s) needed to be checked for access
     */ function accessKeyMatchesTransaction(accessKey, receiverId, actions) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var permission, _permission_FunctionCall, allowedReceiverId, allowedMethods, _actions, functionCall;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        permission = accessKey.access_key.permission;
                        if (permission === "FullAccess") return [
                            2,
                            true
                        ];
                        if (permission.FunctionCall) {
                            _permission_FunctionCall = permission.FunctionCall, allowedReceiverId = _permission_FunctionCall.receiver_id, allowedMethods = _permission_FunctionCall.method_names;
                            /********************************
            Accept multisig access keys and let wallets attempt to signAndSendTransaction
            If an access key has itself as receiverId and method permission add_request_and_confirm, then it is being used in a wallet with multisig contract: https://github.com/near/core-contracts/blob/671c05f09abecabe7a7e58efe942550a35fc3292/multisig/src/lib.rs#L149-L153
            ********************************/ if (allowedReceiverId === _this.accountId && allowedMethods.includes($e9946f30836d12d1$var$MULTISIG_HAS_METHOD)) return [
                                2,
                                true
                            ];
                            if (allowedReceiverId === receiverId) {
                                if (actions.length !== 1) return [
                                    2,
                                    false
                                ];
                                _actions = (0, $8GFUW._)(actions, 1), functionCall = _actions[0].functionCall;
                                return [
                                    2,
                                    functionCall && (!functionCall.deposit || functionCall.deposit.toString() === "0") && // TODO: Should support charging amount smaller than allowance?
                                    (allowedMethods.length === 0 || allowedMethods.includes(functionCall.methodName))
                                ];
                            // TODO: Handle cases when allowance doesn't have enough to pay for gas
                            }
                        }
                        // TODO: Support other permissions than FunctionCall
                        return [
                            2,
                            false
                        ];
                    });
                })();
            }
        },
        {
            key: "accessKeyForTransaction",
            value: /**
     * Helper function returning the access key (if it exists) to the receiver that grants the designated permission
     * @param receiverId The NEAR account seeking the access key for a transaction
     * @param actions The action(s) sought to gain access to
     * @param localKey A local public key provided to check for access
     * @returns Promise<any>
     */ function accessKeyForTransaction(receiverId, actions, localKey) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var accessKeys, accessKey, _tmp, walletKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, accessKey1, _tmp1, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccessKeys()
                                ];
                            case 1:
                                accessKeys = _state.sent();
                                if (!localKey) return [
                                    3,
                                    4
                                ];
                                accessKey = accessKeys.find(function(key) {
                                    return key.public_key.toString() === localKey.toString();
                                });
                                _tmp = accessKey;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.accessKeyMatchesTransaction(accessKey, receiverId, actions)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                if (_tmp) return [
                                    2,
                                    accessKey
                                ];
                                _state.label = 4;
                            case 4:
                                walletKeys = _this.walletConnection._authData.allKeys;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    11,
                                    12,
                                    13
                                ]);
                                _iterator = accessKeys[Symbol.iterator]();
                                _state.label = 6;
                            case 6:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    10
                                ];
                                accessKey1 = _step.value;
                                _tmp1 = walletKeys.indexOf(accessKey1.public_key) !== -1;
                                if (!_tmp1) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    _this.accessKeyMatchesTransaction(accessKey1, receiverId, actions)
                                ];
                            case 7:
                                _tmp1 = _state.sent();
                                _state.label = 8;
                            case 8:
                                if (_tmp1) return [
                                    2,
                                    accessKey1
                                ];
                                _state.label = 9;
                            case 9:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    6
                                ];
                            case 10:
                                return [
                                    3,
                                    13
                                ];
                            case 11:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ConnectedWalletAccount;
}($gXWlL.Account);
module.exports.ConnectedWalletAccount = $e9946f30836d12d1$var$ConnectedWalletAccount;

});


parcelRequire.register("85znT", function(module, exports) {

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connect = void 0;

var $kowPj = parcelRequire("kowPj");
function $5e3a3cf58e7156e5$var$connect(config) {
    return $5e3a3cf58e7156e5$var$_connect.apply(this, arguments);
}
function $5e3a3cf58e7156e5$var$_connect() {
    $5e3a3cf58e7156e5$var$_connect = /**
 * Initialize connection to Near network.
 */ (0, $byzP8._)(function(config) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                new $kowPj.Near(config)
            ];
        });
    });
    return $5e3a3cf58e7156e5$var$_connect.apply(this, arguments);
}
module.exports.connect = $5e3a3cf58e7156e5$var$connect;

});

parcelRequire.register("fU2q1", function(module, exports) {
parcelRequire("daRlP");

var $hBCvE = parcelRequire("hBCvE");
var $b93df64d209c7239$var$polyfill;



if ($hBCvE("Error.captureStackTrace")) $b93df64d209c7239$var$polyfill = (parcelRequire("1dl9C"));
else if ($hBCvE("Error.prototype.stack")) $b93df64d209c7239$var$polyfill = (parcelRequire("biTSf"));
else $b93df64d209c7239$var$polyfill = (parcelRequire("kNTt5"));
module.exports = $b93df64d209c7239$var$polyfill();

});
parcelRequire.register("daRlP", function(module, exports) {

(parcelRequire("hBCvE")).check("es5");

});
parcelRequire.register("hBCvE", function(module, exports) {
parcelRequire("cHQrq");

module.exports = (parcelRequire("bzjnC"));

});
parcelRequire.register("cHQrq", function(module, exports) {

var $bzjnC = parcelRequire("bzjnC");
var $94022df666cbff93$var$define = $bzjnC.define, $94022df666cbff93$var$test = $bzjnC.test;
$94022df666cbff93$var$define("strict mode", function() {
    return this === undefined;
});
$94022df666cbff93$var$define("arguments.callee.caller", function() {
    try {
        return function() {
            return arguments.callee.caller;
        }() === arguments.callee;
    } catch (strictModeIsEnforced) {
        return false;
    }
});
$94022df666cbff93$var$define("es5", function() {
    return $94022df666cbff93$var$test("Array.prototype.forEach") && $94022df666cbff93$var$test("Array.prototype.map") && $94022df666cbff93$var$test("Function.prototype.bind") && $94022df666cbff93$var$test("Object.create") && $94022df666cbff93$var$test("Object.defineProperties") && $94022df666cbff93$var$test("Object.defineProperty") && $94022df666cbff93$var$test("Object.prototype.hasOwnProperty");
});
$94022df666cbff93$var$define("Array.prototype.forEach", function() {
    return Array.prototype.forEach;
});
$94022df666cbff93$var$define("Array.prototype.map", function() {
    return Array.prototype.map;
});
$94022df666cbff93$var$define("Function.prototype.bind", function() {
    return Function.prototype.bind;
});
$94022df666cbff93$var$define("Object.create", function() {
    return Object.create;
});
$94022df666cbff93$var$define("Object.defineProperties", function() {
    return Object.defineProperties;
});
$94022df666cbff93$var$define("Object.defineProperty", function() {
    return Object.defineProperty;
});
$94022df666cbff93$var$define("Object.prototype.hasOwnProperty", function() {
    return Object.prototype.hasOwnProperty;
});
$94022df666cbff93$var$define("Error.captureStackTrace", function() {
    return Error.captureStackTrace;
});
$94022df666cbff93$var$define("Error.prototype.stack", function() {
    try {
        throw new Error();
    } catch (e) {
        return e.stack || e.stacktrace;
    }
});

});
parcelRequire.register("bzjnC", function(module, exports) {

var $1RBoH = parcelRequire("1RBoH");
var $86c1ff07fad7825b$var$detector = new $1RBoH();
var $86c1ff07fad7825b$var$capability = function capability(name) {
    return $86c1ff07fad7825b$var$detector.test(name);
};
$86c1ff07fad7825b$var$capability.define = function(name, test) {
    $86c1ff07fad7825b$var$detector.define(name, test);
};
$86c1ff07fad7825b$var$capability.check = function(name) {
    $86c1ff07fad7825b$var$detector.check(name);
};
$86c1ff07fad7825b$var$capability.test = $86c1ff07fad7825b$var$capability;
module.exports = $86c1ff07fad7825b$var$capability;

});
parcelRequire.register("1RBoH", function(module, exports) {
var $15b7c00488c6008e$var$CapabilityDetector = function CapabilityDetector() {
    this.tests = {};
    this.cache = {};
};
$15b7c00488c6008e$var$CapabilityDetector.prototype = {
    constructor: $15b7c00488c6008e$var$CapabilityDetector,
    define: function define(name, test) {
        if (typeof name != "string" || !(test instanceof Function)) throw new Error("Invalid capability definition.");
        if (this.tests[name]) throw new Error('Duplicated capability definition by "' + name + '".');
        this.tests[name] = test;
    },
    check: function check(name) {
        if (!this.test(name)) throw new Error('The current environment does not support "' + name + '", therefore we cannot continue.');
    },
    test: function test(name) {
        if (this.cache[name] !== undefined) return this.cache[name];
        if (!this.tests[name]) throw new Error('Unknown capability with name "' + name + '".');
        var test = this.tests[name];
        this.cache[name] = !!test();
        return this.cache[name];
    }
};
module.exports = $15b7c00488c6008e$var$CapabilityDetector;

});





parcelRequire.register("1dl9C", function(module, exports) {

var $eJSga = parcelRequire("eJSga");
module.exports = function() {
    Error.getStackTrace = function(throwable) {
        return throwable.stack;
    };
    return {
        prepareStackTrace: $eJSga
    };
};

});
parcelRequire.register("eJSga", function(module, exports) {
var $abaf5b87207231d1$var$prepareStackTrace = function prepareStackTrace(throwable, frames, warnings) {
    var string = "";
    string += throwable.name || "Error";
    string += ": " + (throwable.message || "");
    if (warnings instanceof Array) for(var warningIndex in warnings){
        var warning = warnings[warningIndex];
        string += "\n   # " + warning;
    }
    for(var frameIndex in frames){
        var frame = frames[frameIndex];
        string += "\n   at " + frame.toString();
    }
    return string;
};
module.exports = $abaf5b87207231d1$var$prepareStackTrace;

});


parcelRequire.register("biTSf", function(module, exports) {

var $5G1Xa = parcelRequire("5G1Xa");

var $g1nxr = parcelRequire("g1nxr");

var $5yr8C = parcelRequire("5yr8C");
var $83acb78bf9e33919$require$cache = $5yr8C.cache;

var $eJSga = parcelRequire("eJSga");
module.exports = function() {
    Error.captureStackTrace = function captureStackTrace(throwable, terminator) {
        var warnings;
        var frameShifts = [
            captureStackTrace
        ];
        if (terminator) // additional frames can come here if arguments.callee.caller is supported
        // otherwise it is hard to identify the terminator
        frameShifts.push(terminator);
        var captured = $5G1Xa.getInstance().captureFrameStrings(frameShifts);
        Object.defineProperties(throwable, {
            stack: {
                configurable: true,
                get: $83acb78bf9e33919$require$cache(function() {
                    var frames = $g1nxr.getInstance().getFrames(captured.frameStrings, captured.functionValues);
                    return (Error.prepareStackTrace || $eJSga)(throwable, frames, warnings);
                })
            },
            cachedStack: {
                configurable: true,
                writable: true,
                enumerable: false,
                value: true
            }
        });
    };
    Error.getStackTrace = function(throwable) {
        if (throwable.cachedStack) return throwable.stack;
        var frameStrings = $5G1Xa.getInstance().getFrameStrings(throwable), frames = [], warnings;
        if (frameStrings) frames = $g1nxr.getInstance().getFrames(frameStrings, []);
        else warnings = [
            "The stack is not readable by unthrown errors in this environment."
        ];
        var stack = (Error.prepareStackTrace || $eJSga)(throwable, frames, warnings);
        if (frameStrings) try {
            Object.defineProperties(throwable, {
                stack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: stack
                },
                cachedStack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: true
                }
            });
        } catch (nonConfigurableError) {}
        return stack;
    };
    return {
        prepareStackTrace: $eJSga
    };
};

});
parcelRequire.register("5G1Xa", function(module, exports) {

var $90gMA = parcelRequire("90gMA");
var $422263e2a98c4969$require$Class = $90gMA.Class;

var $90gMA = parcelRequire("90gMA");
var $422263e2a98c4969$require$abstractMethod = $90gMA.abstractMethod;

var $5yr8C = parcelRequire("5yr8C");
var $422263e2a98c4969$require$eachCombination = $5yr8C.eachCombination;

var $5yr8C = parcelRequire("5yr8C");
var $422263e2a98c4969$require$cache = $5yr8C.cache;

var $hBCvE = parcelRequire("hBCvE");
var $422263e2a98c4969$var$AbstractFrameStringSource = $422263e2a98c4969$require$Class(Object, {
    prototype: {
        captureFrameStrings: function captureFrameStrings(frameShifts) {
            var error = this.createError();
            frameShifts.unshift(this.captureFrameStrings);
            frameShifts.unshift(this.createError);
            var capturedFrameStrings = this.getFrameStrings(error);
            var frameStrings = capturedFrameStrings.slice(frameShifts.length), functionValues = [];
            if ($hBCvE("arguments.callee.caller")) {
                var capturedFunctionValues = [
                    this.createError,
                    this.captureFrameStrings
                ];
                try {
                    var aCaller = arguments.callee;
                    while(aCaller = aCaller.caller)capturedFunctionValues.push(aCaller);
                } catch (useStrictError) {}
                functionValues = capturedFunctionValues.slice(frameShifts.length);
            }
            return {
                frameStrings: frameStrings,
                functionValues: functionValues
            };
        },
        getFrameStrings: function getFrameStrings(error) {
            var message = error.message || "";
            var name = error.name || "";
            var stackString = this.getStackString(error);
            if (stackString === undefined) return;
            var stackStringChunks = stackString.split("\n");
            var fromPosition = 0;
            var toPosition = stackStringChunks.length;
            if (this.hasHeader) fromPosition += name.split("\n").length + message.split("\n").length - 1;
            if (this.hasFooter) toPosition -= 1;
            return stackStringChunks.slice(fromPosition, toPosition);
        },
        createError: $422263e2a98c4969$require$abstractMethod,
        getStackString: $422263e2a98c4969$require$abstractMethod,
        hasHeader: undefined,
        hasFooter: undefined
    }
});
var $422263e2a98c4969$var$FrameStringSourceCalibrator = $422263e2a98c4969$require$Class(Object, {
    prototype: {
        calibrateClass: function calibrateClass(FrameStringSource) {
            return this.calibrateMethods(FrameStringSource) && this.calibrateEnvelope(FrameStringSource);
        },
        calibrateMethods: function calibrateMethods(FrameStringSource) {
            try {
                $422263e2a98c4969$require$eachCombination([
                    [
                        function(message) {
                            return new Error(message);
                        },
                        function(message) {
                            try {
                                throw new Error(message);
                            } catch (error) {
                                return error;
                            }
                        }
                    ],
                    [
                        function(error) {
                            return error.stack;
                        },
                        function(error) {
                            return error.stacktrace;
                        }
                    ]
                ], function(createError, getStackString) {
                    if (getStackString(createError())) throw {
                        getStackString: getStackString,
                        createError: createError
                    };
                });
            } catch (workingImplementation) {
                $422263e2a98c4969$require$Class.merge.call(FrameStringSource, {
                    prototype: workingImplementation
                });
                return true;
            }
            return false;
        },
        calibrateEnvelope: function calibrateEnvelope(FrameStringSource) {
            var getStackString = FrameStringSource.prototype.getStackString;
            var createError = FrameStringSource.prototype.createError;
            var calibratorStackString = getStackString(createError("marker"));
            var calibratorFrameStrings = calibratorStackString.split("\n");
            $422263e2a98c4969$require$Class.merge.call(FrameStringSource, {
                prototype: {
                    hasHeader: /marker/.test(calibratorFrameStrings[0]),
                    hasFooter: calibratorFrameStrings[calibratorFrameStrings.length - 1] === ""
                }
            });
            return true;
        }
    }
});
module.exports = {
    getClass: $422263e2a98c4969$require$cache(function() {
        var FrameStringSource;
        if (FrameStringSource) return FrameStringSource;
        FrameStringSource = $422263e2a98c4969$require$Class($422263e2a98c4969$var$AbstractFrameStringSource, {});
        var calibrator = new $422263e2a98c4969$var$FrameStringSourceCalibrator();
        if (!calibrator.calibrateClass(FrameStringSource)) throw new Error("Cannot read Error.prototype.stack in this environment.");
        return FrameStringSource;
    }),
    getInstance: $422263e2a98c4969$require$cache(function() {
        var FrameStringSource = this.getClass();
        var instance = new FrameStringSource();
        return instance;
    })
};

});
parcelRequire.register("90gMA", function(module, exports) {
parcelRequire("daRlP");

module.exports = (parcelRequire("2FQHe"));

});
parcelRequire.register("2FQHe", function(module, exports) {


module.exports = {
    Class: (parcelRequire("1VnWp")),
    abstractMethod: (parcelRequire("8D7RK"))
};

});
parcelRequire.register("1VnWp", function(module, exports) {
var $166daf7dced92725$var$Class = function Class1() {
    var checkOption = function checkOption(option) {
        var key = "config";
        if (option instanceof Function) key = "Source";
        else if (option instanceof Array) key = "buildArgs";
        else if (option instanceof Object) key = "config";
        else throw new Error("Invalid configuration option.");
        if (options.hasOwnProperty(key)) throw new Error("Duplicated configuration option: " + key + ".");
        options[key] = option;
    };
    var options = Object.create({
        Source: Object,
        config: {},
        buildArgs: []
    });
    for(var index = 0, length = arguments.length; index < length; ++index)checkOption(arguments[index]);
    var Source = options.Source, config = options.config, buildArgs = options.buildArgs;
    return (Source.extend || $166daf7dced92725$var$Class.extend).call(Source, config, buildArgs);
};
$166daf7dced92725$var$Class.factory = function() {
    var Source = this;
    return function() {
        var instance = this;
        if (instance.build instanceof Function) instance.build.apply(instance, arguments);
        if (instance.init instanceof Function) instance.init.apply(instance, arguments);
    };
};
$166daf7dced92725$var$Class.extend = function(config, buildArgs) {
    var Source = this;
    if (!config) config = {};
    var Subject;
    if (config.prototype instanceof Object && config.prototype.constructor !== Object) Subject = config.prototype.constructor;
    else if (config.factory instanceof Function) Subject = config.factory.call(Source);
    Subject = (Source.clone || $166daf7dced92725$var$Class.clone).call(Source, Subject, buildArgs);
    (Subject.merge || $166daf7dced92725$var$Class.merge).call(Subject, config);
    return Subject;
};
$166daf7dced92725$var$Class.prototype.extend = function(config, buildArgs) {
    var subject = this;
    var instance = (subject.clone || $166daf7dced92725$var$Class.prototype.clone).apply(subject, buildArgs);
    (instance.merge || $166daf7dced92725$var$Class.prototype.merge).call(instance, config);
    return instance;
};
$166daf7dced92725$var$Class.clone = function(Subject, buildArgs) {
    var Source = this;
    if (!(Subject instanceof Function)) Subject = (Source.factory || $166daf7dced92725$var$Class.factory).call(Source);
    Subject.prototype = (Source.prototype.clone || $166daf7dced92725$var$Class.prototype.clone).apply(Source.prototype, buildArgs || []);
    Subject.prototype.constructor = Subject;
    for(var staticProperty in Source)if (staticProperty !== "prototype") Subject[staticProperty] = Source[staticProperty];
    return Subject;
};
$166daf7dced92725$var$Class.prototype.clone = function() {
    var subject = this;
    var instance = Object.create(subject);
    if (instance.build instanceof Function) instance.build.apply(instance, arguments);
    return instance;
};
$166daf7dced92725$var$Class.merge = function(config) {
    var Subject = this;
    for(var staticProperty in config)if (staticProperty !== "prototype") Subject[staticProperty] = config[staticProperty];
    if (config.prototype instanceof Object) (Subject.prototype.merge || $166daf7dced92725$var$Class.prototype.merge).call(Subject.prototype, config.prototype);
    return Subject;
};
$166daf7dced92725$var$Class.prototype.merge = function(config) {
    var subject = this;
    for(var property in config)if (property !== "constructor") subject[property] = config[property];
    return subject;
};
$166daf7dced92725$var$Class.absorb = function(config) {
    var Subject = this;
    for(var staticProperty in config)if (staticProperty !== "prototype" && (Subject[staticProperty] === undefined || Subject[staticProperty] === Function.prototype[staticProperty])) Subject[staticProperty] = config[staticProperty];
    if (config.prototype instanceof Object) (Subject.prototype.absorb || $166daf7dced92725$var$Class.prototype.absorb).call(Subject.prototype, config.prototype);
    return Subject;
};
$166daf7dced92725$var$Class.prototype.absorb = function(config) {
    var subject = this;
    for(var property in config)if (property !== "constructor" && (subject[property] === undefined || subject[property] === Object.prototype[property])) subject[property] = config[property];
    return subject;
};
$166daf7dced92725$var$Class.getAncestor = function() {
    var Source = this;
    if (Source !== Source.prototype.constructor) return Source.prototype.constructor;
};
$166daf7dced92725$var$Class.newInstance = function() {
    var Subject = this;
    var instance = Object.create(this.prototype);
    Subject.apply(instance, arguments);
    return instance;
};
module.exports = $166daf7dced92725$var$Class;

});

parcelRequire.register("8D7RK", function(module, exports) {
module.exports = function() {
    throw new Error("Not implemented.");
};

});



parcelRequire.register("5yr8C", function(module, exports) {

module.exports = (parcelRequire("1G303"));

});
parcelRequire.register("1G303", function(module, exports) {


module.exports = {
    cache: (parcelRequire("2YAee")),
    eachCombination: (parcelRequire("218bB"))
};

});
parcelRequire.register("2YAee", function(module, exports) {
var $22ad499cb64dc167$var$cache = function cache(fn) {
    var called = false, store;
    if (!(fn instanceof Function)) {
        called = true;
        store = fn;
        fn = null;
    }
    return function() {
        if (!called) {
            called = true;
            store = fn.apply(this, arguments);
            fn = null;
        }
        return store;
    };
};
module.exports = $22ad499cb64dc167$var$cache;

});

parcelRequire.register("218bB", function(module, exports) {
module.exports = function eachCombination(alternativesByDimension, callback, combination) {
    if (!combination) combination = [];
    if (combination.length < alternativesByDimension.length) {
        var alternatives = alternativesByDimension[combination.length];
        for(var index in alternatives){
            combination[combination.length] = alternatives[index];
            eachCombination(alternativesByDimension, callback, combination);
            --combination.length;
        }
    } else callback.apply(null, combination);
};

});




parcelRequire.register("g1nxr", function(module, exports) {

var $90gMA = parcelRequire("90gMA");
var $ba9eff954bb88784$require$Class = $90gMA.Class;

var $5suK2 = parcelRequire("5suK2");

var $5yr8C = parcelRequire("5yr8C");
var $ba9eff954bb88784$require$cache = $5yr8C.cache;
var $ba9eff954bb88784$var$FrameStringParser = $ba9eff954bb88784$require$Class(Object, {
    prototype: {
        stackParser: null,
        frameParser: null,
        locationParsers: null,
        constructor: function constructor(options) {
            $ba9eff954bb88784$require$Class.prototype.merge.call(this, options);
        },
        getFrames: function getFrames(frameStrings, functionValues) {
            var frames = [];
            for(var index = 0, length = frameStrings.length; index < length; ++index)frames[index] = this.getFrame(frameStrings[index], functionValues[index]);
            return frames;
        },
        getFrame: function getFrame(frameString, functionValue) {
            var config = {
                frameString: frameString,
                functionValue: functionValue
            };
            return new $5suK2(config);
        }
    }
});
module.exports = {
    getClass: $ba9eff954bb88784$require$cache(function() {
        return $ba9eff954bb88784$var$FrameStringParser;
    }),
    getInstance: $ba9eff954bb88784$require$cache(function() {
        var FrameStringParser = this.getClass();
        var instance = new FrameStringParser();
        return instance;
    })
};

});
parcelRequire.register("5suK2", function(module, exports) {

var $90gMA = parcelRequire("90gMA");
var $3f9769ece0bba67b$require$Class = $90gMA.Class;

var $90gMA = parcelRequire("90gMA");
var $3f9769ece0bba67b$require$abstractMethod = $90gMA.abstractMethod;
var $3f9769ece0bba67b$var$Frame = $3f9769ece0bba67b$require$Class(Object, {
    prototype: {
        init: $3f9769ece0bba67b$require$Class.prototype.merge,
        frameString: undefined,
        toString: function toString() {
            return this.frameString;
        },
        functionValue: undefined,
        getThis: $3f9769ece0bba67b$require$abstractMethod,
        getTypeName: $3f9769ece0bba67b$require$abstractMethod,
        getFunction: function getFunction() {
            return this.functionValue;
        },
        getFunctionName: $3f9769ece0bba67b$require$abstractMethod,
        getMethodName: $3f9769ece0bba67b$require$abstractMethod,
        getFileName: $3f9769ece0bba67b$require$abstractMethod,
        getLineNumber: $3f9769ece0bba67b$require$abstractMethod,
        getColumnNumber: $3f9769ece0bba67b$require$abstractMethod,
        getEvalOrigin: $3f9769ece0bba67b$require$abstractMethod,
        isTopLevel: $3f9769ece0bba67b$require$abstractMethod,
        isEval: $3f9769ece0bba67b$require$abstractMethod,
        isNative: $3f9769ece0bba67b$require$abstractMethod,
        isConstructor: $3f9769ece0bba67b$require$abstractMethod
    }
});
module.exports = $3f9769ece0bba67b$var$Frame;

});



parcelRequire.register("kNTt5", function(module, exports) {

var $5yr8C = parcelRequire("5yr8C");
var $f253690cc23196d3$require$cache = $5yr8C.cache;

var $eJSga = parcelRequire("eJSga");
module.exports = function() {
    Error.captureStackTrace = function(throwable, terminator) {
        Object.defineProperties(throwable, {
            stack: {
                configurable: true,
                get: $f253690cc23196d3$require$cache(function() {
                    return (Error.prepareStackTrace || $eJSga)(throwable, []);
                })
            },
            cachedStack: {
                configurable: true,
                writable: true,
                enumerable: false,
                value: true
            }
        });
    };
    Error.getStackTrace = function(throwable) {
        if (throwable.cachedStack) return throwable.stack;
        var stack = (Error.prepareStackTrace || $eJSga)(throwable, []);
        try {
            Object.defineProperties(throwable, {
                stack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: stack
                },
                cachedStack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: true
                }
            });
        } catch (nonConfigurableError) {}
        return stack;
    };
    return {
        prepareStackTrace: $eJSga
    };
};

});


// React

var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");
var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));


parcelRequire("6cds3");
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));



var $8GFUW = parcelRequire("8GFUW");

var $3a13c4050bc50495$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a13c4050bc50495$var$runtime = function(exports) {
    "use strict";
    var define = function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    };
    var wrap = function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    };
    var tryCatch = // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    };
    var Generator = // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var defineIteratorMethods = // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    };
    var AsyncIterator = function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    };
    var makeInvokeMethod = function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    };
    var pushTryEntry = function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    };
    var resetTryEntry = function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    };
    var Context = function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    };
    var values = function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    };
    var doneResult = function doneResult() {
        return {
            value: undefined,
            done: true
        };
    };
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    exports.wrap = wrap;
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    exports.values = values;
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            var handle = function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            };
            if (this.done) throw exception;
            var context = this;
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $3a13c4050bc50495$exports));
try {
    regeneratorRuntime = $3a13c4050bc50495$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $3a13c4050bc50495$var$runtime;
    else Function("r", "regeneratorRuntime = r")($3a13c4050bc50495$var$runtime);
}



var $6cds3 = parcelRequire("6cds3");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");
function $a6876eae976b1234$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $c4006311849aa271$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $a6876eae976b1234$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");



var $6cds3 = parcelRequire("6cds3");

var $8OnJk = parcelRequire("8OnJk");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");
function $9c3c5e85872c2b24$export$2e2bcd8739ae039() {
    $9c3c5e85872c2b24$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c3c5e85872c2b24$export$2e2bcd8739ae039.apply(this, arguments);
}



var $6cds3 = parcelRequire("6cds3");

function $8abce7d05baac96b$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.checkForDefaultPrevented, checkForDefaultPrevented = tmp === void 0 ? true : tmp;
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $becf66aa9c19994c$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $becf66aa9c19994c$export$43e446d32b3d21af() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        return refs.forEach(function(ref) {
            return $becf66aa9c19994c$var$$6ed0406888f73fc4$var$setRef(ref, node);
        });
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $becf66aa9c19994c$export$c7b2cbe3552a0d05() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $6cds3.useCallback)($becf66aa9c19994c$export$43e446d32b3d21af.apply(void 0, (0, $fLnyw._)(refs)), refs);
}



var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");


var $8GFUW = parcelRequire("8GFUW");

var $6cds3 = parcelRequire("6cds3");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
function $ac20025c1aee149a$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    var Provider = function Provider(props) {
        var children = props.children, context = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
            "children"
        ]); // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var value = (0, $6cds3.useMemo)(function() {
            return context;
        }, Object.values(context));
        return /*#__PURE__*/ (0, $6cds3.createElement)(Context.Provider, {
            value: value
        }, children);
    };
    var useContext = function useContext(consumerName) {
        var context = (0, $6cds3.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    };
    var Context = /*#__PURE__*/ (0, $6cds3.createContext)(defaultContext);
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $ac20025c1aee149a$export$50c7b4e9d9f19c1(scopeName) {
    var createContextScopeDeps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var $c512c27ab02ef895$export$fd42f52fd3ae1109 = /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        var BaseContext = /*#__PURE__*/ (0, $6cds3.createContext)(defaultContext);
        var index = defaultContexts.length;
        defaultContexts = (0, $fLnyw._)(defaultContexts).concat([
            defaultContext
        ]);
        function Provider(props) {
            var scope = props.scope, children = props.children, context = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
                "scope",
                "children"
            ]);
            var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            var value = (0, $6cds3.useMemo)(function() {
                return context;
            }, Object.values(context));
            return /*#__PURE__*/ (0, $6cds3.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            var context = (0, $6cds3.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    };
    var defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ var createScope = function() {
        var scopeContexts = defaultContexts.map(function(defaultContext) {
            return /*#__PURE__*/ (0, $6cds3.createContext)(defaultContext);
        });
        return function useScope(scope) {
            var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $6cds3.useMemo)(function() {
                return (0, $dxWQo._)({}, "__scope".concat(scopeName), (0, $8E768._)((0, $8OnJk._)({}, scope), (0, $dxWQo._)({}, scopeName, contexts)));
            }, [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $ac20025c1aee149a$var$$c512c27ab02ef895$var$composeContextScopes.apply(void 0, [
            createScope
        ].concat((0, $fLnyw._)(createContextScopeDeps)))
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $ac20025c1aee149a$var$$c512c27ab02ef895$var$composeContextScopes() {
    for(var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++){
        scopes[_key] = arguments[_key];
    }
    var baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    var createScope1 = function() {
        var scopeHooks = scopes.map(function(createScope) {
            return {
                useScope: createScope(),
                scopeName: createScope.scopeName
            };
        });
        return function useComposedScopes(overrideScopes) {
            var nextScopes1 = scopeHooks.reduce(function(nextScopes, param) {
                var useScope = param.useScope, scopeName = param.scopeName;
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                var scopeProps = useScope(overrideScopes);
                var currentScope = scopeProps["__scope".concat(scopeName)];
                return (0, $8OnJk._)({}, nextScopes, currentScope);
            }, {});
            return (0, $6cds3.useMemo)(function() {
                return (0, $dxWQo._)({}, "__scope".concat(baseScope.scopeName), nextScopes1);
            }, [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $fLnyw = parcelRequire("fLnyw");


var $6cds3 = parcelRequire("6cds3");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ var $513654131ef3bd4b$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var children = props.children, slotProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    var childrenArray = (0, $6cds3.Children).toArray(children);
    var slottable = childrenArray.find($513654131ef3bd4b$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        var newElement = slottable.props.children;
        var newChildren = childrenArray.map(function(child) {
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $6cds3.Children).count(newElement) > 1) return (0, $6cds3.Children).only(null);
                return /*#__PURE__*/ (0, $6cds3.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $6cds3.createElement)($513654131ef3bd4b$var$$5e63c961fc1ce211$var$SlotClone, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $6cds3.isValidElement)(newElement) ? /*#__PURE__*/ (0, $6cds3.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $6cds3.createElement)($513654131ef3bd4b$var$$5e63c961fc1ce211$var$SlotClone, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$513654131ef3bd4b$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ var $513654131ef3bd4b$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var children = props.children, slotProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    if (/*#__PURE__*/ (0, $6cds3.isValidElement)(children)) return /*#__PURE__*/ (0, $6cds3.cloneElement)(children, (0, $8E768._)((0, $8OnJk._)({}, $513654131ef3bd4b$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props)), {
        ref: forwardedRef ? (0, $becf66aa9c19994c$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    }));
    return (0, $6cds3.Children).count(children) > 1 ? (0, $6cds3.Children).only(null) : null;
});
$513654131ef3bd4b$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ var $513654131ef3bd4b$export$d9f1ccf0bdb05d45 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $6cds3.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $513654131ef3bd4b$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $6cds3.isValidElement)(child) && child.type === $513654131ef3bd4b$export$d9f1ccf0bdb05d45;
}
function $513654131ef3bd4b$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    var _loop = function(propName) {
        var slotPropValue = slotProps[propName];
        var childPropValue = childProps[propName];
        var isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                childPropValue.apply(void 0, (0, $fLnyw._)(args));
                slotPropValue.apply(void 0, (0, $fLnyw._)(args));
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = (0, $8OnJk._)({}, slotPropValue, childPropValue);
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    };
    // all child props should override
    var overrideProps = (0, $8OnJk._)({}, childProps);
    for(var propName in childProps)_loop(propName);
    return (0, $8OnJk._)({}, slotProps, overrideProps);
}
var $513654131ef3bd4b$export$be92b6f5f03c0fe9 = $513654131ef3bd4b$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $88a40bb64f7ba2d9$export$c74125a8e3af6bb2(name) {
    var useCollection = /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        var context = useCollectionContext(name + "CollectionConsumer", scope);
        var getItems = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(function() {
            var collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
            var items = Array.from(context.itemMap.values());
            var orderedItems = items.sort(function(a, b) {
                return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
            });
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    };
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ var PROVIDER_NAME = name + "CollectionProvider";
    var _$6vYhU$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)(PROVIDER_NAME), 2), createCollectionContext = _$6vYhU$createContextScope[0], createCollectionScope = _$6vYhU$createContextScope[1];
    var _createCollectionContext = (0, $8GFUW._)(createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    }), 2), CollectionProviderImpl = _createCollectionContext[0], useCollectionContext = _createCollectionContext[1];
    var CollectionProvider = function(props) {
        var scope = props.scope, children = props.children;
        var ref = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(null);
        var itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ var COLLECTION_SLOT_NAME = name + "CollectionSlot";
    var CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(function(props, forwardedRef) {
        var scope = props.scope, children = props.children;
        var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $513654131ef3bd4b$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ var ITEM_SLOT_NAME = name + "CollectionItemSlot";
    var ITEM_DATA_ATTR = "data-radix-collection-item";
    var CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(function(props, forwardedRef) {
        var scope = props.scope, children = props.children, itemData = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
            "scope",
            "children"
        ]);
        var ref = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(null);
        var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        var context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
            context.itemMap.set(ref, (0, $8OnJk._)({
                ref: ref
            }, itemData));
            return function() {
                return void context.itemMap.delete(ref);
            };
        });
        var _obj;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $513654131ef3bd4b$export$8c6ed5c666ac1360), (_obj = {}, (0, $dxWQo._)(_obj, ITEM_DATA_ATTR, ""), (0, $dxWQo._)(_obj, "ref", composedRefs), _obj), children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}




var $8OnJk = parcelRequire("8OnJk");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");


var $6cds3 = parcelRequire("6cds3");


var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");



var $6cds3 = parcelRequire("6cds3");


var $02d9b2ca3ec07cdd$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ var $02d9b2ca3ec07cdd$export$250ffa63cdc0d034 = $02d9b2ca3ec07cdd$var$$8927f6f2acc4f386$var$NODES.reduce(function(primitive, node) {
    var Node = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
        var asChild = props.asChild, primitiveProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
            "asChild"
        ]);
        var Comp = asChild ? (0, $513654131ef3bd4b$export$8c6ed5c666ac1360) : node;
        (0, $6cds3.useEffect)(function() {
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $6cds3.createElement)(Comp, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = "Primitive.".concat(node);
    return (0, $8E768._)((0, $8OnJk._)({}, primitive), (0, $dxWQo._)({}, node, Node));
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $02d9b2ca3ec07cdd$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $6d4849ee44552f5f$exports.flushSync)(function() {
        return target.dispatchEvent(event);
    });
}
/* -----------------------------------------------------------------------------------------------*/ var $02d9b2ca3ec07cdd$export$be92b6f5f03c0fe9 = $02d9b2ca3ec07cdd$export$250ffa63cdc0d034;




var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $31706a47374637c9$export$25bec8c6f54ee79a(callback) {
    var callbackRef = (0, $6cds3.useRef)(callback);
    (0, $6cds3.useEffect)(function() {
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $6cds3.useMemo)(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _callbackRef$current;
            var _callbackRef$current1;
            return (_callbackRef$current1 = callbackRef.current) === null || _callbackRef$current1 === void 0 ? void 0 : (_callbackRef$current = _callbackRef$current1).call.apply(_callbackRef$current, [
                callbackRef
            ].concat((0, $fLnyw._)(args)));
        };
    }, []);
}



var $6cds3 = parcelRequire("6cds3");

/**
 * Listens for when the escape key is down
 */ function $3517df3d4b27084e$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var onEscapeKeyDown = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $6cds3.useEffect)(function() {
        var handleKeyDown = function(event) {
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return function() {
            return ownerDocument.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ var $495a48040502b2f4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $495a48040502b2f4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $495a48040502b2f4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $495a48040502b2f4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $495a48040502b2f4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
var $495a48040502b2f4$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $6cds3.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
var $495a48040502b2f4$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var _node$ownerDocument;
    var tmp = props.disableOutsidePointerEvents, disableOutsidePointerEvents = tmp === void 0 ? false : tmp, onEscapeKeyDown = props.onEscapeKeyDown, onPointerDownOutside = props.onPointerDownOutside, onFocusOutside = props.onFocusOutside, onInteractOutside = props.onInteractOutside, onDismiss = props.onDismiss, layerProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "disableOutsidePointerEvents",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside",
        "onDismiss"
    ]);
    var context = (0, $6cds3.useContext)($495a48040502b2f4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    var _$kqwpH$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), node1 = _$kqwpH$useState[0], setNode = _$kqwpH$useState[1];
    var ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var _$kqwpH$useState1 = (0, $8GFUW._)((0, $6cds3.useState)({}), 2), force = _$kqwpH$useState1[1];
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setNode(node);
    });
    var layers = Array.from(context.layers);
    var _to_consumable_array_slice = (0, $8GFUW._)((0, $fLnyw._)(context.layersWithOutsidePointerEventsDisabled).slice(-1), 1), highestLayerWithOutsidePointerEventsDisabled = _to_consumable_array_slice[0]; // prettier-ignore
    var highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    var index = node1 ? layers.indexOf(node1) : -1;
    var isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    var isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    var pointerDownOutside = $495a48040502b2f4$var$$5cb92bef7577960e$var$usePointerDownOutside(function(event) {
        var target = event.target;
        var isPointerDownOnBranch = (0, $fLnyw._)(context.branches).some(function(branch) {
            return branch.contains(target);
        });
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    var focusOutside = $495a48040502b2f4$var$$5cb92bef7577960e$var$useFocusOutside(function(event) {
        var target = event.target;
        var isFocusInBranch = (0, $fLnyw._)(context.branches).some(function(branch) {
            return branch.contains(target);
        });
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $3517df3d4b27084e$export$3a72a57244d6e765)(function(event) {
        var isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $6cds3.useEffect)(function() {
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $495a48040502b2f4$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $495a48040502b2f4$var$$5cb92bef7577960e$var$dispatchUpdate();
        return function() {
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $495a48040502b2f4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $6cds3.useEffect)(function() {
        return function() {
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $495a48040502b2f4$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $6cds3.useEffect)(function() {
        var handleUpdate = function() {
            return force({});
        };
        document.addEventListener($495a48040502b2f4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return function() {
            return document.removeEventListener($495a48040502b2f4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        };
    }, []);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: (0, $8OnJk._)({
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined
        }, props.style),
        onFocusCapture: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($495a48040502b2f4$export$177fb62ff3ec1f22, {
    displayName: $495a48040502b2f4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ var $495a48040502b2f4$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
var $495a48040502b2f4$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var context = (0, $6cds3.useContext)($495a48040502b2f4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $6cds3.useEffect)(function() {
        var node = ref.current;
        if (node) {
            context.branches.add(node);
            return function() {
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($495a48040502b2f4$export$4d5eb2109db14228, {
    displayName: $495a48040502b2f4$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $495a48040502b2f4$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var handlePointerDownOutside = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onPointerDownOutside);
    var isPointerInsideReactTreeRef = (0, $6cds3.useRef)(false);
    var handleClickRef = (0, $6cds3.useRef)(function() {});
    (0, $6cds3.useEffect)(function() {
        var handlePointerDown = function(event) {
            if (event.target && !isPointerInsideReactTreeRef.current) {
                var handleAndDispatchPointerDownOutsideEvent = function handleAndDispatchPointerDownOutsideEvent() {
                    $495a48040502b2f4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($495a48040502b2f4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var eventDetail = {
                    originalEvent: event
                };
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ var timerId = window.setTimeout(function() {
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return function() {
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: function() {
            return isPointerInsideReactTreeRef.current = true;
        }
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $495a48040502b2f4$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var handleFocusOutside = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onFocusOutside);
    var isFocusInsideReactTreeRef = (0, $6cds3.useRef)(false);
    (0, $6cds3.useEffect)(function() {
        var handleFocus = function(event) {
            if (event.target && !isFocusInsideReactTreeRef.current) {
                var eventDetail = {
                    originalEvent: event
                };
                $495a48040502b2f4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($495a48040502b2f4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return function() {
            return ownerDocument.removeEventListener("focusin", handleFocus);
        };
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: function() {
            return isFocusInsideReactTreeRef.current = true;
        },
        onBlurCapture: function() {
            return isFocusInsideReactTreeRef.current = false;
        }
    };
}
function $495a48040502b2f4$var$$5cb92bef7577960e$var$dispatchUpdate() {
    var event = new CustomEvent($495a48040502b2f4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $495a48040502b2f4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, param) {
    var discrete = param.discrete;
    var target = detail.originalEvent.target;
    var event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $02d9b2ca3ec07cdd$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $495a48040502b2f4$export$be92b6f5f03c0fe9 = $495a48040502b2f4$export$177fb62ff3ec1f22;
var $495a48040502b2f4$export$aecb2ddcb55c95be = $495a48040502b2f4$export$4d5eb2109db14228;





var $6cds3 = parcelRequire("6cds3");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ var $5521a3997b1d3e3c$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
var $5521a3997b1d3e3c$export$602eac185826482c = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var _globalThis$document;
    var tmp = props.container, container = tmp === void 0 ? globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body : tmp, portalProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "container"
    ]);
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).createPortal(/*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($5521a3997b1d3e3c$export$602eac185826482c, {
    displayName: $5521a3997b1d3e3c$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $5521a3997b1d3e3c$export$be92b6f5f03c0fe9 = $5521a3997b1d3e3c$export$602eac185826482c;



var $8GFUW = parcelRequire("8GFUW");

var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ var $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $6cds3.useLayoutEffect) : function() {};


function $9ce5901ff07c9a39$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $6cds3.useReducer)(function(state, event) {
        var nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
var $9ce5901ff07c9a39$export$99c2b779aa4e8b8b = function(props) {
    var present = props.present, children = props.children;
    var presence = $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$usePresence(present);
    var child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $6cds3.Children).only(children);
    var ref = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    var forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $6cds3.cloneElement)(child, {
        ref: ref
    }) : null;
};
$9ce5901ff07c9a39$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$usePresence(present) {
    var _$iqq3r$useState = (0, $8GFUW._)((0, $6cds3.useState)(), 2), node1 = _$iqq3r$useState[0], setNode = _$iqq3r$useState[1];
    var stylesRef = (0, $6cds3.useRef)({});
    var prevPresentRef = (0, $6cds3.useRef)(present);
    var prevAnimationNameRef = (0, $6cds3.useRef)("none");
    var initialState = present ? "mounted" : "unmounted";
    var _$fe963b355347cc68$export$3e6543de14f8614f = (0, $8GFUW._)($9ce5901ff07c9a39$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    }), 2), state = _$fe963b355347cc68$export$3e6543de14f8614f[0], send = _$fe963b355347cc68$export$3e6543de14f8614f[1];
    (0, $6cds3.useEffect)(function() {
        var currentAnimationName = $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        var styles = stylesRef.current;
        var wasPresent = prevPresentRef.current;
        var hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            var prevAnimationName = prevAnimationNameRef.current;
            var currentAnimationName = $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ var isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ var handleAnimationEnd = function(event) {
                var currentAnimationName = $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                var isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $6d4849ee44552f5f$exports.flushSync)(function() {
                    return send("ANIMATION_END");
                });
            };
            var handleAnimationStart = function(event) {
                if (event.target === node1) prevAnimationNameRef.current = $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return function() {
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $6cds3.useCallback)(function(node) {
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $9ce5901ff07c9a39$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $8GFUW = parcelRequire("8GFUW");

var $6cds3 = parcelRequire("6cds3");

function $67d582389dee973c$export$6f32135080cb4c3(param) {
    var prop = param.prop, defaultProp = param.defaultProp, tmp = param.onChange, onChange = tmp === void 0 ? function() {} : tmp;
    var _$71cd76cc60e0454e$var$useUncontrolledState = (0, $8GFUW._)($67d582389dee973c$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    }), 2), uncontrolledProp = _$71cd76cc60e0454e$var$useUncontrolledState[0], setUncontrolledProp = _$71cd76cc60e0454e$var$useUncontrolledState[1];
    var isControlled = prop !== undefined;
    var value1 = isControlled ? prop : uncontrolledProp;
    var handleChange = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onChange);
    var setValue = (0, $6cds3.useCallback)(function(nextValue) {
        if (isControlled) {
            var setter = nextValue;
            var value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $67d582389dee973c$var$$71cd76cc60e0454e$var$useUncontrolledState(param) {
    var defaultProp = param.defaultProp, onChange = param.onChange;
    var uncontrolledState = (0, $6cds3.useState)(defaultProp);
    var _uncontrolledState = (0, $8GFUW._)(uncontrolledState, 1), value = _uncontrolledState[0];
    var prevValueRef = (0, $6cds3.useRef)(value);
    var handleChange = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onChange);
    (0, $6cds3.useEffect)(function() {
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $8OnJk = parcelRequire("8OnJk");


var $6cds3 = parcelRequire("6cds3");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ var $7ed1a47f24ab3004$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
var $7ed1a47f24ab3004$export$439d29a4e110a164 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).span, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: (0, $8OnJk._)({
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal"
        }, props.style)
    }));
});
/*#__PURE__*/ Object.assign($7ed1a47f24ab3004$export$439d29a4e110a164, {
    displayName: $7ed1a47f24ab3004$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $7ed1a47f24ab3004$export$be92b6f5f03c0fe9 = $7ed1a47f24ab3004$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
var $b6d9fa9872f1b5e9$var$_$eyrYI$createCollection = (0, $8GFUW._)((0, $88a40bb64f7ba2d9$export$c74125a8e3af6bb2)("Toast"), 3), $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$Collection = $b6d9fa9872f1b5e9$var$_$eyrYI$createCollection[0], $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useCollection = $b6d9fa9872f1b5e9$var$_$eyrYI$createCollection[1], $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$createCollectionScope = $b6d9fa9872f1b5e9$var$_$eyrYI$createCollection[2];
var $b6d9fa9872f1b5e9$var$_$eyrYI$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)("Toast", [
    $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$createCollectionScope
]), 2), $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$createToastContext = $b6d9fa9872f1b5e9$var$_$eyrYI$createContextScope[0], $b6d9fa9872f1b5e9$export$8a359da18fbc9073 = $b6d9fa9872f1b5e9$var$_$eyrYI$createContextScope[1];
var $b6d9fa9872f1b5e9$var$_$054eb8030ebde76e$var$createToastContext = (0, $8GFUW._)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$createToastContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$PROVIDER_NAME), 2), $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastProviderProvider = $b6d9fa9872f1b5e9$var$_$054eb8030ebde76e$var$createToastContext[0], $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastProviderContext = $b6d9fa9872f1b5e9$var$_$054eb8030ebde76e$var$createToastContext[1];
var $b6d9fa9872f1b5e9$export$f5d03d415824e0e = function(props) {
    var __scopeToast = props.__scopeToast, tmp = props.label, label = tmp === void 0 ? "Notification" : tmp, tmp1 = props.duration, duration = tmp1 === void 0 ? 5000 : tmp1, tmp2 = props.swipeDirection, swipeDirection = tmp2 === void 0 ? "right" : tmp2, tmp3 = props.swipeThreshold, swipeThreshold = tmp3 === void 0 ? 50 : tmp3, children = props.children;
    var _$eyrYI$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), viewport = _$eyrYI$useState[0], setViewport = _$eyrYI$useState[1];
    var _$eyrYI$useState1 = (0, $8GFUW._)((0, $6cds3.useState)(0), 2), toastCount = _$eyrYI$useState1[0], setToastCount = _$eyrYI$useState1[1];
    var isFocusedToastEscapeKeyDownRef = (0, $6cds3.useRef)(false);
    var isClosePausedRef = (0, $6cds3.useRef)(false);
    return /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $6cds3.useCallback)(function() {
            return setToastCount(function(prevCount) {
                return prevCount + 1;
            });
        }, []),
        onToastRemove: (0, $6cds3.useCallback)(function() {
            return setToastCount(function(prevCount) {
                return prevCount - 1;
            });
        }, []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$b6d9fa9872f1b5e9$export$f5d03d415824e0e.propTypes = {
    label: function(props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            var error = "Invalid prop `label` supplied to `".concat($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$PROVIDER_NAME, "`. Expected non-empty `string`.");
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$f5d03d415824e0e, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
var $b6d9fa9872f1b5e9$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, tmp = props.hotkey, hotkey = tmp === void 0 ? $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY : tmp, tmp1 = props.label, label = tmp1 === void 0 ? "Notifications ({hotkey})" : tmp1, viewportProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "hotkey",
        "label"
    ]);
    var context = $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastProviderContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    var getItems = $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    var wrapperRef = (0, $6cds3.useRef)(null);
    var headFocusProxyRef = (0, $6cds3.useRef)(null);
    var tailFocusProxyRef = (0, $6cds3.useRef)(null);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    var hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    var hasToasts = context.toastCount > 0;
    (0, $6cds3.useEffect)(function() {
        var handleKeyDown = function(event) {
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            var isHotkeyPressed = hotkey.every(function(key) {
                return event[key] || event.code === key;
            });
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        hotkey
    ]);
    (0, $6cds3.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            var handlePause = function() {
                if (!context.isClosePausedRef.current) {
                    var pauseEvent = new CustomEvent($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            var handleResume = function() {
                if (context.isClosePausedRef.current) {
                    var resumeEvent = new CustomEvent($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            var handleFocusOutResume = function(event) {
                var isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            var handlePointerLeaveResume = function() {
                var isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return function() {
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    var getSortedTabbableCandidates = (0, $6cds3.useCallback)(function(param) {
        var tabbingDirection = param.tabbingDirection;
        var toastItems = getItems();
        var tabbableCandidates = toastItems.map(function(toastItem) {
            var toastNode = toastItem.ref.current;
            var toastTabbableCandidates = [
                toastNode
            ].concat((0, $fLnyw._)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)));
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $6cds3.useEffect)(function() {
        var viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            var handleKeyDown = function(event) {
                var isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                var isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    var focusedElement = document.activeElement;
                    var isTabbingBackwards = event.shiftKey;
                    var targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    var tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    var sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    var index = sortedCandidates.findIndex(function(candidate) {
                        return candidate === focusedElement;
                    });
                    if ($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return function() {
                return viewport.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $495a48040502b2f4$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: function() {
            var tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).ol, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: function() {
            var tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$6192c2425ecfd989, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, onFocusFromOutsideViewport = props.onFocusFromOutsideViewport, proxyProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "onFocusFromOutsideViewport"
    ]);
    var context = $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastProviderContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $7ed1a47f24ab3004$export$439d29a4e110a164), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: function(event) {
            var _context$viewport;
            var prevFocusedElement = event.relatedTarget;
            var isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
var $b6d9fa9872f1b5e9$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var forceMount = props.forceMount, openProp = props.open, defaultOpen = props.defaultOpen, onOpenChange = props.onOpenChange, toastProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "forceMount",
        "open",
        "defaultOpen",
        "onOpenChange"
    ]);
    var _$eyrYI$useControllableState = (0, $8GFUW._)((0, $67d582389dee973c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    }), 2), tmp = _$eyrYI$useControllableState[0], open = tmp === void 0 ? true : tmp, setOpen = _$eyrYI$useControllableState[1];
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: function() {
            return setOpen(false);
        },
        onPause: (0, $31706a47374637c9$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $31706a47374637c9$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onSwipeStart, function(event) {
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onSwipeMove, function(event) {
            var _event_detail_delta = event.detail.delta, x = _event_detail_delta.x, y = _event_detail_delta.y;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", "".concat(x, "px"));
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", "".concat(y, "px"));
        }),
        onSwipeCancel: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onSwipeCancel, function(event) {
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onSwipeEnd, function(event) {
            var _event_detail_delta = event.detail.delta, x = _event_detail_delta.x, y = _event_detail_delta.y;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", "".concat(x, "px"));
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", "".concat(y, "px"));
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$8d8dc7d5f743331b, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$_$054eb8030ebde76e$var$createToastContext1 = (0, $8GFUW._)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$createToastContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose: function() {}
}), 2), $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastInteractiveProvider = $b6d9fa9872f1b5e9$var$_$054eb8030ebde76e$var$createToastContext1[0], $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastInteractiveContext = $b6d9fa9872f1b5e9$var$_$054eb8030ebde76e$var$createToastContext1[1];
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, tmp = props.type, type = tmp === void 0 ? "foreground" : tmp, durationProp = props.duration, open = props.open, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onPause = props.onPause, onResume = props.onResume, onSwipeStart = props.onSwipeStart, onSwipeMove = props.onSwipeMove, onSwipeCancel = props.onSwipeCancel, onSwipeEnd = props.onSwipeEnd, toastProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "type",
        "duration",
        "open",
        "onClose",
        "onEscapeKeyDown",
        "onPause",
        "onResume",
        "onSwipeStart",
        "onSwipeMove",
        "onSwipeCancel",
        "onSwipeEnd"
    ]);
    var context = $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastProviderContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    var _$eyrYI$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), node1 = _$eyrYI$useState[0], setNode = _$eyrYI$useState[1];
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setNode(node);
    });
    var pointerStartRef = (0, $6cds3.useRef)(null);
    var swipeDeltaRef = (0, $6cds3.useRef)(null);
    var duration1 = durationProp || context.duration;
    var closeTimerStartTimeRef = (0, $6cds3.useRef)(0);
    var closeTimerRemainingTimeRef = (0, $6cds3.useRef)(duration1);
    var closeTimerRef = (0, $6cds3.useRef)(0);
    var onToastAdd = context.onToastAdd, onToastRemove = context.onToastRemove;
    var handleClose = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(function() {
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        var isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    var startTimer = (0, $6cds3.useCallback)(function(duration) {
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $6cds3.useEffect)(function() {
        var viewport = context.viewport;
        if (viewport) {
            var handleResume = function() {
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            var handlePause = function() {
                var elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return function() {
                viewport.removeEventListener($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $6cds3.useEffect)(function() {
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $6cds3.useEffect)(function() {
        onToastAdd();
        return function() {
            return onToastRemove();
        };
    }, [
        onToastAdd,
        onToastRemove
    ]);
    var announceTextContent = (0, $6cds3.useMemo)(function() {
        return node1 ? $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $6cds3.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $6d4849ee44552f5f$exports.createPortal)(/*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $495a48040502b2f4$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(onEscapeKeyDown, function() {
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).li, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: (0, $8OnJk._)({
            userSelect: "none",
            touchAction: "none"
        }, props.style),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerDown, function(event) {
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerMove, function(event) {
            if (!pointerStartRef.current) return;
            var x = event.clientX - pointerStartRef.current.x;
            var y = event.clientY - pointerStartRef.current.y;
            var hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            var isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            var clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            var clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            var clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            var moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            var delta = {
                x: clampedX,
                y: clampedY
            };
            var eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerUp, function(event1) {
            var delta = swipeDeltaRef.current;
            var target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                var toast = event1.currentTarget;
                var eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", function(event) {
                    return event.preventDefault();
                }, {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type: function(props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            var error = "Invalid prop `type` supplied to `".concat($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_NAME, "`. Expected `foreground | background`.");
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastAnnounce = function(props) {
    var __scopeToast = props.__scopeToast, children = props.children, announceProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "children"
    ]);
    var context = $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastProviderContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    var _$eyrYI$useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), renderAnnounceText = _$eyrYI$useState[0], setRenderAnnounceText = _$eyrYI$useState[1];
    var _$eyrYI$useState1 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isAnnounced = _$eyrYI$useState1[0], setIsAnnounced = _$eyrYI$useState1[1]; // render text content in the next frame to ensure toast is announced in NVDA
    $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useNextFrame(function() {
        return setRenderAnnounceText(true);
    }); // cleanup after announcing
    (0, $6cds3.useEffect)(function() {
        var timer = window.setTimeout(function() {
            return setIsAnnounced(true);
        }, 1000);
        return function() {
            return window.clearTimeout(timer);
        };
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $6cds3.createElement)((0, $5521a3997b1d3e3c$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $7ed1a47f24ab3004$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $6cds3.createElement)((0, $6cds3.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
var $b6d9fa9872f1b5e9$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, titleProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$16d42d7c29b95a4, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
var $b6d9fa9872f1b5e9$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, descriptionProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$ecddd96c53621d9a, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
var $b6d9fa9872f1b5e9$export$3019feecfda683d2 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var altText = props.altText, actionProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "altText"
    ]);
    if (!altText) return null;
    return /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$export$811e70f61c205839, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$b6d9fa9872f1b5e9$export$3019feecfda683d2.propTypes = {
    altText: function(props) {
        if (!props.altText) return new Error("Missing prop `altText` expected on `".concat($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ACTION_NAME, "`"));
        return null;
    }
};
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$3019feecfda683d2, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
var $b6d9fa9872f1b5e9$export$811e70f61c205839 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, closeProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast"
    ]);
    var interactiveContext = $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useToastInteractiveContext($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $6cds3.createElement)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).button, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($b6d9fa9872f1b5e9$export$811e70f61c205839, {
    displayName: $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, altText = props.altText, announceExcludeProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "altText"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    var textContent = [];
    var childNodes = Array.from(container.childNodes);
    childNodes.forEach(function(node) {
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            var isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            var isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                var _textContent;
                if (isExcluded) {
                    var altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else (_textContent = textContent).push.apply(_textContent, (0, $fLnyw._)($b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$getAnnounceTextContent(node)));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, param) {
    var discrete = param.discrete;
    var currentTarget = detail.originalEvent.currentTarget;
    var event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $02d9b2ca3ec07cdd$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
var $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$isDeltaInDirection = function(delta, direction) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var deltaX = Math.abs(delta.x);
    var deltaY = Math.abs(delta.y);
    var isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$useNextFrame() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    var fn = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(callback);
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        var raf1 = 0;
        var raf2 = 0;
        raf1 = window.requestAnimationFrame(function() {
            return raf2 = window.requestAnimationFrame(fn);
        });
        return function() {
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    var nodes = [];
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $b6d9fa9872f1b5e9$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    var previouslyFocusedElement = document.activeElement;
    return candidates.some(function(candidate) {
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
var $b6d9fa9872f1b5e9$export$2881499e37b75b9a = $b6d9fa9872f1b5e9$export$f5d03d415824e0e;
var $b6d9fa9872f1b5e9$export$d5c6c08dc2d3ca7 = $b6d9fa9872f1b5e9$export$6192c2425ecfd989;
var $b6d9fa9872f1b5e9$export$be92b6f5f03c0fe9 = $b6d9fa9872f1b5e9$export$8d8dc7d5f743331b;
var $b6d9fa9872f1b5e9$export$f99233281efd08a0 = $b6d9fa9872f1b5e9$export$16d42d7c29b95a4;
var $b6d9fa9872f1b5e9$export$393edc798c47379d = $b6d9fa9872f1b5e9$export$ecddd96c53621d9a;
var $b6d9fa9872f1b5e9$export$e19cd5f9376f8cee = $b6d9fa9872f1b5e9$export$3019feecfda683d2;
var $b6d9fa9872f1b5e9$export$f39c2d165cd861fe = $b6d9fa9872f1b5e9$export$811e70f61c205839;



var $8OnJk = parcelRequire("8OnJk");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");
function $81cdd58995c2c489$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $81cdd58995c2c489$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $81cdd58995c2c489$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $81cdd58995c2c489$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $81cdd58995c2c489$export$2e2bcd8739ae039 = $81cdd58995c2c489$export$4f5d2d50c9deca37;


var $817718bbc98c41ca$var$falsyToString = function(value) {
    return typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
};
var $817718bbc98c41ca$export$a274e22fb40f762e = (0, $81cdd58995c2c489$export$2e2bcd8739ae039);
var $817718bbc98c41ca$export$87dc52566e90b739 = function(base, config) {
    return function(props) {
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $817718bbc98c41ca$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        var variants = config.variants, defaultVariants = config.defaultVariants;
        var getVariantClassNames = Object.keys(variants).map(function(variant) {
            var variantProp = props === null || props === void 0 ? void 0 : props[variant];
            var defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            var variantKey = $817718bbc98c41ca$var$falsyToString(variantProp) || $817718bbc98c41ca$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        var propsWithoutUndefined = props && Object.entries(props).reduce(function(acc, param) {
            var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        var getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, param1) {
            var cvClass = param1.class, cvClassName = param1.className, compoundVariantOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(param1, [
                "class",
                "className"
            ]);
            return Object.entries(compoundVariantOptions).every(function(param) {
                var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
                return Array.isArray(value) ? value.includes((0, $8OnJk._)({}, defaultVariants, propsWithoutUndefined)[key]) : (0, $8OnJk._)({}, defaultVariants, propsWithoutUndefined)[key] === value;
            }) ? (0, $fLnyw._)(acc).concat([
                cvClass,
                cvClassName
            ]) : acc;
        }, []);
        return $817718bbc98c41ca$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};


/**
 * lucide-react v0.257.0 - ISC
 */ /**
 * lucide-react v0.257.0 - ISC
 */ 
var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
/**
 * lucide-react v0.257.0 - ISC
 */ var $de40e87992e763b2$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


var $7cb731e627edfd3e$export$73bda83cddbc7187 = function(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
};
var $7cb731e627edfd3e$export$2e2bcd8739ae039 = function(iconName, iconNode) {
    var Component = (0, $6cds3.forwardRef)(function(_param, ref) {
        var _param_color = _param.color, color = _param_color === void 0 ? "currentColor" : _param_color, _param_size = _param.size, size = _param_size === void 0 ? 24 : _param_size, _param_strokeWidth = _param.strokeWidth, strokeWidth = _param_strokeWidth === void 0 ? 2 : _param_strokeWidth, absoluteStrokeWidth = _param.absoluteStrokeWidth, children = _param.children, rest = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
            "color",
            "size",
            "strokeWidth",
            "absoluteStrokeWidth",
            "children"
        ]);
        return (0, $6cds3.createElement)("svg", (0, $8OnJk._)((0, $8E768._)((0, $8OnJk._)({
            ref: ref
        }, (0, $de40e87992e763b2$export$2e2bcd8739ae039)), {
            width: size,
            height: size,
            stroke: color,
            strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
            className: "lucide lucide-".concat($7cb731e627edfd3e$export$73bda83cddbc7187(iconName))
        }), rest), (0, $fLnyw._)(iconNode.map(function(param) {
            var _$_param = (0, $8GFUW._)(param, 2), tag = _$_param[0], attrs = _$_param[1];
            return (0, $6cds3.createElement)(tag, attrs);
        })).concat((0, $fLnyw._)((Array.isArray(children) ? children : [
            children
        ]) || [])));
    });
    Component.displayName = "".concat(iconName);
    return Component;
};


var $aadbdee67ef521af$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);



var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");


var $8OnJk = parcelRequire("8OnJk");
var $c4f7c383fe260b43$var$CLASS_PART_SEPARATOR = "-";
function $c4f7c383fe260b43$export$e3a687438e51f555(config) {
    var getClassGroupId = function getClassGroupId(className) {
        var classParts = className.split($c4f7c383fe260b43$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $c4f7c383fe260b43$var$getGroupRecursive(classParts, classMap) || $c4f7c383fe260b43$var$getGroupIdForArbitraryProperty(className);
    };
    var getConflictingClassGroupIds = function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    };
    var classMap = $c4f7c383fe260b43$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $c4f7c383fe260b43$var$getGroupRecursive(classParts, classPartObject) {
    var _classPartObject_validators_find;
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $c4f7c383fe260b43$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($c4f7c383fe260b43$var$CLASS_PART_SEPARATOR);
    return (_classPartObject_validators_find = classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })) === null || _classPartObject_validators_find === void 0 ? void 0 : _classPartObject_validators_find.classGroupId;
}
var $c4f7c383fe260b43$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $c4f7c383fe260b43$var$getGroupIdForArbitraryProperty(className) {
    if ($c4f7c383fe260b43$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $c4f7c383fe260b43$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName === null || arbitraryPropertyClassName === void 0 ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $c4f7c383fe260b43$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $c4f7c383fe260b43$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $c4f7c383fe260b43$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $c4f7c383fe260b43$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $c4f7c383fe260b43$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($c4f7c383fe260b43$var$isThemeGetter(classDefinition)) {
                $c4f7c383fe260b43$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], _$classGroup = _ref3[1];
            $c4f7c383fe260b43$var$processClassesRecursively(_$classGroup, $c4f7c383fe260b43$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $c4f7c383fe260b43$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($c4f7c383fe260b43$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $c4f7c383fe260b43$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $c4f7c383fe260b43$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}


// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $6ad5b7ac06924a03$export$cf6a7cbaa5f64437(maxCacheSize) {
    var update = function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    };
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}


var $917682236ce04c31$export$61823b46426d06fa = "!";
function $917682236ce04c31$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($917682236ce04c31$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $917682236ce04c31$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}


function $c2e2c477fffc62df$export$56ab4ba5b0b25eb0(config) {
    return (0, $8OnJk._)({
        cache: (0, $6ad5b7ac06924a03$export$cf6a7cbaa5f64437)(config.cacheSize),
        splitModifiers: (0, $917682236ce04c31$export$b5f40ac45a8dd583)(config)
    }, (0, $c4f7c383fe260b43$export$e3a687438e51f555)(config));
}



var $932b69c1b16e23cf$var$SPLIT_CLASSES_REGEX = /\s+/;
function $932b69c1b16e23cf$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($932b69c1b16e23cf$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $917682236ce04c31$export$4f247a60f8a83b3a)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $917682236ce04c31$export$61823b46426d06fa) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}


/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $29d284311bb588bf$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $29d284311bb588bf$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $29d284311bb588bf$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $29d284311bb588bf$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}


function $b87ba0f14662415e$export$ea2d4fba4d1bd27f() {
    var initTailwindMerge = function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $c2e2c477fffc62df$export$56ab4ba5b0b25eb0)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    var tailwindMerge = function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $932b69c1b16e23cf$export$b41084d9255a3248)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    return function callTailwindMerge() {
        return functionToCall((0, $29d284311bb588bf$export$a8bbfb445e1f163f).apply(null, arguments));
    };
}


function $142cc1f96c533345$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}


var $dd55711df61a9a30$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $dd55711df61a9a30$var$fractionRegex = /^\d+\/\d+$/;
var $dd55711df61a9a30$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $dd55711df61a9a30$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $dd55711df61a9a30$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $dd55711df61a9a30$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $dd55711df61a9a30$export$38db3d147cb3433(value) {
    return $dd55711df61a9a30$export$7e4aa119212bc614(value) || $dd55711df61a9a30$var$stringLengths.has(value) || $dd55711df61a9a30$var$fractionRegex.test(value) || $dd55711df61a9a30$export$f5e3af6d4c0fbe38(value);
}
function $dd55711df61a9a30$export$f5e3af6d4c0fbe38(value) {
    return $dd55711df61a9a30$var$getIsArbitraryValue(value, "length", $dd55711df61a9a30$var$isLengthOnly);
}
function $dd55711df61a9a30$export$92dbd3a305a7cb8b(value) {
    return $dd55711df61a9a30$var$getIsArbitraryValue(value, "size", $dd55711df61a9a30$var$isNever);
}
function $dd55711df61a9a30$export$57d00f225f425549(value) {
    return $dd55711df61a9a30$var$getIsArbitraryValue(value, "position", $dd55711df61a9a30$var$isNever);
}
function $dd55711df61a9a30$export$478a5386e985802b(value) {
    return $dd55711df61a9a30$var$getIsArbitraryValue(value, "url", $dd55711df61a9a30$var$isUrl);
}
function $dd55711df61a9a30$export$ea45ce4f1b2d6088(value) {
    return $dd55711df61a9a30$var$getIsArbitraryValue(value, "number", $dd55711df61a9a30$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $dd55711df61a9a30$export$cd3ce15f42623f06 = $dd55711df61a9a30$export$ea45ce4f1b2d6088;
function $dd55711df61a9a30$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $dd55711df61a9a30$export$e50269385c77c348(value) {
    return value.endsWith("%") && $dd55711df61a9a30$export$7e4aa119212bc614(value.slice(0, -1));
}
function $dd55711df61a9a30$export$a287f47fed4544b8(value) {
    return $dd55711df61a9a30$var$isIntegerOnly(value) || $dd55711df61a9a30$var$getIsArbitraryValue(value, "number", $dd55711df61a9a30$var$isIntegerOnly);
}
function $dd55711df61a9a30$export$5534a8576501817d(value) {
    return $dd55711df61a9a30$var$arbitraryValueRegex.test(value);
}
function $dd55711df61a9a30$export$ebb65efc98a3b5f7() {
    return true;
}
function $dd55711df61a9a30$export$a40791c6b7db5bcc(value) {
    return $dd55711df61a9a30$var$tshirtUnitRegex.test(value);
}
function $dd55711df61a9a30$export$d01106465b385604(value) {
    return $dd55711df61a9a30$var$getIsArbitraryValue(value, "", $dd55711df61a9a30$var$isShadow);
}
function $dd55711df61a9a30$var$getIsArbitraryValue(value, label, testValue) {
    var result = $dd55711df61a9a30$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $dd55711df61a9a30$var$isLengthOnly(value) {
    return $dd55711df61a9a30$var$lengthUnitRegex.test(value);
}
function $dd55711df61a9a30$var$isNever() {
    return false;
}
function $dd55711df61a9a30$var$isUrl(value) {
    return value.startsWith("url(");
}
function $dd55711df61a9a30$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $dd55711df61a9a30$var$isShadow(value) {
    return $dd55711df61a9a30$var$shadowRegex.test(value);
}


function $34301aa03c0037fb$export$ed30944e0fe6ae5c() {
    var colors = (0, $142cc1f96c533345$export$e176af7b8eefe933)("colors");
    var spacing = (0, $142cc1f96c533345$export$e176af7b8eefe933)("spacing");
    var blur = (0, $142cc1f96c533345$export$e176af7b8eefe933)("blur");
    var brightness = (0, $142cc1f96c533345$export$e176af7b8eefe933)("brightness");
    var borderColor = (0, $142cc1f96c533345$export$e176af7b8eefe933)("borderColor");
    var borderRadius = (0, $142cc1f96c533345$export$e176af7b8eefe933)("borderRadius");
    var borderSpacing = (0, $142cc1f96c533345$export$e176af7b8eefe933)("borderSpacing");
    var borderWidth = (0, $142cc1f96c533345$export$e176af7b8eefe933)("borderWidth");
    var contrast = (0, $142cc1f96c533345$export$e176af7b8eefe933)("contrast");
    var grayscale = (0, $142cc1f96c533345$export$e176af7b8eefe933)("grayscale");
    var hueRotate = (0, $142cc1f96c533345$export$e176af7b8eefe933)("hueRotate");
    var invert = (0, $142cc1f96c533345$export$e176af7b8eefe933)("invert");
    var gap = (0, $142cc1f96c533345$export$e176af7b8eefe933)("gap");
    var gradientColorStops = (0, $142cc1f96c533345$export$e176af7b8eefe933)("gradientColorStops");
    var gradientColorStopPositions = (0, $142cc1f96c533345$export$e176af7b8eefe933)("gradientColorStopPositions");
    var inset = (0, $142cc1f96c533345$export$e176af7b8eefe933)("inset");
    var margin = (0, $142cc1f96c533345$export$e176af7b8eefe933)("margin");
    var opacity = (0, $142cc1f96c533345$export$e176af7b8eefe933)("opacity");
    var padding = (0, $142cc1f96c533345$export$e176af7b8eefe933)("padding");
    var saturate = (0, $142cc1f96c533345$export$e176af7b8eefe933)("saturate");
    var scale = (0, $142cc1f96c533345$export$e176af7b8eefe933)("scale");
    var sepia = (0, $142cc1f96c533345$export$e176af7b8eefe933)("sepia");
    var skew = (0, $142cc1f96c533345$export$e176af7b8eefe933)("skew");
    var space = (0, $142cc1f96c533345$export$e176af7b8eefe933)("space");
    var translate = (0, $142cc1f96c533345$export$e176af7b8eefe933)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAuto = function getSpacingWithAuto() {
        return [
            "auto",
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $dd55711df61a9a30$export$38db3d147cb3433)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $dd55711df61a9a30$export$7e4aa119212bc614),
            (0, $dd55711df61a9a30$export$5534a8576501817d)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $dd55711df61a9a30$export$5534a8576501817d)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $dd55711df61a9a30$export$7e4aa119212bc614),
            (0, $dd55711df61a9a30$export$ea45ce4f1b2d6088)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $dd55711df61a9a30$export$7e4aa119212bc614),
            (0, $dd55711df61a9a30$export$5534a8576501817d)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $dd55711df61a9a30$export$ebb65efc98a3b5f7)
            ],
            spacing: [
                (0, $dd55711df61a9a30$export$38db3d147cb3433)
            ],
            blur: [
                "none",
                "",
                (0, $dd55711df61a9a30$export$a40791c6b7db5bcc),
                (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $dd55711df61a9a30$export$a40791c6b7db5bcc),
                (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
            ],
            borderSpacing: [
                spacing
            ],
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: [
                spacing
            ],
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $dd55711df61a9a30$export$e50269385c77c348),
                (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
            ],
            inset: getSpacingWithAuto(),
            margin: getSpacingWithAuto(),
            opacity: getNumber(),
            padding: [
                spacing
            ],
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: [
                spacing
            ],
            translate: [
                spacing
            ]
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $dd55711df61a9a30$export$a40791c6b7db5bcc)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $dd55711df61a9a30$export$a287f47fed4544b8)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAuto()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $dd55711df61a9a30$export$a287f47fed4544b8)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $dd55711df61a9a30$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                (0, $dd55711df61a9a30$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $dd55711df61a9a30$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $dd55711df61a9a30$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $dd55711df61a9a30$export$a40791c6b7db5bcc)
                            ]
                        },
                        (0, $dd55711df61a9a30$export$a40791c6b7db5bcc),
                        (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $dd55711df61a9a30$export$a40791c6b7db5bcc),
                        (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $dd55711df61a9a30$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $dd55711df61a9a30$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $dd55711df61a9a30$export$7e4aa119212bc614),
                        (0, $dd55711df61a9a30$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: [
                        spacing
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $dd55711df61a9a30$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $dd55711df61a9a30$export$57d00f225f425549)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $dd55711df61a9a30$export$92dbd3a305a7cb8b)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $dd55711df61a9a30$export$478a5386e985802b)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $dd55711df61a9a30$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $dd55711df61a9a30$export$a40791c6b7db5bcc),
                        (0, $dd55711df61a9a30$export$d01106465b385604)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $dd55711df61a9a30$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $dd55711df61a9a30$export$a40791c6b7db5bcc),
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $dd55711df61a9a30$export$a287f47fed4544b8),
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": [
                        spacing
                    ]
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $dd55711df61a9a30$export$5534a8576501817d)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $dd55711df61a9a30$export$38db3d147cb3433),
                        (0, $dd55711df61a9a30$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}


var $abdf8ab69b7e4218$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $b87ba0f14662415e$export$ea2d4fba4d1bd27f)((0, $34301aa03c0037fb$export$ed30944e0fe6ae5c));


function $2bbfe96e4adedbff$export$1343a74baacb0543() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0, $abdf8ab69b7e4218$export$b4660bb6000dfbc9)((0, $81cdd58995c2c489$export$4f5d2d50c9deca37)(inputs));
}
function $2bbfe96e4adedbff$export$3ae94a2503e890a1(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
    return formattedDate;
}
function $2bbfe96e4adedbff$export$6e9c8de5b9a230fd(wallet, contractId) {
    return $2bbfe96e4adedbff$var$_checkValidUser.apply(this, arguments);
}
function $2bbfe96e4adedbff$var$_checkValidUser() {
    $2bbfe96e4adedbff$var$_checkValidUser = (0, $byzP8._)(function(wallet, contractId) {
        var resp, res, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        wallet.callMethod({
                            method: "get_user",
                            contractId: contractId,
                            gas: "3000000000000"
                        })
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        4,
                        wallet.getTransactionResult(resp.transaction.hash)
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    console.log("error in check user", err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $2bbfe96e4adedbff$var$_checkValidUser.apply(this, arguments);
}
function $2bbfe96e4adedbff$export$fe3a4b613a74459f(wallet, contractId, name, email) {
    return $2bbfe96e4adedbff$var$_registerLister.apply(this, arguments);
}
function $2bbfe96e4adedbff$var$_registerLister() {
    $2bbfe96e4adedbff$var$_registerLister = (0, $byzP8._)(function(wallet, contractId, name, email) {
        var resp, res, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        wallet.callMethod({
                            method: "create_lister",
                            contractId: contractId,
                            args: {
                                name: name,
                                email: email
                            },
                            gas: "3000000000000"
                        })
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        4,
                        wallet.getTransactionResult(resp.transaction.hash)
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    console.log("error in check user", err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $2bbfe96e4adedbff$var$_registerLister.apply(this, arguments);
}
function $2bbfe96e4adedbff$export$ee4bada55e029fef(wallet, contractId, name, email) {
    return $2bbfe96e4adedbff$var$_registerContractor.apply(this, arguments);
}
function $2bbfe96e4adedbff$var$_registerContractor() {
    $2bbfe96e4adedbff$var$_registerContractor = (0, $byzP8._)(function(wallet, contractId, name, email) {
        var resp, res, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        wallet.callMethod({
                            method: "create_contractor",
                            contractId: contractId,
                            args: {
                                name: name,
                                email: email
                            },
                            gas: "3000000000000"
                        })
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        4,
                        wallet.getTransactionResult(resp.transaction.hash)
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    console.log("error in check user", err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $2bbfe96e4adedbff$var$_registerContractor.apply(this, arguments);
}
function $2bbfe96e4adedbff$export$45abfc3976589d02(wallet, contractId) {
    return $2bbfe96e4adedbff$var$_deleteAccount.apply(this, arguments);
}
function $2bbfe96e4adedbff$var$_deleteAccount() {
    $2bbfe96e4adedbff$var$_deleteAccount = (0, $byzP8._)(function(wallet, contractId) {
        var resp, res, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        wallet.callMethod({
                            method: "remove_user",
                            contractId: contractId,
                            args: {},
                            gas: "3000000000000"
                        })
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        4,
                        wallet.getTransactionResult(resp.transaction.hash)
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    console.log("error in check user", err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $2bbfe96e4adedbff$var$_deleteAccount.apply(this, arguments);
}
function $2bbfe96e4adedbff$export$7c4d5b09373bb58d(wallet, contractId, title, description, is_milestoned, start_date, end_date) {
    return $2bbfe96e4adedbff$var$_createContract.apply(this, arguments);
}
function $2bbfe96e4adedbff$var$_createContract() {
    $2bbfe96e4adedbff$var$_createContract = (0, $byzP8._)(function(wallet, contractId, title, description, is_milestoned, start_date, end_date) {
        var resp, res, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        wallet.callMethod({
                            method: "create_contract",
                            contractId: contractId,
                            args: {
                                title: title,
                                description: description,
                                is_milestoned: is_milestoned,
                                start_date: start_date.getTime(),
                                end_date: end_date.getTime()
                            },
                            gas: "3000000000000"
                        })
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        4,
                        wallet.getTransactionResult(resp.transaction.hash)
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 3:
                    err = _state.sent();
                    console.log("error in check user", err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $2bbfe96e4adedbff$var$_createContract.apply(this, arguments);
}


var $2760494e6d577487$export$f5d03d415824e0e = $b6d9fa9872f1b5e9$export$2881499e37b75b9a;
var $2760494e6d577487$export$6192c2425ecfd989 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($b6d9fa9872f1b5e9$export$d5c6c08dc2d3ca7, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", className)
    }, props));
});
$2760494e6d577487$export$6192c2425ecfd989.displayName = $b6d9fa9872f1b5e9$export$d5c6c08dc2d3ca7.displayName;
var $2760494e6d577487$var$toastVariants = (0, $817718bbc98c41ca$export$87dc52566e90b739)("group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
    variants: {
        variant: {
            default: "border bg-background",
            destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var $2760494e6d577487$export$8d8dc7d5f743331b = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "variant"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($b6d9fa9872f1b5e9$export$be92b6f5f03c0fe9, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)($2760494e6d577487$var$toastVariants({
            variant: variant
        }), className)
    }, props));
});
$2760494e6d577487$export$8d8dc7d5f743331b.displayName = $b6d9fa9872f1b5e9$export$be92b6f5f03c0fe9.displayName;
var $2760494e6d577487$export$3019feecfda683d2 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($b6d9fa9872f1b5e9$export$e19cd5f9376f8cee, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive", className)
    }, props));
});
$2760494e6d577487$export$3019feecfda683d2.displayName = $b6d9fa9872f1b5e9$export$e19cd5f9376f8cee.displayName;
var $2760494e6d577487$export$811e70f61c205839 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($b6d9fa9872f1b5e9$export$f39c2d165cd861fe, (0, $8E768._)((0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", className),
        "toast-close": ""
    }, props), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $aadbdee67ef521af$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
});
$2760494e6d577487$export$811e70f61c205839.displayName = $b6d9fa9872f1b5e9$export$f39c2d165cd861fe.displayName;
var $2760494e6d577487$export$16d42d7c29b95a4 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($b6d9fa9872f1b5e9$export$f99233281efd08a0, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("text-sm font-semibold", className)
    }, props));
});
$2760494e6d577487$export$16d42d7c29b95a4.displayName = $b6d9fa9872f1b5e9$export$f99233281efd08a0.displayName;
var $2760494e6d577487$export$ecddd96c53621d9a = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($b6d9fa9872f1b5e9$export$393edc798c47379d, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("text-sm opacity-90", className)
    }, props));
});
$2760494e6d577487$export$ecddd96c53621d9a.displayName = $b6d9fa9872f1b5e9$export$393edc798c47379d.displayName;


// Inspired by react-hot-toast library
function $877ef6de280e80e7$export$c90d7ca213038c72() {
    $877ef6de280e80e7$export$c90d7ca213038c72 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $877ef6de280e80e7$export$c90d7ca213038c72.apply(this, arguments);
}


function $9c04611ef3cd7bb6$export$cffab43ebdf6037(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
var $a65c6a8ddb514a0f$var$TOAST_LIMIT = 1;
var $a65c6a8ddb514a0f$var$TOAST_REMOVE_DELAY = 1000000;
var $a65c6a8ddb514a0f$var$actionTypes = {
    ADD_TOAST: "ADD_TOAST",
    UPDATE_TOAST: "UPDATE_TOAST",
    DISMISS_TOAST: "DISMISS_TOAST",
    REMOVE_TOAST: "REMOVE_TOAST"
};
var $a65c6a8ddb514a0f$var$count = 0;
function $a65c6a8ddb514a0f$var$genId() {
    $a65c6a8ddb514a0f$var$count = ($a65c6a8ddb514a0f$var$count + 1) % Number.MAX_VALUE;
    return $a65c6a8ddb514a0f$var$count.toString();
}
var $a65c6a8ddb514a0f$var$toastTimeouts = new Map();
var $a65c6a8ddb514a0f$var$addToRemoveQueue = function(toastId) {
    if ($a65c6a8ddb514a0f$var$toastTimeouts.has(toastId)) return;
    var timeout = setTimeout(function() {
        $a65c6a8ddb514a0f$var$toastTimeouts.delete(toastId);
        $a65c6a8ddb514a0f$var$dispatch({
            type: "REMOVE_TOAST",
            toastId: toastId
        });
    }, $a65c6a8ddb514a0f$var$TOAST_REMOVE_DELAY);
    $a65c6a8ddb514a0f$var$toastTimeouts.set(toastId, timeout);
};
var $a65c6a8ddb514a0f$export$1650419e431d3ba3 = function(state, action) {
    switch(action.type){
        case "ADD_TOAST":
            return (0, $8E768._)((0, $8OnJk._)({}, state), {
                toasts: [
                    action.toast
                ].concat((0, $fLnyw._)(state.toasts)).slice(0, $a65c6a8ddb514a0f$var$TOAST_LIMIT)
            });
        case "UPDATE_TOAST":
            return (0, $8E768._)((0, $8OnJk._)({}, state), {
                toasts: state.toasts.map(function(t) {
                    return t.id === action.toast.id ? (0, $8OnJk._)({}, t, action.toast) : t;
                })
            });
        case "DISMISS_TOAST":
            {
                var toastId = action.toastId;
                // ! Side effects ! - This could be extracted into a dismissToast() action,
                // but I'll keep it here for simplicity
                if (toastId) $a65c6a8ddb514a0f$var$addToRemoveQueue(toastId);
                else state.toasts.forEach(function(toast) {
                    $a65c6a8ddb514a0f$var$addToRemoveQueue(toast.id);
                });
                return (0, $8E768._)((0, $8OnJk._)({}, state), {
                    toasts: state.toasts.map(function(t) {
                        return t.id === toastId || toastId === undefined ? (0, $8E768._)((0, $8OnJk._)({}, t), {
                            open: false
                        }) : t;
                    })
                });
            }
        case "REMOVE_TOAST":
            if (action.toastId === undefined) return (0, $8E768._)((0, $8OnJk._)({}, state), {
                toasts: []
            });
            return (0, $8E768._)((0, $8OnJk._)({}, state), {
                toasts: state.toasts.filter(function(t) {
                    return t.id !== action.toastId;
                })
            });
    }
};
var $a65c6a8ddb514a0f$var$listeners = [];
var $a65c6a8ddb514a0f$var$memoryState = {
    toasts: []
};
function $a65c6a8ddb514a0f$var$dispatch(action) {
    $a65c6a8ddb514a0f$var$memoryState = $a65c6a8ddb514a0f$export$1650419e431d3ba3($a65c6a8ddb514a0f$var$memoryState, action);
    $a65c6a8ddb514a0f$var$listeners.forEach(function(listener) {
        listener($a65c6a8ddb514a0f$var$memoryState);
    });
}
function $a65c6a8ddb514a0f$export$b410431fab84fa58(_param) {
    var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
    var id = $a65c6a8ddb514a0f$var$genId();
    var update = function(props) {
        return $a65c6a8ddb514a0f$var$dispatch({
            type: "UPDATE_TOAST",
            toast: (0, $8E768._)((0, $8OnJk._)({}, props), {
                id: id
            })
        });
    };
    var dismiss = function() {
        return $a65c6a8ddb514a0f$var$dispatch({
            type: "DISMISS_TOAST",
            toastId: id
        });
    };
    $a65c6a8ddb514a0f$var$dispatch({
        type: "ADD_TOAST",
        toast: (0, $8E768._)((0, $8OnJk._)({}, props), {
            id: id,
            open: true,
            onOpenChange: function(open) {
                if (!open) dismiss();
            }
        })
    });
    return {
        id: id,
        dismiss: dismiss,
        update: update
    };
}
function $a65c6a8ddb514a0f$export$a407b657d3044108() {
    var _React_useState = (0, $8GFUW._)($6cds3.useState($a65c6a8ddb514a0f$var$memoryState), 2), state = _React_useState[0], setState = _React_useState[1];
    $6cds3.useEffect(function() {
        $a65c6a8ddb514a0f$var$listeners.push(setState);
        return function() {
            var index = $a65c6a8ddb514a0f$var$listeners.indexOf(setState);
            if (index > -1) $a65c6a8ddb514a0f$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    return (0, $8E768._)((0, $8OnJk._)({}, state), {
        toast: $a65c6a8ddb514a0f$export$b410431fab84fa58,
        dismiss: function(toastId) {
            return $a65c6a8ddb514a0f$var$dispatch({
                type: "DISMISS_TOAST",
                toastId: toastId
            });
        }
    });
}


function $66bc8323b1b46bc1$export$fb98e3a2a4cd92d7() {
    var toasts = (0, $a65c6a8ddb514a0f$export$a407b657d3044108)().toasts;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2760494e6d577487$export$f5d03d415824e0e), {
        children: [
            toasts.map(function(_param) {
                var id = _param.id, title = _param.title, description = _param.description, action = _param.action, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
                    "id",
                    "title",
                    "description",
                    "action"
                ]);
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2760494e6d577487$export$8d8dc7d5f743331b), (0, $8E768._)((0, $8OnJk._)({}, props), {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "grid gap-1",
                            children: [
                                title && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2760494e6d577487$export$16d42d7c29b95a4), {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2760494e6d577487$export$ecddd96c53621d9a), {
                                    children: description
                                })
                            ]
                        }),
                        action,
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2760494e6d577487$export$811e70f61c205839), {})
                    ]
                }), id);
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2760494e6d577487$export$6192c2425ecfd989), {})
        ]
    });
}


/**
 * React Router DOM v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
/**
 * @remix-run/router v1.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $jbUp2 = parcelRequire("jbUp2");

var $2uHzb = parcelRequire("2uHzb");

var $4Tldu = parcelRequire("4Tldu");

var $imR8K = parcelRequire("imR8K");
function $e5fd8313026a48a6$export$e62c166da838fa3(arr) {
    return (0, $jbUp2._array_with_holes)(arr) || (0, $2uHzb._iterable_to_array)(arr) || (0, $imR8K._unsupported_iterable_to_array)(arr) || (0, $4Tldu._non_iterable_rest)();
}



var $fLnyw = parcelRequire("fLnyw");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");
function $96b280a33643b696$var$_extends() {
    $96b280a33643b696$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b280a33643b696$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $96b280a33643b696$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($96b280a33643b696$export$e19cd5f9376f8cee || ($96b280a33643b696$export$e19cd5f9376f8cee = {}));
var $96b280a33643b696$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $96b280a33643b696$export$2b76ad033c6e6d08(options) {
    var clampIndex = function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    };
    var getCurrentLocation = function getCurrentLocation() {
        return entries[index];
    };
    var createMemoryLocation = function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $96b280a33643b696$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    };
    var createHref = function createHref(to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $96b280a33643b696$export$719fc203c4e16dee(options) {
    var createBrowserLocation = function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createBrowserHref = function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    return $96b280a33643b696$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $96b280a33643b696$export$b71fdd3798280242(options) {
    var createHashLocation = function createHashLocation(window1, globalHistory) {
        var _parsePath = $96b280a33643b696$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createHashHref = function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to));
    };
    var validateHashLocation = function validateHashLocation(location, to) {
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    };
    if (options === void 0) options = {};
    return $96b280a33643b696$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96b280a33643b696$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96b280a33643b696$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $96b280a33643b696$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $96b280a33643b696$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $96b280a33643b696$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $96b280a33643b696$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96b280a33643b696$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $96b280a33643b696$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $96b280a33643b696$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96b280a33643b696$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    var getIndex = function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    };
    var handlePop = function handlePop() {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    };
    var push = function push(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        var location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $96b280a33643b696$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    };
    var replace = function replace(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        var location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $96b280a33643b696$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    };
    var createURL = function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
        $96b280a33643b696$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    };
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($96b280a33643b696$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $96b280a33643b696$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($96b280a33643b696$var$ResultType || ($96b280a33643b696$var$ResultType = {}));
var $96b280a33643b696$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96b280a33643b696$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $fLnyw._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96b280a33643b696$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $96b280a33643b696$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($96b280a33643b696$var$isIndexRoute(route)) {
            var indexRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96b280a33643b696$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $96b280a33643b696$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $96b280a33643b696$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $96b280a33643b696$var$flattenRoutes(routes);
    $96b280a33643b696$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $96b280a33643b696$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $96b280a33643b696$var$safelyDecodeURI(pathname));
    return matches;
}
function $96b280a33643b696$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96b280a33643b696$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $96b280a33643b696$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $96b280a33643b696$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $96b280a33643b696$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96b280a33643b696$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $96b280a33643b696$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $96b280a33643b696$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $e5fd8313026a48a6$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $96b280a33643b696$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $fLnyw._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $fLnyw._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $96b280a33643b696$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $96b280a33643b696$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $96b280a33643b696$var$paramRe = /^:\w+$/;
var $96b280a33643b696$var$dynamicSegmentValue = 3;
var $96b280a33643b696$var$indexRouteValue = 2;
var $96b280a33643b696$var$emptySegmentValue = 1;
var $96b280a33643b696$var$staticSegmentValue = 10;
var $96b280a33643b696$var$splatPenalty = -2;
var $96b280a33643b696$var$isSplat = function(s) {
    return s === "*";
};
function $96b280a33643b696$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($96b280a33643b696$var$isSplat)) initialScore += $96b280a33643b696$var$splatPenalty;
    if (index) initialScore += $96b280a33643b696$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$96b280a33643b696$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($96b280a33643b696$var$paramRe.test(segment) ? $96b280a33643b696$var$dynamicSegmentValue : segment === "" ? $96b280a33643b696$var$emptySegmentValue : $96b280a33643b696$var$staticSegmentValue);
    }, initialScore);
}
function $96b280a33643b696$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96b280a33643b696$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $96b280a33643b696$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96b280a33643b696$export$a5c6d149b50c1d86($96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96b280a33643b696$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $96b280a33643b696$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $8GFUW._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $96b280a33643b696$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $96b280a33643b696$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $8GFUW._)($96b280a33643b696$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $96b280a33643b696$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96b280a33643b696$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $96b280a33643b696$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $96b280a33643b696$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $96b280a33643b696$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $96b280a33643b696$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $96b280a33643b696$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96b280a33643b696$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96b280a33643b696$var$normalizeSearch(search),
        hash: $96b280a33643b696$var$normalizeHash(hash)
    };
}
function $96b280a33643b696$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96b280a33643b696$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $96b280a33643b696$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $96b280a33643b696$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $96b280a33643b696$export$8ccf933b0513f8d0(toArg);
    else {
        to = $96b280a33643b696$var$_extends({}, toArg);
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $96b280a33643b696$var$getInvalidPathError("?", "pathname", "search", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "pathname", "hash", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $96b280a33643b696$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $96b280a33643b696$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $96b280a33643b696$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $96b280a33643b696$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $96b280a33643b696$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $96b280a33643b696$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $96b280a33643b696$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $96b280a33643b696$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(AbortedDeferredError, Error1);
    var _super = (0, $6OZAO._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $978gY._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $2TMdq._)(Error));
var $96b280a33643b696$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $978gY._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $96b280a33643b696$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $96b280a33643b696$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $8GFUW._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $dxWQo._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $kry2a._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, null, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $96b280a33643b696$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                if (error) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var aborted, onAbort;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $96b280a33643b696$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $8GFUW._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $dxWQo._)({}, key, $96b280a33643b696$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $96b280a33643b696$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $96b280a33643b696$var$unwrapTrackedPromise(value) {
    if (!$96b280a33643b696$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $96b280a33643b696$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $96b280a33643b696$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $96b280a33643b696$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var $96b280a33643b696$export$acf1a680051f5031 = function ErrorResponse(status, statusText, data, internal) {
    "use strict";
    (0, $978gY._)(this, ErrorResponse);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $96b280a33643b696$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $96b280a33643b696$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $96b280a33643b696$var$validMutationMethods = new Set($96b280a33643b696$var$validMutationMethodsArr);
var $96b280a33643b696$var$validRequestMethodsArr = [
    "get"
].concat((0, $fLnyw._)($96b280a33643b696$var$validMutationMethodsArr));
var $96b280a33643b696$var$validRequestMethods = new Set($96b280a33643b696$var$validRequestMethodsArr);
var $96b280a33643b696$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $96b280a33643b696$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $96b280a33643b696$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $96b280a33643b696$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $96b280a33643b696$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $96b280a33643b696$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $96b280a33643b696$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $96b280a33643b696$export$baddd0131ee8c05b(init) {
    var initialize = // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $96b280a33643b696$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($96b280a33643b696$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    };
    var dispose = // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    };
    var subscribe = // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    };
    var updateState = // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $96b280a33643b696$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    };
    var completeNavigation = // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $96b280a33643b696$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $96b280a33643b696$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($96b280a33643b696$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    };
    var revalidate = // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    };
    var getFetcher = function getFetcher(key) {
        return state.fetchers.get(key) || $96b280a33643b696$export$52eace9c284d3585;
    };
    var fetch = // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        var match = $96b280a33643b696$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    };
    var interruptActiveLoads = function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $fLnyw._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    };
    var setFetcherError = function setFetcherError(key, routeId, error) {
        var boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $dxWQo._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    };
    var deleteFetcher = function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    };
    var abortFetcher = function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $96b280a33643b696$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    };
    var markFetchersDone = function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $96b280a33643b696$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var markFetchRedirectsDone = function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    };
    var abortStaleFetchLoads = function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    };
    var getBlocker = function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    };
    var deleteBlocker = function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    };
    var updateBlocker = // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $96b280a33643b696$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    };
    var shouldBlockNavigation = function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $96b280a33643b696$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $8GFUW._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    };
    var cancelActiveDeferreds = function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    };
    var enableScrollRestoration = // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $96b280a33643b696$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    };
    var getScrollKey = function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $96b280a33643b696$var$createUseMatchesMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    };
    var saveScrollPosition = function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    };
    var getSavedScrollPosition = function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    };
    var _internalSetRoutes = function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    };
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $96b280a33643b696$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $96b280a33643b696$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $dxWQo._)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $byzP8._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $96b280a33643b696$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $96b280a33643b696$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $96b280a33643b696$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $byzP8._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, location, basename);
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $96b280a33643b696$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $96b280a33643b696$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $dxWQo._)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $96b280a33643b696$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $96b280a33643b696$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $dxWQo._)({}, $96b280a33643b696$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $96b280a33643b696$var$getLoadingNavigation(location, opts.submission);
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $96b280a33643b696$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $byzP8._)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        navigation = $96b280a33643b696$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        });
                        actionMatch = $96b280a33643b696$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $96b280a33643b696$var$ResultType.error,
                            error: $96b280a33643b696$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$96b280a33643b696$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($96b280a33643b696$var$isErrorResult(result)) {
                            boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $dxWQo._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($96b280a33643b696$var$isDeferredResult(result)) throw $96b280a33643b696$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $dxWQo._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $byzP8._)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || $96b280a33643b696$var$getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || $96b280a33643b696$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $8GFUW._)($96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $96b280a33643b696$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($96b280a33643b696$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        pendingNavigationLoadId = ++incrementingLoadId;
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect = $96b280a33643b696$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            startRedirectNavigation(state, redirect, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $96b280a33643b696$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $byzP8._)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, actionResult, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher, didAbortFetchLoads;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $96b280a33643b696$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        }
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher);
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if ($96b280a33643b696$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            fetchRedirectIds.add(key);
                            loadingFetcher = $96b280a33643b696$var$getLoadingFetcher(submission);
                            state.fetchers.set(key, loadingFetcher);
                            updateState({
                                fetchers: new Map(state.fetchers)
                            });
                            return [
                                2,
                                startRedirectNavigation(state, actionResult, {
                                    submission: submission,
                                    isFetchActionRedirect: true
                                })
                            ];
                        }
                        // Process any non-redirect errors thrown
                        if ($96b280a33643b696$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($96b280a33643b696$var$isDeferredResult(actionResult)) throw $96b280a33643b696$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $96b280a33643b696$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $96b280a33643b696$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $96b280a33643b696$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $8GFUW._)($96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $dxWQo._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $96b280a33643b696$var$findRedirect(results);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(state, redirect)
                        ];
                        _processLoaderData = $96b280a33643b696$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $96b280a33643b696$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        didAbortFetchLoads = abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $96b280a33643b696$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($96b280a33643b696$var$_extends({
                                errors: errors,
                                loaderData: $96b280a33643b696$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $byzP8._)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, result, boundaryMatch, doneFetcher;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        loadingFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$96b280a33643b696$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $96b280a33643b696$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (!$96b280a33643b696$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        // Process any non-redirect errors thrown
                        if ($96b280a33643b696$var$isErrorResult(result)) {
                            boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key);
                            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $dxWQo._)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $byzP8._)(function(state, redirect, _temp) {
            var _ref, submission, replace, isFetchActionRedirect, redirectLocation, url, isDifferentBasename, redirectHistoryAction, activeSubmission, overrideNavigation;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, replace = _ref.replace, isFetchActionRedirect = _ref.isFetchActionRedirect;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $96b280a33643b696$var$createLocation(state.location, redirect.location, $96b280a33643b696$var$_extends({
                            _isRedirect: true
                        }, isFetchActionRedirect ? {
                            _isFetchActionRedirect: true
                        } : {}));
                        $96b280a33643b696$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        // Check if this an absolute external redirect that goes to a new origin
                        if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
                            url = init.history.createURL(redirect.location);
                            isDifferentBasename = $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $96b280a33643b696$export$e19cd5f9376f8cee.Replace : $96b280a33643b696$export$e19cd5f9376f8cee.Push;
                        activeSubmission = submission || $96b280a33643b696$var$getSubmissionFromNavigation(state.navigation);
                        if (!($96b280a33643b696$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $96b280a33643b696$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $96b280a33643b696$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!isFetchActionRedirect) return [
                            3,
                            4
                        ];
                        // For a fetch action redirect, we kick off a new loading navigation
                        // without the fetcher submission, but we send it along for shouldRevalidate
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: $96b280a33643b696$var$getLoadingNavigation(redirectLocation),
                                fetcherSubmission: activeSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        overrideNavigation = $96b280a33643b696$var$getLoadingNavigation(redirectLocation, activeSubmission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $byzP8._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $fLnyw._)(matchesToLoad.map(function(match) {
                                return $96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $fLnyw._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $96b280a33643b696$var$callLoaderOrAction("loader", $96b280a33643b696$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $96b280a33643b696$var$ResultType.error,
                                        error: $96b280a33643b696$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $96b280a33643b696$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $96b280a33643b696$export$4d0306f8f6a4585b = Symbol("deferred");
function $96b280a33643b696$export$3336b097a6fbc59a(routes, opts) {
    $96b280a33643b696$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    var dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $byzP8._)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
                        matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD") {
                            error = $96b280a33643b696$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $dxWQo._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $96b280a33643b696$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $dxWQo._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($96b280a33643b696$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $96b280a33643b696$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $byzP8._)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
                        matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96b280a33643b696$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $96b280a33643b696$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $96b280a33643b696$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($96b280a33643b696$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$96b280a33643b696$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $byzP8._)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $96b280a33643b696$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$96b280a33643b696$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $96b280a33643b696$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $96b280a33643b696$var$isResponse(result1) ? result1 : $96b280a33643b696$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($96b280a33643b696$var$isQueryRouteResponse(e)) {
                            if (e.type === $96b280a33643b696$var$ResultType.error && !$96b280a33643b696$var$isRedirectResponse(e.response)) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($96b280a33643b696$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $byzP8._)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $96b280a33643b696$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $96b280a33643b696$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        _state.label = 3;
                    case 3:
                        if ($96b280a33643b696$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($96b280a33643b696$var$isDeferredResult(result)) {
                            error1 = $96b280a33643b696$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $96b280a33643b696$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($96b280a33643b696$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $dxWQo._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$96b280a33643b696$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $dxWQo._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $96b280a33643b696$var$_extends({}, context, {
                                statusCode: $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? (0, $dxWQo._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $96b280a33643b696$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $dxWQo._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? (0, $dxWQo._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $byzP8._)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $96b280a33643b696$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $dxWQo._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $fLnyw._)(matchesToLoad.map(function(match) {
                                return $96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        activeDeferreds = new Map();
                        context = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $96b280a33643b696$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $96b280a33643b696$export$fec11da027c70692(routes, context, error) {
    var newContext = $96b280a33643b696$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $dxWQo._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $96b280a33643b696$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $96b280a33643b696$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $96b280a33643b696$export$cae722b0cc860f13(to ? to : ".", $96b280a33643b696$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $96b280a33643b696$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$96b280a33643b696$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96b280a33643b696$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $96b280a33643b696$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $96b280a33643b696$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$96b280a33643b696$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96b280a33643b696$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96b280a33643b696$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $96b280a33643b696$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $96b280a33643b696$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $8GFUW._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96b280a33643b696$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($96b280a33643b696$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $96b280a33643b696$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $96b280a33643b696$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $96b280a33643b696$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $96b280a33643b696$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($96b280a33643b696$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $96b280a33643b696$var$shouldRevalidateLoader(match, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96b280a33643b696$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They only set `defaultShouldRevalidate` on
        // explicit revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        //
        // They automatically revalidate without even calling shouldRevalidate if:
        // - They were cancelled
        // - They're in the middle of their first load and therefore this is still
        //   an initial load and not a revalidation
        //
        // If neither of those is true, then they _always_ check shouldRevalidate
        var fetcher = state.fetchers.get(key);
        var isPerformingInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === undefined && // If a fetcher.load redirected then it'll be "loading" without any data
        // so ensure we're not processing the redirect from this fetcher
        !fetchRedirectIds.has(key);
        var fetcherMatch = $96b280a33643b696$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = cancelledFetcherLoads.includes(key) || isPerformingInitialLoad || $96b280a33643b696$var$shouldRevalidateLoader(fetcherMatch, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96b280a33643b696$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $96b280a33643b696$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96b280a33643b696$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $96b280a33643b696$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $96b280a33643b696$var$_loadLazyRouteModule.apply(this, arguments);
}
function $96b280a33643b696$var$_loadLazyRouteModule() {
    $96b280a33643b696$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $byzP8._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $96b280a33643b696$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $96b280a33643b696$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$96b280a33643b696$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $96b280a33643b696$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_loadLazyRouteModule.apply(this, arguments);
}
function $96b280a33643b696$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $96b280a33643b696$var$_callLoaderOrAction.apply(this, arguments);
}
function $96b280a33643b696$var$_callLoaderOrAction() {
    $96b280a33643b696$var$_callLoaderOrAction = (0, $byzP8._)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, data, contentType, _result$init, _result$init2;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler),
                            $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $96b280a33643b696$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $96b280a33643b696$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $96b280a33643b696$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $96b280a33643b696$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$96b280a33643b696$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($96b280a33643b696$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $96b280a33643b696$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) location = $96b280a33643b696$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $96b280a33643b696$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
                    throw {
                        type: resultType || $96b280a33643b696$var$ResultType.data,
                        response: result
                    };
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $96b280a33643b696$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $96b280a33643b696$export$acf1a680051f5031(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $96b280a33643b696$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($96b280a33643b696$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $96b280a33643b696$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($96b280a33643b696$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $96b280a33643b696$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96b280a33643b696$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $96b280a33643b696$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($96b280a33643b696$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $96b280a33643b696$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($96b280a33643b696$var$isErrorResult(result)) {
            var boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $96b280a33643b696$var$_extends({}, errors, (0, $dxWQo._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($96b280a33643b696$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($96b280a33643b696$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96b280a33643b696$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $96b280a33643b696$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $96b280a33643b696$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $fLnyw._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $96b280a33643b696$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96b280a33643b696$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $96b280a33643b696$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $96b280a33643b696$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($96b280a33643b696$var$isRedirectResult(result)) return result;
    }
}
function $96b280a33643b696$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(path) : path;
    return $96b280a33643b696$export$fe53371bee54353d($96b280a33643b696$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $96b280a33643b696$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $96b280a33643b696$var$isDeferredResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.deferred;
}
function $96b280a33643b696$var$isErrorResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.error;
}
function $96b280a33643b696$var$isRedirectResult(result) {
    return (result && result.type) === $96b280a33643b696$var$ResultType.redirect;
}
function $96b280a33643b696$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $96b280a33643b696$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96b280a33643b696$var$isRedirectResponse(result) {
    if (!$96b280a33643b696$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $96b280a33643b696$var$isQueryRouteResponse(obj) {
    return obj && $96b280a33643b696$var$isResponse(obj.response) && (obj.type === $96b280a33643b696$var$ResultType.data || $96b280a33643b696$var$ResultType.error);
}
function $96b280a33643b696$var$isValidMethod(method) {
    return $96b280a33643b696$var$validRequestMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$isMutationMethod(method) {
    return $96b280a33643b696$var$validMutationMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $96b280a33643b696$var$_resolveDeferredResults.apply(this, arguments);
}
function $96b280a33643b696$var$_resolveDeferredResults() {
    $96b280a33643b696$var$_resolveDeferredResults = (0, $byzP8._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$96b280a33643b696$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($96b280a33643b696$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    signal = signals[index];
                                    $96b280a33643b696$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $96b280a33643b696$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $7UAGh.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_resolveDeferredResults.apply(this, arguments);
}
function $96b280a33643b696$var$resolveDeferredData(result, signal, unwrap) {
    return $96b280a33643b696$var$_resolveDeferredData.apply(this, arguments);
}
function $96b280a33643b696$var$_resolveDeferredData() {
    $96b280a33643b696$var$_resolveDeferredData = (0, $byzP8._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_resolveDeferredData.apply(this, arguments);
}
function $96b280a33643b696$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $96b280a33643b696$var$createUseMatchesMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96b280a33643b696$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96b280a33643b696$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $96b280a33643b696$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96b280a33643b696$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $96b280a33643b696$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $96b280a33643b696$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96b280a33643b696$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher1;
    }
}
function $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $96b280a33643b696$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6OZAO = parcelRequire("6OZAO");

var $6cds3 = parcelRequire("6cds3");

function $4a3e215446c0ed92$var$_extends() {
    $4a3e215446c0ed92$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a3e215446c0ed92$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $4a3e215446c0ed92$export$3add0d5dce533e2e = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$export$145dfa71566a64dc = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$var$AwaitContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $4a3e215446c0ed92$export$26749e8557646306 = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$export$c7914228fb69b0f5 = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$export$9072aa6dd1f93057 = /*#__PURE__*/ $6cds3.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $4a3e215446c0ed92$var$RouteErrorContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4a3e215446c0ed92$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var _React_useContext = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4a3e215446c0ed92$export$9c954a9d03d32f4a() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4a3e215446c0ed92$export$45d76561a5302f2b() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4a3e215446c0ed92$export$1b3f31771c5d07c() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4a3e215446c0ed92$export$6c330e8992e8a295(pattern) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var pathname = $4a3e215446c0ed92$export$45d76561a5302f2b().pathname;
    return $6cds3.useMemo(function() {
        return (0, $96b280a33643b696$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $4a3e215446c0ed92$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6cds3.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4a3e215446c0ed92$export$9770f232ac06a008() {
    var isDataRoute = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4a3e215446c0ed92$var$useNavigateStable() : $4a3e215446c0ed92$var$useNavigateUnstable();
}
function $4a3e215446c0ed92$var$useNavigateUnstable() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    var _React_useContext = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var _useLocation = $4a3e215446c0ed92$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $4a3e215446c0ed92$var$OutletContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4a3e215446c0ed92$export$4138103a3ae699cc() {
    return $6cds3.useContext($4a3e215446c0ed92$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4a3e215446c0ed92$export$a3be3530d8e40d0b(context) {
    var outlet = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4a3e215446c0ed92$export$99eaa27ddbbb95ef() {
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var _useLocation = $4a3e215446c0ed92$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $6cds3.useMemo(function() {
        return (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4a3e215446c0ed92$export$5d3fca4a98652595(routes, locationArg) {
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var navigator = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).navigator;
    var _React_useContext = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $4a3e215446c0ed92$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $96b280a33643b696$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $4a3e215446c0ed92$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4a3e215446c0ed92$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a3e215446c0ed92$var$DefaultErrorComponent() {
    var error = $4a3e215446c0ed92$export$ed527bf60f6e05f2();
    var message = (0, $96b280a33643b696$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6cds3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6cds3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $4a3e215446c0ed92$var$defaultErrorElement = /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DefaultErrorComponent, null);
var $4a3e215446c0ed92$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ftJVG._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $6OZAO._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $978gY._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $kry2a._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($6cds3.Component);
function $4a3e215446c0ed92$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4a3e215446c0ed92$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $4a3e215446c0ed92$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6cds3.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4a3e215446c0ed92$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($4a3e215446c0ed92$var$DataRouterHook || ($4a3e215446c0ed92$var$DataRouterHook = {}));
var $4a3e215446c0ed92$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($4a3e215446c0ed92$var$DataRouterStateHook || ($4a3e215446c0ed92$var$DataRouterStateHook = {}));
function $4a3e215446c0ed92$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a3e215446c0ed92$var$useDataRouterContext(hookName) {
    var ctx = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a3e215446c0ed92$var$useDataRouterState(hookName) {
    var state = $6cds3.useContext($4a3e215446c0ed92$export$145dfa71566a64dc);
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
function $4a3e215446c0ed92$var$useRouteContext(hookName) {
    var route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4a3e215446c0ed92$var$useCurrentRouteId(hookName) {
    var route = $4a3e215446c0ed92$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4a3e215446c0ed92$export$5fc8298006ad9e58() {
    return $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4a3e215446c0ed92$export$d0fd4b7106de2769() {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4a3e215446c0ed92$export$600dc272ed516c15() {
    var dataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseRevalidator);
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4a3e215446c0ed92$export$2378eb7f5ff86053() {
    var _useDataRouterState = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $6cds3.useMemo(function() {
        return matches.map(function(match) {
            var pathname = match.pathname, params = match.params;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4a3e215446c0ed92$export$1448a5050d252c4d() {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    var routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4a3e215446c0ed92$export$fd5d37484eab868d(routeId) {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4a3e215446c0ed92$export$fdc00f3f26066d5e() {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseActionData);
    var route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4a3e215446c0ed92$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $6cds3.useContext($4a3e215446c0ed92$var$RouteErrorContext);
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    var routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $4a3e215446c0ed92$export$78a72ddb39bdd145() {
    var value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $4a3e215446c0ed92$export$17f53340677d5831() {
    var value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $4a3e215446c0ed92$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4a3e215446c0ed92$export$2af03a1de5c0910(shouldBlock) {
    var _useDataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $8GFUW._)($6cds3.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $6cds3.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $4a3e215446c0ed92$var$_extends({}, currentLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4a3e215446c0ed92$var$_extends({}, nextLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6cds3.useEffect(function() {
        var key = String(++$4a3e215446c0ed92$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6cds3.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $96b280a33643b696$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4a3e215446c0ed92$var$useNavigateStable() {
    var router = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseNavigateStable).router;
    var id = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4a3e215446c0ed92$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $4a3e215446c0ed92$var$alreadyWarned = {};
function $4a3e215446c0ed92$var$warningOnce(key, cond, message) {
    if (!cond && !$4a3e215446c0ed92$var$alreadyWarned[key]) $4a3e215446c0ed92$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $4a3e215446c0ed92$var$START_TRANSITION = "startTransition";
var $4a3e215446c0ed92$var$startTransitionImpl = $6cds3[$4a3e215446c0ed92$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a3e215446c0ed92$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    var _React_useState = (0, $8GFUW._)($6cds3.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $6cds3.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $6cds3.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $4a3e215446c0ed92$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4a3e215446c0ed92$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4a3e215446c0ed92$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var _useLocation = $4a3e215446c0ed92$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $4a3e215446c0ed92$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, (0, $96b280a33643b696$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $6cds3.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4a3e215446c0ed92$export$910ae8079b2c2852(props) {
    return $4a3e215446c0ed92$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4a3e215446c0ed92$export$e7b0ac011bb776c6(_props) {
    (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4a3e215446c0ed92$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $6cds3.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $6cds3.useMemo(function() {
        var trailingPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4a3e215446c0ed92$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $4a3e215446c0ed92$export$5d3fca4a98652595($4a3e215446c0ed92$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4a3e215446c0ed92$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$ResolveAwait, null, children));
}
var $4a3e215446c0ed92$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($4a3e215446c0ed92$var$AwaitRenderStatus || ($4a3e215446c0ed92$var$AwaitRenderStatus = {}));
var $4a3e215446c0ed92$var$neverSettledPromise = new Promise(function() {});
var $4a3e215446c0ed92$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ftJVG._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $6OZAO._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $978gY._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $kry2a._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $4a3e215446c0ed92$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $4a3e215446c0ed92$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.error : promise._data !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.success : $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && promise._error instanceof (0, $96b280a33643b696$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $4a3e215446c0ed92$var$neverSettledPromise;
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($6cds3.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $4a3e215446c0ed92$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $4a3e215446c0ed92$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4a3e215446c0ed92$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $6cds3.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $6cds3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $fLnyw._)(parentPath).concat([
            index
        ]);
        if (element.type === $6cds3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4a3e215446c0ed92$export$e7b0ac011bb776c6) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4a3e215446c0ed92$export$daf73786167a7f72(matches) {
    return $4a3e215446c0ed92$var$_renderMatches(matches);
}
function $4a3e215446c0ed92$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6cds3.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6cds3.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4a3e215446c0ed92$export$f30f7e456d254e83(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a3e215446c0ed92$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4a3e215446c0ed92$export$52b333d321859367
    }).initialize();
}



function $0e36e707c39d0f3a$var$_extends() {
    $0e36e707c39d0f3a$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e36e707c39d0f3a$var$_extends.apply(this, arguments);
}
function $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e36e707c39d0f3a$var$defaultMethod = "get";
var $0e36e707c39d0f3a$var$defaultEncType = "application/x-www-form-urlencoded";
function $0e36e707c39d0f3a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0e36e707c39d0f3a$var$isButtonElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0e36e707c39d0f3a$var$isFormElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0e36e707c39d0f3a$var$isInputElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0e36e707c39d0f3a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0e36e707c39d0f3a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0e36e707c39d0f3a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
                    searchParams.append(key, value);
                });
            };
            for(var _iterator = defaultSearchParams.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return searchParams;
}
// One-time check for submitter support
var $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = null;
function $0e36e707c39d0f3a$var$isFormDataSubmitterSupported() {
    if ($0e36e707c39d0f3a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = true;
    }
    return $0e36e707c39d0f3a$var$_formDataSupportsSubmitter;
}
var $0e36e707c39d0f3a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0e36e707c39d0f3a$var$getFormEncType(encType) {
    if (encType != null && !$0e36e707c39d0f3a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($0e36e707c39d0f3a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0e36e707c39d0f3a$var$isButtonElement(target) || $0e36e707c39d0f3a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("formenctype")) || $0e36e707c39d0f3a$var$getFormEncType(form.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0e36e707c39d0f3a$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0e36e707c39d0f3a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0e36e707c39d0f3a$var$defaultMethod;
        action = null;
        encType = $0e36e707c39d0f3a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $0e36e707c39d0f3a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $0e36e707c39d0f3a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $0e36e707c39d0f3a$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $0e36e707c39d0f3a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367)
    }).initialize();
}
function $0e36e707c39d0f3a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367)
    }).initialize();
}
function $0e36e707c39d0f3a$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0e36e707c39d0f3a$var$_extends({}, state, {
        errors: $0e36e707c39d0f3a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0e36e707c39d0f3a$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $96b280a33643b696$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                var error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $0e36e707c39d0f3a$var$START_TRANSITION = "startTransition";
var $0e36e707c39d0f3a$var$startTransitionImpl = $6cds3[$0e36e707c39d0f3a$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54(_ref) {
    var basename = _ref.basename, children = _ref.children, future = _ref.future, _$window = _ref.window;
    var historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0e36e707c39d0f3a$export$7221d69dcfc8e36b(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, future = _ref2.future, _$window = _ref2.window;
    var historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0e36e707c39d0f3a$export$eefb0c834599897e(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, future = _ref3.future, history = _ref3.history;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $0e36e707c39d0f3a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var $0e36e707c39d0f3a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6cds3.forwardRef(function LinkWithRef(_ref4, ref) {
    var handleClick = function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    };
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref4, $0e36e707c39d0f3a$var$_excluded);
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0e36e707c39d0f3a$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $96b280a33643b696$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $4a3e215446c0ed92$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $0e36e707c39d0f3a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6cds3.createElement("a", $0e36e707c39d0f3a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $0e36e707c39d0f3a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6cds3.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref5, $0e36e707c39d0f3a$var$_excluded2);
    var path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var routerState = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    var navigator = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a6c7ac8248d6e38a, $0e36e707c39d0f3a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $0e36e707c39d0f3a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6cds3.forwardRef(function(props, ref) {
    var submit = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$FormImpl, $0e36e707c39d0f3a$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
var $0e36e707c39d0f3a$var$FormImpl = /*#__PURE__*/ $6cds3.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? $0e36e707c39d0f3a$var$defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, submit = _ref6.submit, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref6, $0e36e707c39d0f3a$var$_excluded3);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $6cds3.createElement("form", $0e36e707c39d0f3a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0e36e707c39d0f3a$export$11aac1aab828f1fa(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    $0e36e707c39d0f3a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0e36e707c39d0f3a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($0e36e707c39d0f3a$var$DataRouterHook || ($0e36e707c39d0f3a$var$DataRouterHook = {}));
var $0e36e707c39d0f3a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0e36e707c39d0f3a$var$DataRouterStateHook || ($0e36e707c39d0f3a$var$DataRouterStateHook = {}));
function $0e36e707c39d0f3a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0e36e707c39d0f3a$var$useDataRouterContext(hookName) {
    var ctx = $6cds3.useContext((0, $4a3e215446c0ed92$export$3add0d5dce533e2e));
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e36e707c39d0f3a$var$useDataRouterState(hookName) {
    var state = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0e36e707c39d0f3a$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6cds3.useCallback(function(event) {
        if ($0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $96b280a33643b696$export$fe53371bee54353d)(location) === (0, $96b280a33643b696$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0e36e707c39d0f3a$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $6cds3.useRef($0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $6cds3.useRef(false);
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var searchParams = $6cds3.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0e36e707c39d0f3a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var setSearchParams = $6cds3.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0e36e707c39d0f3a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0e36e707c39d0f3a$export$47c85c6e3a081d3() {
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmit).router;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    var currentRouteId = (0, $4a3e215446c0ed92$export$5fc8298006ad9e58)();
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $0e36e707c39d0f3a$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmitFetcher).router;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        !(fetcherRouteId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    var routeContext = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !routeContext && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $8GFUW._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $0e36e707c39d0f3a$var$_extends({}, (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $96b280a33643b696$export$fe53371bee54353d)(path);
}
function $0e36e707c39d0f3a$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $6cds3.forwardRef(function(props, ref) {
        var submit = $0e36e707c39d0f3a$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$FormImpl, $0e36e707c39d0f3a$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
var $0e36e707c39d0f3a$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0e36e707c39d0f3a$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseFetcher).router;
    var route = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var _React_useState = (0, $8GFUW._)($6cds3.useState(function() {
        return String(++$0e36e707c39d0f3a$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $8GFUW._)($6cds3.useState(function() {
        !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        return $0e36e707c39d0f3a$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $8GFUW._)($6cds3.useState(function() {
        return function(href) {
            !router && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
            !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $0e36e707c39d0f3a$var$useSubmitFetcher(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $6cds3.useMemo(function() {
        return $0e36e707c39d0f3a$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $6cds3.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0e36e707c39d0f3a$export$fa996778a3a31087() {
    var state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetchers);
    return (0, $fLnyw._)(state.fetchers.values());
}
var $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $0e36e707c39d0f3a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0e36e707c39d0f3a$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var matches = (0, $4a3e215446c0ed92$export$2378eb7f5ff86053)();
    var navigation = (0, $4a3e215446c0ed92$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6cds3.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0e36e707c39d0f3a$var$usePageHide($6cds3.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $0e36e707c39d0f3a$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0e36e707c39d0f3a$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0e36e707c39d0f3a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($0e36e707c39d0f3a$var$_extends({}, location, {
                    pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0e36e707c39d0f3a$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $6cds3.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $6cds3.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0e36e707c39d0f3a$export$39f4eb3dbd812741(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, $4a3e215446c0ed92$export$2af03a1de5c0910)(when);
    $6cds3.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $6cds3.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}



var $byzP8 = parcelRequire("byzP8");


var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");


var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");



var $dab50cebba406f42$export$dca1ee5a936bb312 = (0, $817718bbc98c41ca$export$87dc52566e90b739)("inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var $dab50cebba406f42$export$353f5b6fc5456de1 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, size = _param.size, _param_asChild = _param.asChild, asChild = _param_asChild === void 0 ? false : _param_asChild, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "variant",
        "size",
        "asChild"
    ]);
    var Comp = asChild ? (0, $513654131ef3bd4b$export$8c6ed5c666ac1360) : "button";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Comp, (0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)($dab50cebba406f42$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref
    }, props));
});
$dab50cebba406f42$export$353f5b6fc5456de1.displayName = "Button";


var $9a83d8baa1aa3084$export$bba18cbf7d7dd729 = {
    name: "Transpact",
    description: "An DApp based on NEAR Protocol",
    url: "https://main--luxury-entremet-53224c.netlify.app/",
    ogImage: "https://tx.shadcn.com/og.jpg",
    links: {
        twitter: "https://devpost.com/software/transparent-contract",
        github: "https://github.com/hackArchive/Transpact/"
    }
};



var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");

var $3e3432b9f3194b83$export$ba15ad942ef5ab4f = {
    mainNav: [
        {
            title: "List",
            href: "/dashboard/lister"
        },
        {
            title: "Bid",
            href: "/dashboard/bidder"
        },
        {
            title: "Features",
            href: "/#features"
        },
        {
            title: "Pricing",
            href: "/pricing",
            disabled: true
        },
        {
            title: "Blog",
            href: "/blog",
            disabled: true
        },
        {
            title: "Documentation",
            href: "/docs",
            disabled: true
        }
    ]
};




var $8GFUW = parcelRequire("8GFUW");


var $6cds3 = parcelRequire("6cds3");





var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $2fb20c0723c84e47$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("AlertTriangle", [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
            key: "c3ski4"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $aa6ef40c51a2cf33$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $971f03f1ae2c8c7a$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Check", [
    [
        "polyline",
        {
            points: "20 6 9 17 4 12",
            key: "10jjfj"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $625d457db8fc666f$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("ChevronLeft", [
    [
        "polyline",
        {
            points: "15 18 9 12 15 6",
            key: "kvxz59"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $96fc56be218b0aba$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("ChevronRight", [
    [
        "polyline",
        {
            points: "9 18 15 12 9 6",
            key: "1rtp27"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $4dd346d464add6cd$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Command", [
    [
        "path",
        {
            d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3",
            key: "11bfej"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $f1d7775b0968586a$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("CreditCard", [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "5",
            rx: "2",
            key: "ynyp8z"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "10",
            y2: "10",
            key: "1b3vmo"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $10b631b021f21c45$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Edit", [
    [
        "path",
        {
            d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
            key: "1qinfi"
        }
    ],
    [
        "path",
        {
            d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
            key: "1cs3r3"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $6f5fc5e8f4e88341$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("File", [
    [
        "path",
        {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            key: "1nnpy2"
        }
    ],
    [
        "polyline",
        {
            points: "14 2 14 8 20 8",
            key: "1ew0cm"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $d5bf4661f125807a$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("FileText", [
    [
        "path",
        {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            key: "1nnpy2"
        }
    ],
    [
        "polyline",
        {
            points: "14 2 14 8 20 8",
            key: "1ew0cm"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "8",
            y1: "13",
            y2: "13",
            key: "14keom"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "8",
            y1: "17",
            y2: "17",
            key: "17nazh"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "8",
            y1: "9",
            y2: "9",
            key: "1a5vjj"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $66317aed6efbeb0d$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("HelpCircle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $11e7aa118240ba21$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Image", [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            key: "1m3agn"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $ee646d422b3fa5c6$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Info", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $1d2910e80daa3f71$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Laptop", [
    [
        "path",
        {
            d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
            key: "tarvll"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $50cae1d6b3e4e183$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("LayoutDashboard", [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $6e69421017c5d994$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Loader2", [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $a550248eb21f0bca$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Moon", [
    [
        "path",
        {
            d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z",
            key: "a7tn18"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $da0a61a8fcd4b957$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("MoreVertical", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "5",
            r: "1",
            key: "gxeob9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "19",
            r: "1",
            key: "lyex9k"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $9c80ff1b6b0c778d$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Package", [
    [
        "path",
        {
            d: "M16.5 9.4 7.55 4.24",
            key: "10qotr"
        }
    ],
    [
        "path",
        {
            d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
            key: "yt0hxn"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "22",
            y2: "12",
            key: "a4e8g8"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $9c529b3f1aa4cc41$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Pizza", [
    [
        "path",
        {
            d: "M15 11h.01",
            key: "rns66s"
        }
    ],
    [
        "path",
        {
            d: "M11 15h.01",
            key: "k85uqc"
        }
    ],
    [
        "path",
        {
            d: "M16 16h.01",
            key: "1f9h7w"
        }
    ],
    [
        "path",
        {
            d: "m2 16 20 6-6-20A20 20 0 0 0 2 16",
            key: "e4slt2"
        }
    ],
    [
        "path",
        {
            d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4",
            key: "rerf8f"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $219670c0a281ed9c$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Plus", [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "5",
            y2: "19",
            key: "pwfkuu"
        }
    ],
    [
        "line",
        {
            x1: "5",
            x2: "19",
            y1: "12",
            y2: "12",
            key: "13b5wn"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $51c343eeedc916c2$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("PlusCircle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "16",
            key: "10p56q"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "12",
            y2: "12",
            key: "1jonct"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $89a4c2cfa8668254$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $258f11cfa8d6c923$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("SunMedium", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 3v1",
            key: "1asbbs"
        }
    ],
    [
        "path",
        {
            d: "M12 20v1",
            key: "1wcdkc"
        }
    ],
    [
        "path",
        {
            d: "M3 12h1",
            key: "lp3yf2"
        }
    ],
    [
        "path",
        {
            d: "M20 12h1",
            key: "1vloll"
        }
    ],
    [
        "path",
        {
            d: "m18.364 5.636-.707.707",
            key: "1hakh0"
        }
    ],
    [
        "path",
        {
            d: "m6.343 17.657-.707.707",
            key: "18m9nf"
        }
    ],
    [
        "path",
        {
            d: "m5.636 5.636.707.707",
            key: "1xv1c5"
        }
    ],
    [
        "path",
        {
            d: "m17.657 17.657.707.707",
            key: "vl76zb"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $4204b5ede9bd9041$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Trash", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $8fd6600589db4431$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Twitter", [
    [
        "path",
        {
            d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
            key: "pff0z6"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $b74e69a643bf0311$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("User", [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $7cea5baf0da2cd06$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("UserPlus", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "19",
            y1: "8",
            y2: "14",
            key: "1bvyxn"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "11",
            y2: "11",
            key: "1shjgl"
        }
    ]
]);

/**
 * lucide-react v0.257.0 - ISC
 */ 
var $3b99232527110744$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Users", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "path",
        {
            d: "M16 3.13a4 4 0 0 1 0 7.75",
            key: "1da9ce"
        }
    ]
]);


var $0e4adbb94da664e1$export$4f13f83fd8bb1dac = {
    logo: (0, $4dd346d464add6cd$export$2e2bcd8739ae039),
    close: (0, $aadbdee67ef521af$export$2e2bcd8739ae039),
    spinner: (0, $6e69421017c5d994$export$2e2bcd8739ae039),
    chevronLeft: (0, $625d457db8fc666f$export$2e2bcd8739ae039),
    chevronRight: (0, $96fc56be218b0aba$export$2e2bcd8739ae039),
    trash: (0, $4204b5ede9bd9041$export$2e2bcd8739ae039),
    post: (0, $d5bf4661f125807a$export$2e2bcd8739ae039),
    page: (0, $6f5fc5e8f4e88341$export$2e2bcd8739ae039),
    media: (0, $11e7aa118240ba21$export$2e2bcd8739ae039),
    settings: (0, $89a4c2cfa8668254$export$2e2bcd8739ae039),
    billing: (0, $f1d7775b0968586a$export$2e2bcd8739ae039),
    ellipsis: (0, $da0a61a8fcd4b957$export$2e2bcd8739ae039),
    add: (0, $219670c0a281ed9c$export$2e2bcd8739ae039),
    warning: (0, $2fb20c0723c84e47$export$2e2bcd8739ae039),
    user: (0, $b74e69a643bf0311$export$2e2bcd8739ae039),
    arrowRight: (0, $aa6ef40c51a2cf33$export$2e2bcd8739ae039),
    help: (0, $66317aed6efbeb0d$export$2e2bcd8739ae039),
    pizza: (0, $9c529b3f1aa4cc41$export$2e2bcd8739ae039),
    sun: (0, $258f11cfa8d6c923$export$2e2bcd8739ae039),
    moon: (0, $a550248eb21f0bca$export$2e2bcd8739ae039),
    laptop: (0, $1d2910e80daa3f71$export$2e2bcd8739ae039),
    package: (0, $9c80ff1b6b0c778d$export$2e2bcd8739ae039),
    dashboard: (0, $50cae1d6b3e4e183$export$2e2bcd8739ae039),
    edit: (0, $10b631b021f21c45$export$2e2bcd8739ae039),
    userPlus: (0, $7cea5baf0da2cd06$export$2e2bcd8739ae039),
    plusCircle: (0, $51c343eeedc916c2$export$2e2bcd8739ae039),
    info: (0, $ee646d422b3fa5c6$export$2e2bcd8739ae039),
    gitHub: function(_param) /*#__PURE__*/ {
        var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
        return (0, $fba0f23e9e6a11bb$exports.jsx)("svg", (0, $8E768._)((0, $8OnJk._)({
            "aria-hidden": "true",
            focusable: "false",
            "data-prefix": "fab",
            "data-icon": "github",
            role: "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 496 512"
        }, props), {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fill: "currentColor",
                d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
            })
        }));
    },
    twitter: (0, $8fd6600589db4431$export$2e2bcd8739ae039),
    check: (0, $971f03f1ae2c8c7a$export$2e2bcd8739ae039),
    users: (0, $3b99232527110744$export$2e2bcd8739ae039)
};



parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
function $fabb7e54fc6c3cc4$export$6cb73ce3da5a9e7b() {
    $6cds3.useLayoutEffect(function() {
        var originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = "hidden";
        return function() {
            return document.body.style.overflow = originalStyle;
        };
    }, []);
}




function $ffa0a3c40ae07149$export$3a923eed7dfec49a(param) {
    var items = param.items, children = param.children;
    (0, $fabb7e54fc6c3cc4$export$6cb73ce3da5a9e7b)();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("fixed inset-0 top-16 z-50 grid h-[calc(100vh-4rem)] grid-flow-row auto-rows-max overflow-auto p-6 pb-32 shadow-md animate-in slide-in-from-bottom-80 md:hidden"),
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "relative z-20 grid gap-6 rounded-md bg-popover p-4 text-popover-foreground shadow-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                    to: "/",
                    className: "flex items-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).logo, {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: "font-bold",
                            children: (0, $9a83d8baa1aa3084$export$bba18cbf7d7dd729).name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("nav", {
                    className: "grid grid-flow-row auto-rows-max text-sm",
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                            to: item.disabled ? "#" : item.href,
                            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex w-full items-center rounded-md p-2 text-sm font-medium hover:underline", item.disabled && "cursor-not-allowed opacity-60"),
                            children: item.title
                        }, index);
                    })
                }),
                children
            ]
        })
    });
}



function $e773a99b452aacad$export$4418626cb10d22e4(param) {
    var items = param.items, children = param.children;
    // const segment = useSelectedLayoutSegment();
    var _React_useState = (0, $8GFUW._)($6cds3.useState(false), 2), showMobileMenu = _React_useState[0], setShowMobileMenu = _React_useState[1];
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex gap-6 md:gap-10",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "hidden items-center space-x-2 md:flex",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).logo, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        className: "hidden font-bold sm:inline-block",
                        children: (0, $9a83d8baa1aa3084$export$bba18cbf7d7dd729).name
                    })
                ]
            }),
            (items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("nav", {
                className: "hidden gap-6 md:flex",
                children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$b0d92dbee9b5b60d), {
                        to: item.disabled ? "#" : item.href,
                        className: function(param) {
                            var isActive = param.isActive;
                            return (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex items-center text-lg font-medium transition-colors hover:text-foreground/80 sm:text-sm", isActive ? "text-foreground" : "text-foreground/60", item.disabled && "cursor-not-allowed opacity-80");
                        },
                        children: item.title
                    }, index);
                })
            }) : null,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                className: "flex items-center space-x-2 md:hidden",
                onClick: function() {
                    return setShowMobileMenu(!showMobileMenu);
                },
                children: [
                    showMobileMenu ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).close, {}) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).logo, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        className: "font-bold",
                        children: "Menu"
                    })
                ]
            }),
            showMobileMenu && items && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ffa0a3c40ae07149$export$3a923eed7dfec49a), {
                items: items,
                children: children
            })
        ]
    });
}



parcelRequire("6cds3");



parcelRequire("6cds3");


var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");



var $6cds3 = parcelRequire("6cds3");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");


var $6cds3 = parcelRequire("6cds3");






var $8OnJk = parcelRequire("8OnJk");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");


var $6cds3 = parcelRequire("6cds3");





var $6cds3 = parcelRequire("6cds3");
var $ad4cf16c545e595a$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $6cds3.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ var $ad4cf16c545e595a$export$c760c09fdd558351 = function(props) {
    var dir = props.dir, children = props.children;
    return /*#__PURE__*/ (0, $6cds3.createElement)($ad4cf16c545e595a$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $ad4cf16c545e595a$export$b39126d51d94e6f3(localDir) {
    var globalDir = (0, $6cds3.useContext)($ad4cf16c545e595a$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $ad4cf16c545e595a$export$2881499e37b75b9a = $ad4cf16c545e595a$export$c760c09fdd558351;




var $6cds3 = parcelRequire("6cds3");
/** Number of components which have requested interest to have focus guards */ var $6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$count = 0;
function $6b90108589ddc0b8$export$ac5b58043b79449b(props) {
    $6b90108589ddc0b8$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $6b90108589ddc0b8$export$b7ece24a22aeda8c() {
    (0, $6cds3.useEffect)(function() {
        var _edgeGuards$, _edgeGuards$2;
        var edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$count++;
        return function() {
            if ($6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(function(node) {
                return node.remove();
            });
            $6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $6b90108589ddc0b8$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    var element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
var $6b90108589ddc0b8$export$be92b6f5f03c0fe9 = $6b90108589ddc0b8$export$ac5b58043b79449b;




var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");


var $6cds3 = parcelRequire("6cds3");



var $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ var $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0ab32e587c90dbe2$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var tmp = props.loop, loop = tmp === void 0 ? false : tmp, tmp1 = props.trapped, trapped = tmp1 === void 0 ? false : tmp1, onMountAutoFocusProp = props.onMountAutoFocus, onUnmountAutoFocusProp = props.onUnmountAutoFocus, scopeProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "loop",
        "trapped",
        "onMountAutoFocus",
        "onUnmountAutoFocus"
    ]);
    var _$45QHv$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), container1 = _$45QHv$useState[0], setContainer = _$45QHv$useState[1];
    var onMountAutoFocus = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    var onUnmountAutoFocus = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    var lastFocusedElementRef = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setContainer(node);
    });
    var focusScope = (0, $6cds3.useRef)({
        paused: false,
        pause: function() {
            this.paused = true;
        },
        resume: function() {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $6cds3.useEffect)(function() {
        if (trapped) {
            var handleFocusIn = function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                var target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            };
            var handleFocusOut = function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                var relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            ;
            var handleMutations = // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                var focusedElement = document.activeElement;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        if (mutation.removedNodes.length > 0) {
                            if (!(container1 !== null && container1 !== void 0 && container1.contains(focusedElement))) $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(container1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            var mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return function() {
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $6cds3.useEffect)(function() {
        if (container1) {
            $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            var previouslyFocusedElement = document.activeElement;
            var hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                var mountEvent = new CustomEvent($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focusFirst($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$removeLinks($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return function() {
                container1.removeEventListener($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(function() {
                    var unmountEvent = new CustomEvent($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    var handleKeyDown = (0, $6cds3.useCallback)(function(event) {
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        var isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        var focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            var container = event.currentTarget;
            var _$d3863c46a17e8a28$var$getTabbableEdges = (0, $8GFUW._)($0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$getTabbableEdges(container), 2), first = _$d3863c46a17e8a28$var$getTabbableEdges[0], last = _$d3863c46a17e8a28$var$getTabbableEdges[1];
            var hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0ab32e587c90dbe2$export$20e40289641fbbb6, {
    displayName: $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focusFirst(candidates) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.select, select = tmp === void 0 ? false : tmp;
    var previouslyFocusedElement = document.activeElement;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(candidate, {
                select: select
            });
            if (document.activeElement !== previouslyFocusedElement) return;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    var candidates = $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    var first = $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    var last = $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    var nodes = [];
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            // we stop checking if it's hidden at the `container` level (excluding)
            if (!$0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$isHidden(element, {
                upTo: container
            })) return element;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$isHidden(node, param) {
    var upTo = param.upTo;
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focus(element) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.select, select = tmp === void 0 ? false : tmp;
    // only focus if that element is focusable
    if (element && element.focus) {
        var previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ var $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$focusScopesStack = $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ var stack = [];
    return {
        add: function(focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            var activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove: function(focusScope) {
            var _stack$;
            stack = $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    var updatedArray = (0, $fLnyw._)(array);
    var index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0ab32e587c90dbe2$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter(function(item) {
        return item.tagName !== "A";
    });
}
var $0ab32e587c90dbe2$export$be92b6f5f03c0fe9 = $0ab32e587c90dbe2$export$20e40289641fbbb6;



var $8GFUW = parcelRequire("8GFUW");

var $6cds3 = parcelRequire("6cds3");

var $3a7a3a6a18539928$var$$1746a345f3d73bb7$var$useReactId = $6cds3["useId".toString()] || function() {
    return undefined;
};
var $3a7a3a6a18539928$var$$1746a345f3d73bb7$var$count = 0;
function $3a7a3a6a18539928$export$f680877a34711e37(deterministicId) {
    var _$2AODx$react_useState = (0, $8GFUW._)($6cds3.useState($3a7a3a6a18539928$var$$1746a345f3d73bb7$var$useReactId()), 2), id = _$2AODx$react_useState[0], setId = _$2AODx$react_useState[1]; // React versions older than 18 will have client-side ids only.
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        if (!deterministicId) setId(function(reactId) {
            return reactId !== null && reactId !== void 0 ? reactId : String($3a7a3a6a18539928$var$$1746a345f3d73bb7$var$count++);
        });
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? "radix-".concat(id) : "");
}



var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");


var $6cds3 = parcelRequire("6cds3");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $1ObTH = parcelRequire("1ObTH");

var $byzP8 = parcelRequire("byzP8");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");
function $f5dbeeabf004a4ed$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $f5dbeeabf004a4ed$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $f5dbeeabf004a4ed$var$getSide(placement) {
    return placement.split("-")[0];
}
function $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($f5dbeeabf004a4ed$var$getSide(placement)) ? "x" : "y";
}
function $f5dbeeabf004a4ed$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var mainAxis = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement);
    var length = $f5dbeeabf004a4ed$var$getLengthFromAxis(mainAxis);
    var commonAlign = reference[length] / 2 - floating[length] / 2;
    var side = $f5dbeeabf004a4ed$var$getSide(placement);
    var isVertical = mainAxis === "x";
    var coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($f5dbeeabf004a4ed$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var $f5dbeeabf004a4ed$export$48a53dcb22e581d0 = function() {
    var _ref = (0, $byzP8._)(function(reference, floating, config) {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware_i, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? "bottom" : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? "absolute" : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    validMiddleware = middleware.filter(Boolean);
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = $f5dbeeabf004a4ed$var$computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    middlewareData = {};
                    resetCount = 0;
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < validMiddleware.length)) return [
                        3,
                        11
                    ];
                    _validMiddleware_i = validMiddleware[i], name = _validMiddleware_i.name, fn = _validMiddleware_i.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platform,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData = (0, $8E768._)((0, $8OnJk._)({}, middlewareData), (0, $dxWQo._)({}, name, (0, $8OnJk._)({}, middlewareData[name], data)));
                    if (!(reset && resetCount <= 50)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!(typeof reset === "object")) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = $f5dbeeabf004a4ed$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    return [
                        3,
                        10
                    ];
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    });
    return function computePosition(reference, floating, config) {
        return _ref.apply(this, arguments);
    };
}();
function $f5dbeeabf004a4ed$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $f5dbeeabf004a4ed$var$expandPaddingObject(padding) {
    return (0, $8OnJk._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $f5dbeeabf004a4ed$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $f5dbeeabf004a4ed$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f5dbeeabf004a4ed$export$ee05aea0aeecbad4(rect) {
    return (0, $8E768._)((0, $8OnJk._)({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, options) {
    return $f5dbeeabf004a4ed$var$_detectOverflow.apply(this, arguments);
}
function $f5dbeeabf004a4ed$var$_detectOverflow() {
    $f5dbeeabf004a4ed$var$_detectOverflow = /**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ (0, $byzP8._)(function(state, options) {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? "clippingAncestors" : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? "viewport" : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? "floating" : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = $f5dbeeabf004a4ed$var$getSideObjectFromPadding(padding);
                    altContext = elementContext === "floating" ? "reference" : "floating";
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = $f5dbeeabf004a4ed$export$ee05aea0aeecbad4.apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === "floating" ? (0, $8E768._)((0, $8OnJk._)({}, rects.floating), {
                        x: x,
                        y: y
                    }) : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = $f5dbeeabf004a4ed$export$ee05aea0aeecbad4.apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    });
    return $f5dbeeabf004a4ed$var$_detectOverflow.apply(this, arguments);
}
var $f5dbeeabf004a4ed$var$min = Math.min;
var $f5dbeeabf004a4ed$var$max = Math.max;
function $f5dbeeabf004a4ed$var$within(min$1, value, max$1) {
    return $f5dbeeabf004a4ed$var$max(min$1, $f5dbeeabf004a4ed$var$min(value, max$1));
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var $f5dbeeabf004a4ed$export$f2120bbfa5450bd2 = function(options) {
    return {
        name: "arrow",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var x, y, placement, rects, platform, elements, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _ref = $f5dbeeabf004a4ed$var$evaluate(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = $f5dbeeabf004a4ed$var$getSideObjectFromPadding(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement);
                            length = $f5dbeeabf004a4ed$var$getLengthFromAxis(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === "y";
                            minProp = isYAxis ? "top" : "left";
                            maxProp = isYAxis ? "bottom" : "right";
                            clientProp = isYAxis ? "clientHeight" : "clientWidth";
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = $f5dbeeabf004a4ed$var$min(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = $f5dbeeabf004a4ed$var$min(paddingObject[maxProp], largestPossiblePadding);
                            min$1 = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = $f5dbeeabf004a4ed$var$within(min$1, center, max);
                            shouldAddOffset = $f5dbeeabf004a4ed$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min$1 ? min$1 - center : max - center : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, $dxWQo._)(_obj1, axis, coords[axis] - alignmentOffset), (0, $dxWQo._)(_obj1, "data", (_obj = {}, (0, $dxWQo._)(_obj, axis, offset), (0, $dxWQo._)(_obj, "centerOffset", center - offset + alignmentOffset), _obj)), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
var $f5dbeeabf004a4ed$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
var $f5dbeeabf004a4ed$var$allPlacements = /*#__PURE__*/ $f5dbeeabf004a4ed$var$sides.reduce(function(acc, side) {
    return acc.concat(side, side + "-start", side + "-end");
}, []);
var $f5dbeeabf004a4ed$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $f5dbeeabf004a4ed$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(side) {
        return $f5dbeeabf004a4ed$var$oppositeSideMap[side];
    });
}
function $f5dbeeabf004a4ed$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = $f5dbeeabf004a4ed$var$getAlignment(placement);
    var mainAxis = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement);
    var length = $f5dbeeabf004a4ed$var$getLengthFromAxis(mainAxis);
    var mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f5dbeeabf004a4ed$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $f5dbeeabf004a4ed$var$getOppositePlacement(mainAlignmentSide)
    };
}
var $f5dbeeabf004a4ed$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $f5dbeeabf004a4ed$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, function(alignment) {
        return $f5dbeeabf004a4ed$var$oppositeAlignmentMap[alignment];
    });
}
function $f5dbeeabf004a4ed$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, $fLnyw._)(allowedPlacements.filter(function(placement) {
        return $f5dbeeabf004a4ed$var$getAlignment(placement) === alignment;
    })).concat((0, $fLnyw._)(allowedPlacements.filter(function(placement) {
        return $f5dbeeabf004a4ed$var$getAlignment(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return $f5dbeeabf004a4ed$var$getSide(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return $f5dbeeabf004a4ed$var$getAlignment(placement) === alignment || (autoAlignment ? $f5dbeeabf004a4ed$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var $f5dbeeabf004a4ed$export$91fb6ecbd551914 = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements, overflow, currentIndex, currentPlacement, _getAlignmentSides, main, cross, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? $f5dbeeabf004a4ed$var$allPlacements : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements = alignment !== undefined || allowedPlacements === $f5dbeeabf004a4ed$var$allPlacements ? $f5dbeeabf004a4ed$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            return [
                                4,
                                $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            _getAlignmentSides = $f5dbeeabf004a4ed$var$getAlignmentSides.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])), main = _getAlignmentSides.main, cross = _getAlignmentSides.cross;
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements[0]
                                    }
                                }
                            ];
                            currentOverflows = [
                                overflow[$f5dbeeabf004a4ed$var$getSide(currentPlacement)],
                                overflow[main],
                                overflow[cross]
                            ];
                            allOverflows = (0, $fLnyw._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = $f5dbeeabf004a4ed$var$getAlignment(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                $f5dbeeabf004a4ed$var$getAlignment(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $f5dbeeabf004a4ed$var$getExpandedPlacements(placement) {
    var oppositePlacement = $f5dbeeabf004a4ed$var$getOppositePlacement(placement);
    return [
        $f5dbeeabf004a4ed$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $f5dbeeabf004a4ed$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $f5dbeeabf004a4ed$var$getSideList(side, isStart, rtl) {
    var lr = [
        "left",
        "right"
    ];
    var rl = [
        "right",
        "left"
    ];
    var tb = [
        "top",
        "bottom"
    ];
    var bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f5dbeeabf004a4ed$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    var alignment = $f5dbeeabf004a4ed$var$getAlignment(placement);
    var list = $f5dbeeabf004a4ed$var$getSideList($f5dbeeabf004a4ed$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map($f5dbeeabf004a4ed$var$getOppositeAlignmentPlacement));
    }
    return list;
}
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var $f5dbeeabf004a4ed$export$8a83211c878a3f1f = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var _fallbackPlacements, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, isBasePlacement, rtl, fallbackPlacements, placements, overflow, overflows, overflowsData, _getAlignmentSides, main, cross, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$map$so, placement1;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? "bestFit" : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? "none" : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            side = $f5dbeeabf004a4ed$var$getSide(placement);
                            isBasePlacement = $f5dbeeabf004a4ed$var$getSide(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                $f5dbeeabf004a4ed$var$getOppositePlacement(initialPlacement)
                            ] : $f5dbeeabf004a4ed$var$getExpandedPlacements(initialPlacement));
                            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, $fLnyw._)($f5dbeeabf004a4ed$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, $fLnyw._)(fallbackPlacements));
                            return [
                                4,
                                $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                _getAlignmentSides = $f5dbeeabf004a4ed$var$getAlignmentSides(placement, rects, rtl), main = _getAlignmentSides.main, cross = _getAlignmentSides.cross;
                                overflows.push(overflow[main], overflow[cross]);
                            }
                            overflowsData = (0, $fLnyw._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) // Try next placement and re-run the lifecycle.
                                return [
                                    2,
                                    {
                                        data: {
                                            index: nextIndex,
                                            overflows: overflowsData
                                        },
                                        reset: {
                                            placement: nextPlacement
                                        }
                                    }
                                ];
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case "bestFit":
                                        {
                                            ;
                                            placement1 = (_overflowsData$map$so = overflowsData.map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$map$so[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case "initialPlacement":
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $f5dbeeabf004a4ed$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $f5dbeeabf004a4ed$var$isAnySideFullyClipped(overflow) {
    return $f5dbeeabf004a4ed$var$sides.some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var $f5dbeeabf004a4ed$export$fe8985bb6374093c = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var rects, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects;
                            _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? "referenceHidden" : _evaluate_strategy, detectOverflowOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case "referenceHidden":
                                    return [
                                        3,
                                        1
                                    ];
                                case "escaped":
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, (0, $8E768._)((0, $8OnJk._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = $f5dbeeabf004a4ed$var$getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: $f5dbeeabf004a4ed$var$isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, (0, $8E768._)((0, $8OnJk._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = $f5dbeeabf004a4ed$var$getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: $f5dbeeabf004a4ed$var$isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function $f5dbeeabf004a4ed$var$getBoundingRect(rects) {
    var minX = $f5dbeeabf004a4ed$var$min.apply(void 0, (0, $fLnyw._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = $f5dbeeabf004a4ed$var$min.apply(void 0, (0, $fLnyw._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = $f5dbeeabf004a4ed$var$max.apply(void 0, (0, $fLnyw._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = $f5dbeeabf004a4ed$var$max.apply(void 0, (0, $fLnyw._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $f5dbeeabf004a4ed$var$getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return $f5dbeeabf004a4ed$export$ee05aea0aeecbad4($f5dbeeabf004a4ed$var$getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var $f5dbeeabf004a4ed$export$18c8ad048e32c7d5 = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ($f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement) === "x") {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = $f5dbeeabf004a4ed$var$getSide(placement) === "top";
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            var width = right - left;
                            var height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        var isLeftSide = $f5dbeeabf004a4ed$var$getSide(placement) === "left";
                        var maxRight = $f5dbeeabf004a4ed$var$max.apply(void 0, (0, $fLnyw._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = $f5dbeeabf004a4ed$var$min.apply(void 0, (0, $fLnyw._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        var left1 = minLeft;
                        var right1 = maxRight;
                        var width1 = right1 - left1;
                        var height1 = bottom1 - top1;
                        return {
                            top: top1,
                            bottom: bottom1,
                            left: left1,
                            right: right1,
                            width: width1,
                            height: height1,
                            x: left1,
                            y: top1
                        };
                    }
                    return fallback;
                }
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            clientRects = $f5dbeeabf004a4ed$var$getRectsByLine(nativeClientRects);
                            fallback = $f5dbeeabf004a4ed$export$ee05aea0aeecbad4($f5dbeeabf004a4ed$var$getBoundingRect(nativeClientRects));
                            paddingObject = $f5dbeeabf004a4ed$var$getSideObjectFromPadding(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function $f5dbeeabf004a4ed$var$convertValueToCoords(state, options) {
    return $f5dbeeabf004a4ed$var$_convertValueToCoords.apply(this, arguments);
}
function $f5dbeeabf004a4ed$var$_convertValueToCoords() {
    $f5dbeeabf004a4ed$var$_convertValueToCoords = (0, $byzP8._)(function(state, options) {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = $f5dbeeabf004a4ed$var$getSide(placement);
                    alignment = $f5dbeeabf004a4ed$var$getAlignment(placement);
                    isVertical = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement) === "x";
                    mainAxisMulti = [
                        "left",
                        "top"
                    ].includes(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = $f5dbeeabf004a4ed$var$evaluate(options, state);
                    _ref = typeof rawValue === "number" ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : (0, $8OnJk._)({
                        mainAxis: 0,
                        crossAxis: 0,
                        alignmentAxis: null
                    }, rawValue), mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    });
    return $f5dbeeabf004a4ed$var$_convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var $f5dbeeabf004a4ed$export$cc800923e997bb8 = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var x, y, diffCoords;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y;
                            return [
                                4,
                                $f5dbeeabf004a4ed$var$convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: diffCoords
                                }
                            ];
                    }
                });
            })();
        }
    };
};
function $f5dbeeabf004a4ed$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var $f5dbeeabf004a4ed$export$fba63a578e423eb = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var x, y, placement, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, mainAxis, crossAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, _obj, limitedCoords;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement;
                            _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            mainAxis = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement($f5dbeeabf004a4ed$var$getSide(placement));
                            crossAxis = $f5dbeeabf004a4ed$var$getCrossAxis(mainAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === "y" ? "top" : "left";
                                maxSide = mainAxis === "y" ? "bottom" : "right";
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = $f5dbeeabf004a4ed$var$within(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === "y" ? "top" : "left";
                                maxSide1 = crossAxis === "y" ? "bottom" : "right";
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = $f5dbeeabf004a4ed$var$within(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0, $8E768._)((0, $8OnJk._)({}, state), (_obj = {}, (0, $dxWQo._)(_obj, mainAxis, mainAxisCoord), (0, $dxWQo._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, $8E768._)((0, $8OnJk._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var $f5dbeeabf004a4ed$export$7bf07e38f3dc4b69 = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function(state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var mainAxis = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement);
            var crossAxis = $f5dbeeabf004a4ed$var$getCrossAxis(mainAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = $f5dbeeabf004a4ed$var$evaluate(offset, state);
            var computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $8OnJk._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === "y" ? "height" : "width";
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === "y" ? "width" : "height";
                var isOriginSide = [
                    "top",
                    "left"
                ].includes($f5dbeeabf004a4ed$var$getSide(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return(_obj = {}, (0, $dxWQo._)(_obj, mainAxis, mainAxisCoord), (0, $dxWQo._)(_obj, crossAxis, crossAxisCoord), _obj);
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var $f5dbeeabf004a4ed$export$346677f925de839c = function size(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn: function(state) {
            return (0, $byzP8._)(function() {
                var placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, axis, isXAxis, _rects_floating, width, height, heightSide, widthSide, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, maximumClippingWidth, maximumClippingHeight, xMin, xMax, yMin, yMax, nextDimensions;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = $f5dbeeabf004a4ed$var$evaluate(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, $c4006311849aa271$export$69fdd232f62cde60)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = $f5dbeeabf004a4ed$var$getSide(placement);
                            alignment = $f5dbeeabf004a4ed$var$getAlignment(placement);
                            axis = $f5dbeeabf004a4ed$var$getMainAxisFromPlacement(placement);
                            isXAxis = axis === "x";
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === "top" || side === "bottom")) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? "start" : "end") ? "left" : "right";
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === "end" ? "top" : "bottom";
                            _state.label = 4;
                        case 4:
                            overflowAvailableHeight = height - overflow[heightSide];
                            overflowAvailableWidth = width - overflow[widthSide];
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if (isXAxis) {
                                maximumClippingWidth = width - overflow.left - overflow.right;
                                availableWidth = alignment || noShift ? $f5dbeeabf004a4ed$var$min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
                            } else {
                                maximumClippingHeight = height - overflow.top - overflow.bottom;
                                availableHeight = alignment || noShift ? $f5dbeeabf004a4ed$var$min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
                            }
                            if (noShift && !alignment) {
                                xMin = $f5dbeeabf004a4ed$var$max(overflow.left, 0);
                                xMax = $f5dbeeabf004a4ed$var$max(overflow.right, 0);
                                yMin = $f5dbeeabf004a4ed$var$max(overflow.top, 0);
                                yMax = $f5dbeeabf004a4ed$var$max(overflow.bottom, 0);
                                if (isXAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $f5dbeeabf004a4ed$var$max(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $f5dbeeabf004a4ed$var$max(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0, $8E768._)((0, $8OnJk._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};


var $byzP8 = parcelRequire("byzP8");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

function $f3e37db8bfe4dcf2$var$getWindow(node) {
    var _node$ownerDocument;
    return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $f3e37db8bfe4dcf2$var$getComputedStyle$1(element) {
    return $f3e37db8bfe4dcf2$var$getWindow(element).getComputedStyle(element);
}
function $f3e37db8bfe4dcf2$var$isNode(value) {
    return value instanceof $f3e37db8bfe4dcf2$var$getWindow(value).Node;
}
function $f3e37db8bfe4dcf2$var$getNodeName(node) {
    if ($f3e37db8bfe4dcf2$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $f3e37db8bfe4dcf2$var$isHTMLElement(value) {
    return value instanceof $f3e37db8bfe4dcf2$var$getWindow(value).HTMLElement;
}
function $f3e37db8bfe4dcf2$var$isElement(value) {
    return value instanceof $f3e37db8bfe4dcf2$var$getWindow(value).Element;
}
function $f3e37db8bfe4dcf2$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return node instanceof $f3e37db8bfe4dcf2$var$getWindow(node).ShadowRoot || node instanceof ShadowRoot;
}
function $f3e37db8bfe4dcf2$var$isOverflowElement(element) {
    var _getComputedStyle$1 = $f3e37db8bfe4dcf2$var$getComputedStyle$1(element), overflow = _getComputedStyle$1.overflow, overflowX = _getComputedStyle$1.overflowX, overflowY = _getComputedStyle$1.overflowY, display = _getComputedStyle$1.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $f3e37db8bfe4dcf2$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($f3e37db8bfe4dcf2$var$getNodeName(element));
}
function $f3e37db8bfe4dcf2$var$isContainingBlock(element) {
    var safari = $f3e37db8bfe4dcf2$var$isSafari();
    var css = $f3e37db8bfe4dcf2$var$getComputedStyle$1(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !safari && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !safari && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some(function(value) {
        return (css.willChange || "").includes(value);
    }) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(function(value) {
        return (css.contain || "").includes(value);
    });
}
function $f3e37db8bfe4dcf2$var$isSafari() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $f3e37db8bfe4dcf2$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($f3e37db8bfe4dcf2$var$getNodeName(node));
}
var $f3e37db8bfe4dcf2$var$min = Math.min;
var $f3e37db8bfe4dcf2$var$max = Math.max;
var $f3e37db8bfe4dcf2$var$round = Math.round;
var $f3e37db8bfe4dcf2$var$floor = Math.floor;
var $f3e37db8bfe4dcf2$var$createEmptyCoords = function(v) {
    return {
        x: v,
        y: v
    };
};
function $f3e37db8bfe4dcf2$var$getCssDimensions(element) {
    var css = $f3e37db8bfe4dcf2$var$getComputedStyle$1(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = $f3e37db8bfe4dcf2$var$isHTMLElement(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = $f3e37db8bfe4dcf2$var$round(width) !== offsetWidth || $f3e37db8bfe4dcf2$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $f3e37db8bfe4dcf2$var$unwrapElement(element) {
    return !$f3e37db8bfe4dcf2$var$isElement(element) ? element.contextElement : element;
}
function $f3e37db8bfe4dcf2$var$getScale(element) {
    var domElement = $f3e37db8bfe4dcf2$var$unwrapElement(element);
    if (!$f3e37db8bfe4dcf2$var$isHTMLElement(domElement)) return $f3e37db8bfe4dcf2$var$createEmptyCoords(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = $f3e37db8bfe4dcf2$var$getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? $f3e37db8bfe4dcf2$var$round(rect.width) : rect.width) / width;
    var y = ($ ? $f3e37db8bfe4dcf2$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var $f3e37db8bfe4dcf2$var$noOffsets = /*#__PURE__*/ $f3e37db8bfe4dcf2$var$createEmptyCoords(0);
function $f3e37db8bfe4dcf2$var$getVisualOffsets(element, isFixed, floatingOffsetParent) {
    var _win$visualViewport, _win$visualViewport2;
    if (isFixed === void 0) isFixed = true;
    if (!$f3e37db8bfe4dcf2$var$isSafari()) return $f3e37db8bfe4dcf2$var$noOffsets;
    var win = element ? $f3e37db8bfe4dcf2$var$getWindow(element) : window;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== win) return $f3e37db8bfe4dcf2$var$noOffsets;
    return {
        x: ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0,
        y: ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0
    };
}
function $f3e37db8bfe4dcf2$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = $f3e37db8bfe4dcf2$var$unwrapElement(element);
    var scale = $f3e37db8bfe4dcf2$var$createEmptyCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($f3e37db8bfe4dcf2$var$isElement(offsetParent)) scale = $f3e37db8bfe4dcf2$var$getScale(offsetParent);
        } else scale = $f3e37db8bfe4dcf2$var$getScale(element);
    }
    var visualOffsets = $f3e37db8bfe4dcf2$var$getVisualOffsets(domElement, isFixedStrategy, offsetParent);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = $f3e37db8bfe4dcf2$var$getWindow(domElement);
        var offsetWin = offsetParent && $f3e37db8bfe4dcf2$var$isElement(offsetParent) ? $f3e37db8bfe4dcf2$var$getWindow(offsetParent) : offsetParent;
        var currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            var iframeScale = $f3e37db8bfe4dcf2$var$getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = getComputedStyle(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = $f3e37db8bfe4dcf2$var$getWindow(currentIFrame).frameElement;
        }
    }
    return (0, $f5dbeeabf004a4ed$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $f3e37db8bfe4dcf2$var$getDocumentElement(node) {
    return (($f3e37db8bfe4dcf2$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $f3e37db8bfe4dcf2$var$getNodeScroll(element) {
    if ($f3e37db8bfe4dcf2$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $f3e37db8bfe4dcf2$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isOffsetParentAnElement = $f3e37db8bfe4dcf2$var$isHTMLElement(offsetParent);
    var documentElement = $f3e37db8bfe4dcf2$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = $f3e37db8bfe4dcf2$var$createEmptyCoords(1);
    var offsets = $f3e37db8bfe4dcf2$var$createEmptyCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($f3e37db8bfe4dcf2$var$getNodeName(offsetParent) !== "body" || $f3e37db8bfe4dcf2$var$isOverflowElement(documentElement)) scroll = $f3e37db8bfe4dcf2$var$getNodeScroll(offsetParent);
        if ($f3e37db8bfe4dcf2$var$isHTMLElement(offsetParent)) {
            var offsetRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(offsetParent);
            scale = $f3e37db8bfe4dcf2$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $f3e37db8bfe4dcf2$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $f3e37db8bfe4dcf2$var$getBoundingClientRect($f3e37db8bfe4dcf2$var$getDocumentElement(element)).left + $f3e37db8bfe4dcf2$var$getNodeScroll(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $f3e37db8bfe4dcf2$var$getDocumentRect(element) {
    var html = $f3e37db8bfe4dcf2$var$getDocumentElement(element);
    var scroll = $f3e37db8bfe4dcf2$var$getNodeScroll(element);
    var body = element.ownerDocument.body;
    var width = $f3e37db8bfe4dcf2$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = $f3e37db8bfe4dcf2$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + $f3e37db8bfe4dcf2$var$getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if ($f3e37db8bfe4dcf2$var$getComputedStyle$1(body).direction === "rtl") x += $f3e37db8bfe4dcf2$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f3e37db8bfe4dcf2$var$getParentNode(node) {
    if ($f3e37db8bfe4dcf2$var$getNodeName(node) === "html") return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $f3e37db8bfe4dcf2$var$isShadowRoot(node) && node.host || // Fallback.
    $f3e37db8bfe4dcf2$var$getDocumentElement(node);
    return $f3e37db8bfe4dcf2$var$isShadowRoot(result) ? result.host : result;
}
function $f3e37db8bfe4dcf2$var$getNearestOverflowAncestor(node) {
    var parentNode = $f3e37db8bfe4dcf2$var$getParentNode(node);
    if ($f3e37db8bfe4dcf2$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($f3e37db8bfe4dcf2$var$isHTMLElement(parentNode) && $f3e37db8bfe4dcf2$var$isOverflowElement(parentNode)) return parentNode;
    return $f3e37db8bfe4dcf2$var$getNearestOverflowAncestor(parentNode);
}
function $f3e37db8bfe4dcf2$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    var scrollableAncestor = $f3e37db8bfe4dcf2$var$getNearestOverflowAncestor(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    var win = $f3e37db8bfe4dcf2$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $f3e37db8bfe4dcf2$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $f3e37db8bfe4dcf2$export$3b57c1601291186b(scrollableAncestor));
}
function $f3e37db8bfe4dcf2$var$getViewportRect(element, strategy) {
    var win = $f3e37db8bfe4dcf2$var$getWindow(element);
    var html = $f3e37db8bfe4dcf2$var$getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = $f3e37db8bfe4dcf2$var$isSafari();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $f3e37db8bfe4dcf2$var$getInnerBoundingClientRect(element, strategy) {
    var clientRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(element, true, strategy === "fixed");
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = $f3e37db8bfe4dcf2$var$isHTMLElement(element) ? $f3e37db8bfe4dcf2$var$getScale(element) : $f3e37db8bfe4dcf2$var$createEmptyCoords(1);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f3e37db8bfe4dcf2$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === "viewport") rect = $f3e37db8bfe4dcf2$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $f3e37db8bfe4dcf2$var$getDocumentRect($f3e37db8bfe4dcf2$var$getDocumentElement(element));
    else if ($f3e37db8bfe4dcf2$var$isElement(clippingAncestor)) rect = $f3e37db8bfe4dcf2$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = $f3e37db8bfe4dcf2$var$getVisualOffsets(element);
        rect = (0, $8E768._)((0, $8OnJk._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $f5dbeeabf004a4ed$export$ee05aea0aeecbad4)(rect);
}
function $f3e37db8bfe4dcf2$var$hasFixedPositionAncestor(element, stopNode) {
    var parentNode = $f3e37db8bfe4dcf2$var$getParentNode(element);
    if (parentNode === stopNode || !$f3e37db8bfe4dcf2$var$isElement(parentNode) || $f3e37db8bfe4dcf2$var$isLastTraversableNode(parentNode)) return false;
    return $f3e37db8bfe4dcf2$var$getComputedStyle$1(parentNode).position === "fixed" || $f3e37db8bfe4dcf2$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $f3e37db8bfe4dcf2$var$getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = $f3e37db8bfe4dcf2$export$3b57c1601291186b(element).filter(function(el) {
        return $f3e37db8bfe4dcf2$var$isElement(el) && $f3e37db8bfe4dcf2$var$getNodeName(el) !== "body";
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = $f3e37db8bfe4dcf2$var$getComputedStyle$1(element).position === "fixed";
    var currentNode = elementIsFixed ? $f3e37db8bfe4dcf2$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($f3e37db8bfe4dcf2$var$isElement(currentNode) && !$f3e37db8bfe4dcf2$var$isLastTraversableNode(currentNode)){
        var computedStyle = $f3e37db8bfe4dcf2$var$getComputedStyle$1(currentNode);
        var currentNodeIsContaining = $f3e37db8bfe4dcf2$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $f3e37db8bfe4dcf2$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $f3e37db8bfe4dcf2$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $f3e37db8bfe4dcf2$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $f3e37db8bfe4dcf2$var$getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === "clippingAncestors" ? $f3e37db8bfe4dcf2$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, $fLnyw._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstClippingAncestor = clippingAncestors[0];
    var clippingRect = clippingAncestors.reduce(function(accRect, clippingAncestor) {
        var rect = $f3e37db8bfe4dcf2$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $f3e37db8bfe4dcf2$var$max(rect.top, accRect.top);
        accRect.right = $f3e37db8bfe4dcf2$var$min(rect.right, accRect.right);
        accRect.bottom = $f3e37db8bfe4dcf2$var$min(rect.bottom, accRect.bottom);
        accRect.left = $f3e37db8bfe4dcf2$var$max(rect.left, accRect.left);
        return accRect;
    }, $f3e37db8bfe4dcf2$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $f3e37db8bfe4dcf2$var$getDimensions(element) {
    return $f3e37db8bfe4dcf2$var$getCssDimensions(element);
}
function $f3e37db8bfe4dcf2$var$getTrueOffsetParent(element, polyfill) {
    if (!$f3e37db8bfe4dcf2$var$isHTMLElement(element) || $f3e37db8bfe4dcf2$var$getComputedStyle$1(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $f3e37db8bfe4dcf2$var$getContainingBlock(element) {
    var currentNode = $f3e37db8bfe4dcf2$var$getParentNode(element);
    while($f3e37db8bfe4dcf2$var$isHTMLElement(currentNode) && !$f3e37db8bfe4dcf2$var$isLastTraversableNode(currentNode)){
        if ($f3e37db8bfe4dcf2$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $f3e37db8bfe4dcf2$var$getParentNode(currentNode);
    }
    return null;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $f3e37db8bfe4dcf2$var$getOffsetParent(element, polyfill) {
    var window1 = $f3e37db8bfe4dcf2$var$getWindow(element);
    if (!$f3e37db8bfe4dcf2$var$isHTMLElement(element)) return window1;
    var offsetParent = $f3e37db8bfe4dcf2$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $f3e37db8bfe4dcf2$var$isTableElement(offsetParent) && $f3e37db8bfe4dcf2$var$getComputedStyle$1(offsetParent).position === "static")offsetParent = $f3e37db8bfe4dcf2$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($f3e37db8bfe4dcf2$var$getNodeName(offsetParent) === "html" || $f3e37db8bfe4dcf2$var$getNodeName(offsetParent) === "body" && $f3e37db8bfe4dcf2$var$getComputedStyle$1(offsetParent).position === "static" && !$f3e37db8bfe4dcf2$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $f3e37db8bfe4dcf2$var$getContainingBlock(element) || window1;
}
function $f3e37db8bfe4dcf2$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = $f3e37db8bfe4dcf2$var$isHTMLElement(offsetParent);
    var documentElement = $f3e37db8bfe4dcf2$var$getDocumentElement(offsetParent);
    var isFixed = strategy === "fixed";
    var rect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = $f3e37db8bfe4dcf2$var$createEmptyCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($f3e37db8bfe4dcf2$var$getNodeName(offsetParent) !== "body" || $f3e37db8bfe4dcf2$var$isOverflowElement(documentElement)) scroll = $f3e37db8bfe4dcf2$var$getNodeScroll(offsetParent);
        if ($f3e37db8bfe4dcf2$var$isHTMLElement(offsetParent)) {
            var offsetRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $f3e37db8bfe4dcf2$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
var $f3e37db8bfe4dcf2$export$722a64dea1b767dc = {
    getClippingRect: $f3e37db8bfe4dcf2$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $f3e37db8bfe4dcf2$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $f3e37db8bfe4dcf2$var$isElement,
    getDimensions: $f3e37db8bfe4dcf2$var$getDimensions,
    getOffsetParent: $f3e37db8bfe4dcf2$var$getOffsetParent,
    getDocumentElement: $f3e37db8bfe4dcf2$var$getDocumentElement,
    getScale: $f3e37db8bfe4dcf2$var$getScale,
    getElementRects: function(_ref) {
        return (0, $byzP8._)(function() {
            var reference, floating, strategy, getOffsetParentFn, getDimensionsFn, _tmp, _tmp1, _tmp2;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        reference = _ref.reference, floating = _ref.floating, strategy = _ref.strategy;
                        getOffsetParentFn = this.getOffsetParent || $f3e37db8bfe4dcf2$var$getOffsetParent;
                        getDimensionsFn = this.getDimensions;
                        _tmp = {};
                        _tmp1 = [
                            reference
                        ];
                        return [
                            4,
                            getOffsetParentFn(floating)
                        ];
                    case 1:
                        _tmp.reference = $f3e37db8bfe4dcf2$var$getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                            _state.sent(),
                            strategy
                        ]));
                        _tmp2 = [
                            {
                                x: 0,
                                y: 0
                            }
                        ];
                        return [
                            4,
                            getDimensionsFn(floating)
                        ];
                    case 2:
                        return [
                            2,
                            (_tmp.floating = (0, $8OnJk._).apply(void 0, _tmp2.concat([
                                _state.sent()
                            ])), _tmp)
                        ];
                }
            });
        }).apply(this);
    },
    getClientRects: function(element) {
        return Array.from(element.getClientRects());
    },
    isRTL: function(element) {
        return $f3e37db8bfe4dcf2$var$getComputedStyle$1(element).direction === "rtl";
    }
};
// https://samthor.au/2021/observing-dom/
function $f3e37db8bfe4dcf2$var$observeMove(element, onMove) {
    var cleanup = function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    };
    var io = null;
    var timeoutId;
    var root = $f3e37db8bfe4dcf2$var$getDocumentElement(element);
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top, width = _element_getBoundingClientRect.width, height = _element_getBoundingClientRect.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = $f3e37db8bfe4dcf2$var$floor(top);
        var insetRight = $f3e37db8bfe4dcf2$var$floor(root.clientWidth - (left + width));
        var insetBottom = $f3e37db8bfe4dcf2$var$floor(root.clientHeight - (top + height));
        var insetLeft = $f3e37db8bfe4dcf2$var$floor(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: $f3e37db8bfe4dcf2$var$max(0, $f3e37db8bfe4dcf2$var$min(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $8E768._)((0, $8OnJk._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $f3e37db8bfe4dcf2$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === "function" : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === "function" : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = $f3e37db8bfe4dcf2$var$unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, $fLnyw._)(referenceEl ? $f3e37db8bfe4dcf2$export$3b57c1601291186b(referenceEl) : []).concat((0, $fLnyw._)($f3e37db8bfe4dcf2$export$3b57c1601291186b(floating))) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    var cleanupIo = referenceEl && layoutShift ? $f3e37db8bfe4dcf2$var$observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, $8GFUW._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? $f3e37db8bfe4dcf2$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ var $f3e37db8bfe4dcf2$export$48a53dcb22e581d0 = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = (0, $8OnJk._)({
        platform: $f3e37db8bfe4dcf2$export$722a64dea1b767dc
    }, options);
    var platformWithCache = (0, $8E768._)((0, $8OnJk._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $f5dbeeabf004a4ed$export$48a53dcb22e581d0)(reference, floating, (0, $8E768._)((0, $8OnJk._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};



var $6cds3 = parcelRequire("6cds3");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var $26c78fdce868f04a$export$f2120bbfa5450bd2 = function(options) {
    var isRef = function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    };
    return {
        name: "arrow",
        options: options,
        fn: function(state) {
            var _ref = typeof options === "function" ? options(state) : options, element = _ref.element, padding = _ref.padding;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $f5dbeeabf004a4ed$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $f5dbeeabf004a4ed$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $26c78fdce868f04a$var$index = typeof document !== "undefined" ? (0, $6cds3.useLayoutEffect) : (0, $6cds3.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $26c78fdce868f04a$var$deepEqual(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, $1ObTH._)(b))) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    var length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$26c78fdce868f04a$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$26c78fdce868f04a$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $26c78fdce868f04a$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    var win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $26c78fdce868f04a$var$roundByDPR(element, value) {
    var dpr = $26c78fdce868f04a$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $26c78fdce868f04a$var$useLatestRef(value) {
    var ref = $6cds3.useRef(value);
    $26c78fdce868f04a$var$index(function() {
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $26c78fdce868f04a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    var _options_placement = options.placement, placement = _options_placement === void 0 ? "bottom" : _options_placement, _options_strategy = options.strategy, strategy = _options_strategy === void 0 ? "absolute" : _options_strategy, _options_middleware = options.middleware, middleware = _options_middleware === void 0 ? [] : _options_middleware, platform = options.platform, tmp = options.elements, _ref = tmp === void 0 ? {} : tmp, externalReference = _ref.reference, externalFloating = _ref.floating, _options_transform = options.transform, transform = _options_transform === void 0 ? true : _options_transform, whileElementsMounted = options.whileElementsMounted, open = options.open;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    }), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, $8GFUW._)($6cds3.useState(middleware), 2), latestMiddleware = _React_useState1[0], setLatestMiddleware = _React_useState1[1];
    if (!$26c78fdce868f04a$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    var _React_useState2 = (0, $8GFUW._)($6cds3.useState(null), 2), _reference = _React_useState2[0], _setReference = _React_useState2[1];
    var _React_useState3 = (0, $8GFUW._)($6cds3.useState(null), 2), _floating = _React_useState3[0], _setFloating = _React_useState3[1];
    var setReference = $6cds3.useCallback(function(node) {
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    var setFloating = $6cds3.useCallback(function(node) {
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    var referenceEl = externalReference || _reference;
    var floatingEl = externalFloating || _floating;
    var referenceRef = $6cds3.useRef(null);
    var floatingRef = $6cds3.useRef(null);
    var dataRef = $6cds3.useRef(data);
    var whileElementsMountedRef = $26c78fdce868f04a$var$useLatestRef(whileElementsMounted);
    var platformRef = $26c78fdce868f04a$var$useLatestRef(platform);
    var update = $6cds3.useCallback(function() {
        if (!referenceRef.current || !floatingRef.current) return;
        var config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $f3e37db8bfe4dcf2$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then(function(data) {
            var fullData = (0, $8E768._)((0, $8OnJk._)({}, data), {
                isPositioned: true
            });
            if (isMountedRef.current && !$26c78fdce868f04a$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $6d4849ee44552f5f$exports.flushSync(function() {
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $26c78fdce868f04a$var$index(function() {
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData(function(data) {
                return (0, $8E768._)((0, $8OnJk._)({}, data), {
                    isPositioned: false
                });
            });
        }
    }, [
        open
    ]);
    var isMountedRef = $6cds3.useRef(false);
    $26c78fdce868f04a$var$index(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    $26c78fdce868f04a$var$index(function() {
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    var refs = $6cds3.useMemo(function() {
        return {
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        };
    }, [
        setReference,
        setFloating
    ]);
    var elements = $6cds3.useMemo(function() {
        return {
            reference: referenceEl,
            floating: floatingEl
        };
    }, [
        referenceEl,
        floatingEl
    ]);
    var floatingStyles = $6cds3.useMemo(function() {
        var initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        var x = $26c78fdce868f04a$var$roundByDPR(elements.floating, data.x);
        var y = $26c78fdce868f04a$var$roundByDPR(elements.floating, data.y);
        if (transform) return (0, $8OnJk._)((0, $8E768._)((0, $8OnJk._)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), $26c78fdce868f04a$var$getDPR(elements.floating) >= 1.5 && {
            willChange: "transform"
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $6cds3.useMemo(function() {
        return (0, $8E768._)((0, $8OnJk._)({}, data), {
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        });
    }, [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}





var $6cds3 = parcelRequire("6cds3");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ var $93a52fa050c7b74c$var$$7e8f5cd07187803e$var$NAME = "Arrow";
var $93a52fa050c7b74c$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var children = props.children, tmp = props.width, width = tmp === void 0 ? 10 : tmp, tmp1 = props.height, height = tmp1 === void 0 ? 5 : tmp1, arrowProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "children",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).svg, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $6cds3.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($93a52fa050c7b74c$export$21b07c8f274aebd5, {
    displayName: $93a52fa050c7b74c$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $93a52fa050c7b74c$export$be92b6f5f03c0fe9 = $93a52fa050c7b74c$export$21b07c8f274aebd5;








var $8GFUW = parcelRequire("8GFUW");

var $6cds3 = parcelRequire("6cds3");

function $faa9b9e7936220ba$export$1ab7ae714698c4b8(element) {
    var _$9gyGR$useState = (0, $8GFUW._)((0, $6cds3.useState)(undefined), 2), size = _$9gyGR$useState[0], setSize = _$9gyGR$useState[1];
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            var resizeObserver = new ResizeObserver(function(entries) {
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                var entry = entries[0];
                var width;
                var height;
                if ("borderBoxSize" in entry) {
                    var borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    var borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return function() {
                return resizeObserver.unobserve(element);
            };
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


var $ed1fe7c5ccd267a8$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $ed1fe7c5ccd267a8$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ var $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
var $ed1fe7c5ccd267a8$var$_$kY93V$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$POPPER_NAME), 2), $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$createPopperContext = $ed1fe7c5ccd267a8$var$_$kY93V$createContextScope[0], $ed1fe7c5ccd267a8$export$722aac194ae923 = $ed1fe7c5ccd267a8$var$_$kY93V$createContextScope[1];
var $ed1fe7c5ccd267a8$var$_$cf1ac5d9fe0e8206$var$createPopperContext = (0, $8GFUW._)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$createPopperContext($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$POPPER_NAME), 2), $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$PopperProvider = $ed1fe7c5ccd267a8$var$_$cf1ac5d9fe0e8206$var$createPopperContext[0], $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$usePopperContext = $ed1fe7c5ccd267a8$var$_$cf1ac5d9fe0e8206$var$createPopperContext[1];
var $ed1fe7c5ccd267a8$export$badac9ada3a0bdf9 = function(props) {
    var __scopePopper = props.__scopePopper, children = props.children;
    var _$kY93V$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), anchor = _$kY93V$useState[0], setAnchor = _$kY93V$useState[1];
    return /*#__PURE__*/ (0, $6cds3.createElement)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($ed1fe7c5ccd267a8$export$badac9ada3a0bdf9, {
    displayName: $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ var $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
var $ed1fe7c5ccd267a8$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopePopper = props.__scopePopper, virtualRef = props.virtualRef, anchorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopper",
        "virtualRef"
    ]);
    var context = $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$usePopperContext($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $6cds3.useEffect)(function() {
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($ed1fe7c5ccd267a8$export$ecd4e1ccab6ed6d, {
    displayName: $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ var $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
var $ed1fe7c5ccd267a8$var$_$cf1ac5d9fe0e8206$var$createPopperContext1 = (0, $8GFUW._)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$createPopperContext($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME), 2), $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$PopperContentProvider = $ed1fe7c5ccd267a8$var$_$cf1ac5d9fe0e8206$var$createPopperContext1[0], $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$useContentContext = $ed1fe7c5ccd267a8$var$_$cf1ac5d9fe0e8206$var$createPopperContext1[1];
var $ed1fe7c5ccd267a8$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    var __scopePopper = props.__scopePopper, tmp = props.side, side = tmp === void 0 ? "bottom" : tmp, tmp1 = props.sideOffset, sideOffset = tmp1 === void 0 ? 0 : tmp1, tmp2 = props.align, align = tmp2 === void 0 ? "center" : tmp2, tmp3 = props.alignOffset, alignOffset = tmp3 === void 0 ? 0 : tmp3, tmp4 = props.arrowPadding, arrowPadding = tmp4 === void 0 ? 0 : tmp4, tmp5 = props.collisionBoundary, collisionBoundary = tmp5 === void 0 ? [] : tmp5, tmp6 = props.collisionPadding, collisionPaddingProp = tmp6 === void 0 ? 0 : tmp6, tmp7 = props.sticky, sticky = tmp7 === void 0 ? "partial" : tmp7, tmp8 = props.hideWhenDetached, hideWhenDetached = tmp8 === void 0 ? false : tmp8, tmp9 = props.avoidCollisions, avoidCollisions = tmp9 === void 0 ? true : tmp9, onPlaced = props.onPlaced, contentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopper",
        "side",
        "sideOffset",
        "align",
        "alignOffset",
        "arrowPadding",
        "collisionBoundary",
        "collisionPadding",
        "sticky",
        "hideWhenDetached",
        "avoidCollisions",
        "onPlaced"
    ]);
    var context = $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$usePopperContext($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    var _$kY93V$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), content = _$kY93V$useState[0], setContent = _$kY93V$useState[1];
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setContent(node);
    });
    var _$kY93V$useState1 = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), arrow = _$kY93V$useState1[0], setArrow = _$kY93V$useState1[1];
    var arrowSize = (0, $faa9b9e7936220ba$export$1ab7ae714698c4b8)(arrow);
    var arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    var arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    var desiredPlacement = side + (align !== "center" ? "-" + align : "");
    var collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : (0, $8OnJk._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, collisionPaddingProp);
    var boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    var hasExplicitBoundaries = boundary.length > 0;
    var detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    var _$kY93V$useFloating = (0, $26c78fdce868f04a$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (0, $f3e37db8bfe4dcf2$export$deee3a793edee05f),
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $f5dbeeabf004a4ed$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $f5dbeeabf004a4ed$export$fba63a578e423eb)((0, $8OnJk._)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $f5dbeeabf004a4ed$export$7bf07e38f3dc4b69)() : undefined
            }, detectOverflowOptions)),
            avoidCollisions && (0, $f5dbeeabf004a4ed$export$8a83211c878a3f1f)((0, $8OnJk._)({}, detectOverflowOptions)),
            (0, $f5dbeeabf004a4ed$export$346677f925de839c)((0, $8E768._)((0, $8OnJk._)({}, detectOverflowOptions), {
                apply: function(param) {
                    var elements = param.elements, rects = param.rects, availableWidth = param.availableWidth, availableHeight = param.availableHeight;
                    var _rects_reference = rects.reference, anchorWidth = _rects_reference.width, anchorHeight = _rects_reference.height;
                    var contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", "".concat(availableWidth, "px"));
                    contentStyle.setProperty("--radix-popper-available-height", "".concat(availableHeight, "px"));
                    contentStyle.setProperty("--radix-popper-anchor-width", "".concat(anchorWidth, "px"));
                    contentStyle.setProperty("--radix-popper-anchor-height", "".concat(anchorHeight, "px"));
                }
            })),
            arrow && (0, $26c78fdce868f04a$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $f5dbeeabf004a4ed$export$fe8985bb6374093c)({
                strategy: "referenceHidden"
            })
        ]
    }), refs = _$kY93V$useFloating.refs, floatingStyles = _$kY93V$useFloating.floatingStyles, placement = _$kY93V$useFloating.placement, isPositioned = _$kY93V$useFloating.isPositioned, middlewareData = _$kY93V$useFloating.middlewareData;
    var _$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement = (0, $8GFUW._)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement), 2), placedSide = _$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement[0], placedAlign = _$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement[1];
    var handlePlaced = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onPlaced);
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    var arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    var arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    var cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    var _$kY93V$useState2 = (0, $8GFUW._)((0, $6cds3.useState)(), 2), contentZIndex = _$kY93V$useState2[0], setContentZIndex = _$kY93V$useState2[1];
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: (0, $8E768._)((0, $8OnJk._)({}, floatingStyles), (0, $dxWQo._)({
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex
        }, "--radix-popper-transform-origin", [
            (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
            (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
        ].join(" "))) // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $6cds3.createElement)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: (0, $8E768._)((0, $8OnJk._)({}, contentProps.style), {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        })
    }))));
});
/*#__PURE__*/ Object.assign($ed1fe7c5ccd267a8$export$bc4ae5855d3c4fc, {
    displayName: $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ var $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
var $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $ed1fe7c5ccd267a8$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    var __scopePopper = props.__scopePopper, arrowProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopper"
    ]);
    var contentContext = $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$useContentContext($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    var baseSide = $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    var _obj;
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $6cds3.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: (_obj = {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY
        }, (0, $dxWQo._)(_obj, baseSide, 0), (0, $dxWQo._)(_obj, "transformOrigin", {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
        }[contentContext.placedSide]), (0, $dxWQo._)(_obj, "transform", {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[contentContext.placedSide]), (0, $dxWQo._)(_obj, "visibility", contentContext.shouldHideArrow ? "hidden" : undefined), _obj)
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $93a52fa050c7b74c$export$be92b6f5f03c0fe9), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: (0, $8E768._)((0, $8OnJk._)({}, arrowProps.style), {
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        })
    }))));
});
/*#__PURE__*/ Object.assign($ed1fe7c5ccd267a8$export$79d62cd4e10a3fd0, {
    displayName: $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
var $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$transformOrigin = function(options) {
    return {
        name: "transformOrigin",
        options: options,
        fn: function(data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            var placement = data.placement, rects = data.rects, middlewareData = data.middlewareData;
            var cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            var isArrowHidden = cannotCenterArrow;
            var arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            var arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            var _$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement = (0, $8GFUW._)($ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement), 2), placedSide = _$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement[0], placedAlign = _$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement[1];
            var noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            var arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            var arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            var x = "";
            var y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
                y = "".concat(-arrowHeight, "px");
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
                y = "".concat(rects.floating.height + arrowHeight, "px");
            } else if (placedSide === "right") {
                x = "".concat(-arrowHeight, "px");
                y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
            } else if (placedSide === "left") {
                x = "".concat(rects.floating.width + arrowHeight, "px");
                y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    };
};
function $ed1fe7c5ccd267a8$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    var _placement_split = (0, $8GFUW._)(placement.split("-"), 2), side = _placement_split[0], tmp = _placement_split[1], align = tmp === void 0 ? "center" : tmp;
    return [
        side,
        align
    ];
}
var $ed1fe7c5ccd267a8$export$be92b6f5f03c0fe9 = $ed1fe7c5ccd267a8$export$badac9ada3a0bdf9;
var $ed1fe7c5ccd267a8$export$b688253958b8dfe7 = $ed1fe7c5ccd267a8$export$ecd4e1ccab6ed6d;
var $ed1fe7c5ccd267a8$export$7c6e2c02157bb7d2 = $ed1fe7c5ccd267a8$export$bc4ae5855d3c4fc;
var $ed1fe7c5ccd267a8$export$21b07c8f274aebd5 = $ed1fe7c5ccd267a8$export$79d62cd4e10a3fd0;






var $8OnJk = parcelRequire("8OnJk");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");


var $6cds3 = parcelRequire("6cds3");









var $48e862867c143952$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $48e862867c143952$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ var $48e862867c143952$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
var $48e862867c143952$var$_$98Iye$createCollection = (0, $8GFUW._)((0, $88a40bb64f7ba2d9$export$c74125a8e3af6bb2)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$GROUP_NAME), 3), $48e862867c143952$var$$d7bdfb9eb0fdf311$var$Collection = $48e862867c143952$var$_$98Iye$createCollection[0], $48e862867c143952$var$$d7bdfb9eb0fdf311$var$useCollection = $48e862867c143952$var$_$98Iye$createCollection[1], $48e862867c143952$var$$d7bdfb9eb0fdf311$var$createCollectionScope = $48e862867c143952$var$_$98Iye$createCollection[2];
var $48e862867c143952$var$_$98Iye$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $48e862867c143952$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]), 2), $48e862867c143952$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext = $48e862867c143952$var$_$98Iye$createContextScope[0], $48e862867c143952$export$c7109489551a4f4 = $48e862867c143952$var$_$98Iye$createContextScope[1];
var $48e862867c143952$var$_$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext = (0, $8GFUW._)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($48e862867c143952$var$$d7bdfb9eb0fdf311$var$GROUP_NAME), 2), $48e862867c143952$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider = $48e862867c143952$var$_$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext[0], $48e862867c143952$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext = $48e862867c143952$var$_$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext[1];
var $48e862867c143952$export$8699f7c8af148338 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    return /*#__PURE__*/ (0, $6cds3.createElement)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $6cds3.createElement)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $6cds3.createElement)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($48e862867c143952$export$8699f7c8af148338, {
    displayName: $48e862867c143952$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $48e862867c143952$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeRovingFocusGroup = props.__scopeRovingFocusGroup, orientation = props.orientation, tmp = props.loop, loop = tmp === void 0 ? false : tmp, dir = props.dir, currentTabStopIdProp = props.currentTabStopId, defaultCurrentTabStopId = props.defaultCurrentTabStopId, onCurrentTabStopIdChange = props.onCurrentTabStopIdChange, onEntryFocus = props.onEntryFocus, groupProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeRovingFocusGroup",
        "orientation",
        "loop",
        "dir",
        "currentTabStopId",
        "defaultCurrentTabStopId",
        "onCurrentTabStopIdChange",
        "onEntryFocus"
    ]);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    var direction = (0, $ad4cf16c545e595a$export$b39126d51d94e6f3)(dir);
    var _$98Iye$useControllableState = (0, $8GFUW._)((0, $67d582389dee973c$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    }), 2), tmp1 = _$98Iye$useControllableState[0], currentTabStopId = tmp1 === void 0 ? null : tmp1, setCurrentTabStopId = _$98Iye$useControllableState[1];
    var _$98Iye$useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isTabbingBackOut = _$98Iye$useState[0], setIsTabbingBackOut = _$98Iye$useState[1];
    var handleEntryFocus = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onEntryFocus);
    var getItems = $48e862867c143952$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    var isClickFocusRef = (0, $6cds3.useRef)(false);
    var _$98Iye$useState1 = (0, $8GFUW._)((0, $6cds3.useState)(0), 2), focusableItemsCount = _$98Iye$useState1[0], setFocusableItemsCount = _$98Iye$useState1[1];
    (0, $6cds3.useEffect)(function() {
        var node = ref.current;
        if (node) {
            node.addEventListener($48e862867c143952$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return function() {
                return node.removeEventListener($48e862867c143952$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            };
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $6cds3.useCallback)(function(tabStopId) {
            return setCurrentTabStopId(tabStopId);
        }, [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $6cds3.useCallback)(function() {
            return setIsTabbingBackOut(true);
        }, []),
        onFocusableItemAdd: (0, $6cds3.useCallback)(function() {
            return setFocusableItemsCount(function(prevCount) {
                return prevCount + 1;
            });
        }, []),
        onFocusableItemRemove: (0, $6cds3.useCallback)(function() {
            return setFocusableItemsCount(function(prevCount) {
                return prevCount - 1;
            });
        }, [])
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: (0, $8OnJk._)({
            outline: "none"
        }, props.style),
        onMouseDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onMouseDown, function() {
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocus, function(event) {
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            var isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                var entryFocusEvent = new CustomEvent($48e862867c143952$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $48e862867c143952$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    var items = getItems().filter(function(item) {
                        return item.focusable;
                    });
                    var activeItem = items.find(function(item) {
                        return item.active;
                    });
                    var currentItem = items.find(function(item) {
                        return item.id === currentTabStopId;
                    });
                    var candidateItems = [
                        activeItem,
                        currentItem
                    ].concat((0, $fLnyw._)(items)).filter(Boolean);
                    var candidateNodes = candidateItems.map(function(item) {
                        return item.ref.current;
                    });
                    $48e862867c143952$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onBlur, function() {
            return setIsTabbingBackOut(false);
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ var $48e862867c143952$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
var $48e862867c143952$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeRovingFocusGroup = props.__scopeRovingFocusGroup, tmp = props.focusable, focusable = tmp === void 0 ? true : tmp, tmp1 = props.active, active = tmp1 === void 0 ? false : tmp1, tabStopId = props.tabStopId, itemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeRovingFocusGroup",
        "focusable",
        "active",
        "tabStopId"
    ]);
    var autoId = (0, $3a7a3a6a18539928$export$f680877a34711e37)();
    var id = tabStopId || autoId;
    var context = $48e862867c143952$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($48e862867c143952$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    var isCurrentTabStop = context.currentTabStopId === id;
    var getItems = $48e862867c143952$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    var onFocusableItemAdd = context.onFocusableItemAdd, onFocusableItemRemove = context.onFocusableItemRemove;
    (0, $6cds3.useEffect)(function() {
        if (focusable) {
            onFocusableItemAdd();
            return function() {
                return onFocusableItemRemove();
            };
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)($48e862867c143952$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).span, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onMouseDown, function(event) {
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocus, function() {
            return context.onItemFocus(id);
        }),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            var focusIntent = $48e862867c143952$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                var items = getItems().filter(function(item) {
                    return item.focusable;
                });
                var candidateNodes = items.map(function(item) {
                    return item.ref.current;
                });
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    var currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $48e862867c143952$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(function() {
                    return $48e862867c143952$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                });
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($48e862867c143952$export$ab9df7c53fe8454, {
    displayName: $48e862867c143952$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
var $48e862867c143952$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $48e862867c143952$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $48e862867c143952$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    var key = $48e862867c143952$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $48e862867c143952$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $48e862867c143952$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    var PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $48e862867c143952$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map(function(_, index) {
        return array[(startIndex + index) % array.length];
    });
}
var $48e862867c143952$export$be92b6f5f03c0fe9 = $48e862867c143952$export$8699f7c8af148338;
var $48e862867c143952$export$6d08773d2e66f8f2 = $48e862867c143952$export$ab9df7c53fe8454;




var $2d232392051ea0c1$var$getDefaultParent = function getDefaultParent(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $2d232392051ea0c1$var$counterMap = new WeakMap();
var $2d232392051ea0c1$var$uncontrolledNodes = new WeakMap();
var $2d232392051ea0c1$var$markerMap = {};
var $2d232392051ea0c1$var$lockCount = 0;
var $2d232392051ea0c1$var$unwrapHost = function unwrapHost1(node) {
    return node && (node.host || $2d232392051ea0c1$var$unwrapHost(node.parentNode));
};
var $2d232392051ea0c1$var$correctTargets = function correctTargets(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $2d232392051ea0c1$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $2d232392051ea0c1$var$applyAttributeToOthers = function applyAttributeToOthers(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $2d232392051ea0c1$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$2d232392051ea0c1$var$markerMap[markerName]) $2d232392051ea0c1$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $2d232392051ea0c1$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function keep1(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function deep1(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($2d232392051ea0c1$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $2d232392051ea0c1$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $2d232392051ea0c1$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $2d232392051ea0c1$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $2d232392051ea0c1$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $2d232392051ea0c1$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$2d232392051ea0c1$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $2d232392051ea0c1$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $2d232392051ea0c1$var$lockCount--;
        if (!$2d232392051ea0c1$var$lockCount) {
            // clear
            $2d232392051ea0c1$var$counterMap = new WeakMap();
            $2d232392051ea0c1$var$counterMap = new WeakMap();
            $2d232392051ea0c1$var$uncontrolledNodes = new WeakMap();
            $2d232392051ea0c1$var$markerMap = {};
        }
    };
};
var $2d232392051ea0c1$export$6e33d16126ed003c = function hideOthers(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $2d232392051ea0c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $2d232392051ea0c1$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $2d232392051ea0c1$export$59151cc8db999a24 = function inertOthers(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $2d232392051ea0c1$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $2d232392051ea0c1$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $2d232392051ea0c1$export$cc95fea82d705fca = function supportsInert() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $2d232392051ea0c1$export$9845d4b6bdad192b = function suppressOthers(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($2d232392051ea0c1$export$cc95fea82d705fca() ? $2d232392051ea0c1$export$59151cc8db999a24 : $2d232392051ea0c1$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");
var $18aa8ab4d20d7a61$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $18aa8ab4d20d7a61$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $18aa8ab4d20d7a61$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $18aa8ab4d20d7a61$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $2894889a23562024$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $6cds3 = parcelRequire("6cds3");
function $8db7ca8c4b22e213$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $6cds3.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $5bbcf113c5c53a8c$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $8db7ca8c4b22e213$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $2894889a23562024$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $7UAGh = parcelRequire("7UAGh");
function $8f88036768f593ea$var$ItoI(a) {
    return a;
}
function $8f88036768f593ea$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $8f88036768f593ea$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function read() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function useMedium(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function assignSyncMedium(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function push(x) {
                    return cb(x);
                },
                filter: function filter() {
                    return buffer;
                }
            };
        },
        assignMedium: function assignMedium(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function executeQueue() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function cycle() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function push(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function filter(_filter) {
                    pendingQueue = pendingQueue.filter(_filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $8f88036768f593ea$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $8f88036768f593ea$var$ItoI;
    return $8f88036768f593ea$var$innerCreateMedium(defaults, middleware);
}
function $8f88036768f593ea$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $8f88036768f593ea$var$innerCreateMedium(null);
    medium.options = (0, $7UAGh.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $c1fe9d686c961435$export$e27363444bedfeac = (0, $8f88036768f593ea$export$e13ec7dd7a14088d)();


var $3645f440c618c499$var$nothing = function nothing() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $3645f440c618c499$export$22940b497e769dee = $6cds3.forwardRef(function(props, parentRef) {
    var ref = $6cds3.useRef(null);
    var _a = $6cds3.useState({
        onScrollCapture: $3645f440c618c499$var$nothing,
        onWheelCapture: $3645f440c618c499$var$nothing,
        onTouchMoveCapture: $3645f440c618c499$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $7UAGh.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $5bbcf113c5c53a8c$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $7UAGh.__assign)((0, $7UAGh.__assign)({}, rest), callbacks);
    return $6cds3.createElement($6cds3.Fragment, null, enabled && $6cds3.createElement(SideCar, {
        sideCar: (0, $c1fe9d686c961435$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $6cds3.cloneElement($6cds3.Children.only(children), (0, $7UAGh.__assign)((0, $7UAGh.__assign)({}, containerProps), {
        ref: containerRef
    })) : $6cds3.createElement(Container, (0, $7UAGh.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$3645f440c618c499$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$3645f440c618c499$export$22940b497e769dee.classNames = {
    fullWidth: (0, $18aa8ab4d20d7a61$export$898e37bbd2a0ae4e),
    zeroRight: (0, $18aa8ab4d20d7a61$export$1da7500147d4bc3)
};



var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");
var $73635dc726fb3def$var$SideCar = function SideCar(_a) {
    var sideCar = _a.sideCar, rest = (0, $7UAGh.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $6cds3.createElement(Target, (0, $7UAGh.__assign)({}, rest));
};
$73635dc726fb3def$var$SideCar.isSideCarExport = true;
function $73635dc726fb3def$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $73635dc726fb3def$var$SideCar;
}



var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
var $1fdda95670b5b327$var$currentNonce;
var $1fdda95670b5b327$export$c5f670b24c0ae95a = function setNonce(nonce) {
    $1fdda95670b5b327$var$currentNonce = nonce;
};
var $1fdda95670b5b327$export$2b85b721e524d74b = function getNonce() {
    if ($1fdda95670b5b327$var$currentNonce) return $1fdda95670b5b327$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $53137abe5e74fc14$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1fdda95670b5b327$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $53137abe5e74fc14$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $53137abe5e74fc14$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $53137abe5e74fc14$export$7c74eec858d5d226 = function stylesheetSingleton() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function add(style) {
            if (counter == 0) {
                if (stylesheet = $53137abe5e74fc14$var$makeStyleTag()) {
                    $53137abe5e74fc14$var$injectStyles(stylesheet, style);
                    $53137abe5e74fc14$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function remove() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $e255e1573e3628cf$export$7d7b35c2d250e94c = function styleHookSingleton() {
    var sheet = (0, $53137abe5e74fc14$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $6cds3.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $f84485bc620a2a76$export$c1248ee86ba532c8 = function styleSingleton() {
    var useStyle = (0, $e255e1573e3628cf$export$7d7b35c2d250e94c)();
    var Sheet = function Sheet(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $b98ea1a71f633363$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $b98ea1a71f633363$var$parse = function parse(x) {
    return parseInt(x || "", 10) || 0;
};
var $b98ea1a71f633363$var$getOffset = function getOffset(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $b98ea1a71f633363$var$parse(left),
        $b98ea1a71f633363$var$parse(top),
        $b98ea1a71f633363$var$parse(right)
    ];
};
var $b98ea1a71f633363$export$75f2ca8f029c77f4 = function getGapWidth(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $b98ea1a71f633363$export$efed13b5d0ca3386;
    var offsets = $b98ea1a71f633363$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $08937980cc3aceb3$var$Style = (0, $f84485bc620a2a76$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $08937980cc3aceb3$var$getStyles = function getStyles(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $18aa8ab4d20d7a61$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $18aa8ab4d20d7a61$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $18aa8ab4d20d7a61$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $18aa8ab4d20d7a61$export$1da7500147d4bc3), " .").concat((0, $18aa8ab4d20d7a61$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $18aa8ab4d20d7a61$export$898e37bbd2a0ae4e), " .").concat((0, $18aa8ab4d20d7a61$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $18aa8ab4d20d7a61$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $08937980cc3aceb3$export$9aa43b459c5ae9b9 = function RemoveScrollBar(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $6cds3.useMemo(function() {
        return (0, $b98ea1a71f633363$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $6cds3.createElement($08937980cc3aceb3$var$Style, {
        styles: $08937980cc3aceb3$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $0c4c3651a2403367$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $0c4c3651a2403367$var$options = Object.defineProperty({}, "passive", {
        get: function get() {
            $0c4c3651a2403367$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $0c4c3651a2403367$var$options, $0c4c3651a2403367$var$options);
    // @ts-ignore
    window.removeEventListener("test", $0c4c3651a2403367$var$options, $0c4c3651a2403367$var$options);
} catch (err) {
    $0c4c3651a2403367$var$passiveSupported = false;
}
var $0c4c3651a2403367$export$10a6e88623fa9454 = $0c4c3651a2403367$var$passiveSupported ? {
    passive: false
} : false;


var $cb70b0fea97977d7$var$alwaysContainsScroll = function alwaysContainsScroll(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $cb70b0fea97977d7$var$elementCanBeScrolled = function elementCanBeScrolled(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$cb70b0fea97977d7$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $cb70b0fea97977d7$var$elementCouldBeVScrolled = function elementCouldBeVScrolled(node) {
    return $cb70b0fea97977d7$var$elementCanBeScrolled(node, "overflowY");
};
var $cb70b0fea97977d7$var$elementCouldBeHScrolled = function elementCouldBeHScrolled(node) {
    return $cb70b0fea97977d7$var$elementCanBeScrolled(node, "overflowX");
};
var $cb70b0fea97977d7$export$9ec64480cae49817 = function locationCouldBeScrolled(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $cb70b0fea97977d7$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $cb70b0fea97977d7$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $cb70b0fea97977d7$var$getVScrollVariables = function getVScrollVariables(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $cb70b0fea97977d7$var$getHScrollVariables = function getHScrollVariables(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $cb70b0fea97977d7$var$elementCouldBeScrolled = function elementCouldBeScrolled(axis, node) {
    return axis === "v" ? $cb70b0fea97977d7$var$elementCouldBeVScrolled(node) : $cb70b0fea97977d7$var$elementCouldBeHScrolled(node);
};
var $cb70b0fea97977d7$var$getScrollVariables = function getScrollVariables(axis, node) {
    return axis === "v" ? $cb70b0fea97977d7$var$getVScrollVariables(node) : $cb70b0fea97977d7$var$getHScrollVariables(node);
};
var $cb70b0fea97977d7$var$getDirectionFactor = function getDirectionFactor(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $cb70b0fea97977d7$export$dde0441bd4a6ded8 = function handleScroll(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $cb70b0fea97977d7$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $cb70b0fea97977d7$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($cb70b0fea97977d7$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $937a225d3f562cb3$export$6e085704a79f4f56 = function getTouchXY(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $937a225d3f562cb3$export$39efaa2ca254a28d = function getDeltaXY(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $937a225d3f562cb3$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $937a225d3f562cb3$var$deltaCompare = function deltaCompare(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $937a225d3f562cb3$var$generateStyle = function generateStyle(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $937a225d3f562cb3$var$idCounter = 0;
var $937a225d3f562cb3$var$lockStack = [];
function $937a225d3f562cb3$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $6cds3.useRef([]);
    var touchStartRef = $6cds3.useRef([
        0,
        0
    ]);
    var activeAxis = $6cds3.useRef();
    var id = $6cds3.useState($937a225d3f562cb3$var$idCounter++)[0];
    var Style = $6cds3.useState(function() {
        return (0, $f84485bc620a2a76$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $6cds3.useRef(props);
    $6cds3.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $6cds3.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $7UAGh.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($937a225d3f562cb3$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $6cds3.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $937a225d3f562cb3$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $cb70b0fea97977d7$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $cb70b0fea97977d7$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $cb70b0fea97977d7$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $6cds3.useCallback(function(_event) {
        var event = _event;
        if (!$937a225d3f562cb3$var$lockStack.length || $937a225d3f562cb3$var$lockStack[$937a225d3f562cb3$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $937a225d3f562cb3$export$39efaa2ca254a28d(event) : $937a225d3f562cb3$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $937a225d3f562cb3$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($937a225d3f562cb3$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $6cds3.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $6cds3.useCallback(function(event) {
        touchStartRef.current = $937a225d3f562cb3$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $6cds3.useCallback(function(event) {
        shouldCancel(event.type, $937a225d3f562cb3$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $6cds3.useCallback(function(event) {
        shouldCancel(event.type, $937a225d3f562cb3$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $6cds3.useEffect(function() {
        $937a225d3f562cb3$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $0c4c3651a2403367$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $0c4c3651a2403367$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $0c4c3651a2403367$export$10a6e88623fa9454));
        return function() {
            $937a225d3f562cb3$var$lockStack = $937a225d3f562cb3$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $0c4c3651a2403367$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $0c4c3651a2403367$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $0c4c3651a2403367$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $6cds3.createElement($6cds3.Fragment, null, inert ? $6cds3.createElement(Style, {
        styles: $937a225d3f562cb3$var$generateStyle(id)
    }) : null, removeScrollBar ? $6cds3.createElement((0, $08937980cc3aceb3$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $fdb9ba10ecbf1b8c$export$2e2bcd8739ae039 = (0, $73635dc726fb3def$export$6cacc8fb0a9b94ce)((0, $c1fe9d686c961435$export$e27363444bedfeac), (0, $937a225d3f562cb3$export$a09dbff87b5da2d));


var $8b6c725e50844855$var$ReactRemoveScroll = $6cds3.forwardRef(function(props, ref) {
    return $6cds3.createElement((0, $3645f440c618c499$export$22940b497e769dee), (0, $7UAGh.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $fdb9ba10ecbf1b8c$export$2e2bcd8739ae039)
    }));
});
$8b6c725e50844855$var$ReactRemoveScroll.classNames = (0, $3645f440c618c499$export$22940b497e769dee).classNames;
var $8b6c725e50844855$export$2e2bcd8739ae039 = $8b6c725e50844855$var$ReactRemoveScroll;


var $693433fd97814b42$var$$6cc32821e9371a1c$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $693433fd97814b42$var$$6cc32821e9371a1c$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $693433fd97814b42$var$$6cc32821e9371a1c$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $693433fd97814b42$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS = (0, $fLnyw._)($693433fd97814b42$var$$6cc32821e9371a1c$var$FIRST_KEYS).concat((0, $fLnyw._)($693433fd97814b42$var$$6cc32821e9371a1c$var$LAST_KEYS));
var $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
    ltr: (0, $fLnyw._)($693433fd97814b42$var$$6cc32821e9371a1c$var$SELECTION_KEYS).concat([
        "ArrowRight"
    ]),
    rtl: (0, $fLnyw._)($693433fd97814b42$var$$6cc32821e9371a1c$var$SELECTION_KEYS).concat([
        "ArrowLeft"
    ])
};
var $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$MENU_NAME = "Menu";
var $693433fd97814b42$var$_$epM9y$createCollection = (0, $8GFUW._)((0, $88a40bb64f7ba2d9$export$c74125a8e3af6bb2)($693433fd97814b42$var$$6cc32821e9371a1c$var$MENU_NAME), 3), $693433fd97814b42$var$$6cc32821e9371a1c$var$Collection = $693433fd97814b42$var$_$epM9y$createCollection[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useCollection = $693433fd97814b42$var$_$epM9y$createCollection[1], $693433fd97814b42$var$$6cc32821e9371a1c$var$createCollectionScope = $693433fd97814b42$var$_$epM9y$createCollection[2];
var $693433fd97814b42$var$_$epM9y$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)($693433fd97814b42$var$$6cc32821e9371a1c$var$MENU_NAME, [
    $693433fd97814b42$var$$6cc32821e9371a1c$var$createCollectionScope,
    (0, $ed1fe7c5ccd267a8$export$722aac194ae923),
    (0, $48e862867c143952$export$c7109489551a4f4)
]), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext = $693433fd97814b42$var$_$epM9y$createContextScope[0], $693433fd97814b42$export$4027731b685e72eb = $693433fd97814b42$var$_$epM9y$createContextScope[1];
var $693433fd97814b42$var$$6cc32821e9371a1c$var$usePopperScope = (0, $ed1fe7c5ccd267a8$export$722aac194ae923)();
var $693433fd97814b42$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope = (0, $48e862867c143952$export$c7109489551a4f4)();
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$MENU_NAME), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext[1];
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext1 = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$MENU_NAME), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuRootProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext1[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuRootContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext1[1];
var $693433fd97814b42$export$d9b273488cd8ce6f = function(props) {
    var __scopeMenu = props.__scopeMenu, tmp = props.open, open = tmp === void 0 ? false : tmp, children = props.children, dir = props.dir, onOpenChange = props.onOpenChange, tmp1 = props.modal, modal = tmp1 === void 0 ? true : tmp1;
    var popperScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    var _$epM9y$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), content = _$epM9y$useState[0], setContent = _$epM9y$useState[1];
    var isUsingKeyboardRef = (0, $6cds3.useRef)(false);
    var handleOpenChange = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onOpenChange);
    var direction = (0, $ad4cf16c545e595a$export$b39126d51d94e6f3)(dir);
    (0, $6cds3.useEffect)(function() {
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        var handleKeyDown = function() {
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        var handlePointer = function() {
            return isUsingKeyboardRef.current = false;
        };
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return function() {
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: (0, $6cds3.useCallback)(function() {
            return handleOpenChange(false);
        }, [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
/*#__PURE__*/ Object.assign($693433fd97814b42$export$d9b273488cd8ce6f, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuAnchor
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$ANCHOR_NAME = "MenuAnchor";
var $693433fd97814b42$export$9fa5ebd18bee4d43 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, anchorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu"
    ]);
    var popperScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$b688253958b8dfe7), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$9fa5ebd18bee4d43, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext2 = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
}), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$PortalProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext2[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$usePortalContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext2[1];
var $693433fd97814b42$export$793392f970497feb = function(props) {
    var __scopeMenu = props.__scopeMenu, forceMount = props.forceMount, children = props.children, container = props.container;
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $5521a3997b1d3e3c$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($693433fd97814b42$export$793392f970497feb, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext3 = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuContentProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext3[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContentContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext3[1];
var $693433fd97814b42$export$479f0f2f71193efe = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var portalContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePortalContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    var tmp = props.forceMount, forceMount = tmp === void 0 ? portalContext.forceMount : tmp, contentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "forceMount"
    ]);
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    var rootContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuRootContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuRootContentModal, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuRootContentNonModal, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ var $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    (0, $6cds3.useEffect)(function() {
        var content = ref.current;
        if (content) return (0, $2d232392051ea0c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocusOutside, function(event) {
            return event.preventDefault();
        }, {
            checkForDefaultPrevented: false
        }),
        onDismiss: function() {
            return context.onOpenChange(false);
        }
    }));
});
var $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: function() {
            return context.onOpenChange(false);
        }
    }));
});
/* ---------------------------------------------------------------------------------------------- */ var $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, tmp = props.loop, loop = tmp === void 0 ? false : tmp, trapFocus = props.trapFocus, onOpenAutoFocus = props.onOpenAutoFocus, onCloseAutoFocus = props.onCloseAutoFocus, disableOutsidePointerEvents = props.disableOutsidePointerEvents, onEntryFocus = props.onEntryFocus, onEscapeKeyDown = props.onEscapeKeyDown, onPointerDownOutside = props.onPointerDownOutside, onFocusOutside = props.onFocusOutside, onInteractOutside = props.onInteractOutside, onDismiss = props.onDismiss, disableOutsideScroll = props.disableOutsideScroll, contentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu",
        "loop",
        "trapFocus",
        "onOpenAutoFocus",
        "onCloseAutoFocus",
        "disableOutsidePointerEvents",
        "onEntryFocus",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside",
        "onDismiss",
        "disableOutsideScroll"
    ]);
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    var rootContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuRootContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    var popperScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    var rovingFocusGroupScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    var getItems = $693433fd97814b42$var$$6cc32821e9371a1c$var$useCollection(__scopeMenu);
    var _$epM9y$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), currentItemId = _$epM9y$useState[0], setCurrentItemId = _$epM9y$useState[1];
    var contentRef = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    var timerRef = (0, $6cds3.useRef)(0);
    var searchRef = (0, $6cds3.useRef)("");
    var pointerGraceTimerRef = (0, $6cds3.useRef)(0);
    var pointerGraceIntentRef = (0, $6cds3.useRef)(null);
    var pointerDirRef = (0, $6cds3.useRef)("right");
    var lastPointerXRef = (0, $6cds3.useRef)(0);
    var ScrollLockWrapper = disableOutsideScroll ? (0, $8b6c725e50844855$export$2e2bcd8739ae039) : (0, $6cds3.Fragment);
    var scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $513654131ef3bd4b$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    } : undefined;
    var handleTypeaheadSearch = function(key) {
        var _items$find, _items$find2;
        var search = searchRef.current + key;
        var items = getItems().filter(function(item) {
            return !item.disabled;
        });
        var currentItem = document.activeElement;
        var currentMatch = (_items$find = items.find(function(item) {
            return item.ref.current === currentItem;
        })) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        var values = items.map(function(item) {
            return item.textValue;
        });
        var nextMatch = $693433fd97814b42$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        var newItem = (_items$find2 = items.find(function(item) {
            return item.textValue === nextMatch;
        })) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(function() {
                return updateSearch("");
            }, 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(function() {
            return newItem.focus();
        });
    };
    (0, $6cds3.useEffect)(function() {
        return function() {
            return window.clearTimeout(timerRef.current);
        };
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $6b90108589ddc0b8$export$b7ece24a22aeda8c)();
    var isPointerMovingToSubmenu = (0, $6cds3.useCallback)(function(event) {
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        var isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $693433fd97814b42$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: (0, $6cds3.useCallback)(function(event) {
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: (0, $6cds3.useCallback)(function(event) {
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: (0, $6cds3.useCallback)(function(event) {
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: (0, $6cds3.useCallback)(function(intent) {
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ (0, $6cds3.createElement)(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ (0, $6cds3.createElement)((0, $0ab32e587c90dbe2$export$20e40289641fbbb6), {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(onOpenAutoFocus, function(event) {
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $495a48040502b2f4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $48e862867c143952$export$be92b6f5f03c0fe9), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(onEntryFocus, function(event) {
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        })
    }), /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$7c6e2c02157bb7d2), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $693433fd97814b42$var$$6cc32821e9371a1c$var$getOpenState(context.open),
        "data-radix-menu-content": "",
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: (0, $8OnJk._)({
            outline: "none"
        }, contentProps.style),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(contentProps.onKeyDown, function(event) {
            // submenu key events bubble through portals. We only care about keys in this menu.
            var target = event.target;
            var isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
            var isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            var isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === "Tab") event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            var content = contentRef.current;
            if (event.target !== content) return;
            if (!$693433fd97814b42$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            var items = getItems().filter(function(item) {
                return !item.disabled;
            });
            var candidateNodes = items.map(function(item) {
                return item.ref.current;
            });
            if ($693433fd97814b42$var$$6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $693433fd97814b42$var$$6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onBlur, function(event) {
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = "";
            }
        }),
        onPointerMove: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerMove, $693433fd97814b42$var$$6cc32821e9371a1c$var$whenMouse(function(event) {
            var target = event.target;
            var pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                var newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$479f0f2f71193efe, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuGroup
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$GROUP_NAME = "MenuGroup";
var $693433fd97814b42$export$22a631d1f72787bb = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, groupProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "group"
    }, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$22a631d1f72787bb, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuLabel
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$LABEL_NAME = "MenuLabel";
var $693433fd97814b42$export$dd37bec0e8a99143 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, labelProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$dd37bec0e8a99143, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
var $693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
var $693433fd97814b42$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var tmp = props.disabled, disabled = tmp === void 0 ? false : tmp, onSelect = props.onSelect, itemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "disabled",
        "onSelect"
    ]);
    var ref = (0, $6cds3.useRef)(null);
    var rootContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuRootContext($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    var contentContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContentContext($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    var isPointerDownRef = (0, $6cds3.useRef)(false);
    var handleSelect = function() {
        var menuItem = ref.current;
        if (!disabled && menuItem) {
            var itemSelectEvent = new CustomEvent($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_SELECT, function(event) {
                return onSelect === null || onSelect === void 0 ? void 0 : onSelect(event);
            }, {
                once: true
            });
            (0, $02d9b2ca3ec07cdd$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: function(event) {
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerUp, function(event) {
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            var isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($693433fd97814b42$var$$6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$2ce376c2cc3355c8, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_NAME
});
/* ---------------------------------------------------------------------------------------------- */ var $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, tmp = props.disabled, disabled = tmp === void 0 ? false : tmp, textValue = props.textValue, itemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu",
        "disabled",
        "textValue"
    ]);
    var contentContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContentContext($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    var rovingFocusGroupScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    var _$epM9y$useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), isFocused = _$epM9y$useState[0], setIsFocused = _$epM9y$useState[1]; // get the item's `.textContent` as default strategy for typeahead `textValue`
    var _$epM9y$useState1 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), textContent = _$epM9y$useState1[0], setTextContent = _$epM9y$useState1[1];
    (0, $6cds3.useEffect)(function() {
        var menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $48e862867c143952$export$6d08773d2e66f8f2), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "menuitem",
        "data-highlighted": isFocused ? "" : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerMove, $693433fd97814b42$var$$6cc32821e9371a1c$var$whenMouse(function(event) {
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    var item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerLeave, $693433fd97814b42$var$$6cc32821e9371a1c$var$whenMouse(function(event) {
            return contentContext.onItemLeave(event);
        })),
        onFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocus, function() {
            return setIsFocused(true);
        }),
        onBlur: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onBlur, function() {
            return setIsFocused(false);
        })
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $693433fd97814b42$export$f6f243521332502d = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var tmp = props.checked, checked = tmp === void 0 ? false : tmp, onCheckedChange = props.onCheckedChange, checkboxItemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "checked",
        "onCheckedChange"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$export$2ce376c2cc3355c8, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "menuitemcheckbox",
        "aria-checked": $693433fd97814b42$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? "mixed" : checked
    }, checkboxItemProps, {
        ref: forwardedRef,
        "data-state": $693433fd97814b42$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, function() {
            return onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange($693433fd97814b42$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? true : !checked);
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$f6f243521332502d, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext4 = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: function() {}
}), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$RadioGroupProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext4[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useRadioGroupContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext4[1];
var $693433fd97814b42$export$ea2200c9eee416b3 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var value = props.value, onValueChange = props.onValueChange, groupProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "value",
        "onValueChange"
    ]);
    var handleValueChange = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onValueChange);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$export$22a631d1f72787bb, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$ea2200c9eee416b3, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $693433fd97814b42$export$69bd225e9817f6d0 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var value = props.value, radioItemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "value"
    ]);
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useRadioGroupContext($693433fd97814b42$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME, props.__scopeMenu);
    var checked = value === context.value;
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$export$2ce376c2cc3355c8, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "menuitemradio",
        "aria-checked": checked
    }, radioItemProps, {
        ref: forwardedRef,
        "data-state": $693433fd97814b42$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(radioItemProps.onSelect, function() {
            var _context$onValueChang;
            return (_context$onValueChang = context.onValueChange) === null || _context$onValueChang === void 0 ? void 0 : _context$onValueChang.call(context, value);
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$69bd225e9817f6d0, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext5 = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
}), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$ItemIndicatorProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext5[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useItemIndicatorContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext5[1];
var $693433fd97814b42$export$a2593e23056970a3 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, forceMount = props.forceMount, itemIndicatorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu",
        "forceMount"
    ]);
    var indicatorContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useItemIndicatorContext($693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || $693433fd97814b42$var$$6cc32821e9371a1c$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).span, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, itemIndicatorProps, {
        ref: forwardedRef,
        "data-state": $693433fd97814b42$var$$6cc32821e9371a1c$var$getCheckedState(indicatorContext.checked)
    })));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$a2593e23056970a3, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSeparator
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$SEPARATOR_NAME = "MenuSeparator";
var $693433fd97814b42$export$1cec7dcdd713e220 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, separatorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu"
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).div, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "separator",
        "aria-orientation": "horizontal"
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$1cec7dcdd713e220, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuArrow
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$ARROW_NAME = "MenuArrow";
var $693433fd97814b42$export$bcdda4773debf5fa = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeMenu = props.__scopeMenu, arrowProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeMenu"
    ]);
    var popperScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$21b07c8f274aebd5), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$bcdda4773debf5fa, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
var $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext6 = (0, $8GFUW._)($693433fd97814b42$var$$6cc32821e9371a1c$var$createMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_NAME), 2), $693433fd97814b42$var$$6cc32821e9371a1c$var$MenuSubProvider = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext6[0], $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuSubContext = $693433fd97814b42$var$_$6cc32821e9371a1c$var$createMenuContext6[1];
var $693433fd97814b42$export$71bdb9d1e2909932 = function(props) {
    var __scopeMenu = props.__scopeMenu, children = props.children, tmp = props.open, open = tmp === void 0 ? false : tmp, onOpenChange = props.onOpenChange;
    var parentMenuContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
    var popperScope = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    var _$epM9y$useState = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), trigger = _$epM9y$useState[0], setTrigger = _$epM9y$useState[1];
    var _$epM9y$useState1 = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), content = _$epM9y$useState1[0], setContent = _$epM9y$useState1[1];
    var handleOpenChange = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(onOpenChange); // Prevent the parent menu from reopening with open submenus.
    (0, $6cds3.useEffect)(function() {
        if (parentMenuContext.open === false) handleOpenChange(false);
        return function() {
            return handleOpenChange(false);
        };
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuSubProvider, {
        scope: __scopeMenu,
        contentId: (0, $3a7a3a6a18539928$export$f680877a34711e37)(),
        triggerId: (0, $3a7a3a6a18539928$export$f680877a34711e37)(),
        trigger: trigger,
        onTriggerChange: setTrigger
    }, children)));
};
/*#__PURE__*/ Object.assign($693433fd97814b42$export$71bdb9d1e2909932, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $693433fd97814b42$export$5fbbb3ba7297405f = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    var rootContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuRootContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    var subContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuSubContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    var contentContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContentContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    var openTimerRef = (0, $6cds3.useRef)(null);
    var pointerGraceTimerRef = contentContext.pointerGraceTimerRef, onPointerGraceIntentChange = contentContext.onPointerGraceIntentChange;
    var scope = {
        __scopeMenu: props.__scopeMenu
    };
    var clearOpenTimer = (0, $6cds3.useCallback)(function() {
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    (0, $6cds3.useEffect)(function() {
        return clearOpenTimer;
    }, [
        clearOpenTimer
    ]);
    (0, $6cds3.useEffect)(function() {
        var pointerGraceTimer = pointerGraceTimerRef.current;
        return function() {
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$export$9fa5ebd18bee4d43, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        asChild: true
    }, scope), /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": $693433fd97814b42$var$$6cc32821e9371a1c$var$getOpenState(context.open)
    }, props, {
        ref: (0, $becf66aa9c19994c$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange) // This is redundant for mouse users but we cannot determine pointer type from
        ,
        onClick: function(event) {
            var _props$onClick;
            (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
            if (props.disabled || event.defaultPrevented) return;
            /**
       * We manually focus because iOS Safari doesn't always focus on click (e.g. buttons)
       * and we rely heavily on `onFocusOutside` for submenus to close when switching
       * between separate submenus.
       */ event.currentTarget.focus();
            if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerMove, $693433fd97814b42$var$$6cc32821e9371a1c$var$whenMouse(function(event) {
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
                contentContext.onPointerGraceIntentChange(null);
                openTimerRef.current = window.setTimeout(function() {
                    context.onOpenChange(true);
                    clearOpenTimer();
                }, 100);
            }
        })),
        onPointerLeave: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerLeave, $693433fd97814b42$var$$6cc32821e9371a1c$var$whenMouse(function(event) {
            var _context$content;
            clearOpenTimer();
            var contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
            if (contentRect) {
                var _context$content2;
                // TODO: make sure to update this when we change positioning logic
                var side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
                var rightSide = side === "right";
                var bleed = rightSide ? -5 : 5;
                var contentNearEdge = contentRect[rightSide ? "left" : "right"];
                var contentFarEdge = contentRect[rightSide ? "right" : "left"];
                contentContext.onPointerGraceIntentChange({
                    area: [
                        // consistently within polygon bounds
                        {
                            x: event.clientX + bleed,
                            y: event.clientY
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.bottom
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.bottom
                        }
                    ],
                    side: side
                });
                window.clearTimeout(pointerGraceTimerRef.current);
                pointerGraceTimerRef.current = window.setTimeout(function() {
                    return contentContext.onPointerGraceIntentChange(null);
                }, 300);
            } else {
                contentContext.onTriggerLeave(event);
                if (event.defaultPrevented) return; // There's 100ms where the user may leave an item before the submenu was opened.
                contentContext.onPointerGraceIntentChange(null);
            }
        })),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            var isTypingAhead = contentContext.searchRef.current !== "";
            if (props.disabled || isTypingAhead && event.key === " ") return;
            if ($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                var _context$content3;
                context.onOpenChange(true); // The trigger may hold focus if opened via pointer interaction
                // so we ensure content is given focus again when switching to keyboard.
                (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$5fbbb3ba7297405f, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubContent
 * -----------------------------------------------------------------------------------------------*/ var $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME = "MenuSubContent";
var $693433fd97814b42$export$e7142ab31822bde6 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var portalContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$usePortalContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    var tmp = props.forceMount, forceMount = tmp === void 0 ? portalContext.forceMount : tmp, subContentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "forceMount"
    ]);
    var context = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    var rootContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuRootContext($693433fd97814b42$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    var subContext = $693433fd97814b42$var$$6cc32821e9371a1c$var$useMenuSubContext($693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    var ref = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $6cds3.createElement)($693433fd97814b42$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId
    }, subContentProps, {
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: function(event) {
            var _ref$current;
            // when opening a submenu, focus content for keyboard users only
            if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
            event.preventDefault();
        } // The menu might close because of focusing another menu item in the parent menu. We
        ,
        onCloseAutoFocus: function(event) {
            return event.preventDefault();
        },
        onFocusOutside: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocusOutside, function(event) {
            // We prevent closing when the trigger is focused to avoid triggering a re-open animation
            // on pointer interaction.
            if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onEscapeKeyDown, function(event) {
            rootContext.onClose(); // ensure pressing escape in submenu doesn't escape full screen mode
            event.preventDefault();
        }),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            // Submenu key events bubble through portals. We only care about keys in this menu.
            var isKeyDownInside = event.currentTarget.contains(event.target);
            var isCloseKey = $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
            if (isKeyDownInside && isCloseKey) {
                var _subContext$trigger;
                context.onOpenChange(false); // We focus manually because we prevented it in `onCloseAutoFocus`
                (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })))));
});
/*#__PURE__*/ Object.assign($693433fd97814b42$export$e7142ab31822bde6, {
    displayName: $693433fd97814b42$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $693433fd97814b42$var$$6cc32821e9371a1c$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $693433fd97814b42$var$$6cc32821e9371a1c$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $693433fd97814b42$var$$6cc32821e9371a1c$var$getCheckedState(checked) {
    return $693433fd97814b42$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $693433fd97814b42$var$$6cc32821e9371a1c$var$focusFirst(candidates) {
    var PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $693433fd97814b42$var$$6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map(function(_, index) {
        return array[(startIndex + index) % array.length];
    });
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $693433fd97814b42$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    var isRepeated = search.length > 1 && Array.from(search).every(function(char) {
        return char === search[0];
    });
    var normalizedSearch = isRepeated ? search[0] : search;
    var currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    var wrappedValues = $693433fd97814b42$var$$6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    var excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter(function(v) {
        return v !== currentMatch;
    });
    var nextMatch = wrappedValues.find(function(value) {
        return value.toLowerCase().startsWith(normalizedSearch.toLowerCase());
    });
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $693433fd97814b42$var$$6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    var x = point.x, y = point.y;
    var inside = false;
    for(var i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        var xi = polygon[i].x;
        var yi = polygon[i].y;
        var xj = polygon[j].x;
        var yj = polygon[j].y; // prettier-ignore
        var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $693433fd97814b42$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    var cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $693433fd97814b42$var$$6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $693433fd97814b42$var$$6cc32821e9371a1c$var$whenMouse(handler) {
    return function(event) {
        return event.pointerType === "mouse" ? handler(event) : undefined;
    };
}
var $693433fd97814b42$export$be92b6f5f03c0fe9 = $693433fd97814b42$export$d9b273488cd8ce6f;
var $693433fd97814b42$export$b688253958b8dfe7 = $693433fd97814b42$export$9fa5ebd18bee4d43;
var $693433fd97814b42$export$602eac185826482c = $693433fd97814b42$export$793392f970497feb;
var $693433fd97814b42$export$7c6e2c02157bb7d2 = $693433fd97814b42$export$479f0f2f71193efe;
var $693433fd97814b42$export$eb2fcfdbd7ba97d4 = $693433fd97814b42$export$22a631d1f72787bb;
var $693433fd97814b42$export$b04be29aa201d4f5 = $693433fd97814b42$export$dd37bec0e8a99143;
var $693433fd97814b42$export$6d08773d2e66f8f2 = $693433fd97814b42$export$2ce376c2cc3355c8;
var $693433fd97814b42$export$16ce288f89fa631c = $693433fd97814b42$export$f6f243521332502d;
var $693433fd97814b42$export$a98f0dcb43a68a25 = $693433fd97814b42$export$ea2200c9eee416b3;
var $693433fd97814b42$export$371ab307eab489c0 = $693433fd97814b42$export$69bd225e9817f6d0;
var $693433fd97814b42$export$c3468e2714d175fa = $693433fd97814b42$export$a2593e23056970a3;
var $693433fd97814b42$export$1ff3c3f08ae963c0 = $693433fd97814b42$export$1cec7dcdd713e220;
var $693433fd97814b42$export$21b07c8f274aebd5 = $693433fd97814b42$export$bcdda4773debf5fa;
var $693433fd97814b42$export$d7a01e11500dfb6f = $693433fd97814b42$export$71bdb9d1e2909932;
var $693433fd97814b42$export$2ea8a7a591ac5eac = $693433fd97814b42$export$5fbbb3ba7297405f;
var $693433fd97814b42$export$6d4de93b380beddf = $693433fd97814b42$export$e7142ab31822bde6;



/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var $e3254c7c4d71ef48$var$_$9kmUS$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)($e3254c7c4d71ef48$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    (0, $693433fd97814b42$export$4027731b685e72eb)
]), 2), $e3254c7c4d71ef48$var$$d08ef79370b62062$var$createDropdownMenuContext = $e3254c7c4d71ef48$var$_$9kmUS$createContextScope[0], $e3254c7c4d71ef48$export$c0623cd925aeb687 = $e3254c7c4d71ef48$var$_$9kmUS$createContextScope[1];
var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope = (0, $693433fd97814b42$export$4027731b685e72eb)();
var $e3254c7c4d71ef48$var$_$d08ef79370b62062$var$createDropdownMenuContext = (0, $8GFUW._)($e3254c7c4d71ef48$var$$d08ef79370b62062$var$createDropdownMenuContext($e3254c7c4d71ef48$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME), 2), $e3254c7c4d71ef48$var$$d08ef79370b62062$var$DropdownMenuProvider = $e3254c7c4d71ef48$var$_$d08ef79370b62062$var$createDropdownMenuContext[0], $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useDropdownMenuContext = $e3254c7c4d71ef48$var$_$d08ef79370b62062$var$createDropdownMenuContext[1];
var $e3254c7c4d71ef48$export$e44a253a59704894 = function(props) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, children = props.children, dir = props.dir, openProp = props.open, defaultOpen = props.defaultOpen, onOpenChange = props.onOpenChange, tmp = props.modal, modal = tmp === void 0 ? true : tmp;
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    var triggerRef = (0, $6cds3.useRef)(null);
    var _$9kmUS$useControllableState = (0, $8GFUW._)((0, $67d582389dee973c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    }), 2), tmp1 = _$9kmUS$useControllableState[0], open = tmp1 === void 0 ? false : tmp1, setOpen = _$9kmUS$useControllableState[1];
    return /*#__PURE__*/ (0, $6cds3.createElement)($e3254c7c4d71ef48$var$$d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $3a7a3a6a18539928$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $3a7a3a6a18539928$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $6cds3.useCallback)(function() {
            return setOpen(function(prevOpen) {
                return !prevOpen;
            });
        }, [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$be92b6f5f03c0fe9), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$e44a253a59704894, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $e3254c7c4d71ef48$export$d2469213b3befba9 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, tmp = props.disabled, disabled = tmp === void 0 ? false : tmp, triggerProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu",
        "disabled"
    ]);
    var context = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useDropdownMenuContext($e3254c7c4d71ef48$var$$d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$b688253958b8dfe7), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        asChild: true
    }, menuScope), /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).button, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? "open" : "closed",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: (0, $becf66aa9c19994c$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
        onPointerDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerDown, function(event) {
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            if (disabled) return;
            if ([
                "Enter",
                " "
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === "ArrowDown") context.onOpenChange(true); // prevent keydown from scrolling window / first focused item to execute
            // that keydown (inadvertently closing the menu)
            if ([
                "Enter",
                " ",
                "ArrowDown"
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$d2469213b3befba9, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuPortal
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$PORTAL_NAME = "DropdownMenuPortal";
var $e3254c7c4d71ef48$export$cd369b4d4d54efc9 = function(props) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, portalProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$602eac185826482c), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, portalProps));
};
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$cd369b4d4d54efc9, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
var $e3254c7c4d71ef48$export$6e76d93a37c01248 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, contentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var context = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useDropdownMenuContext($e3254c7c4d71ef48$var$$d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    var hasInteractedOutsideRef = (0, $6cds3.useRef)(false);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$7c6e2c02157bb7d2), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onCloseAutoFocus, function(event) {
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onInteractOutside, function(event) {
            var originalEvent = event.detail.originalEvent;
            var ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            var isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: (0, $8E768._)((0, $8OnJk._)({}, props.style), {
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        })
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$6e76d93a37c01248, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuGroup
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$GROUP_NAME = "DropdownMenuGroup";
var $e3254c7c4d71ef48$export$246bebaba3a2f70e = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, groupProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$eb2fcfdbd7ba97d4), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$246bebaba3a2f70e, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuLabel
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$LABEL_NAME = "DropdownMenuLabel";
var $e3254c7c4d71ef48$export$76e48c5b57f24495 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, labelProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$b04be29aa201d4f5), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$76e48c5b57f24495, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItem
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$ITEM_NAME = "DropdownMenuItem";
var $e3254c7c4d71ef48$export$ed97964d1871885d = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, itemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$6d08773d2e66f8f2), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$ed97964d1871885d, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $e3254c7c4d71ef48$export$53a69729da201fa9 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, checkboxItemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$16ce288f89fa631c), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, checkboxItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$53a69729da201fa9, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $e3254c7c4d71ef48$export$3323ad73d55f587e = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, radioGroupProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$a98f0dcb43a68a25), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, radioGroupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$3323ad73d55f587e, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $e3254c7c4d71ef48$export$e4f69b41b1637536 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, radioItemProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$371ab307eab489c0), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, radioItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$e4f69b41b1637536, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $e3254c7c4d71ef48$export$42355ae145153fb6 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, itemIndicatorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$c3468e2714d175fa), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, itemIndicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$42355ae145153fb6, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSeparator
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $e3254c7c4d71ef48$export$da160178fd3bc7e9 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, separatorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$1ff3c3f08ae963c0), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$da160178fd3bc7e9, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuArrow
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$ARROW_NAME = "DropdownMenuArrow";
var $e3254c7c4d71ef48$export$34b8980744021ec5 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, arrowProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$21b07c8f274aebd5), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$34b8980744021ec5, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSub
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$export$2f307d81a64f5442 = function(props) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, children = props.children, openProp = props.open, onOpenChange = props.onOpenChange, defaultOpen = props.defaultOpen;
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    var _$9kmUS$useControllableState = (0, $8GFUW._)((0, $67d582389dee973c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    }), 2), tmp = _$9kmUS$useControllableState[0], open = tmp === void 0 ? false : tmp, setOpen = _$9kmUS$useControllableState[1];
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$d7a01e11500dfb6f), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, {
        open: open,
        onOpenChange: setOpen
    }), children);
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $e3254c7c4d71ef48$export$21dcb7ec56f874cf = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, subTriggerProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$2ea8a7a591ac5eac), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, subTriggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$21dcb7ec56f874cf, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubContent
 * -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$var$$d08ef79370b62062$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $e3254c7c4d71ef48$export$f34ec8bc2482cc5f = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeDropdownMenu = props.__scopeDropdownMenu, subContentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeDropdownMenu"
    ]);
    var menuScope = $e3254c7c4d71ef48$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $693433fd97814b42$export$6d4de93b380beddf), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, menuScope, subContentProps, {
        ref: forwardedRef,
        style: (0, $8E768._)((0, $8OnJk._)({}, props.style), {
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        })
    }));
});
/*#__PURE__*/ Object.assign($e3254c7c4d71ef48$export$f34ec8bc2482cc5f, {
    displayName: $e3254c7c4d71ef48$var$$d08ef79370b62062$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $e3254c7c4d71ef48$export$be92b6f5f03c0fe9 = $e3254c7c4d71ef48$export$e44a253a59704894;
var $e3254c7c4d71ef48$export$41fb9f06171c75f4 = $e3254c7c4d71ef48$export$d2469213b3befba9;
var $e3254c7c4d71ef48$export$602eac185826482c = $e3254c7c4d71ef48$export$cd369b4d4d54efc9;
var $e3254c7c4d71ef48$export$7c6e2c02157bb7d2 = $e3254c7c4d71ef48$export$6e76d93a37c01248;
var $e3254c7c4d71ef48$export$eb2fcfdbd7ba97d4 = $e3254c7c4d71ef48$export$246bebaba3a2f70e;
var $e3254c7c4d71ef48$export$b04be29aa201d4f5 = $e3254c7c4d71ef48$export$76e48c5b57f24495;
var $e3254c7c4d71ef48$export$6d08773d2e66f8f2 = $e3254c7c4d71ef48$export$ed97964d1871885d;
var $e3254c7c4d71ef48$export$16ce288f89fa631c = $e3254c7c4d71ef48$export$53a69729da201fa9;
var $e3254c7c4d71ef48$export$a98f0dcb43a68a25 = $e3254c7c4d71ef48$export$3323ad73d55f587e;
var $e3254c7c4d71ef48$export$371ab307eab489c0 = $e3254c7c4d71ef48$export$e4f69b41b1637536;
var $e3254c7c4d71ef48$export$c3468e2714d175fa = $e3254c7c4d71ef48$export$42355ae145153fb6;
var $e3254c7c4d71ef48$export$1ff3c3f08ae963c0 = $e3254c7c4d71ef48$export$da160178fd3bc7e9;
var $e3254c7c4d71ef48$export$21b07c8f274aebd5 = $e3254c7c4d71ef48$export$34b8980744021ec5;
var $e3254c7c4d71ef48$export$d7a01e11500dfb6f = $e3254c7c4d71ef48$export$2f307d81a64f5442;
var $e3254c7c4d71ef48$export$2ea8a7a591ac5eac = $e3254c7c4d71ef48$export$21dcb7ec56f874cf;
var $e3254c7c4d71ef48$export$6d4de93b380beddf = $e3254c7c4d71ef48$export$f34ec8bc2482cc5f;


/**
 * lucide-react v0.257.0 - ISC
 */ 
var $01ff04014f2cf5ec$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Circle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);



var $8d373e31e89182ea$export$e44a253a59704894 = $e3254c7c4d71ef48$export$be92b6f5f03c0fe9;
var $8d373e31e89182ea$export$d2469213b3befba9 = $e3254c7c4d71ef48$export$41fb9f06171c75f4;
var $8d373e31e89182ea$export$246bebaba3a2f70e = $e3254c7c4d71ef48$export$eb2fcfdbd7ba97d4;
var $8d373e31e89182ea$export$cd369b4d4d54efc9 = $e3254c7c4d71ef48$export$602eac185826482c;
var $8d373e31e89182ea$export$2f307d81a64f5442 = $e3254c7c4d71ef48$export$d7a01e11500dfb6f;
var $8d373e31e89182ea$export$3323ad73d55f587e = $e3254c7c4d71ef48$export$a98f0dcb43a68a25;
var $8d373e31e89182ea$export$21dcb7ec56f874cf = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, inset = _param.inset, children = _param.children, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "inset",
        "children"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsxs)($e3254c7c4d71ef48$export$2ea8a7a591ac5eac, (0, $8E768._)((0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent", inset && "pl-8", className)
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $96fc56be218b0aba$export$2e2bcd8739ae039), {
                className: "ml-auto h-4 w-4"
            })
        ]
    }));
});
$8d373e31e89182ea$export$21dcb7ec56f874cf.displayName = $e3254c7c4d71ef48$export$2ea8a7a591ac5eac.displayName;
var $8d373e31e89182ea$export$f34ec8bc2482cc5f = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$6d4de93b380beddf, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
    }, props));
});
$8d373e31e89182ea$export$f34ec8bc2482cc5f.displayName = $e3254c7c4d71ef48$export$6d4de93b380beddf.displayName;
var $8d373e31e89182ea$export$6e76d93a37c01248 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, _param_sideOffset = _param.sideOffset, sideOffset = _param_sideOffset === void 0 ? 4 : _param_sideOffset, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "sideOffset"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$7c6e2c02157bb7d2, (0, $8OnJk._)({
            ref: ref,
            sideOffset: sideOffset,
            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
        }, props))
    });
});
$8d373e31e89182ea$export$6e76d93a37c01248.displayName = $e3254c7c4d71ef48$export$7c6e2c02157bb7d2.displayName;
var $8d373e31e89182ea$export$ed97964d1871885d = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, inset = _param.inset, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "inset"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$6d08773d2e66f8f2, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", inset && "pl-8", className)
    }, props));
});
$8d373e31e89182ea$export$ed97964d1871885d.displayName = $e3254c7c4d71ef48$export$6d08773d2e66f8f2.displayName;
var $8d373e31e89182ea$export$53a69729da201fa9 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, checked = _param.checked, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "children",
        "checked"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsxs)($e3254c7c4d71ef48$export$16ce288f89fa631c, (0, $8E768._)((0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        checked: checked
    }, props), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $971f03f1ae2c8c7a$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    })
                })
            }),
            children
        ]
    }));
});
$8d373e31e89182ea$export$53a69729da201fa9.displayName = $e3254c7c4d71ef48$export$16ce288f89fa631c.displayName;
var $8d373e31e89182ea$export$e4f69b41b1637536 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "children"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsxs)($e3254c7c4d71ef48$export$371ab307eab489c0, (0, $8E768._)((0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
    }, props), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $01ff04014f2cf5ec$export$2e2bcd8739ae039), {
                        className: "h-2 w-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
});
$8d373e31e89182ea$export$e4f69b41b1637536.displayName = $e3254c7c4d71ef48$export$371ab307eab489c0.displayName;
var $8d373e31e89182ea$export$76e48c5b57f24495 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, inset = _param.inset, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "inset"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$b04be29aa201d4f5, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className)
    }, props));
});
$8d373e31e89182ea$export$76e48c5b57f24495.displayName = $e3254c7c4d71ef48$export$b04be29aa201d4f5.displayName;
var $8d373e31e89182ea$export$da160178fd3bc7e9 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($e3254c7c4d71ef48$export$1ff3c3f08ae963c0, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("-mx-1 my-1 h-px bg-muted", className)
    }, props));
});
$8d373e31e89182ea$export$da160178fd3bc7e9.displayName = $e3254c7c4d71ef48$export$1ff3c3f08ae963c0.displayName;
var $8d373e31e89182ea$export$b1e098e2962e8df5 = function(_param) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", (0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("ml-auto text-xs tracking-widest opacity-60", className)
    }, props));
};
$8d373e31e89182ea$export$b1e098e2962e8df5.displayName = "DropdownMenuShortcut";



function $4e9134094db358e6$export$eb2db0afe7f2511() {
    // const { setTheme } = useTheme();
    // TODO: Fix Theme
    var setTheme = console.log;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$e44a253a59704894), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d373e31e89182ea$export$d2469213b3befba9), {
                asChild: true,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    size: "sm",
                    className: "h-8 w-8 px-0",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).sun, {
                            className: "rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).moon, {
                            className: "absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: "sr-only",
                            children: "Toggle theme"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$6e76d93a37c01248), {
                align: "end",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$ed97964d1871885d), {
                        onClick: function() {
                            return setTheme("light");
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).sun, {
                                className: "mr-2 h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                children: "Light"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$ed97964d1871885d), {
                        onClick: function() {
                            return setTheme("dark");
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).moon, {
                                className: "mr-2 h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                children: "Dark"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$ed97964d1871885d), {
                        onClick: function() {
                            return setTheme("system");
                        },
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).laptop, {
                                className: "mr-2 h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                children: "System"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $3acbba690857c4ad$export$9967e3f82432943a(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("footer", {
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)(className),
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "container flex flex-col items-center justify-between gap-4 py-10 md:h-24 md:flex-row md:py-0",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex flex-col items-center gap-4 px-8 md:flex-row md:gap-2 md:px-0",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).logo, {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "text-center text-sm leading-loose md:text-left",
                            children: "Built with React and NEAR Protocol."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4e9134094db358e6$export$eb2db0afe7f2511), {})
            ]
        })
    });
}



var $6cds3 = parcelRequire("6cds3");
var $9a7c6a607a16349a$export$19648c908dc8d0bf = (0, $6cds3.createContext)(null);


var $2ccedb9e281f523c$var$MainLayout = function(param) {
    var children = param.children;
    var _useContext = (0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)), wallet = _useContext.wallet, isSignedIn = _useContext.isSignedIn;
    var handleLogin = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                wallet.signIn();
                return [
                    2
                ];
            });
        });
        return function handleLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLogout = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                wallet.signOut();
                return [
                    2
                ];
            });
        });
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex min-h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("header", {
                className: "container z-40 bg-background",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex h-20 items-center justify-between py-6",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e773a99b452aacad$export$4418626cb10d22e4), {
                            items: (0, $3e3432b9f3194b83$export$ba15ad942ef5ab4f).mainNav
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("nav", {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                                className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                                    variant: "secondary",
                                    size: "sm"
                                }), "px-4"),
                                onClick: isSignedIn ? handleLogout : handleLogin,
                                children: isSignedIn ? "Logout ".concat(wallet.accountId) : "Login"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("main", {
                className: "flex-1",
                children: children
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3acbba690857c4ad$export$9967e3f82432943a), {})
        ]
    });
};
var $2ccedb9e281f523c$export$2e2bcd8739ae039 = $2ccedb9e281f523c$var$MainLayout;




var $4a6d5b98f5a54c19$exports = {};

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");
"use strict";
var $4a6d5b98f5a54c19$var$y = Object.create;
var $4a6d5b98f5a54c19$var$a = Object.defineProperty;
var $4a6d5b98f5a54c19$var$v = Object.getOwnPropertyDescriptor;
var $4a6d5b98f5a54c19$var$S = Object.getOwnPropertyNames;
var $4a6d5b98f5a54c19$var$L = Object.getPrototypeOf, $4a6d5b98f5a54c19$var$w = Object.prototype.hasOwnProperty;
var $4a6d5b98f5a54c19$var$k = function(e, o) {
    for(var n in o)$4a6d5b98f5a54c19$var$a(e, n, {
        get: o[n],
        enumerable: !0
    });
}, $4a6d5b98f5a54c19$var$p = function(e, o, n, i) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (o && typeof o == "object" || typeof o == "function") try {
        var _loop = function() {
            var r = _step.value;
            !$4a6d5b98f5a54c19$var$w.call(e, r) && r !== n && $4a6d5b98f5a54c19$var$a(e, r, {
                get: function() {
                    return o[r];
                },
                enumerable: !(i = $4a6d5b98f5a54c19$var$v(o, r)) || i.enumerable
            });
        };
        for(var _iterator = $4a6d5b98f5a54c19$var$S(o)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var $4a6d5b98f5a54c19$var$$ = function(e, o, n) {
    return n = e != null ? $4a6d5b98f5a54c19$var$y($4a6d5b98f5a54c19$var$L(e)) : {}, $4a6d5b98f5a54c19$var$p(o || !e || !e.__esModule ? $4a6d5b98f5a54c19$var$a(n, "default", {
        value: e,
        enumerable: !0
    }) : n, e);
}, $4a6d5b98f5a54c19$var$z = function(e) {
    return $4a6d5b98f5a54c19$var$p($4a6d5b98f5a54c19$var$a({}, "__esModule", {
        value: !0
    }), e);
};
var $4a6d5b98f5a54c19$var$I = {};
$4a6d5b98f5a54c19$var$k($4a6d5b98f5a54c19$var$I, {
    GlobalLoading: function() {
        return $4a6d5b98f5a54c19$var$E;
    },
    globalLoading: function() {
        return $4a6d5b98f5a54c19$var$P;
    },
    hide: function() {
        return $4a6d5b98f5a54c19$var$b;
    },
    show: function() {
        return $4a6d5b98f5a54c19$var$g;
    },
    showLoading: function() {
        return $4a6d5b98f5a54c19$var$s;
    }
});
$4a6d5b98f5a54c19$exports = $4a6d5b98f5a54c19$var$z($4a6d5b98f5a54c19$var$I);

var $4a6d5b98f5a54c19$var$t = $4a6d5b98f5a54c19$var$$((parcelRequire("6cds3"))), $4a6d5b98f5a54c19$var$s = function() {}, $4a6d5b98f5a54c19$var$g = function() {
    $4a6d5b98f5a54c19$var$s && $4a6d5b98f5a54c19$var$s(!0);
}, $4a6d5b98f5a54c19$var$b = function() {
    $4a6d5b98f5a54c19$var$s && $4a6d5b98f5a54c19$var$s(!1);
}, $4a6d5b98f5a54c19$var$P = {
    show: $4a6d5b98f5a54c19$var$g,
    hide: $4a6d5b98f5a54c19$var$b
}, $4a6d5b98f5a54c19$var$E = function(e) {
    var _ref = e || {}, o = _ref.children, n = _ref.WrapperComponent, tmp = _ref.loadingSize, i = tmp === void 0 ? 70 : tmp, tmp1 = _ref.loadingColor, r = tmp1 === void 0 ? "#eee" : tmp1, tmp2 = _ref.loadingSpeed, c = tmp2 === void 0 ? 1 : tmp2, tmp3 = _ref.loadingThickness, l = tmp3 === void 0 ? 7 : tmp3, tmp4 = _ref.backgroundColor, f = tmp4 === void 0 ? "rgba(0, 0, 0, 0.6)" : tmp4, tmp5 = _ref.zIndex, h = tmp5 === void 0 ? 999 : tmp5, m = (0, $c4006311849aa271$export$69fdd232f62cde60)(_ref, [
        "children",
        "WrapperComponent",
        "loadingSize",
        "loadingColor",
        "loadingSpeed",
        "loadingThickness",
        "backgroundColor",
        "zIndex"
    ]), _ref1 = (0, $8GFUW._)((0, $4a6d5b98f5a54c19$var$t.useState)(!1), 2), u = _ref1[0], C = _ref1[1];
    (0, $4a6d5b98f5a54c19$var$t.useEffect)(function() {
        $4a6d5b98f5a54c19$var$s = C;
    }, []);
    var d = function() {
        return $4a6d5b98f5a54c19$var$t.default.createElement($4a6d5b98f5a54c19$var$t.default.Fragment, null, $4a6d5b98f5a54c19$var$t.default.createElement("style", null, "\n            @keyframes spin {\n                 0% { transform: rotate(0deg); }\n                 100% { transform: rotate(360deg); }\n            }\n        "), $4a6d5b98f5a54c19$var$t.default.createElement("div", {
            style: {
                position: "relative",
                animation: "spin ".concat(c, "s linear infinite")
            }
        }, $4a6d5b98f5a54c19$var$t.default.createElement("div", {
            style: {
                width: i,
                height: i,
                borderRadius: "50%",
                border: "".concat(l, "px solid"),
                borderTopColor: "".concat(r)
            }
        }), $4a6d5b98f5a54c19$var$t.default.createElement("div", {
            style: {
                width: i,
                height: i,
                borderRadius: "50%",
                border: "".concat(l, "px solid rgba(255, 255, 255, 0.5)"),
                position: "absolute",
                top: 0
            }
        })));
    }, x = (0, $8E768._)((0, $8OnJk._)({}, $4a6d5b98f5a54c19$var$G), {
        zIndex: h,
        backgroundColor: f
    });
    return u ? n ? $4a6d5b98f5a54c19$var$t.default.createElement(n, (0, $8OnJk._)({}, m), o || d()) : $4a6d5b98f5a54c19$var$t.default.createElement("div", {
        style: x
    }, o || d()) : null;
}, $4a6d5b98f5a54c19$var$G = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $72b212c13c11575e$var$HomePage = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var _useContext = (0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)), wallet = _useContext.wallet, contractId = _useContext.contractId, isSignedIn = _useContext.isSignedIn;
    var navigator = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var stars = 0;
    var handleLogin = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                wallet.signIn();
                return [
                    2
                ];
            });
        });
        return function handleLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var getStarted = function() {
        var _ref = (0, $byzP8._)(function() {
            var res;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!isSignedIn) return [
                            3,
                            1
                        ];
                        handleLogin();
                        return [
                            3,
                            3
                        ];
                    case 1:
                        (0, $4a6d5b98f5a54c19$exports.globalLoading).show();
                        return [
                            4,
                            (0, $2bbfe96e4adedbff$export$6e9c8de5b9a230fd)(wallet, contractId)
                        ];
                    case 2:
                        res = _state.sent();
                        (0, $4a6d5b98f5a54c19$exports.globalLoading).hide();
                        if (res.status === "LISTER") {
                            (0, $a65c6a8ddb514a0f$export$b410431fab84fa58)({
                                title: "Listner Account Found",
                                description: "You are Successfully Logged in",
                                variant: "destructive"
                            });
                            navigator("/dashboard/lister");
                        }
                        if (res.status === "CONTRACTOR") {
                            (0, $a65c6a8ddb514a0f$export$b410431fab84fa58)({
                                title: "Contractor Account Found",
                                description: "You are Successfully Logged in",
                                variant: "destructive"
                            });
                            navigator("/dashboard/bidder");
                        }
                        if (res.status === "NOTCREATED") navigator("/start");
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getStarted() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $6cds3.useEffect)(function() {
        wallet.startUp();
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $2ccedb9e281f523c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "space-y-6 pb-8 pt-6 md:pb-12 md:pt-10 lg:py-32",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container flex max-w-[64rem] flex-col items-center gap-4 text-center",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                            to: (0, $9a83d8baa1aa3084$export$bba18cbf7d7dd729).links.twitter,
                            className: "rounded-2xl bg-muted px-4 py-1.5 text-sm font-medium",
                            target: "_blank",
                            children: "Like our project on Devpost"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("h1", {
                            className: "font-heading text-3xl sm:text-5xl md:text-6xl lg:text-7xl",
                            children: [
                                "Seize control, contracts unfold, ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                "funds tracked, corruption controlled"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: "max-w-[42rem] leading-normal text-muted-foreground sm:text-xl sm:leading-8",
                            children: [
                                "An Decentralised App based on React and NEAR Protocol. ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                "Transparent and trustless contract creation and tracking."
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "space-x-4",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                                    className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                                        size: "lg"
                                    })),
                                    onClick: getStarted,
                                    children: "Get Started"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                    to: (0, $9a83d8baa1aa3084$export$bba18cbf7d7dd729).links.github,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                                        variant: "outline",
                                        size: "lg"
                                    })),
                                    children: "GitHub"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("section", {
                id: "features",
                className: "container space-y-6 bg-slate-50 py-8 dark:bg-transparent md:py-12 lg:py-24",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "mx-auto flex max-w-[58rem] flex-col items-center space-y-4 text-center",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                className: "font-heading text-3xl leading-[1.1] sm:text-3xl md:text-6xl",
                                children: "Features"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "max-w-[85%] leading-normal text-muted-foreground sm:text-lg sm:leading-7",
                                children: "This project is build using React 18 and NEAR Protocol with Rust powering the smart contract."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "mx-auto grid justify-center gap-4 sm:grid-cols-2 md:max-w-[64rem] md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "relative overflow-hidden rounded-lg border bg-background p-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex h-[180px] flex-col justify-between rounded-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            className: "h-12 w-12 fill-current",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M11.572 0c-.176 0-.31.001-.358.007a19.76 19.76 0 0 1-.364.033C7.443.346 4.25 2.185 2.228 5.012a11.875 11.875 0 0 0-2.119 5.243c-.096.659-.108.854-.108 1.747s.012 1.089.108 1.748c.652 4.506 3.86 8.292 8.209 9.695.779.25 1.6.422 2.534.525.363.04 1.935.04 2.299 0 1.611-.178 2.977-.577 4.323-1.264.207-.106.247-.134.219-.158-.02-.013-.9-1.193-1.955-2.62l-1.919-2.592-2.404-3.558a338.739 338.739 0 0 0-2.422-3.556c-.009-.002-.018 1.579-.023 3.51-.007 3.38-.01 3.515-.052 3.595a.426.426 0 0 1-.206.214c-.075.037-.14.044-.495.044H7.81l-.108-.068a.438.438 0 0 1-.157-.171l-.05-.106.006-4.703.007-4.705.072-.092a.645.645 0 0 1 .174-.143c.096-.047.134-.051.54-.051.478 0 .558.018.682.154.035.038 1.337 1.999 2.895 4.361a10760.433 10760.433 0 0 0 4.735 7.17l1.9 2.879.096-.063a12.317 12.317 0 0 0 2.466-2.163 11.944 11.944 0 0 0 2.824-6.134c.096-.66.108-.854.108-1.748 0-.893-.012-1.088-.108-1.747-.652-4.506-3.859-8.292-8.208-9.695a12.597 12.597 0 0 0-2.499-.523A33.119 33.119 0 0 0 11.573 0zm4.069 7.217c.347 0 .408.005.486.047a.473.473 0 0 1 .237.277c.018.06.023 1.365.018 4.304l-.006 4.218-.744-1.14-.746-1.14v-3.066c0-1.982.01-3.097.023-3.15a.478.478 0 0 1 .233-.296c.096-.05.13-.054.5-.054z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                    className: "font-bold",
                                                    children: "Next.js 13"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "App dir, Routing, Layouts, Loading UI and API routes."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "relative overflow-hidden rounded-lg border bg-background p-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex h-[180px] flex-col justify-between rounded-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            className: "h-12 w-12 fill-current",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38a2.167 2.167 0 0 0-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44a23.476 23.476 0 0 0-3.107-.534A23.892 23.892 0 0 0 12.769 4.7c1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442a22.73 22.73 0 0 0-3.113.538 15.02 15.02 0 0 1-.254-1.42c-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87a25.64 25.64 0 0 1-4.412.005 26.64 26.64 0 0 1-1.183-1.86c-.372-.64-.71-1.29-1.018-1.946a25.17 25.17 0 0 1 1.013-1.954c.38-.66.773-1.286 1.18-1.868A25.245 25.245 0 0 1 12 8.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933a25.952 25.952 0 0 0-1.345-2.32zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493a23.966 23.966 0 0 0-1.1-2.98c.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98a23.142 23.142 0 0 0-1.086 2.964c-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39a25.819 25.819 0 0 0 1.341-2.338zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143a22.005 22.005 0 0 1-2.006-.386c.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295a1.185 1.185 0 0 1-.553-.132c-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                    className: "font-bold",
                                                    children: "React 18"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "text-sm",
                                                    children: "Server and Client Components. Use hook."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "relative overflow-hidden rounded-lg border bg-background p-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex h-[180px] flex-col justify-between rounded-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            className: "h-12 w-12 fill-current",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M0 12C0 5.373 5.373 0 12 0c4.873 0 9.067 2.904 10.947 7.077l-15.87 15.87a11.981 11.981 0 0 1-1.935-1.099L14.99 12H12l-8.485 8.485A11.962 11.962 0 0 1 0 12Zm12.004 12L24 12.004C23.998 18.628 18.628 23.998 12.004 24Z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                    className: "font-bold",
                                                    children: "Database"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "ORM using Prisma and deployed on PlanetScale."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "relative overflow-hidden rounded-lg border bg-background p-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex h-[180px] flex-col justify-between rounded-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            className: "h-12 w-12 fill-current",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M12.001 4.8c-3.2 0-5.2 1.6-6 4.8 1.2-1.6 2.6-2.2 4.2-1.8.913.228 1.565.89 2.288 1.624C13.666 10.618 15.027 12 18.001 12c3.2 0 5.2-1.6 6-4.8-1.2 1.6-2.6 2.2-4.2 1.8-.913-.228-1.565-.89-2.288-1.624C16.337 6.182 14.976 4.8 12.001 4.8zm-6 7.2c-3.2 0-5.2 1.6-6 4.8 1.2-1.6 2.6-2.2 4.2-1.8.913.228 1.565.89 2.288 1.624 1.177 1.194 2.538 2.576 5.512 2.576 3.2 0 5.2-1.6 6-4.8-1.2 1.6-2.6 2.2-4.2 1.8-.913-.228-1.565-.89-2.288-1.624C10.337 13.382 8.976 12 6.001 12z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                    className: "font-bold",
                                                    children: "Components"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "UI components built using Radix UI and styled with Tailwind CSS."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "relative overflow-hidden rounded-lg border bg-background p-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex h-[180px] flex-col justify-between rounded-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "1",
                                            className: "h-12 w-12 fill-current",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                    className: "font-bold",
                                                    children: "Authentication"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Authentication using NextAuth.js and middlewares."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "relative overflow-hidden rounded-lg border bg-background p-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex h-[180px] flex-col justify-between rounded-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            className: "h-12 w-12 fill-current",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                    className: "font-bold",
                                                    children: "Subscriptions"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: "Free and paid subscriptions using Stripe."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "mx-auto text-center md:max-w-[58rem]",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "leading-normal text-muted-foreground sm:text-lg sm:leading-7",
                            children: "Transpact also includes a indentity verification."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                id: "open-source",
                className: "container py-8 md:py-12 lg:py-24",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "mx-auto flex max-w-[58rem] flex-col items-center justify-center gap-4 text-center",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "font-heading text-3xl leading-[1.1] sm:text-3xl md:text-6xl",
                            children: "Proudly Open Source"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: "max-w-[85%] leading-normal text-muted-foreground sm:text-lg sm:leading-7",
                            children: [
                                "Transpact is open source and powered by open source software. ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                " ",
                                "The code is available on",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                    to: (0, $9a83d8baa1aa3084$export$bba18cbf7d7dd729).links.github,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "underline underline-offset-4",
                                    children: "GitHub"
                                }),
                                ".",
                                " "
                            ]
                        }),
                        stars && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                            to: (0, $9a83d8baa1aa3084$export$bba18cbf7d7dd729).links.github,
                            target: "_blank",
                            rel: "noreferrer",
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "flex h-10 w-10 items-center justify-center space-x-2 rounded-md border border-muted bg-muted",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24",
                                        className: "h-5 w-5 text-foreground",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                            d: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "h-4 w-4 border-y-8 border-l-0 border-r-8 border-solid border-muted border-y-transparent"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "flex h-10 items-center rounded-md border border-muted bg-muted px-4 font-medium"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $72b212c13c11575e$export$2e2bcd8739ae039 = $72b212c13c11575e$var$HomePage;






var $6cds3 = parcelRequire("6cds3");





var $bd28d30e42f148a1$var$StartPage = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var ref1 = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)((0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2ccedb9e281f523c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
            className: "space-y-6 pb-8 pt-6 md:pb-12 md:pt-10 lg:py-32",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "container flex max-w-[64rem] flex-col items-center gap-4 text-center",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                        className: "font-heading text-3xl sm:text-5xl md:text-6xl lg:text-7xl",
                        children: "Get Started"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        className: "max-w-[42rem] leading-normal text-muted-foreground sm:text-xl sm:leading-8",
                        children: "Choose one of two options"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/verify-user?redirect=/dashboard/lister&user=lister",
                                className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                                    size: "lg"
                                })),
                                children: "Lister"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/verify-user?redirect=/dashboard/bidder&user=bidder",
                                className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                                    variant: "outline",
                                    size: "lg"
                                })),
                                children: "Bidder"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $bd28d30e42f148a1$export$2e2bcd8739ae039 = $bd28d30e42f148a1$var$StartPage;




var $byzP8 = parcelRequire("byzP8");


var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");


var $6b650fc028a96be1$export$dc17cc91b69b42a1 = {
    mainNav: [
        {
            title: "List",
            href: "/dashboard/lister"
        },
        {
            title: "Bid",
            href: "/dashboard/bidder"
        }
    ],
    sidebarNav: [
        {
            title: "My Contracts",
            href: "/dashboard/lister",
            icon: "users"
        },
        {
            title: "Add Contract",
            href: "/contract/add",
            icon: "package"
        }
    ],
    sidebarNavBidder: [
        {
            title: "My Bids",
            href: "/dashboard/bidder",
            icon: "users"
        },
        {
            title: "All Bids",
            href: "/bid/all",
            icon: "package"
        }
    ]
}; // {
 //   title: "All Contracts",
 //   href: "/dashboard/lister",
 //   icon: "dashboard",
 // },
 // {
 //   title: "Invoices",
 //   href: "/dashboard/invoices",
 //   icon: "billing",
 //   disabled: true,
 // },
 // {
 //   title: "Reports",
 //   href: "/dashboard/reports",
 //   icon: "post",
 //   disabled: true,
 // },
 // {
 //   title: "Profile",
 //   href: "/dashboard/profile",
 //   icon: "settings",
 //   disabled: true,
 // },
 // {
 //   title: "Upgrade to Plus",
 //   href: "/dashboard/billing",
 //   icon: "settings",
 //   disabled: true,
 // },







function $52be4b0bf50d73a6$export$6195926672cda932(param) {
    var items = param.items;
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var path = location.pathname;
    if (!(items === null || items === void 0 ? void 0 : items.length)) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("nav", {
        className: "grid items-start gap-2",
        children: items.map(function(item, index) {
            var Icon = (0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac)[item.icon || "arrowRight"];
            console.log(path, item.href);
            return item.href && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$b0d92dbee9b5b60d), {
                to: item.disabled ? "/" : item.href,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("group flex items-center rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground", path === item.href ? "bg-accent" : "transparent", item.disabled && "cursor-not-allowed opacity-80"),
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Icon, {
                            className: "mr-2 h-4 w-4"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            children: item.title
                        })
                    ]
                })
            }, index);
        })
    });
}




var $byzP8 = parcelRequire("byzP8");

var $7UAGh = parcelRequire("7UAGh");



var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");



var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");


var $8GFUW = parcelRequire("8GFUW");


var $6cds3 = parcelRequire("6cds3");




/* -------------------------------------------------------------------------------------------------
 * Avatar
 * -----------------------------------------------------------------------------------------------*/ var $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$AVATAR_NAME = "Avatar";
var $9b9880f17f0aaf3f$var$_$8NyvN$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)($9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$AVATAR_NAME), 2), $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$createAvatarContext = $9b9880f17f0aaf3f$var$_$8NyvN$createContextScope[0], $9b9880f17f0aaf3f$export$90370d16b488820f = $9b9880f17f0aaf3f$var$_$8NyvN$createContextScope[1];
var $9b9880f17f0aaf3f$var$_$cddcb0b647441e34$var$createAvatarContext = (0, $8GFUW._)($9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$createAvatarContext($9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$AVATAR_NAME), 2), $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$AvatarProvider = $9b9880f17f0aaf3f$var$_$cddcb0b647441e34$var$createAvatarContext[0], $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$useAvatarContext = $9b9880f17f0aaf3f$var$_$cddcb0b647441e34$var$createAvatarContext[1];
var $9b9880f17f0aaf3f$export$e2255cf6045e8d47 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeAvatar = props.__scopeAvatar, avatarProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeAvatar"
    ]);
    var _$8NyvN$useState = (0, $8GFUW._)((0, $6cds3.useState)("idle"), 2), imageLoadingStatus = _$8NyvN$useState[0], setImageLoadingStatus = _$8NyvN$useState[1];
    return /*#__PURE__*/ (0, $6cds3.createElement)($9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$AvatarProvider, {
        scope: __scopeAvatar,
        imageLoadingStatus: imageLoadingStatus,
        onImageLoadingStatusChange: setImageLoadingStatus
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).span, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, avatarProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($9b9880f17f0aaf3f$export$e2255cf6045e8d47, {
    displayName: $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$AVATAR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AvatarImage
 * -----------------------------------------------------------------------------------------------*/ var $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$IMAGE_NAME = "AvatarImage";
var $9b9880f17f0aaf3f$export$2cd8ae1985206fe8 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeAvatar = props.__scopeAvatar, src = props.src, tmp = props.onLoadingStatusChange, onLoadingStatusChange = tmp === void 0 ? function() {} : tmp, imageProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeAvatar",
        "src",
        "onLoadingStatusChange"
    ]);
    var context = $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$useAvatarContext($9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$IMAGE_NAME, __scopeAvatar);
    var imageLoadingStatus = $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$useImageLoadingStatus(src);
    var handleLoadingStatusChange = (0, $31706a47374637c9$export$25bec8c6f54ee79a)(function(status) {
        onLoadingStatusChange(status);
        context.onImageLoadingStatusChange(status);
    });
    (0, $ec4b0eab0b56ab6a$export$e5c5a5f917a5871c)(function() {
        if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
    }, [
        imageLoadingStatus,
        handleLoadingStatusChange
    ]);
    return imageLoadingStatus === "loaded" ? /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).img, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, imageProps, {
        ref: forwardedRef,
        src: src
    })) : null;
});
/*#__PURE__*/ Object.assign($9b9880f17f0aaf3f$export$2cd8ae1985206fe8, {
    displayName: $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$IMAGE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AvatarFallback
 * -----------------------------------------------------------------------------------------------*/ var $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$FALLBACK_NAME = "AvatarFallback";
var $9b9880f17f0aaf3f$export$69fffb6a9571fbfe = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopeAvatar = props.__scopeAvatar, delayMs = props.delayMs, fallbackProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopeAvatar",
        "delayMs"
    ]);
    var context = $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$useAvatarContext($9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$FALLBACK_NAME, __scopeAvatar);
    var _$8NyvN$useState = (0, $8GFUW._)((0, $6cds3.useState)(delayMs === undefined), 2), canRender = _$8NyvN$useState[0], setCanRender = _$8NyvN$useState[1];
    (0, $6cds3.useEffect)(function() {
        if (delayMs !== undefined) {
            var timerId = window.setTimeout(function() {
                return setCanRender(true);
            }, delayMs);
            return function() {
                return window.clearTimeout(timerId);
            };
        }
    }, [
        delayMs
    ]);
    return canRender && context.imageLoadingStatus !== "loaded" ? /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).span, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, fallbackProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($9b9880f17f0aaf3f$export$69fffb6a9571fbfe, {
    displayName: $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$FALLBACK_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $9b9880f17f0aaf3f$var$$cddcb0b647441e34$var$useImageLoadingStatus(src) {
    var _$8NyvN$useState = (0, $8GFUW._)((0, $6cds3.useState)("idle"), 2), loadingStatus = _$8NyvN$useState[0], setLoadingStatus = _$8NyvN$useState[1];
    (0, $6cds3.useEffect)(function() {
        if (!src) {
            setLoadingStatus("error");
            return;
        }
        var isMounted = true;
        var image = new window.Image();
        var updateStatus = function(status) {
            return function() {
                if (!isMounted) return;
                setLoadingStatus(status);
            };
        };
        setLoadingStatus("loading");
        image.onload = updateStatus("loaded");
        image.onerror = updateStatus("error");
        image.src = src;
        return function() {
            isMounted = false;
        };
    }, [
        src
    ]);
    return loadingStatus;
}
var $9b9880f17f0aaf3f$export$be92b6f5f03c0fe9 = $9b9880f17f0aaf3f$export$e2255cf6045e8d47;
var $9b9880f17f0aaf3f$export$3e431a229df88919 = $9b9880f17f0aaf3f$export$2cd8ae1985206fe8;
var $9b9880f17f0aaf3f$export$fb8d7f40caaeea67 = $9b9880f17f0aaf3f$export$69fffb6a9571fbfe;



var $15c64de668c78439$export$e2255cf6045e8d47 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($9b9880f17f0aaf3f$export$be92b6f5f03c0fe9, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)
    }, props));
});
$15c64de668c78439$export$e2255cf6045e8d47.displayName = $9b9880f17f0aaf3f$export$be92b6f5f03c0fe9.displayName;
var $15c64de668c78439$export$2cd8ae1985206fe8 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($9b9880f17f0aaf3f$export$3e431a229df88919, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("aspect-square h-full w-full", className)
    }, props));
});
$15c64de668c78439$export$2cd8ae1985206fe8.displayName = $9b9880f17f0aaf3f$export$3e431a229df88919.displayName;
var $15c64de668c78439$export$69fffb6a9571fbfe = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($9b9880f17f0aaf3f$export$fb8d7f40caaeea67, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex h-full w-full items-center justify-center rounded-full bg-muted", className)
    }, props));
});
$15c64de668c78439$export$69fffb6a9571fbfe.displayName = $9b9880f17f0aaf3f$export$fb8d7f40caaeea67.displayName;



function $e335e6f11774d62c$export$6c0524ba53950d9f(_param) {
    var user = _param.user, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "user"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $15c64de668c78439$export$e2255cf6045e8d47), (0, $8E768._)((0, $8OnJk._)({}, props), {
        children: user.image ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $15c64de668c78439$export$2cd8ae1985206fe8), {
            alt: "Picture",
            src: user.image
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $15c64de668c78439$export$69fffb6a9571fbfe), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "sr-only",
                    children: user.name
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).user, {
                    className: "h-4 w-4"
                })
            ]
        })
    }));
}





var $6cds3 = parcelRequire("6cds3");


function $301777d0b0678548$export$3dae770bdeb98043(param) {
    var user = param.user;
    var _useContext = (0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)), wallet = _useContext.wallet, contractId = _useContext.contractId;
    var navigator = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$e44a253a59704894), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d373e31e89182ea$export$d2469213b3befba9), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e335e6f11774d62c$export$6c0524ba53950d9f), {
                    user: {
                        name: user.name || null,
                        image: user.image || null
                    },
                    className: "h-8 w-8"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8d373e31e89182ea$export$6e76d93a37c01248), {
                align: "end",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "flex items-center justify-start gap-2 p-2",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "flex flex-col space-y-1 leading-none",
                            children: [
                                user.name && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: user.name
                                }),
                                user.email && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    className: "w-[200px] truncate text-sm text-muted-foreground",
                                    children: user.email
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d373e31e89182ea$export$da160178fd3bc7e9), {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d373e31e89182ea$export$ed97964d1871885d), {
                        className: "cursor-pointer",
                        onSelect: function() {
                            var _ref = (0, $byzP8._)(function(event) {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    (0, $4a6d5b98f5a54c19$exports.globalLoading).show();
                                    event.preventDefault();
                                    (0, $2bbfe96e4adedbff$export$45abfc3976589d02)(wallet, contractId);
                                    wallet.signOut();
                                    navigator("/");
                                    (0, $4a6d5b98f5a54c19$exports.globalLoading).hide();
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(event) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: "Delete Account"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d373e31e89182ea$export$ed97964d1871885d), {
                        className: "cursor-pointer",
                        onSelect: function(event) {
                            event.preventDefault();
                            wallet.signOut();
                        },
                        children: "Sign out"
                    })
                ]
            })
        ]
    });
}



var $6cds3 = parcelRequire("6cds3");



function $abed61b84e9aa1ca$export$f35abaf34fd2d2bf(param) {
    var heading = param.heading, text = param.text, children = param.children;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex items-center justify-between px-2",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "grid gap-1",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                        className: "font-heading text-3xl md:text-4xl",
                        children: heading
                    }),
                    text && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        className: "text-lg text-muted-foreground",
                        children: text
                    })
                ]
            }),
            children
        ]
    });
}



var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


parcelRequire("6cds3");

function $3d427baccb8d4aec$export$fba5249c7bd13e1f(_param) {
    var children = _param.children, className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8E768._)((0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("grid items-start gap-8", className)
    }, props), {
        children: children
    }));
}




var $8OnJk = parcelRequire("8OnJk");



function $4f33967b0ee7b063$export$8f31e4c4a37b8e9c(_param) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("animate-pulse rounded-md bg-muted", className)
    }, props));
}


function $8d457518e1db0edc$var$ItemSkeleton() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "p-4",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "space-y-3",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4f33967b0ee7b063$export$8f31e4c4a37b8e9c), {
                    className: "h-5 w-2/5"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4f33967b0ee7b063$export$8f31e4c4a37b8e9c), {
                    className: "h-4 w-4/5"
                })
            ]
        })
    });
}
var $8d457518e1db0edc$export$9e4cc2e016b1e8ed = function(param) {
    var heading = param.heading, text = param.text, buttonLabel = param.buttonLabel;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3d427baccb8d4aec$export$fba5249c7bd13e1f), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abed61b84e9aa1ca$export$f35abaf34fd2d2bf), {
                heading: heading,
                text: text,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                    children: buttonLabel
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "divide-border-200 divide-y rounded-md border",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d457518e1db0edc$var$ItemSkeleton, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d457518e1db0edc$var$ItemSkeleton, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d457518e1db0edc$var$ItemSkeleton, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d457518e1db0edc$var$ItemSkeleton, {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8d457518e1db0edc$var$ItemSkeleton, {})
                ]
            })
        ]
    });
};
var $8d457518e1db0edc$export$2e2bcd8739ae039 = $8d457518e1db0edc$export$9e4cc2e016b1e8ed;


function $8fcc03b285aec188$export$2e2bcd8739ae039(param) {
    var type = param.type, children = param.children, loading = param.loading, text = param.text, buttonLabel = param.buttonLabel, heading = param.heading;
    var wallet = (0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)).wallet;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex min-h-screen flex-col space-y-6",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("header", {
                className: "sticky top-0 z-40 border-b bg-background",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container flex h-16 items-center justify-between py-4",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e773a99b452aacad$export$4418626cb10d22e4), {
                            items: (0, $6b650fc028a96be1$export$dc17cc91b69b42a1).mainNav
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $301777d0b0678548$export$3dae770bdeb98043), {
                            user: {
                                name: wallet.accountId,
                                image: null,
                                email: wallet.accountId
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "container grid flex-1 gap-12 md:grid-cols-[200px_1fr]",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("aside", {
                        className: "hidden w-[200px] flex-col md:flex",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $52be4b0bf50d73a6$export$6195926672cda932), {
                            items: type === "none" ? [] : type === "lister" ? (0, $6b650fc028a96be1$export$dc17cc91b69b42a1).sidebarNav : (0, $6b650fc028a96be1$export$dc17cc91b69b42a1).sidebarNavBidder
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("main", {
                        className: "flex w-full flex-1 flex-col overflow-hidden",
                        children: loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8d457518e1db0edc$export$2e2bcd8739ae039), {
                            text: text,
                            buttonLabel: buttonLabel,
                            heading: heading
                        }) : children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3acbba690857c4ad$export$9967e3f82432943a), {
                className: "border-t"
            })
        ]
    });
}







var $c9896781e2e17aea$export$adf7f6a47eb011b3 = [
    {
        id: "1",
        name: "Infrastructure Development Contract for Smart City Project",
        amount: "100000",
        files: [],
        owner: "",
        status: "progress",
        startDate: new Date(),
        endDate: new Date(),
        description: "\n    This contract outlines the agreement between the government and the infrastructure development company for the implementation of critical infrastructure in a smart city project. The project aims to transform the city's infrastructure to support advanced technologies and improve the quality of life for its residents. The contract includes the following key provisions:\n\n    Scope of Work: The contract defines the specific infrastructure development projects to be undertaken, such as building smart roads, installing smart streetlights, implementing an intelligent transportation system, deploying IoT sensors for waste management, etc.\n    \n    Timeline and Milestones: The contract establishes a timeline for project completion, including specific milestones for each infrastructure component. This ensures timely progress and allows for efficient project monitoring.\n    \n    Technical Specifications: The contract outlines the technical requirements and standards for the infrastructure development, including connectivity, interoperability, cybersecurity, and data privacy measures. It ensures that the infrastructure is designed and implemented to meet the highest quality and security standards.\n    \n    Budget and Payment Terms: The contract includes the agreed-upon budget for the infrastructure development project and specifies the payment terms, such as milestone-based payments or periodic installments.\n    \n    Roles and Responsibilities: The contract clearly defines the roles and responsibilities of the government and the infrastructure development company. It outlines the obligations of each party regarding project management, coordination, reporting, and compliance with regulations.\n    \n    Change Management: The contract includes provisions for managing changes or modifications to the scope of work, timeline, or budget. It establishes a process for requesting and approving changes and ensures transparency and accountability throughout the project.\n    \n    Dispute Resolution: The contract includes mechanisms for resolving disputes that may arise during the project implementation. It may specify arbitration, mediation, or other dispute resolution methods to ensure a fair and timely resolution.\n    \n    This sample infrastructure development contract provides a solid foundation for the implementation of infrastructure projects in our app's dummy data. It covers essential aspects related to project scope, timeline, technical specifications, budget, roles, and dispute resolution.\n    "
    }
];



var $byzP8 = parcelRequire("byzP8");


var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");



var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");

var $8c71e3d4f4d87252$export$54ec01a60f47d33d = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "w-full overflow-auto",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", (0, $8OnJk._)({
            ref: ref,
            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("w-full caption-bottom text-sm", className)
        }, props))
    });
});
$8c71e3d4f4d87252$export$54ec01a60f47d33d.displayName = "Table";
var $8c71e3d4f4d87252$export$f850895b287ef28e = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("thead", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("[&_tr]:border-b", className)
    }, props));
});
$8c71e3d4f4d87252$export$f850895b287ef28e.displayName = "TableHeader";
var $8c71e3d4f4d87252$export$76ccd210b9029917 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("tbody", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("[&_tr:last-child]:border-0", className)
    }, props));
});
$8c71e3d4f4d87252$export$76ccd210b9029917.displayName = "TableBody";
var $8c71e3d4f4d87252$export$1f116082bba1f9a8 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("tfoot", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("bg-primary font-medium text-primary-foreground", className)
    }, props));
});
$8c71e3d4f4d87252$export$1f116082bba1f9a8.displayName = "TableFooter";
var $8c71e3d4f4d87252$export$b05581f4e764e162 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("tr", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className)
    }, props));
});
$8c71e3d4f4d87252$export$b05581f4e764e162.displayName = "TableRow";
var $8c71e3d4f4d87252$export$2f4a7be4f0dcc2 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("th", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", className)
    }, props));
});
$8c71e3d4f4d87252$export$2f4a7be4f0dcc2.displayName = "TableHead";
var $8c71e3d4f4d87252$export$1e4baea7053fc0e3 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("td", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("p-4 align-middle [&:has([role=checkbox])]:pr-0", className)
    }, props));
});
$8c71e3d4f4d87252$export$1e4baea7053fc0e3.displayName = "TableCell";
var $8c71e3d4f4d87252$export$35468a455d619eb3 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("caption", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("mt-4 text-sm text-muted-foreground", className)
    }, props));
});
$8c71e3d4f4d87252$export$35468a455d619eb3.displayName = "TableCaption";










var $6cds3 = parcelRequire("6cds3");
var $ff67f583320e0759$export$eae686c5662f0382 = (0, $6cds3.createContext)(null);


var $8fd777e58ebd560c$export$161ed36b9c17dff5 = function(param) {
    var contracts = param.contracts;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8c71e3d4f4d87252$export$54ec01a60f47d33d), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$35468a455d619eb3), {
                children: "A list of all available bids."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$f850895b287ef28e), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8c71e3d4f4d87252$export$b05581f4e764e162), {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$2f4a7be4f0dcc2), {
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$2f4a7be4f0dcc2), {
                            children: "Amount"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$2f4a7be4f0dcc2), {
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$2f4a7be4f0dcc2), {
                            children: "Start"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$2f4a7be4f0dcc2), {
                            children: "Deadline"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$2f4a7be4f0dcc2), {
                            className: "text-right",
                            children: "Actions"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$76ccd210b9029917), {
                children: contracts.map(function(param, i) {
                    var name = param.name, amount = param.amount, owner = param.owner, status = param.status, id = param.id, startDate = param.startDate, endDate = param.endDate;
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8c71e3d4f4d87252$export$b05581f4e764e162), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$1e4baea7053fc0e3), {
                                className: "font-medium",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$1e4baea7053fc0e3), {
                                children: amount
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$1e4baea7053fc0e3), {
                                children: status
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$1e4baea7053fc0e3), {
                                children: (0, $2bbfe96e4adedbff$export$3ae94a2503e890a1)(startDate !== null && startDate !== void 0 ? startDate : new Date())
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$1e4baea7053fc0e3), {
                                children: (0, $2bbfe96e4adedbff$export$3ae94a2503e890a1)(startDate !== null && startDate !== void 0 ? startDate : new Date())
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c71e3d4f4d87252$export$1e4baea7053fc0e3), {
                                className: "text-right",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                    to: "/contract/".concat(id),
                                    className: "mr-2",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                                        className: "rounded-full",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).info, {
                                            className: "h-4 w-4"
                                        })
                                    })
                                })
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var $8fd777e58ebd560c$var$AllBidsPage = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var ref1 = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)((0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)));
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    // const [contracts, setContracts] = useState<Contract[]>([]);
    var _useContext = (0, $6cds3.useContext)((0, $ff67f583320e0759$export$eae686c5662f0382)), contracts = _useContext.contracts, setContracts = _useContext.setContracts;
    var getContracts = function() {
        var _ref = (0, $byzP8._)(function() {
            var contracts;
            return (0, $7UAGh.__generator)(this, function(_state) {
                if (loading) return [
                    2
                ];
                setLoading(true);
                try {
                    contracts = (0, $c9896781e2e17aea$export$adf7f6a47eb011b3);
                    setContracts(contracts);
                } catch (e) {
                    console.log(e);
                } finally{
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function getContracts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $6cds3.useEffect)(function() {
        getContracts();
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fcc03b285aec188$export$2e2bcd8739ae039), {
        type: "bidder",
        loading: loading,
        heading: "Available Bids",
        text: "View and Make Bids",
        buttonLabel: "Available Bids",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3d427baccb8d4aec$export$fba5249c7bd13e1f), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abed61b84e9aa1ca$export$f35abaf34fd2d2bf), {
                    heading: "Available Bids",
                    text: "View and make bids.",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                        to: "/dashboard/bidder",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                            variant: "outline",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).add, {
                                    className: "mr-2 h-4 w-4"
                                }),
                                "My Bids"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8fd777e58ebd560c$export$161ed36b9c17dff5, {
                    contracts: contracts
                })
            ]
        })
    });
};
var $8fd777e58ebd560c$export$2e2bcd8739ae039 = $8fd777e58ebd560c$var$AllBidsPage;



var $77efc7be1ebf8b86$var$ListerDashboard = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var ref1 = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)((0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)));
    var _useContext = (0, $6cds3.useContext)((0, $ff67f583320e0759$export$eae686c5662f0382)), contracts = _useContext.contracts, setContracts = _useContext.setContracts;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var getContracts = function() {
        var _ref = (0, $byzP8._)(function() {
            var contracts;
            return (0, $7UAGh.__generator)(this, function(_state) {
                if (loading) return [
                    2
                ];
                setLoading(true);
                try {
                    contracts = (0, $c9896781e2e17aea$export$adf7f6a47eb011b3);
                // setContract(contracts);
                } catch (e) {
                    console.log(e);
                } finally{
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function getContracts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $6cds3.useEffect)(function() {
        getContracts();
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fcc03b285aec188$export$2e2bcd8739ae039), {
        type: "lister",
        loading: loading,
        heading: "Manage Contracts",
        text: "Add and Manage Contracts",
        buttonLabel: "Add Contract",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3d427baccb8d4aec$export$fba5249c7bd13e1f), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abed61b84e9aa1ca$export$f35abaf34fd2d2bf), {
                    heading: "My Contracts",
                    text: "Create and manage your contracts.",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                        to: "/contract/add",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                            variant: "outline",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).add, {
                                    className: "mr-2 h-4 w-4"
                                }),
                                "Add Contract"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fd777e58ebd560c$export$161ed36b9c17dff5), {
                    contracts: contracts
                })
            ]
        })
    });
};
var $77efc7be1ebf8b86$export$2e2bcd8739ae039 = $77efc7be1ebf8b86$var$ListerDashboard;



var $byzP8 = parcelRequire("byzP8");


var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");







var $byzP8 = parcelRequire("byzP8");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");

var $byzP8 = parcelRequire("byzP8");

var $dxWQo = parcelRequire("dxWQo");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $6cds3 = parcelRequire("6cds3");
var $ba34d1ebd6528b77$var$isCheckBoxInput = function(element) {
    return element.type === "checkbox";
};
var $ba34d1ebd6528b77$var$isDateObject = function(value1) {
    return value1 instanceof Date;
};
var $ba34d1ebd6528b77$var$isNullOrUndefined = function(value1) {
    return value1 == null;
};
var $ba34d1ebd6528b77$var$isObjectType = function(value1) {
    return typeof value1 === "object";
};
var $ba34d1ebd6528b77$var$isObject = function(value1) {
    return !$ba34d1ebd6528b77$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $ba34d1ebd6528b77$var$isObjectType(value1) && !$ba34d1ebd6528b77$var$isDateObject(value1);
};
var $ba34d1ebd6528b77$var$getEventValue = function(event) {
    return $ba34d1ebd6528b77$var$isObject(event) && event.target ? $ba34d1ebd6528b77$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
};
var $ba34d1ebd6528b77$var$getNodeParentName = function(name) {
    return name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
};
var $ba34d1ebd6528b77$var$isNameInFieldArray = function(names, name) {
    return names.has($ba34d1ebd6528b77$var$getNodeParentName(name));
};
var $ba34d1ebd6528b77$var$isPlainObject = function(tempObject) {
    var prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $ba34d1ebd6528b77$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $ba34d1ebd6528b77$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $ba34d1ebd6528b77$var$cloneObject(data) {
    var copy;
    var isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($ba34d1ebd6528b77$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $ba34d1ebd6528b77$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$ba34d1ebd6528b77$var$isPlainObject(data)) copy = data;
        else {
            for(var key in data)if (data.hasOwnProperty(key)) copy[key] = $ba34d1ebd6528b77$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $ba34d1ebd6528b77$var$compact = function(value1) {
    return Array.isArray(value1) ? value1.filter(Boolean) : [];
};
var $ba34d1ebd6528b77$var$isUndefined = function(val) {
    return val === undefined;
};
var $ba34d1ebd6528b77$export$3988ae62b71be9a3 = function(obj, path, defaultValue) {
    if (!path || !$ba34d1ebd6528b77$var$isObject(obj)) return defaultValue;
    var result = $ba34d1ebd6528b77$var$compact(path.split(/[,[\].]+?/)).reduce(function(result, key) {
        return $ba34d1ebd6528b77$var$isNullOrUndefined(result) ? result : result[key];
    }, obj);
    return $ba34d1ebd6528b77$var$isUndefined(result) || result === obj ? $ba34d1ebd6528b77$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $ba34d1ebd6528b77$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
var $ba34d1ebd6528b77$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
var $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
var $ba34d1ebd6528b77$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ var $ba34d1ebd6528b77$export$4d957a5e1be13b03 = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($ba34d1ebd6528b77$var$HookFormContext);
};
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ var $ba34d1ebd6528b77$export$8ce1ff4f94d08846 = function(props) {
    var children = props.children, data = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($ba34d1ebd6528b77$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $ba34d1ebd6528b77$var$getProxyFormState = function(formState, control, localProxyFormState) {
    var _loop = function(key) {
        Object.defineProperty(result, key, {
            get: function() {
                var _key = key;
                if (control._proxyFormState[_key] !== $ba34d1ebd6528b77$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $ba34d1ebd6528b77$var$VALIDATION_MODE.all;
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            }
        });
    };
    var isRoot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var result = {
        defaultValues: control._defaultValues
    };
    for(var key in formState)_loop(key);
    return result;
};
var $ba34d1ebd6528b77$var$isEmptyObject = function(value1) {
    return $ba34d1ebd6528b77$var$isObject(value1) && !Object.keys(value1).length;
};
var $ba34d1ebd6528b77$var$shouldRenderFormState = function(formStateData, _proxyFormState, updateFormState, isRoot) {
    updateFormState(formStateData);
    var name = formStateData.name, formState = (0, $c4006311849aa271$export$69fdd232f62cde60)(formStateData, [
        "name"
    ]);
    return $ba34d1ebd6528b77$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(function(key) {
        return _proxyFormState[key] === (!isRoot || $ba34d1ebd6528b77$var$VALIDATION_MODE.all);
    });
};
var $ba34d1ebd6528b77$var$convertToArrayPayload = function(value1) {
    return Array.isArray(value1) ? value1 : [
        value1
    ];
};
var $ba34d1ebd6528b77$var$shouldSubscribeByName = function(name, signalName, exact) {
    return exact && signalName ? name === signalName : !name || !signalName || name === signalName || $ba34d1ebd6528b77$var$convertToArrayPayload(name).some(function(currentName) {
        return currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName));
    });
};
function $ba34d1ebd6528b77$var$useSubscribe(props) {
    var _props = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        var subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return function() {
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$606f11b2eb45ecc6(props) {
    var methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    var _ref = props || {}, _ref_control = _ref.control, control = _ref_control === void 0 ? methods.control : _ref_control, disabled = _ref.disabled, name = _ref.name, exact = _ref.exact;
    var _React_useState = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._formState), 2), formState = _React_useState[0], updateFormState = _React_useState[1];
    var _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(true);
    var _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    var _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    _name.current = name;
    $ba34d1ebd6528b77$var$useSubscribe({
        disabled: disabled,
        next: function(value1) {
            return _mounted.current && $ba34d1ebd6528b77$var$shouldSubscribeByName(_name.current, value1.name, exact) && $ba34d1ebd6528b77$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState((0, $8OnJk._)({}, control._formState, value1));
        },
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return function() {
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $ba34d1ebd6528b77$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $ba34d1ebd6528b77$var$isString = function(value1) {
    return typeof value1 === "string";
};
var $ba34d1ebd6528b77$var$generateWatchOutput = function(names, _names, formValues, isGlobal, defaultValue) {
    if ($ba34d1ebd6528b77$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map(function(fieldName) {
        return isGlobal && _names.watch.add(fieldName), $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, fieldName);
    });
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $ba34d1ebd6528b77$export$3c773aa2b84f29e0(props) {
    var methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    var _ref = props || {}, _ref_control = _ref.control, control = _ref_control === void 0 ? methods.control : _ref_control, name = _ref.name, defaultValue = _ref.defaultValue, disabled = _ref.disabled, exact = _ref.exact;
    var _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    _name.current = name;
    $ba34d1ebd6528b77$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: function(formState) {
            if ($ba34d1ebd6528b77$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    var _React_useState = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._getWatch(name, defaultValue)), 2), value1 = _React_useState[0], updateValue = _React_useState[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        return control._removeUnmounted();
    });
    return value1;
}
var $ba34d1ebd6528b77$var$isKey = function(value1) {
    return /^\w*$/.test(value1);
};
var $ba34d1ebd6528b77$var$stringToPath = function(input) {
    return $ba34d1ebd6528b77$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
};
function $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(object, path, value1) {
    var index = -1;
    var tempPath = $ba34d1ebd6528b77$var$isKey(path) ? [
        path
    ] : $ba34d1ebd6528b77$var$stringToPath(path);
    var length = tempPath.length;
    var lastIndex = length - 1;
    while(++index < length){
        var key = tempPath[index];
        var newValue = value1;
        if (index !== lastIndex) {
            var objValue = object[key];
            newValue = $ba34d1ebd6528b77$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$e8c786024a2b0a79(props) {
    var methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    var name = props.name, _props_control = props.control, control = _props_control === void 0 ? methods.control : _props_control, shouldUnregister = props.shouldUnregister;
    var isArrayField = $ba34d1ebd6528b77$var$isNameInFieldArray(control._names.array, name);
    var value1 = $ba34d1ebd6528b77$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    var formState = $ba34d1ebd6528b77$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    var _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(control.register(name, (0, $8E768._)((0, $8OnJk._)({}, props.rules), {
        value: value1
    })));
    _registerProps.current = control.register(name, props.rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        var _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        var updateMounted = function(name, value1) {
            var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            var value1 = $ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($ba34d1ebd6528b77$var$isUndefined($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name))) $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return function() {
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(function(event) {
                return _registerProps.current.onChange({
                    target: {
                        value: $ba34d1ebd6528b77$var$getEventValue(event),
                        name: name
                    },
                    type: $ba34d1ebd6528b77$var$EVENTS.CHANGE
                });
            }, [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(function() {
                return _registerProps.current.onBlur({
                    target: {
                        value: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $ba34d1ebd6528b77$var$EVENTS.BLUR
                });
            }, [
                name,
                control
            ]),
            ref: function(elm) {
                var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: function() {
                        return elm.focus();
                    },
                    select: function() {
                        return elm.select();
                    },
                    setCustomValidity: function(message) {
                        return elm.setCustomValidity(message);
                    },
                    reportValidity: function() {
                        return elm.reportValidity();
                    }
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: function() {
                    return !!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.errors, name);
                }
            },
            isDirty: {
                enumerable: true,
                get: function() {
                    return !!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.dirtyFields, name);
                }
            },
            isTouched: {
                enumerable: true,
                get: function() {
                    return !!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.touchedFields, name);
                }
            },
            error: {
                enumerable: true,
                get: function() {
                    return $ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.errors, name);
                }
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ var $ba34d1ebd6528b77$export$bd0bf19f25da8474 = function(props) {
    return props.render($ba34d1ebd6528b77$export$e8c786024a2b0a79(props));
};
var $ba34d1ebd6528b77$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$a7fed597f4b8afd8(props) {
    var methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    var _React_useState = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    var _props_control = props.control, control = _props_control === void 0 ? methods.control : _props_control, onSubmit = props.onSubmit, children = props.children, action = props.action, _props_method = props.method, method = _props_method === void 0 ? $ba34d1ebd6528b77$var$POST_REQUEST : _props_method, headers = props.headers, encType = props.encType, onError = props.onError, render = props.render, onSuccess = props.onSuccess, validateStatus = props.validateStatus, rest = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "control",
        "onSubmit",
        "children",
        "action",
        "method",
        "headers",
        "encType",
        "onError",
        "render",
        "onSuccess",
        "validateStatus"
    ]);
    var submit = function() {
        var _ref = (0, $byzP8._)(function(event) {
            var hasError, type;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasError = false;
                        type = "";
                        return [
                            4,
                            control.handleSubmit(function() {
                                var _ref = (0, $byzP8._)(function(data) {
                                    var formData, formDataJson, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, name, shouldStringifySubmissionData, response, error;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                formData = new FormData();
                                                formDataJson = "";
                                                try {
                                                    formDataJson = JSON.stringify(data);
                                                } catch (_a) {}
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                try {
                                                    for(_iterator = control._names.mount[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                        name = _step.value;
                                                        formData.append(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(data, name));
                                                    }
                                                } catch (err) {
                                                    _didIteratorError = true;
                                                    _iteratorError = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                            _iterator.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError) {
                                                            throw _iteratorError;
                                                        }
                                                    }
                                                }
                                                if (onSubmit) onSubmit({
                                                    data: data,
                                                    event: event,
                                                    method: method,
                                                    formData: formData,
                                                    formDataJson: formDataJson
                                                });
                                                if (!action) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                shouldStringifySubmissionData = [
                                                    headers && headers["Content-Type"],
                                                    encType
                                                ].some(function(value1) {
                                                    return value1 && value1.includes("json");
                                                });
                                                return [
                                                    4,
                                                    fetch(action, {
                                                        method: method,
                                                        headers: (0, $8OnJk._)({}, headers, encType ? {
                                                            "Content-Type": encType
                                                        } : {}),
                                                        body: shouldStringifySubmissionData ? formDataJson : formData
                                                    })
                                                ];
                                            case 2:
                                                response = _state.sent();
                                                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                                                    hasError = true;
                                                    onError && onError({
                                                        response: response
                                                    });
                                                    type = String(response.status);
                                                } else onSuccess && onSuccess({
                                                    response: response
                                                });
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                error = _state.sent();
                                                hasError = true;
                                                onError && onError({
                                                    error: error
                                                });
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(data) {
                                    return _ref.apply(this, arguments);
                                };
                            }())(event)
                        ];
                    case 1:
                        _state.sent();
                        if (hasError && props.control) {
                            props.control._subjects.state.next({
                                isSubmitSuccessful: false
                            });
                            props.control.setError("root.server", {
                                type: type
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function submit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("form", (0, $8OnJk._)({
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit
    }, rest), children);
}
var $ba34d1ebd6528b77$export$b196c2a4f765bd30 = function(name, validateAllFieldCriteria, errors, type, message) {
    return validateAllFieldCriteria ? (0, $8E768._)((0, $8OnJk._)({}, errors[name]), {
        types: (0, $8E768._)((0, $8OnJk._)({}, errors[name] && errors[name].types ? errors[name].types : {}), (0, $dxWQo._)({}, type, message || true))
    }) : {};
};
var $ba34d1ebd6528b77$var$focusFieldBy = function(fields, callback, fieldsNames) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (fieldsNames || Object.keys(fields))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ref = _step.value;
            var key = _ref;
            var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(fields, key);
            if (field) {
                var _f = field._f, currentField = (0, $c4006311849aa271$export$69fdd232f62cde60)(field, [
                    "_f"
                ]);
                if (_f && callback(_f.name)) {
                    if (_f.ref.focus) {
                        _f.ref.focus();
                        break;
                    } else if (_f.refs && _f.refs[0].focus) {
                        _f.refs[0].focus();
                        break;
                    }
                } else if ($ba34d1ebd6528b77$var$isObject(currentField)) $ba34d1ebd6528b77$var$focusFieldBy(currentField, callback);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var $ba34d1ebd6528b77$var$generateId = function() {
    var d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $ba34d1ebd6528b77$var$getFocusFieldName = function(name, index) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return options.shouldFocus || $ba34d1ebd6528b77$var$isUndefined(options.shouldFocus) ? options.focusName || "".concat(name, ".").concat($ba34d1ebd6528b77$var$isUndefined(options.focusIndex) ? index : options.focusIndex, ".") : "";
};
var $ba34d1ebd6528b77$var$getValidationModes = function(mode) {
    return {
        isOnSubmit: !mode || mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all,
        isOnTouch: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onTouched
    };
};
var $ba34d1ebd6528b77$var$isWatched = function(name, _names, isBlurEvent) {
    return !isBlurEvent && (_names.watchAll || _names.watch.has(name) || (0, $fLnyw._)(_names.watch).some(function(watchName) {
        return name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length));
    }));
};
var $ba34d1ebd6528b77$var$updateFieldArrayRootError = function(errors, error, name) {
    var fieldArrayErrors = $ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name));
    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $ba34d1ebd6528b77$var$isBoolean = function(value1) {
    return typeof value1 === "boolean";
};
var $ba34d1ebd6528b77$var$isFileInput = function(element) {
    return element.type === "file";
};
var $ba34d1ebd6528b77$var$isFunction = function(value1) {
    return typeof value1 === "function";
};
var $ba34d1ebd6528b77$var$isHTMLElement = function(value1) {
    if (!$ba34d1ebd6528b77$var$isWeb) return false;
    var owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $ba34d1ebd6528b77$var$isMessage = function(value1) {
    return $ba34d1ebd6528b77$var$isString(value1);
};
var $ba34d1ebd6528b77$var$isRadioInput = function(element) {
    return element.type === "radio";
};
var $ba34d1ebd6528b77$var$isRegex = function(value1) {
    return value1 instanceof RegExp;
};
var $ba34d1ebd6528b77$var$defaultResult = {
    value: false,
    isValid: false
};
var $ba34d1ebd6528b77$var$validResult = {
    value: true,
    isValid: true
};
var $ba34d1ebd6528b77$var$getCheckboxValue = function(options) {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            var values = options.filter(function(option) {
                return option && option.checked && !option.disabled;
            }).map(function(option) {
                return option.value;
            });
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$ba34d1ebd6528b77$var$isUndefined(options[0].attributes.value) ? $ba34d1ebd6528b77$var$isUndefined(options[0].value) || options[0].value === "" ? $ba34d1ebd6528b77$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $ba34d1ebd6528b77$var$validResult : $ba34d1ebd6528b77$var$defaultResult;
    }
    return $ba34d1ebd6528b77$var$defaultResult;
};
var $ba34d1ebd6528b77$var$defaultReturn = {
    isValid: false,
    value: null
};
var $ba34d1ebd6528b77$var$getRadioValue = function(options) {
    return Array.isArray(options) ? options.reduce(function(previous, option) {
        return option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous;
    }, $ba34d1ebd6528b77$var$defaultReturn) : $ba34d1ebd6528b77$var$defaultReturn;
};
function $ba34d1ebd6528b77$var$getValidateError(result, ref) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "validate";
    if ($ba34d1ebd6528b77$var$isMessage(result) || Array.isArray(result) && result.every($ba34d1ebd6528b77$var$isMessage) || $ba34d1ebd6528b77$var$isBoolean(result) && !result) return {
        type: type,
        message: $ba34d1ebd6528b77$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $ba34d1ebd6528b77$var$getValueAndMessage = function(validationData) {
    return $ba34d1ebd6528b77$var$isObject(validationData) && !$ba34d1ebd6528b77$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
};
var $ba34d1ebd6528b77$var$validateField = function() {
    var _ref = (0, $byzP8._)(function(field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
        var _field__f, ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, inputValue, inputRef, setCustomValidity, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref, value1, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, convertTimeToDate, isTime, isWeek, maxLengthOutput, minLengthOutput, exceedMax1, exceedMin1, _getValueAndMessage, patternValue, message1, result, validateError, validationResult, _tmp, _tmp1, _i, key, validateError1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _field__f = field._f, ref = _field__f.ref, refs = _field__f.refs, required = _field__f.required, maxLength = _field__f.maxLength, minLength = _field__f.minLength, min = _field__f.min, max = _field__f.max, pattern = _field__f.pattern, validate = _field__f.validate, name = _field__f.name, valueAsNumber = _field__f.valueAsNumber, mount = _field__f.mount, disabled = _field__f.disabled;
                    inputValue = $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, name);
                    if (!mount || disabled) return [
                        2,
                        {}
                    ];
                    inputRef = refs ? refs[0] : ref;
                    setCustomValidity = function(message) {
                        if (shouldUseNativeValidation && inputRef.reportValidity) {
                            inputRef.setCustomValidity($ba34d1ebd6528b77$var$isBoolean(message) ? "" : message || "");
                            inputRef.reportValidity();
                        }
                    };
                    error = {};
                    isRadio = $ba34d1ebd6528b77$var$isRadioInput(ref);
                    isCheckBox = $ba34d1ebd6528b77$var$isCheckBoxInput(ref);
                    isRadioOrCheckbox = isRadio || isCheckBox;
                    isEmpty = (valueAsNumber || $ba34d1ebd6528b77$var$isFileInput(ref)) && $ba34d1ebd6528b77$var$isUndefined(ref.value) && $ba34d1ebd6528b77$var$isUndefined(inputValue) || $ba34d1ebd6528b77$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
                    appendErrorsCurry = $ba34d1ebd6528b77$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
                    getMinMaxMessage = function(exceedMax, maxLengthMessage, minLengthMessage) {
                        var maxType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.maxLength, minType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.minLength;
                        var message = exceedMax ? maxLengthMessage : minLengthMessage;
                        error[name] = (0, $8OnJk._)({
                            type: exceedMax ? maxType : minType,
                            message: message,
                            ref: ref
                        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
                    };
                    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $ba34d1ebd6528b77$var$isNullOrUndefined(inputValue)) || $ba34d1ebd6528b77$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$ba34d1ebd6528b77$var$getCheckboxValue(refs).isValid || isRadio && !$ba34d1ebd6528b77$var$getRadioValue(refs).isValid)) {
                        _ref = $ba34d1ebd6528b77$var$isMessage(required) ? {
                            value: !!required,
                            message: required
                        } : $ba34d1ebd6528b77$var$getValueAndMessage(required), value1 = _ref.value, message = _ref.message;
                        if (value1) {
                            error[name] = (0, $8OnJk._)({
                                type: $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.required,
                                message: message,
                                ref: inputRef
                            }, appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.required, message));
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(message);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if (!isEmpty && (!$ba34d1ebd6528b77$var$isNullOrUndefined(min) || !$ba34d1ebd6528b77$var$isNullOrUndefined(max))) {
                        ;
                        ;
                        maxOutput = $ba34d1ebd6528b77$var$getValueAndMessage(max);
                        minOutput = $ba34d1ebd6528b77$var$getValueAndMessage(min);
                        if (!$ba34d1ebd6528b77$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
                            valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
                            if (!$ba34d1ebd6528b77$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
                            if (!$ba34d1ebd6528b77$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
                        } else {
                            valueDate = ref.valueAsDate || new Date(inputValue);
                            convertTimeToDate = function(time) {
                                return new Date(new Date().toDateString() + " " + time);
                            };
                            isTime = ref.type == "time";
                            isWeek = ref.type == "week";
                            if ($ba34d1ebd6528b77$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
                            if ($ba34d1ebd6528b77$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
                        }
                        if (exceedMax || exceedMin) {
                            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.max, $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.min);
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(error[name].message);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if ((maxLength || minLength) && !isEmpty && ($ba34d1ebd6528b77$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
                        maxLengthOutput = $ba34d1ebd6528b77$var$getValueAndMessage(maxLength);
                        minLengthOutput = $ba34d1ebd6528b77$var$getValueAndMessage(minLength);
                        exceedMax1 = !$ba34d1ebd6528b77$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
                        exceedMin1 = !$ba34d1ebd6528b77$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
                        if (exceedMax1 || exceedMin1) {
                            getMinMaxMessage(exceedMax1, maxLengthOutput.message, minLengthOutput.message);
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(error[name].message);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if (pattern && !isEmpty && $ba34d1ebd6528b77$var$isString(inputValue)) {
                        _getValueAndMessage = $ba34d1ebd6528b77$var$getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, message1 = _getValueAndMessage.message;
                        if ($ba34d1ebd6528b77$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
                            error[name] = (0, $8OnJk._)({
                                type: $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.pattern,
                                message: message1,
                                ref: ref
                            }, appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.pattern, message1));
                            if (!validateAllFieldCriteria) {
                                setCustomValidity(message1);
                                return [
                                    2,
                                    error
                                ];
                            }
                        }
                    }
                    if (!validate) return [
                        3,
                        7
                    ];
                    if (!$ba34d1ebd6528b77$var$isFunction(validate)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        validate(inputValue, formValues)
                    ];
                case 1:
                    result = _state.sent();
                    validateError = $ba34d1ebd6528b77$var$getValidateError(result, inputRef);
                    if (validateError) {
                        error[name] = (0, $8OnJk._)({}, validateError, appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                        if (!validateAllFieldCriteria) {
                            setCustomValidity(validateError.message);
                            return [
                                2,
                                error
                            ];
                        }
                    }
                    return [
                        3,
                        7
                    ];
                case 2:
                    if (!$ba34d1ebd6528b77$var$isObject(validate)) return [
                        3,
                        7
                    ];
                    validationResult = {};
                    _tmp = [];
                    for(_tmp1 in validate)_tmp.push(_tmp1);
                    _i = 0;
                    _state.label = 3;
                case 3:
                    if (!(_i < _tmp.length)) return [
                        3,
                        6
                    ];
                    key = _tmp[_i];
                    if (!$ba34d1ebd6528b77$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        validate[key](inputValue, formValues)
                    ];
                case 4:
                    validateError1 = $ba34d1ebd6528b77$var$getValidateError.apply(void 0, [
                        _state.sent(),
                        inputRef,
                        key
                    ]);
                    if (validateError1) {
                        validationResult = (0, $8OnJk._)({}, validateError1, appendErrorsCurry(key, validateError1.message));
                        setCustomValidity(validateError1.message);
                        if (validateAllFieldCriteria) error[name] = validationResult;
                    }
                    _state.label = 5;
                case 5:
                    _i++;
                    return [
                        3,
                        3
                    ];
                case 6:
                    if (!$ba34d1ebd6528b77$var$isEmptyObject(validationResult)) {
                        error[name] = (0, $8OnJk._)({
                            ref: inputRef
                        }, validationResult);
                        if (!validateAllFieldCriteria) return [
                            2,
                            error
                        ];
                    }
                    _state.label = 7;
                case 7:
                    setCustomValidity(true);
                    return [
                        2,
                        error
                    ];
            }
        });
    });
    return function validateField(field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
        return _ref.apply(this, arguments);
    };
}();
function $ba34d1ebd6528b77$var$append(data, value1) {
    return (0, $fLnyw._)(data).concat((0, $fLnyw._)($ba34d1ebd6528b77$var$convertToArrayPayload(value1)));
}
var $ba34d1ebd6528b77$var$fillEmptyArray = function(value1) {
    return Array.isArray(value1) ? value1.map(function() {
        return undefined;
    }) : undefined;
};
function $ba34d1ebd6528b77$var$insert(data, index, value1) {
    return (0, $fLnyw._)(data.slice(0, index)).concat((0, $fLnyw._)($ba34d1ebd6528b77$var$convertToArrayPayload(value1)), (0, $fLnyw._)(data.slice(index)));
}
var $ba34d1ebd6528b77$var$moveArrayAt = function(data, from, to) {
    if (!Array.isArray(data)) return [];
    if ($ba34d1ebd6528b77$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $ba34d1ebd6528b77$var$prepend(data, value1) {
    return (0, $fLnyw._)($ba34d1ebd6528b77$var$convertToArrayPayload(value1)).concat((0, $fLnyw._)($ba34d1ebd6528b77$var$convertToArrayPayload(data)));
}
function $ba34d1ebd6528b77$var$removeAtIndexes(data, indexes) {
    var i = 0;
    var temp = (0, $fLnyw._)(data);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            temp.splice(index - i, 1);
            i++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $ba34d1ebd6528b77$var$compact(temp).length ? temp : [];
}
var $ba34d1ebd6528b77$var$removeArrayAt = function(data, index) {
    return $ba34d1ebd6528b77$var$isUndefined(index) ? [] : $ba34d1ebd6528b77$var$removeAtIndexes(data, $ba34d1ebd6528b77$var$convertToArrayPayload(index).sort(function(a, b) {
        return a - b;
    }));
};
var $ba34d1ebd6528b77$var$swapArrayAt = function(data, indexA, indexB) {
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $ba34d1ebd6528b77$var$baseGet(object, updatePath) {
    var length = updatePath.slice(0, -1).length;
    var index = 0;
    while(index < length)object = $ba34d1ebd6528b77$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $ba34d1ebd6528b77$var$isEmptyArray(obj) {
    for(var key in obj){
        if (obj.hasOwnProperty(key) && !$ba34d1ebd6528b77$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $ba34d1ebd6528b77$var$unset(object, path) {
    var paths = Array.isArray(path) ? path : $ba34d1ebd6528b77$var$isKey(path) ? [
        path
    ] : $ba34d1ebd6528b77$var$stringToPath(path);
    var childObject = paths.length === 1 ? object : $ba34d1ebd6528b77$var$baseGet(object, paths);
    var index = paths.length - 1;
    var key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($ba34d1ebd6528b77$var$isObject(childObject) && $ba34d1ebd6528b77$var$isEmptyObject(childObject) || Array.isArray(childObject) && $ba34d1ebd6528b77$var$isEmptyArray(childObject))) $ba34d1ebd6528b77$var$unset(object, paths.slice(0, -1));
    return object;
}
var $ba34d1ebd6528b77$var$updateAt = function(fieldValues, index, value1) {
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$310131896651d559(props) {
    var methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    var _props_control = props.control, control = _props_control === void 0 ? methods.control : _props_control, name = props.name, _props_keyName = props.keyName, keyName = _props_keyName === void 0 ? "id" : _props_keyName, shouldUnregister = props.shouldUnregister;
    var _React_useState = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._getFieldArray(name)), 2), fields = _React_useState[0], setFields = _React_useState[1];
    var ids = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(control._getFieldArray(name).map($ba34d1ebd6528b77$var$generateId));
    var _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(fields);
    var _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    var _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $ba34d1ebd6528b77$var$useSubscribe({
        next: function(param) {
            var values = param.values, fieldArrayName = param.name;
            if (fieldArrayName === _name.current || !fieldArrayName) {
                var fieldValues = $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($ba34d1ebd6528b77$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    var updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(function(updatedFieldArrayValues) {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    var append$1 = function(value1, options) {
        var appendValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        var updatedFieldArrayValues = $ba34d1ebd6528b77$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $ba34d1ebd6528b77$var$append(ids.current, appendValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$append, {
            argA: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    var prepend$1 = function(value1, options) {
        var prependValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        var updatedFieldArrayValues = $ba34d1ebd6528b77$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, 0, options);
        ids.current = $ba34d1ebd6528b77$var$prepend(ids.current, prependValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$prepend, {
            argA: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    var remove = function(index) {
        var updatedFieldArrayValues = $ba34d1ebd6528b77$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $ba34d1ebd6528b77$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$removeArrayAt, {
            argA: index
        });
    };
    var insert$1 = function(index, value1, options) {
        var insertValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        var updatedFieldArrayValues = $ba34d1ebd6528b77$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, index, options);
        ids.current = $ba34d1ebd6528b77$var$insert(ids.current, index, insertValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$insert, {
            argA: index,
            argB: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    var swap = function(indexA, indexB) {
        var updatedFieldArrayValues = control._getFieldArray(name);
        $ba34d1ebd6528b77$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $ba34d1ebd6528b77$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    var move = function(from, to) {
        var updatedFieldArrayValues = control._getFieldArray(name);
        $ba34d1ebd6528b77$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $ba34d1ebd6528b77$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    var update = function(index, value1) {
        var updateValue = $ba34d1ebd6528b77$var$cloneObject(value1);
        var updatedFieldArrayValues = $ba34d1ebd6528b77$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = (0, $fLnyw._)(updatedFieldArrayValues).map(function(item, i) {
            return !item || i === index ? $ba34d1ebd6528b77$var$generateId() : ids.current[i];
        });
        updateValues(updatedFieldArrayValues);
        setFields((0, $fLnyw._)(updatedFieldArrayValues));
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    var replace = function(value1) {
        var updatedFieldArrayValues = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($ba34d1ebd6528b77$var$generateId);
        updateValues((0, $fLnyw._)(updatedFieldArrayValues));
        setFields((0, $fLnyw._)(updatedFieldArrayValues));
        control._updateFieldArray(name, (0, $fLnyw._)(updatedFieldArrayValues), function(data) {
            return data;
        }, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        control._state.action = false;
        $ba34d1ebd6528b77$var$isWatched(name, control._names) && control._subjects.state.next((0, $8OnJk._)({}, control._formState));
        if (_actioned.current && (!$ba34d1ebd6528b77$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then(function(result) {
                var error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(result.errors, name);
                var existingError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $ba34d1ebd6528b77$var$validateField(field, control._formValues, control._options.criteriaMode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then(function(error) {
                    return !$ba34d1ebd6528b77$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $ba34d1ebd6528b77$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    });
                });
            }
        }
        control._subjects.values.next({
            name: name,
            values: (0, $8OnJk._)({}, control._formValues)
        });
        control._names.focus && $ba34d1ebd6528b77$var$focusFieldBy(control._fields, function(key) {
            return !!key && key.startsWith(control._names.focus || "");
        });
        control._names.focus = "";
        control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        !$ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return function() {
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useMemo(function() {
            return fields.map(function(field, index) {
                return (0, $8E768._)((0, $8OnJk._)({}, field), (0, $dxWQo._)({}, keyName, ids.current[index] || $ba34d1ebd6528b77$var$generateId()));
            });
        }, [
            fields,
            keyName
        ])
    };
}
function $ba34d1ebd6528b77$var$createSubject() {
    var _observers = [];
    var next = function(value1) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _observers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var observer = _step.value;
                observer.next && observer.next(value1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var subscribe = function(observer) {
        _observers.push(observer);
        return {
            unsubscribe: function() {
                _observers = _observers.filter(function(o) {
                    return o !== observer;
                });
            }
        };
    };
    var unsubscribe = function() {
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $ba34d1ebd6528b77$var$isPrimitive = function(value1) {
    return $ba34d1ebd6528b77$var$isNullOrUndefined(value1) || !$ba34d1ebd6528b77$var$isObjectType(value1);
};
function $ba34d1ebd6528b77$var$deepEqual(object1, object2) {
    if ($ba34d1ebd6528b77$var$isPrimitive(object1) || $ba34d1ebd6528b77$var$isPrimitive(object2)) return object1 === object2;
    if ($ba34d1ebd6528b77$var$isDateObject(object1) && $ba34d1ebd6528b77$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var val1 = object1[key];
            if (!keys2.includes(key)) return false;
            if (key !== "ref") {
                var val2 = object2[key];
                if ($ba34d1ebd6528b77$var$isDateObject(val1) && $ba34d1ebd6528b77$var$isDateObject(val2) || $ba34d1ebd6528b77$var$isObject(val1) && $ba34d1ebd6528b77$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$ba34d1ebd6528b77$var$deepEqual(val1, val2) : val1 !== val2) return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
var $ba34d1ebd6528b77$var$isMultipleSelect = function(element) {
    return element.type === "select-multiple";
};
var $ba34d1ebd6528b77$var$isRadioOrCheckbox = function(ref) {
    return $ba34d1ebd6528b77$var$isRadioInput(ref) || $ba34d1ebd6528b77$var$isCheckBoxInput(ref);
};
var $ba34d1ebd6528b77$var$live = function(ref) {
    return $ba34d1ebd6528b77$var$isHTMLElement(ref) && ref.isConnected;
};
var $ba34d1ebd6528b77$var$objectHasFunction = function(data) {
    for(var key in data){
        if ($ba34d1ebd6528b77$var$isFunction(data[key])) return true;
    }
    return false;
};
function $ba34d1ebd6528b77$var$markFieldsDirty(data) {
    var fields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var isParentNodeArray = Array.isArray(data);
    if ($ba34d1ebd6528b77$var$isObject(data) || isParentNodeArray) for(var key in data){
        if (Array.isArray(data[key]) || $ba34d1ebd6528b77$var$isObject(data[key]) && !$ba34d1ebd6528b77$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $ba34d1ebd6528b77$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$ba34d1ebd6528b77$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    var isParentNodeArray = Array.isArray(data);
    if ($ba34d1ebd6528b77$var$isObject(data) || isParentNodeArray) {
        for(var key in data)if (Array.isArray(data[key]) || $ba34d1ebd6528b77$var$isObject(data[key]) && !$ba34d1ebd6528b77$var$objectHasFunction(data[key])) {
            if ($ba34d1ebd6528b77$var$isUndefined(formValues) || $ba34d1ebd6528b77$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $ba34d1ebd6528b77$var$markFieldsDirty(data[key], []) : (0, $8OnJk._)({}, $ba34d1ebd6528b77$var$markFieldsDirty(data[key]));
            else $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(data[key], $ba34d1ebd6528b77$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$ba34d1ebd6528b77$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $ba34d1ebd6528b77$var$getDirtyFields = function(defaultValues, formValues) {
    return $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $ba34d1ebd6528b77$var$markFieldsDirty(formValues));
};
var $ba34d1ebd6528b77$var$getFieldValueAs = function(value1, param) {
    var valueAsNumber = param.valueAsNumber, valueAsDate = param.valueAsDate, setValueAs = param.setValueAs;
    return $ba34d1ebd6528b77$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $ba34d1ebd6528b77$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
};
function $ba34d1ebd6528b77$var$getFieldValue(_f) {
    var ref = _f.ref;
    if (_f.refs ? _f.refs.every(function(ref) {
        return ref.disabled;
    }) : ref.disabled) return;
    if ($ba34d1ebd6528b77$var$isFileInput(ref)) return ref.files;
    if ($ba34d1ebd6528b77$var$isRadioInput(ref)) return $ba34d1ebd6528b77$var$getRadioValue(_f.refs).value;
    if ($ba34d1ebd6528b77$var$isMultipleSelect(ref)) return (0, $fLnyw._)(ref.selectedOptions).map(function(param) {
        var value1 = param.value;
        return value1;
    });
    if ($ba34d1ebd6528b77$var$isCheckBoxInput(ref)) return $ba34d1ebd6528b77$var$getCheckboxValue(_f.refs).value;
    return $ba34d1ebd6528b77$var$getFieldValueAs($ba34d1ebd6528b77$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $ba34d1ebd6528b77$var$getResolverOptions = function(fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) {
    var fields = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = fieldsNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
            field && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(fields, name, field._f);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        criteriaMode: criteriaMode,
        names: (0, $fLnyw._)(fieldsNames),
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $ba34d1ebd6528b77$var$getRuleValue = function(rule) {
    return $ba34d1ebd6528b77$var$isUndefined(rule) ? rule : $ba34d1ebd6528b77$var$isRegex(rule) ? rule.source : $ba34d1ebd6528b77$var$isObject(rule) ? $ba34d1ebd6528b77$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
};
var $ba34d1ebd6528b77$var$hasValidation = function(options) {
    return options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
};
function $ba34d1ebd6528b77$var$schemaErrorLookup(errors, _fields, name) {
    var error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
    if (error || $ba34d1ebd6528b77$var$isKey(name)) return {
        error: error,
        name: name
    };
    var names = name.split(".");
    while(names.length){
        var fieldName = names.join(".");
        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
        var foundError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $ba34d1ebd6528b77$var$skipValidation = function(isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) {
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $ba34d1ebd6528b77$var$unsetEmptyArray = function(ref, name) {
    return !$ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(ref, name)).length && $ba34d1ebd6528b77$var$unset(ref, name);
};
var $ba34d1ebd6528b77$var$defaultOptions = {
    mode: $ba34d1ebd6528b77$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $ba34d1ebd6528b77$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $ba34d1ebd6528b77$var$createFormControl() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, flushRootRender = arguments.length > 1 ? arguments[1] : void 0;
    var _options = (0, $8OnJk._)({}, $ba34d1ebd6528b77$var$defaultOptions, props);
    var _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $ba34d1ebd6528b77$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    var _fields = {};
    var _defaultValues = $ba34d1ebd6528b77$var$isObject(_options.defaultValues) || $ba34d1ebd6528b77$var$isObject(_options.values) ? $ba34d1ebd6528b77$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    var _formValues = _options.shouldUnregister ? {} : $ba34d1ebd6528b77$var$cloneObject(_defaultValues);
    var _state = {
        action: false,
        mount: false,
        watch: false
    };
    var _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    var delayErrorCallback;
    var timer = 0;
    var _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    var _subjects = {
        values: $ba34d1ebd6528b77$var$createSubject(),
        array: $ba34d1ebd6528b77$var$createSubject(),
        state: $ba34d1ebd6528b77$var$createSubject()
    };
    var shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    var validationModeBeforeSubmit = $ba34d1ebd6528b77$var$getValidationModes(_options.mode);
    var validationModeAfterSubmit = $ba34d1ebd6528b77$var$getValidationModes(_options.reValidateMode);
    var shouldDisplayAllAssociatedErrors = _options.criteriaMode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all;
    var debounce = function(callback) {
        return function(wait) {
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    };
    var _updateValid = function() {
        var _ref = (0, $byzP8._)(function(shouldUpdateValid) {
            var isValid, _tmp;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(_proxyFormState.isValid || shouldUpdateValid)) return [
                            3,
                            5
                        ];
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _executeSchema()
                        ];
                    case 1:
                        _tmp = $ba34d1ebd6528b77$var$isEmptyObject.apply(void 0, [
                            _state.sent().errors
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            executeBuiltInValidation(_fields, true)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        isValid = _tmp;
                        if (isValid !== _formState.isValid) _subjects.state.next({
                            isValid: isValid
                        });
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function _updateValid(shouldUpdateValid) {
            return _ref.apply(this, arguments);
        };
    }();
    var _updateIsValidating = function(value1) {
        return _proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    };
    var _updateFieldArray = function(name) {
        var values = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], method = arguments.length > 2 ? arguments[2] : void 0, args = arguments.length > 3 ? arguments[3] : void 0, shouldSetValues = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, shouldUpdateFieldsAndState = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name))) {
                var fieldValues = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name))) {
                var errors = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $ba34d1ebd6528b77$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                var touchedFields = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    var updateErrors = function(name, error) {
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    var updateValidAndValue = function(name, shouldSkipSetValueAs, value1, ref) {
        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            var defaultValue = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, $ba34d1ebd6528b77$var$isUndefined(value1) ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $ba34d1ebd6528b77$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $ba34d1ebd6528b77$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    var updateTouchAndDirty = function(name, fieldValue, isBlurEvent, shouldDirty, shouldRender) {
        var shouldUpdateField = false;
        var isPreviousDirty = false;
        var output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            var isCurrentFieldPristine = $ba34d1ebd6528b77$var$deepEqual($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, name) : $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            var isPreviousFieldTouched = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    var shouldRenderByError = function(name, isValid, error, fieldState) {
        var previousFieldError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name);
        var shouldUpdateValid = _proxyFormState.isValid && $ba34d1ebd6528b77$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(function() {
                return updateErrors(name, error);
            });
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(_formState.errors, name);
        }
        if ((error ? !$ba34d1ebd6528b77$var$deepEqual(previousFieldError, error) : previousFieldError) || !$ba34d1ebd6528b77$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            var updatedFormState = (0, $8E768._)((0, $8OnJk._)({}, fieldState, shouldUpdateValid && $ba34d1ebd6528b77$var$isBoolean(isValid) ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _formState = (0, $8OnJk._)({}, _formState, updatedFormState);
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    var _executeSchema = function() {
        var _ref = (0, $byzP8._)(function(name) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                return [
                    2,
                    _options.resolver(_formValues, _options.context, $ba34d1ebd6528b77$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
                ];
            });
        });
        return function _executeSchema(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var executeSchemaAndUpdateState = function() {
        var _ref = (0, $byzP8._)(function(names) {
            var errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, name, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _executeSchema()
                        ];
                    case 1:
                        errors = _state.sent().errors;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (names) try {
                            for(_iterator = names[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                name = _step.value;
                                error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
                                error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(_formState.errors, name);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        else _formState.errors = errors;
                        return [
                            2,
                            errors
                        ];
                }
            });
        });
        return function executeSchemaAndUpdateState(names) {
            return _ref.apply(this, arguments);
        };
    }();
    var executeBuiltInValidation = function() {
        var _ref = (0, $byzP8._)(function(fields, shouldOnlyCheckValid) {
            var context, _tmp, _tmp1, _i, _ref, name, field, _f, fieldValue, isFieldArrayRoot, fieldError, _tmp2;
            var _arguments = arguments;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        context = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {
                            valid: true
                        };
                        _tmp = [];
                        for(_tmp1 in fields)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            7
                        ];
                        _ref = _tmp[_i];
                        name = _ref;
                        field = fields[name];
                        if (!field) return [
                            3,
                            6
                        ];
                        _f = field._f, fieldValue = (0, $c4006311849aa271$export$69fdd232f62cde60)(field, [
                            "_f"
                        ]);
                        if (!_f) return [
                            3,
                            3
                        ];
                        isFieldArrayRoot = _names.array.has(_f.name);
                        return [
                            4,
                            $ba34d1ebd6528b77$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot)
                        ];
                    case 2:
                        fieldError = _state.sent();
                        if (fieldError[_f.name]) {
                            context.valid = false;
                            if (shouldOnlyCheckValid) return [
                                3,
                                7
                            ];
                        }
                        !shouldOnlyCheckValid && ($ba34d1ebd6528b77$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $ba34d1ebd6528b77$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $ba34d1ebd6528b77$var$unset(_formState.errors, _f.name));
                        _state.label = 3;
                    case 3:
                        _tmp2 = fieldValue;
                        if (!_tmp2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context)
                        ];
                    case 4:
                        _tmp2 = _state.sent();
                        _state.label = 5;
                    case 5:
                        _tmp2;
                        _state.label = 6;
                    case 6:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 7:
                        return [
                            2,
                            context.valid
                        ];
                }
            });
        });
        return function executeBuiltInValidation(fields, shouldOnlyCheckValid) {
            return _ref.apply(this, arguments);
        };
    }();
    var _removeUnmounted = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _names.unMount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                field && (field._f.refs ? field._f.refs.every(function(ref) {
                    return !$ba34d1ebd6528b77$var$live(ref);
                }) : !$ba34d1ebd6528b77$var$live(field._f.ref)) && unregister(name);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _names.unMount = new Set();
    };
    var _getDirty = function(name, data) {
        return name && data && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, data), !$ba34d1ebd6528b77$var$deepEqual(getValues(), _defaultValues);
    };
    var _getWatch = function(names, defaultValue, isGlobal) {
        return $ba34d1ebd6528b77$var$generateWatchOutput(names, _names, (0, $8OnJk._)({}, _state.mount ? _formValues : $ba34d1ebd6528b77$var$isUndefined(defaultValue) ? _defaultValues : $ba34d1ebd6528b77$var$isString(names) ? (0, $dxWQo._)({}, names, defaultValue) : defaultValue), isGlobal, defaultValue);
    };
    var _getFieldArray = function(name) {
        return $ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    };
    var setFieldValue = function(name, value1) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        var fieldValue = value1;
        if (field) {
            var fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, $ba34d1ebd6528b77$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $ba34d1ebd6528b77$var$isHTMLElement(fieldReference.ref) && $ba34d1ebd6528b77$var$isNullOrUndefined(value1) ? "" : value1;
                if ($ba34d1ebd6528b77$var$isMultipleSelect(fieldReference.ref)) (0, $fLnyw._)(fieldReference.ref.options).forEach(function(optionRef) {
                    return optionRef.selected = fieldValue.includes(optionRef.value);
                });
                else if (fieldReference.refs) {
                    if ($ba34d1ebd6528b77$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach(function(checkboxRef) {
                        return (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find(function(data) {
                            return data === checkboxRef.value;
                        }) : fieldValue === checkboxRef.value);
                    }) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach(function(radioRef) {
                        return radioRef.checked = radioRef.value === fieldValue;
                    });
                } else if ($ba34d1ebd6528b77$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: (0, $8OnJk._)({}, _formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    var setValues = function(name, value1, options) {
        for(var fieldKey in value1){
            var fieldValue = value1[fieldKey];
            var fieldName = "".concat(name, ".").concat(fieldKey);
            var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$ba34d1ebd6528b77$var$isPrimitive(fieldValue) || field && !field._f) && !$ba34d1ebd6528b77$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    var setValue = function(name, value1) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        var isFieldArray = _names.array.has(name);
        var cloneValue = $ba34d1ebd6528b77$var$cloneObject(value1);
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: (0, $8OnJk._)({}, _formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$ba34d1ebd6528b77$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $ba34d1ebd6528b77$var$isWatched(name, _names) && _subjects.state.next((0, $8OnJk._)({}, _formState));
        _subjects.values.next({
            name: name,
            values: (0, $8OnJk._)({}, _formValues)
        });
        !_state.mount && flushRootRender();
    };
    var onChange = function() {
        var _ref = (0, $byzP8._)(function(event) {
            var target, name, isFieldValueUpdated, field, getCurrentFieldValue, error, isValid, fieldValue, isBlurEvent, shouldSkipValidation, watched, fieldState, shouldRender, errors, previousErrorLookupResult, errorLookupResult;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = event.target;
                        name = target.name;
                        isFieldValueUpdated = true;
                        field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                        getCurrentFieldValue = function() {
                            return target.type ? $ba34d1ebd6528b77$var$getFieldValue(field._f) : $ba34d1ebd6528b77$var$getEventValue(event);
                        };
                        if (!field) return [
                            3,
                            7
                        ];
                        fieldValue = getCurrentFieldValue();
                        isBlurEvent = event.type === $ba34d1ebd6528b77$var$EVENTS.BLUR || event.type === $ba34d1ebd6528b77$var$EVENTS.FOCUS_OUT;
                        shouldSkipValidation = !$ba34d1ebd6528b77$var$hasValidation(field._f) && !_options.resolver && !$ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $ba34d1ebd6528b77$var$skipValidation(isBlurEvent, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
                        watched = $ba34d1ebd6528b77$var$isWatched(name, _names, isBlurEvent);
                        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
                        if (isBlurEvent) {
                            field._f.onBlur && field._f.onBlur(event);
                            delayErrorCallback && delayErrorCallback(0);
                        } else if (field._f.onChange) field._f.onChange(event);
                        fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
                        shouldRender = !$ba34d1ebd6528b77$var$isEmptyObject(fieldState) || watched;
                        !isBlurEvent && _subjects.values.next({
                            name: name,
                            type: event.type,
                            values: (0, $8OnJk._)({}, _formValues)
                        });
                        if (shouldSkipValidation) {
                            _proxyFormState.isValid && _updateValid();
                            return [
                                2,
                                shouldRender && _subjects.state.next((0, $8OnJk._)({
                                    name: name
                                }, watched ? {} : fieldState))
                            ];
                        }
                        !isBlurEvent && watched && _subjects.state.next((0, $8OnJk._)({}, _formState));
                        _updateIsValidating(true);
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _executeSchema([
                                name
                            ])
                        ];
                    case 1:
                        errors = _state.sent().errors;
                        previousErrorLookupResult = $ba34d1ebd6528b77$var$schemaErrorLookup(_formState.errors, _fields, name);
                        errorLookupResult = $ba34d1ebd6528b77$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                        error = errorLookupResult.error;
                        name = errorLookupResult.name;
                        isValid = $ba34d1ebd6528b77$var$isEmptyObject(errors);
                        return [
                            3,
                            6
                        ];
                    case 2:
                        return [
                            4,
                            $ba34d1ebd6528b77$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation)
                        ];
                    case 3:
                        error = _state.sent()[name];
                        isFieldValueUpdated = isNaN(fieldValue) || fieldValue === $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                        if (!isFieldValueUpdated) return [
                            3,
                            6
                        ];
                        if (!error) return [
                            3,
                            4
                        ];
                        isValid = false;
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!_proxyFormState.isValid) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            executeBuiltInValidation(_fields, true)
                        ];
                    case 5:
                        isValid = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (isFieldValueUpdated) {
                            field._f.deps && trigger(field._f.deps);
                            shouldRenderByError(name, isValid, error, fieldState);
                        }
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var trigger = function() {
        var _ref = (0, $byzP8._)(function(name) {
            var options, isValid, validationResult, fieldNames, errors;
            var _arguments = arguments;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        fieldNames = $ba34d1ebd6528b77$var$convertToArrayPayload(name);
                        _updateIsValidating(true);
                        if (!_options.resolver) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeSchemaAndUpdateState($ba34d1ebd6528b77$var$isUndefined(name) ? name : fieldNames)
                        ];
                    case 1:
                        errors = _state.sent();
                        isValid = $ba34d1ebd6528b77$var$isEmptyObject(errors);
                        validationResult = name ? !fieldNames.some(function(name) {
                            return $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
                        }) : isValid;
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!name) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            Promise.all(fieldNames.map(function() {
                                var _ref = (0, $byzP8._)(function(fieldName) {
                                    var field;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
                                                return [
                                                    4,
                                                    executeBuiltInValidation(field && field._f ? (0, $dxWQo._)({}, fieldName, field) : field)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(fieldName) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 3:
                        validationResult = _state.sent().every(Boolean);
                        !(!validationResult && !_formState.isValid) && _updateValid();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            executeBuiltInValidation(_fields)
                        ];
                    case 5:
                        validationResult = isValid = _state.sent();
                        _state.label = 6;
                    case 6:
                        _subjects.state.next((0, $8E768._)((0, $8OnJk._)({}, !$ba34d1ebd6528b77$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                            name: name
                        }, _options.resolver || !name ? {
                            isValid: isValid
                        } : {}), {
                            errors: _formState.errors,
                            isValidating: false
                        }));
                        options.shouldFocus && !validationResult && $ba34d1ebd6528b77$var$focusFieldBy(_fields, function(key) {
                            return key && $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, key);
                        }, name ? fieldNames : _names.mount);
                        return [
                            2,
                            validationResult
                        ];
                }
            });
        });
        return function trigger(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var getValues = function(fieldNames) {
        var values = (0, $8OnJk._)({}, _defaultValues, _state.mount ? _formValues : {});
        return $ba34d1ebd6528b77$var$isUndefined(fieldNames) ? values : $ba34d1ebd6528b77$var$isString(fieldNames) ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map(function(name) {
            return $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, name);
        });
    };
    var getFieldState = function(name, formState) {
        return {
            invalid: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).errors, name)
        };
    };
    var clearErrors = function(name) {
        name && $ba34d1ebd6528b77$var$convertToArrayPayload(name).forEach(function(inputName) {
            return $ba34d1ebd6528b77$var$unset(_formState.errors, inputName);
        });
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    var setError = function(name, error, options) {
        var ref = ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $8E768._)((0, $8OnJk._)({}, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    var watch = function(name, defaultValue) {
        return $ba34d1ebd6528b77$var$isFunction(name) ? _subjects.values.subscribe({
            next: function(payload) {
                return name(_getWatch(undefined, defaultValue), payload);
            }
        }) : _getWatch(name, defaultValue, true);
    };
    var unregister = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (name ? $ba34d1ebd6528b77$var$convertToArrayPayload(name) : _names.mount)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fieldName = _step.value;
                _names.mount.delete(fieldName);
                _names.array.delete(fieldName);
                if (!options.keepValue) {
                    $ba34d1ebd6528b77$var$unset(_fields, fieldName);
                    $ba34d1ebd6528b77$var$unset(_formValues, fieldName);
                }
                !options.keepError && $ba34d1ebd6528b77$var$unset(_formState.errors, fieldName);
                !options.keepDirty && $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && $ba34d1ebd6528b77$var$unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister && !options.keepDefaultValue && $ba34d1ebd6528b77$var$unset(_defaultValues, fieldName);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _subjects.values.next({
            values: (0, $8OnJk._)({}, _formValues)
        });
        _subjects.state.next((0, $8OnJk._)({}, _formState, !options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _updateValid();
    };
    var register = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        var disabledIsDefined = $ba34d1ebd6528b77$var$isBoolean(options.disabled);
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, (0, $8E768._)((0, $8OnJk._)({}, field || {}), {
            _f: (0, $8OnJk._)((0, $8E768._)((0, $8OnJk._)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        }));
        _names.mount.add(name);
        if (!$ba34d1ebd6528b77$var$isUndefined(options.value)) $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, options.value);
        field ? disabledIsDefined && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, $ba34d1ebd6528b77$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return (0, $8E768._)((0, $8OnJk._)({}, disabledIsDefined ? {
            disabled: options.disabled
        } : {}, _options.progressive ? {
            required: !!options.required,
            min: $ba34d1ebd6528b77$var$getRuleValue(options.min),
            max: $ba34d1ebd6528b77$var$getRuleValue(options.max),
            minLength: $ba34d1ebd6528b77$var$getRuleValue(options.minLength),
            maxLength: $ba34d1ebd6528b77$var$getRuleValue(options.maxLength),
            pattern: $ba34d1ebd6528b77$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: function(ref) {
                if (ref) {
                    register(name, options);
                    field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                    var fieldRef = $ba34d1ebd6528b77$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    var radioOrCheckbox = $ba34d1ebd6528b77$var$isRadioOrCheckbox(fieldRef);
                    var refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find(function(option) {
                        return option === fieldRef;
                    }) : fieldRef === field._f.ref) return;
                    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: (0, $8OnJk._)({}, field._f, radioOrCheckbox ? {
                            refs: (0, $fLnyw._)(refs.filter($ba34d1ebd6528b77$var$live)).concat([
                                fieldRef
                            ], (0, $fLnyw._)(Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                {}
                            ] : [])),
                            ref: {
                                type: fieldRef.type,
                                name: name
                            }
                        } : {
                            ref: fieldRef
                        })
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($ba34d1ebd6528b77$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        });
    };
    var _focusError = function() {
        return _options.shouldFocusError && $ba34d1ebd6528b77$var$focusFieldBy(_fields, function(key) {
            return key && $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, key);
        }, _names.mount);
    };
    var handleSubmit = function(onValid, onInvalid) {
        return function() {
            var _ref = (0, $byzP8._)(function(e) {
                var fieldValues, _ref, errors, values;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (e) {
                                e.preventDefault && e.preventDefault();
                                e.persist && e.persist();
                            }
                            fieldValues = $ba34d1ebd6528b77$var$cloneObject(_formValues);
                            _subjects.state.next({
                                isSubmitting: true
                            });
                            if (!_options.resolver) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _executeSchema()
                            ];
                        case 1:
                            _ref = _state.sent(), errors = _ref.errors, values = _ref.values;
                            _formState.errors = errors;
                            fieldValues = values;
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                executeBuiltInValidation(_fields)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            $ba34d1ebd6528b77$var$unset(_formState.errors, "root");
                            if (!$ba34d1ebd6528b77$var$isEmptyObject(_formState.errors)) return [
                                3,
                                6
                            ];
                            _subjects.state.next({
                                errors: {}
                            });
                            return [
                                4,
                                onValid(fieldValues, e)
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                9
                            ];
                        case 6:
                            if (!onInvalid) return [
                                3,
                                8
                            ];
                            return [
                                4,
                                onInvalid((0, $8OnJk._)({}, _formState.errors), e)
                            ];
                        case 7:
                            _state.sent();
                            _state.label = 8;
                        case 8:
                            _focusError();
                            setTimeout(_focusError);
                            _state.label = 9;
                        case 9:
                            _subjects.state.next({
                                isSubmitted: true,
                                isSubmitting: false,
                                isSubmitSuccessful: $ba34d1ebd6528b77$var$isEmptyObject(_formState.errors),
                                submitCount: _formState.submitCount + 1,
                                errors: _formState.errors
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
    };
    var resetField = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name)) {
            if ($ba34d1ebd6528b77$var$isUndefined(options.defaultValue)) setValue(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $ba34d1ebd6528b77$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $ba34d1ebd6528b77$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next((0, $8OnJk._)({}, _formState));
        }
    };
    var _reset = function(formValues) {
        var keepStateOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var updatedValues = formValues || _defaultValues;
        var cloneUpdatedValues = $ba34d1ebd6528b77$var$cloneObject(updatedValues);
        var values = formValues && !$ba34d1ebd6528b77$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) try {
                for(var _iterator = _names.mount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var fieldName = _step.value;
                    $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(values, fieldName, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, fieldName));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if ($ba34d1ebd6528b77$var$isWeb && $ba34d1ebd6528b77$var$isUndefined(formValues)) try {
                    for(var _iterator1 = _names.mount[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var name = _step1.value;
                        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                        if (field && field._f) {
                            var fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                            if ($ba34d1ebd6528b77$var$isHTMLElement(fieldReference)) {
                                var form = fieldReference.closest("form");
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $ba34d1ebd6528b77$var$cloneObject(_defaultValues) : {} : $ba34d1ebd6528b77$var$cloneObject(values);
            _subjects.array.next({
                values: (0, $8OnJk._)({}, values)
            });
            _subjects.values.next({
                values: (0, $8OnJk._)({}, values)
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$ba34d1ebd6528b77$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    var reset = function(formValues, keepStateOptions) {
        return _reset($ba34d1ebd6528b77$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    };
    var setFocus = function(name) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        var fieldReference = field && field._f;
        if (fieldReference) {
            var fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    var _updateFormState = function(updatedFormState) {
        _formState = (0, $8OnJk._)({}, _formState, updatedFormState);
    };
    var _resetDefaultValues = function() {
        return $ba34d1ebd6528b77$var$isFunction(_options.defaultValues) && _options.defaultValues().then(function(values) {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    };
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $8OnJk._)({}, _options, value);
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$87c0cf8eb5a167e0() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef();
    var _values = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef();
    var _React_useState = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $ba34d1ebd6528b77$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $ba34d1ebd6528b77$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    }), 2), formState = _React_useState[0], updateFormState = _React_useState[1];
    if (!_formControl.current) _formControl.current = (0, $8E768._)((0, $8OnJk._)({}, $ba34d1ebd6528b77$var$createFormControl(props, function() {
        return updateFormState(function(formState) {
            return (0, $8OnJk._)({}, formState);
        });
    })), {
        formState: formState
    });
    var control = _formControl.current.control;
    control._options = props;
    $ba34d1ebd6528b77$var$useSubscribe({
        subject: control._subjects.state,
        next: function(value1) {
            if ($ba34d1ebd6528b77$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState((0, $8OnJk._)({}, control._formState));
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        if (props.values && !$ba34d1ebd6528b77$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next((0, $8OnJk._)({}, control._formState));
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $ba34d1ebd6528b77$var$getProxyFormState(formState, control);
    return _formControl.current;
}



var $af2aa57f500dd80d$var$e = function e(i, _e, t) {
    if (i && "reportValidity" in i) {
        var f = (0, $ba34d1ebd6528b77$export$3988ae62b71be9a3)(t, _e);
        i.setCustomValidity(f && f.message || ""), i.reportValidity();
    }
}, $af2aa57f500dd80d$export$6bd436d70894afff = function t(r, i) {
    var t = function t(_t) {
        var f = i.fields[_t];
        f && f.ref && "reportValidity" in f.ref ? $af2aa57f500dd80d$var$e(f.ref, _t, r) : f.refs && f.refs.forEach(function(i) {
            return $af2aa57f500dd80d$var$e(i, _t, r);
        });
    };
    for(var f in i.fields)t(f);
}, $af2aa57f500dd80d$export$3cfb7e8a4d7a0630 = function f(e, _f) {
    _f.shouldUseNativeValidation && $af2aa57f500dd80d$export$6bd436d70894afff(e, _f);
    var o = {};
    for(var a in e){
        var n = (0, $ba34d1ebd6528b77$export$3988ae62b71be9a3)(_f.fields, a);
        (0, $ba34d1ebd6528b77$export$adaa4cf7ef1b65be)(o, a, Object.assign(e[a] || {}, {
            ref: n && n.ref
        }));
    }
    return o;
};


var $682e60b97368662c$var$n = function n(e, o) {
    for(var n = {}; e.length;){
        var t = e[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in t) {
                var u = t.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("unionErrors" in t && t.unionErrors.forEach(function(r) {
            return r.errors.forEach(function(r) {
                return e.push(r);
            });
        }), o) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $ba34d1ebd6528b77$export$b196c2a4f765bd30)(a, o, n, s, f ? [].concat(f, t.message) : t.message);
        }
        e.shift();
    }
    return n;
}, $682e60b97368662c$export$66b7b5879c70f722 = function t(r, _t, s) {
    return void 0 === s && (s = {}), function(i, a, u) {
        try {
            return Promise.resolve(function(o, n) {
                try {
                    var a = Promise.resolve(r["sync" === s.mode ? "parse" : "parseAsync"](i, _t)).then(function(r) {
                        return u.shouldUseNativeValidation && (0, $af2aa57f500dd80d$export$6bd436d70894afff)({}, u), {
                            errors: {},
                            values: s.raw ? i : r
                        };
                    });
                } catch (r) {
                    return n(r);
                }
                return a && a.then ? a.then(void 0, n) : a;
            }(0, function(r) {
                if (function(r) {
                    return null != r.errors;
                }(r)) return {
                    values: {},
                    errors: (0, $af2aa57f500dd80d$export$3cfb7e8a4d7a0630)($682e60b97368662c$var$n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
};




var $3vWwE = parcelRequire("3vWwE");

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $dxWQo = parcelRequire("dxWQo");

var $ftJVG = parcelRequire("ftJVG");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
var $bc80ebcf21bfccd0$export$7debb50ef11d5e0b;
(function(util) {
    var assertIs = function assertIs(_arg) {};
    var assertNever = function assertNever(_x) {
        throw new Error();
    };
    var joinValues = function joinValues(array) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
        return array.map(function(val) {
            return typeof val === "string" ? "'".concat(val, "'") : val;
        }).join(separator);
    };
    util.assertEqual = function(val) {
        return val;
    };
    util.assertIs = assertIs;
    util.assertNever = assertNever;
    util.arrayToEnum = function(items) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                obj[item] = item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    util.getValidEnumValues = function(obj) {
        var validKeys = util.objectKeys(obj).filter(function(k) {
            return typeof obj[obj[k]] !== "number";
        });
        var filtered = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                filtered[k] = obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return util.objectValues(filtered);
    };
    util.objectValues = function(obj) {
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? function(obj) {
        return Object.keys(obj) // eslint-disable-line ban/ban
        ;
    } : function(object) {
        var keys = [];
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = function(arr, checker) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (checker(item)) return item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? function(val) {
        return Number.isInteger(val) // eslint-disable-line ban/ban
        ;
    } : function(val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    };
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = function(_, value) {
        if ((typeof value === "undefined" ? "undefined" : (0, $1ObTH._)(value)) === "bigint") return value.toString();
        return value;
    };
})($bc80ebcf21bfccd0$export$7debb50ef11d5e0b || ($bc80ebcf21bfccd0$export$7debb50ef11d5e0b = {}));
var $bc80ebcf21bfccd0$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = function(first, second) {
        return (0, $8OnJk._)({}, first, second);
    };
})($bc80ebcf21bfccd0$export$4aa2142c225fd5c7 || ($bc80ebcf21bfccd0$export$4aa2142c225fd5c7 = {}));
var $bc80ebcf21bfccd0$export$5716da67bfaa244d = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
var $bc80ebcf21bfccd0$export$3e9057828ebd5c7a = function(data) {
    var t = typeof data === "undefined" ? "undefined" : (0, $1ObTH._)(data);
    switch(t){
        case "undefined":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined;
        case "string":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan : $bc80ebcf21bfccd0$export$5716da67bfaa244d.number;
        case "boolean":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean;
        case "function":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.function;
        case "bigint":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.array;
            if (data === null) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.date;
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.object;
        default:
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.unknown;
    }
};
var $bc80ebcf21bfccd0$export$5ba560653e4a1035 = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var $bc80ebcf21bfccd0$export$913eddeaf297cfea = function(obj) {
    var json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
var $bc80ebcf21bfccd0$export$f98dac4b251ab333 = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $ftJVG._)(ZodError, Error1);
    var _super = (0, $6OZAO._)(ZodError);
    function ZodError(issues) {
        (0, $978gY._)(this, ZodError);
        var _this;
        _this = _super.call(this);
        _this.issues = [];
        _this.addIssue = function(sub) {
            _this.issues = (0, $fLnyw._)(_this.issues).concat([
                sub
            ]);
        };
        _this.addIssues = function() {
            var subs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            _this.issues = (0, $fLnyw._)(_this.issues).concat((0, $fLnyw._)(subs));
        };
        var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf((0, $3vWwE._)(_this), actualProto);
        else _this.__proto__ = actualProto;
        _this.name = "ZodError";
        _this.issues = issues;
        return _this;
    }
    (0, $kry2a._)(ZodError, [
        {
            key: "errors",
            get: function get() {
                return this.issues;
            }
        },
        {
            key: "format",
            value: function format(_mapper) {
                var mapper = _mapper || function(issue) {
                    return issue.message;
                };
                var fieldErrors = {
                    _errors: []
                };
                var processError = function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = error.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var issue = _step.value;
                            if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                            else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                            else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                            else {
                                var curr = fieldErrors;
                                var i = 0;
                                while(i < issue.path.length){
                                    var el = issue.path[i];
                                    var terminal = i === issue.path.length - 1;
                                    if (!terminal) curr[el] = curr[el] || {
                                        _errors: []
                                    };
                                    else {
                                        curr[el] = curr[el] || {
                                            _errors: []
                                        };
                                        curr[el]._errors.push(mapper(issue));
                                    }
                                    curr = curr[el];
                                    i++;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                processError(this);
                return fieldErrors;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: "message",
            get: function get() {
                return JSON.stringify(this.issues, $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.issues.length === 0;
            }
        },
        {
            key: "flatten",
            value: function flatten() {
                var mapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(issue) {
                    return issue.message;
                };
                var fieldErrors = {};
                var formErrors = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (sub.path.length > 0) {
                            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                            fieldErrors[sub.path[0]].push(mapper(sub));
                        } else formErrors.push(mapper(sub));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    formErrors: formErrors,
                    fieldErrors: fieldErrors
                };
            }
        },
        {
            key: "formErrors",
            get: function get() {
                return this.flatten();
            }
        }
    ]);
    return ZodError;
}((0, $2TMdq._)(Error));
$bc80ebcf21bfccd0$export$f98dac4b251ab333.create = function(issues) {
    var error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333(issues);
    return error;
};
var $bc80ebcf21bfccd0$export$341b0b6e0a6f5099 = function(issue, _ctx) {
    var message;
    switch(issue.code){
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) message = "Required";
            else message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_literal:
            message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.jsonStringifyReplacer));
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.unrecognized_keys:
            message = "Unrecognized key(s) in object: ".concat($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.keys, ", "));
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union:
            message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union_discriminator:
            message = "Invalid discriminator value. Expected ".concat($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.options));
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value:
            message = "Invalid enum value. Expected ".concat($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.options), ", received '").concat(issue.received, "'");
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_return_type:
            message = "Invalid function return type";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_date:
            message = "Invalid date";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = 'Invalid input: must include "'.concat(issue.validation.includes, '"');
                    if (typeof issue.validation.position === "number") message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
                } else if ("startsWith" in issue.validation) message = 'Invalid input: must start with "'.concat(issue.validation.startsWith, '"');
                else if ("endsWith" in issue.validation) message = 'Invalid input: must end with "'.concat(issue.validation.endsWith, '"');
                else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = "Invalid ".concat(issue.validation);
            else message = "Invalid";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));
            else message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));
            else message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.custom:
            message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_intersection_types:
            message = "Intersection results could not be merged";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of:
            message = "Number must be a multiple of ".concat(issue.multipleOf);
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
var $bc80ebcf21bfccd0$var$overrideErrorMap = $bc80ebcf21bfccd0$export$341b0b6e0a6f5099;
function $bc80ebcf21bfccd0$export$1097a8289cfd22d7(map) {
    $bc80ebcf21bfccd0$var$overrideErrorMap = map;
}
function $bc80ebcf21bfccd0$export$32f27c719778d4c4() {
    return $bc80ebcf21bfccd0$var$overrideErrorMap;
}
var $bc80ebcf21bfccd0$export$244a85fde9c419ed = function(params) {
    var data = params.data, path = params.path, errorMaps = params.errorMaps, issueData = params.issueData;
    var fullPath = (0, $fLnyw._)(path).concat((0, $fLnyw._)(issueData.path || []));
    var fullIssue = (0, $8E768._)((0, $8OnJk._)({}, issueData), {
        path: fullPath
    });
    var errorMessage = "";
    var maps = errorMaps.filter(function(m) {
        return !!m;
    }).slice().reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = maps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var map = _step.value;
            errorMessage = map(fullIssue, {
                data: data,
                defaultError: errorMessage
            }).message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $8E768._)((0, $8OnJk._)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
var $bc80ebcf21bfccd0$export$1526d2e05f74572 = [];
function $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, issueData) {
    var issue = $bc80ebcf21bfccd0$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
            $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
        ].filter(function(x) {
            return !!x;
        })
    });
    ctx.common.issues.push(issue);
}
var $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f = /*#__PURE__*/ function() {
    "use strict";
    function ParseStatus() {
        (0, $978gY._)(this, ParseStatus);
        this.value = "valid";
    }
    (0, $kry2a._)(ParseStatus, [
        {
            key: "dirty",
            value: function dirty() {
                if (this.value === "valid") this.value = "dirty";
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.value !== "aborted") this.value = "aborted";
            }
        }
    ], [
        {
            key: "mergeArray",
            value: function mergeArray(status, results) {
                var arrayValue = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if (s.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (s.status === "dirty") status.dirty();
                        arrayValue.push(s.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: arrayValue
                };
            }
        },
        {
            key: "mergeObjectAsync",
            value: function mergeObjectAsync(status, pairs) {
                return (0, $byzP8._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, _, _tmp, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                _ = syncPairs.push;
                                _tmp = {};
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                _tmp.key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    ParseStatus.mergeObjectSync(status, syncPairs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mergeObjectSync",
            value: function mergeObjectSync(status, pairs) {
                var finalObject = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pair = _step.value;
                        var key = pair.key, value = pair.value;
                        if (key.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (key.status === "dirty") status.dirty();
                        if (value.status === "dirty") status.dirty();
                        if (typeof value.value !== "undefined" || pair.alwaysSet) finalObject[key.value] = value.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: finalObject
                };
            }
        }
    ]);
    return ParseStatus;
}();
var $bc80ebcf21bfccd0$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
var $bc80ebcf21bfccd0$export$325a211da9693fcf = function(value) {
    return {
        status: "dirty",
        value: value
    };
};
var $bc80ebcf21bfccd0$export$c6813a8d51f77eaf = function(value) {
    return {
        status: "valid",
        value: value
    };
};
var $bc80ebcf21bfccd0$export$afa861e3c5730743 = function(x) {
    return x.status === "aborted";
};
var $bc80ebcf21bfccd0$export$910b6cdd390341b3 = function(x) {
    return x.status === "dirty";
};
var $bc80ebcf21bfccd0$export$1ea939691cdc45b8 = function(x) {
    return x.status === "valid";
};
var $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e = function(x) {
    return typeof Promise !== "undefined" && x instanceof Promise;
};
var $bc80ebcf21bfccd0$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = function(message) {
        return typeof message === "string" ? {
            message: message
        } : message || {};
    };
    errorUtil.toString = function(message) {
        return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
    };
})($bc80ebcf21bfccd0$var$errorUtil || ($bc80ebcf21bfccd0$var$errorUtil = {}));
var $bc80ebcf21bfccd0$var$ParseInputLazyPath = /*#__PURE__*/ function() {
    "use strict";
    function ParseInputLazyPath(parent, value, path, key) {
        (0, $978gY._)(this, ParseInputLazyPath);
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    (0, $kry2a._)(ParseInputLazyPath, [
        {
            key: "path",
            get: function get() {
                if (!this._cachedPath.length) {
                    var _this__cachedPath, _this__cachedPath1;
                    if (this._key instanceof Array) (_this__cachedPath = this._cachedPath).push.apply(_this__cachedPath, (0, $fLnyw._)(this._path).concat((0, $fLnyw._)(this._key)));
                    else (_this__cachedPath1 = this._cachedPath).push.apply(_this__cachedPath1, (0, $fLnyw._)(this._path).concat([
                        this._key
                    ]));
                }
                return this._cachedPath;
            }
        }
    ]);
    return ParseInputLazyPath;
}();
var $bc80ebcf21bfccd0$var$handleResult = function(ctx, result) {
    if ($bc80ebcf21bfccd0$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                var error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $bc80ebcf21bfccd0$var$processCreateParams(params) {
    if (!params) return {};
    var errorMap = params.errorMap, invalid_type_error = params.invalid_type_error, required_error = params.required_error, description = params.description;
    if (errorMap && (invalid_type_error || required_error)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    var customMap = function(iss, ctx) {
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
var $bc80ebcf21bfccd0$export$19342e026b58ebb7 = /*#__PURE__*/ function() {
    "use strict";
    function ZodType(def) {
        (0, $978gY._)(this, ZodType);
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    (0, $kry2a._)(ZodType, [
        {
            key: "description",
            get: function get() {
                return this._def.description;
            }
        },
        {
            key: "_getType",
            value: function _getType(input) {
                return $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data);
            }
        },
        {
            key: "_getOrReturnCtx",
            value: function _getOrReturnCtx(input, ctx) {
                return ctx || {
                    common: input.parent.common,
                    data: input.data,
                    parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data),
                    schemaErrorMap: this._def.errorMap,
                    path: input.path,
                    parent: input.parent
                };
            }
        },
        {
            key: "_processInputParams",
            value: function _processInputParams(input) {
                return {
                    status: new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f(),
                    ctx: {
                        common: input.parent.common,
                        data: input.data,
                        parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data),
                        schemaErrorMap: this._def.errorMap,
                        path: input.path,
                        parent: input.parent
                    }
                };
            }
        },
        {
            key: "_parseSync",
            value: function _parseSync(input) {
                var result = this._parse(input);
                if ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
                return result;
            }
        },
        {
            key: "_parseAsync",
            value: function _parseAsync(input) {
                var result = this._parse(input);
                return Promise.resolve(result);
            }
        },
        {
            key: "parse",
            value: function parse(data, params) {
                var result = this.safeParse(data, params);
                if (result.success) return result.data;
                throw result.error;
            }
        },
        {
            key: "safeParse",
            value: function safeParse(data, params) {
                var _a;
                var ctx = {
                    common: {
                        issues: [],
                        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
                    },
                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                    schemaErrorMap: this._def.errorMap,
                    parent: null,
                    data: data,
                    parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(data)
                };
                var result = this._parseSync({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
                return $bc80ebcf21bfccd0$var$handleResult(ctx, result);
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(data, params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safeParseAsync(data, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.success) return [
                                    2,
                                    result.data
                                ];
                                throw result.error;
                        }
                    });
                })();
            }
        },
        {
            key: "safeParseAsync",
            value: function safeParseAsync(data, params) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var ctx, maybeAsyncResult, result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ctx = {
                                    common: {
                                        issues: [],
                                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                                        async: true
                                    },
                                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                                    schemaErrorMap: _this._def.errorMap,
                                    parent: null,
                                    data: data,
                                    parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(data)
                                };
                                maybeAsyncResult = _this._parse({
                                    data: data,
                                    path: ctx.path,
                                    parent: ctx
                                });
                                return [
                                    4,
                                    $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    $bc80ebcf21bfccd0$var$handleResult(ctx, result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refine",
            value: function refine(check, message) {
                var getIssueProperties = function(val) {
                    if (typeof message === "string" || typeof message === "undefined") return {
                        message: message
                    };
                    else if (typeof message === "function") return message(val);
                    else return message;
                };
                return this._refinement(function(val, ctx) {
                    var result = check(val);
                    var setError = function() {
                        return ctx.addIssue((0, $8OnJk._)({
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.custom
                        }, getIssueProperties(val)));
                    };
                    if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(data) {
                        if (!data) {
                            setError();
                            return false;
                        } else return true;
                    });
                    if (!result) {
                        setError();
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "refinement",
            value: function refinement(check, refinementData) {
                return this._refinement(function(val, ctx) {
                    if (!check(val)) {
                        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "_refinement",
            value: function _refinement(refinement) {
                return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582({
                    schema: this,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
                    effect: {
                        type: "refinement",
                        refinement: refinement
                    }
                });
            }
        },
        {
            key: "superRefine",
            value: function superRefine(refinement) {
                return this._refinement(refinement);
            }
        },
        {
            key: "optional",
            value: function optional() {
                return $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create(this, this._def);
            }
        },
        {
            key: "nullable",
            value: function nullable() {
                return $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create(this, this._def);
            }
        },
        {
            key: "nullish",
            value: function nullish() {
                return this.nullable().optional();
            }
        },
        {
            key: "array",
            value: function array() {
                return $bc80ebcf21bfccd0$export$7acfc3e64785411.create(this, this._def);
            }
        },
        {
            key: "promise",
            value: function promise() {
                return $bc80ebcf21bfccd0$export$3f196b0127d6e50a.create(this, this._def);
            }
        },
        {
            key: "or",
            value: function or(option) {
                return $bc80ebcf21bfccd0$export$a8b236cb5070a311.create([
                    this,
                    option
                ], this._def);
            }
        },
        {
            key: "and",
            value: function and(incoming) {
                return $bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create(this, incoming, this._def);
            }
        },
        {
            key: "transform",
            value: function transform(transform) {
                return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582((0, $8E768._)((0, $8OnJk._)({}, $bc80ebcf21bfccd0$var$processCreateParams(this._def)), {
                    schema: this,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
                    effect: {
                        type: "transform",
                        transform: transform
                    }
                }));
            }
        },
        {
            key: "default",
            value: function _default(def) {
                var defaultValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new $bc80ebcf21bfccd0$export$bb19b37874861e7e((0, $8E768._)((0, $8OnJk._)({}, $bc80ebcf21bfccd0$var$processCreateParams(this._def)), {
                    innerType: this,
                    defaultValue: defaultValueFunc,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDefault
                }));
            }
        },
        {
            key: "brand",
            value: function brand() {
                return new $bc80ebcf21bfccd0$export$66b0c798a395271f((0, $8OnJk._)({
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBranded,
                    type: this
                }, $bc80ebcf21bfccd0$var$processCreateParams(this._def)));
            }
        },
        {
            key: "catch",
            value: function _catch(def) {
                var catchValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new $bc80ebcf21bfccd0$export$75a44ec6249ac76b((0, $8E768._)((0, $8OnJk._)({}, $bc80ebcf21bfccd0$var$processCreateParams(this._def)), {
                    innerType: this,
                    catchValue: catchValueFunc,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodCatch
                }));
            }
        },
        {
            key: "describe",
            value: function describe(description) {
                var This = this.constructor;
                return new This((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    description: description
                }));
            }
        },
        {
            key: "pipe",
            value: function pipe(target) {
                return $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da.create(this, target);
            }
        },
        {
            key: "isOptional",
            value: function isOptional() {
                return this.safeParse(undefined).success;
            }
        },
        {
            key: "isNullable",
            value: function isNullable() {
                return this.safeParse(null).success;
            }
        }
    ]);
    return ZodType;
}();
var $bc80ebcf21bfccd0$var$cuidRegex = /^c[^\s-]{8,}$/i;
var $bc80ebcf21bfccd0$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
var $bc80ebcf21bfccd0$var$ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
var $bc80ebcf21bfccd0$var$uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
var $bc80ebcf21bfccd0$var$emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
var $bc80ebcf21bfccd0$var$emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
var $bc80ebcf21bfccd0$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var $bc80ebcf21bfccd0$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
var $bc80ebcf21bfccd0$var$datetimeRegex = function(args) {
    if (args.precision) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}(([+-]\\d{2}(:?\\d{2})?)|Z)$"));
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}Z$"));
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$");
    } else {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
    }
};
function $bc80ebcf21bfccd0$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $bc80ebcf21bfccd0$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $bc80ebcf21bfccd0$var$ipv6Regex.test(ip)) return true;
    return false;
}
var $bc80ebcf21bfccd0$export$1230eb29b8d3b502 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodString, ZodType);
    var _super = (0, $6OZAO._)(ZodString);
    function ZodString() {
        (0, $978gY._)(this, ZodString);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._regex = function(regex, validation, message) {
            return _this.refinement(function(data) {
                return regex.test(data);
            }, (0, $8OnJk._)({
                validation: validation,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string
            }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
        };
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */ _this.nonempty = function(message) {
            return _this.min(1, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message));
        };
        _this.trim = function() {
            return new ZodString((0, $8E768._)((0, $8OnJk._)({}, _this._def), {
                checks: (0, $fLnyw._)(_this._def.checks).concat([
                    {
                        kind: "trim"
                    }
                ])
            }));
        };
        _this.toLowerCase = function() {
            return new ZodString((0, $8E768._)((0, $8OnJk._)({}, _this._def), {
                checks: (0, $fLnyw._)(_this._def.checks).concat([
                    {
                        kind: "toLowerCase"
                    }
                ])
            }));
        };
        _this.toUpperCase = function() {
            return new ZodString((0, $8E768._)((0, $8OnJk._)({}, _this._def), {
                checks: (0, $fLnyw._)(_this._def.checks).concat([
                    {
                        kind: "toUpperCase"
                    }
                ])
            }));
        };
        return _this;
    }
    (0, $kry2a._)(ZodString, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = String(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.string) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.string,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var ctx1 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.length < check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.length > check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "length") {
                            var tooBig = input.data.length > check.value;
                            var tooSmall = input.data.length < check.value;
                            if (tooBig || tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                if (tooBig) $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                else if (tooSmall) $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "email") {
                            if (!$bc80ebcf21bfccd0$var$emailRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "email",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "emoji") {
                            if (!$bc80ebcf21bfccd0$var$emojiRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "emoji",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "uuid") {
                            if (!$bc80ebcf21bfccd0$var$uuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "uuid",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid") {
                            if (!$bc80ebcf21bfccd0$var$cuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "cuid",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid2") {
                            if (!$bc80ebcf21bfccd0$var$cuid2Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "cuid2",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ulid") {
                            if (!$bc80ebcf21bfccd0$var$ulidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "ulid",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "url") try {
                            new URL(input.data);
                        } catch (_a) {
                            ctx1 = this._getOrReturnCtx(input, ctx1);
                            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                validation: "url",
                                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                message: check.message
                            });
                            status.dirty();
                        }
                        else if (check.kind === "regex") {
                            check.regex.lastIndex = 0;
                            var testResult = check.regex.test(input.data);
                            if (!testResult) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "regex",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "trim") input.data = input.data.trim();
                        else if (check.kind === "includes") {
                            if (!input.data.includes(check.value, check.position)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        includes: check.value,
                                        position: check.position
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
                        else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
                        else if (check.kind === "startsWith") {
                            if (!input.data.startsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        startsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "endsWith") {
                            if (!input.data.endsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: {
                                        endsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "datetime") {
                            var regex = $bc80ebcf21bfccd0$var$datetimeRegex(check);
                            if (!regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    validation: "datetime",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ip") {
                            if (!$bc80ebcf21bfccd0$var$isValidIP(input.data, check.version)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    validation: "ip",
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodString((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "email",
            value: function email(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "email"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "url",
            value: function url(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "url"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "emoji",
            value: function emoji(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "emoji"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "uuid",
            value: function uuid(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "uuid"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid",
            value: function cuid(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "cuid"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid2",
            value: function cuid2(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "cuid2"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "ulid",
            value: function ulid(message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "ulid"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "ip",
            value: function ip(options) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "ip"
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(options)));
            }
        },
        {
            key: "datetime",
            value: function datetime(options) {
                var _a;
                if (typeof options === "string") return this._addCheck({
                    kind: "datetime",
                    precision: null,
                    offset: false,
                    message: options
                });
                return this._addCheck((0, $8OnJk._)({
                    kind: "datetime",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
                    offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "regex",
            value: function regex(regex, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "regex",
                    regex: regex
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "includes",
            value: function includes(value, options) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "includes",
                    value: value,
                    position: options === null || options === void 0 ? void 0 : options.position
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "startsWith",
            value: function startsWith(value, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "startsWith",
                    value: value
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "endsWith",
            value: function endsWith(value, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "endsWith",
                    value: value
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "min",
                    value: minLength
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "max",
                    value: maxLength
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return this._addCheck((0, $8OnJk._)({
                    kind: "length",
                    value: len
                }, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message)));
            }
        },
        {
            key: "isDatetime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "datetime";
                });
            }
        },
        {
            key: "isEmail",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "email";
                });
            }
        },
        {
            key: "isURL",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "url";
                });
            }
        },
        {
            key: "isEmoji",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "emoji";
                });
            }
        },
        {
            key: "isUUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "uuid";
                });
            }
        },
        {
            key: "isCUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid";
                });
            }
        },
        {
            key: "isCUID2",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid2";
                });
            }
        },
        {
            key: "isULID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ulid";
                });
            }
        },
        {
            key: "isIP",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ip";
                });
            }
        },
        {
            key: "minLength",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxLength",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodString;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$1230eb29b8d3b502.create = function(params) {
    var _a;
    return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502((0, $8OnJk._)({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $bc80ebcf21bfccd0$var$floatSafeRemainder(val, step) {
    var valDecCount = (val.toString().split(".")[1] || "").length;
    var stepDecCount = (step.toString().split(".")[1] || "").length;
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
var $bc80ebcf21bfccd0$export$5b070a55c0c43e09 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNumber, ZodType);
    var _super = (0, $6OZAO._)(ZodNumber);
    function ZodNumber() {
        (0, $978gY._)(this, ZodNumber);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        _this.step = _this.multipleOf;
        return _this;
    }
    (0, $kry2a._)(ZodNumber, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Number(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.number) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.number,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var ctx1 = undefined;
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "int") {
                            if (!$bc80ebcf21bfccd0$export$7debb50ef11d5e0b.isInteger(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                                    expected: "integer",
                                    received: "float",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    minimum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    maximum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if ($bc80ebcf21bfccd0$var$floatSafeRemainder(input.data, check.value) !== 0) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "finite") {
                            if (!Number.isFinite(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_finite,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodNumber((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodNumber((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "int",
            value: function int(message) {
                return this._addCheck({
                    kind: "int",
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "finite",
            value: function finite(message) {
                return this._addCheck({
                    kind: "finite",
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "safe",
            value: function safe(message) {
                return this._addCheck({
                    kind: "min",
                    inclusive: true,
                    value: Number.MIN_SAFE_INTEGER,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                })._addCheck({
                    kind: "max",
                    inclusive: true,
                    value: Number.MAX_SAFE_INTEGER,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        },
        {
            key: "isInt",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "int" || ch.kind === "multipleOf" && $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.isInteger(ch.value);
                });
            }
        },
        {
            key: "isFinite",
            get: function get() {
                var max = null, min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
                        else if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        } else if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Number.isFinite(min) && Number.isFinite(max);
            }
        }
    ]);
    return ZodNumber;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$5b070a55c0c43e09.create = function(params) {
    return new $bc80ebcf21bfccd0$export$5b070a55c0c43e09((0, $8OnJk._)({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$67d741fd70ff98f4 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodBigInt, ZodType);
    var _super = (0, $6OZAO._)(ZodBigInt);
    function ZodBigInt() {
        (0, $978gY._)(this, ZodBigInt);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        return _this;
    }
    (0, $kry2a._)(ZodBigInt, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = BigInt(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var ctx1 = undefined;
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    type: "bigint",
                                    minimum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    type: "bigint",
                                    maximum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (input.data % check.value !== BigInt(0)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodBigInt((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodBigInt((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: false,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: true,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodBigInt;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$67d741fd70ff98f4.create = function(params) {
    var _a;
    return new $bc80ebcf21bfccd0$export$67d741fd70ff98f4((0, $8OnJk._)({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$723d146f80596191 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodBoolean, ZodType);
    var _super = (0, $6OZAO._)(ZodBoolean);
    function ZodBoolean() {
        (0, $978gY._)(this, ZodBoolean);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodBoolean, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Boolean(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodBoolean;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$723d146f80596191.create = function(params) {
    return new $bc80ebcf21bfccd0$export$723d146f80596191((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$e974be33bdc55521 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodDate, ZodType);
    var _super = (0, $6OZAO._)(ZodDate);
    function ZodDate() {
        (0, $978gY._)(this, ZodDate);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodDate, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = new Date(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.date) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.date,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (isNaN(input.data.getTime())) {
                    var ctx1 = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_date
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
                var ctx2 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.getTime() < check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx2, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    minimum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.getTime() > check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx2, {
                                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    maximum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: new Date(input.data.getTime())
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodDate((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    checks: (0, $fLnyw._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "min",
            value: function min(minDate, message) {
                return this._addCheck({
                    kind: "min",
                    value: minDate.getTime(),
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "max",
            value: function max(maxDate, message) {
                return this._addCheck({
                    kind: "max",
                    value: maxDate.getTime(),
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                });
            }
        },
        {
            key: "minDate",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min != null ? new Date(min) : null;
            }
        },
        {
            key: "maxDate",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max != null ? new Date(max) : null;
            }
        }
    ]);
    return ZodDate;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$e974be33bdc55521.create = function(params) {
    return new $bc80ebcf21bfccd0$export$e974be33bdc55521((0, $8OnJk._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDate
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$bcc3b40f6b638044 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodSymbol, ZodType);
    var _super = (0, $6OZAO._)(ZodSymbol);
    function ZodSymbol() {
        (0, $978gY._)(this, ZodSymbol);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodSymbol, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodSymbol;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$bcc3b40f6b638044.create = function(params) {
    return new $bc80ebcf21bfccd0$export$bcc3b40f6b638044((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodSymbol
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$4e780e961c30340d = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodUndefined, ZodType);
    var _super = (0, $6OZAO._)(ZodUndefined);
    function ZodUndefined() {
        (0, $978gY._)(this, ZodUndefined);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodUndefined, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodUndefined;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$4e780e961c30340d.create = function(params) {
    return new $bc80ebcf21bfccd0$export$4e780e961c30340d((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUndefined
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a96281f914484f2d = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNull, ZodType);
    var _super = (0, $6OZAO._)(ZodNull);
    function ZodNull() {
        (0, $978gY._)(this, ZodNull);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNull, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.null) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.null,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodNull;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$a96281f914484f2d.create = function(params) {
    return new $bc80ebcf21bfccd0$export$a96281f914484f2d((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNull
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodAny, ZodType);
    var _super = (0, $6OZAO._)(ZodAny);
    function ZodAny() {
        (0, $978gY._)(this, ZodAny);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        _this._any = true;
        return _this;
    }
    (0, $kry2a._)(ZodAny, [
        {
            key: "_parse",
            value: function _parse(input) {
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodAny;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create = function(params) {
    return new $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodAny
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$ef3b1bb1630977ae = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodUnknown, ZodType);
    var _super = (0, $6OZAO._)(ZodUnknown);
    function ZodUnknown() {
        (0, $978gY._)(this, ZodUnknown);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // required
        _this._unknown = true;
        return _this;
    }
    (0, $kry2a._)(ZodUnknown, [
        {
            key: "_parse",
            value: function _parse(input) {
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodUnknown;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create = function(params) {
    return new $bc80ebcf21bfccd0$export$ef3b1bb1630977ae((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUnknown
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNever, ZodType);
    var _super = (0, $6OZAO._)(ZodNever);
    function ZodNever() {
        (0, $978gY._)(this, ZodNever);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNever, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._getOrReturnCtx(input);
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                    expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.never,
                    received: ctx.parsedType
                });
                return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            }
        }
    ]);
    return ZodNever;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create = function(params) {
    return new $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNever
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$7d39f5df85f21031 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodVoid, ZodType);
    var _super = (0, $6OZAO._)(ZodVoid);
    function ZodVoid() {
        (0, $978gY._)(this, ZodVoid);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodVoid, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.void,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        }
    ]);
    return ZodVoid;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$7d39f5df85f21031.create = function(params) {
    return new $bc80ebcf21bfccd0$export$7d39f5df85f21031((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodVoid
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$7acfc3e64785411 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodArray, ZodType);
    var _super = (0, $6OZAO._)(ZodArray);
    function ZodArray() {
        (0, $978gY._)(this, ZodArray);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodArray, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), ctx = _this__processInputParams.ctx, status = _this__processInputParams.status;
                var def = this._def;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.array,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (def.exactLength !== null) {
                    var tooBig = ctx.data.length > def.exactLength.value;
                    var tooSmall = ctx.data.length < def.exactLength.value;
                    if (tooBig || tooSmall) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: tooBig ? $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big : $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                            minimum: tooSmall ? def.exactLength.value : undefined,
                            maximum: tooBig ? def.exactLength.value : undefined,
                            type: "array",
                            inclusive: true,
                            exact: true,
                            message: def.exactLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.minLength !== null) {
                    if (ctx.data.length < def.minLength.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                            minimum: def.minLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.minLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxLength !== null) {
                    if (ctx.data.length > def.maxLength.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                            maximum: def.maxLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.maxLength.message
                        });
                        status.dirty();
                    }
                }
                if (ctx.common.async) return Promise.all((0, $fLnyw._)(ctx.data).map(function(item, i) {
                    return def.type._parseAsync(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                })).then(function(result) {
                    return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, result);
                });
                var result = (0, $fLnyw._)(ctx.data).map(function(item, i) {
                    return def.type._parseSync(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, result);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.type;
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return new ZodArray((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    minLength: {
                        value: minLength,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return new ZodArray((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    maxLength: {
                        value: maxLength,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return new ZodArray((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    exactLength: {
                        value: len,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodArray;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$7acfc3e64785411.create = function(schema, params) {
    return new $bc80ebcf21bfccd0$export$7acfc3e64785411((0, $8OnJk._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodArray
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
function $bc80ebcf21bfccd0$var$deepPartialify(schema) {
    if (schema instanceof $bc80ebcf21bfccd0$export$736315c5b55efbad) {
        var newShape = {};
        for(var key in schema.shape){
            var fieldSchema = schema.shape[key];
            newShape[key] = $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create($bc80ebcf21bfccd0$var$deepPartialify(fieldSchema));
        }
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8E768._)((0, $8OnJk._)({}, schema._def), {
            shape: function() {
                return newShape;
            }
        }));
    } else if (schema instanceof $bc80ebcf21bfccd0$export$7acfc3e64785411) return new $bc80ebcf21bfccd0$export$7acfc3e64785411((0, $8E768._)((0, $8OnJk._)({}, schema._def), {
        type: $bc80ebcf21bfccd0$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8) return $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create($bc80ebcf21bfccd0$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bc80ebcf21bfccd0$export$aaac0b8b429cef5) return $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create($bc80ebcf21bfccd0$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3) return $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create(schema.items.map(function(item) {
        return $bc80ebcf21bfccd0$var$deepPartialify(item);
    }));
    else return schema;
}
var $bc80ebcf21bfccd0$export$736315c5b55efbad = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodObject, ZodType);
    var _super = (0, $6OZAO._)(ZodObject);
    function ZodObject() {
        (0, $978gY._)(this, ZodObject);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ _this.nonstrict = _this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ _this.augment = _this.extend;
        return _this;
    }
    (0, $kry2a._)(ZodObject, [
        {
            key: "_getCached",
            value: function _getCached() {
                if (this._cached !== null) return this._cached;
                var shape = this._def.shape();
                var keys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(shape);
                return this._cached = {
                    shape: shape,
                    keys: keys
                };
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx1 = _this__processInputParams.ctx;
                var _this__getCached = this._getCached(), shape = _this__getCached.shape, shapeKeys = _this__getCached.keys;
                var extraKeys = [];
                if (!(this._def.catchall instanceof $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
                    for(var key in ctx1.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
                }
                var pairs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = shapeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        var keyValidator = shape[key1];
                        var value = ctx1.data[key1];
                        pairs.push({
                            key: {
                                status: "valid",
                                value: key1
                            },
                            value: keyValidator._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx1, value, ctx1.path, key1)),
                            alwaysSet: key1 in ctx1.data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._def.catchall instanceof $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5) {
                    var unknownKeys = this._def.unknownKeys;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (unknownKeys === "passthrough") try {
                        for(var _iterator1 = extraKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key2 = _step1.value;
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key2
                                },
                                value: {
                                    status: "valid",
                                    value: ctx1.data[key2]
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (unknownKeys === "strict") {
                        if (extraKeys.length > 0) {
                            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.unrecognized_keys,
                                keys: extraKeys
                            });
                            status.dirty();
                        }
                    } else if (unknownKeys === "strip") ;
                    else throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                } else {
                    // run catchall validation
                    var catchall = this._def.catchall;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = extraKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var key3 = _step2.value;
                            var value1 = ctx1.data[key3];
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key3
                                },
                                value: catchall._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx1, value1, ctx1.path, key3) //, ctx.child(key), value, getParsedType(value)
                                ),
                                alwaysSet: key3 in ctx1.data
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                if (ctx1.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $byzP8._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, _, _tmp, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                _ = syncPairs.push;
                                _tmp = {
                                    key: key
                                };
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp.alwaysSet = pair.alwaysSet, _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    syncPairs
                                ];
                        }
                    });
                })).then(function(syncPairs) {
                    return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
                });
                else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "shape",
            get: function get() {
                return this._def.shape();
            }
        },
        {
            key: "strict",
            value: function strict(message) {
                var _this = this;
                $bc80ebcf21bfccd0$var$errorUtil.errToObj;
                return new ZodObject((0, $8OnJk._)((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    unknownKeys: "strict"
                }), message !== undefined ? {
                    errorMap: function(issue, ctx) {
                        var _a, _b, _c, _d;
                        var defaultError = (_c = (_b = (_a = _this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys") return {
                            message: (_d = $bc80ebcf21bfccd0$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                        };
                        return {
                            message: defaultError
                        };
                    }
                } : {}));
            }
        },
        {
            key: "strip",
            value: function strip() {
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    unknownKeys: "strip"
                }));
            }
        },
        {
            key: "passthrough",
            value: function passthrough() {
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    unknownKeys: "passthrough"
                }));
            }
        },
        {
            // const AugmentFactory =
            //   <Def extends ZodObjectDef>(def: Def) =>
            //   <Augmentation extends ZodRawShape>(
            //     augmentation: Augmentation
            //   ): ZodObject<
            //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
            //     Def["unknownKeys"],
            //     Def["catchall"]
            //   > => {
            //     return new ZodObject({
            //       ...def,
            //       shape: () => ({
            //         ...def.shape(),
            //         ...augmentation,
            //       }),
            //     }) as any;
            //   };
            key: "extend",
            value: function extend(augmentation) {
                var _this = this;
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return (0, $8OnJk._)({}, _this._def.shape(), augmentation);
                    }
                }));
            }
        },
        {
            /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ key: "merge",
            value: function merge(merging) {
                var _this = this;
                var merged = new ZodObject({
                    unknownKeys: merging._def.unknownKeys,
                    catchall: merging._def.catchall,
                    shape: function() {
                        return (0, $8OnJk._)({}, _this._def.shape(), merging._def.shape());
                    },
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
                });
                return merged;
            }
        },
        {
            // merge<
            //   Incoming extends AnyZodObject,
            //   Augmentation extends Incoming["shape"],
            //   NewOutput extends {
            //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
            //       ? Augmentation[k]["_output"]
            //       : k extends keyof Output
            //       ? Output[k]
            //       : never;
            //   },
            //   NewInput extends {
            //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
            //       ? Augmentation[k]["_input"]
            //       : k extends keyof Input
            //       ? Input[k]
            //       : never;
            //   }
            // >(
            //   merging: Incoming
            // ): ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"],
            //   NewOutput,
            //   NewInput
            // > {
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "setKey",
            value: function setKey(key, schema) {
                return this.augment((0, $dxWQo._)({}, key, schema));
            }
        },
        {
            // merge<Incoming extends AnyZodObject>(
            //   merging: Incoming
            // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
            // ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"]
            // > {
            //   // const mergedShape = objectUtil.mergeShapes(
            //   //   this._def.shape(),
            //   //   merging._def.shape()
            //   // );
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "catchall",
            value: function catchall(index) {
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    catchall: index
                }));
            }
        },
        {
            key: "pick",
            value: function pick(mask) {
                var _this = this;
                var shape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(mask).forEach(function(key) {
                    if (mask[key] && _this.shape[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            key: "omit",
            value: function omit(mask) {
                var _this = this;
                var shape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    if (!mask[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            /**
     * @deprecated
     */ key: "deepPartial",
            value: function deepPartial() {
                return $bc80ebcf21bfccd0$var$deepPartialify(this);
            }
        },
        {
            key: "partial",
            value: function partial(mask) {
                var _this = this;
                var newShape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    var fieldSchema = _this.shape[key];
                    if (mask && !mask[key]) newShape[key] = fieldSchema;
                    else newShape[key] = fieldSchema.optional();
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "required",
            value: function required(mask) {
                var _this = this;
                var newShape = {};
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach(function(key) {
                    if (mask && !mask[key]) newShape[key] = _this.shape[key];
                    else {
                        var fieldSchema = _this.shape[key];
                        var newField = fieldSchema;
                        while(newField instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                        newShape[key] = newField;
                    }
                });
                return new ZodObject((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "keyof",
            value: function keyof() {
                return $bc80ebcf21bfccd0$var$createZodEnum($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape));
            }
        }
    ]);
    return ZodObject;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$736315c5b55efbad.create = function(shape, params) {
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8OnJk._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strip",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
$bc80ebcf21bfccd0$export$736315c5b55efbad.strictCreate = function(shape, params) {
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8OnJk._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strict",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
$bc80ebcf21bfccd0$export$736315c5b55efbad.lazycreate = function(shape, params) {
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad((0, $8OnJk._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a8b236cb5070a311 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodUnion, ZodType);
    var _super = (0, $6OZAO._)(ZodUnion);
    function ZodUnion() {
        (0, $978gY._)(this, ZodUnion);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var handleResults = function handleResults(results) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // return first issue-free validation if it exists
                        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var result = _step.value;
                            if (result.result.status === "valid") return result.result;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var result1 = _step1.value;
                            if (result1.result.status === "dirty") {
                                var // add issues from dirty option
                                _ctx_common_issues;
                                (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $fLnyw._)(result1.ctx.common.issues));
                                return result1.result;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // return invalid
                    var unionErrors = results.map(function(result) {
                        return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(result.ctx.common.issues);
                    });
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union,
                        unionErrors: unionErrors
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                };
                var ctx = this._processInputParams(input).ctx;
                var options = this._def.options;
                if (ctx.common.async) return Promise.all(options.map(function() {
                    var _ref = (0, $byzP8._)(function(option) {
                        var childCtx, _tmp;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    childCtx = (0, $8E768._)((0, $8OnJk._)({}, ctx), {
                                        common: (0, $8E768._)((0, $8OnJk._)({}, ctx.common), {
                                            issues: []
                                        }),
                                        parent: null
                                    });
                                    _tmp = {};
                                    return [
                                        4,
                                        option._parseAsync({
                                            data: ctx.data,
                                            path: ctx.path,
                                            parent: childCtx
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_tmp.result = _state.sent(), _tmp.ctx = childCtx, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(option) {
                        return _ref.apply(this, arguments);
                    };
                }())).then(handleResults);
                else {
                    var dirty = undefined;
                    var issues = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            var childCtx = (0, $8E768._)((0, $8OnJk._)({}, ctx), {
                                common: (0, $8E768._)((0, $8OnJk._)({}, ctx.common), {
                                    issues: []
                                }),
                                parent: null
                            });
                            var result = option._parseSync({
                                data: ctx.data,
                                path: ctx.path,
                                parent: childCtx
                            });
                            if (result.status === "valid") return result;
                            else if (result.status === "dirty" && !dirty) dirty = {
                                result: result,
                                ctx: childCtx
                            };
                            if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (dirty) {
                        var _ctx_common_issues;
                        (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $fLnyw._)(dirty.ctx.common.issues));
                        return dirty.result;
                    }
                    var unionErrors = issues.map(function(issues) {
                        return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(issues);
                    });
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union,
                        unionErrors: unionErrors
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        }
    ]);
    return ZodUnion;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$a8b236cb5070a311.create = function(types, params) {
    return new $bc80ebcf21bfccd0$export$a8b236cb5070a311((0, $8OnJk._)({
        options: types,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUnion
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
var $bc80ebcf21bfccd0$var$getDiscriminator = function(type) {
    if (type instanceof $bc80ebcf21bfccd0$export$378d0cfce37406e6) return $bc80ebcf21bfccd0$var$getDiscriminator(type.schema);
    else if (type instanceof $bc80ebcf21bfccd0$export$a60af00cc0ce2582) return $bc80ebcf21bfccd0$var$getDiscriminator(type.innerType());
    else if (type instanceof $bc80ebcf21bfccd0$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $bc80ebcf21bfccd0$export$bb19b37874861e7e) return $bc80ebcf21bfccd0$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $bc80ebcf21bfccd0$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
var $bc80ebcf21bfccd0$export$5ef2424805ac76a3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodDiscriminatedUnion, ZodType);
    var _super = (0, $6OZAO._)(ZodDiscriminatedUnion);
    function ZodDiscriminatedUnion() {
        (0, $978gY._)(this, ZodDiscriminatedUnion);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodDiscriminatedUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var discriminator = this.discriminator;
                var discriminatorValue = ctx.data[discriminator];
                var option = this.optionsMap.get(discriminatorValue);
                if (!option) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union_discriminator,
                        options: Array.from(this.optionsMap.keys()),
                        path: [
                            discriminator
                        ]
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (ctx.common.async) return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                else return option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "discriminator",
            get: function get() {
                return this._def.discriminator;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        },
        {
            key: "optionsMap",
            get: function get() {
                return this._def.optionsMap;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ function create(discriminator, options, params) {
                // Get all the valid discriminator values
                var optionsMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        var discriminatorValues = $bc80ebcf21bfccd0$var$getDiscriminator(type.shape[discriminator]);
                        if (!discriminatorValues) throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = discriminatorValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                if (optionsMap.has(value)) throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
                                optionsMap.set(value, type);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ZodDiscriminatedUnion((0, $8OnJk._)({
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDiscriminatedUnion,
                    discriminator: discriminator,
                    options: options,
                    optionsMap: optionsMap
                }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
            }
        }
    ]);
    return ZodDiscriminatedUnion;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
function $bc80ebcf21bfccd0$var$mergeValues(a, b) {
    var aType = $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(a);
    var bType = $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.object && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
        var bKeys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(b);
        var sharedKeys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(a).filter(function(key) {
            return bKeys.indexOf(key) !== -1;
        });
        var newObj = (0, $8OnJk._)({}, a, b);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sharedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var sharedValue = $bc80ebcf21bfccd0$var$mergeValues(a[key], b[key]);
                if (!sharedValue.valid) return {
                    valid: false
                };
                newObj[key] = sharedValue.data;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.array && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        var newArray = [];
        for(var index = 0; index < a.length; index++){
            var itemA = a[index];
            var itemB = b[index];
            var sharedValue1 = $bc80ebcf21bfccd0$var$mergeValues(itemA, itemB);
            if (!sharedValue1.valid) return {
                valid: false
            };
            newArray.push(sharedValue1.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.date && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
var $bc80ebcf21bfccd0$export$c02deaf0bb5203d4 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodIntersection, ZodType);
    var _super = (0, $6OZAO._)(ZodIntersection);
    function ZodIntersection() {
        (0, $978gY._)(this, ZodIntersection);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodIntersection, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var handleParsed = function(parsedLeft, parsedRight) {
                    if ($bc80ebcf21bfccd0$export$afa861e3c5730743(parsedLeft) || $bc80ebcf21bfccd0$export$afa861e3c5730743(parsedRight)) return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    var merged = $bc80ebcf21bfccd0$var$mergeValues(parsedLeft.value, parsedRight.value);
                    if (!merged.valid) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_intersection_types
                        });
                        return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    }
                    if ($bc80ebcf21bfccd0$export$910b6cdd390341b3(parsedLeft) || $bc80ebcf21bfccd0$export$910b6cdd390341b3(parsedRight)) status.dirty();
                    return {
                        status: status.value,
                        value: merged.data
                    };
                };
                if (ctx.common.async) return Promise.all([
                    this._def.left._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }),
                    this._def.right._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    })
                ]).then(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), left = _param[0], right = _param[1];
                    return handleParsed(left, right);
                });
                else return handleParsed(this._def.left._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }), this._def.right._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }));
            }
        }
    ]);
    return ZodIntersection;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create = function(left, right, params) {
    return new $bc80ebcf21bfccd0$export$c02deaf0bb5203d4((0, $8OnJk._)({
        left: left,
        right: right,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodIntersection
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodTuple, ZodType);
    var _super = (0, $6OZAO._)(ZodTuple);
    function ZodTuple() {
        (0, $978gY._)(this, ZodTuple);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodTuple, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.array,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (ctx.data.length < this._def.items.length) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        minimum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var rest = this._def.rest;
                if (!rest && ctx.data.length > this._def.items.length) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        maximum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    status.dirty();
                }
                var items = (0, $fLnyw._)(ctx.data).map(function(item, itemIndex) {
                    var schema = _this._def.items[itemIndex] || _this._def.rest;
                    if (!schema) return null;
                    return schema._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
                }).filter(function(x) {
                    return !!x;
                }); // filter nulls
                if (ctx.common.async) return Promise.all(items).then(function(results) {
                    return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, results);
                });
                else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, items);
            }
        },
        {
            key: "items",
            get: function get() {
                return this._def.items;
            }
        },
        {
            key: "rest",
            value: function rest(rest) {
                return new ZodTuple((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    rest: rest
                }));
            }
        }
    ]);
    return ZodTuple;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create = function(schemas, params) {
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3((0, $8OnJk._)({
        items: schemas,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a2acc09968cb4b7f = /*#__PURE__*/ function(ZodType1) {
    "use strict";
    (0, $ftJVG._)(ZodRecord, ZodType1);
    var _super = (0, $6OZAO._)(ZodRecord);
    function ZodRecord() {
        (0, $978gY._)(this, ZodRecord);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodRecord, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var pairs = [];
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                for(var key in ctx.data)pairs.push({
                    key: keyType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
                    value: valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
                });
                if (ctx.common.async) return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
                else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.valueType;
            }
        }
    ], [
        {
            key: "create",
            value: function create(first, second, third) {
                if (second instanceof $bc80ebcf21bfccd0$export$19342e026b58ebb7) return new ZodRecord((0, $8OnJk._)({
                    keyType: first,
                    valueType: second,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodRecord
                }, $bc80ebcf21bfccd0$var$processCreateParams(third)));
                return new ZodRecord((0, $8OnJk._)({
                    keyType: $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create(),
                    valueType: first,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodRecord
                }, $bc80ebcf21bfccd0$var$processCreateParams(second)));
            }
        }
    ]);
    return ZodRecord;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$163b6a2b712d9542 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodMap, ZodType);
    var _super = (0, $6OZAO._)(ZodMap);
    function ZodMap() {
        (0, $978gY._)(this, ZodMap);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodMap, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.map) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.map,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                var pairs = (0, $fLnyw._)(ctx.data.entries()).map(function(param, index) {
                    var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
                    return {
                        key: keyType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, key, ctx.path, [
                            index,
                            "key"
                        ])),
                        value: valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, value, ctx.path, [
                            index,
                            "value"
                        ]))
                    };
                });
                if (ctx.common.async) {
                    var finalMap = new Map();
                    return Promise.resolve().then(/*#__PURE__*/ (0, $byzP8._)(function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = pairs[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    pair = _step.value;
                                    return [
                                        4,
                                        pair.key
                                    ];
                                case 3:
                                    key = _state.sent();
                                    return [
                                        4,
                                        pair.value
                                    ];
                                case 4:
                                    value = _state.sent();
                                    if (key.status === "aborted" || value.status === "aborted") return [
                                        2,
                                        $bc80ebcf21bfccd0$export$9a105a556e65c2c0
                                    ];
                                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                                    finalMap.set(key.value, value.value);
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        {
                                            status: status.value,
                                            value: finalMap
                                        }
                                    ];
                            }
                        });
                    }));
                } else {
                    var finalMap1 = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var key = pair.key;
                            var value = pair.value;
                            if (key.status === "aborted" || value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                            if (key.status === "dirty" || value.status === "dirty") status.dirty();
                            finalMap1.set(key.value, value.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: finalMap1
                    };
                }
            }
        }
    ]);
    return ZodMap;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$163b6a2b712d9542.create = function(keyType, valueType, params) {
    return new $bc80ebcf21bfccd0$export$163b6a2b712d9542((0, $8OnJk._)({
        valueType: valueType,
        keyType: keyType,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodMap
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$977057706f816712 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodSet, ZodType);
    var _super = (0, $6OZAO._)(ZodSet);
    function ZodSet() {
        (0, $978gY._)(this, ZodSet);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodSet, [
        {
            key: "_parse",
            value: function _parse(input) {
                var finalizeSet = function finalizeSet(elements) {
                    var parsedSet = new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (element.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                            if (element.status === "dirty") status.dirty();
                            parsedSet.add(element.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: parsedSet
                    };
                };
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.set) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.set,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var def = this._def;
                if (def.minSize !== null) {
                    if (ctx.data.size < def.minSize.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                            minimum: def.minSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.minSize.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxSize !== null) {
                    if (ctx.data.size > def.maxSize.value) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                            maximum: def.maxSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.maxSize.message
                        });
                        status.dirty();
                    }
                }
                var valueType = this._def.valueType;
                var elements = (0, $fLnyw._)(ctx.data.values()).map(function(item, i) {
                    return valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                if (ctx.common.async) return Promise.all(elements).then(function(elements) {
                    return finalizeSet(elements);
                });
                else return finalizeSet(elements);
            }
        },
        {
            key: "min",
            value: function min(minSize, message) {
                return new ZodSet((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    minSize: {
                        value: minSize,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxSize, message) {
                return new ZodSet((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    maxSize: {
                        value: maxSize,
                        message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "size",
            value: function size(size, message) {
                return this.min(size, message).max(size, message);
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodSet;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$977057706f816712.create = function(valueType, params) {
    return new $bc80ebcf21bfccd0$export$977057706f816712((0, $8OnJk._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodSet
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$d4602ba55673f53c = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodFunction, ZodType);
    var _super = (0, $6OZAO._)(ZodFunction);
    function ZodFunction() {
        (0, $978gY._)(this, ZodFunction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.validate = _this.implement;
        return _this;
    }
    (0, $kry2a._)(ZodFunction, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var makeArgsIssue = function makeArgsIssue(args, error) {
                    return $bc80ebcf21bfccd0$export$244a85fde9c419ed({
                        data: args,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
                            $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_arguments,
                            argumentsError: error
                        }
                    });
                };
                var makeReturnsIssue = function makeReturnsIssue(returns, error) {
                    return $bc80ebcf21bfccd0$export$244a85fde9c419ed({
                        data: returns,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
                            $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_return_type,
                            returnTypeError: error
                        }
                    });
                };
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.function) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.function,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var params = {
                    errorMap: ctx.common.contextualErrorMap
                };
                var fn = ctx.data;
                var _this1 = this;
                if (this._def.returns instanceof $bc80ebcf21bfccd0$export$3f196b0127d6e50a) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(/*#__PURE__*/ (0, $byzP8._)(function() {
                    var _len, args, _key, error, parsedArgs, result, parsedReturns;
                    var _arguments = arguments;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                    args[_key] = _arguments[_key];
                                }
                                error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333([]);
                                return [
                                    4,
                                    _this1._def.args.parseAsync(args, params).catch(function(e) {
                                        error.addIssue(makeArgsIssue(args, e));
                                        throw error;
                                    })
                                ];
                            case 1:
                                parsedArgs = _state.sent();
                                return [
                                    4,
                                    fn.apply(void 0, (0, $fLnyw._)(parsedArgs))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    4,
                                    _this1._def.returns._def.type.parseAsync(result, params).catch(function(e) {
                                        error.addIssue(makeReturnsIssue(result, e));
                                        throw error;
                                    })
                                ];
                            case 3:
                                parsedReturns = _state.sent();
                                return [
                                    2,
                                    parsedReturns
                                ];
                        }
                    });
                }));
                else return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var parsedArgs = _this._def.args.safeParse(args, params);
                    if (!parsedArgs.success) throw new $bc80ebcf21bfccd0$export$f98dac4b251ab333([
                        makeArgsIssue(args, parsedArgs.error)
                    ]);
                    var result = fn.apply(void 0, (0, $fLnyw._)(parsedArgs.data));
                    var parsedReturns = _this._def.returns.safeParse(result, params);
                    if (!parsedReturns.success) throw new $bc80ebcf21bfccd0$export$f98dac4b251ab333([
                        makeReturnsIssue(result, parsedReturns.error)
                    ]);
                    return parsedReturns.data;
                });
            }
        },
        {
            key: "parameters",
            value: function parameters() {
                return this._def.args;
            }
        },
        {
            key: "returnType",
            value: function returnType() {
                return this._def.returns;
            }
        },
        {
            key: "args",
            value: function args() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new ZodFunction((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    args: $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create(items).rest($bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create())
                }));
            }
        },
        {
            key: "returns",
            value: function returns(returnType) {
                return new ZodFunction((0, $8E768._)((0, $8OnJk._)({}, this._def), {
                    returns: returnType
                }));
            }
        },
        {
            key: "implement",
            value: function implement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        },
        {
            key: "strictImplement",
            value: function strictImplement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        }
    ], [
        {
            key: "create",
            value: function create(args, returns, params) {
                return new ZodFunction((0, $8OnJk._)({
                    args: args ? args : $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create([]).rest($bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create()),
                    returns: returns || $bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create(),
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodFunction
                }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
            }
        }
    ]);
    return ZodFunction;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$378d0cfce37406e6 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodLazy, ZodType);
    var _super = (0, $6OZAO._)(ZodLazy);
    function ZodLazy() {
        (0, $978gY._)(this, ZodLazy);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodLazy, [
        {
            key: "schema",
            get: function get() {
                return this._def.getter();
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var lazySchema = this._def.getter();
                return lazySchema._parse({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        }
    ]);
    return ZodLazy;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$378d0cfce37406e6.create = function(getter, params) {
    return new $bc80ebcf21bfccd0$export$378d0cfce37406e6((0, $8OnJk._)({
        getter: getter,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodLazy
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$7e44096782a165d3 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodLiteral, ZodType);
    var _super = (0, $6OZAO._)(ZodLiteral);
    function ZodLiteral() {
        (0, $978gY._)(this, ZodLiteral);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodLiteral, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (input.data !== this._def.value) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        received: ctx.data,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_literal,
                        expected: this._def.value
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this._def.value;
            }
        }
    ]);
    return ZodLiteral;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$7e44096782a165d3.create = function(value, params) {
    return new $bc80ebcf21bfccd0$export$7e44096782a165d3((0, $8OnJk._)({
        value: value,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodLiteral
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
function $bc80ebcf21bfccd0$var$createZodEnum(values, params) {
    return new $bc80ebcf21bfccd0$export$d325d1f0e1c20179((0, $8OnJk._)({
        values: values,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEnum
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
}
var $bc80ebcf21bfccd0$export$d325d1f0e1c20179 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodEnum, ZodType);
    var _super = (0, $6OZAO._)(ZodEnum);
    function ZodEnum() {
        (0, $978gY._)(this, ZodEnum);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (typeof input.data !== "string") {
                    var ctx = this._getOrReturnCtx(input);
                    var expectedValues = this._def.values;
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        expected: $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (this._def.values.indexOf(input.data) === -1) {
                    var ctx1 = this._getOrReturnCtx(input);
                    var expectedValues1 = this._def.values;
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx1, {
                        received: ctx1.data,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value,
                        options: expectedValues1
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.values;
            }
        },
        {
            key: "enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Values",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "extract",
            value: function extract(values) {
                return ZodEnum.create(values);
            }
        },
        {
            key: "exclude",
            value: function exclude(values) {
                return ZodEnum.create(this.options.filter(function(opt) {
                    return !values.includes(opt);
                }));
            }
        }
    ]);
    return ZodEnum;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$d325d1f0e1c20179.create = $bc80ebcf21bfccd0$var$createZodEnum;
var $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNativeEnum, ZodType);
    var _super = (0, $6OZAO._)(ZodNativeEnum);
    function ZodNativeEnum() {
        (0, $978gY._)(this, ZodNativeEnum);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNativeEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                var nativeEnumValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
                var ctx = this._getOrReturnCtx(input);
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.string && ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.number) {
                    var expectedValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        expected: $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                if (nativeEnumValues.indexOf(input.data) === -1) {
                    var expectedValues1 = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        received: ctx.data,
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value,
                        options: expectedValues1
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
            }
        },
        {
            key: "enum",
            get: function get() {
                return this._def.values;
            }
        }
    ]);
    return ZodNativeEnum;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$370b2e8d6d6f5c56.create = function(values, params) {
    return new $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56((0, $8OnJk._)({
        values: values,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNativeEnum
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$3f196b0127d6e50a = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodPromise, ZodType);
    var _super = (0, $6OZAO._)(ZodPromise);
    function ZodPromise() {
        (0, $978gY._)(this, ZodPromise);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodPromise, [
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise && ctx.common.async === false) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                var promisified = ctx.parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
                return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(promisified.then(function(data) {
                    return _this._def.type.parseAsync(data, {
                        path: ctx.path,
                        errorMap: ctx.common.contextualErrorMap
                    });
                }));
            }
        }
    ]);
    return ZodPromise;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$3f196b0127d6e50a.create = function(schema, params) {
    return new $bc80ebcf21bfccd0$export$3f196b0127d6e50a((0, $8OnJk._)({
        type: schema,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodPromise
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$a60af00cc0ce2582 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodEffects, ZodType);
    var _super = (0, $6OZAO._)(ZodEffects);
    function ZodEffects() {
        (0, $978gY._)(this, ZodEffects);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodEffects, [
        {
            key: "innerType",
            value: function innerType() {
                return this._def.schema;
            }
        },
        {
            key: "sourceType",
            value: function sourceType() {
                return this._def.schema._def.typeName === $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var effect = this._def.effect || null;
                if (effect.type === "preprocess") {
                    var processed = effect.transform(ctx.data);
                    if (ctx.common.async) return Promise.resolve(processed).then(function(processed) {
                        return _this._def.schema._parseAsync({
                            data: processed,
                            path: ctx.path,
                            parent: ctx
                        });
                    });
                    else return this._def.schema._parseSync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx
                    });
                }
                var checkCtx = {
                    addIssue: function(arg) {
                        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, arg);
                        if (arg.fatal) status.abort();
                        else status.dirty();
                    },
                    get path () {
                        return ctx.path;
                    }
                };
                checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
                if (effect.type === "refinement") {
                    var executeRefinement = function(acc) {
                        var result = effect.refinement(acc, checkCtx);
                        if (ctx.common.async) return Promise.resolve(result);
                        if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                        return acc;
                    };
                    if (ctx.common.async === false) {
                        var inner = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (inner.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (inner.status === "dirty") status.dirty();
                        // return value is ignored
                        executeRefinement(inner.value);
                        return {
                            status: status.value,
                            value: inner.value
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(inner) {
                        if (inner.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                        if (inner.status === "dirty") status.dirty();
                        return executeRefinement(inner.value).then(function() {
                            return {
                                status: status.value,
                                value: inner.value
                            };
                        });
                    });
                }
                if (effect.type === "transform") {
                    if (ctx.common.async === false) {
                        var base = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (!$bc80ebcf21bfccd0$export$1ea939691cdc45b8(base)) return base;
                        var result = effect.transform(base.value, checkCtx);
                        if (result instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                        return {
                            status: status.value,
                            value: result
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(base) {
                        if (!$bc80ebcf21bfccd0$export$1ea939691cdc45b8(base)) return base;
                        return Promise.resolve(effect.transform(base.value, checkCtx)).then(function(result) {
                            return {
                                status: status.value,
                                value: result
                            };
                        });
                    });
                }
                $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(effect);
            }
        }
    ]);
    return ZodEffects;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$a60af00cc0ce2582.create = function(schema, effect, params) {
    return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582((0, $8OnJk._)({
        schema: schema,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
$bc80ebcf21bfccd0$export$a60af00cc0ce2582.createWithPreprocess = function(preprocess, schema, params) {
    return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582((0, $8OnJk._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$aa56fec1e9d629b8 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodOptional, ZodType);
    var _super = (0, $6OZAO._)(ZodOptional);
    function ZodOptional() {
        (0, $978gY._)(this, ZodOptional);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodOptional, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(undefined);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodOptional;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$aa56fec1e9d629b8((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodOptional
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$aaac0b8b429cef5 = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNullable, ZodType);
    var _super = (0, $6OZAO._)(ZodNullable);
    function ZodNullable() {
        (0, $978gY._)(this, ZodNullable);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNullable, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.null) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(null);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodNullable;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$aaac0b8b429cef5.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$aaac0b8b429cef5((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNullable
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$bb19b37874861e7e = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodDefault, ZodType);
    var _super = (0, $6OZAO._)(ZodDefault);
    function ZodDefault() {
        (0, $978gY._)(this, ZodDefault);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodDefault, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                if (ctx.parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
                return this._def.innerType._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "removeDefault",
            value: function removeDefault() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodDefault;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$bb19b37874861e7e.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$bb19b37874861e7e((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : function() {
            return params.default;
        }
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$75a44ec6249ac76b = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodCatch, ZodType);
    var _super = (0, $6OZAO._)(ZodCatch);
    function ZodCatch() {
        (0, $978gY._)(this, ZodCatch);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodCatch, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                // newCtx is used to not collect issues from inner types in ctx
                var newCtx = (0, $8E768._)((0, $8OnJk._)({}, ctx), {
                    common: (0, $8E768._)((0, $8OnJk._)({}, ctx.common), {
                        issues: []
                    })
                });
                var result = this._def.innerType._parse({
                    data: newCtx.data,
                    path: newCtx.path,
                    parent: (0, $8OnJk._)({}, newCtx)
                });
                if ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result)) return result.then(function(result) {
                    return {
                        status: "valid",
                        value: result.status === "valid" ? result.value : _this._def.catchValue({
                            get error () {
                                return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(newCtx.common.issues);
                            },
                            input: newCtx.data
                        })
                    };
                });
                else return {
                    status: "valid",
                    value: result.status === "valid" ? result.value : this._def.catchValue({
                        get error () {
                            return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(newCtx.common.issues);
                        },
                        input: newCtx.data
                    })
                };
            }
        },
        {
            key: "removeCatch",
            value: function removeCatch() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodCatch;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$75a44ec6249ac76b.create = function(type, params) {
    return new $bc80ebcf21bfccd0$export$75a44ec6249ac76b((0, $8OnJk._)({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : function() {
            return params.catch;
        }
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$26ccfa0145e8511f = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodNaN, ZodType);
    var _super = (0, $6OZAO._)(ZodNaN);
    function ZodNaN() {
        (0, $978gY._)(this, ZodNaN);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodNaN, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan) {
                    var ctx = this._getOrReturnCtx(input);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan,
                        received: ctx.parsedType
                    });
                    return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        }
    ]);
    return ZodNaN;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
$bc80ebcf21bfccd0$export$26ccfa0145e8511f.create = function(params) {
    return new $bc80ebcf21bfccd0$export$26ccfa0145e8511f((0, $8OnJk._)({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNaN
    }, $bc80ebcf21bfccd0$var$processCreateParams(params)));
};
var $bc80ebcf21bfccd0$export$cf2deea74cde46b4 = Symbol("zod_brand");
var $bc80ebcf21bfccd0$export$66b0c798a395271f = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodBranded, ZodType);
    var _super = (0, $6OZAO._)(ZodBranded);
    function ZodBranded() {
        (0, $978gY._)(this, ZodBranded);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodBranded, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                return this._def.type._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        }
    ]);
    return ZodBranded;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $ftJVG._)(ZodPipeline, ZodType);
    var _super = (0, $6OZAO._)(ZodPipeline);
    function ZodPipeline() {
        (0, $978gY._)(this, ZodPipeline);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ZodPipeline, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.common.async) {
                    var _this = this;
                    var handleAsync = function() {
                        var _ref = (0, $byzP8._)(function() {
                            var inResult;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this._def.in._parseAsync({
                                                data: ctx.data,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        inResult = _state.sent();
                                        if (inResult.status === "aborted") return [
                                            2,
                                            $bc80ebcf21bfccd0$export$9a105a556e65c2c0
                                        ];
                                        if (inResult.status === "dirty") {
                                            status.dirty();
                                            return [
                                                2,
                                                $bc80ebcf21bfccd0$export$325a211da9693fcf(inResult.value)
                                            ];
                                        } else return [
                                            2,
                                            _this._def.out._parseAsync({
                                                data: inResult.value,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleAsync() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return handleAsync();
                } else {
                    var inResult = this._def.in._parseSync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return {
                            status: "dirty",
                            value: inResult.value
                        };
                    } else return this._def.out._parseSync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(a, b) {
                return new ZodPipeline({
                    in: a,
                    out: b,
                    typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodPipeline
                });
            }
        }
    ]);
    return ZodPipeline;
}($bc80ebcf21bfccd0$export$19342e026b58ebb7);
var $bc80ebcf21bfccd0$export$4c00f665f0d4b443 = function(check) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, /*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal = arguments.length > 2 ? arguments[2] : void 0;
    if (check) return $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create().superRefine(function(data, ctx) {
        var _a, _b;
        if (!check(data)) {
            var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            var _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            var p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $8E768._)((0, $8OnJk._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create();
};
var $bc80ebcf21bfccd0$export$1ee8ee30835eab8b = {
    object: $bc80ebcf21bfccd0$export$736315c5b55efbad.lazycreate
};
var $bc80ebcf21bfccd0$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
})($bc80ebcf21bfccd0$export$558106ce543bd011 || ($bc80ebcf21bfccd0$export$558106ce543bd011 = {}));
var $bc80ebcf21bfccd0$export$3d916e7c22dbd8b5 = function(// const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        message: "Input not instance of ".concat(cls.name)
    };
    return $bc80ebcf21bfccd0$export$4c00f665f0d4b443(function(data) {
        return data instanceof cls;
    }, params);
};
var $bc80ebcf21bfccd0$export$22b082955e083ec3 = $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create;
var $bc80ebcf21bfccd0$export$98e628dec113755e = $bc80ebcf21bfccd0$export$5b070a55c0c43e09.create;
var $bc80ebcf21bfccd0$export$9e06de0973666692 = $bc80ebcf21bfccd0$export$26ccfa0145e8511f.create;
var $bc80ebcf21bfccd0$export$a0f65b52274bcc00 = $bc80ebcf21bfccd0$export$67d741fd70ff98f4.create;
var $bc80ebcf21bfccd0$export$4a21f16c33752377 = $bc80ebcf21bfccd0$export$723d146f80596191.create;
var $bc80ebcf21bfccd0$export$324d90190a8b822a = $bc80ebcf21bfccd0$export$e974be33bdc55521.create;
var $bc80ebcf21bfccd0$export$8f701197936bc2a6 = $bc80ebcf21bfccd0$export$bcc3b40f6b638044.create;
var $bc80ebcf21bfccd0$export$1db45310990710a5 = $bc80ebcf21bfccd0$export$4e780e961c30340d.create;
var $bc80ebcf21bfccd0$export$7b1b591b262c240 = $bc80ebcf21bfccd0$export$a96281f914484f2d.create;
var $bc80ebcf21bfccd0$export$4154a199d7d90455 = $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create;
var $bc80ebcf21bfccd0$export$19282c40b967aec6 = $bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create;
var $bc80ebcf21bfccd0$export$b3e22bcfd64c1022 = $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create;
var $bc80ebcf21bfccd0$export$490e536ee7389aeb = $bc80ebcf21bfccd0$export$7d39f5df85f21031.create;
var $bc80ebcf21bfccd0$export$2f23118c22fb2630 = $bc80ebcf21bfccd0$export$7acfc3e64785411.create;
var $bc80ebcf21bfccd0$export$be5493f9613cbbe = $bc80ebcf21bfccd0$export$736315c5b55efbad.create;
var $bc80ebcf21bfccd0$export$8fb0df5f40d0b477 = $bc80ebcf21bfccd0$export$736315c5b55efbad.strictCreate;
var $bc80ebcf21bfccd0$export$971dd5b0dfd021b6 = $bc80ebcf21bfccd0$export$a8b236cb5070a311.create;
var $bc80ebcf21bfccd0$export$4b888e40c4ee26dd = $bc80ebcf21bfccd0$export$5ef2424805ac76a3.create;
var $bc80ebcf21bfccd0$export$bc86dfbf7795668c = $bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create;
var $bc80ebcf21bfccd0$export$65e3907585753458 = $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create;
var $bc80ebcf21bfccd0$export$e5185e241753e543 = $bc80ebcf21bfccd0$export$a2acc09968cb4b7f.create;
var $bc80ebcf21bfccd0$export$871de8747c9eaa88 = $bc80ebcf21bfccd0$export$163b6a2b712d9542.create;
var $bc80ebcf21bfccd0$export$adaa4cf7ef1b65be = $bc80ebcf21bfccd0$export$977057706f816712.create;
var $bc80ebcf21bfccd0$export$44e51c8aac7c2deb = $bc80ebcf21bfccd0$export$d4602ba55673f53c.create;
var $bc80ebcf21bfccd0$export$488013bae63b21da = $bc80ebcf21bfccd0$export$378d0cfce37406e6.create;
var $bc80ebcf21bfccd0$export$c8ec6e1ec9fefcb0 = $bc80ebcf21bfccd0$export$7e44096782a165d3.create;
var $bc80ebcf21bfccd0$export$78a99c8d44d72635 = $bc80ebcf21bfccd0$export$d325d1f0e1c20179.create;
var $bc80ebcf21bfccd0$export$6fe7eca19ebe5199 = $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56.create;
var $bc80ebcf21bfccd0$export$c957ef27a0ebfd4 = $bc80ebcf21bfccd0$export$3f196b0127d6e50a.create;
var $bc80ebcf21bfccd0$export$dc573d8a6576cdb3 = $bc80ebcf21bfccd0$export$a60af00cc0ce2582.create;
var $bc80ebcf21bfccd0$export$516e28dec6a4b6d4 = $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create;
var $bc80ebcf21bfccd0$export$133fc36489ac9add = $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create;
var $bc80ebcf21bfccd0$export$fc37fe19dfda43ee = $bc80ebcf21bfccd0$export$a60af00cc0ce2582.createWithPreprocess;
var $bc80ebcf21bfccd0$export$43f28b24e1eb8181 = $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da.create;
var $bc80ebcf21bfccd0$export$3b3d07727c5b702c = function() {
    return $bc80ebcf21bfccd0$export$22b082955e083ec3().optional();
};
var $bc80ebcf21bfccd0$export$eb150471a61fced6 = function() {
    return $bc80ebcf21bfccd0$export$98e628dec113755e().optional();
};
var $bc80ebcf21bfccd0$export$269251733cdcbbf1 = function() {
    return $bc80ebcf21bfccd0$export$4a21f16c33752377().optional();
};
var $bc80ebcf21bfccd0$export$8c14e57e778d3873 = {
    string: function(arg) {
        return $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    number: function(arg) {
        return $bc80ebcf21bfccd0$export$5b070a55c0c43e09.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    boolean: function(arg) {
        return $bc80ebcf21bfccd0$export$723d146f80596191.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    bigint: function(arg) {
        return $bc80ebcf21bfccd0$export$67d741fd70ff98f4.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    },
    date: function(arg) {
        return $bc80ebcf21bfccd0$export$e974be33bdc55521.create((0, $8E768._)((0, $8OnJk._)({}, arg), {
            coerce: true
        }));
    }
};
var $bc80ebcf21bfccd0$export$96c94437c95d7862 = $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
var $bc80ebcf21bfccd0$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $bc80ebcf21bfccd0$export$341b0b6e0a6f5099,
    setErrorMap: $bc80ebcf21bfccd0$export$1097a8289cfd22d7,
    getErrorMap: $bc80ebcf21bfccd0$export$32f27c719778d4c4,
    makeIssue: $bc80ebcf21bfccd0$export$244a85fde9c419ed,
    EMPTY_PATH: $bc80ebcf21bfccd0$export$1526d2e05f74572,
    addIssueToContext: $bc80ebcf21bfccd0$export$db7caee60e5d514d,
    ParseStatus: $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f,
    INVALID: $bc80ebcf21bfccd0$export$9a105a556e65c2c0,
    DIRTY: $bc80ebcf21bfccd0$export$325a211da9693fcf,
    OK: $bc80ebcf21bfccd0$export$c6813a8d51f77eaf,
    isAborted: $bc80ebcf21bfccd0$export$afa861e3c5730743,
    isDirty: $bc80ebcf21bfccd0$export$910b6cdd390341b3,
    isValid: $bc80ebcf21bfccd0$export$1ea939691cdc45b8,
    isAsync: $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e,
    get util () {
        return $bc80ebcf21bfccd0$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $bc80ebcf21bfccd0$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $bc80ebcf21bfccd0$export$5716da67bfaa244d,
    getParsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a,
    ZodType: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    ZodString: $bc80ebcf21bfccd0$export$1230eb29b8d3b502,
    ZodNumber: $bc80ebcf21bfccd0$export$5b070a55c0c43e09,
    ZodBigInt: $bc80ebcf21bfccd0$export$67d741fd70ff98f4,
    ZodBoolean: $bc80ebcf21bfccd0$export$723d146f80596191,
    ZodDate: $bc80ebcf21bfccd0$export$e974be33bdc55521,
    ZodSymbol: $bc80ebcf21bfccd0$export$bcc3b40f6b638044,
    ZodUndefined: $bc80ebcf21bfccd0$export$4e780e961c30340d,
    ZodNull: $bc80ebcf21bfccd0$export$a96281f914484f2d,
    ZodAny: $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb,
    ZodUnknown: $bc80ebcf21bfccd0$export$ef3b1bb1630977ae,
    ZodNever: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5,
    ZodVoid: $bc80ebcf21bfccd0$export$7d39f5df85f21031,
    ZodArray: $bc80ebcf21bfccd0$export$7acfc3e64785411,
    ZodObject: $bc80ebcf21bfccd0$export$736315c5b55efbad,
    ZodUnion: $bc80ebcf21bfccd0$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $bc80ebcf21bfccd0$export$5ef2424805ac76a3,
    ZodIntersection: $bc80ebcf21bfccd0$export$c02deaf0bb5203d4,
    ZodTuple: $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3,
    ZodRecord: $bc80ebcf21bfccd0$export$a2acc09968cb4b7f,
    ZodMap: $bc80ebcf21bfccd0$export$163b6a2b712d9542,
    ZodSet: $bc80ebcf21bfccd0$export$977057706f816712,
    ZodFunction: $bc80ebcf21bfccd0$export$d4602ba55673f53c,
    ZodLazy: $bc80ebcf21bfccd0$export$378d0cfce37406e6,
    ZodLiteral: $bc80ebcf21bfccd0$export$7e44096782a165d3,
    ZodEnum: $bc80ebcf21bfccd0$export$d325d1f0e1c20179,
    ZodNativeEnum: $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56,
    ZodPromise: $bc80ebcf21bfccd0$export$3f196b0127d6e50a,
    ZodEffects: $bc80ebcf21bfccd0$export$a60af00cc0ce2582,
    ZodTransformer: $bc80ebcf21bfccd0$export$a60af00cc0ce2582,
    ZodOptional: $bc80ebcf21bfccd0$export$aa56fec1e9d629b8,
    ZodNullable: $bc80ebcf21bfccd0$export$aaac0b8b429cef5,
    ZodDefault: $bc80ebcf21bfccd0$export$bb19b37874861e7e,
    ZodCatch: $bc80ebcf21bfccd0$export$75a44ec6249ac76b,
    ZodNaN: $bc80ebcf21bfccd0$export$26ccfa0145e8511f,
    BRAND: $bc80ebcf21bfccd0$export$cf2deea74cde46b4,
    ZodBranded: $bc80ebcf21bfccd0$export$66b0c798a395271f,
    ZodPipeline: $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da,
    custom: $bc80ebcf21bfccd0$export$4c00f665f0d4b443,
    Schema: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    ZodSchema: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    late: $bc80ebcf21bfccd0$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $bc80ebcf21bfccd0$export$558106ce543bd011;
    },
    coerce: $bc80ebcf21bfccd0$export$8c14e57e778d3873,
    any: $bc80ebcf21bfccd0$export$4154a199d7d90455,
    array: $bc80ebcf21bfccd0$export$2f23118c22fb2630,
    bigint: $bc80ebcf21bfccd0$export$a0f65b52274bcc00,
    boolean: $bc80ebcf21bfccd0$export$4a21f16c33752377,
    date: $bc80ebcf21bfccd0$export$324d90190a8b822a,
    discriminatedUnion: $bc80ebcf21bfccd0$export$4b888e40c4ee26dd,
    effect: $bc80ebcf21bfccd0$export$dc573d8a6576cdb3,
    "enum": $bc80ebcf21bfccd0$export$78a99c8d44d72635,
    "function": $bc80ebcf21bfccd0$export$44e51c8aac7c2deb,
    "instanceof": $bc80ebcf21bfccd0$export$3d916e7c22dbd8b5,
    intersection: $bc80ebcf21bfccd0$export$bc86dfbf7795668c,
    lazy: $bc80ebcf21bfccd0$export$488013bae63b21da,
    literal: $bc80ebcf21bfccd0$export$c8ec6e1ec9fefcb0,
    map: $bc80ebcf21bfccd0$export$871de8747c9eaa88,
    nan: $bc80ebcf21bfccd0$export$9e06de0973666692,
    nativeEnum: $bc80ebcf21bfccd0$export$6fe7eca19ebe5199,
    never: $bc80ebcf21bfccd0$export$b3e22bcfd64c1022,
    "null": $bc80ebcf21bfccd0$export$7b1b591b262c240,
    nullable: $bc80ebcf21bfccd0$export$133fc36489ac9add,
    number: $bc80ebcf21bfccd0$export$98e628dec113755e,
    object: $bc80ebcf21bfccd0$export$be5493f9613cbbe,
    oboolean: $bc80ebcf21bfccd0$export$269251733cdcbbf1,
    onumber: $bc80ebcf21bfccd0$export$eb150471a61fced6,
    optional: $bc80ebcf21bfccd0$export$516e28dec6a4b6d4,
    ostring: $bc80ebcf21bfccd0$export$3b3d07727c5b702c,
    pipeline: $bc80ebcf21bfccd0$export$43f28b24e1eb8181,
    preprocess: $bc80ebcf21bfccd0$export$fc37fe19dfda43ee,
    promise: $bc80ebcf21bfccd0$export$c957ef27a0ebfd4,
    record: $bc80ebcf21bfccd0$export$e5185e241753e543,
    set: $bc80ebcf21bfccd0$export$adaa4cf7ef1b65be,
    strictObject: $bc80ebcf21bfccd0$export$8fb0df5f40d0b477,
    string: $bc80ebcf21bfccd0$export$22b082955e083ec3,
    symbol: $bc80ebcf21bfccd0$export$8f701197936bc2a6,
    transformer: $bc80ebcf21bfccd0$export$dc573d8a6576cdb3,
    tuple: $bc80ebcf21bfccd0$export$65e3907585753458,
    "undefined": $bc80ebcf21bfccd0$export$1db45310990710a5,
    union: $bc80ebcf21bfccd0$export$971dd5b0dfd021b6,
    unknown: $bc80ebcf21bfccd0$export$19282c40b967aec6,
    "void": $bc80ebcf21bfccd0$export$490e536ee7389aeb,
    NEVER: $bc80ebcf21bfccd0$export$96c94437c95d7862,
    ZodIssueCode: $bc80ebcf21bfccd0$export$5ba560653e4a1035,
    quotelessJson: $bc80ebcf21bfccd0$export$913eddeaf297cfea,
    ZodError: $bc80ebcf21bfccd0$export$f98dac4b251ab333
});



function $eed97d47c423435d$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $eed97d47c423435d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $eed97d47c423435d$export$2e2bcd8739ae039(obj);
}


function $2cd349b4b0303572$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $5bef1fb2b5291d67$export$2e2bcd8739ae039(value) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $eed97d47c423435d$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $0d5117f350b1bdf8$export$2e2bcd8739ae039(argument) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $eed97d47c423435d$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $e9700a92d29354e1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $5bef1fb2b5291d67$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $c45f97e3b4fe5562$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $42f03e37c3bf6a04$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $2bbf1bac62878a58$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $42f03e37c3bf6a04$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $81549d6575e59fd2$var$MILLISECONDS_IN_DAY = 86400000;
function $81549d6575e59fd2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $81549d6575e59fd2$var$MILLISECONDS_IN_DAY) + 1;
}





function $4c1747deb3303159$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $e3f8e82b65d70da1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $4c1747deb3303159$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $4c1747deb3303159$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $a60c2d1b99df8c3c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $e3f8e82b65d70da1$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $4c1747deb3303159$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $2c681c49860d78b1$var$MILLISECONDS_IN_WEEK = 604800000;
function $2c681c49860d78b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $4c1747deb3303159$export$2e2bcd8739ae039)(date).getTime() - (0, $a60c2d1b99df8c3c$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2c681c49860d78b1$var$MILLISECONDS_IN_WEEK) + 1;
}







var $34725ad826d407f2$var$defaultOptions = {};
function $34725ad826d407f2$export$430a3269e24b912e() {
    return $34725ad826d407f2$var$defaultOptions;
}
function $34725ad826d407f2$export$95365be1b0704abc(newOptions) {
    $34725ad826d407f2$var$defaultOptions = newOptions;
}


function $13633788983a89e8$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $d5ec1dd23e93379f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $13633788983a89e8$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $13633788983a89e8$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $7d518ce50b60e682$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $d5ec1dd23e93379f$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $13633788983a89e8$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $d170c2d37368a72a$var$MILLISECONDS_IN_WEEK = 604800000;
function $d170c2d37368a72a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $13633788983a89e8$export$2e2bcd8739ae039)(date, options).getTime() - (0, $7d518ce50b60e682$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d170c2d37368a72a$var$MILLISECONDS_IN_WEEK) + 1;
}



function $6ccd543656d9ca8b$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $e9a28287a8abd3ed$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $e9a28287a8abd3ed$export$2e2bcd8739ae039 = $e9a28287a8abd3ed$var$formatters;


var $4c7efc752dd64390$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4c7efc752dd64390$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $d5ec1dd23e93379f$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $e3f8e82b65d70da1$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $d170c2d37368a72a$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $2c681c49860d78b1$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $81549d6575e59fd2$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4c7efc752dd64390$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4c7efc752dd64390$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4c7efc752dd64390$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4c7efc752dd64390$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4c7efc752dd64390$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4c7efc752dd64390$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $e9a28287a8abd3ed$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4c7efc752dd64390$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $4c7efc752dd64390$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4c7efc752dd64390$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4c7efc752dd64390$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $4c7efc752dd64390$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4c7efc752dd64390$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4c7efc752dd64390$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4c7efc752dd64390$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $4c7efc752dd64390$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $4c7efc752dd64390$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $4c7efc752dd64390$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(minutes, 2);
}
function $4c7efc752dd64390$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $4c7efc752dd64390$var$formatTimezone(offset, dirtyDelimiter);
}
function $4c7efc752dd64390$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $6ccd543656d9ca8b$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4c7efc752dd64390$export$2e2bcd8739ae039 = $4c7efc752dd64390$var$formatters;


var $60e9229989f36652$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $60e9229989f36652$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $60e9229989f36652$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $60e9229989f36652$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $60e9229989f36652$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $60e9229989f36652$var$timeLongFormatter(timePattern, formatLong));
};
var $60e9229989f36652$var$longFormatters = {
    p: $60e9229989f36652$var$timeLongFormatter,
    P: $60e9229989f36652$var$dateTimeLongFormatter
};
var $60e9229989f36652$export$2e2bcd8739ae039 = $60e9229989f36652$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $366a4a56a4bc62c1$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $b87027257b8909ff$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $b87027257b8909ff$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $b87027257b8909ff$export$c6cc36aa33304772(token) {
    return $b87027257b8909ff$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $b87027257b8909ff$export$c6b49d6dceb604a1(token) {
    return $b87027257b8909ff$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $b87027257b8909ff$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $a14379cad6b2e2c7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $a14379cad6b2e2c7$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a14379cad6b2e2c7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $a14379cad6b2e2c7$export$2e2bcd8739ae039 = $a14379cad6b2e2c7$var$formatDistance;


function $a7b99ec3a814aa68$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $d5e43bcd17868a80$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $d5e43bcd17868a80$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d5e43bcd17868a80$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d5e43bcd17868a80$var$formatLong = {
    date: (0, $a7b99ec3a814aa68$export$2e2bcd8739ae039)({
        formats: $d5e43bcd17868a80$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $a7b99ec3a814aa68$export$2e2bcd8739ae039)({
        formats: $d5e43bcd17868a80$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $a7b99ec3a814aa68$export$2e2bcd8739ae039)({
        formats: $d5e43bcd17868a80$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d5e43bcd17868a80$export$2e2bcd8739ae039 = $d5e43bcd17868a80$var$formatLong;


var $eab580b353f38319$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $eab580b353f38319$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $eab580b353f38319$var$formatRelativeLocale[token];
};
var $eab580b353f38319$export$2e2bcd8739ae039 = $eab580b353f38319$var$formatRelative;


function $95046244fe9b530b$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $4e7105c4f0415e68$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $4e7105c4f0415e68$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $4e7105c4f0415e68$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $4e7105c4f0415e68$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $4e7105c4f0415e68$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $4e7105c4f0415e68$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $4e7105c4f0415e68$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $4e7105c4f0415e68$var$localize = {
    ordinalNumber: $4e7105c4f0415e68$var$ordinalNumber,
    era: (0, $95046244fe9b530b$export$2e2bcd8739ae039)({
        values: $4e7105c4f0415e68$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $95046244fe9b530b$export$2e2bcd8739ae039)({
        values: $4e7105c4f0415e68$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $95046244fe9b530b$export$2e2bcd8739ae039)({
        values: $4e7105c4f0415e68$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $95046244fe9b530b$export$2e2bcd8739ae039)({
        values: $4e7105c4f0415e68$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $95046244fe9b530b$export$2e2bcd8739ae039)({
        values: $4e7105c4f0415e68$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4e7105c4f0415e68$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $4e7105c4f0415e68$export$2e2bcd8739ae039 = $4e7105c4f0415e68$var$localize;


function $14f4a193bf743687$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $14f4a193bf743687$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $14f4a193bf743687$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $14f4a193bf743687$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $14f4a193bf743687$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ab1a6c78a39fe2c8$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $65a0bb912cf61f0b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $65a0bb912cf61f0b$var$parseOrdinalNumberPattern = /\d+/i;
var $65a0bb912cf61f0b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $65a0bb912cf61f0b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $65a0bb912cf61f0b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $65a0bb912cf61f0b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $65a0bb912cf61f0b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $65a0bb912cf61f0b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $65a0bb912cf61f0b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $65a0bb912cf61f0b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $65a0bb912cf61f0b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $65a0bb912cf61f0b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $65a0bb912cf61f0b$var$match = {
    ordinalNumber: (0, $ab1a6c78a39fe2c8$export$2e2bcd8739ae039)({
        matchPattern: $65a0bb912cf61f0b$var$matchOrdinalNumberPattern,
        parsePattern: $65a0bb912cf61f0b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $14f4a193bf743687$export$2e2bcd8739ae039)({
        matchPatterns: $65a0bb912cf61f0b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65a0bb912cf61f0b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $14f4a193bf743687$export$2e2bcd8739ae039)({
        matchPatterns: $65a0bb912cf61f0b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65a0bb912cf61f0b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $14f4a193bf743687$export$2e2bcd8739ae039)({
        matchPatterns: $65a0bb912cf61f0b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65a0bb912cf61f0b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $14f4a193bf743687$export$2e2bcd8739ae039)({
        matchPatterns: $65a0bb912cf61f0b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65a0bb912cf61f0b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $14f4a193bf743687$export$2e2bcd8739ae039)({
        matchPatterns: $65a0bb912cf61f0b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $65a0bb912cf61f0b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $65a0bb912cf61f0b$export$2e2bcd8739ae039 = $65a0bb912cf61f0b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $d5a6580ba4c351c8$var$locale = {
    code: "en-US",
    formatDistance: (0, $a14379cad6b2e2c7$export$2e2bcd8739ae039),
    formatLong: (0, $d5e43bcd17868a80$export$2e2bcd8739ae039),
    formatRelative: (0, $eab580b353f38319$export$2e2bcd8739ae039),
    localize: (0, $4e7105c4f0415e68$export$2e2bcd8739ae039),
    match: (0, $65a0bb912cf61f0b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d5a6580ba4c351c8$export$2e2bcd8739ae039 = $d5a6580ba4c351c8$var$locale;


var $58d4c6083db81b0b$export$2e2bcd8739ae039 = (0, $d5a6580ba4c351c8$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $03c5e06834f993e7$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $03c5e06834f993e7$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $03c5e06834f993e7$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $03c5e06834f993e7$var$doubleQuoteRegExp = /''/g;
var $03c5e06834f993e7$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $03c5e06834f993e7$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $58d4c6083db81b0b$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $e9700a92d29354e1$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $366a4a56a4bc62c1$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $2bbf1bac62878a58$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($03c5e06834f993e7$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $60e9229989f36652$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($03c5e06834f993e7$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $03c5e06834f993e7$var$cleanEscapedString(substring);
        var formatter = (0, $4c7efc752dd64390$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $b87027257b8909ff$export$c6b49d6dceb604a1)(substring)) (0, $b87027257b8909ff$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $b87027257b8909ff$export$c6cc36aa33304772)(substring)) (0, $b87027257b8909ff$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($03c5e06834f993e7$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $03c5e06834f993e7$var$cleanEscapedString(input) {
    var matched = input.match($03c5e06834f993e7$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($03c5e06834f993e7$var$doubleQuoteRegExp, "'");
}


/**
 * lucide-react v0.257.0 - ISC
 */ 
var $baade51261a67af7$export$2e2bcd8739ae039 = (0, $7cb731e627edfd3e$export$2e2bcd8739ae039)("Calendar", [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            ry: "2",
            key: "eu3xkr"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "2",
            y2: "6",
            key: "m3sa8f"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "2",
            y2: "6",
            key: "18kwsl"
        }
    ],
    [
        "line",
        {
            x1: "3",
            x2: "21",
            y1: "10",
            y2: "10",
            key: "xt86sb"
        }
    ]
]);




var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");

var $a86a65377abd0af8$export$f5b8910cec6cf069 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, type = _param.type, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "type"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", (0, $8OnJk._)({
        type: type,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className),
        ref: ref
    }, props));
});
$a86a65377abd0af8$export$f5b8910cec6cf069.displayName = "Input";



var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");


var $6cds3 = parcelRequire("6cds3");















/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
var $84889850f2fc9333$var$_$am6gm$createContextScope = (0, $8GFUW._)((0, $ac20025c1aee149a$export$50c7b4e9d9f19c1)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $ed1fe7c5ccd267a8$export$722aac194ae923)
]), 2), $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$createPopoverContext = $84889850f2fc9333$var$_$am6gm$createContextScope[0], $84889850f2fc9333$export$c8393c9e73286932 = $84889850f2fc9333$var$_$am6gm$createContextScope[1];
var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $ed1fe7c5ccd267a8$export$722aac194ae923)();
var $84889850f2fc9333$var$_$cb5cc270b50c6fcd$var$createPopoverContext = (0, $8GFUW._)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$createPopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$POPOVER_NAME), 2), $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverProvider = $84889850f2fc9333$var$_$cb5cc270b50c6fcd$var$createPopoverContext[0], $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext = $84889850f2fc9333$var$_$cb5cc270b50c6fcd$var$createPopoverContext[1];
var $84889850f2fc9333$export$5b6b19405a83ff9d = function(props) {
    var __scopePopover = props.__scopePopover, children = props.children, openProp = props.open, defaultOpen = props.defaultOpen, onOpenChange = props.onOpenChange, tmp = props.modal, modal = tmp === void 0 ? false : tmp;
    var popperScope = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    var triggerRef = (0, $6cds3.useRef)(null);
    var _$am6gm$useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), hasCustomAnchor = _$am6gm$useState[0], setHasCustomAnchor = _$am6gm$useState[1];
    var _$am6gm$useControllableState = (0, $8GFUW._)((0, $67d582389dee973c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    }), 2), tmp1 = _$am6gm$useControllableState[0], open = tmp1 === void 0 ? false : tmp1, setOpen = _$am6gm$useControllableState[1];
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $6cds3.createElement)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $3a7a3a6a18539928$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $6cds3.useCallback)(function() {
            return setOpen(function(prevOpen) {
                return !prevOpen;
            });
        }, [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $6cds3.useCallback)(function() {
            return setHasCustomAnchor(true);
        }, []),
        onCustomAnchorRemove: (0, $6cds3.useCallback)(function() {
            return setHasCustomAnchor(false);
        }, []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$5b6b19405a83ff9d, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
var $84889850f2fc9333$export$96e5381f42521a79 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, anchorProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopover"
    ]);
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    var popperScope = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    var onCustomAnchorAdd = context.onCustomAnchorAdd, onCustomAnchorRemove = context.onCustomAnchorRemove;
    (0, $6cds3.useEffect)(function() {
        onCustomAnchorAdd();
        return function() {
            return onCustomAnchorRemove();
        };
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$b688253958b8dfe7), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$96e5381f42521a79, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
var $84889850f2fc9333$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, triggerProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopover"
    ]);
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    var popperScope = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    var composedTriggerRef = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    var trigger = /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).button, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$b688253958b8dfe7), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$7dacb05d26466c3, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
var $84889850f2fc9333$var$_$cb5cc270b50c6fcd$var$createPopoverContext1 = (0, $8GFUW._)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$createPopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
}), 2), $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PortalProvider = $84889850f2fc9333$var$_$cb5cc270b50c6fcd$var$createPopoverContext1[0], $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePortalContext = $84889850f2fc9333$var$_$cb5cc270b50c6fcd$var$createPopoverContext1[1];
var $84889850f2fc9333$export$dd679ffb4362d2d4 = function(props) {
    var __scopePopover = props.__scopePopover, forceMount = props.forceMount, children = props.children, container = props.container;
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $6cds3.createElement)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $5521a3997b1d3e3c$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$dd679ffb4362d2d4, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
var $84889850f2fc9333$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var portalContext = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePortalContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    var tmp = props.forceMount, forceMount = tmp === void 0 ? portalContext.forceMount : tmp, contentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "forceMount"
    ]);
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $9ce5901ff07c9a39$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $6cds3.createElement)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $6cds3.createElement)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$d7e1f420b25549ff, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    var contentRef = (0, $6cds3.useRef)(null);
    var composedRefs = (0, $becf66aa9c19994c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    var isRightClickOutsideRef = (0, $6cds3.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $6cds3.useEffect)(function() {
        var content = contentRef.current;
        if (content) return (0, $2d232392051ea0c1$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $8b6c725e50844855$export$2e2bcd8739ae039), {
        as: (0, $513654131ef3bd4b$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $6cds3.createElement)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onCloseAutoFocus, function(event) {
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onPointerDownOutside, function(event) {
            var originalEvent = event.detail.originalEvent;
            var ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            var isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onFocusOutside, function(event) {
            return event.preventDefault();
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    var hasInteractedOutsideRef = (0, $6cds3.useRef)(false);
    var hasPointerDownOutsideRef = (0, $6cds3.useRef)(false);
    return /*#__PURE__*/ (0, $6cds3.createElement)($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: function(event) {
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: function(event) {
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            var target = event.target;
            var targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, trapFocus = props.trapFocus, onOpenAutoFocus = props.onOpenAutoFocus, onCloseAutoFocus = props.onCloseAutoFocus, disableOutsidePointerEvents = props.disableOutsidePointerEvents, onEscapeKeyDown = props.onEscapeKeyDown, onPointerDownOutside = props.onPointerDownOutside, onFocusOutside = props.onFocusOutside, onInteractOutside = props.onInteractOutside, contentProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopover",
        "trapFocus",
        "onOpenAutoFocus",
        "onCloseAutoFocus",
        "disableOutsidePointerEvents",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside"
    ]);
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    var popperScope = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $6b90108589ddc0b8$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $0ab32e587c90dbe2$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $495a48040502b2f4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: function() {
            return context.onOpenChange(false);
        }
    }, /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$7c6e2c02157bb7d2), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        "data-state": $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: (0, $8E768._)((0, $8OnJk._)({}, contentProps.style), {
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        })
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
var $84889850f2fc9333$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, closeProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopover"
    ]);
    var context = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopoverContext($84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).button, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $8abce7d05baac96b$export$b9ecd428b558ff10)(props.onClick, function() {
            return context.onOpenChange(false);
        })
    }));
});
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$d6ac43ebaa40d53e, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ var $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
var $84889850f2fc9333$export$3152841115e061b2 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    var __scopePopover = props.__scopePopover, arrowProps = (0, $c4006311849aa271$export$69fdd232f62cde60)(props, [
        "__scopePopover"
    ]);
    var popperScope = $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $ed1fe7c5ccd267a8$export$21b07c8f274aebd5), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($84889850f2fc9333$export$3152841115e061b2, {
    displayName: $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $84889850f2fc9333$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
var $84889850f2fc9333$export$be92b6f5f03c0fe9 = $84889850f2fc9333$export$5b6b19405a83ff9d;
var $84889850f2fc9333$export$b688253958b8dfe7 = $84889850f2fc9333$export$96e5381f42521a79;
var $84889850f2fc9333$export$41fb9f06171c75f4 = $84889850f2fc9333$export$7dacb05d26466c3;
var $84889850f2fc9333$export$602eac185826482c = $84889850f2fc9333$export$dd679ffb4362d2d4;
var $84889850f2fc9333$export$7c6e2c02157bb7d2 = $84889850f2fc9333$export$d7e1f420b25549ff;
var $84889850f2fc9333$export$f39c2d165cd861fe = $84889850f2fc9333$export$d6ac43ebaa40d53e;
var $84889850f2fc9333$export$21b07c8f274aebd5 = $84889850f2fc9333$export$3152841115e061b2;



var $92ca368498d82bb0$export$5b6b19405a83ff9d = $84889850f2fc9333$export$be92b6f5f03c0fe9;
var $92ca368498d82bb0$export$7dacb05d26466c3 = $84889850f2fc9333$export$41fb9f06171c75f4;
var $92ca368498d82bb0$export$d7e1f420b25549ff = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, _param_align = _param.align, align = _param_align === void 0 ? "center" : _param_align, _param_sideOffset = _param.sideOffset, sideOffset = _param_sideOffset === void 0 ? 4 : _param_sideOffset, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "align",
        "sideOffset"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($84889850f2fc9333$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($84889850f2fc9333$export$7c6e2c02157bb7d2, (0, $8OnJk._)({
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
        }, props))
    });
});
$92ca368498d82bb0$export$d7e1f420b25549ff.displayName = $84889850f2fc9333$export$7c6e2c02157bb7d2.displayName;





var $8OnJk = parcelRequire("8OnJk");


parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");




function $a547069edc855704$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




function $6d0ecf9a428ec130$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $606915c4cd25bdf9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $a547069edc855704$export$2e2bcd8739ae039)(dirtyDate, days);
}




function $9296fdc2fbd3affb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $e057ce7241b8c298$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $b9a67232a996f916$var$MILLISECONDS_IN_DAY = 86400000;
function $b9a67232a996f916$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $e057ce7241b8c298$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $e057ce7241b8c298$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $366a4a56a4bc62c1$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $366a4a56a4bc62c1$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b9a67232a996f916$var$MILLISECONDS_IN_DAY);
}



function $d0991680e59a9314$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}





function $fb7133dd2ccac13e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $e5091816f47eca48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    return (0, $fb7133dd2ccac13e$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}



function $fa420e09b5f264b5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $24a377abc374d178$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $43d4a3484b08b076$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    return (0, $24a377abc374d178$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}





function $116c089ca35ac55b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $fa66e0e9a3684fa5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $116c089ca35ac55b$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $954778d92ca562fe$var$MILLISECONDS_IN_WEEK = 604800000;
function $954778d92ca562fe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(date).getTime() - (0, $fa66e0e9a3684fa5$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $954778d92ca562fe$var$MILLISECONDS_IN_WEEK) + 1;
}



function $baea151675f25c94$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}



function $8ebe16428d511cf5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    return Math.floor((0, $baea151675f25c94$export$2e2bcd8739ae039)(dirtyDate) / 1000);
}







function $2d47ca7001f17697$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $24a377abc374d178$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $24a377abc374d178$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $3453a7ebeb77e40b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $2d47ca7001f17697$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $24a377abc374d178$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $82220a43b29e96d8$var$MILLISECONDS_IN_WEEK = 604800000;
function $82220a43b29e96d8$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $24a377abc374d178$export$2e2bcd8739ae039)(date, options).getTime() - (0, $3453a7ebeb77e40b$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $82220a43b29e96d8$var$MILLISECONDS_IN_WEEK) + 1;
}




var $28b3c9913d4fb78d$var$MILLISECONDS_IN_WEEK = 604800000;
function $28b3c9913d4fb78d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var startOfWeekLeft = (0, $24a377abc374d178$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $24a377abc374d178$export$2e2bcd8739ae039)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $366a4a56a4bc62c1$export$2e2bcd8739ae039)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $366a4a56a4bc62c1$export$2e2bcd8739ae039)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $28b3c9913d4fb78d$var$MILLISECONDS_IN_WEEK);
}




function $0dd262a5c7ed7dc6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $a22bbf2dcd1a235a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $1fafae7b955e044e$export$2e2bcd8739ae039(date, options) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    return (0, $28b3c9913d4fb78d$export$2e2bcd8739ae039)((0, $0dd262a5c7ed7dc6$export$2e2bcd8739ae039)(date), (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(date), options) + 1;
}



function $c11d30d91d8569f9$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $28b36b744929d6ec$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



function $bdd887e93cf852b9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $e057ce7241b8c298$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $e057ce7241b8c298$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $63ee334c32f82cb8$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}



function $cfa6c444bf3b3ba0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $0127433a1b264500$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}




function $12f073eb98306650$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}


function $fcc9984cfdd13319$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $15235f62ba686e41$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $fcc9984cfdd13319$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $fcc9984cfdd13319$export$2e2bcd8739ae039)(o, minLen);
}


function $7c82c484262babb6$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $15235f62ba686e41$export$2e2bcd8739ae039)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}





function $846fc99929bb71b3$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}







function $a5c883865d903b3c$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $50859a28edac1620$export$2e2bcd8739ae039(o, p) {
    $50859a28edac1620$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $50859a28edac1620$export$2e2bcd8739ae039(o, p);
}


function $9ac022430c6bab36$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $50859a28edac1620$export$2e2bcd8739ae039)(subClass, superClass);
}


function $939928d339059212$export$2e2bcd8739ae039(o) {
    $939928d339059212$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $939928d339059212$export$2e2bcd8739ae039(o);
}


function $93787dd14a8735f7$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}




function $6105dfc2330f8db5$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $a5c883865d903b3c$export$2e2bcd8739ae039)(self);
}


function $9113642ee56fc20c$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $93787dd14a8735f7$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $939928d339059212$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $939928d339059212$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6105dfc2330f8db5$export$2e2bcd8739ae039)(this, result);
    };
}


function $f50e9ddf3899eedf$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $8c0883e9635940ff$export$2e2bcd8739ae039(input, hint) {
    if ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $ca9f2a3c06394527$export$2e2bcd8739ae039(arg) {
    var key = (0, $8c0883e9635940ff$export$2e2bcd8739ae039)(arg, "string");
    return (0, $eed97d47c423435d$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $73a5a93d106b2fb4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $ca9f2a3c06394527$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $73a5a93d106b2fb4$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $73a5a93d106b2fb4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $73a5a93d106b2fb4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $c5ff8c04c412c17d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $ca9f2a3c06394527$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $a66c04983d4862bc$var$TIMEZONE_UNIT_PRIORITY = 10;
var $a66c04983d4862bc$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Setter);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $a66c04983d4862bc$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($a66c04983d4862bc$export$81d53e3678089a6);
var $a66c04983d4862bc$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this2), "priority", $a66c04983d4862bc$var$TIMEZONE_UNIT_PRIORITY);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($a66c04983d4862bc$export$81d53e3678089a6);












var $cc809539b5636e7d$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Parser);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $a66c04983d4862bc$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $dbad402edbfd7645$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $ab0062cf69c840fc$export$dfd9b671c89acc8e = 7;
var $ab0062cf69c840fc$export$3913210603d8e9ae = 365.2425;
var $ab0062cf69c840fc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $ab0062cf69c840fc$export$91246f0b9bd9beff = 60000;
var $ab0062cf69c840fc$export$7f72910d6dfd237a = 3600000;
var $ab0062cf69c840fc$export$397c2d5776aa9055 = 1000;
var $ab0062cf69c840fc$export$4dec998e48f9c246 = -$ab0062cf69c840fc$export$81caae6e1cc7a622;
var $ab0062cf69c840fc$export$f2f5ae5a8e2d8f9f = 60;
var $ab0062cf69c840fc$export$3c58128db900d44e = 3;
var $ab0062cf69c840fc$export$80d7e435f744f319 = 12;
var $ab0062cf69c840fc$export$4db7641526e3241f = 4;
var $ab0062cf69c840fc$export$698aec755e92c695 = 3600;
var $ab0062cf69c840fc$export$a77c1a7ebebe2a5a = 60;
var $ab0062cf69c840fc$export$815a9362476d2fe3 = $ab0062cf69c840fc$export$698aec755e92c695 * 24;
var $ab0062cf69c840fc$export$34804a017b31e2fe = $ab0062cf69c840fc$export$815a9362476d2fe3 * 7;
var $ab0062cf69c840fc$export$7271e9e3478110d1 = $ab0062cf69c840fc$export$815a9362476d2fe3 * $ab0062cf69c840fc$export$3913210603d8e9ae;
var $ab0062cf69c840fc$export$8e6600bbdee7dabb = $ab0062cf69c840fc$export$7271e9e3478110d1 / 12;
var $ab0062cf69c840fc$export$be1dccf2de902d31 = $ab0062cf69c840fc$export$8e6600bbdee7dabb * 3;


var $5edcca2ef81431b7$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $5edcca2ef81431b7$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $df569d25b8cbbc26$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $df569d25b8cbbc26$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $df569d25b8cbbc26$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $ab0062cf69c840fc$export$7f72910d6dfd237a) + minutes * (0, $ab0062cf69c840fc$export$91246f0b9bd9beff) + seconds * (0, $ab0062cf69c840fc$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $df569d25b8cbbc26$export$d931c43c4608a164(dateString) {
    return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $df569d25b8cbbc26$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $df569d25b8cbbc26$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388((0, $5edcca2ef81431b7$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $df569d25b8cbbc26$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $df569d25b8cbbc26$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $df569d25b8cbbc26$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $df569d25b8cbbc26$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $b3f58eef679f8dea$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $df569d25b8cbbc26$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));












var $961b5d1dbfed123a$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $d5ec1dd23e93379f$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $df569d25b8cbbc26$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $13633788983a89e8$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $13633788983a89e8$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $275eb11756953a12$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $df569d25b8cbbc26$export$2c9307b2e29c533c)(4, dateString);
                return (0, $df569d25b8cbbc26$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $4c1747deb3303159$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $3bfd9a68259652bd$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $df569d25b8cbbc26$export$2c9307b2e29c533c)(4, dateString);
                return (0, $df569d25b8cbbc26$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $cc9603e362f91a70$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $8266fde60668db8b$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $9a79549ee95bb2f2$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $4ad78b744d39db5a$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));















function $67fc57d02484b74b$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $d170c2d37368a72a$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $4af3b0010d470f7c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $13633788983a89e8$export$2e2bcd8739ae039)((0, $67fc57d02484b74b$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));















function $b5c58821261cf0f3$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $2c681c49860d78b1$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $4df141ea42ddafd7$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $4c1747deb3303159$export$2e2bcd8739ae039)((0, $b5c58821261cf0f3$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $ef9e76fc0817a93b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $ef9e76fc0817a93b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $ef9e76fc0817a93b$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $df569d25b8cbbc26$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $ef9e76fc0817a93b$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $ef9e76fc0817a93b$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $71e20061db80afe6$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $df569d25b8cbbc26$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));













function $84026e4350aa1751$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $9c19ad621993fb36$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $84026e4350aa1751$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $68d5a11aab8c5007$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $84026e4350aa1751$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $4dc6bd25aab439bf$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $84026e4350aa1751$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));













function $dbbe98ec58fdba4d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $4dec0d95ad6f4fdc$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $dbbe98ec58fdba4d$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $e3b18a7fd0b4cae4$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $df569d25b8cbbc26$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $301bf261fc23f768$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $df569d25b8cbbc26$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $a34970f51ba44935$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $df569d25b8cbbc26$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $667426d114ad01b2$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $367d60b40b3516bf$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $4f57cfd1b6150c26$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $36d68e9c5e24b374$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $99d47413b53b711f$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $7a3e113e81789960$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $df569d25b8cbbc26$export$cc7cc9e2a3ff9388)((0, $5edcca2ef81431b7$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $32ee3d7bb7e253b7$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $df569d25b8cbbc26$export$4f84e3a82c7b538)((0, $df569d25b8cbbc26$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $69783d320d9578da$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));











var $22e8aa2ad6a4b904$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $df569d25b8cbbc26$export$6497f4c0ecdfba8e)((0, $5edcca2ef81431b7$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $f72a3ac23a2adb1a$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $df569d25b8cbbc26$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));










var $676c5dc15428781c$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)((0, $a5c883865d903b3c$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $df569d25b8cbbc26$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $cc809539b5636e7d$export$7acfa6ed01010e37));


var $1cadfdb6063af430$export$19131010e7fd8373 = {
    G: new (0, $dbad402edbfd7645$export$8e5a1d3f85a9688)(),
    y: new (0, $b3f58eef679f8dea$export$48d352de7cd4a988)(),
    Y: new (0, $961b5d1dbfed123a$export$b8ef38dfcf05d5db)(),
    R: new (0, $275eb11756953a12$export$951d1df011fde06f)(),
    u: new (0, $3bfd9a68259652bd$export$bad9d2ea38e8f1a)(),
    Q: new (0, $cc9603e362f91a70$export$5cb0f701186dde1d)(),
    q: new (0, $8266fde60668db8b$export$300c0c2990e20e6d)(),
    M: new (0, $9a79549ee95bb2f2$export$400dd8b40ef138a3)(),
    L: new (0, $4ad78b744d39db5a$export$1d7eaa53eaa5deba)(),
    w: new (0, $4af3b0010d470f7c$export$c4005ffc174e07c0)(),
    I: new (0, $4df141ea42ddafd7$export$6fc8dbedd560a6af)(),
    d: new (0, $ef9e76fc0817a93b$export$e8d4b28a20981dd2)(),
    D: new (0, $71e20061db80afe6$export$6cfe0d613455f615)(),
    E: new (0, $9c19ad621993fb36$export$1b03c8b76262f7bd)(),
    e: new (0, $68d5a11aab8c5007$export$44d1c127ab42c480)(),
    c: new (0, $4dc6bd25aab439bf$export$e447a647caaaec1d)(),
    i: new (0, $4dec0d95ad6f4fdc$export$693fb1e525095b2a)(),
    a: new (0, $e3b18a7fd0b4cae4$export$8d1e08492351df91)(),
    b: new (0, $301bf261fc23f768$export$73ca2bd0a17d273)(),
    B: new (0, $a34970f51ba44935$export$bb9212adf05373db)(),
    h: new (0, $667426d114ad01b2$export$8a04050a727a1756)(),
    H: new (0, $367d60b40b3516bf$export$e56f4dea2c3e56dd)(),
    K: new (0, $4f57cfd1b6150c26$export$cbbe855312f87d77)(),
    k: new (0, $36d68e9c5e24b374$export$6008046d2b34b6a5)(),
    m: new (0, $99d47413b53b711f$export$2b52670d9e2be53)(),
    s: new (0, $7a3e113e81789960$export$94d46d540cf1366a)(),
    S: new (0, $32ee3d7bb7e253b7$export$b8e6f8b2d70893b1)(),
    X: new (0, $69783d320d9578da$export$104d901d49fea29b)(),
    x: new (0, $22e8aa2ad6a4b904$export$12910e5204b52b9)(),
    t: new (0, $f72a3ac23a2adb1a$export$2cd8bf877a05e96)(),
    T: new (0, $676c5dc15428781c$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $97cace6d1f714b04$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $97cace6d1f714b04$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $97cace6d1f714b04$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $97cace6d1f714b04$var$doubleQuoteRegExp = /''/g;
var $97cace6d1f714b04$var$notWhitespaceRegExp = /\S/;
var $97cace6d1f714b04$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $97cace6d1f714b04$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $34725ad826d407f2$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $58d4c6083db81b0b$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $a66c04983d4862bc$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($97cace6d1f714b04$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $60e9229989f36652$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $60e9229989f36652$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($97cace6d1f714b04$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $7c82c484262babb6$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $b87027257b8909ff$export$c6b49d6dceb604a1)(token)) (0, $b87027257b8909ff$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $b87027257b8909ff$export$c6cc36aa33304772)(token)) (0, $b87027257b8909ff$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $1cadfdb6063af430$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($97cace6d1f714b04$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $97cace6d1f714b04$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $97cace6d1f714b04$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $2bbf1bac62878a58$export$2e2bcd8739ae039)(date, (0, $366a4a56a4bc62c1$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $7c82c484262babb6$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $846fc99929bb71b3$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $97cace6d1f714b04$var$cleanEscapedString(input) {
    return input.match($97cace6d1f714b04$var$escapedStringRegExp)[1].replace($97cace6d1f714b04$var$doubleQuoteRegExp, "'");
}





function $1a0c5cfa88810db3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $f4d055175170a8b6$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $1a0c5cfa88810db3$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}




function $6d10bc3ac4faf5b6$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}



function $3ce1940d102d7cf8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $0d5117f350b1bdf8$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $9a9e0af1a09e6c22$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2cd349b4b0303572$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c45f97e3b4fe5562$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a547069edc855704$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $f4320dd0211d24a5$var$__assign = function __assign1() {
    $f4320dd0211d24a5$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4320dd0211d24a5$var$__assign.apply(this, arguments);
};
function $f4320dd0211d24a5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f4320dd0211d24a5$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function $f4320dd0211d24a5$export$2d8c2b43ec0e528(props) {
    return props.mode === "multiple";
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function $f4320dd0211d24a5$export$f7b9f96866ec1964(props) {
    return props.mode === "range";
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function $f4320dd0211d24a5$export$e659ce9b264ea61(props) {
    return props.mode === "single";
}
/**
 * The name of the default CSS classes.
 */ var $f4320dd0211d24a5$var$defaultClassNames = {
    root: "rdp",
    multiple_months: "rdp-multiple_months",
    with_weeknumber: "rdp-with_weeknumber",
    vhidden: "rdp-vhidden",
    button_reset: "rdp-button_reset",
    button: "rdp-button",
    caption: "rdp-caption",
    caption_start: "rdp-caption_start",
    caption_end: "rdp-caption_end",
    caption_between: "rdp-caption_between",
    caption_label: "rdp-caption_label",
    caption_dropdowns: "rdp-caption_dropdowns",
    dropdown: "rdp-dropdown",
    dropdown_month: "rdp-dropdown_month",
    dropdown_year: "rdp-dropdown_year",
    dropdown_icon: "rdp-dropdown_icon",
    months: "rdp-months",
    month: "rdp-month",
    table: "rdp-table",
    tbody: "rdp-tbody",
    tfoot: "rdp-tfoot",
    head: "rdp-head",
    head_row: "rdp-head_row",
    head_cell: "rdp-head_cell",
    nav: "rdp-nav",
    nav_button: "rdp-nav_button",
    nav_button_previous: "rdp-nav_button_previous",
    nav_button_next: "rdp-nav_button_next",
    nav_icon: "rdp-nav_icon",
    row: "rdp-row",
    weeknumber: "rdp-weeknumber",
    cell: "rdp-cell",
    day: "rdp-day",
    day_today: "rdp-day_today",
    day_outside: "rdp-day_outside",
    day_selected: "rdp-day_selected",
    day_disabled: "rdp-day_disabled",
    day_hidden: "rdp-day_hidden",
    day_range_start: "rdp-day_range_start",
    day_range_end: "rdp-day_range_end",
    day_range_middle: "rdp-day_range_middle"
};
/**
 * The default formatter for the caption.
 */ function $f4320dd0211d24a5$var$formatCaption(month, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(month, "LLLL y", options);
}
/**
 * The default formatter for the Day button.
 */ function $f4320dd0211d24a5$var$formatDay(day, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(day, "d", options);
}
/**
 * The default formatter for the Month caption.
 */ function $f4320dd0211d24a5$var$formatMonthCaption(month, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(month, "LLLL", options);
}
/**
 * The default formatter for the week number.
 */ function $f4320dd0211d24a5$var$formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function $f4320dd0211d24a5$var$formatWeekdayName(weekday, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(weekday, "cccccc", options);
}
/**
 * The default formatter for the Year caption.
 */ function $f4320dd0211d24a5$var$formatYearCaption(year, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(year, "yyyy", options);
}
var $f4320dd0211d24a5$var$formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: $f4320dd0211d24a5$var$formatCaption,
    formatDay: $f4320dd0211d24a5$var$formatDay,
    formatMonthCaption: $f4320dd0211d24a5$var$formatMonthCaption,
    formatWeekNumber: $f4320dd0211d24a5$var$formatWeekNumber,
    formatWeekdayName: $f4320dd0211d24a5$var$formatWeekdayName,
    formatYearCaption: $f4320dd0211d24a5$var$formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var $f4320dd0211d24a5$var$labelDay = function labelDay(day, activeModifiers, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(day, "do MMMM (EEEE)", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $f4320dd0211d24a5$var$labelMonthDropdown = function labelMonthDropdown() {
    return "Month: ";
};
/**
 * The default ARIA label for next month button in navigation
 */ var $f4320dd0211d24a5$var$labelNext = function labelNext() {
    return "Go to next month";
};
/**
 * The default ARIA label for previous month button in navigation
 */ var $f4320dd0211d24a5$var$labelPrevious = function labelPrevious() {
    return "Go to previous month";
};
/**
 * The default ARIA label for the Weekday element.
 */ var $f4320dd0211d24a5$var$labelWeekday = function labelWeekday(day, options) {
    return (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(day, "cccc", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $f4320dd0211d24a5$var$labelWeekNumber = function labelWeekNumber(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $f4320dd0211d24a5$var$labelYearDropdown = function labelYearDropdown() {
    return "Year: ";
};
var $f4320dd0211d24a5$var$labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: $f4320dd0211d24a5$var$labelDay,
    labelMonthDropdown: $f4320dd0211d24a5$var$labelMonthDropdown,
    labelNext: $f4320dd0211d24a5$var$labelNext,
    labelPrevious: $f4320dd0211d24a5$var$labelPrevious,
    labelWeekNumber: $f4320dd0211d24a5$var$labelWeekNumber,
    labelWeekday: $f4320dd0211d24a5$var$labelWeekday,
    labelYearDropdown: $f4320dd0211d24a5$var$labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function $f4320dd0211d24a5$var$getDefaultContextValues() {
    var captionLayout = "buttons";
    var classNames = $f4320dd0211d24a5$var$defaultClassNames;
    var locale = (0, $d5a6580ba4c351c8$export$2e2bcd8739ae039);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: $f4320dd0211d24a5$var$formatters,
        labels: $f4320dd0211d24a5$var$labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: "default"
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function $f4320dd0211d24a5$var$parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, $fa420e09b5f264b5$export$2e2bcd8739ae039)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, $e057ce7241b8c298$export$2e2bcd8739ae039)(fromDate) : undefined,
        toDate: toDate ? (0, $e057ce7241b8c298$export$2e2bcd8739ae039)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var $f4320dd0211d24a5$export$5e463664ac32e9a9 = (0, $6cds3.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function $f4320dd0211d24a5$export$a84f964d022d25c(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = $f4320dd0211d24a5$var$getDefaultContextValues();
    var _b = $f4320dd0211d24a5$var$parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== "buttons" && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = "buttons";
    var onSelect;
    if ($f4320dd0211d24a5$export$e659ce9b264ea61(initialProps) || $f4320dd0211d24a5$export$2d8c2b43ec0e528(initialProps) || $f4320dd0211d24a5$export$f7b9f96866ec1964(initialProps)) onSelect = initialProps.onSelect;
    var value = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: $f4320dd0211d24a5$var$__assign({}, initialProps.components),
        formatters: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$5e463664ac32e9a9.Provider, {
        value: value
    }, props.children);
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function $f4320dd0211d24a5$export$332e9e0d64b1f294() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$export$5e463664ac32e9a9);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function $f4320dd0211d24a5$export$5b9f95302ae85eba(props) {
    var _a = $f4320dd0211d24a5$export$332e9e0d64b1f294(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, _$formatCaption = _a.formatters.formatCaption;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id
    }, _$formatCaption(props.displayMonth, {
        locale: locale
    }));
}
/**
 * Render the icon in the styled drop-down.
 */ function $f4320dd0211d24a5$export$eaf28e65c2d9267c(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $f4320dd0211d24a5$var$__assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
        fill: "currentColor",
        fillRule: "nonzero"
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function $f4320dd0211d24a5$export$931cbfb6bfb85fc(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : $f4320dd0211d24a5$export$eaf28e65c2d9267c;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: className,
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("span", {
        className: dayPicker.classNames.vhidden
    }, props["aria-label"]), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("select", {
        name: props.name,
        "aria-label": props["aria-label"],
        className: dayPicker.classNames.dropdown,
        style: dayPicker.styles.dropdown,
        value: value,
        onChange: onChange
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: dayPicker.classNames.caption_label,
        style: dayPicker.styles.caption_label,
        "aria-hidden": "true"
    }, caption, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(IconDropdownComponent, {
        className: dayPicker.classNames.dropdown_icon,
        style: dayPicker.styles.dropdown_icon
    })));
}
/** Render the dropdown to navigate between months. */ function $f4320dd0211d24a5$var$MonthsDropdown(props) {
    var _a;
    var _b = $f4320dd0211d24a5$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, _$formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null);
    if (!toDate) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null);
    var dropdownMonths = [];
    if ((0, $cfa6c444bf3b3ba0$export$2e2bcd8739ae039)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, $f4d055175170a8b6$export$2e2bcd8739ae039)(date, month));
    } else {
        // display all the 12 months
        var date = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, $f4d055175170a8b6$export$2e2bcd8739ae039)(date, month));
    }
    var handleChange = function handleChange(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, $f4d055175170a8b6$export$2e2bcd8739ae039)((0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$931cbfb6bfb85fc;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: _$formatMonthCaption(props.displayMonth, {
            locale: locale
        })
    }, dropdownMonths.map(function(m) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("option", {
            key: m.getMonth(),
            value: m.getMonth()
        }, _$formatMonthCaption(m, {
            locale: locale
        }));
    }));
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function $f4320dd0211d24a5$var$YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = $f4320dd0211d24a5$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, _$formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null);
    if (!toDate) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null);
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, $6d10bc3ac4faf5b6$export$2e2bcd8739ae039)((0, $3ce1940d102d7cf8$export$2e2bcd8739ae039)(new Date()), year));
    var handleChange = function handleChange(e) {
        var newMonth = (0, $6d10bc3ac4faf5b6$export$2e2bcd8739ae039)((0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$931cbfb6bfb85fc;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: _$formatYearCaption(displayMonth, {
            locale: locale
        })
    }, years.map(function(year) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("option", {
            key: year.getFullYear(),
            value: year.getFullYear()
        }, _$formatYearCaption(year, {
            locale: locale
        }));
    }));
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function $f4320dd0211d24a5$var$useControlledValue(defaultValue, controlledValue) {
    var _a = (0, $6cds3.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function $f4320dd0211d24a5$var$getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, $d0991680e59a9314$export$2e2bcd8739ae039)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, $d0991680e59a9314$export$2e2bcd8739ae039)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(initialMonth);
}
/** Controls the navigation state. */ function $f4320dd0211d24a5$var$useNavigationState() {
    var context = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var initialMonth = $f4320dd0211d24a5$var$getInitialMonth(context);
    var _a = $f4320dd0211d24a5$var$useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function goToMonth(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function $f4320dd0211d24a5$var$getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(month);
    var end = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)((0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(start, numberOfMonths));
    var monthsDiff = (0, $d0991680e59a9314$export$2e2bcd8739ae039)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function $f4320dd0211d24a5$var$getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(startingMonth);
    if (!toDate) return (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(month, offset);
    var monthsDiff = (0, $d0991680e59a9314$export$2e2bcd8739ae039)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function $f4320dd0211d24a5$var$getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(startingMonth);
    if (!fromDate) return (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(month, -offset);
    var monthsDiff = (0, $d0991680e59a9314$export$2e2bcd8739ae039)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var $f4320dd0211d24a5$export$3044ab7fdabeaee6 = (0, $6cds3.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function $f4320dd0211d24a5$export$d91daf425539f32f(props) {
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var _a = $f4320dd0211d24a5$var$useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = $f4320dd0211d24a5$var$getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = $f4320dd0211d24a5$var$getNextMonth(currentMonth, dayPicker);
    var previousMonth = $f4320dd0211d24a5$var$getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function isDateDisplayed(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, $63ee334c32f82cb8$export$2e2bcd8739ae039)(date, displayMonth);
        });
    };
    var goToDate = function goToDate(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, $28b36b744929d6ec$export$2e2bcd8739ae039)(date, refDate)) goToMonth((0, $6d0ecf9a428ec130$export$2e2bcd8739ae039)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$3044ab7fdabeaee6.Provider, {
        value: value
    }, props.children);
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $f4320dd0211d24a5$export$d0fd4b7106de2769() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$export$3044ab7fdabeaee6);
    if (!context) throw new Error("useNavigation must be used within a NavigationProvider");
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function $f4320dd0211d24a5$export$6a3605aba74bcb3d(props) {
    var _a;
    var _b = $f4320dd0211d24a5$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = $f4320dd0211d24a5$export$d0fd4b7106de2769().goToMonth;
    var handleMonthChange = function handleMonthChange(newMonth) {
        goToMonth(newMonth);
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$5b9f95302ae85eba;
    var captionLabel = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: classNames.vhidden
    }, captionLabel), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$MonthsDropdown, {
        onChange: handleMonthChange,
        displayMonth: props.displayMonth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$YearsDropdown, {
        onChange: handleMonthChange,
        displayMonth: props.displayMonth
    }));
}
/**
 * Render the "previous month" button in the navigation.
 */ function $f4320dd0211d24a5$export$fac286bb0d0d0385(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $f4320dd0211d24a5$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
        fill: "currentColor",
        fillRule: "nonzero"
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function $f4320dd0211d24a5$export$142e5a7835580ff5(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $f4320dd0211d24a5$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
        fill: "currentColor"
    }));
}
/** Render a button HTML element applying the reset class name. */ var $f4320dd0211d24a5$export$353f5b6fc5456de1 = (0, $6cds3.forwardRef)(function(props, ref) {
    var _a = $f4320dd0211d24a5$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(" ");
    var style = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("button", $f4320dd0211d24a5$var$__assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function $f4320dd0211d24a5$var$Navigation(props) {
    var _a, _b;
    var _c = $f4320dd0211d24a5$export$332e9e0d64b1f294(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null);
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(" ");
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(" ");
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$142e5a7835580ff5;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : $f4320dd0211d24a5$export$fac286bb0d0d0385;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: classNames.nav,
        style: styles.nav
    }, !props.hidePrevious && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$353f5b6fc5456de1, {
        name: "previous-month",
        "aria-label": previousLabel,
        className: previousClassName,
        style: styles.nav_button_previous,
        disabled: !props.previousMonth,
        onClick: props.onPreviousClick
    }, dir === "rtl" ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(IconRightComponent, {
        className: classNames.nav_icon,
        style: styles.nav_icon
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(IconLeftComponent, {
        className: classNames.nav_icon,
        style: styles.nav_icon
    })), !props.hideNext && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$353f5b6fc5456de1, {
        name: "next-month",
        "aria-label": nextLabel,
        className: nextClassName,
        style: styles.nav_button_next,
        disabled: !props.nextMonth,
        onClick: props.onNextClick
    }, dir === "rtl" ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(IconLeftComponent, {
        className: classNames.nav_icon,
        style: styles.nav_icon
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(IconRightComponent, {
        className: classNames.nav_icon,
        style: styles.nav_icon
    })));
}
/**
 * Render a caption with a button-based navigation.
 */ function $f4320dd0211d24a5$export$f6e46da460a028c1(props) {
    var numberOfMonths = $f4320dd0211d24a5$export$332e9e0d64b1f294().numberOfMonths;
    var _a = $f4320dd0211d24a5$export$d0fd4b7106de2769(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, $63ee334c32f82cb8$export$2e2bcd8739ae039)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function handlePreviousClick() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function handleNextClick() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function $f4320dd0211d24a5$export$32fbfacc5d962e0c(props) {
    var _a;
    var _b = $f4320dd0211d24a5$export$332e9e0d64b1f294(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$5b9f95302ae85eba;
    var caption;
    if (disableNavigation) caption = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === "dropdown") caption = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === "dropdown-buttons") caption = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$f6e46da460a028c1, {
        displayMonth: props.displayMonth,
        id: props.id
    }));
    else caption = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$f6e46da460a028c1, {
        displayMonth: props.displayMonth,
        id: props.id
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: classNames.caption,
        style: styles.caption
    }, caption);
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $f4320dd0211d24a5$export$a06f1c675e846f6f(props) {
    var _a = $f4320dd0211d24a5$export$332e9e0d64b1f294(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("tfoot", {
        className: tfoot,
        style: styles.tfoot
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("tr", null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("td", {
        colSpan: 8
    }, footer)));
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $f4320dd0211d24a5$var$getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(new Date()) : (0, $24a377abc374d178$export$2e2bcd8739ae039)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, $a547069edc855704$export$2e2bcd8739ae039)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function $f4320dd0211d24a5$export$b008e842a2213343() {
    var _a = $f4320dd0211d24a5$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, _$formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = $f4320dd0211d24a5$var$getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("tr", {
        style: styles.head_row,
        className: classNames.head_row
    }, showWeekNumber && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("td", {
        style: styles.head_cell,
        className: classNames.head_cell
    }), weekdays.map(function(weekday, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("th", {
            key: i,
            scope: "col",
            className: classNames.head_cell,
            style: styles.head_cell,
            "aria-label": labelWeekday(weekday, {
                locale: locale
            })
        }, _$formatWeekdayName(weekday, {
            locale: locale
        }));
    }));
}
/** Render the table head. */ function $f4320dd0211d24a5$export$e93312b7773dfcac() {
    var _a;
    var _b = $f4320dd0211d24a5$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$b008e842a2213343;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("thead", {
        style: styles.head,
        className: classNames.head
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(HeadRowComponent, null));
}
/** Render the content of the day cell. */ function $f4320dd0211d24a5$export$16d0634337daf8ec(props) {
    var _a = $f4320dd0211d24a5$export$332e9e0d64b1f294(), locale = _a.locale, _$formatDay = _a.formatters.formatDay;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, _$formatDay(props.date, {
        locale: locale
    }));
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var $f4320dd0211d24a5$export$26e3e4d6f601d4d6 = (0, $6cds3.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function $f4320dd0211d24a5$export$913827019032c8d4(props) {
    if (!$f4320dd0211d24a5$export$2d8c2b43ec0e528(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$26e3e4d6f601d4d6.Provider, {
            value: emptyContextValue
        }, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$91128e1c5ca64a0d, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $f4320dd0211d24a5$export$91128e1c5ca64a0d(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function onDayClick(day, activeModifiers, e) {
        var _$_a, _b;
        (_$_a = initialProps.onDayClick) === null || _$_a === void 0 || _$_a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? $f4320dd0211d24a5$var$__spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$26e3e4d6f601d4d6.Provider, {
        value: contextValue
    }, children);
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $f4320dd0211d24a5$export$458361db477d8ed0() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$export$26e3e4d6f601d4d6);
    if (!context) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function $f4320dd0211d24a5$export$27ef550b4e6acc0c(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (!from) return {
        from: day,
        to: undefined
    };
    if (!to && (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(from, day)) return {
        from: from,
        to: day
    };
    if (!to && (0, $28b36b744929d6ec$export$2e2bcd8739ae039)(day, from)) return {
        from: day,
        to: from
    };
    if (!to) return {
        from: from,
        to: day
    };
    if ((0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(to, day) && (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(from, day)) return undefined;
    if ((0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(to, day)) return {
        from: to,
        to: undefined
    };
    if ((0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(from, day)) return undefined;
    if ((0, $c11d30d91d8569f9$export$2e2bcd8739ae039)(from, day)) return {
        from: day,
        to: to
    };
    return {
        from: from,
        to: day
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var $f4320dd0211d24a5$export$49c734aed8c840bb = (0, $6cds3.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function $f4320dd0211d24a5$export$deb49a47c7ee5fdf(props) {
    if (!$f4320dd0211d24a5$export$f7b9f96866ec1964(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$49c734aed8c840bb.Provider, {
            value: emptyContextValue
        }, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$cca59e032fbbe71f, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $f4320dd0211d24a5$export$cca59e032fbbe71f(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function onDayClick(day, activeModifiers, e) {
        var _$_a, _b;
        (_$_a = initialProps.onDayClick) === null || _$_a === void 0 || _$_a.call(initialProps, day, activeModifiers, e);
        var newRange = $f4320dd0211d24a5$export$27ef550b4e6acc0c(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, $9a9e0af1a09e6c22$export$2e2bcd8739ae039)(selectedFrom, min - 1),
            before: (0, $a547069edc855704$export$2e2bcd8739ae039)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, $a547069edc855704$export$2e2bcd8739ae039)(selectedFrom, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, $a547069edc855704$export$2e2bcd8739ae039)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $a547069edc855704$export$2e2bcd8739ae039)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, $b9a67232a996f916$export$2e2bcd8739ae039)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, $9a9e0af1a09e6c22$export$2e2bcd8739ae039)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, $a547069edc855704$export$2e2bcd8739ae039)(selectedTo, offset)
            });
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$49c734aed8c840bb.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        }
    }, children);
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $f4320dd0211d24a5$export$ad0998138eb321e7() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$export$49c734aed8c840bb);
    if (!context) throw new Error("useSelectRange must be used within a SelectRangeProvider");
    return context;
}
/** Normalize to array a matcher input. */ function $f4320dd0211d24a5$var$matcherToArray(matcher) {
    if (Array.isArray(matcher)) return $f4320dd0211d24a5$var$__spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function $f4320dd0211d24a5$var$getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = $f4320dd0211d24a5$var$matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var $f4320dd0211d24a5$export$7652a4f8ecc53eb5;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})($f4320dd0211d24a5$export$7652a4f8ecc53eb5 || ($f4320dd0211d24a5$export$7652a4f8ecc53eb5 = {}));
var $f4320dd0211d24a5$var$Selected = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.Selected, $f4320dd0211d24a5$var$Disabled = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.Disabled, $f4320dd0211d24a5$var$Hidden = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.Hidden, $f4320dd0211d24a5$var$Today = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.Today, $f4320dd0211d24a5$var$RangeEnd = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.RangeEnd, $f4320dd0211d24a5$var$RangeMiddle = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.RangeMiddle, $f4320dd0211d24a5$var$RangeStart = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.RangeStart, $f4320dd0211d24a5$var$Outside = $f4320dd0211d24a5$export$7652a4f8ecc53eb5.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function $f4320dd0211d24a5$var$getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[$f4320dd0211d24a5$var$Selected] = $f4320dd0211d24a5$var$matcherToArray(dayPicker.selected), _a[$f4320dd0211d24a5$var$Disabled] = $f4320dd0211d24a5$var$matcherToArray(dayPicker.disabled), _a[$f4320dd0211d24a5$var$Hidden] = $f4320dd0211d24a5$var$matcherToArray(dayPicker.hidden), _a[$f4320dd0211d24a5$var$Today] = [
        dayPicker.today
    ], _a[$f4320dd0211d24a5$var$RangeEnd] = [], _a[$f4320dd0211d24a5$var$RangeMiddle] = [], _a[$f4320dd0211d24a5$var$RangeStart] = [], _a[$f4320dd0211d24a5$var$Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[$f4320dd0211d24a5$var$Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[$f4320dd0211d24a5$var$Disabled].push({
        after: dayPicker.toDate
    });
    if ($f4320dd0211d24a5$export$2d8c2b43ec0e528(dayPicker)) internalModifiers[$f4320dd0211d24a5$var$Disabled] = internalModifiers[$f4320dd0211d24a5$var$Disabled].concat(selectMultiple.modifiers[$f4320dd0211d24a5$var$Disabled]);
    else if ($f4320dd0211d24a5$export$f7b9f96866ec1964(dayPicker)) {
        internalModifiers[$f4320dd0211d24a5$var$Disabled] = internalModifiers[$f4320dd0211d24a5$var$Disabled].concat(selectRange.modifiers[$f4320dd0211d24a5$var$Disabled]);
        internalModifiers[$f4320dd0211d24a5$var$RangeStart] = selectRange.modifiers[$f4320dd0211d24a5$var$RangeStart];
        internalModifiers[$f4320dd0211d24a5$var$RangeMiddle] = selectRange.modifiers[$f4320dd0211d24a5$var$RangeMiddle];
        internalModifiers[$f4320dd0211d24a5$var$RangeEnd] = selectRange.modifiers[$f4320dd0211d24a5$var$RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var $f4320dd0211d24a5$var$ModifiersContext = (0, $6cds3.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function $f4320dd0211d24a5$var$ModifiersProvider(props) {
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var selectMultiple = $f4320dd0211d24a5$export$458361db477d8ed0();
    var selectRange = $f4320dd0211d24a5$export$ad0998138eb321e7();
    var internalModifiers = $f4320dd0211d24a5$var$getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = $f4320dd0211d24a5$var$getCustomModifiers(dayPicker.modifiers);
    var modifiers = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, internalModifiers), customModifiers);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$ModifiersContext.Provider, {
        value: modifiers
    }, props.children);
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function $f4320dd0211d24a5$var$useModifiers() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$var$ModifiersContext);
    if (!context) throw new Error("useModifiers must be used within a ModifiersProvider");
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function $f4320dd0211d24a5$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function $f4320dd0211d24a5$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function $f4320dd0211d24a5$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function $f4320dd0211d24a5$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function $f4320dd0211d24a5$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/** Return `true` whether `date` is inside `range`. */ function $f4320dd0211d24a5$var$isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (!from) return false;
    if (!to && (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(from, date)) return true;
    if (!to) return false;
    var isRangeInverted = (0, $b9a67232a996f916$export$2e2bcd8739ae039)(to, from) < 0;
    if (isRangeInverted) _a = [
        to,
        from
    ], from = _a[0], to = _a[1];
    var isInRange = (0, $b9a67232a996f916$export$2e2bcd8739ae039)(date, from) >= 0 && (0, $b9a67232a996f916$export$2e2bcd8739ae039)(to, date) >= 0;
    return isInRange;
}
/** Returns true if `value` is a Date type. */ function $f4320dd0211d24a5$var$isDateType(value) {
    return (0, $5bef1fb2b5291d67$export$2e2bcd8739ae039)(value);
}
/** Returns true if `value` is an array of valid dates. */ function $f4320dd0211d24a5$var$isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, $5bef1fb2b5291d67$export$2e2bcd8739ae039));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function $f4320dd0211d24a5$export$b74c33566721f70f(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === "boolean") return matcher;
        if ($f4320dd0211d24a5$var$isDateType(matcher)) return (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(day, matcher);
        if ($f4320dd0211d24a5$var$isArrayOfDates(matcher)) return matcher.includes(day);
        if ($f4320dd0211d24a5$export$dd455b9c98fea187(matcher)) return $f4320dd0211d24a5$var$isDateInRange(day, matcher);
        if ($f4320dd0211d24a5$export$483c833837970a3(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if ($f4320dd0211d24a5$export$654311eaff47f3cd(matcher)) {
            var diffBefore = (0, $b9a67232a996f916$export$2e2bcd8739ae039)(matcher.before, day);
            var diffAfter = (0, $b9a67232a996f916$export$2e2bcd8739ae039)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, $c11d30d91d8569f9$export$2e2bcd8739ae039)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ($f4320dd0211d24a5$export$4760905e07020cd4(matcher)) return (0, $b9a67232a996f916$export$2e2bcd8739ae039)(day, matcher.after) > 0;
        if ($f4320dd0211d24a5$export$a3bef2c4e855ef4e(matcher)) return (0, $b9a67232a996f916$export$2e2bcd8739ae039)(matcher.before, day) > 0;
        if (typeof matcher === "function") return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function $f4320dd0211d24a5$var$getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if ($f4320dd0211d24a5$export$b74c33566721f70f(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, $63ee334c32f82cb8$export$2e2bcd8739ae039)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function $f4320dd0211d24a5$var$getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(displayMonths[0]);
    var lastDayInMonth = (0, $fa420e09b5f264b5$export$2e2bcd8739ae039)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = $f4320dd0211d24a5$var$getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, $a547069edc855704$export$2e2bcd8739ae039)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, $a547069edc855704$export$2e2bcd8739ae039)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var $f4320dd0211d24a5$var$MAX_RETRY = 365;
/** Return the next date to be focused. */ function $f4320dd0211d24a5$var$getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, $a547069edc855704$export$2e2bcd8739ae039),
        week: (0, $606915c4cd25bdf9$export$2e2bcd8739ae039),
        month: (0, $6d0ecf9a428ec130$export$2e2bcd8739ae039),
        year: (0, $9296fdc2fbd3affb$export$2e2bcd8739ae039),
        startOfWeek: function startOfWeek1(date) {
            return context.ISOWeek ? (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(date) : (0, $24a377abc374d178$export$2e2bcd8739ae039)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function endOfWeek1(date) {
            return context.ISOWeek ? (0, $e5091816f47eca48$export$2e2bcd8739ae039)(date) : (0, $fb7133dd2ccac13e$export$2e2bcd8739ae039)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
    if (direction === "before" && fromDate) newFocusedDay = (0, $0127433a1b264500$export$2e2bcd8739ae039)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === "after" && toDate) newFocusedDay = (0, $12f073eb98306650$export$2e2bcd8739ae039)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = $f4320dd0211d24a5$var$getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > $f4320dd0211d24a5$var$MAX_RETRY) return retry.lastFocused;
        return $f4320dd0211d24a5$var$getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var $f4320dd0211d24a5$export$e1f21ba6aeca320f = (0, $6cds3.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function $f4320dd0211d24a5$export$97cf4ab9b312b61a(props) {
    var navigation = $f4320dd0211d24a5$export$d0fd4b7106de2769();
    var modifiers = $f4320dd0211d24a5$var$useModifiers();
    var _a = (0, $6cds3.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, $6cds3.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = $f4320dd0211d24a5$var$getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function blur() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function focus(date) {
        setFocusedDay(date);
    };
    var context = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var moveFocus = function moveFocus(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = $f4320dd0211d24a5$var$getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function focusDayAfter() {
            return moveFocus("day", "after");
        },
        focusDayBefore: function focusDayBefore() {
            return moveFocus("day", "before");
        },
        focusWeekAfter: function focusWeekAfter() {
            return moveFocus("week", "after");
        },
        focusWeekBefore: function focusWeekBefore() {
            return moveFocus("week", "before");
        },
        focusMonthBefore: function focusMonthBefore() {
            return moveFocus("month", "before");
        },
        focusMonthAfter: function focusMonthAfter() {
            return moveFocus("month", "after");
        },
        focusYearBefore: function focusYearBefore() {
            return moveFocus("year", "before");
        },
        focusYearAfter: function focusYearAfter() {
            return moveFocus("year", "after");
        },
        focusStartOfWeek: function focusStartOfWeek() {
            return moveFocus("startOfWeek", "before");
        },
        focusEndOfWeek: function focusEndOfWeek() {
            return moveFocus("endOfWeek", "after");
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$e1f21ba6aeca320f.Provider, {
        value: value
    }, props.children);
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $f4320dd0211d24a5$export$69130071837c676e() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$export$e1f21ba6aeca320f);
    if (!context) throw new Error("useFocusContext must be used within a FocusProvider");
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function $f4320dd0211d24a5$export$174df9b23ec1eb4b(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = $f4320dd0211d24a5$var$useModifiers();
    var activeModifiers = $f4320dd0211d24a5$var$getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var $f4320dd0211d24a5$export$9632b0427d86eff3 = (0, $6cds3.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function $f4320dd0211d24a5$export$d40a11a5bbe785ba(props) {
    if (!$f4320dd0211d24a5$export$e659ce9b264ea61(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$9632b0427d86eff3.Provider, {
            value: emptyContextValue
        }, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$37bf09040cff7c3b, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $f4320dd0211d24a5$export$37bf09040cff7c3b(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function onDayClick(day, activeModifiers, e) {
        var _$_a, _b, _c;
        (_$_a = initialProps.onDayClick) === null || _$_a === void 0 || _$_a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$9632b0427d86eff3.Provider, {
        value: contextValue
    }, children);
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $f4320dd0211d24a5$export$2d75d772c98e4b05() {
    var context = (0, $6cds3.useContext)($f4320dd0211d24a5$export$9632b0427d86eff3);
    if (!context) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function $f4320dd0211d24a5$var$useDayEventHandlers(date, activeModifiers) {
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var single = $f4320dd0211d24a5$export$2d75d772c98e4b05();
    var multiple = $f4320dd0211d24a5$export$458361db477d8ed0();
    var range = $f4320dd0211d24a5$export$ad0998138eb321e7();
    var _a = $f4320dd0211d24a5$export$69130071837c676e(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function onClick(e) {
        var _a, _b, _c, _d;
        if ($f4320dd0211d24a5$export$e659ce9b264ea61(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if ($f4320dd0211d24a5$export$2d8c2b43ec0e528(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if ($f4320dd0211d24a5$export$f7b9f96866ec1964(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function onFocus(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function onBlur(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function onMouseEnter(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function onMouseLeave(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function onPointerEnter(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function onPointerLeave(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function onTouchCancel(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function onTouchEnd(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function onTouchMove(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function onTouchStart(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function onKeyUp(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function onKeyDown(e) {
        var _a;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function $f4320dd0211d24a5$var$useSelectedDays() {
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var single = $f4320dd0211d24a5$export$2d75d772c98e4b05();
    var multiple = $f4320dd0211d24a5$export$458361db477d8ed0();
    var range = $f4320dd0211d24a5$export$ad0998138eb321e7();
    var selectedDays = $f4320dd0211d24a5$export$e659ce9b264ea61(dayPicker) ? single.selected : $f4320dd0211d24a5$export$2d8c2b43ec0e528(dayPicker) ? multiple.selected : $f4320dd0211d24a5$export$f7b9f96866ec1964(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function $f4320dd0211d24a5$var$isInternalModifier(modifier) {
    return Object.values($f4320dd0211d24a5$export$7652a4f8ecc53eb5).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function $f4320dd0211d24a5$var$getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if ($f4320dd0211d24a5$var$isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function $f4320dd0211d24a5$var$getDayStyle(dayPicker, activeModifiers) {
    var style = $f4320dd0211d24a5$var$__assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function $f4320dd0211d24a5$export$634dab6d85b953fc(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var focusContext = $f4320dd0211d24a5$export$69130071837c676e();
    var activeModifiers = $f4320dd0211d24a5$export$174df9b23ec1eb4b(day, displayMonth);
    var eventHandlers = $f4320dd0211d24a5$var$useDayEventHandlers(day, activeModifiers);
    var selectedDays = $f4320dd0211d24a5$var$useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
    // Focus the button if the day is focused according to the focus context
    (0, $6cds3.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = $f4320dd0211d24a5$var$getDayClassNames(dayPicker, activeModifiers).join(" ");
    var style = $f4320dd0211d24a5$var$getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : $f4320dd0211d24a5$export$16d0634337daf8ec;
    var children = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: "gridcell"
    };
    var isFocusTarget = focusContext.focusTarget && (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, $bdd887e93cf852b9$export$2e2bcd8739ae039)(focusContext.focusedDay, day);
    var buttonProps = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: "gridcell"
    }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function $f4320dd0211d24a5$export$7a9a31a911eb9a20(props) {
    var buttonRef = (0, $6cds3.useRef)(null);
    var dayRender = $f4320dd0211d24a5$export$634dab6d85b953fc(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", $f4320dd0211d24a5$var$__assign({}, dayRender.divProps));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$353f5b6fc5456de1, $f4320dd0211d24a5$var$__assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function $f4320dd0211d24a5$export$f52f5e0fedb732da(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = $f4320dd0211d24a5$export$332e9e0d64b1f294(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, _$formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = _$formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber
    }, content);
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function handleClick(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$353f5b6fc5456de1, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick
    }, content);
}
/** Render a row in the calendar, with the days and the week number. */ function $f4320dd0211d24a5$export$b59bdbef9ce70de2(props) {
    var _a, _b;
    var _c = $f4320dd0211d24a5$export$332e9e0d64b1f294(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$7a9a31a911eb9a20;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : $f4320dd0211d24a5$export$f52f5e0fedb732da;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("td", {
        className: classNames.cell,
        style: styles.cell
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(WeeknumberComponent, {
        number: props.weekNumber,
        dates: props.dates
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("tr", {
        className: classNames.row,
        style: styles.row
    }, weekNumberCell, props.dates.map(function(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("td", {
            className: classNames.cell,
            style: styles.cell,
            key: (0, $8ebe16428d511cf5$export$2e2bcd8739ae039)(date),
            role: "presentation"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(DayComponent, {
            displayMonth: props.displayMonth,
            date: date
        }));
    }));
}
/** Return the weeks between two dates.  */ function $f4320dd0211d24a5$var$daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $e5091816f47eca48$export$2e2bcd8739ae039)(toDate) : (0, $fb7133dd2ccac13e$export$2e2bcd8739ae039)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $43d4a3484b08b076$export$2e2bcd8739ae039)(fromDate) : (0, $24a377abc374d178$export$2e2bcd8739ae039)(fromDate, options);
    var nOfDays = (0, $b9a67232a996f916$export$2e2bcd8739ae039)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, $a547069edc855704$export$2e2bcd8739ae039)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $954778d92ca562fe$export$2e2bcd8739ae039)(date) : (0, $82220a43b29e96d8$export$2e2bcd8739ae039)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function $f4320dd0211d24a5$var$getMonthWeeks(month, options) {
    var weeksInMonth = $f4320dd0211d24a5$var$daysToMonthWeeks((0, $a22bbf2dcd1a235a$export$2e2bcd8739ae039)(month), (0, $fa420e09b5f264b5$export$2e2bcd8739ae039)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, $1fafae7b955e044e$export$2e2bcd8739ae039)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, $606915c4cd25bdf9$export$2e2bcd8739ae039)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = $f4320dd0211d24a5$var$daysToMonthWeeks((0, $606915c4cd25bdf9$export$2e2bcd8739ae039)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function $f4320dd0211d24a5$var$Table(props) {
    var _a, _b, _c;
    var _d = $f4320dd0211d24a5$export$332e9e0d64b1f294(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = $f4320dd0211d24a5$var$getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : $f4320dd0211d24a5$export$e93312b7773dfcac;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : $f4320dd0211d24a5$export$b59bdbef9ce70de2;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : $f4320dd0211d24a5$export$a06f1c675e846f6f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props["aria-labelledby"]
    }, !hideHead && (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(HeadComponent, null), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("tbody", {
        className: classNames.tbody,
        style: styles.tbody,
        role: "rowgroup"
    }, weeks.map(function(week) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(RowComponent, {
            displayMonth: props.displayMonth,
            key: week.weekNumber,
            dates: week.dates,
            weekNumber: week.weekNumber
        });
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(FooterComponent, {
        displayMonth: props.displayMonth
    }));
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ function $f4320dd0211d24a5$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $f4320dd0211d24a5$var$useIsomorphicLayoutEffect = $f4320dd0211d24a5$var$canUseDOM() ? $6cds3.useLayoutEffect : $6cds3.useEffect;
var $f4320dd0211d24a5$var$serverHandoffComplete = false;
var $f4320dd0211d24a5$var$id = 0;
function $f4320dd0211d24a5$var$genId() {
    return "react-day-picker-".concat(++$f4320dd0211d24a5$var$id);
}
function $f4320dd0211d24a5$var$useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : $f4320dd0211d24a5$var$serverHandoffComplete ? $f4320dd0211d24a5$var$genId() : null;
    var _b = $6cds3.useState(initialId), id = _b[0], setId = _b[1];
    $f4320dd0211d24a5$var$useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId($f4320dd0211d24a5$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6cds3.useEffect(function() {
        if ($f4320dd0211d24a5$var$serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        $f4320dd0211d24a5$var$serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function $f4320dd0211d24a5$var$Month(props) {
    var _a;
    var _b;
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = $f4320dd0211d24a5$export$d0fd4b7106de2769().displayMonths;
    var captionId = $f4320dd0211d24a5$var$useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === "rtl") _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : $f4320dd0211d24a5$export$32fbfacc5d962e0c;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        key: props.displayIndex,
        className: className.join(" "),
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(CaptionComponent, {
        id: captionId,
        displayMonth: props.displayMonth
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$Table, {
        id: tableId,
        "aria-labelledby": captionId,
        displayMonth: props.displayMonth
    }));
}
/** Render the container with the months according to the number of months to display. */ function $f4320dd0211d24a5$var$Root(_a) {
    var initialProps = _a.initialProps;
    var dayPicker = $f4320dd0211d24a5$export$332e9e0d64b1f294();
    var focusContext = $f4320dd0211d24a5$export$69130071837c676e();
    var navigation = $f4320dd0211d24a5$export$d0fd4b7106de2769();
    var _b = (0, $6cds3.useState)(false), hasInitialFocus = _b[0], setHasInitialFocus = _b[1];
    // Focus the focus target when initialFocus is passed in
    (0, $6cds3.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith("data-");
    }).reduce(function(attrs, key) {
        var _$_a;
        return $f4320dd0211d24a5$var$__assign($f4320dd0211d24a5$var$__assign({}, attrs), (_$_a = {}, _$_a[key] = initialProps[key], _$_a));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", $f4320dd0211d24a5$var$__assign({
        className: classNames.join(" "),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id
    }, dataAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: dayPicker.classNames.months,
        style: dayPicker.styles.months
    }, navigation.displayMonths.map(function(month, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$Month, {
            key: i,
            displayIndex: i,
            displayMonth: month
        });
    })));
}
/** Provide the value for all the context providers. */ function $f4320dd0211d24a5$export$8f349d07558f59c4(props) {
    var children = props.children, initialProps = $f4320dd0211d24a5$var$__rest(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$a84f964d022d25c, {
        initialProps: initialProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$d91daf425539f32f, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$d40a11a5bbe785ba, {
        initialProps: initialProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$913827019032c8d4, {
        initialProps: initialProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$deb49a47c7ee5fdf, {
        initialProps: initialProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$ModifiersProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$97cf4ab9b312b61a, null, children)))))));
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function $f4320dd0211d24a5$export$97e6db89a86ff7ab(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$export$8f349d07558f59c4, $f4320dd0211d24a5$var$__assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($f4320dd0211d24a5$var$Root, {
        initialProps: props
    }));
}
/** @private */ function $f4320dd0211d24a5$var$isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function $f4320dd0211d24a5$export$1e36b9f257eee5fa(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, $d5a6580ba4c351c8$export$2e2bcd8739ae039) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? "PP" : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = $f4320dd0211d24a5$var$parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function parseValue(value) {
        return (0, $97cace6d1f714b04$export$2e2bcd8739ae039)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, $6cds3.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, $6cds3.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(defaultSelected, format$1, {
        locale: locale
    }) : "";
    var _g = (0, $6cds3.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function reset() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    };
    var setSelected = function setSelected(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(date, format$1, {
            locale: locale
        }) : "");
    };
    var handleDayClick = function handleDayClick(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue("");
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(day, format$1, {
            locale: locale
        }) : "");
    };
    var handleMonthChange = function handleMonthChange(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function handleChange(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, $b9a67232a996f916$export$2e2bcd8739ae039)(fromDate, day) > 0;
        var isAfter = toDate && (0, $b9a67232a996f916$export$2e2bcd8739ae039)(day, toDate) > 0;
        if (!$f4320dd0211d24a5$var$isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function handleBlur(e) {
        var day = parseValue(e.target.value);
        if (!$f4320dd0211d24a5$var$isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function handleFocus(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if ($f4320dd0211d24a5$var$isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function $f4320dd0211d24a5$export$92cab9761365b1ec(props) {
    return props.mode === undefined || props.mode === "default";
}




function $bdb794e41bdf86a6$export$e1aef45b828286de(_param) {
    var className = _param.className, classNames = _param.classNames, _param_showOutsideDays = _param.showOutsideDays, showOutsideDays = _param_showOutsideDays === void 0 ? true : _param_showOutsideDays, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "classNames",
        "showOutsideDays"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f4320dd0211d24a5$export$97e6db89a86ff7ab), (0, $8OnJk._)({
        showOutsideDays: showOutsideDays,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("p-3", className),
        classNames: (0, $8OnJk._)({
            months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
            month: "space-y-4",
            caption: "flex justify-center pt-1 relative items-center",
            caption_label: "text-sm font-medium",
            nav: "space-x-1 flex items-center",
            nav_button: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                variant: "outline"
            }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
            nav_button_previous: "absolute left-1",
            nav_button_next: "absolute right-1",
            table: "w-full border-collapse space-y-1",
            head_row: "flex",
            head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
            row: "flex w-full mt-2",
            cell: "text-center text-sm p-0 relative [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
            day: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)((0, $dab50cebba406f42$export$dca1ee5a936bb312)({
                variant: "ghost"
            }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
            day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
            day_today: "bg-accent text-accent-foreground",
            day_outside: "text-muted-foreground opacity-50",
            day_disabled: "text-muted-foreground opacity-50",
            day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
            day_hidden: "invisible"
        }, classNames),
        components: {
            IconLeft: function(_param) /*#__PURE__*/ {
                var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
                return (0, $fba0f23e9e6a11bb$exports.jsx)((0, $625d457db8fc666f$export$2e2bcd8739ae039), {
                    className: "h-4 w-4"
                });
            },
            IconRight: function(_param) /*#__PURE__*/ {
                var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
                return (0, $fba0f23e9e6a11bb$exports.jsx)((0, $96fc56be218b0aba$export$2e2bcd8739ae039), {
                    className: "h-4 w-4"
                });
            }
        }
    }, props));
}
$bdb794e41bdf86a6$export$e1aef45b828286de.displayName = "Calendar";






var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");



var $6cds3 = parcelRequire("6cds3");




var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

/* -------------------------------------------------------------------------------------------------
 * Label
 * -----------------------------------------------------------------------------------------------*/ var $6feb0bbf10767917$var$$b73a6c6685e72184$var$NAME = "Label";
var $6feb0bbf10767917$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, forwardedRef) {
    return /*#__PURE__*/ (0, $6cds3.createElement)((0, $02d9b2ca3ec07cdd$export$250ffa63cdc0d034).label, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        onMouseDown: function(event) {
            var _props$onMouseDown;
            (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, event); // prevent text selection when double clicking label
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    }));
});
/*#__PURE__*/ Object.assign($6feb0bbf10767917$export$b04be29aa201d4f5, {
    displayName: $6feb0bbf10767917$var$$b73a6c6685e72184$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $6feb0bbf10767917$export$be92b6f5f03c0fe9 = $6feb0bbf10767917$export$b04be29aa201d4f5;




var $e3ccf5fd9ad654e7$var$labelVariants = (0, $817718bbc98c41ca$export$87dc52566e90b739)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
var $e3ccf5fd9ad654e7$export$b04be29aa201d4f5 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)($6feb0bbf10767917$export$be92b6f5f03c0fe9, (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)($e3ccf5fd9ad654e7$var$labelVariants(), className)
    }, props));
});
$e3ccf5fd9ad654e7$export$b04be29aa201d4f5.displayName = $6feb0bbf10767917$export$be92b6f5f03c0fe9.displayName;


var $8526f68d88b7d8ed$export$a7fed597f4b8afd8 = (0, $ba34d1ebd6528b77$export$8ce1ff4f94d08846);
var $8526f68d88b7d8ed$var$FormFieldContext = /*#__PURE__*/ $6cds3.createContext({});
var $8526f68d88b7d8ed$export$56e87bf42978147a = function(_param) {
    var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8526f68d88b7d8ed$var$FormFieldContext.Provider, {
        value: {
            name: props.name
        },
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ba34d1ebd6528b77$export$bd0bf19f25da8474), (0, $8OnJk._)({}, props))
    });
};
var $8526f68d88b7d8ed$export$b0aeb07a3112de27 = function() {
    var fieldContext = $6cds3.useContext($8526f68d88b7d8ed$var$FormFieldContext);
    var itemContext = $6cds3.useContext($8526f68d88b7d8ed$var$FormItemContext);
    var _useFormContext = (0, $ba34d1ebd6528b77$export$4d957a5e1be13b03)(), getFieldState = _useFormContext.getFieldState, formState = _useFormContext.formState;
    var fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) throw new Error("useFormField should be used within <FormField>");
    var id = itemContext.id;
    return (0, $8OnJk._)({
        id: id,
        name: fieldContext.name,
        formItemId: "".concat(id, "-form-item"),
        formDescriptionId: "".concat(id, "-form-item-description"),
        formMessageId: "".concat(id, "-form-item-message")
    }, fieldState);
};
var $8526f68d88b7d8ed$var$FormItemContext = /*#__PURE__*/ $6cds3.createContext({});
var $8526f68d88b7d8ed$export$6713ee24224a3285 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    var id = $6cds3.useId();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($8526f68d88b7d8ed$var$FormItemContext.Provider, {
        value: {
            id: id
        },
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8OnJk._)({
            ref: ref,
            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("space-y-2", className)
        }, props))
    });
});
$8526f68d88b7d8ed$export$6713ee24224a3285.displayName = "FormItem";
var $8526f68d88b7d8ed$export$842aba50ed0ce9d7 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    var _useFormField = $8526f68d88b7d8ed$export$b0aeb07a3112de27(), error = _useFormField.error, formItemId = _useFormField.formItemId;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e3ccf5fd9ad654e7$export$b04be29aa201d4f5), (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)(error && "text-destructive", className),
        htmlFor: formItemId
    }, props));
});
$8526f68d88b7d8ed$export$842aba50ed0ce9d7.displayName = "FormLabel";
var $8526f68d88b7d8ed$export$fe5d99d8691b3f62 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var props = (0, $877ef6de280e80e7$export$c90d7ca213038c72)({}, (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(_param));
    var _useFormField = $8526f68d88b7d8ed$export$b0aeb07a3112de27(), error = _useFormField.error, formItemId = _useFormField.formItemId, formDescriptionId = _useFormField.formDescriptionId, formMessageId = _useFormField.formMessageId;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $513654131ef3bd4b$export$8c6ed5c666ac1360), (0, $8OnJk._)({
        ref: ref,
        id: formItemId,
        "aria-describedby": !error ? "".concat(formDescriptionId) : "".concat(formDescriptionId, " ").concat(formMessageId),
        "aria-invalid": !!error
    }, props));
});
$8526f68d88b7d8ed$export$fe5d99d8691b3f62.displayName = "FormControl";
var $8526f68d88b7d8ed$export$3d84b9e998b8ea49 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    var formDescriptionId = $8526f68d88b7d8ed$export$b0aeb07a3112de27().formDescriptionId;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", (0, $8OnJk._)({
        ref: ref,
        id: formDescriptionId,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("text-sm text-muted-foreground", className)
    }, props));
});
$8526f68d88b7d8ed$export$3d84b9e998b8ea49.displayName = "FormDescription";
var $8526f68d88b7d8ed$export$2e8ae7a1a126169a = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className",
        "children"
    ]);
    var _useFormField = $8526f68d88b7d8ed$export$b0aeb07a3112de27(), error = _useFormField.error, formMessageId = _useFormField.formMessageId;
    var body = error ? String(error === null || error === void 0 ? void 0 : error.message) : children;
    if (!body) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", (0, $8E768._)((0, $8OnJk._)({
        ref: ref,
        id: formMessageId,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("text-sm font-medium text-destructive", className)
    }, props), {
        children: body
    }));
});
$8526f68d88b7d8ed$export$2e8ae7a1a126169a.displayName = "FormMessage";



var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");

var $e65217ce862c5e5a$export$379139ebc1c2b235 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("textarea", (0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className),
        ref: ref
    }, props));
});
$e65217ce862c5e5a$export$379139ebc1c2b235.displayName = "Textarea";






var $feb808b5dc42c31c$var$formSchema = $bc80ebcf21bfccd0$export$be5493f9613cbbe({
    title: $bc80ebcf21bfccd0$export$22b082955e083ec3().min(1).max(50),
    totalAmount: $bc80ebcf21bfccd0$export$98e628dec113755e().positive(),
    startDate: $bc80ebcf21bfccd0$export$324d90190a8b822a(),
    endDate: $bc80ebcf21bfccd0$export$324d90190a8b822a(),
    description: $bc80ebcf21bfccd0$export$22b082955e083ec3().min(1),
    files: $bc80ebcf21bfccd0$export$4154a199d7d90455()
});
function $feb808b5dc42c31c$export$e60bd9050663d25c(_param) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    var navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var _React_useContext = $6cds3.useContext((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)), isSignedIn = _React_useContext.isSignedIn, wallet = _React_useContext.wallet, contractId = _React_useContext.contractId;
    var _React_useContext1 = $6cds3.useContext((0, $ff67f583320e0759$export$eae686c5662f0382)), contracts = _React_useContext1.contracts, setContracts = _React_useContext1.setContracts;
    var form = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)({
        resolver: (0, $682e60b97368662c$export$66b7b5879c70f722)($feb808b5dc42c31c$var$formSchema),
        defaultValues: {
            title: "",
            totalAmount: 0,
            startDate: undefined,
            endDate: undefined
        }
    });
    var _React_useState = (0, $8GFUW._)($6cds3.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    function onSubmit(values) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0, $byzP8._)(function(values) {
            var values1, result, newContract, err, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoading(true);
                        values1 = form.getValues();
                        (0, $4a6d5b98f5a54c19$exports.globalLoading).show();
                        return [
                            4,
                            (0, $2bbfe96e4adedbff$export$7c4d5b09373bb58d)(wallet, contractId, values1.title, values1.description, false, values1.startDate, values1.endDate)
                        ];
                    case 1:
                        result = _state.sent();
                        console.log(result);
                        if (result.status === "CREATED") navigate("/dashboard/lister");
                        newContract = {
                            name: values1.title,
                            amount: values1.totalAmount.toString(),
                            description: values1.description,
                            startDate: values1.startDate,
                            endDate: values1.endDate,
                            files: [
                                ""
                            ],
                            owner: "",
                            id: Math.round(Math.random() * 100).toString(),
                            status: "progress"
                        };
                        setContracts((0, $fLnyw._)(contracts).concat([
                            newContract
                        ]));
                        (0, $4a6d5b98f5a54c19$exports.globalLoading).hide();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        error = err;
                        (0, $a65c6a8ddb514a0f$export$b410431fab84fa58)({
                            title: "Failed to signin/signup",
                            description: error === null || error === void 0 ? void 0 : error.message,
                            variant: "destructive"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    $6cds3.useEffect(function() {
        return function() {};
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8E768._)((0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("grid gap-6 px-2", className)
    }, props), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$a7fed597f4b8afd8), (0, $8E768._)((0, $8OnJk._)({}, form), {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("form", {
                onSubmit: form.handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                    disabled: loading,
                    className: "grid grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "title",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Title"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "Mumbai Delhi Expressway Project..."
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "totalAmount",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Total Amount"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8E768._)((0, $8OnJk._)({
                                                placeholder: "$1000",
                                                type: "number"
                                            }, field), {
                                                onChange: function(e) {
                                                    return field.onChange(Number.parseFloat(e.target.value));
                                                }
                                            }))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "startDate",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "flex flex-col w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Start Date"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $92ca368498d82bb0$export$5b6b19405a83ff9d), {
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92ca368498d82bb0$export$7dacb05d26466c3), {
                                                    asChild: true,
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                                                            variant: "outline",
                                                            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("pl-3 text-left font-normal w-full", !field.value && "text-muted-foreground"),
                                                            children: [
                                                                field.value ? (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(field.value, "PPP") : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    children: "Pick a date"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $baade51261a67af7$export$2e2bcd8739ae039), {
                                                                    className: "ml-auto h-4 w-4 opacity-50"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92ca368498d82bb0$export$d7e1f420b25549ff), {
                                                    className: "w-auto p-0",
                                                    align: "start",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bdb794e41bdf86a6$export$e1aef45b828286de), {
                                                        mode: "single",
                                                        selected: field.value,
                                                        // @ts-ignore
                                                        onSelect: field.onChange,
                                                        initialFocus: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "endDate",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "flex flex-col w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "End Date"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $92ca368498d82bb0$export$5b6b19405a83ff9d), {
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92ca368498d82bb0$export$7dacb05d26466c3), {
                                                    asChild: true,
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                                                            variant: "outline",
                                                            className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("pl-3 text-left font-normal w-full", !field.value && "text-muted-foreground"),
                                                            children: [
                                                                field.value ? (0, $03c5e06834f993e7$export$2e2bcd8739ae039)(field.value, "PPP") : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    children: "Pick a date"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $baade51261a67af7$export$2e2bcd8739ae039), {
                                                                    className: "ml-auto h-4 w-4 opacity-50"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92ca368498d82bb0$export$d7e1f420b25549ff), {
                                                    className: "w-auto p-0",
                                                    align: "start",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bdb794e41bdf86a6$export$e1aef45b828286de), {
                                                        mode: "single",
                                                        selected: field.value,
                                                        // @ts-ignore
                                                        onSelect: field.onChange,
                                                        initialFocus: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "description",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e65217ce862c5e5a$export$379139ebc1c2b235), (0, $8OnJk._)({
                                                placeholder: "Enter as much details as possible",
                                                rows: 5
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "files",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "File(s)"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "Select Images or PDFs",
                                                type: "file",
                                                accept: "image/*, application/pdf",
                                                multiple: true
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                            type: "submit",
                            className: "col-span-2 mt-6",
                            children: "Add"
                        })
                    ]
                })
            })
        }))
    }));
}




var $b3a72b81d4e7bb19$var$NewContract = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var ref1 = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)((0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)));
    var _useContext = (0, $6cds3.useContext)((0, $ff67f583320e0759$export$eae686c5662f0382)), contracts = _useContext.contracts, setContracts = _useContext.setContracts;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var submitForm = function() {
        var _ref = (0, $byzP8._)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                if (loading) return [
                    2
                ];
                setLoading(true);
                setLoading(false);
                return [
                    2
                ];
            });
        });
        return function submitForm() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fcc03b285aec188$export$2e2bcd8739ae039), {
        type: "lister",
        loading: false,
        heading: "",
        text: "",
        buttonLabel: "",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3d427baccb8d4aec$export$fba5249c7bd13e1f), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abed61b84e9aa1ca$export$f35abaf34fd2d2bf), {
                    heading: "Add Contract",
                    text: "Create and manage your contracts.",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                        to: "/dashboard/lister",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                            variant: "outline",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).users, {
                                    className: "mr-2 h-4 w-4"
                                }),
                                "View My Contracts"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $feb808b5dc42c31c$export$e60bd9050663d25c), {})
            ]
        })
    });
};
var $b3a72b81d4e7bb19$export$2e2bcd8739ae039 = $b3a72b81d4e7bb19$var$NewContract;



var $byzP8 = parcelRequire("byzP8");


var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");










var $30fc099107e2db55$var$BidderDashboard = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var ref1 = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)((0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)));
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    // const [contracts, setContracts] = useState<Contract[]>([]);
    var _useContext = (0, $6cds3.useContext)((0, $ff67f583320e0759$export$eae686c5662f0382)), contracts = _useContext.contracts, setContracts = _useContext.setContracts;
    var getContracts = function() {
        var _ref = (0, $byzP8._)(function() {
            var contracts;
            return (0, $7UAGh.__generator)(this, function(_state) {
                if (loading) return [
                    2
                ];
                setLoading(true);
                try {
                    contracts = (0, $c9896781e2e17aea$export$adf7f6a47eb011b3);
                    setContracts(contracts);
                } catch (e) {
                    console.log(e);
                } finally{
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function getContracts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $6cds3.useEffect)(function() {
        getContracts();
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fcc03b285aec188$export$2e2bcd8739ae039), {
        type: "bidder",
        loading: loading,
        heading: "My Bids",
        text: "View and Manage Bids",
        buttonLabel: "Available Contract",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3d427baccb8d4aec$export$fba5249c7bd13e1f), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abed61b84e9aa1ca$export$f35abaf34fd2d2bf), {
                    heading: "My Bids",
                    text: "View and manage your bids.",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                        to: "/bid/all",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                            variant: "outline",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e4adbb94da664e1$export$4f13f83fd8bb1dac).add, {
                                    className: "mr-2 h-4 w-4"
                                }),
                                "Available Bids"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fd777e58ebd560c$export$161ed36b9c17dff5), {
                    contracts: contracts
                })
            ]
        })
    });
};
var $30fc099107e2db55$export$2e2bcd8739ae039 = $30fc099107e2db55$var$BidderDashboard;






var $6cds3 = parcelRequire("6cds3");



var $8OnJk = parcelRequire("8OnJk");



var $6cds3 = parcelRequire("6cds3");

var $44b31678df0b8391$export$60332b2344f7fe41 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("rounded-lg border bg-card text-card-foreground shadow-sm", className)
    }, props));
});
$44b31678df0b8391$export$60332b2344f7fe41.displayName = "Card";
var $44b31678df0b8391$export$5665775b26e26c5d = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("flex flex-col space-y-1.5 p-6", className)
    }, props));
});
$44b31678df0b8391$export$5665775b26e26c5d.displayName = "CardHeader";
var $44b31678df0b8391$export$474db65c3c394e1c = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("h3", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
$44b31678df0b8391$export$474db65c3c394e1c.displayName = "CardTitle";
var $44b31678df0b8391$export$16e0ed4cb97c00d4 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("p", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("text-sm text-muted-foreground", className)
    }, props));
});
$44b31678df0b8391$export$16e0ed4cb97c00d4.displayName = "CardDescription";
var $44b31678df0b8391$export$64ef9b8c11710c47 = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("p-6 pt-0", className)
    }, props));
});
$44b31678df0b8391$export$64ef9b8c11710c47.displayName = "CardContent";
var $44b31678df0b8391$export$e9897d434e0741ee = /*#__PURE__*/ $6cds3.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8OnJk._)({
        ref: ref,
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)(" flex items-center p-6 pt-0", className)
    }, props));
});
$44b31678df0b8391$export$e9897d434e0741ee.displayName = "CardFooter";



var $byzP8 = parcelRequire("byzP8");

var $8OnJk = parcelRequire("8OnJk");

var $8E768 = parcelRequire("8E768");


var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");











var $e1f494b02f72e814$var$formSchema = $bc80ebcf21bfccd0$export$be5493f9613cbbe({
    firstName: $bc80ebcf21bfccd0$export$22b082955e083ec3().min(1).max(50),
    lastName: $bc80ebcf21bfccd0$export$22b082955e083ec3().min(1).max(50),
    email: $bc80ebcf21bfccd0$export$22b082955e083ec3().email(),
    licenseNo: $bc80ebcf21bfccd0$export$22b082955e083ec3().min(4),
    licensePhoto: $bc80ebcf21bfccd0$export$4154a199d7d90455(),
    profilePhoto: $bc80ebcf21bfccd0$export$4154a199d7d90455().optional()
});
function $e1f494b02f72e814$export$4877859cf31d237(_param) {
    var className = _param.className, props = (0, $c4006311849aa271$export$69fdd232f62cde60)(_param, [
        "className"
    ]);
    var _React_useContext = $6cds3.useContext((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)), isSignedIn = _React_useContext.isSignedIn, wallet = _React_useContext.wallet, contractId = _React_useContext.contractId;
    var _useSearchParams = (0, $8GFUW._)((0, $0e36e707c39d0f3a$export$f1a78c17382fe22a)(), 2), searchParams = _useSearchParams[0], setSearchParams = _useSearchParams[1];
    var navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var _React_useState = (0, $8GFUW._)($6cds3.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var form = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)({
        resolver: (0, $682e60b97368662c$export$66b7b5879c70f722)($e1f494b02f72e814$var$formSchema),
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            licenseNo: "",
            licensePhoto: null,
            profilePhoto: null
        }
    });
    function onSubmit(values) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0, $byzP8._)(function(values) {
            var userType, form_values, result, result1, err, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            6,
                            7
                        ]);
                        (0, $4a6d5b98f5a54c19$exports.globalLoading).show();
                        userType = searchParams.get("user");
                        form_values = form.getValues();
                        if (!(userType === "lister")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, $2bbfe96e4adedbff$export$fe3a4b613a74459f)(wallet, contractId, form_values.firstName, form_values.email)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.status === "LISTER CREATED") {
                            (0, $a65c6a8ddb514a0f$export$b410431fab84fa58)({
                                title: "Lister Account",
                                description: "Successfully registered as Lister",
                                variant: "destructive"
                            });
                            navigate("/dashboard/lister");
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!(userType === "bidder")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0, $2bbfe96e4adedbff$export$ee4bada55e029fef)(wallet, contractId, form_values.firstName, form_values.email)
                        ];
                    case 3:
                        result1 = _state.sent();
                        if (result1.status === "CONTRACTOR CREATED") {
                            (0, $a65c6a8ddb514a0f$export$b410431fab84fa58)({
                                title: "Contractor Account",
                                description: "Successfully registered as Contractor",
                                variant: "destructive"
                            });
                            navigate("/dashboard/bidder");
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        err = _state.sent();
                        error = err;
                        (0, $a65c6a8ddb514a0f$export$b410431fab84fa58)({
                            title: "Failed to signin/signup",
                            description: error === null || error === void 0 ? void 0 : error.message,
                            variant: "destructive"
                        });
                        return [
                            3,
                            7
                        ];
                    case 6:
                        (0, $4a6d5b98f5a54c19$exports.globalLoading).hide();
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    $6cds3.useEffect(function() {
        return function() {};
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", (0, $8E768._)((0, $8OnJk._)({
        className: (0, $2bbfe96e4adedbff$export$1343a74baacb0543)("grid gap-6 px-2", className)
    }, props), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$a7fed597f4b8afd8), (0, $8E768._)((0, $8OnJk._)({}, form), {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("form", {
                onSubmit: form.handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                    disabled: loading,
                    className: "grid grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "firstName",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "First Name"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "John"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "lastName",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Last Name"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "Doe"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "email",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "joh@gmail.com"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "licenseNo",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "License No"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "ABC 105"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "licensePhoto",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "License Copy"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "Image/PDF of License",
                                                type: "file",
                                                accept: "image/*, application/pdf"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$56e87bf42978147a), {
                            control: form.control,
                            name: "profilePhoto",
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $8526f68d88b7d8ed$export$6713ee24224a3285), {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$842aba50ed0ce9d7), {
                                            children: "Profile Picture"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$fe5d99d8691b3f62), {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a86a65377abd0af8$export$f5b8910cec6cf069), (0, $8OnJk._)({
                                                placeholder: "PNG/JPEG",
                                                type: "file",
                                                accept: "image/*"
                                            }, field))
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8526f68d88b7d8ed$export$2e8ae7a1a126169a), {})
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dab50cebba406f42$export$353f5b6fc5456de1), {
                            type: "submit",
                            className: "col-span-2 mt-6",
                            children: "Submit"
                        })
                    ]
                })
            })
        }))
    }));
}


var $b55409c7c5a1d2e1$var$VerifyUser = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var isSignedIn = (0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)).isSignedIn;
    if (!isSignedIn) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
        children: "Please SignIn to Continue"
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2ccedb9e281f523c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
            className: "space-y-6 pb-8 pt-6 md:pb-12 md:pt-10 lg:py-32",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $44b31678df0b8391$export$60332b2344f7fe41), {
                className: "max-w-md mx-auto",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $44b31678df0b8391$export$5665775b26e26c5d), {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $44b31678df0b8391$export$64ef9b8c11710c47), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e1f494b02f72e814$export$4877859cf31d237), {
                            className: "max-w-sm"
                        })
                    })
                ]
            })
        })
    });
};
var $b55409c7c5a1d2e1$export$2e2bcd8739ae039 = $b55409c7c5a1d2e1$var$VerifyUser;





var $byzP8 = parcelRequire("byzP8");


var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");



var $6cds3 = parcelRequire("6cds3");







var $fbce84e9a8a2fdf2$var$ContractDetailsPage = function(param) {
    var ref = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)(param);
    var ref1 = (0, $9c04611ef3cd7bb6$export$cffab43ebdf6037)((0, $6cds3.useContext)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf)));
    var _useParams = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)(), contractId = _useParams.id;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(undefined), 2), contract = _useState1[0], setContract = _useState1[1];
    var getContracts = function() {
        var _ref = (0, $byzP8._)(function() {
            var contract;
            return (0, $7UAGh.__generator)(this, function(_state) {
                console.log(contractId);
                if (loading || !contractId) return [
                    2
                ];
                setLoading(true);
                try {
                    contract = (0, $c9896781e2e17aea$export$adf7f6a47eb011b3)[0];
                    console.log(contract);
                    setContract(contract);
                } catch (e) {
                    setContract(null);
                    console.log(e);
                } finally{
                    setLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return function getContracts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $6cds3.useEffect)(function() {
        getContracts();
    }, [
        contractId
    ]);
    if (contract === null) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
        children: "Loading"
    });
    var _contract_name, _contract_startDate, _contract_endDate;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fcc03b285aec188$export$2e2bcd8739ae039), {
        type: "none",
        loading: loading || contract === undefined,
        heading: "Contract Info",
        text: "View and bid for contract",
        buttonLabel: "",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3d427baccb8d4aec$export$fba5249c7bd13e1f), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abed61b84e9aa1ca$export$f35abaf34fd2d2bf), {
                    heading: (_contract_name = contract === null || contract === void 0 ? void 0 : contract.name) !== null && _contract_name !== void 0 ? _contract_name : "",
                    text: ""
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "grid grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "font-bold",
                                    children: "START: "
                                }),
                                " ",
                                (0, $2bbfe96e4adedbff$export$3ae94a2503e890a1)((_contract_startDate = contract === null || contract === void 0 ? void 0 : contract.startDate) !== null && _contract_startDate !== void 0 ? _contract_startDate : new Date())
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "font-bold",
                                    children: "DEADLINE: "
                                }),
                                " ",
                                (0, $2bbfe96e4adedbff$export$3ae94a2503e890a1)((_contract_endDate = contract === null || contract === void 0 ? void 0 : contract.endDate) !== null && _contract_endDate !== void 0 ? _contract_endDate : new Date())
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "font-bold",
                                    children: "QUATATION: "
                                }),
                                " $",
                                contract === null || contract === void 0 ? void 0 : contract.amount
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mt-6",
                    children: contract === null || contract === void 0 ? void 0 : contract.description
                })
            ]
        })
    });
};
var $fbce84e9a8a2fdf2$export$2e2bcd8739ae039 = $fbce84e9a8a2fdf2$var$ContractDetailsPage;




var $37993afad672ebae$var$App = function(param) {
    var isSignedIn = param.isSignedIn, contractId = param.contractId, wallet = param.wallet;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)({
        isSignedIn: isSignedIn,
        contractId: contractId,
        wallet: wallet
    }), 2), walletContext = _useState[0], setWalletContext = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)((0, $c9896781e2e17aea$export$adf7f6a47eb011b3)), 2), contract = _useState1[0], setContract = _useState1[1];
    var router = (0, $0e36e707c39d0f3a$export$1f3f55432a00e06d)([
        {
            path: "/",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72b212c13c11575e$export$2e2bcd8739ae039), {})
        },
        {
            path: "/start",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bd28d30e42f148a1$export$2e2bcd8739ae039), {})
        },
        {
            path: "/dashboard/lister",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $77efc7be1ebf8b86$export$2e2bcd8739ae039), {})
        },
        {
            path: "/dashboard/bidder",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $30fc099107e2db55$export$2e2bcd8739ae039), {})
        },
        {
            path: "/contract/add",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b3a72b81d4e7bb19$export$2e2bcd8739ae039), {})
        },
        {
            path: "/bid/all",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8fd777e58ebd560c$export$2e2bcd8739ae039), {})
        },
        {
            path: "/verify-user",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b55409c7c5a1d2e1$export$2e2bcd8739ae039), {})
        },
        {
            path: "/contract/:id",
            element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fbce84e9a8a2fdf2$export$2e2bcd8739ae039), {})
        }
    ], {});
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9a7c6a607a16349a$export$19648c908dc8d0bf).Provider, {
        value: walletContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $ff67f583320e0759$export$eae686c5662f0382).Provider, {
            value: {
                contracts: contract,
                setContracts: setContract
            },
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$323e4fc2fa4753fb), {
                    router: router
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a6d5b98f5a54c19$exports.GlobalLoading), {
                    zIndex: 50
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $66bc8323b1b46bc1$export$fb98e3a2a4cd92d7), {})
            ]
        })
    });
};
var $37993afad672ebae$export$2e2bcd8739ae039 = $37993afad672ebae$var$App;


/* A helper file that simplifies using the wallet selector */ // near api js

var $byzP8 = parcelRequire("byzP8");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $7UAGh = parcelRequire("7UAGh");
var $c1be85fca55b560a$exports = {};
"use strict";
var $c1be85fca55b560a$var$__createBinding = $c1be85fca55b560a$exports && $c1be85fca55b560a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c1be85fca55b560a$var$__setModuleDefault = $c1be85fca55b560a$exports && $c1be85fca55b560a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c1be85fca55b560a$var$__importStar = $c1be85fca55b560a$exports && $c1be85fca55b560a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $c1be85fca55b560a$var$__createBinding(result, mod, k);
    }
    $c1be85fca55b560a$var$__setModuleDefault(result, mod);
    return result;
};
var $c1be85fca55b560a$var$__exportStar = $c1be85fca55b560a$exports && $c1be85fca55b560a$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $c1be85fca55b560a$var$__createBinding(exports1, m, p);
};
Object.defineProperty($c1be85fca55b560a$exports, "__esModule", {
    value: true
});

/** @hidden @module */ $c1be85fca55b560a$exports.keyStores = $c1be85fca55b560a$var$__importStar((parcelRequire("7KkEL")));

$c1be85fca55b560a$var$__exportStar((parcelRequire("hHZrX")), $c1be85fca55b560a$exports);

$c1be85fca55b560a$var$__exportStar((parcelRequire("85znT")), $c1be85fca55b560a$exports);
var $01b3352f6ea28008$exports = {};

$01b3352f6ea28008$exports = (parcelRequire("fU2q1"));






var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");

var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";

var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;



var $6cds3 = parcelRequire("6cds3");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");


var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");
function $345e37a151d920a4$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}



var $7UAGh = parcelRequire("7UAGh");

function $27591a696a1a3a20$export$128a15b65d1b6041(createImpl) {
    var _super = function _super(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $738cdd1468679cef$export$c9648b76fd580c34 = (0, $27591a696a1a3a20$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $6057bfaf8274b9cf$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8667a5c54dd09873$export$f55210826850c514 = function() {
    var Subscription = function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    };
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $7UAGh.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $345e37a151d920a4$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $738cdd1468679cef$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $7UAGh.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8667a5c54dd09873$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $738cdd1468679cef$export$c9648b76fd580c34)) errors = (0, $7UAGh.__spreadArray)((0, $7UAGh.__spreadArray)([], (0, $7UAGh.__read)(errors)), (0, $7UAGh.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $738cdd1468679cef$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8667a5c54dd09873$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $6057bfaf8274b9cf$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $6057bfaf8274b9cf$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8667a5c54dd09873$export$610f9c3ca1a38dd8 = $8667a5c54dd09873$export$f55210826850c514.EMPTY;
function $8667a5c54dd09873$export$4f9221cbada3c4fc(value) {
    return value instanceof $8667a5c54dd09873$export$f55210826850c514 || value && "closed" in value && (0, $345e37a151d920a4$export$f6e2535fb5126e54)(value.remove) && (0, $345e37a151d920a4$export$f6e2535fb5126e54)(value.add) && (0, $345e37a151d920a4$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8667a5c54dd09873$var$execFinalizer(finalizer) {
    if ((0, $345e37a151d920a4$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $64ccd667427e3b82$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $7UAGh = parcelRequire("7UAGh");
var $9cf89fb3d04b7397$export$365aa6bd3c788e3d = {
    setTimeout: function setTimeout1(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $9cf89fb3d04b7397$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $7UAGh.__spreadArray)([
            handler,
            timeout
        ], (0, $7UAGh.__read)(args)));
        return setTimeout.apply(void 0, (0, $7UAGh.__spreadArray)([
            handler,
            timeout
        ], (0, $7UAGh.__read)(args)));
    },
    clearTimeout: function clearTimeout1(handle) {
        var delegate = $9cf89fb3d04b7397$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $de30f5e29bc32332$export$ebf645db02d3e99f(err) {
    (0, $9cf89fb3d04b7397$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $64ccd667427e3b82$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $34224e2fb309499f$export$8793edee2d425525() {}


var $1644ac769f31b435$export$b7f97edb34bc1f87 = function() {
    return $1644ac769f31b435$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $1644ac769f31b435$export$dd472c3d8fe5a85a(error) {
    return $1644ac769f31b435$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $1644ac769f31b435$export$ff9346b0d1d30313(value) {
    return $1644ac769f31b435$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $1644ac769f31b435$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $2c45853514b5caf7$var$context = null;
function $2c45853514b5caf7$export$d974811edc77eafa(cb) {
    if ((0, $64ccd667427e3b82$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$2c45853514b5caf7$var$context;
        if (isRoot) $2c45853514b5caf7$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $2c45853514b5caf7$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $2c45853514b5caf7$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $2c45853514b5caf7$export$3e205fbb5df021e0(err) {
    if ((0, $64ccd667427e3b82$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $2c45853514b5caf7$var$context) {
        $2c45853514b5caf7$var$context.errorThrown = true;
        $2c45853514b5caf7$var$context.error = err;
    }
}


var $c1759c586e2b3c05$export$60959659b2c22881 = function(_super) {
    var Subscriber = function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8667a5c54dd09873$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $c1759c586e2b3c05$export$88d395d20619a0af;
        return _this;
    };
    (0, $7UAGh.__extends)(Subscriber, _super);
    Subscriber.create = function(next, error, complete) {
        return new $c1759c586e2b3c05$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $c1759c586e2b3c05$var$handleStoppedNotification((0, $1644ac769f31b435$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $c1759c586e2b3c05$var$handleStoppedNotification((0, $1644ac769f31b435$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $c1759c586e2b3c05$var$handleStoppedNotification((0, $1644ac769f31b435$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8667a5c54dd09873$export$f55210826850c514));
var $c1759c586e2b3c05$var$_bind = Function.prototype.bind;
function $c1759c586e2b3c05$var$bind(fn, thisArg) {
    return $c1759c586e2b3c05$var$_bind.call(fn, thisArg);
}
var $c1759c586e2b3c05$var$ConsumerObserver = function() {
    var ConsumerObserver = function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    };
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $c1759c586e2b3c05$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $c1759c586e2b3c05$var$handleUnhandledError(error);
        }
        else $c1759c586e2b3c05$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $c1759c586e2b3c05$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $c1759c586e2b3c05$export$94eeb6a328cab6c7 = function(_super) {
    var SafeSubscriber = function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $345e37a151d920a4$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $64ccd667427e3b82$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $c1759c586e2b3c05$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $c1759c586e2b3c05$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $c1759c586e2b3c05$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $c1759c586e2b3c05$var$ConsumerObserver(partialObserver);
        return _this;
    };
    (0, $7UAGh.__extends)(SafeSubscriber, _super);
    return SafeSubscriber;
}($c1759c586e2b3c05$export$60959659b2c22881);
function $c1759c586e2b3c05$var$handleUnhandledError(error) {
    if ((0, $64ccd667427e3b82$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $2c45853514b5caf7$export$3e205fbb5df021e0)(error);
    else (0, $de30f5e29bc32332$export$ebf645db02d3e99f)(error);
}
function $c1759c586e2b3c05$var$defaultErrorHandler(err) {
    throw err;
}
function $c1759c586e2b3c05$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $64ccd667427e3b82$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $9cf89fb3d04b7397$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $c1759c586e2b3c05$export$88d395d20619a0af = {
    closed: true,
    next: (0, $34224e2fb309499f$export$8793edee2d425525),
    error: $c1759c586e2b3c05$var$defaultErrorHandler,
    complete: (0, $34224e2fb309499f$export$8793edee2d425525)
};



var $1d16fb5e59891444$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $bce1e6add181b4bc$export$f0954fd7d5368655(x) {
    return x;
}


function $9550bd941c40af8f$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $9550bd941c40af8f$export$71f88a61afaa14d7(fns);
}
function $9550bd941c40af8f$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $bce1e6add181b4bc$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $1349d708dd855fce$export$77cea355fa80b5f4 = function() {
    var Observable = function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    };
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $1349d708dd855fce$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $c1759c586e2b3c05$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $2c45853514b5caf7$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $1349d708dd855fce$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $c1759c586e2b3c05$export$94eeb6a328cab6c7)({
                next: function next1(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $1d16fb5e59891444$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $9550bd941c40af8f$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $1349d708dd855fce$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $1349d708dd855fce$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $64ccd667427e3b82$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $1349d708dd855fce$var$isObserver(value) {
    return value && (0, $345e37a151d920a4$export$f6e2535fb5126e54)(value.next) && (0, $345e37a151d920a4$export$f6e2535fb5126e54)(value.error) && (0, $345e37a151d920a4$export$f6e2535fb5126e54)(value.complete);
}
function $1349d708dd855fce$var$isSubscriber(value) {
    return value && value instanceof (0, $c1759c586e2b3c05$export$60959659b2c22881) || $1349d708dd855fce$var$isObserver(value) && (0, $8667a5c54dd09873$export$4f9221cbada3c4fc)(value);
}




var $8b7704283c714c74$export$f708eee25634bc80 = (0, $27591a696a1a3a20$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $d442f062d34a5142$export$b6bbab5a9b109038 = function(_super) {
    var Subject = function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    };
    (0, $7UAGh.__extends)(Subject, _super);
    Subject.prototype.lift = function(operator) {
        var subject = new $d442f062d34a5142$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $8b7704283c714c74$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $2c45853514b5caf7$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $7UAGh.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $2c45853514b5caf7$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $2c45853514b5caf7$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function get() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8667a5c54dd09873$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8667a5c54dd09873$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $6057bfaf8274b9cf$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $1349d708dd855fce$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $d442f062d34a5142$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $1349d708dd855fce$export$77cea355fa80b5f4));
var $d442f062d34a5142$export$155189cde295587d = function(_super) {
    var AnonymousSubject = function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    };
    (0, $7UAGh.__extends)(AnonymousSubject, _super);
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8667a5c54dd09873$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($d442f062d34a5142$export$b6bbab5a9b109038);


var $36c178b219a287b9$export$cc3d42e6b2b9cf8b = function(_super) {
    var BehaviorSubject = function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    };
    (0, $7UAGh.__extends)(BehaviorSubject, _super);
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function get() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $d442f062d34a5142$export$b6bbab5a9b109038));


function $24f82da02ce83e01$export$ebec8610810318c5(source) {
    return (0, $345e37a151d920a4$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $24f82da02ce83e01$export$871731df685d7753(init) {
    return function(source) {
        if ($24f82da02ce83e01$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}



var $7UAGh = parcelRequire("7UAGh");

function $82da95a332dc1e74$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $82da95a332dc1e74$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $82da95a332dc1e74$export$8fbbf0c4d80268e5 = function(_super) {
    var OperatorSubscriber = function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    };
    (0, $7UAGh.__extends)(OperatorSubscriber, _super);
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $c1759c586e2b3c05$export$60959659b2c22881));


function $e0d1216350f95563$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $82da95a332dc1e74$export$b9e075132cc6937f)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}


function $e687a35152d55f01$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $24f82da02ce83e01$export$871731df685d7753)((0, $e0d1216350f95563$export$30fc204bc7867c02)(accumulator, seed, arguments.length >= 2, true));
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f76789f9143a442d$var$__awaiter(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $f76789f9143a442d$var$Provider = /*#__PURE__*/ function() {
    "use strict";
    function Provider(url) {
        (0, $978gY._)(this, Provider);
        this.provider = new $c1be85fca55b560a$exports.providers.JsonRpcProvider({
            url: url
        });
    }
    (0, $kry2a._)(Provider, [
        {
            key: "query",
            value: function query(params) {
                return this.provider.query(params);
            }
        },
        {
            key: "viewAccessKey",
            value: function viewAccessKey(param) {
                var accountId = param.accountId, publicKey = param.publicKey;
                return this.query({
                    request_type: "view_access_key",
                    finality: "final",
                    account_id: accountId,
                    public_key: publicKey
                });
            }
        },
        {
            key: "block",
            value: function block(reference) {
                return this.provider.block(reference);
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(signedTransaction) {
                return this.provider.sendTransaction(signedTransaction);
            }
        }
    ]);
    return Provider;
}();
var $f76789f9143a442d$var$KEY_DELIMITER = ":";
var $f76789f9143a442d$var$JsonStorage = /*#__PURE__*/ function() {
    "use strict";
    function JsonStorage(storage, namespace) {
        (0, $978gY._)(this, JsonStorage);
        this.storage = storage;
        this.namespace = Array.isArray(namespace) ? namespace.join($f76789f9143a442d$var$KEY_DELIMITER) : namespace;
    }
    (0, $kry2a._)(JsonStorage, [
        {
            key: "resolveKey",
            value: function resolveKey(key) {
                return [
                    this.namespace,
                    key
                ].join($f76789f9143a442d$var$KEY_DELIMITER);
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                return this.storage.getItem(this.resolveKey(key)).then(function(item) {
                    return typeof item === "string" ? JSON.parse(item) : null;
                });
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                return this.storage.setItem(this.resolveKey(key), JSON.stringify(value));
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                return this.storage.removeItem(this.resolveKey(key));
            }
        }
    ]);
    return JsonStorage;
}();
var $f76789f9143a442d$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $f76789f9143a442d$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $f76789f9143a442d$var$global$m = // eslint-disable-next-line es-x/no-global-this -- safe
$f76789f9143a442d$var$check(typeof globalThis == "object" && globalThis) || $f76789f9143a442d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$f76789f9143a442d$var$check(typeof self == "object" && self) || $f76789f9143a442d$var$check(typeof $f76789f9143a442d$var$commonjsGlobal == "object" && $f76789f9143a442d$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $f76789f9143a442d$var$objectGetOwnPropertyDescriptor = {};
var $f76789f9143a442d$var$fails$k = function fails$k(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $f76789f9143a442d$var$fails$j = $f76789f9143a442d$var$fails$k;
// Detect IE8's incomplete defineProperty implementation
var $f76789f9143a442d$var$descriptors = !$f76789f9143a442d$var$fails$j(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});
var $f76789f9143a442d$var$fails$i = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$functionBindNative = !$f76789f9143a442d$var$fails$i(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $f76789f9143a442d$var$NATIVE_BIND$3 = $f76789f9143a442d$var$functionBindNative;
var $f76789f9143a442d$var$call$h = Function.prototype.call;
var $f76789f9143a442d$var$functionCall = $f76789f9143a442d$var$NATIVE_BIND$3 ? $f76789f9143a442d$var$call$h.bind($f76789f9143a442d$var$call$h) : function functionCall() {
    return $f76789f9143a442d$var$call$h.apply($f76789f9143a442d$var$call$h, arguments);
};
var $f76789f9143a442d$var$objectPropertyIsEnumerable = {};
var $f76789f9143a442d$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f76789f9143a442d$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $f76789f9143a442d$var$NASHORN_BUG = $f76789f9143a442d$var$getOwnPropertyDescriptor$2 && !$f76789f9143a442d$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$f76789f9143a442d$var$objectPropertyIsEnumerable.f = $f76789f9143a442d$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $f76789f9143a442d$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $f76789f9143a442d$var$$propertyIsEnumerable;
var $f76789f9143a442d$var$createPropertyDescriptor$4 = function createPropertyDescriptor$4(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $f76789f9143a442d$var$NATIVE_BIND$2 = $f76789f9143a442d$var$functionBindNative;
var $f76789f9143a442d$var$FunctionPrototype$2 = Function.prototype;
var $f76789f9143a442d$var$bind$5 = $f76789f9143a442d$var$FunctionPrototype$2.bind;
var $f76789f9143a442d$var$call$g = $f76789f9143a442d$var$FunctionPrototype$2.call;
var $f76789f9143a442d$var$uncurryThis$j = $f76789f9143a442d$var$NATIVE_BIND$2 && $f76789f9143a442d$var$bind$5.bind($f76789f9143a442d$var$call$g, $f76789f9143a442d$var$call$g);
var $f76789f9143a442d$var$functionUncurryThis = $f76789f9143a442d$var$NATIVE_BIND$2 ? function functionUncurryThis(fn) {
    return fn && $f76789f9143a442d$var$uncurryThis$j(fn);
} : function(fn) {
    return fn && function() {
        return $f76789f9143a442d$var$call$g.apply(fn, arguments);
    };
};
var $f76789f9143a442d$var$uncurryThis$i = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$toString$6 = $f76789f9143a442d$var$uncurryThis$i({}.toString);
var $f76789f9143a442d$var$stringSlice$3 = $f76789f9143a442d$var$uncurryThis$i("".slice);
var $f76789f9143a442d$var$classofRaw$1 = function classofRaw$1(it) {
    return $f76789f9143a442d$var$stringSlice$3($f76789f9143a442d$var$toString$6(it), 8, -1);
};
var $f76789f9143a442d$var$uncurryThis$h = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$fails$h = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$classof$7 = $f76789f9143a442d$var$classofRaw$1;
var $f76789f9143a442d$var$$Object$4 = Object;
var $f76789f9143a442d$var$split = $f76789f9143a442d$var$uncurryThis$h("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $f76789f9143a442d$var$indexedObject = $f76789f9143a442d$var$fails$h(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$f76789f9143a442d$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function indexedObject(it) {
    return $f76789f9143a442d$var$classof$7(it) == "String" ? $f76789f9143a442d$var$split(it, "") : $f76789f9143a442d$var$$Object$4(it);
} : $f76789f9143a442d$var$$Object$4;
var $f76789f9143a442d$var$$TypeError$e = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $f76789f9143a442d$var$requireObjectCoercible$5 = function requireObjectCoercible$5(it) {
    if (it == undefined) throw $f76789f9143a442d$var$$TypeError$e("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $f76789f9143a442d$var$IndexedObject$2 = $f76789f9143a442d$var$indexedObject;
var $f76789f9143a442d$var$requireObjectCoercible$4 = $f76789f9143a442d$var$requireObjectCoercible$5;
var $f76789f9143a442d$var$toIndexedObject$5 = function toIndexedObject$5(it) {
    return $f76789f9143a442d$var$IndexedObject$2($f76789f9143a442d$var$requireObjectCoercible$4(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $f76789f9143a442d$var$isCallable$l = function isCallable$l(argument) {
    return typeof argument == "function";
};
var $f76789f9143a442d$var$isCallable$k = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$isObject$8 = function isObject$8(it) {
    return typeof it == "object" ? it !== null : $f76789f9143a442d$var$isCallable$k(it);
};
var $f76789f9143a442d$var$global$l = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$isCallable$j = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$aFunction = function aFunction(argument) {
    return $f76789f9143a442d$var$isCallable$j(argument) ? argument : undefined;
};
var $f76789f9143a442d$var$getBuiltIn$8 = function getBuiltIn$8(namespace, method) {
    return arguments.length < 2 ? $f76789f9143a442d$var$aFunction($f76789f9143a442d$var$global$l[namespace]) : $f76789f9143a442d$var$global$l[namespace] && $f76789f9143a442d$var$global$l[namespace][method];
};
var $f76789f9143a442d$var$uncurryThis$g = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$objectIsPrototypeOf = $f76789f9143a442d$var$uncurryThis$g({}.isPrototypeOf);
var $f76789f9143a442d$var$getBuiltIn$7 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$engineUserAgent = $f76789f9143a442d$var$getBuiltIn$7("navigator", "userAgent") || "";
var $f76789f9143a442d$var$global$k = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$userAgent$3 = $f76789f9143a442d$var$engineUserAgent;
var $f76789f9143a442d$var$process$3 = $f76789f9143a442d$var$global$k.process;
var $f76789f9143a442d$var$Deno$1 = $f76789f9143a442d$var$global$k.Deno;
var $f76789f9143a442d$var$versions = $f76789f9143a442d$var$process$3 && $f76789f9143a442d$var$process$3.versions || $f76789f9143a442d$var$Deno$1 && $f76789f9143a442d$var$Deno$1.version;
var $f76789f9143a442d$var$v8 = $f76789f9143a442d$var$versions && $f76789f9143a442d$var$versions.v8;
var $f76789f9143a442d$var$match, $f76789f9143a442d$var$version;
if ($f76789f9143a442d$var$v8) {
    $f76789f9143a442d$var$match = $f76789f9143a442d$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $f76789f9143a442d$var$version = $f76789f9143a442d$var$match[0] > 0 && $f76789f9143a442d$var$match[0] < 4 ? 1 : +($f76789f9143a442d$var$match[0] + $f76789f9143a442d$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$f76789f9143a442d$var$version && $f76789f9143a442d$var$userAgent$3) {
    $f76789f9143a442d$var$match = $f76789f9143a442d$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$f76789f9143a442d$var$match || $f76789f9143a442d$var$match[1] >= 74) {
        $f76789f9143a442d$var$match = $f76789f9143a442d$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($f76789f9143a442d$var$match) $f76789f9143a442d$var$version = +$f76789f9143a442d$var$match[1];
    }
}
var $f76789f9143a442d$var$engineV8Version = $f76789f9143a442d$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $f76789f9143a442d$var$V8_VERSION$1 = $f76789f9143a442d$var$engineV8Version;
var $f76789f9143a442d$var$fails$g = $f76789f9143a442d$var$fails$k;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $f76789f9143a442d$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$f76789f9143a442d$var$fails$g(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $f76789f9143a442d$var$V8_VERSION$1 && $f76789f9143a442d$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $f76789f9143a442d$var$NATIVE_SYMBOL$1 = $f76789f9143a442d$var$nativeSymbol;
var $f76789f9143a442d$var$useSymbolAsUid = $f76789f9143a442d$var$NATIVE_SYMBOL$1 && !Symbol.sham && (0, $1ObTH._)(Symbol.iterator) == "symbol";
var $f76789f9143a442d$var$getBuiltIn$6 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$isCallable$i = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$isPrototypeOf$2 = $f76789f9143a442d$var$objectIsPrototypeOf;
var $f76789f9143a442d$var$USE_SYMBOL_AS_UID$1 = $f76789f9143a442d$var$useSymbolAsUid;
var $f76789f9143a442d$var$$Object$3 = Object;
var $f76789f9143a442d$var$isSymbol$2 = $f76789f9143a442d$var$USE_SYMBOL_AS_UID$1 ? function isSymbol$2(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $1ObTH._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $f76789f9143a442d$var$getBuiltIn$6("Symbol");
    return $f76789f9143a442d$var$isCallable$i($Symbol) && $f76789f9143a442d$var$isPrototypeOf$2($Symbol.prototype, $f76789f9143a442d$var$$Object$3(it));
};
var $f76789f9143a442d$var$$String$3 = String;
var $f76789f9143a442d$var$tryToString$4 = function tryToString$4(argument) {
    try {
        return $f76789f9143a442d$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $f76789f9143a442d$var$isCallable$h = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$tryToString$3 = $f76789f9143a442d$var$tryToString$4;
var $f76789f9143a442d$var$$TypeError$d = TypeError;
// `Assert: IsCallable(argument) is true`
var $f76789f9143a442d$var$aCallable$8 = function aCallable$8(argument) {
    if ($f76789f9143a442d$var$isCallable$h(argument)) return argument;
    throw $f76789f9143a442d$var$$TypeError$d($f76789f9143a442d$var$tryToString$3(argument) + " is not a function");
};
var $f76789f9143a442d$var$aCallable$7 = $f76789f9143a442d$var$aCallable$8;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $f76789f9143a442d$var$getMethod$4 = function getMethod$4(V, P) {
    var func = V[P];
    return func == null ? undefined : $f76789f9143a442d$var$aCallable$7(func);
};
var $f76789f9143a442d$var$call$f = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$isCallable$g = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$isObject$7 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$$TypeError$c = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $f76789f9143a442d$var$ordinaryToPrimitive$1 = function ordinaryToPrimitive$1(input, pref) {
    var fn, val;
    if (pref === "string" && $f76789f9143a442d$var$isCallable$g(fn = input.toString) && !$f76789f9143a442d$var$isObject$7(val = $f76789f9143a442d$var$call$f(fn, input))) return val;
    if ($f76789f9143a442d$var$isCallable$g(fn = input.valueOf) && !$f76789f9143a442d$var$isObject$7(val = $f76789f9143a442d$var$call$f(fn, input))) return val;
    if (pref !== "string" && $f76789f9143a442d$var$isCallable$g(fn = input.toString) && !$f76789f9143a442d$var$isObject$7(val = $f76789f9143a442d$var$call$f(fn, input))) return val;
    throw $f76789f9143a442d$var$$TypeError$c("Can't convert object to primitive value");
};
var $f76789f9143a442d$var$shared$4 = {
    exports: {}
};
var $f76789f9143a442d$var$global$j = $f76789f9143a442d$var$global$m;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f76789f9143a442d$var$defineProperty$5 = Object.defineProperty;
var $f76789f9143a442d$var$defineGlobalProperty$3 = function defineGlobalProperty$3(key, value) {
    try {
        $f76789f9143a442d$var$defineProperty$5($f76789f9143a442d$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $f76789f9143a442d$var$global$j[key] = value;
    }
    return value;
};
var $f76789f9143a442d$var$global$i = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$defineGlobalProperty$2 = $f76789f9143a442d$var$defineGlobalProperty$3;
var $f76789f9143a442d$var$SHARED = "__core-js_shared__";
var $f76789f9143a442d$var$store$3 = $f76789f9143a442d$var$global$i[$f76789f9143a442d$var$SHARED] || $f76789f9143a442d$var$defineGlobalProperty$2($f76789f9143a442d$var$SHARED, {});
var $f76789f9143a442d$var$sharedStore = $f76789f9143a442d$var$store$3;
var $f76789f9143a442d$var$store$2 = $f76789f9143a442d$var$sharedStore;
($f76789f9143a442d$var$shared$4.exports = function(key, value) {
    return $f76789f9143a442d$var$store$2[key] || ($f76789f9143a442d$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $f76789f9143a442d$var$requireObjectCoercible$3 = $f76789f9143a442d$var$requireObjectCoercible$5;
var $f76789f9143a442d$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $f76789f9143a442d$var$toObject$4 = function toObject$4(argument) {
    return $f76789f9143a442d$var$$Object$2($f76789f9143a442d$var$requireObjectCoercible$3(argument));
};
var $f76789f9143a442d$var$uncurryThis$f = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$toObject$3 = $f76789f9143a442d$var$toObject$4;
var $f76789f9143a442d$var$hasOwnProperty = $f76789f9143a442d$var$uncurryThis$f({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $f76789f9143a442d$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $f76789f9143a442d$var$hasOwnProperty($f76789f9143a442d$var$toObject$3(it), key);
};
var $f76789f9143a442d$var$uncurryThis$e = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$id = 0;
var $f76789f9143a442d$var$postfix = Math.random();
var $f76789f9143a442d$var$toString$5 = $f76789f9143a442d$var$uncurryThis$e(1.0.toString);
var $f76789f9143a442d$var$uid$2 = function uid$2(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $f76789f9143a442d$var$toString$5(++$f76789f9143a442d$var$id + $f76789f9143a442d$var$postfix, 36);
};
var $f76789f9143a442d$var$global$h = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$shared$3 = $f76789f9143a442d$var$shared$4.exports;
var $f76789f9143a442d$var$hasOwn$9 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$uid$1 = $f76789f9143a442d$var$uid$2;
var $f76789f9143a442d$var$NATIVE_SYMBOL = $f76789f9143a442d$var$nativeSymbol;
var $f76789f9143a442d$var$USE_SYMBOL_AS_UID = $f76789f9143a442d$var$useSymbolAsUid;
var $f76789f9143a442d$var$WellKnownSymbolsStore = $f76789f9143a442d$var$shared$3("wks");
var $f76789f9143a442d$var$Symbol$1 = $f76789f9143a442d$var$global$h.Symbol;
var $f76789f9143a442d$var$symbolFor = $f76789f9143a442d$var$Symbol$1 && $f76789f9143a442d$var$Symbol$1["for"];
var $f76789f9143a442d$var$createWellKnownSymbol = $f76789f9143a442d$var$USE_SYMBOL_AS_UID ? $f76789f9143a442d$var$Symbol$1 : $f76789f9143a442d$var$Symbol$1 && $f76789f9143a442d$var$Symbol$1.withoutSetter || $f76789f9143a442d$var$uid$1;
var $f76789f9143a442d$var$wellKnownSymbol$h = function wellKnownSymbol$h(name) {
    if (!$f76789f9143a442d$var$hasOwn$9($f76789f9143a442d$var$WellKnownSymbolsStore, name) || !($f76789f9143a442d$var$NATIVE_SYMBOL || typeof $f76789f9143a442d$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($f76789f9143a442d$var$NATIVE_SYMBOL && $f76789f9143a442d$var$hasOwn$9($f76789f9143a442d$var$Symbol$1, name)) $f76789f9143a442d$var$WellKnownSymbolsStore[name] = $f76789f9143a442d$var$Symbol$1[name];
        else if ($f76789f9143a442d$var$USE_SYMBOL_AS_UID && $f76789f9143a442d$var$symbolFor) $f76789f9143a442d$var$WellKnownSymbolsStore[name] = $f76789f9143a442d$var$symbolFor(description);
        else $f76789f9143a442d$var$WellKnownSymbolsStore[name] = $f76789f9143a442d$var$createWellKnownSymbol(description);
    }
    return $f76789f9143a442d$var$WellKnownSymbolsStore[name];
};
var $f76789f9143a442d$var$call$e = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$isObject$6 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$isSymbol$1 = $f76789f9143a442d$var$isSymbol$2;
var $f76789f9143a442d$var$getMethod$3 = $f76789f9143a442d$var$getMethod$4;
var $f76789f9143a442d$var$ordinaryToPrimitive = $f76789f9143a442d$var$ordinaryToPrimitive$1;
var $f76789f9143a442d$var$wellKnownSymbol$g = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$$TypeError$b = TypeError;
var $f76789f9143a442d$var$TO_PRIMITIVE = $f76789f9143a442d$var$wellKnownSymbol$g("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $f76789f9143a442d$var$toPrimitive$1 = function toPrimitive$1(input, pref) {
    if (!$f76789f9143a442d$var$isObject$6(input) || $f76789f9143a442d$var$isSymbol$1(input)) return input;
    var exoticToPrim = $f76789f9143a442d$var$getMethod$3(input, $f76789f9143a442d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $f76789f9143a442d$var$call$e(exoticToPrim, input, pref);
        if (!$f76789f9143a442d$var$isObject$6(result) || $f76789f9143a442d$var$isSymbol$1(result)) return result;
        throw $f76789f9143a442d$var$$TypeError$b("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $f76789f9143a442d$var$ordinaryToPrimitive(input, pref);
};
var $f76789f9143a442d$var$toPrimitive = $f76789f9143a442d$var$toPrimitive$1;
var $f76789f9143a442d$var$isSymbol = $f76789f9143a442d$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $f76789f9143a442d$var$toPropertyKey$3 = function toPropertyKey$3(argument) {
    var key = $f76789f9143a442d$var$toPrimitive(argument, "string");
    return $f76789f9143a442d$var$isSymbol(key) ? key : key + "";
};
var $f76789f9143a442d$var$global$g = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$isObject$5 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$document$3 = $f76789f9143a442d$var$global$g.document;
// typeof document.createElement is 'object' in old IE
var $f76789f9143a442d$var$EXISTS$1 = $f76789f9143a442d$var$isObject$5($f76789f9143a442d$var$document$3) && $f76789f9143a442d$var$isObject$5($f76789f9143a442d$var$document$3.createElement);
var $f76789f9143a442d$var$documentCreateElement$2 = function documentCreateElement$2(it) {
    return $f76789f9143a442d$var$EXISTS$1 ? $f76789f9143a442d$var$document$3.createElement(it) : {};
};
var $f76789f9143a442d$var$DESCRIPTORS$a = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$fails$f = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$createElement$1 = $f76789f9143a442d$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $f76789f9143a442d$var$ie8DomDefine = !$f76789f9143a442d$var$DESCRIPTORS$a && !$f76789f9143a442d$var$fails$f(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($f76789f9143a442d$var$createElement$1("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});
var $f76789f9143a442d$var$DESCRIPTORS$9 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$call$d = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$propertyIsEnumerableModule$1 = $f76789f9143a442d$var$objectPropertyIsEnumerable;
var $f76789f9143a442d$var$createPropertyDescriptor$3 = $f76789f9143a442d$var$createPropertyDescriptor$4;
var $f76789f9143a442d$var$toIndexedObject$4 = $f76789f9143a442d$var$toIndexedObject$5;
var $f76789f9143a442d$var$toPropertyKey$2 = $f76789f9143a442d$var$toPropertyKey$3;
var $f76789f9143a442d$var$hasOwn$8 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$IE8_DOM_DEFINE$1 = $f76789f9143a442d$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f76789f9143a442d$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$f76789f9143a442d$var$objectGetOwnPropertyDescriptor.f = $f76789f9143a442d$var$DESCRIPTORS$9 ? $f76789f9143a442d$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $f76789f9143a442d$var$toIndexedObject$4(O);
    P = $f76789f9143a442d$var$toPropertyKey$2(P);
    if ($f76789f9143a442d$var$IE8_DOM_DEFINE$1) try {
        return $f76789f9143a442d$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($f76789f9143a442d$var$hasOwn$8(O, P)) return $f76789f9143a442d$var$createPropertyDescriptor$3(!$f76789f9143a442d$var$call$d($f76789f9143a442d$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $f76789f9143a442d$var$objectDefineProperty = {};
var $f76789f9143a442d$var$DESCRIPTORS$8 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$fails$e = $f76789f9143a442d$var$fails$k;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $f76789f9143a442d$var$v8PrototypeDefineBug = $f76789f9143a442d$var$DESCRIPTORS$8 && $f76789f9143a442d$var$fails$e(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $f76789f9143a442d$var$isObject$4 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$$String$2 = String;
var $f76789f9143a442d$var$$TypeError$a = TypeError;
// `Assert: Type(argument) is Object`
var $f76789f9143a442d$var$anObject$d = function anObject$d(argument) {
    if ($f76789f9143a442d$var$isObject$4(argument)) return argument;
    throw $f76789f9143a442d$var$$TypeError$a($f76789f9143a442d$var$$String$2(argument) + " is not an object");
};
var $f76789f9143a442d$var$DESCRIPTORS$7 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$IE8_DOM_DEFINE = $f76789f9143a442d$var$ie8DomDefine;
var $f76789f9143a442d$var$V8_PROTOTYPE_DEFINE_BUG$1 = $f76789f9143a442d$var$v8PrototypeDefineBug;
var $f76789f9143a442d$var$anObject$c = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$toPropertyKey$1 = $f76789f9143a442d$var$toPropertyKey$3;
var $f76789f9143a442d$var$$TypeError$9 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f76789f9143a442d$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f76789f9143a442d$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f76789f9143a442d$var$ENUMERABLE = "enumerable";
var $f76789f9143a442d$var$CONFIGURABLE$1 = "configurable";
var $f76789f9143a442d$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$f76789f9143a442d$var$objectDefineProperty.f = $f76789f9143a442d$var$DESCRIPTORS$7 ? $f76789f9143a442d$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $f76789f9143a442d$var$anObject$c(O);
    P = $f76789f9143a442d$var$toPropertyKey$1(P);
    $f76789f9143a442d$var$anObject$c(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $f76789f9143a442d$var$WRITABLE in Attributes && !Attributes[$f76789f9143a442d$var$WRITABLE]) {
        var current = $f76789f9143a442d$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$f76789f9143a442d$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $f76789f9143a442d$var$CONFIGURABLE$1 in Attributes ? Attributes[$f76789f9143a442d$var$CONFIGURABLE$1] : current[$f76789f9143a442d$var$CONFIGURABLE$1],
                enumerable: $f76789f9143a442d$var$ENUMERABLE in Attributes ? Attributes[$f76789f9143a442d$var$ENUMERABLE] : current[$f76789f9143a442d$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $f76789f9143a442d$var$$defineProperty(O, P, Attributes);
} : $f76789f9143a442d$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $f76789f9143a442d$var$anObject$c(O);
    P = $f76789f9143a442d$var$toPropertyKey$1(P);
    $f76789f9143a442d$var$anObject$c(Attributes);
    if ($f76789f9143a442d$var$IE8_DOM_DEFINE) try {
        return $f76789f9143a442d$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $f76789f9143a442d$var$$TypeError$9("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $f76789f9143a442d$var$DESCRIPTORS$6 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$definePropertyModule$5 = $f76789f9143a442d$var$objectDefineProperty;
var $f76789f9143a442d$var$createPropertyDescriptor$2 = $f76789f9143a442d$var$createPropertyDescriptor$4;
var $f76789f9143a442d$var$createNonEnumerableProperty$5 = $f76789f9143a442d$var$DESCRIPTORS$6 ? function createNonEnumerableProperty$5(object, key, value) {
    return $f76789f9143a442d$var$definePropertyModule$5.f(object, key, $f76789f9143a442d$var$createPropertyDescriptor$2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $f76789f9143a442d$var$makeBuiltIn$2 = {
    exports: {}
};
var $f76789f9143a442d$var$DESCRIPTORS$5 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$hasOwn$7 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f76789f9143a442d$var$getDescriptor = $f76789f9143a442d$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $f76789f9143a442d$var$EXISTS = $f76789f9143a442d$var$hasOwn$7($f76789f9143a442d$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $f76789f9143a442d$var$PROPER = $f76789f9143a442d$var$EXISTS && (function something() {}).name === "something";
var $f76789f9143a442d$var$CONFIGURABLE = $f76789f9143a442d$var$EXISTS && (!$f76789f9143a442d$var$DESCRIPTORS$5 || $f76789f9143a442d$var$DESCRIPTORS$5 && $f76789f9143a442d$var$getDescriptor($f76789f9143a442d$var$FunctionPrototype$1, "name").configurable);
var $f76789f9143a442d$var$functionName = {
    EXISTS: $f76789f9143a442d$var$EXISTS,
    PROPER: $f76789f9143a442d$var$PROPER,
    CONFIGURABLE: $f76789f9143a442d$var$CONFIGURABLE
};
var $f76789f9143a442d$var$uncurryThis$d = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$isCallable$f = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$store$1 = $f76789f9143a442d$var$sharedStore;
var $f76789f9143a442d$var$functionToString = $f76789f9143a442d$var$uncurryThis$d(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$f76789f9143a442d$var$isCallable$f($f76789f9143a442d$var$store$1.inspectSource)) $f76789f9143a442d$var$store$1.inspectSource = function(it) {
    return $f76789f9143a442d$var$functionToString(it);
};
var $f76789f9143a442d$var$inspectSource$4 = $f76789f9143a442d$var$store$1.inspectSource;
var $f76789f9143a442d$var$global$f = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$isCallable$e = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$inspectSource$3 = $f76789f9143a442d$var$inspectSource$4;
var $f76789f9143a442d$var$WeakMap$1 = $f76789f9143a442d$var$global$f.WeakMap;
var $f76789f9143a442d$var$nativeWeakMap = $f76789f9143a442d$var$isCallable$e($f76789f9143a442d$var$WeakMap$1) && /native code/.test($f76789f9143a442d$var$inspectSource$3($f76789f9143a442d$var$WeakMap$1));
var $f76789f9143a442d$var$shared$2 = $f76789f9143a442d$var$shared$4.exports;
var $f76789f9143a442d$var$uid = $f76789f9143a442d$var$uid$2;
var $f76789f9143a442d$var$keys = $f76789f9143a442d$var$shared$2("keys");
var $f76789f9143a442d$var$sharedKey$3 = function sharedKey$3(key) {
    return $f76789f9143a442d$var$keys[key] || ($f76789f9143a442d$var$keys[key] = $f76789f9143a442d$var$uid(key));
};
var $f76789f9143a442d$var$hiddenKeys$4 = {};
var $f76789f9143a442d$var$NATIVE_WEAK_MAP = $f76789f9143a442d$var$nativeWeakMap;
var $f76789f9143a442d$var$global$e = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$uncurryThis$c = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$isObject$3 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$createNonEnumerableProperty$4 = $f76789f9143a442d$var$createNonEnumerableProperty$5;
var $f76789f9143a442d$var$hasOwn$6 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$shared$1 = $f76789f9143a442d$var$sharedStore;
var $f76789f9143a442d$var$sharedKey$2 = $f76789f9143a442d$var$sharedKey$3;
var $f76789f9143a442d$var$hiddenKeys$3 = $f76789f9143a442d$var$hiddenKeys$4;
var $f76789f9143a442d$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $f76789f9143a442d$var$TypeError$2 = $f76789f9143a442d$var$global$e.TypeError;
var $f76789f9143a442d$var$WeakMap = $f76789f9143a442d$var$global$e.WeakMap;
var $f76789f9143a442d$var$set$1, $f76789f9143a442d$var$get, $f76789f9143a442d$var$has;
var $f76789f9143a442d$var$enforce = function enforce(it) {
    return $f76789f9143a442d$var$has(it) ? $f76789f9143a442d$var$get(it) : $f76789f9143a442d$var$set$1(it, {});
};
var $f76789f9143a442d$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$f76789f9143a442d$var$isObject$3(it) || (state = $f76789f9143a442d$var$get(it)).type !== TYPE) throw $f76789f9143a442d$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($f76789f9143a442d$var$NATIVE_WEAK_MAP || $f76789f9143a442d$var$shared$1.state) {
    var $f76789f9143a442d$var$store = $f76789f9143a442d$var$shared$1.state || ($f76789f9143a442d$var$shared$1.state = new $f76789f9143a442d$var$WeakMap());
    var $f76789f9143a442d$var$wmget = $f76789f9143a442d$var$uncurryThis$c($f76789f9143a442d$var$store.get);
    var $f76789f9143a442d$var$wmhas = $f76789f9143a442d$var$uncurryThis$c($f76789f9143a442d$var$store.has);
    var $f76789f9143a442d$var$wmset = $f76789f9143a442d$var$uncurryThis$c($f76789f9143a442d$var$store.set);
    $f76789f9143a442d$var$set$1 = function set$1(it, metadata) {
        if ($f76789f9143a442d$var$wmhas($f76789f9143a442d$var$store, it)) throw new $f76789f9143a442d$var$TypeError$2($f76789f9143a442d$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f76789f9143a442d$var$wmset($f76789f9143a442d$var$store, it, metadata);
        return metadata;
    };
    $f76789f9143a442d$var$get = function get(it) {
        return $f76789f9143a442d$var$wmget($f76789f9143a442d$var$store, it) || {};
    };
    $f76789f9143a442d$var$has = function has(it) {
        return $f76789f9143a442d$var$wmhas($f76789f9143a442d$var$store, it);
    };
} else {
    var $f76789f9143a442d$var$STATE = $f76789f9143a442d$var$sharedKey$2("state");
    $f76789f9143a442d$var$hiddenKeys$3[$f76789f9143a442d$var$STATE] = true;
    $f76789f9143a442d$var$set$1 = function set$1(it, metadata) {
        if ($f76789f9143a442d$var$hasOwn$6(it, $f76789f9143a442d$var$STATE)) throw new $f76789f9143a442d$var$TypeError$2($f76789f9143a442d$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f76789f9143a442d$var$createNonEnumerableProperty$4(it, $f76789f9143a442d$var$STATE, metadata);
        return metadata;
    };
    $f76789f9143a442d$var$get = function get(it) {
        return $f76789f9143a442d$var$hasOwn$6(it, $f76789f9143a442d$var$STATE) ? it[$f76789f9143a442d$var$STATE] : {};
    };
    $f76789f9143a442d$var$has = function has(it) {
        return $f76789f9143a442d$var$hasOwn$6(it, $f76789f9143a442d$var$STATE);
    };
}
var $f76789f9143a442d$var$internalState = {
    set: $f76789f9143a442d$var$set$1,
    get: $f76789f9143a442d$var$get,
    has: $f76789f9143a442d$var$has,
    enforce: $f76789f9143a442d$var$enforce,
    getterFor: $f76789f9143a442d$var$getterFor
};
var $f76789f9143a442d$var$fails$d = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$isCallable$d = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$hasOwn$5 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$DESCRIPTORS$4 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$CONFIGURABLE_FUNCTION_NAME$1 = $f76789f9143a442d$var$functionName.CONFIGURABLE;
var $f76789f9143a442d$var$inspectSource$2 = $f76789f9143a442d$var$inspectSource$4;
var $f76789f9143a442d$var$InternalStateModule$2 = $f76789f9143a442d$var$internalState;
var $f76789f9143a442d$var$enforceInternalState = $f76789f9143a442d$var$InternalStateModule$2.enforce;
var $f76789f9143a442d$var$getInternalState$2 = $f76789f9143a442d$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f76789f9143a442d$var$defineProperty$4 = Object.defineProperty;
var $f76789f9143a442d$var$CONFIGURABLE_LENGTH = $f76789f9143a442d$var$DESCRIPTORS$4 && !$f76789f9143a442d$var$fails$d(function() {
    return $f76789f9143a442d$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $f76789f9143a442d$var$TEMPLATE = String(String).split("String");
var $f76789f9143a442d$var$makeBuiltIn$1 = $f76789f9143a442d$var$makeBuiltIn$2.exports = function makeBuiltIn$1(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$f76789f9143a442d$var$hasOwn$5(value, "name") || $f76789f9143a442d$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($f76789f9143a442d$var$DESCRIPTORS$4) $f76789f9143a442d$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($f76789f9143a442d$var$CONFIGURABLE_LENGTH && options && $f76789f9143a442d$var$hasOwn$5(options, "arity") && value.length !== options.arity) $f76789f9143a442d$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $f76789f9143a442d$var$hasOwn$5(options, "constructor") && options.constructor) {
            if ($f76789f9143a442d$var$DESCRIPTORS$4) $f76789f9143a442d$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $f76789f9143a442d$var$enforceInternalState(value);
    if (!$f76789f9143a442d$var$hasOwn$5(state, "source")) state.source = $f76789f9143a442d$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $f76789f9143a442d$var$makeBuiltIn$1(function toString() {
    return $f76789f9143a442d$var$isCallable$d(this) && $f76789f9143a442d$var$getInternalState$2(this).source || $f76789f9143a442d$var$inspectSource$2(this);
}, "toString");
var $f76789f9143a442d$var$isCallable$c = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$definePropertyModule$4 = $f76789f9143a442d$var$objectDefineProperty;
var $f76789f9143a442d$var$makeBuiltIn = $f76789f9143a442d$var$makeBuiltIn$2.exports;
var $f76789f9143a442d$var$defineGlobalProperty$1 = $f76789f9143a442d$var$defineGlobalProperty$3;
var $f76789f9143a442d$var$defineBuiltIn$6 = function defineBuiltIn$6(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($f76789f9143a442d$var$isCallable$c(value)) $f76789f9143a442d$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f76789f9143a442d$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $f76789f9143a442d$var$definePropertyModule$4.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $f76789f9143a442d$var$objectGetOwnPropertyNames = {};
var $f76789f9143a442d$var$ceil = Math.ceil;
var $f76789f9143a442d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $f76789f9143a442d$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $f76789f9143a442d$var$floor : $f76789f9143a442d$var$ceil)(n);
};
var $f76789f9143a442d$var$trunc = $f76789f9143a442d$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $f76789f9143a442d$var$toIntegerOrInfinity$3 = function toIntegerOrInfinity$3(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $f76789f9143a442d$var$trunc(number);
};
var $f76789f9143a442d$var$toIntegerOrInfinity$2 = $f76789f9143a442d$var$toIntegerOrInfinity$3;
var $f76789f9143a442d$var$max$1 = Math.max;
var $f76789f9143a442d$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $f76789f9143a442d$var$toAbsoluteIndex$2 = function toAbsoluteIndex$2(index, length) {
    var integer = $f76789f9143a442d$var$toIntegerOrInfinity$2(index);
    return integer < 0 ? $f76789f9143a442d$var$max$1(integer + length, 0) : $f76789f9143a442d$var$min$2(integer, length);
};
var $f76789f9143a442d$var$toIntegerOrInfinity$1 = $f76789f9143a442d$var$toIntegerOrInfinity$3;
var $f76789f9143a442d$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $f76789f9143a442d$var$toLength$2 = function toLength$2(argument) {
    return argument > 0 ? $f76789f9143a442d$var$min$1($f76789f9143a442d$var$toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $f76789f9143a442d$var$toLength$1 = $f76789f9143a442d$var$toLength$2;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $f76789f9143a442d$var$lengthOfArrayLike$4 = function lengthOfArrayLike$4(obj) {
    return $f76789f9143a442d$var$toLength$1(obj.length);
};
var $f76789f9143a442d$var$toIndexedObject$3 = $f76789f9143a442d$var$toIndexedObject$5;
var $f76789f9143a442d$var$toAbsoluteIndex$1 = $f76789f9143a442d$var$toAbsoluteIndex$2;
var $f76789f9143a442d$var$lengthOfArrayLike$3 = $f76789f9143a442d$var$lengthOfArrayLike$4;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $f76789f9143a442d$var$createMethod$2 = function createMethod$2(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $f76789f9143a442d$var$toIndexedObject$3($this);
        var length = $f76789f9143a442d$var$lengthOfArrayLike$3(O);
        var index = $f76789f9143a442d$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $f76789f9143a442d$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f76789f9143a442d$var$createMethod$2(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f76789f9143a442d$var$createMethod$2(false)
};
var $f76789f9143a442d$var$uncurryThis$b = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$hasOwn$4 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$toIndexedObject$2 = $f76789f9143a442d$var$toIndexedObject$5;
var $f76789f9143a442d$var$indexOf$1 = $f76789f9143a442d$var$arrayIncludes.indexOf;
var $f76789f9143a442d$var$hiddenKeys$2 = $f76789f9143a442d$var$hiddenKeys$4;
var $f76789f9143a442d$var$push$1 = $f76789f9143a442d$var$uncurryThis$b([].push);
var $f76789f9143a442d$var$objectKeysInternal = function objectKeysInternal(object, names) {
    var O = $f76789f9143a442d$var$toIndexedObject$2(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$f76789f9143a442d$var$hasOwn$4($f76789f9143a442d$var$hiddenKeys$2, key) && $f76789f9143a442d$var$hasOwn$4(O, key) && $f76789f9143a442d$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($f76789f9143a442d$var$hasOwn$4(O, key = names[i++])) ~$f76789f9143a442d$var$indexOf$1(result, key) || $f76789f9143a442d$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $f76789f9143a442d$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $f76789f9143a442d$var$internalObjectKeys$1 = $f76789f9143a442d$var$objectKeysInternal;
var $f76789f9143a442d$var$enumBugKeys$2 = $f76789f9143a442d$var$enumBugKeys$3;
var $f76789f9143a442d$var$hiddenKeys$1 = $f76789f9143a442d$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$f76789f9143a442d$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $f76789f9143a442d$var$internalObjectKeys$1(O, $f76789f9143a442d$var$hiddenKeys$1);
};
var $f76789f9143a442d$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$f76789f9143a442d$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $f76789f9143a442d$var$getBuiltIn$5 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$uncurryThis$a = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$getOwnPropertyNamesModule = $f76789f9143a442d$var$objectGetOwnPropertyNames;
var $f76789f9143a442d$var$getOwnPropertySymbolsModule$1 = $f76789f9143a442d$var$objectGetOwnPropertySymbols;
var $f76789f9143a442d$var$anObject$b = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$concat$1 = $f76789f9143a442d$var$uncurryThis$a([].concat);
// all object keys, includes non-enumerable and symbols
var $f76789f9143a442d$var$ownKeys$1 = $f76789f9143a442d$var$getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f76789f9143a442d$var$getOwnPropertyNamesModule.f($f76789f9143a442d$var$anObject$b(it));
    var getOwnPropertySymbols = $f76789f9143a442d$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $f76789f9143a442d$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $f76789f9143a442d$var$hasOwn$3 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$ownKeys = $f76789f9143a442d$var$ownKeys$1;
var $f76789f9143a442d$var$getOwnPropertyDescriptorModule = $f76789f9143a442d$var$objectGetOwnPropertyDescriptor;
var $f76789f9143a442d$var$definePropertyModule$3 = $f76789f9143a442d$var$objectDefineProperty;
var $f76789f9143a442d$var$copyConstructorProperties$1 = function copyConstructorProperties$1(target, source, exceptions) {
    var keys = $f76789f9143a442d$var$ownKeys(source);
    var defineProperty = $f76789f9143a442d$var$definePropertyModule$3.f;
    var getOwnPropertyDescriptor = $f76789f9143a442d$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$f76789f9143a442d$var$hasOwn$3(target, key) && !(exceptions && $f76789f9143a442d$var$hasOwn$3(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $f76789f9143a442d$var$fails$c = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$isCallable$b = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$replacement = /#|\.prototype\./;
var $f76789f9143a442d$var$isForced$2 = function isForced$2(feature, detection) {
    var value = $f76789f9143a442d$var$data[$f76789f9143a442d$var$normalize(feature)];
    return value == $f76789f9143a442d$var$POLYFILL ? true : value == $f76789f9143a442d$var$NATIVE ? false : $f76789f9143a442d$var$isCallable$b(detection) ? $f76789f9143a442d$var$fails$c(detection) : !!detection;
};
var $f76789f9143a442d$var$normalize = $f76789f9143a442d$var$isForced$2.normalize = function normalize(string) {
    return String(string).replace($f76789f9143a442d$var$replacement, ".").toLowerCase();
};
var $f76789f9143a442d$var$data = $f76789f9143a442d$var$isForced$2.data = {};
var $f76789f9143a442d$var$NATIVE = $f76789f9143a442d$var$isForced$2.NATIVE = "N";
var $f76789f9143a442d$var$POLYFILL = $f76789f9143a442d$var$isForced$2.POLYFILL = "P";
var $f76789f9143a442d$var$isForced_1 = $f76789f9143a442d$var$isForced$2;
var $f76789f9143a442d$var$global$d = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$getOwnPropertyDescriptor$1 = $f76789f9143a442d$var$objectGetOwnPropertyDescriptor.f;
var $f76789f9143a442d$var$createNonEnumerableProperty$3 = $f76789f9143a442d$var$createNonEnumerableProperty$5;
var $f76789f9143a442d$var$defineBuiltIn$5 = $f76789f9143a442d$var$defineBuiltIn$6;
var $f76789f9143a442d$var$defineGlobalProperty = $f76789f9143a442d$var$defineGlobalProperty$3;
var $f76789f9143a442d$var$copyConstructorProperties = $f76789f9143a442d$var$copyConstructorProperties$1;
var $f76789f9143a442d$var$isForced$1 = $f76789f9143a442d$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $f76789f9143a442d$var$_export = function _export(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $f76789f9143a442d$var$global$d;
    else if (STATIC) target = $f76789f9143a442d$var$global$d[TARGET] || $f76789f9143a442d$var$defineGlobalProperty(TARGET, {});
    else target = ($f76789f9143a442d$var$global$d[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $f76789f9143a442d$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $f76789f9143a442d$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $1ObTH._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $1ObTH._)(targetProperty))) continue;
            $f76789f9143a442d$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $f76789f9143a442d$var$createNonEnumerableProperty$3(sourceProperty, "sham", true);
        $f76789f9143a442d$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $f76789f9143a442d$var$classof$6 = $f76789f9143a442d$var$classofRaw$1;
var $f76789f9143a442d$var$global$c = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$engineIsNode = $f76789f9143a442d$var$classof$6($f76789f9143a442d$var$global$c.process) == "process";
var $f76789f9143a442d$var$isCallable$a = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$$String$1 = String;
var $f76789f9143a442d$var$$TypeError$8 = TypeError;
var $f76789f9143a442d$var$aPossiblePrototype$1 = function aPossiblePrototype$1(argument) {
    if (typeof argument == "object" || $f76789f9143a442d$var$isCallable$a(argument)) return argument;
    throw $f76789f9143a442d$var$$TypeError$8("Can't set " + $f76789f9143a442d$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $f76789f9143a442d$var$uncurryThis$9 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$anObject$a = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$aPossiblePrototype = $f76789f9143a442d$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $f76789f9143a442d$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $f76789f9143a442d$var$uncurryThis$9(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $f76789f9143a442d$var$anObject$a(O);
        $f76789f9143a442d$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $f76789f9143a442d$var$defineProperty$3 = $f76789f9143a442d$var$objectDefineProperty.f;
var $f76789f9143a442d$var$hasOwn$2 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$wellKnownSymbol$f = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$TO_STRING_TAG$3 = $f76789f9143a442d$var$wellKnownSymbol$f("toStringTag");
var $f76789f9143a442d$var$setToStringTag$3 = function setToStringTag$3(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$f76789f9143a442d$var$hasOwn$2(target, $f76789f9143a442d$var$TO_STRING_TAG$3)) $f76789f9143a442d$var$defineProperty$3(target, $f76789f9143a442d$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $f76789f9143a442d$var$getBuiltIn$4 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$definePropertyModule$2 = $f76789f9143a442d$var$objectDefineProperty;
var $f76789f9143a442d$var$wellKnownSymbol$e = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$DESCRIPTORS$3 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$SPECIES$3 = $f76789f9143a442d$var$wellKnownSymbol$e("species");
var $f76789f9143a442d$var$setSpecies$1 = function setSpecies$1(CONSTRUCTOR_NAME) {
    var Constructor = $f76789f9143a442d$var$getBuiltIn$4(CONSTRUCTOR_NAME);
    var defineProperty = $f76789f9143a442d$var$definePropertyModule$2.f;
    if ($f76789f9143a442d$var$DESCRIPTORS$3 && Constructor && !Constructor[$f76789f9143a442d$var$SPECIES$3]) defineProperty(Constructor, $f76789f9143a442d$var$SPECIES$3, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};
var $f76789f9143a442d$var$isPrototypeOf$1 = $f76789f9143a442d$var$objectIsPrototypeOf;
var $f76789f9143a442d$var$$TypeError$7 = TypeError;
var $f76789f9143a442d$var$anInstance$1 = function anInstance$1(it, Prototype) {
    if ($f76789f9143a442d$var$isPrototypeOf$1(Prototype, it)) return it;
    throw $f76789f9143a442d$var$$TypeError$7("Incorrect invocation");
};
var $f76789f9143a442d$var$wellKnownSymbol$d = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$TO_STRING_TAG$2 = $f76789f9143a442d$var$wellKnownSymbol$d("toStringTag");
var $f76789f9143a442d$var$test = {};
$f76789f9143a442d$var$test[$f76789f9143a442d$var$TO_STRING_TAG$2] = "z";
var $f76789f9143a442d$var$toStringTagSupport = String($f76789f9143a442d$var$test) === "[object z]";
var $f76789f9143a442d$var$TO_STRING_TAG_SUPPORT = $f76789f9143a442d$var$toStringTagSupport;
var $f76789f9143a442d$var$isCallable$9 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$classofRaw = $f76789f9143a442d$var$classofRaw$1;
var $f76789f9143a442d$var$wellKnownSymbol$c = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$TO_STRING_TAG$1 = $f76789f9143a442d$var$wellKnownSymbol$c("toStringTag");
var $f76789f9143a442d$var$$Object$1 = Object;
// ES3 wrong here
var $f76789f9143a442d$var$CORRECT_ARGUMENTS = $f76789f9143a442d$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $f76789f9143a442d$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $f76789f9143a442d$var$classof$5 = $f76789f9143a442d$var$TO_STRING_TAG_SUPPORT ? $f76789f9143a442d$var$classofRaw : function classof$5(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $f76789f9143a442d$var$tryGet(O = $f76789f9143a442d$var$$Object$1(it), $f76789f9143a442d$var$TO_STRING_TAG$1)) == "string" ? tag : $f76789f9143a442d$var$CORRECT_ARGUMENTS ? $f76789f9143a442d$var$classofRaw(O) : (result = $f76789f9143a442d$var$classofRaw(O)) == "Object" && $f76789f9143a442d$var$isCallable$9(O.callee) ? "Arguments" : result;
};
var $f76789f9143a442d$var$uncurryThis$8 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$fails$b = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$isCallable$8 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$classof$4 = $f76789f9143a442d$var$classof$5;
var $f76789f9143a442d$var$getBuiltIn$3 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$inspectSource$1 = $f76789f9143a442d$var$inspectSource$4;
var $f76789f9143a442d$var$noop = function noop() {};
var $f76789f9143a442d$var$empty = [];
var $f76789f9143a442d$var$construct = $f76789f9143a442d$var$getBuiltIn$3("Reflect", "construct");
var $f76789f9143a442d$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $f76789f9143a442d$var$exec$2 = $f76789f9143a442d$var$uncurryThis$8($f76789f9143a442d$var$constructorRegExp.exec);
var $f76789f9143a442d$var$INCORRECT_TO_STRING = !$f76789f9143a442d$var$constructorRegExp.exec($f76789f9143a442d$var$noop);
var $f76789f9143a442d$var$isConstructorModern = function isConstructor(argument) {
    if (!$f76789f9143a442d$var$isCallable$8(argument)) return false;
    try {
        $f76789f9143a442d$var$construct($f76789f9143a442d$var$noop, $f76789f9143a442d$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $f76789f9143a442d$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$f76789f9143a442d$var$isCallable$8(argument)) return false;
    switch($f76789f9143a442d$var$classof$4(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $f76789f9143a442d$var$INCORRECT_TO_STRING || !!$f76789f9143a442d$var$exec$2($f76789f9143a442d$var$constructorRegExp, $f76789f9143a442d$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$f76789f9143a442d$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $f76789f9143a442d$var$isConstructor$1 = !$f76789f9143a442d$var$construct || $f76789f9143a442d$var$fails$b(function() {
    var called;
    return $f76789f9143a442d$var$isConstructorModern($f76789f9143a442d$var$isConstructorModern.call) || !$f76789f9143a442d$var$isConstructorModern(Object) || !$f76789f9143a442d$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $f76789f9143a442d$var$isConstructorLegacy : $f76789f9143a442d$var$isConstructorModern;
var $f76789f9143a442d$var$isConstructor = $f76789f9143a442d$var$isConstructor$1;
var $f76789f9143a442d$var$tryToString$2 = $f76789f9143a442d$var$tryToString$4;
var $f76789f9143a442d$var$$TypeError$6 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $f76789f9143a442d$var$aConstructor$1 = function aConstructor$1(argument) {
    if ($f76789f9143a442d$var$isConstructor(argument)) return argument;
    throw $f76789f9143a442d$var$$TypeError$6($f76789f9143a442d$var$tryToString$2(argument) + " is not a constructor");
};
var $f76789f9143a442d$var$anObject$9 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$aConstructor = $f76789f9143a442d$var$aConstructor$1;
var $f76789f9143a442d$var$wellKnownSymbol$b = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$SPECIES$2 = $f76789f9143a442d$var$wellKnownSymbol$b("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $f76789f9143a442d$var$speciesConstructor$2 = function speciesConstructor$2(O, defaultConstructor) {
    var C = $f76789f9143a442d$var$anObject$9(O).constructor;
    var S;
    return C === undefined || (S = $f76789f9143a442d$var$anObject$9(C)[$f76789f9143a442d$var$SPECIES$2]) == undefined ? defaultConstructor : $f76789f9143a442d$var$aConstructor(S);
};
var $f76789f9143a442d$var$NATIVE_BIND$1 = $f76789f9143a442d$var$functionBindNative;
var $f76789f9143a442d$var$FunctionPrototype = Function.prototype;
var $f76789f9143a442d$var$apply$2 = $f76789f9143a442d$var$FunctionPrototype.apply;
var $f76789f9143a442d$var$call$c = $f76789f9143a442d$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $f76789f9143a442d$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($f76789f9143a442d$var$NATIVE_BIND$1 ? $f76789f9143a442d$var$call$c.bind($f76789f9143a442d$var$apply$2) : function() {
    return $f76789f9143a442d$var$call$c.apply($f76789f9143a442d$var$apply$2, arguments);
});
var $f76789f9143a442d$var$uncurryThis$7 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$aCallable$6 = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$NATIVE_BIND = $f76789f9143a442d$var$functionBindNative;
var $f76789f9143a442d$var$bind$4 = $f76789f9143a442d$var$uncurryThis$7($f76789f9143a442d$var$uncurryThis$7.bind);
// optional / simple context binding
var $f76789f9143a442d$var$functionBindContext = function functionBindContext(fn, that) {
    $f76789f9143a442d$var$aCallable$6(fn);
    return that === undefined ? fn : $f76789f9143a442d$var$NATIVE_BIND ? $f76789f9143a442d$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $f76789f9143a442d$var$getBuiltIn$2 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$html$2 = $f76789f9143a442d$var$getBuiltIn$2("document", "documentElement");
var $f76789f9143a442d$var$uncurryThis$6 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$arraySlice$2 = $f76789f9143a442d$var$uncurryThis$6([].slice);
var $f76789f9143a442d$var$$TypeError$5 = TypeError;
var $f76789f9143a442d$var$validateArgumentsLength$1 = function validateArgumentsLength$1(passed, required) {
    if (passed < required) throw $f76789f9143a442d$var$$TypeError$5("Not enough arguments");
    return passed;
};
var $f76789f9143a442d$var$userAgent$2 = $f76789f9143a442d$var$engineUserAgent;
var $f76789f9143a442d$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($f76789f9143a442d$var$userAgent$2);
var $f76789f9143a442d$var$global$b = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$apply$1 = $f76789f9143a442d$var$functionApply;
var $f76789f9143a442d$var$bind$3 = $f76789f9143a442d$var$functionBindContext;
var $f76789f9143a442d$var$isCallable$7 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$hasOwn$1 = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$fails$a = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$html$1 = $f76789f9143a442d$var$html$2;
var $f76789f9143a442d$var$arraySlice$1 = $f76789f9143a442d$var$arraySlice$2;
var $f76789f9143a442d$var$createElement = $f76789f9143a442d$var$documentCreateElement$2;
var $f76789f9143a442d$var$validateArgumentsLength = $f76789f9143a442d$var$validateArgumentsLength$1;
var $f76789f9143a442d$var$IS_IOS$1 = $f76789f9143a442d$var$engineIsIos;
var $f76789f9143a442d$var$IS_NODE$3 = $f76789f9143a442d$var$engineIsNode;
var $f76789f9143a442d$var$set = $f76789f9143a442d$var$global$b.setImmediate;
var $f76789f9143a442d$var$clear = $f76789f9143a442d$var$global$b.clearImmediate;
var $f76789f9143a442d$var$process$2 = $f76789f9143a442d$var$global$b.process;
var $f76789f9143a442d$var$Dispatch = $f76789f9143a442d$var$global$b.Dispatch;
var $f76789f9143a442d$var$Function$1 = $f76789f9143a442d$var$global$b.Function;
var $f76789f9143a442d$var$MessageChannel = $f76789f9143a442d$var$global$b.MessageChannel;
var $f76789f9143a442d$var$String$1 = $f76789f9143a442d$var$global$b.String;
var $f76789f9143a442d$var$counter = 0;
var $f76789f9143a442d$var$queue$1 = {};
var $f76789f9143a442d$var$ONREADYSTATECHANGE = "onreadystatechange";
var $f76789f9143a442d$var$location, $f76789f9143a442d$var$defer, $f76789f9143a442d$var$channel, $f76789f9143a442d$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $f76789f9143a442d$var$location = $f76789f9143a442d$var$global$b.location;
} catch (error) {}
var $f76789f9143a442d$var$run = function run(id) {
    if ($f76789f9143a442d$var$hasOwn$1($f76789f9143a442d$var$queue$1, id)) {
        var fn = $f76789f9143a442d$var$queue$1[id];
        delete $f76789f9143a442d$var$queue$1[id];
        fn();
    }
};
var $f76789f9143a442d$var$runner = function runner(id) {
    return function() {
        $f76789f9143a442d$var$run(id);
    };
};
var $f76789f9143a442d$var$listener = function listener(event) {
    $f76789f9143a442d$var$run(event.data);
};
var $f76789f9143a442d$var$post = function post(id) {
    // old engines have not location.origin
    $f76789f9143a442d$var$global$b.postMessage($f76789f9143a442d$var$String$1(id), $f76789f9143a442d$var$location.protocol + "//" + $f76789f9143a442d$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$f76789f9143a442d$var$set || !$f76789f9143a442d$var$clear) {
    $f76789f9143a442d$var$set = function setImmediate(handler) {
        $f76789f9143a442d$var$validateArgumentsLength(arguments.length, 1);
        var fn = $f76789f9143a442d$var$isCallable$7(handler) ? handler : $f76789f9143a442d$var$Function$1(handler);
        var args = $f76789f9143a442d$var$arraySlice$1(arguments, 1);
        $f76789f9143a442d$var$queue$1[++$f76789f9143a442d$var$counter] = function() {
            $f76789f9143a442d$var$apply$1(fn, undefined, args);
        };
        $f76789f9143a442d$var$defer($f76789f9143a442d$var$counter);
        return $f76789f9143a442d$var$counter;
    };
    $f76789f9143a442d$var$clear = function clearImmediate(id) {
        delete $f76789f9143a442d$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($f76789f9143a442d$var$IS_NODE$3) $f76789f9143a442d$var$defer = function defer(id) {
        $f76789f9143a442d$var$process$2.nextTick($f76789f9143a442d$var$runner(id));
    };
    else if ($f76789f9143a442d$var$Dispatch && $f76789f9143a442d$var$Dispatch.now) $f76789f9143a442d$var$defer = function defer(id) {
        $f76789f9143a442d$var$Dispatch.now($f76789f9143a442d$var$runner(id));
    };
    else if ($f76789f9143a442d$var$MessageChannel && !$f76789f9143a442d$var$IS_IOS$1) {
        $f76789f9143a442d$var$channel = new $f76789f9143a442d$var$MessageChannel();
        $f76789f9143a442d$var$port = $f76789f9143a442d$var$channel.port2;
        $f76789f9143a442d$var$channel.port1.onmessage = $f76789f9143a442d$var$listener;
        $f76789f9143a442d$var$defer = $f76789f9143a442d$var$bind$3($f76789f9143a442d$var$port.postMessage, $f76789f9143a442d$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($f76789f9143a442d$var$global$b.addEventListener && $f76789f9143a442d$var$isCallable$7($f76789f9143a442d$var$global$b.postMessage) && !$f76789f9143a442d$var$global$b.importScripts && $f76789f9143a442d$var$location && $f76789f9143a442d$var$location.protocol !== "file:" && !$f76789f9143a442d$var$fails$a($f76789f9143a442d$var$post)) {
        $f76789f9143a442d$var$defer = $f76789f9143a442d$var$post;
        $f76789f9143a442d$var$global$b.addEventListener("message", $f76789f9143a442d$var$listener, false);
    // IE8-
    } else if ($f76789f9143a442d$var$ONREADYSTATECHANGE in $f76789f9143a442d$var$createElement("script")) $f76789f9143a442d$var$defer = function defer(id) {
        $f76789f9143a442d$var$html$1.appendChild($f76789f9143a442d$var$createElement("script"))[$f76789f9143a442d$var$ONREADYSTATECHANGE] = function() {
            $f76789f9143a442d$var$html$1.removeChild(this);
            $f76789f9143a442d$var$run(id);
        };
    };
    else $f76789f9143a442d$var$defer = function defer(id) {
        setTimeout($f76789f9143a442d$var$runner(id), 0);
    };
}
var $f76789f9143a442d$var$task$1 = {
    set: $f76789f9143a442d$var$set,
    clear: $f76789f9143a442d$var$clear
};
var $f76789f9143a442d$var$userAgent$1 = $f76789f9143a442d$var$engineUserAgent;
var $f76789f9143a442d$var$global$a = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($f76789f9143a442d$var$userAgent$1) && $f76789f9143a442d$var$global$a.Pebble !== undefined;
var $f76789f9143a442d$var$userAgent = $f76789f9143a442d$var$engineUserAgent;
var $f76789f9143a442d$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($f76789f9143a442d$var$userAgent);
var $f76789f9143a442d$var$global$9 = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$bind$2 = $f76789f9143a442d$var$functionBindContext;
var $f76789f9143a442d$var$getOwnPropertyDescriptor = $f76789f9143a442d$var$objectGetOwnPropertyDescriptor.f;
var $f76789f9143a442d$var$macrotask = $f76789f9143a442d$var$task$1.set;
var $f76789f9143a442d$var$IS_IOS = $f76789f9143a442d$var$engineIsIos;
var $f76789f9143a442d$var$IS_IOS_PEBBLE = $f76789f9143a442d$var$engineIsIosPebble;
var $f76789f9143a442d$var$IS_WEBOS_WEBKIT = $f76789f9143a442d$var$engineIsWebosWebkit;
var $f76789f9143a442d$var$IS_NODE$2 = $f76789f9143a442d$var$engineIsNode;
var $f76789f9143a442d$var$MutationObserver = $f76789f9143a442d$var$global$9.MutationObserver || $f76789f9143a442d$var$global$9.WebKitMutationObserver;
var $f76789f9143a442d$var$document$2 = $f76789f9143a442d$var$global$9.document;
var $f76789f9143a442d$var$process$1 = $f76789f9143a442d$var$global$9.process;
var $f76789f9143a442d$var$Promise$1 = $f76789f9143a442d$var$global$9.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $f76789f9143a442d$var$queueMicrotaskDescriptor = $f76789f9143a442d$var$getOwnPropertyDescriptor($f76789f9143a442d$var$global$9, "queueMicrotask");
var $f76789f9143a442d$var$queueMicrotask = $f76789f9143a442d$var$queueMicrotaskDescriptor && $f76789f9143a442d$var$queueMicrotaskDescriptor.value;
var $f76789f9143a442d$var$flush, $f76789f9143a442d$var$head, $f76789f9143a442d$var$last, $f76789f9143a442d$var$notify$1, $f76789f9143a442d$var$toggle, $f76789f9143a442d$var$node, $f76789f9143a442d$var$promise, $f76789f9143a442d$var$then;
// modern engines have queueMicrotask method
if (!$f76789f9143a442d$var$queueMicrotask) {
    $f76789f9143a442d$var$flush = function flush() {
        var parent, fn;
        if ($f76789f9143a442d$var$IS_NODE$2 && (parent = $f76789f9143a442d$var$process$1.domain)) parent.exit();
        while($f76789f9143a442d$var$head){
            fn = $f76789f9143a442d$var$head.fn;
            $f76789f9143a442d$var$head = $f76789f9143a442d$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($f76789f9143a442d$var$head) $f76789f9143a442d$var$notify$1();
                else $f76789f9143a442d$var$last = undefined;
                throw error;
            }
        }
        $f76789f9143a442d$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$f76789f9143a442d$var$IS_IOS && !$f76789f9143a442d$var$IS_NODE$2 && !$f76789f9143a442d$var$IS_WEBOS_WEBKIT && $f76789f9143a442d$var$MutationObserver && $f76789f9143a442d$var$document$2) {
        $f76789f9143a442d$var$toggle = true;
        $f76789f9143a442d$var$node = $f76789f9143a442d$var$document$2.createTextNode("");
        new $f76789f9143a442d$var$MutationObserver($f76789f9143a442d$var$flush).observe($f76789f9143a442d$var$node, {
            characterData: true
        });
        $f76789f9143a442d$var$notify$1 = function notify$1() {
            $f76789f9143a442d$var$node.data = $f76789f9143a442d$var$toggle = !$f76789f9143a442d$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$f76789f9143a442d$var$IS_IOS_PEBBLE && $f76789f9143a442d$var$Promise$1 && $f76789f9143a442d$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $f76789f9143a442d$var$promise = $f76789f9143a442d$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $f76789f9143a442d$var$promise.constructor = $f76789f9143a442d$var$Promise$1;
        $f76789f9143a442d$var$then = $f76789f9143a442d$var$bind$2($f76789f9143a442d$var$promise.then, $f76789f9143a442d$var$promise);
        $f76789f9143a442d$var$notify$1 = function notify$1() {
            $f76789f9143a442d$var$then($f76789f9143a442d$var$flush);
        };
    // Node.js without promises
    } else if ($f76789f9143a442d$var$IS_NODE$2) $f76789f9143a442d$var$notify$1 = function notify$1() {
        $f76789f9143a442d$var$process$1.nextTick($f76789f9143a442d$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $f76789f9143a442d$var$macrotask = $f76789f9143a442d$var$bind$2($f76789f9143a442d$var$macrotask, $f76789f9143a442d$var$global$9);
        $f76789f9143a442d$var$notify$1 = function notify$1() {
            $f76789f9143a442d$var$macrotask($f76789f9143a442d$var$flush);
        };
    }
}
var $f76789f9143a442d$var$microtask$1 = $f76789f9143a442d$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($f76789f9143a442d$var$last) $f76789f9143a442d$var$last.next = task;
    if (!$f76789f9143a442d$var$head) {
        $f76789f9143a442d$var$head = task;
        $f76789f9143a442d$var$notify$1();
    }
    $f76789f9143a442d$var$last = task;
};
var $f76789f9143a442d$var$global$8 = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$hostReportErrors$1 = function hostReportErrors$1(a, b) {
    var console1 = $f76789f9143a442d$var$global$8.console;
    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
};
var $f76789f9143a442d$var$perform$3 = function perform$3(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $f76789f9143a442d$var$Queue$1 = function Queue$1() {
    this.head = null;
    this.tail = null;
};
$f76789f9143a442d$var$Queue$1.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $f76789f9143a442d$var$queue = $f76789f9143a442d$var$Queue$1;
var $f76789f9143a442d$var$global$7 = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$promiseNativeConstructor = $f76789f9143a442d$var$global$7.Promise;
var $f76789f9143a442d$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $f76789f9143a442d$var$global$6 = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$NativePromiseConstructor$3 = $f76789f9143a442d$var$promiseNativeConstructor;
var $f76789f9143a442d$var$isCallable$6 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$isForced = $f76789f9143a442d$var$isForced_1;
var $f76789f9143a442d$var$inspectSource = $f76789f9143a442d$var$inspectSource$4;
var $f76789f9143a442d$var$wellKnownSymbol$a = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$IS_BROWSER = $f76789f9143a442d$var$engineIsBrowser;
var $f76789f9143a442d$var$V8_VERSION = $f76789f9143a442d$var$engineV8Version;
$f76789f9143a442d$var$NativePromiseConstructor$3 && $f76789f9143a442d$var$NativePromiseConstructor$3.prototype;
var $f76789f9143a442d$var$SPECIES$1 = $f76789f9143a442d$var$wellKnownSymbol$a("species");
var $f76789f9143a442d$var$SUBCLASSING = false;
var $f76789f9143a442d$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $f76789f9143a442d$var$isCallable$6($f76789f9143a442d$var$global$6.PromiseRejectionEvent);
var $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$5 = $f76789f9143a442d$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $f76789f9143a442d$var$inspectSource($f76789f9143a442d$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($f76789f9143a442d$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $f76789f9143a442d$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($f76789f9143a442d$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $f76789f9143a442d$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function FakePromise(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$f76789f9143a442d$var$SPECIES$1] = FakePromise;
    $f76789f9143a442d$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$f76789f9143a442d$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $f76789f9143a442d$var$IS_BROWSER && !$f76789f9143a442d$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $f76789f9143a442d$var$promiseConstructorDetection = {
    CONSTRUCTOR: $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $f76789f9143a442d$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $f76789f9143a442d$var$SUBCLASSING
};
var $f76789f9143a442d$var$newPromiseCapability$2 = {};
var $f76789f9143a442d$var$aCallable$5 = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $f76789f9143a442d$var$aCallable$5(resolve);
    this.reject = $f76789f9143a442d$var$aCallable$5(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$f76789f9143a442d$var$newPromiseCapability$2.f = function(C) {
    return new $f76789f9143a442d$var$PromiseCapability(C);
};
var $f76789f9143a442d$var$$$b = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$IS_NODE$1 = $f76789f9143a442d$var$engineIsNode;
var $f76789f9143a442d$var$global$5 = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$call$b = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$defineBuiltIn$4 = $f76789f9143a442d$var$defineBuiltIn$6;
var $f76789f9143a442d$var$setPrototypeOf$1 = $f76789f9143a442d$var$objectSetPrototypeOf;
var $f76789f9143a442d$var$setToStringTag$2 = $f76789f9143a442d$var$setToStringTag$3;
var $f76789f9143a442d$var$setSpecies = $f76789f9143a442d$var$setSpecies$1;
var $f76789f9143a442d$var$aCallable$4 = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$isCallable$5 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$isObject$2 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$anInstance = $f76789f9143a442d$var$anInstance$1;
var $f76789f9143a442d$var$speciesConstructor$1 = $f76789f9143a442d$var$speciesConstructor$2;
var $f76789f9143a442d$var$task = $f76789f9143a442d$var$task$1.set;
var $f76789f9143a442d$var$microtask = $f76789f9143a442d$var$microtask$1;
var $f76789f9143a442d$var$hostReportErrors = $f76789f9143a442d$var$hostReportErrors$1;
var $f76789f9143a442d$var$perform$2 = $f76789f9143a442d$var$perform$3;
var $f76789f9143a442d$var$Queue = $f76789f9143a442d$var$queue;
var $f76789f9143a442d$var$InternalStateModule$1 = $f76789f9143a442d$var$internalState;
var $f76789f9143a442d$var$NativePromiseConstructor$2 = $f76789f9143a442d$var$promiseNativeConstructor;
var $f76789f9143a442d$var$PromiseConstructorDetection = $f76789f9143a442d$var$promiseConstructorDetection;
var $f76789f9143a442d$var$newPromiseCapabilityModule$3 = $f76789f9143a442d$var$newPromiseCapability$2;
var $f76789f9143a442d$var$PROMISE = "Promise";
var $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$4 = $f76789f9143a442d$var$PromiseConstructorDetection.CONSTRUCTOR;
var $f76789f9143a442d$var$NATIVE_PROMISE_REJECTION_EVENT = $f76789f9143a442d$var$PromiseConstructorDetection.REJECTION_EVENT;
var $f76789f9143a442d$var$NATIVE_PROMISE_SUBCLASSING = $f76789f9143a442d$var$PromiseConstructorDetection.SUBCLASSING;
var $f76789f9143a442d$var$getInternalPromiseState = $f76789f9143a442d$var$InternalStateModule$1.getterFor($f76789f9143a442d$var$PROMISE);
var $f76789f9143a442d$var$setInternalState$1 = $f76789f9143a442d$var$InternalStateModule$1.set;
var $f76789f9143a442d$var$NativePromisePrototype$1 = $f76789f9143a442d$var$NativePromiseConstructor$2 && $f76789f9143a442d$var$NativePromiseConstructor$2.prototype;
var $f76789f9143a442d$var$PromiseConstructor = $f76789f9143a442d$var$NativePromiseConstructor$2;
var $f76789f9143a442d$var$PromisePrototype = $f76789f9143a442d$var$NativePromisePrototype$1;
var $f76789f9143a442d$var$TypeError$1 = $f76789f9143a442d$var$global$5.TypeError;
var $f76789f9143a442d$var$document$1 = $f76789f9143a442d$var$global$5.document;
var $f76789f9143a442d$var$process = $f76789f9143a442d$var$global$5.process;
var $f76789f9143a442d$var$newPromiseCapability$1 = $f76789f9143a442d$var$newPromiseCapabilityModule$3.f;
var $f76789f9143a442d$var$newGenericPromiseCapability = $f76789f9143a442d$var$newPromiseCapability$1;
var $f76789f9143a442d$var$DISPATCH_EVENT = !!($f76789f9143a442d$var$document$1 && $f76789f9143a442d$var$document$1.createEvent && $f76789f9143a442d$var$global$5.dispatchEvent);
var $f76789f9143a442d$var$UNHANDLED_REJECTION = "unhandledrejection";
var $f76789f9143a442d$var$REJECTION_HANDLED = "rejectionhandled";
var $f76789f9143a442d$var$PENDING = 0;
var $f76789f9143a442d$var$FULFILLED = 1;
var $f76789f9143a442d$var$REJECTED = 2;
var $f76789f9143a442d$var$HANDLED = 1;
var $f76789f9143a442d$var$UNHANDLED = 2;
var $f76789f9143a442d$var$Internal, $f76789f9143a442d$var$OwnPromiseCapability, $f76789f9143a442d$var$PromiseWrapper, $f76789f9143a442d$var$nativeThen;
// helpers
var $f76789f9143a442d$var$isThenable = function isThenable(it) {
    var then;
    return $f76789f9143a442d$var$isObject$2(it) && $f76789f9143a442d$var$isCallable$5(then = it.then) ? then : false;
};
var $f76789f9143a442d$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state == $f76789f9143a442d$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $f76789f9143a442d$var$UNHANDLED) $f76789f9143a442d$var$onHandleUnhandled(state);
                state.rejection = $f76789f9143a442d$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($f76789f9143a442d$var$TypeError$1("Promise-chain cycle"));
            else if (then = $f76789f9143a442d$var$isThenable(result)) $f76789f9143a442d$var$call$b(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $f76789f9143a442d$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $f76789f9143a442d$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$f76789f9143a442d$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $f76789f9143a442d$var$onUnhandled(state);
    });
};
var $f76789f9143a442d$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($f76789f9143a442d$var$DISPATCH_EVENT) {
        event = $f76789f9143a442d$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $f76789f9143a442d$var$global$5.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$f76789f9143a442d$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $f76789f9143a442d$var$global$5["on" + name])) handler(event);
    else if (name === $f76789f9143a442d$var$UNHANDLED_REJECTION) $f76789f9143a442d$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $f76789f9143a442d$var$onUnhandled = function onUnhandled(state) {
    $f76789f9143a442d$var$call$b($f76789f9143a442d$var$task, $f76789f9143a442d$var$global$5, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $f76789f9143a442d$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $f76789f9143a442d$var$perform$2(function() {
                if ($f76789f9143a442d$var$IS_NODE$1) $f76789f9143a442d$var$process.emit("unhandledRejection", value, promise);
                else $f76789f9143a442d$var$dispatchEvent($f76789f9143a442d$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $f76789f9143a442d$var$IS_NODE$1 || $f76789f9143a442d$var$isUnhandled(state) ? $f76789f9143a442d$var$UNHANDLED : $f76789f9143a442d$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $f76789f9143a442d$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $f76789f9143a442d$var$HANDLED && !state.parent;
};
var $f76789f9143a442d$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $f76789f9143a442d$var$call$b($f76789f9143a442d$var$task, $f76789f9143a442d$var$global$5, function() {
        var promise = state.facade;
        if ($f76789f9143a442d$var$IS_NODE$1) $f76789f9143a442d$var$process.emit("rejectionHandled", promise);
        else $f76789f9143a442d$var$dispatchEvent($f76789f9143a442d$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $f76789f9143a442d$var$bind$1 = function bind$1(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $f76789f9143a442d$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $f76789f9143a442d$var$REJECTED;
    $f76789f9143a442d$var$notify(state, true);
};
var $f76789f9143a442d$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $f76789f9143a442d$var$TypeError$1("Promise can't be resolved itself");
        var then = $f76789f9143a442d$var$isThenable(value);
        if (then) $f76789f9143a442d$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $f76789f9143a442d$var$call$b(then, value, $f76789f9143a442d$var$bind$1($f76789f9143a442d$var$internalResolve, wrapper, state), $f76789f9143a442d$var$bind$1($f76789f9143a442d$var$internalReject, wrapper, state));
            } catch (error) {
                $f76789f9143a442d$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $f76789f9143a442d$var$FULFILLED;
            $f76789f9143a442d$var$notify(state, false);
        }
    } catch (error) {
        $f76789f9143a442d$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $f76789f9143a442d$var$PromiseConstructor = function Promise1(executor) {
        $f76789f9143a442d$var$anInstance(this, $f76789f9143a442d$var$PromisePrototype);
        $f76789f9143a442d$var$aCallable$4(executor);
        $f76789f9143a442d$var$call$b($f76789f9143a442d$var$Internal, this);
        var state = $f76789f9143a442d$var$getInternalPromiseState(this);
        try {
            executor($f76789f9143a442d$var$bind$1($f76789f9143a442d$var$internalResolve, state), $f76789f9143a442d$var$bind$1($f76789f9143a442d$var$internalReject, state));
        } catch (error) {
            $f76789f9143a442d$var$internalReject(state, error);
        }
    };
    $f76789f9143a442d$var$PromisePrototype = $f76789f9143a442d$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $f76789f9143a442d$var$Internal = function Promise1(executor) {
        $f76789f9143a442d$var$setInternalState$1(this, {
            type: $f76789f9143a442d$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $f76789f9143a442d$var$Queue(),
            rejection: false,
            state: $f76789f9143a442d$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $f76789f9143a442d$var$Internal.prototype = $f76789f9143a442d$var$defineBuiltIn$4($f76789f9143a442d$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $f76789f9143a442d$var$getInternalPromiseState(this);
        var reaction = $f76789f9143a442d$var$newPromiseCapability$1($f76789f9143a442d$var$speciesConstructor$1(this, $f76789f9143a442d$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $f76789f9143a442d$var$isCallable$5(onFulfilled) ? onFulfilled : true;
        reaction.fail = $f76789f9143a442d$var$isCallable$5(onRejected) && onRejected;
        reaction.domain = $f76789f9143a442d$var$IS_NODE$1 ? $f76789f9143a442d$var$process.domain : undefined;
        if (state.state == $f76789f9143a442d$var$PENDING) state.reactions.add(reaction);
        else $f76789f9143a442d$var$microtask(function() {
            $f76789f9143a442d$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $f76789f9143a442d$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $f76789f9143a442d$var$Internal();
        var state = $f76789f9143a442d$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $f76789f9143a442d$var$bind$1($f76789f9143a442d$var$internalResolve, state);
        this.reject = $f76789f9143a442d$var$bind$1($f76789f9143a442d$var$internalReject, state);
    };
    $f76789f9143a442d$var$newPromiseCapabilityModule$3.f = $f76789f9143a442d$var$newPromiseCapability$1 = function newPromiseCapability$1(C) {
        return C === $f76789f9143a442d$var$PromiseConstructor || C === $f76789f9143a442d$var$PromiseWrapper ? new $f76789f9143a442d$var$OwnPromiseCapability(C) : $f76789f9143a442d$var$newGenericPromiseCapability(C);
    };
    if ($f76789f9143a442d$var$isCallable$5($f76789f9143a442d$var$NativePromiseConstructor$2) && $f76789f9143a442d$var$NativePromisePrototype$1 !== Object.prototype) {
        $f76789f9143a442d$var$nativeThen = $f76789f9143a442d$var$NativePromisePrototype$1.then;
        if (!$f76789f9143a442d$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $f76789f9143a442d$var$defineBuiltIn$4($f76789f9143a442d$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $f76789f9143a442d$var$PromiseConstructor(function(resolve, reject) {
                $f76789f9143a442d$var$call$b($f76789f9143a442d$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $f76789f9143a442d$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($f76789f9143a442d$var$setPrototypeOf$1) $f76789f9143a442d$var$setPrototypeOf$1($f76789f9143a442d$var$NativePromisePrototype$1, $f76789f9143a442d$var$PromisePrototype);
    }
}
$f76789f9143a442d$var$$$b({
    global: true,
    constructor: true,
    wrap: true,
    forced: $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $f76789f9143a442d$var$PromiseConstructor
});
$f76789f9143a442d$var$setToStringTag$2($f76789f9143a442d$var$PromiseConstructor, $f76789f9143a442d$var$PROMISE, false);
$f76789f9143a442d$var$setSpecies($f76789f9143a442d$var$PROMISE);
var $f76789f9143a442d$var$iterators = {};
var $f76789f9143a442d$var$wellKnownSymbol$9 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$Iterators$4 = $f76789f9143a442d$var$iterators;
var $f76789f9143a442d$var$ITERATOR$5 = $f76789f9143a442d$var$wellKnownSymbol$9("iterator");
var $f76789f9143a442d$var$ArrayPrototype$1 = Array.prototype;
// check on default Array iterator
var $f76789f9143a442d$var$isArrayIteratorMethod$1 = function isArrayIteratorMethod$1(it) {
    return it !== undefined && ($f76789f9143a442d$var$Iterators$4.Array === it || $f76789f9143a442d$var$ArrayPrototype$1[$f76789f9143a442d$var$ITERATOR$5] === it);
};
var $f76789f9143a442d$var$classof$3 = $f76789f9143a442d$var$classof$5;
var $f76789f9143a442d$var$getMethod$2 = $f76789f9143a442d$var$getMethod$4;
var $f76789f9143a442d$var$Iterators$3 = $f76789f9143a442d$var$iterators;
var $f76789f9143a442d$var$wellKnownSymbol$8 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$ITERATOR$4 = $f76789f9143a442d$var$wellKnownSymbol$8("iterator");
var $f76789f9143a442d$var$getIteratorMethod$2 = function getIteratorMethod$2(it) {
    if (it != undefined) return $f76789f9143a442d$var$getMethod$2(it, $f76789f9143a442d$var$ITERATOR$4) || $f76789f9143a442d$var$getMethod$2(it, "@@iterator") || $f76789f9143a442d$var$Iterators$3[$f76789f9143a442d$var$classof$3(it)];
};
var $f76789f9143a442d$var$call$a = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$aCallable$3 = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$anObject$8 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$tryToString$1 = $f76789f9143a442d$var$tryToString$4;
var $f76789f9143a442d$var$getIteratorMethod$1 = $f76789f9143a442d$var$getIteratorMethod$2;
var $f76789f9143a442d$var$$TypeError$4 = TypeError;
var $f76789f9143a442d$var$getIterator$1 = function getIterator$1(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $f76789f9143a442d$var$getIteratorMethod$1(argument) : usingIterator;
    if ($f76789f9143a442d$var$aCallable$3(iteratorMethod)) return $f76789f9143a442d$var$anObject$8($f76789f9143a442d$var$call$a(iteratorMethod, argument));
    throw $f76789f9143a442d$var$$TypeError$4($f76789f9143a442d$var$tryToString$1(argument) + " is not iterable");
};
var $f76789f9143a442d$var$call$9 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$anObject$7 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$getMethod$1 = $f76789f9143a442d$var$getMethod$4;
var $f76789f9143a442d$var$iteratorClose$1 = function iteratorClose$1(iterator, kind, value) {
    var innerResult, innerError;
    $f76789f9143a442d$var$anObject$7(iterator);
    try {
        innerResult = $f76789f9143a442d$var$getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $f76789f9143a442d$var$call$9(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $f76789f9143a442d$var$anObject$7(innerResult);
    return value;
};
var $f76789f9143a442d$var$bind = $f76789f9143a442d$var$functionBindContext;
var $f76789f9143a442d$var$call$8 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$anObject$6 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$tryToString = $f76789f9143a442d$var$tryToString$4;
var $f76789f9143a442d$var$isArrayIteratorMethod = $f76789f9143a442d$var$isArrayIteratorMethod$1;
var $f76789f9143a442d$var$lengthOfArrayLike$2 = $f76789f9143a442d$var$lengthOfArrayLike$4;
var $f76789f9143a442d$var$isPrototypeOf = $f76789f9143a442d$var$objectIsPrototypeOf;
var $f76789f9143a442d$var$getIterator = $f76789f9143a442d$var$getIterator$1;
var $f76789f9143a442d$var$getIteratorMethod = $f76789f9143a442d$var$getIteratorMethod$2;
var $f76789f9143a442d$var$iteratorClose = $f76789f9143a442d$var$iteratorClose$1;
var $f76789f9143a442d$var$$TypeError$3 = TypeError;
var $f76789f9143a442d$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $f76789f9143a442d$var$ResultPrototype = $f76789f9143a442d$var$Result.prototype;
var $f76789f9143a442d$var$iterate$2 = function iterate$2(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $f76789f9143a442d$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $f76789f9143a442d$var$iteratorClose(iterator, "normal", condition);
        return new $f76789f9143a442d$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $f76789f9143a442d$var$anObject$6(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $f76789f9143a442d$var$getIteratorMethod(iterable);
        if (!iterFn) throw $f76789f9143a442d$var$$TypeError$3($f76789f9143a442d$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($f76789f9143a442d$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $f76789f9143a442d$var$lengthOfArrayLike$2(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $f76789f9143a442d$var$isPrototypeOf($f76789f9143a442d$var$ResultPrototype, result)) return result;
            }
            return new $f76789f9143a442d$var$Result(false);
        }
        iterator = $f76789f9143a442d$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $f76789f9143a442d$var$call$8(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $f76789f9143a442d$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $f76789f9143a442d$var$isPrototypeOf($f76789f9143a442d$var$ResultPrototype, result)) return result;
    }
    return new $f76789f9143a442d$var$Result(false);
};
var $f76789f9143a442d$var$wellKnownSymbol$7 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$ITERATOR$3 = $f76789f9143a442d$var$wellKnownSymbol$7("iterator");
var $f76789f9143a442d$var$SAFE_CLOSING = false;
try {
    var $f76789f9143a442d$var$called = 0;
    var $f76789f9143a442d$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$f76789f9143a442d$var$called++
            };
        },
        "return": function() {
            $f76789f9143a442d$var$SAFE_CLOSING = true;
        }
    };
    $f76789f9143a442d$var$iteratorWithReturn[$f76789f9143a442d$var$ITERATOR$3] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($f76789f9143a442d$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $f76789f9143a442d$var$checkCorrectnessOfIteration$1 = function checkCorrectnessOfIteration$1(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$f76789f9143a442d$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$f76789f9143a442d$var$ITERATOR$3] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $f76789f9143a442d$var$NativePromiseConstructor$1 = $f76789f9143a442d$var$promiseNativeConstructor;
var $f76789f9143a442d$var$checkCorrectnessOfIteration = $f76789f9143a442d$var$checkCorrectnessOfIteration$1;
var $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$3 = $f76789f9143a442d$var$promiseConstructorDetection.CONSTRUCTOR;
var $f76789f9143a442d$var$promiseStaticsIncorrectIteration = $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$f76789f9143a442d$var$checkCorrectnessOfIteration(function(iterable) {
    $f76789f9143a442d$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $f76789f9143a442d$var$$$a = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$call$7 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$aCallable$2 = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$newPromiseCapabilityModule$2 = $f76789f9143a442d$var$newPromiseCapability$2;
var $f76789f9143a442d$var$perform$1 = $f76789f9143a442d$var$perform$3;
var $f76789f9143a442d$var$iterate$1 = $f76789f9143a442d$var$iterate$2;
var $f76789f9143a442d$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $f76789f9143a442d$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$f76789f9143a442d$var$$$a({
    target: "Promise",
    stat: true,
    forced: $f76789f9143a442d$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $f76789f9143a442d$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $f76789f9143a442d$var$perform$1(function() {
            var $promiseResolve = $f76789f9143a442d$var$aCallable$2(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $f76789f9143a442d$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $f76789f9143a442d$var$call$7($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $f76789f9143a442d$var$$$9 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$2 = $f76789f9143a442d$var$promiseConstructorDetection.CONSTRUCTOR;
var $f76789f9143a442d$var$NativePromiseConstructor = $f76789f9143a442d$var$promiseNativeConstructor;
var $f76789f9143a442d$var$getBuiltIn$1 = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$isCallable$4 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$defineBuiltIn$3 = $f76789f9143a442d$var$defineBuiltIn$6;
var $f76789f9143a442d$var$NativePromisePrototype = $f76789f9143a442d$var$NativePromiseConstructor && $f76789f9143a442d$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$f76789f9143a442d$var$$$9({
    target: "Promise",
    proto: true,
    forced: $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($f76789f9143a442d$var$isCallable$4($f76789f9143a442d$var$NativePromiseConstructor)) {
    var $f76789f9143a442d$var$method = $f76789f9143a442d$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($f76789f9143a442d$var$NativePromisePrototype["catch"] !== $f76789f9143a442d$var$method) $f76789f9143a442d$var$defineBuiltIn$3($f76789f9143a442d$var$NativePromisePrototype, "catch", $f76789f9143a442d$var$method, {
        unsafe: true
    });
}
var $f76789f9143a442d$var$$$8 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$call$6 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$aCallable$1 = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$newPromiseCapabilityModule$1 = $f76789f9143a442d$var$newPromiseCapability$2;
var $f76789f9143a442d$var$perform = $f76789f9143a442d$var$perform$3;
var $f76789f9143a442d$var$iterate = $f76789f9143a442d$var$iterate$2;
var $f76789f9143a442d$var$PROMISE_STATICS_INCORRECT_ITERATION = $f76789f9143a442d$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$f76789f9143a442d$var$$$8({
    target: "Promise",
    stat: true,
    forced: $f76789f9143a442d$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $f76789f9143a442d$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $f76789f9143a442d$var$perform(function() {
            var $promiseResolve = $f76789f9143a442d$var$aCallable$1(C.resolve);
            $f76789f9143a442d$var$iterate(iterable, function(promise) {
                $f76789f9143a442d$var$call$6($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $f76789f9143a442d$var$$$7 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$call$5 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$newPromiseCapabilityModule = $f76789f9143a442d$var$newPromiseCapability$2;
var $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$1 = $f76789f9143a442d$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$f76789f9143a442d$var$$$7({
    target: "Promise",
    stat: true,
    forced: $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $f76789f9143a442d$var$newPromiseCapabilityModule.f(this);
        $f76789f9143a442d$var$call$5(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $f76789f9143a442d$var$anObject$5 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$isObject$1 = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$newPromiseCapability = $f76789f9143a442d$var$newPromiseCapability$2;
var $f76789f9143a442d$var$promiseResolve$1 = function promiseResolve$1(C, x) {
    $f76789f9143a442d$var$anObject$5(C);
    if ($f76789f9143a442d$var$isObject$1(x) && x.constructor === C) return x;
    var promiseCapability = $f76789f9143a442d$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $f76789f9143a442d$var$$$6 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$getBuiltIn = $f76789f9143a442d$var$getBuiltIn$8;
var $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR = $f76789f9143a442d$var$promiseConstructorDetection.CONSTRUCTOR;
var $f76789f9143a442d$var$promiseResolve = $f76789f9143a442d$var$promiseResolve$1;
$f76789f9143a442d$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$f76789f9143a442d$var$$$6({
    target: "Promise",
    stat: true,
    forced: $f76789f9143a442d$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $f76789f9143a442d$var$promiseResolve(this, x);
    }
});
var $f76789f9143a442d$var$WebStorageService = /*#__PURE__*/ function() {
    "use strict";
    function WebStorageService() {
        (0, $978gY._)(this, WebStorageService);
    }
    (0, $kry2a._)(WebStorageService, [
        {
            key: "getItem",
            value: function getItem(key) {
                return new Promise(function(resolve) {
                    var value = localStorage.getItem(key);
                    resolve(value);
                });
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                return new Promise(function(resolve) {
                    localStorage.setItem(key, value);
                    resolve();
                });
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                return new Promise(function(resolve) {
                    localStorage.removeItem(key);
                    resolve();
                });
            }
        }
    ]);
    return WebStorageService;
}();
var $f76789f9143a442d$var$objectDefineProperties = {};
var $f76789f9143a442d$var$internalObjectKeys = $f76789f9143a442d$var$objectKeysInternal;
var $f76789f9143a442d$var$enumBugKeys$1 = $f76789f9143a442d$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $f76789f9143a442d$var$objectKeys$2 = Object.keys || function keys(O) {
    return $f76789f9143a442d$var$internalObjectKeys(O, $f76789f9143a442d$var$enumBugKeys$1);
};
var $f76789f9143a442d$var$DESCRIPTORS$2 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$V8_PROTOTYPE_DEFINE_BUG = $f76789f9143a442d$var$v8PrototypeDefineBug;
var $f76789f9143a442d$var$definePropertyModule$1 = $f76789f9143a442d$var$objectDefineProperty;
var $f76789f9143a442d$var$anObject$4 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$toIndexedObject$1 = $f76789f9143a442d$var$toIndexedObject$5;
var $f76789f9143a442d$var$objectKeys$1 = $f76789f9143a442d$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$f76789f9143a442d$var$objectDefineProperties.f = $f76789f9143a442d$var$DESCRIPTORS$2 && !$f76789f9143a442d$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $f76789f9143a442d$var$anObject$4(O);
    var props = $f76789f9143a442d$var$toIndexedObject$1(Properties);
    var keys = $f76789f9143a442d$var$objectKeys$1(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$f76789f9143a442d$var$definePropertyModule$1.f(O, key = keys[index++], props[key]);
    return O;
};
/* global ActiveXObject -- old IE, WSH */ var $f76789f9143a442d$var$anObject$3 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$definePropertiesModule = $f76789f9143a442d$var$objectDefineProperties;
var $f76789f9143a442d$var$enumBugKeys = $f76789f9143a442d$var$enumBugKeys$3;
var $f76789f9143a442d$var$hiddenKeys = $f76789f9143a442d$var$hiddenKeys$4;
var $f76789f9143a442d$var$html = $f76789f9143a442d$var$html$2;
var $f76789f9143a442d$var$documentCreateElement$1 = $f76789f9143a442d$var$documentCreateElement$2;
var $f76789f9143a442d$var$sharedKey$1 = $f76789f9143a442d$var$sharedKey$3;
var $f76789f9143a442d$var$GT = ">";
var $f76789f9143a442d$var$LT = "<";
var $f76789f9143a442d$var$PROTOTYPE = "prototype";
var $f76789f9143a442d$var$SCRIPT = "script";
var $f76789f9143a442d$var$IE_PROTO$1 = $f76789f9143a442d$var$sharedKey$1("IE_PROTO");
var $f76789f9143a442d$var$EmptyConstructor = function EmptyConstructor() {};
var $f76789f9143a442d$var$scriptTag = function scriptTag(content) {
    return $f76789f9143a442d$var$LT + $f76789f9143a442d$var$SCRIPT + $f76789f9143a442d$var$GT + content + $f76789f9143a442d$var$LT + "/" + $f76789f9143a442d$var$SCRIPT + $f76789f9143a442d$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $f76789f9143a442d$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($f76789f9143a442d$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f76789f9143a442d$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $f76789f9143a442d$var$documentCreateElement$1("iframe");
    var JS = "java" + $f76789f9143a442d$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $f76789f9143a442d$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($f76789f9143a442d$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $f76789f9143a442d$var$activeXDocument;
var $f76789f9143a442d$var$NullProtoObject = function NullProtoObject1() {
    try {
        $f76789f9143a442d$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $f76789f9143a442d$var$NullProtoObject = typeof document != "undefined" ? document.domain && $f76789f9143a442d$var$activeXDocument ? $f76789f9143a442d$var$NullProtoObjectViaActiveX($f76789f9143a442d$var$activeXDocument) // old IE
     : $f76789f9143a442d$var$NullProtoObjectViaIFrame() : $f76789f9143a442d$var$NullProtoObjectViaActiveX($f76789f9143a442d$var$activeXDocument); // WSH
    var length = $f76789f9143a442d$var$enumBugKeys.length;
    while(length--)delete $f76789f9143a442d$var$NullProtoObject[$f76789f9143a442d$var$PROTOTYPE][$f76789f9143a442d$var$enumBugKeys[length]];
    return $f76789f9143a442d$var$NullProtoObject();
};
$f76789f9143a442d$var$hiddenKeys[$f76789f9143a442d$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $f76789f9143a442d$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f76789f9143a442d$var$EmptyConstructor[$f76789f9143a442d$var$PROTOTYPE] = $f76789f9143a442d$var$anObject$3(O);
        result = new $f76789f9143a442d$var$EmptyConstructor();
        $f76789f9143a442d$var$EmptyConstructor[$f76789f9143a442d$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f76789f9143a442d$var$IE_PROTO$1] = O;
    } else result = $f76789f9143a442d$var$NullProtoObject();
    return Properties === undefined ? result : $f76789f9143a442d$var$definePropertiesModule.f(result, Properties);
};
var $f76789f9143a442d$var$wellKnownSymbol$6 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$create$2 = $f76789f9143a442d$var$objectCreate;
var $f76789f9143a442d$var$defineProperty$2 = $f76789f9143a442d$var$objectDefineProperty.f;
var $f76789f9143a442d$var$UNSCOPABLES = $f76789f9143a442d$var$wellKnownSymbol$6("unscopables");
var $f76789f9143a442d$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($f76789f9143a442d$var$ArrayPrototype[$f76789f9143a442d$var$UNSCOPABLES] == undefined) $f76789f9143a442d$var$defineProperty$2($f76789f9143a442d$var$ArrayPrototype, $f76789f9143a442d$var$UNSCOPABLES, {
    configurable: true,
    value: $f76789f9143a442d$var$create$2(null)
});
// add a key to Array.prototype[@@unscopables]
var $f76789f9143a442d$var$addToUnscopables$2 = function addToUnscopables$2(key) {
    $f76789f9143a442d$var$ArrayPrototype[$f76789f9143a442d$var$UNSCOPABLES][key] = true;
};
var $f76789f9143a442d$var$fails$9 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$correctPrototypeGetter = !$f76789f9143a442d$var$fails$9(function() {
    var F = function F() {};
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $f76789f9143a442d$var$hasOwn = $f76789f9143a442d$var$hasOwnProperty_1;
var $f76789f9143a442d$var$isCallable$3 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$toObject$2 = $f76789f9143a442d$var$toObject$4;
var $f76789f9143a442d$var$sharedKey = $f76789f9143a442d$var$sharedKey$3;
var $f76789f9143a442d$var$CORRECT_PROTOTYPE_GETTER = $f76789f9143a442d$var$correctPrototypeGetter;
var $f76789f9143a442d$var$IE_PROTO = $f76789f9143a442d$var$sharedKey("IE_PROTO");
var $f76789f9143a442d$var$$Object = Object;
var $f76789f9143a442d$var$ObjectPrototype = $f76789f9143a442d$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $f76789f9143a442d$var$objectGetPrototypeOf = $f76789f9143a442d$var$CORRECT_PROTOTYPE_GETTER ? $f76789f9143a442d$var$$Object.getPrototypeOf : function objectGetPrototypeOf(O) {
    var object = $f76789f9143a442d$var$toObject$2(O);
    if ($f76789f9143a442d$var$hasOwn(object, $f76789f9143a442d$var$IE_PROTO)) return object[$f76789f9143a442d$var$IE_PROTO];
    var constructor = object.constructor;
    if ($f76789f9143a442d$var$isCallable$3(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $f76789f9143a442d$var$$Object ? $f76789f9143a442d$var$ObjectPrototype : null;
};
var $f76789f9143a442d$var$fails$8 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$isCallable$2 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$getPrototypeOf$1 = $f76789f9143a442d$var$objectGetPrototypeOf;
var $f76789f9143a442d$var$defineBuiltIn$2 = $f76789f9143a442d$var$defineBuiltIn$6;
var $f76789f9143a442d$var$wellKnownSymbol$5 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$ITERATOR$2 = $f76789f9143a442d$var$wellKnownSymbol$5("iterator");
var $f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $f76789f9143a442d$var$IteratorPrototype$2, $f76789f9143a442d$var$PrototypeOfArrayIteratorPrototype, $f76789f9143a442d$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $f76789f9143a442d$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $f76789f9143a442d$var$arrayIterator)) $f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $f76789f9143a442d$var$PrototypeOfArrayIteratorPrototype = $f76789f9143a442d$var$getPrototypeOf$1($f76789f9143a442d$var$getPrototypeOf$1($f76789f9143a442d$var$arrayIterator));
        if ($f76789f9143a442d$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $f76789f9143a442d$var$IteratorPrototype$2 = $f76789f9143a442d$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $f76789f9143a442d$var$NEW_ITERATOR_PROTOTYPE = $f76789f9143a442d$var$IteratorPrototype$2 == undefined || $f76789f9143a442d$var$fails$8(function() {
    var test = {};
    // FF44- legacy iterators case
    return $f76789f9143a442d$var$IteratorPrototype$2[$f76789f9143a442d$var$ITERATOR$2].call(test) !== test;
});
if ($f76789f9143a442d$var$NEW_ITERATOR_PROTOTYPE) $f76789f9143a442d$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$f76789f9143a442d$var$isCallable$2($f76789f9143a442d$var$IteratorPrototype$2[$f76789f9143a442d$var$ITERATOR$2])) $f76789f9143a442d$var$defineBuiltIn$2($f76789f9143a442d$var$IteratorPrototype$2, $f76789f9143a442d$var$ITERATOR$2, function() {
    return this;
});
var $f76789f9143a442d$var$iteratorsCore = {
    IteratorPrototype: $f76789f9143a442d$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS$1
};
var $f76789f9143a442d$var$IteratorPrototype$1 = $f76789f9143a442d$var$iteratorsCore.IteratorPrototype;
var $f76789f9143a442d$var$create$1 = $f76789f9143a442d$var$objectCreate;
var $f76789f9143a442d$var$createPropertyDescriptor$1 = $f76789f9143a442d$var$createPropertyDescriptor$4;
var $f76789f9143a442d$var$setToStringTag$1 = $f76789f9143a442d$var$setToStringTag$3;
var $f76789f9143a442d$var$Iterators$2 = $f76789f9143a442d$var$iterators;
var $f76789f9143a442d$var$returnThis$1 = function returnThis$1() {
    return this;
};
var $f76789f9143a442d$var$createIteratorConstructor$1 = function createIteratorConstructor$1(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $f76789f9143a442d$var$create$1($f76789f9143a442d$var$IteratorPrototype$1, {
        next: $f76789f9143a442d$var$createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
    });
    $f76789f9143a442d$var$setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
    $f76789f9143a442d$var$Iterators$2[TO_STRING_TAG] = $f76789f9143a442d$var$returnThis$1;
    return IteratorConstructor;
};
var $f76789f9143a442d$var$$$5 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$call$4 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$FunctionName = $f76789f9143a442d$var$functionName;
var $f76789f9143a442d$var$isCallable$1 = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$createIteratorConstructor = $f76789f9143a442d$var$createIteratorConstructor$1;
var $f76789f9143a442d$var$getPrototypeOf = $f76789f9143a442d$var$objectGetPrototypeOf;
var $f76789f9143a442d$var$setPrototypeOf = $f76789f9143a442d$var$objectSetPrototypeOf;
var $f76789f9143a442d$var$setToStringTag = $f76789f9143a442d$var$setToStringTag$3;
var $f76789f9143a442d$var$createNonEnumerableProperty$2 = $f76789f9143a442d$var$createNonEnumerableProperty$5;
var $f76789f9143a442d$var$defineBuiltIn$1 = $f76789f9143a442d$var$defineBuiltIn$6;
var $f76789f9143a442d$var$wellKnownSymbol$4 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$Iterators$1 = $f76789f9143a442d$var$iterators;
var $f76789f9143a442d$var$IteratorsCore = $f76789f9143a442d$var$iteratorsCore;
var $f76789f9143a442d$var$PROPER_FUNCTION_NAME = $f76789f9143a442d$var$FunctionName.PROPER;
var $f76789f9143a442d$var$CONFIGURABLE_FUNCTION_NAME = $f76789f9143a442d$var$FunctionName.CONFIGURABLE;
var $f76789f9143a442d$var$IteratorPrototype = $f76789f9143a442d$var$IteratorsCore.IteratorPrototype;
var $f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS = $f76789f9143a442d$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $f76789f9143a442d$var$ITERATOR$1 = $f76789f9143a442d$var$wellKnownSymbol$4("iterator");
var $f76789f9143a442d$var$KEYS = "keys";
var $f76789f9143a442d$var$VALUES = "values";
var $f76789f9143a442d$var$ENTRIES = "entries";
var $f76789f9143a442d$var$returnThis = function returnThis() {
    return this;
};
var $f76789f9143a442d$var$defineIterator$1 = function defineIterator$1(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $f76789f9143a442d$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $f76789f9143a442d$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f76789f9143a442d$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f76789f9143a442d$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$f76789f9143a442d$var$ITERATOR$1] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $f76789f9143a442d$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($f76789f9143a442d$var$getPrototypeOf(CurrentIteratorPrototype) !== $f76789f9143a442d$var$IteratorPrototype) {
                if ($f76789f9143a442d$var$setPrototypeOf) $f76789f9143a442d$var$setPrototypeOf(CurrentIteratorPrototype, $f76789f9143a442d$var$IteratorPrototype);
                else if (!$f76789f9143a442d$var$isCallable$1(CurrentIteratorPrototype[$f76789f9143a442d$var$ITERATOR$1])) $f76789f9143a442d$var$defineBuiltIn$1(CurrentIteratorPrototype, $f76789f9143a442d$var$ITERATOR$1, $f76789f9143a442d$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $f76789f9143a442d$var$setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($f76789f9143a442d$var$PROPER_FUNCTION_NAME && DEFAULT == $f76789f9143a442d$var$VALUES && nativeIterator && nativeIterator.name !== $f76789f9143a442d$var$VALUES) {
        if ($f76789f9143a442d$var$CONFIGURABLE_FUNCTION_NAME) $f76789f9143a442d$var$createNonEnumerableProperty$2(IterablePrototype, "name", $f76789f9143a442d$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $f76789f9143a442d$var$call$4(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($f76789f9143a442d$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($f76789f9143a442d$var$KEYS),
            entries: getIterationMethod($f76789f9143a442d$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $f76789f9143a442d$var$defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
        } else $f76789f9143a442d$var$$$5({
            target: NAME,
            proto: true,
            forced: $f76789f9143a442d$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$f76789f9143a442d$var$ITERATOR$1] !== defaultIterator) $f76789f9143a442d$var$defineBuiltIn$1(IterablePrototype, $f76789f9143a442d$var$ITERATOR$1, defaultIterator, {
        name: DEFAULT
    });
    $f76789f9143a442d$var$Iterators$1[NAME] = defaultIterator;
    return methods;
};
var $f76789f9143a442d$var$toIndexedObject = $f76789f9143a442d$var$toIndexedObject$5;
var $f76789f9143a442d$var$addToUnscopables$1 = $f76789f9143a442d$var$addToUnscopables$2;
var $f76789f9143a442d$var$Iterators = $f76789f9143a442d$var$iterators;
var $f76789f9143a442d$var$InternalStateModule = $f76789f9143a442d$var$internalState;
var $f76789f9143a442d$var$defineProperty$1 = $f76789f9143a442d$var$objectDefineProperty.f;
var $f76789f9143a442d$var$defineIterator = $f76789f9143a442d$var$defineIterator$1;
var $f76789f9143a442d$var$DESCRIPTORS$1 = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$ARRAY_ITERATOR = "Array Iterator";
var $f76789f9143a442d$var$setInternalState = $f76789f9143a442d$var$InternalStateModule.set;
var $f76789f9143a442d$var$getInternalState$1 = $f76789f9143a442d$var$InternalStateModule.getterFor($f76789f9143a442d$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $f76789f9143a442d$var$es_array_iterator = $f76789f9143a442d$var$defineIterator(Array, "Array", function(iterated, kind) {
    $f76789f9143a442d$var$setInternalState(this, {
        type: $f76789f9143a442d$var$ARRAY_ITERATOR,
        target: $f76789f9143a442d$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $f76789f9143a442d$var$getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $f76789f9143a442d$var$values = $f76789f9143a442d$var$Iterators.Arguments = $f76789f9143a442d$var$Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$f76789f9143a442d$var$addToUnscopables$1("keys");
$f76789f9143a442d$var$addToUnscopables$1("values");
$f76789f9143a442d$var$addToUnscopables$1("entries");
// V8 ~ Chrome 45- bug
if ($f76789f9143a442d$var$DESCRIPTORS$1 && $f76789f9143a442d$var$values.name !== "values") try {
    $f76789f9143a442d$var$defineProperty$1($f76789f9143a442d$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $f76789f9143a442d$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $f76789f9143a442d$var$documentCreateElement = $f76789f9143a442d$var$documentCreateElement$2;
var $f76789f9143a442d$var$classList = $f76789f9143a442d$var$documentCreateElement("span").classList;
var $f76789f9143a442d$var$DOMTokenListPrototype$1 = $f76789f9143a442d$var$classList && $f76789f9143a442d$var$classList.constructor && $f76789f9143a442d$var$classList.constructor.prototype;
var $f76789f9143a442d$var$domTokenListPrototype = $f76789f9143a442d$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $f76789f9143a442d$var$DOMTokenListPrototype$1;
var $f76789f9143a442d$var$global$4 = $f76789f9143a442d$var$global$m;
var $f76789f9143a442d$var$DOMIterables = $f76789f9143a442d$var$domIterables;
var $f76789f9143a442d$var$DOMTokenListPrototype = $f76789f9143a442d$var$domTokenListPrototype;
var $f76789f9143a442d$var$ArrayIteratorMethods = $f76789f9143a442d$var$es_array_iterator;
var $f76789f9143a442d$var$createNonEnumerableProperty$1 = $f76789f9143a442d$var$createNonEnumerableProperty$5;
var $f76789f9143a442d$var$wellKnownSymbol$3 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$ITERATOR = $f76789f9143a442d$var$wellKnownSymbol$3("iterator");
var $f76789f9143a442d$var$TO_STRING_TAG = $f76789f9143a442d$var$wellKnownSymbol$3("toStringTag");
var $f76789f9143a442d$var$ArrayValues = $f76789f9143a442d$var$ArrayIteratorMethods.values;
var $f76789f9143a442d$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$f76789f9143a442d$var$ITERATOR] !== $f76789f9143a442d$var$ArrayValues) try {
            $f76789f9143a442d$var$createNonEnumerableProperty$1(CollectionPrototype, $f76789f9143a442d$var$ITERATOR, $f76789f9143a442d$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$f76789f9143a442d$var$ITERATOR] = $f76789f9143a442d$var$ArrayValues;
        }
        if (!CollectionPrototype[$f76789f9143a442d$var$TO_STRING_TAG]) $f76789f9143a442d$var$createNonEnumerableProperty$1(CollectionPrototype, $f76789f9143a442d$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($f76789f9143a442d$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $f76789f9143a442d$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $f76789f9143a442d$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $f76789f9143a442d$var$createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, $f76789f9143a442d$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $f76789f9143a442d$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $f76789f9143a442d$var$COLLECTION_NAME in $f76789f9143a442d$var$DOMIterables)$f76789f9143a442d$var$handlePrototype($f76789f9143a442d$var$global$4[$f76789f9143a442d$var$COLLECTION_NAME] && $f76789f9143a442d$var$global$4[$f76789f9143a442d$var$COLLECTION_NAME].prototype, $f76789f9143a442d$var$COLLECTION_NAME);
$f76789f9143a442d$var$handlePrototype($f76789f9143a442d$var$DOMTokenListPrototype, "DOMTokenList");
var $f76789f9143a442d$var$Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger(namespace) {
        (0, $978gY._)(this, Logger);
        this.namespace = namespace;
    }
    (0, $kry2a._)(Logger, [
        {
            key: "emit",
            value: function emit(method) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    params[_key - 1] = arguments[_key];
                }
                var _console;
                if (!Logger.debug) return;
                if (this.namespace && method !== "error") {
                    var // eslint-disable-next-line no-console
                    _console1;
                    (_console1 = console)[method].apply(_console1, [
                        this.namespace
                    ].concat((0, $fLnyw._)(params)));
                    return;
                } // eslint-disable-next-line no-console
                (_console = console)[method].apply(_console, (0, $fLnyw._)(params));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                this.emit.apply(this, [
                    "log"
                ].concat((0, $fLnyw._)(params)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                this.emit.apply(this, [
                    "info"
                ].concat((0, $fLnyw._)(params)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                this.emit.apply(this, [
                    "warn"
                ].concat((0, $fLnyw._)(params)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                this.emit.apply(this, [
                    "error"
                ].concat((0, $fLnyw._)(params)));
            }
        }
    ]);
    return Logger;
}();
$f76789f9143a442d$var$Logger.debug = false;
var $f76789f9143a442d$var$logger = new $f76789f9143a442d$var$Logger();
var $f76789f9143a442d$var$$$4 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$$includes = $f76789f9143a442d$var$arrayIncludes.includes;
var $f76789f9143a442d$var$fails$7 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$addToUnscopables = $f76789f9143a442d$var$addToUnscopables$2;
// FF99+ bug
var $f76789f9143a442d$var$BROKEN_ON_SPARSE = $f76789f9143a442d$var$fails$7(function() {
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$f76789f9143a442d$var$$$4({
    target: "Array",
    proto: true,
    forced: $f76789f9143a442d$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $f76789f9143a442d$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$f76789f9143a442d$var$addToUnscopables("includes");
var $f76789f9143a442d$var$isObject = $f76789f9143a442d$var$isObject$8;
var $f76789f9143a442d$var$classof$2 = $f76789f9143a442d$var$classofRaw$1;
var $f76789f9143a442d$var$wellKnownSymbol$2 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$MATCH$1 = $f76789f9143a442d$var$wellKnownSymbol$2("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $f76789f9143a442d$var$isRegexp = function isRegexp(it) {
    var isRegExp;
    return $f76789f9143a442d$var$isObject(it) && ((isRegExp = it[$f76789f9143a442d$var$MATCH$1]) !== undefined ? !!isRegExp : $f76789f9143a442d$var$classof$2(it) == "RegExp");
};
var $f76789f9143a442d$var$isRegExp$1 = $f76789f9143a442d$var$isRegexp;
var $f76789f9143a442d$var$$TypeError$2 = TypeError;
var $f76789f9143a442d$var$notARegexp = function notARegexp(it) {
    if ($f76789f9143a442d$var$isRegExp$1(it)) throw $f76789f9143a442d$var$$TypeError$2("The method doesn't accept regular expressions");
    return it;
};
var $f76789f9143a442d$var$classof$1 = $f76789f9143a442d$var$classof$5;
var $f76789f9143a442d$var$$String = String;
var $f76789f9143a442d$var$toString$4 = function toString$4(argument) {
    if ($f76789f9143a442d$var$classof$1(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $f76789f9143a442d$var$$String(argument);
};
var $f76789f9143a442d$var$wellKnownSymbol$1 = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$MATCH = $f76789f9143a442d$var$wellKnownSymbol$1("match");
var $f76789f9143a442d$var$correctIsRegexpLogic = function correctIsRegexpLogic(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$f76789f9143a442d$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $f76789f9143a442d$var$$$3 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$uncurryThis$5 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$notARegExp = $f76789f9143a442d$var$notARegexp;
var $f76789f9143a442d$var$requireObjectCoercible$2 = $f76789f9143a442d$var$requireObjectCoercible$5;
var $f76789f9143a442d$var$toString$3 = $f76789f9143a442d$var$toString$4;
var $f76789f9143a442d$var$correctIsRegExpLogic = $f76789f9143a442d$var$correctIsRegexpLogic;
var $f76789f9143a442d$var$stringIndexOf = $f76789f9143a442d$var$uncurryThis$5("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$f76789f9143a442d$var$$$3({
    target: "String",
    proto: true,
    forced: !$f76789f9143a442d$var$correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$f76789f9143a442d$var$stringIndexOf($f76789f9143a442d$var$toString$3($f76789f9143a442d$var$requireObjectCoercible$2(this)), $f76789f9143a442d$var$toString$3($f76789f9143a442d$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $f76789f9143a442d$var$DESCRIPTORS = $f76789f9143a442d$var$descriptors;
var $f76789f9143a442d$var$uncurryThis$4 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$call$3 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$fails$6 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$objectKeys = $f76789f9143a442d$var$objectKeys$2;
var $f76789f9143a442d$var$getOwnPropertySymbolsModule = $f76789f9143a442d$var$objectGetOwnPropertySymbols;
var $f76789f9143a442d$var$propertyIsEnumerableModule = $f76789f9143a442d$var$objectPropertyIsEnumerable;
var $f76789f9143a442d$var$toObject$1 = $f76789f9143a442d$var$toObject$4;
var $f76789f9143a442d$var$IndexedObject$1 = $f76789f9143a442d$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $f76789f9143a442d$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $f76789f9143a442d$var$defineProperty = Object.defineProperty;
var $f76789f9143a442d$var$concat = $f76789f9143a442d$var$uncurryThis$4([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $f76789f9143a442d$var$objectAssign = !$f76789f9143a442d$var$$assign || $f76789f9143a442d$var$fails$6(function() {
    // should have correct order of operations (Edge bug)
    if ($f76789f9143a442d$var$DESCRIPTORS && $f76789f9143a442d$var$$assign({
        b: 1
    }, $f76789f9143a442d$var$$assign($f76789f9143a442d$var$defineProperty({}, "a", {
        enumerable: true,
        get: function get() {
            $f76789f9143a442d$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $f76789f9143a442d$var$$assign({}, A)[symbol] != 7 || $f76789f9143a442d$var$objectKeys($f76789f9143a442d$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $f76789f9143a442d$var$toObject$1(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $f76789f9143a442d$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $f76789f9143a442d$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $f76789f9143a442d$var$IndexedObject$1(arguments[index++]);
        var keys = getOwnPropertySymbols ? $f76789f9143a442d$var$concat($f76789f9143a442d$var$objectKeys(S), getOwnPropertySymbols(S)) : $f76789f9143a442d$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$f76789f9143a442d$var$DESCRIPTORS || $f76789f9143a442d$var$call$3(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $f76789f9143a442d$var$$assign;
var $f76789f9143a442d$var$$$2 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$assign = $f76789f9143a442d$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$f76789f9143a442d$var$$$2({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $f76789f9143a442d$var$assign
}, {
    assign: $f76789f9143a442d$var$assign
});
var $f76789f9143a442d$var$events = {
    exports: {}
};
var $f76789f9143a442d$var$R = typeof Reflect === "object" ? Reflect : null;
var $f76789f9143a442d$var$ReflectApply = $f76789f9143a442d$var$R && typeof $f76789f9143a442d$var$R.apply === "function" ? $f76789f9143a442d$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $f76789f9143a442d$var$ReflectOwnKeys;
if ($f76789f9143a442d$var$R && typeof $f76789f9143a442d$var$R.ownKeys === "function") $f76789f9143a442d$var$ReflectOwnKeys = $f76789f9143a442d$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $f76789f9143a442d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $f76789f9143a442d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $f76789f9143a442d$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $f76789f9143a442d$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $f76789f9143a442d$var$EventEmitter$1() {
    $f76789f9143a442d$var$EventEmitter$1.init.call(this);
}
$f76789f9143a442d$var$events.exports = $f76789f9143a442d$var$EventEmitter$1;
$f76789f9143a442d$var$events.exports.once = $f76789f9143a442d$var$once;
// Backwards-compat with node 0.10.x
$f76789f9143a442d$var$EventEmitter$1.EventEmitter = $f76789f9143a442d$var$EventEmitter$1;
$f76789f9143a442d$var$EventEmitter$1.prototype._events = undefined;
$f76789f9143a442d$var$EventEmitter$1.prototype._eventsCount = 0;
$f76789f9143a442d$var$EventEmitter$1.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $f76789f9143a442d$var$defaultMaxListeners = 10;
function $f76789f9143a442d$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $1ObTH._)(listener)));
}
Object.defineProperty($f76789f9143a442d$var$EventEmitter$1, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return $f76789f9143a442d$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || $f76789f9143a442d$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $f76789f9143a442d$var$defaultMaxListeners = arg;
    }
});
$f76789f9143a442d$var$EventEmitter$1.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$f76789f9143a442d$var$EventEmitter$1.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $f76789f9143a442d$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $f76789f9143a442d$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $f76789f9143a442d$var$EventEmitter$1.defaultMaxListeners;
    return that._maxListeners;
}
$f76789f9143a442d$var$EventEmitter$1.prototype.getMaxListeners = function getMaxListeners() {
    return $f76789f9143a442d$var$_getMaxListeners(this);
};
$f76789f9143a442d$var$EventEmitter$1.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $f76789f9143a442d$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $f76789f9143a442d$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$f76789f9143a442d$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $f76789f9143a442d$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $f76789f9143a442d$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $f76789f9143a442d$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $f76789f9143a442d$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$f76789f9143a442d$var$EventEmitter$1.prototype.addListener = function addListener(type, listener) {
    return $f76789f9143a442d$var$_addListener(this, type, listener, false);
};
$f76789f9143a442d$var$EventEmitter$1.prototype.on = $f76789f9143a442d$var$EventEmitter$1.prototype.addListener;
$f76789f9143a442d$var$EventEmitter$1.prototype.prependListener = function prependListener(type, listener) {
    return $f76789f9143a442d$var$_addListener(this, type, listener, true);
};
function $f76789f9143a442d$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $f76789f9143a442d$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $f76789f9143a442d$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$f76789f9143a442d$var$EventEmitter$1.prototype.once = function once(type, listener) {
    $f76789f9143a442d$var$checkListener(listener);
    this.on(type, $f76789f9143a442d$var$_onceWrap(this, type, listener));
    return this;
};
$f76789f9143a442d$var$EventEmitter$1.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $f76789f9143a442d$var$checkListener(listener);
    this.prependListener(type, $f76789f9143a442d$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$f76789f9143a442d$var$EventEmitter$1.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $f76789f9143a442d$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $f76789f9143a442d$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$f76789f9143a442d$var$EventEmitter$1.prototype.off = $f76789f9143a442d$var$EventEmitter$1.prototype.removeListener;
$f76789f9143a442d$var$EventEmitter$1.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $f76789f9143a442d$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $f76789f9143a442d$var$unwrapListeners(evlistener) : $f76789f9143a442d$var$arrayClone(evlistener, evlistener.length);
}
$f76789f9143a442d$var$EventEmitter$1.prototype.listeners = function listeners(type) {
    return $f76789f9143a442d$var$_listeners(this, type, true);
};
$f76789f9143a442d$var$EventEmitter$1.prototype.rawListeners = function rawListeners(type) {
    return $f76789f9143a442d$var$_listeners(this, type, false);
};
$f76789f9143a442d$var$EventEmitter$1.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $f76789f9143a442d$var$listenerCount.call(emitter, type);
};
$f76789f9143a442d$var$EventEmitter$1.prototype.listenerCount = $f76789f9143a442d$var$listenerCount;
function $f76789f9143a442d$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$f76789f9143a442d$var$EventEmitter$1.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $f76789f9143a442d$var$ReflectOwnKeys(this._events) : [];
};
function $f76789f9143a442d$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $f76789f9143a442d$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $f76789f9143a442d$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $f76789f9143a442d$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        var errorListener = function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        };
        var resolver = function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        };
        $f76789f9143a442d$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $f76789f9143a442d$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $f76789f9143a442d$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $f76789f9143a442d$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $f76789f9143a442d$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $1ObTH._)(emitter)));
}
var $f76789f9143a442d$export$4fae95256245c8c0 = /*#__PURE__*/ function() {
    "use strict";
    function EventEmitter() {
        (0, $978gY._)(this, EventEmitter);
        this.emitter = new $f76789f9143a442d$var$events.exports.EventEmitter();
    }
    (0, $kry2a._)(EventEmitter, [
        {
            key: "on",
            value: function on(eventName, callback) {
                var _this = this;
                this.emitter.on(eventName, callback);
                return {
                    remove: function() {
                        return _this.emitter.off(eventName, callback);
                    }
                };
            }
        },
        {
            key: "off",
            value: function off(eventName, callback) {
                this.emitter.off(eventName, callback);
            }
        },
        {
            key: "emit",
            value: function emit(eventName, event) {
                this.emitter.emit(eventName, event);
            }
        }
    ]);
    return EventEmitter;
}();
var $f76789f9143a442d$var$PACKAGE_NAME = "near-wallet-selector";
var $f76789f9143a442d$var$RECENTLY_SIGNED_IN_WALLETS = "recentlySignedInWallets";
var $f76789f9143a442d$var$CONTRACT = "contract";
var $f76789f9143a442d$var$PENDING_CONTRACT = "contract:pending";
var $f76789f9143a442d$var$SELECTED_WALLET_ID = "selectedWalletId";
var $f76789f9143a442d$var$PENDING_SELECTED_WALLET_ID = "selectedWalletId:pending";
var $f76789f9143a442d$var$WalletModules = /*#__PURE__*/ function() {
    "use strict";
    function WalletModules(param) {
        var factories = param.factories, storage = param.storage, options = param.options, store = param.store, emitter = param.emitter, provider = param.provider;
        (0, $978gY._)(this, WalletModules);
        this.factories = factories;
        this.storage = storage;
        this.options = options;
        this.store = store;
        this.emitter = emitter;
        this.provider = provider;
        this.modules = [];
        this.instances = {};
    }
    (0, $kry2a._)(WalletModules, [
        {
            key: "validateWallet",
            value: function validateWallet(id) {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var accounts, wallet;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accounts = [];
                                return [
                                    4,
                                    this.getWallet(id)
                                ];
                            case 1:
                                wallet = _state.sent();
                                if (!wallet) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    wallet.getAccounts().catch(function(err) {
                                        $f76789f9143a442d$var$logger.log("Failed to validate ".concat(wallet.id, " during setup"));
                                        $f76789f9143a442d$var$logger.error(err);
                                        return [];
                                    })
                                ];
                            case 2:
                                // Ensure our persistent state aligns with the selected wallet.
                                // For example a wallet is selected, but it returns no accounts (not signed in).
                                accounts = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    accounts
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveStorageState",
            value: function resolveStorageState() {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var jsonStorage, pendingSelectedWalletId, pendingContract, _accounts, _this_store_getState, _selectedWalletId, selectedWallet, recentlySignedInWalletsFromPending, _this_store_getState1, contract, selectedWalletId, accounts, recentlySignedInWallets;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jsonStorage = new $f76789f9143a442d$var$JsonStorage(this.storage, $f76789f9143a442d$var$PACKAGE_NAME);
                                return [
                                    4,
                                    jsonStorage.getItem($f76789f9143a442d$var$PENDING_SELECTED_WALLET_ID)
                                ];
                            case 1:
                                pendingSelectedWalletId = _state.sent();
                                return [
                                    4,
                                    jsonStorage.getItem($f76789f9143a442d$var$PENDING_CONTRACT)
                                ];
                            case 2:
                                pendingContract = _state.sent();
                                if (!(pendingSelectedWalletId && pendingContract)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    this.validateWallet(pendingSelectedWalletId)
                                ];
                            case 3:
                                _accounts = _state.sent();
                                return [
                                    4,
                                    jsonStorage.removeItem($f76789f9143a442d$var$PENDING_SELECTED_WALLET_ID)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    jsonStorage.removeItem($f76789f9143a442d$var$PENDING_CONTRACT)
                                ];
                            case 5:
                                _state.sent();
                                if (!_accounts.length) return [
                                    3,
                                    10
                                ];
                                _this_store_getState = this.store.getState(), _selectedWalletId = _this_store_getState.selectedWalletId;
                                return [
                                    4,
                                    this.getWallet(_selectedWalletId)
                                ];
                            case 6:
                                selectedWallet = _state.sent();
                                if (!(selectedWallet && pendingSelectedWalletId !== _selectedWalletId)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    selectedWallet.signOut().catch(function(err) {
                                        $f76789f9143a442d$var$logger.log("Failed to sign out existing wallet");
                                        $f76789f9143a442d$var$logger.error(err);
                                    })
                                ];
                            case 7:
                                _state.sent();
                                _state.label = 8;
                            case 8:
                                return [
                                    4,
                                    this.setWalletAsRecentlySignedIn(pendingSelectedWalletId)
                                ];
                            case 9:
                                recentlySignedInWalletsFromPending = _state.sent();
                                return [
                                    2,
                                    {
                                        accounts: _accounts,
                                        contract: pendingContract,
                                        selectedWalletId: pendingSelectedWalletId,
                                        recentlySignedInWallets: recentlySignedInWalletsFromPending
                                    }
                                ];
                            case 10:
                                _this_store_getState1 = this.store.getState(), contract = _this_store_getState1.contract, selectedWalletId = _this_store_getState1.selectedWalletId;
                                return [
                                    4,
                                    this.validateWallet(selectedWalletId)
                                ];
                            case 11:
                                accounts = _state.sent();
                                return [
                                    4,
                                    jsonStorage.getItem($f76789f9143a442d$var$RECENTLY_SIGNED_IN_WALLETS)
                                ];
                            case 12:
                                recentlySignedInWallets = _state.sent();
                                if (!accounts.length) return [
                                    2,
                                    {
                                        accounts: [],
                                        contract: null,
                                        selectedWalletId: null,
                                        recentlySignedInWallets: recentlySignedInWallets || []
                                    }
                                ];
                                return [
                                    2,
                                    {
                                        accounts: accounts,
                                        contract: contract,
                                        selectedWalletId: selectedWalletId,
                                        recentlySignedInWallets: recentlySignedInWallets || []
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setWalletAsRecentlySignedIn",
            value: function setWalletAsRecentlySignedIn(walletId) {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var jsonStorage, recentlySignedInWallets;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                jsonStorage = new $f76789f9143a442d$var$JsonStorage(this.storage, $f76789f9143a442d$var$PACKAGE_NAME);
                                return [
                                    4,
                                    jsonStorage.getItem($f76789f9143a442d$var$RECENTLY_SIGNED_IN_WALLETS)
                                ];
                            case 1:
                                recentlySignedInWallets = _state.sent();
                                if (!recentlySignedInWallets) recentlySignedInWallets = [];
                                if (!!recentlySignedInWallets.includes(walletId)) return [
                                    3,
                                    3
                                ];
                                recentlySignedInWallets.unshift(walletId);
                                recentlySignedInWallets = recentlySignedInWallets.slice(0, 5);
                                return [
                                    4,
                                    jsonStorage.setItem($f76789f9143a442d$var$RECENTLY_SIGNED_IN_WALLETS, recentlySignedInWallets)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    recentlySignedInWallets
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signOutWallet",
            value: function signOutWallet(walletId) {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var _this, wallet;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getWallet(walletId)
                                ];
                            case 1:
                                wallet = _state.sent();
                                return [
                                    4,
                                    wallet.signOut().catch(function(err) {
                                        $f76789f9143a442d$var$logger.log("Failed to sign out ".concat(wallet.id));
                                        $f76789f9143a442d$var$logger.error(err); // At least clean up state on our side.
                                        _this.onWalletSignedOut(wallet.id);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "onWalletSignedIn",
            value: function onWalletSignedIn(walletId, param) {
                var accounts = param.accounts, contractId = param.contractId, methodNames = param.methodNames;
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var selectedWalletId, jsonStorage, contract, module, recentlySignedInWallets;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                selectedWalletId = this.store.getState().selectedWalletId;
                                jsonStorage = new $f76789f9143a442d$var$JsonStorage(this.storage, $f76789f9143a442d$var$PACKAGE_NAME);
                                contract = {
                                    contractId: contractId,
                                    methodNames: methodNames
                                };
                                if (!!accounts.length) return [
                                    3,
                                    4
                                ];
                                module = this.getModule(walletId); // We can't guarantee the user will actually sign in with browser wallets.
                                if (!(module.type === "browser")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    jsonStorage.setItem($f76789f9143a442d$var$PENDING_SELECTED_WALLET_ID, walletId)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    jsonStorage.setItem($f76789f9143a442d$var$PENDING_CONTRACT, contract)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                            case 4:
                                if (!(selectedWalletId && selectedWalletId !== walletId)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.signOutWallet(selectedWalletId)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    4,
                                    this.setWalletAsRecentlySignedIn(walletId)
                                ];
                            case 7:
                                recentlySignedInWallets = _state.sent();
                                this.store.dispatch({
                                    type: "WALLET_CONNECTED",
                                    payload: {
                                        walletId: walletId,
                                        contract: contract,
                                        accounts: accounts,
                                        recentlySignedInWallets: recentlySignedInWallets
                                    }
                                });
                                this.emitter.emit("signedIn", {
                                    walletId: walletId,
                                    contractId: contractId,
                                    methodNames: methodNames,
                                    accounts: accounts
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "onWalletSignedOut",
            value: function onWalletSignedOut(walletId) {
                this.store.dispatch({
                    type: "WALLET_DISCONNECTED",
                    payload: {
                        walletId: walletId
                    }
                });
                this.emitter.emit("signedOut", {
                    walletId: walletId
                });
            }
        },
        {
            key: "setupWalletEmitter",
            value: function setupWalletEmitter(module) {
                var _this = this;
                var emitter = new $f76789f9143a442d$export$4fae95256245c8c0();
                emitter.on("signedOut", function() {
                    _this.onWalletSignedOut(module.id);
                });
                emitter.on("signedIn", function(event) {
                    _this.onWalletSignedIn(module.id, event);
                });
                emitter.on("accountsChanged", function(param) {
                    var accounts = param.accounts;
                    return $f76789f9143a442d$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            this.emitter.emit("accountsChanged", {
                                walletId: module.id,
                                accounts: accounts
                            });
                            if (!accounts.length) return [
                                2,
                                this.signOutWallet(module.id)
                            ];
                            this.store.dispatch({
                                type: "ACCOUNTS_CHANGED",
                                payload: {
                                    walletId: module.id,
                                    accounts: accounts
                                }
                            });
                            return [
                                2
                            ];
                        });
                    });
                });
                emitter.on("networkChanged", function(param) {
                    var networkId = param.networkId;
                    _this.emitter.emit("networkChanged", {
                        walletId: module.id,
                        networkId: networkId
                    });
                });
                emitter.on("uriChanged", function(param) {
                    var uri = param.uri;
                    _this.emitter.emit("uriChanged", {
                        walletId: module.id,
                        uri: uri
                    });
                });
                return emitter;
            }
        },
        {
            key: "decorateWallet",
            value: function decorateWallet(wallet) {
                var _this = this;
                var _signIn = wallet.signIn;
                var _signOut = wallet.signOut;
                wallet.signIn = function(params) {
                    return $f76789f9143a442d$var$__awaiter(_this, void 0, void 0, function() {
                        var accounts, contractId, _params_methodNames, methodNames;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _signIn(params)
                                    ];
                                case 1:
                                    accounts = _state.sent();
                                    contractId = params.contractId, _params_methodNames = params.methodNames, methodNames = _params_methodNames === void 0 ? [] : _params_methodNames;
                                    return [
                                        4,
                                        this.onWalletSignedIn(wallet.id, {
                                            accounts: accounts,
                                            contractId: contractId,
                                            methodNames: methodNames
                                        })
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        accounts
                                    ];
                            }
                        });
                    });
                };
                wallet.signOut = function() {
                    return $f76789f9143a442d$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _signOut()
                                    ];
                                case 1:
                                    _state.sent();
                                    this.onWalletSignedOut(wallet.id);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                };
                return wallet;
            }
        },
        {
            key: "setupInstance",
            value: function setupInstance(module) {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var message, wallet, _, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!module.metadata.available) {
                                    message = module.type === "injected" ? "not installed" : "not available";
                                    throw Error("".concat(module.metadata.name, " is ").concat(message));
                                }
                                _ = Object.assign;
                                _tmp = [
                                    {
                                        id: module.id,
                                        type: module.type,
                                        metadata: module.metadata
                                    }
                                ];
                                return [
                                    4,
                                    module.init({
                                        id: module.id,
                                        type: module.type,
                                        metadata: module.metadata,
                                        options: this.options,
                                        store: this.store.toReadOnly(),
                                        provider: this.provider,
                                        emitter: this.setupWalletEmitter(module),
                                        logger: new $f76789f9143a442d$var$Logger(module.id),
                                        storage: new $f76789f9143a442d$var$JsonStorage(this.storage, [
                                            $f76789f9143a442d$var$PACKAGE_NAME,
                                            module.id
                                        ])
                                    })
                                ];
                            case 1:
                                wallet = _.apply(Object, _tmp.concat([
                                    _state.sent()
                                ]));
                                return [
                                    2,
                                    this.decorateWallet(wallet)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getModule",
            value: function getModule(id) {
                return this.modules.find(function(x) {
                    return x.id === id;
                });
            }
        },
        {
            key: "getWallet",
            value: function getWallet(id) {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var module, selectedWalletId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                module = this.getModule(id);
                                if (!module) return [
                                    2,
                                    null
                                ];
                                selectedWalletId = this.store.getState().selectedWalletId; // If user uninstalled/removed a wallet which was previously signed in with
                                // best we can do is clean up state on our side.
                                if (!module.metadata.available && selectedWalletId) {
                                    this.onWalletSignedOut(selectedWalletId);
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    4,
                                    module.wallet()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setup",
            value: function setup() {
                return $f76789f9143a442d$var$__awaiter(this, void 0, void 0, function() {
                    var _this, _loop, _this1, modules, i, i1, wallet, err, _ref, accounts, contract, selectedWalletId, recentlySignedInWallets;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, _loop = function(i) {
                                    var module;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this.factories[i]({
                                                        options: _this.options
                                                    }).catch(function(err) {
                                                        $f76789f9143a442d$var$logger.log("Failed to setup module");
                                                        $f76789f9143a442d$var$logger.error(err);
                                                        return null;
                                                    })
                                                ];
                                            case 1:
                                                module = _state.sent();
                                                if (!module) return [
                                                    2,
                                                    "continue"
                                                ];
                                                 // Skip duplicated module.
                                                if (modules.some(function(x) {
                                                    return x.id === module.id;
                                                })) return [
                                                    2,
                                                    "continue"
                                                ];
                                                modules.push({
                                                    id: module.id,
                                                    type: module.type,
                                                    metadata: module.metadata,
                                                    wallet: function() {
                                                        return $f76789f9143a442d$var$__awaiter(_this1, void 0, void 0, function() {
                                                            var instance;
                                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        instance = this.instances[module.id];
                                                                        if (instance) return [
                                                                            2,
                                                                            instance
                                                                        ];
                                                                        return [
                                                                            4,
                                                                            this.setupInstance(module)
                                                                        ];
                                                                    case 1:
                                                                        instance = _state.sent();
                                                                        this.instances[module.id] = instance;
                                                                        return [
                                                                            2,
                                                                            instance
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _this1 = this;
                                modules = [];
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < this.factories.length)) return [
                                    3,
                                    4
                                ];
                                return [
                                    5,
                                    (0, $7UAGh.__values)(_loop(i))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                i += 1;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                this.modules = modules;
                                i1 = 0;
                                _state.label = 5;
                            case 5:
                                if (!(i1 < this.modules.length)) return [
                                    3,
                                    11
                                ];
                                if (!(this.modules[i1].type === "instant-link")) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    this.modules[i1].wallet()
                                ];
                            case 6:
                                wallet = _state.sent();
                                if (!wallet.metadata.runOnStartup) return [
                                    3,
                                    10
                                ];
                                _state.label = 7;
                            case 7:
                                _state.trys.push([
                                    7,
                                    9,
                                    ,
                                    10
                                ]);
                                return [
                                    4,
                                    wallet.signIn({
                                        contractId: wallet.getContractId()
                                    })
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                err = _state.sent();
                                $f76789f9143a442d$var$logger.error("Failed to sign in to wallet. " + err);
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                i1++;
                                return [
                                    3,
                                    5
                                ];
                            case 11:
                                return [
                                    4,
                                    this.resolveStorageState()
                                ];
                            case 12:
                                _ref = _state.sent(), accounts = _ref.accounts, contract = _ref.contract, selectedWalletId = _ref.selectedWalletId, recentlySignedInWallets = _ref.recentlySignedInWallets;
                                this.store.dispatch({
                                    type: "SETUP_WALLET_MODULES",
                                    payload: {
                                        modules: modules,
                                        accounts: accounts,
                                        contract: contract,
                                        selectedWalletId: selectedWalletId,
                                        recentlySignedInWallets: recentlySignedInWallets
                                    }
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return WalletModules;
}();
var $f76789f9143a442d$var$getNetworkPreset = function(networkId) {
    switch(networkId){
        case "mainnet":
            return {
                networkId: networkId,
                nodeUrl: "https://rpc.mainnet.near.org",
                helperUrl: "https://helper.mainnet.near.org",
                explorerUrl: "https://explorer.near.org",
                indexerUrl: "https://api.kitwallet.app"
            };
        case "testnet":
            return {
                networkId: networkId,
                nodeUrl: "https://rpc.testnet.near.org",
                helperUrl: "https://helper.testnet.near.org",
                explorerUrl: "https://explorer.testnet.near.org",
                indexerUrl: "https://testnet-api.kitwallet.app"
            };
        default:
            throw Error("Failed to find config for: '".concat(networkId, "'"));
    }
};
var $f76789f9143a442d$var$resolveNetwork = function(network) {
    return typeof network === "string" ? $f76789f9143a442d$var$getNetworkPreset(network) : network;
};
var $f76789f9143a442d$var$resolveOptions = function(params) {
    var options = {
        languageCode: params.languageCode || undefined,
        network: $f76789f9143a442d$var$resolveNetwork(params.network),
        debug: params.debug || false,
        optimizeWalletOrder: params.optimizeWalletOrder === false ? false : true,
        randomizeWalletOrder: params.randomizeWalletOrder || false
    };
    return {
        options: options,
        storage: params.storage || new $f76789f9143a442d$var$WebStorageService()
    };
};
var $f76789f9143a442d$var$reducer = function(state, action) {
    $f76789f9143a442d$var$logger.log("Store Action", action);
    switch(action.type){
        case "SETUP_WALLET_MODULES":
            {
                var _action_payload = action.payload, modules = _action_payload.modules, accounts = _action_payload.accounts, contract = _action_payload.contract, selectedWalletId = _action_payload.selectedWalletId, recentlySignedInWallets = _action_payload.recentlySignedInWallets;
                var accountStates = accounts.map(function(account, i) {
                    return Object.assign(Object.assign({}, account), {
                        active: i === 0
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    modules: modules,
                    accounts: accountStates,
                    contract: contract,
                    selectedWalletId: selectedWalletId,
                    recentlySignedInWallets: recentlySignedInWallets
                });
            }
        case "WALLET_CONNECTED":
            {
                var _action_payload1 = action.payload, walletId = _action_payload1.walletId, contract1 = _action_payload1.contract, accounts1 = _action_payload1.accounts, recentlySignedInWallets1 = _action_payload1.recentlySignedInWallets;
                if (!accounts1.length) return state;
                var activeAccountIndex = state.accounts.findIndex(function(account) {
                    return account.active;
                });
                var accountStates1 = accounts1.map(function(account, i) {
                    return Object.assign(Object.assign({}, account), {
                        active: i === (activeAccountIndex > -1 ? activeAccountIndex : 0)
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    contract: contract1,
                    accounts: accountStates1,
                    selectedWalletId: walletId,
                    recentlySignedInWallets: recentlySignedInWallets1
                });
            }
        case "WALLET_DISCONNECTED":
            {
                var walletId1 = action.payload.walletId;
                if (walletId1 !== state.selectedWalletId) return state;
                return Object.assign(Object.assign({}, state), {
                    contract: null,
                    accounts: [],
                    selectedWalletId: null
                });
            }
        case "ACCOUNTS_CHANGED":
            {
                var _action_payload2 = action.payload, walletId2 = _action_payload2.walletId, accounts2 = _action_payload2.accounts;
                if (walletId2 !== state.selectedWalletId) return state;
                var activeAccount = state.accounts.find(function(account) {
                    return account.active;
                });
                var isActiveAccountRemoved = !accounts2.some(function(account) {
                    return account.accountId === (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountId);
                });
                var accountStates2 = accounts2.map(function(account, i) {
                    return Object.assign(Object.assign({}, account), {
                        active: isActiveAccountRemoved ? i === 0 : account.accountId === (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountId)
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    accounts: accountStates2
                });
            }
        case "SET_ACTIVE_ACCOUNT":
            {
                var accountId = action.payload.accountId;
                var accountStates3 = state.accounts.map(function(account) {
                    return Object.assign(Object.assign({}, account), {
                        active: account.accountId === accountId
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    accounts: accountStates3
                });
            }
        default:
            return state;
    }
};
var $f76789f9143a442d$var$createStore = function(storage) {
    return $f76789f9143a442d$var$__awaiter(void 0, void 0, void 0, function() {
        var jsonStorage, initialState, _tmp, state$, actions$, syncStorage, prevState;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jsonStorage = new $f76789f9143a442d$var$JsonStorage(storage, $f76789f9143a442d$var$PACKAGE_NAME);
                    _tmp = {
                        modules: [],
                        accounts: []
                    };
                    return [
                        4,
                        jsonStorage.getItem($f76789f9143a442d$var$CONTRACT)
                    ];
                case 1:
                    _tmp.contract = _state.sent();
                    return [
                        4,
                        jsonStorage.getItem($f76789f9143a442d$var$SELECTED_WALLET_ID)
                    ];
                case 2:
                    _tmp.selectedWalletId = _state.sent();
                    return [
                        4,
                        jsonStorage.getItem($f76789f9143a442d$var$RECENTLY_SIGNED_IN_WALLETS)
                    ];
                case 3:
                    initialState = (_tmp.recentlySignedInWallets = _state.sent() || [], _tmp);
                    state$ = new (0, $36c178b219a287b9$export$cc3d42e6b2b9cf8b)(initialState);
                    actions$ = new (0, $d442f062d34a5142$export$b6bbab5a9b109038)();
                    actions$.pipe((0, $e687a35152d55f01$export$c87d910e63d22ed6)($f76789f9143a442d$var$reducer, initialState)).subscribe(state$);
                    syncStorage = function(prevState, state, storageKey, property) {
                        return $f76789f9143a442d$var$__awaiter(void 0, void 0, void 0, function() {
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (state[property] === prevState[property]) return [
                                            2
                                        ];
                                        if (!state[property]) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            jsonStorage.setItem(storageKey, state[property])
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                    case 2:
                                        return [
                                            4,
                                            jsonStorage.removeItem(storageKey)
                                        ];
                                    case 3:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    prevState = state$.getValue();
                    state$.subscribe(function(state) {
                        syncStorage(prevState, state, $f76789f9143a442d$var$SELECTED_WALLET_ID, "selectedWalletId");
                        syncStorage(prevState, state, $f76789f9143a442d$var$CONTRACT, "contract");
                        syncStorage(prevState, state, $f76789f9143a442d$var$RECENTLY_SIGNED_IN_WALLETS, "recentlySignedInWallets");
                        prevState = state;
                    });
                    return [
                        2,
                        {
                            observable: state$,
                            getState: function() {
                                return state$.getValue();
                            },
                            dispatch: function(action) {
                                return actions$.next(action);
                            },
                            toReadOnly: function() {
                                return {
                                    getState: function() {
                                        return state$.getValue();
                                    },
                                    observable: state$.asObservable()
                                };
                            }
                        }
                    ];
            }
        });
    });
};
var $f76789f9143a442d$var$walletSelectorInstance = null;
var $f76789f9143a442d$var$createSelector = function(options, store, walletModules, emitter) {
    return {
        options: options,
        store: store.toReadOnly(),
        wallet: function(id) {
            return $f76789f9143a442d$var$__awaiter(void 0, void 0, void 0, function() {
                var selectedWalletId, wallet;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            selectedWalletId = store.getState().selectedWalletId;
                            return [
                                4,
                                walletModules.getWallet(id || selectedWalletId)
                            ];
                        case 1:
                            wallet = _state.sent();
                            if (!wallet) {
                                if (id) throw new Error("Invalid wallet id");
                                throw new Error("No wallet selected");
                            }
                            return [
                                2,
                                wallet
                            ];
                    }
                });
            });
        },
        setActiveAccount: function(accountId) {
            var accounts = store.getState().accounts;
            if (!accounts.some(function(account) {
                return account.accountId === accountId;
            })) throw new Error("Invalid account id");
            store.dispatch({
                type: "SET_ACTIVE_ACCOUNT",
                payload: {
                    accountId: accountId
                }
            });
        },
        isSignedIn: function() {
            var accounts = store.getState().accounts;
            return Boolean(accounts.length);
        },
        on: function(eventName, callback) {
            return emitter.on(eventName, callback);
        },
        off: function(eventName, callback) {
            emitter.off(eventName, callback);
        }
    };
};
var $f76789f9143a442d$export$f9bdc9e9de5b988e = function(params) {
    return $f76789f9143a442d$var$__awaiter(void 0, void 0, void 0, function() {
        var _resolveOptions, options, storage, emitter, store, walletModules;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _resolveOptions = $f76789f9143a442d$var$resolveOptions(params), options = _resolveOptions.options, storage = _resolveOptions.storage;
                    $f76789f9143a442d$var$Logger.debug = options.debug;
                    emitter = new $f76789f9143a442d$export$4fae95256245c8c0();
                    return [
                        4,
                        $f76789f9143a442d$var$createStore(storage)
                    ];
                case 1:
                    store = _state.sent();
                    walletModules = new $f76789f9143a442d$var$WalletModules({
                        factories: params.modules,
                        storage: storage,
                        options: options,
                        store: store,
                        emitter: emitter,
                        provider: new $f76789f9143a442d$var$Provider(options.network.nodeUrl)
                    });
                    return [
                        4,
                        walletModules.setup()
                    ];
                case 2:
                    _state.sent();
                    if (params.allowMultipleSelectors) return [
                        2,
                        $f76789f9143a442d$var$createSelector(options, store, walletModules, emitter)
                    ];
                    if (!$f76789f9143a442d$var$walletSelectorInstance) $f76789f9143a442d$var$walletSelectorInstance = $f76789f9143a442d$var$createSelector(options, store, walletModules, emitter);
                    return [
                        2,
                        $f76789f9143a442d$var$walletSelectorInstance
                    ];
            }
        });
    });
};
var $f76789f9143a442d$var$wait = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var $f76789f9143a442d$var$poll = function(cb, interval, remaining) {
    return $f76789f9143a442d$var$__awaiter(void 0, void 0, void 0, function() {
        var result;
        return (0, $7UAGh.__generator)(this, function(_state) {
            result = cb();
            if (result) return [
                2,
                result
            ];
            if (!remaining) throw new Error("Exceeded timeout");
            return [
                2,
                $f76789f9143a442d$var$wait(interval).then(function() {
                    return $f76789f9143a442d$var$poll(cb, interval, remaining - 1);
                })
            ];
        });
    });
};
var $f76789f9143a442d$export$9bbfceb27f687c1b = function(cb) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return $f76789f9143a442d$var$__awaiter(void 0, void 0, void 0, function() {
        var _opts_timeout, timeout, _opts_interval, interval;
        return (0, $7UAGh.__generator)(this, function(_state) {
            _opts_timeout = opts.timeout, timeout = _opts_timeout === void 0 ? 100 : _opts_timeout, _opts_interval = opts.interval, interval = _opts_interval === void 0 ? 50 : _opts_interval;
            return [
                2,
                Promise.race([
                    $f76789f9143a442d$var$wait(timeout).then(function() {
                        throw new Error("Exceeded timeout");
                    }),
                    $f76789f9143a442d$var$poll(cb, interval, Math.floor(timeout / interval))
                ])
            ];
        });
    });
};
var $f76789f9143a442d$export$13dd2e33a23839ad = function(state) {
    return state.accounts.find(function(account) {
        return account.active;
    }) || null;
};
var $f76789f9143a442d$var$aCallable = $f76789f9143a442d$var$aCallable$8;
var $f76789f9143a442d$var$toObject = $f76789f9143a442d$var$toObject$4;
var $f76789f9143a442d$var$IndexedObject = $f76789f9143a442d$var$indexedObject;
var $f76789f9143a442d$var$lengthOfArrayLike$1 = $f76789f9143a442d$var$lengthOfArrayLike$4;
var $f76789f9143a442d$var$$TypeError$1 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $f76789f9143a442d$var$createMethod$1 = function createMethod$1(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $f76789f9143a442d$var$aCallable(callbackfn);
        var O = $f76789f9143a442d$var$toObject(that);
        var _$self = $f76789f9143a442d$var$IndexedObject(O);
        var length = $f76789f9143a442d$var$lengthOfArrayLike$1(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in _$self) {
                memo = _$self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $f76789f9143a442d$var$$TypeError$1("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in _$self) memo = callbackfn(memo, _$self[index], index, O);
        return memo;
    };
};
var $f76789f9143a442d$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $f76789f9143a442d$var$createMethod$1(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $f76789f9143a442d$var$createMethod$1(true)
};
var $f76789f9143a442d$var$fails$5 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$arrayMethodIsStrict$1 = function arrayMethodIsStrict$1(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $f76789f9143a442d$var$fails$5(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $f76789f9143a442d$var$$$1 = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$$reduce = $f76789f9143a442d$var$arrayReduce.left;
var $f76789f9143a442d$var$arrayMethodIsStrict = $f76789f9143a442d$var$arrayMethodIsStrict$1;
var $f76789f9143a442d$var$CHROME_VERSION = $f76789f9143a442d$var$engineV8Version;
var $f76789f9143a442d$var$IS_NODE = $f76789f9143a442d$var$engineIsNode;
var $f76789f9143a442d$var$STRICT_METHOD = $f76789f9143a442d$var$arrayMethodIsStrict("reduce");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $f76789f9143a442d$var$CHROME_BUG = !$f76789f9143a442d$var$IS_NODE && $f76789f9143a442d$var$CHROME_VERSION > 79 && $f76789f9143a442d$var$CHROME_VERSION < 83;
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$f76789f9143a442d$var$$$1({
    target: "Array",
    proto: true,
    forced: !$f76789f9143a442d$var$STRICT_METHOD || $f76789f9143a442d$var$CHROME_BUG
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $f76789f9143a442d$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $f76789f9143a442d$var$anObject$2 = $f76789f9143a442d$var$anObject$d;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $f76789f9143a442d$var$regexpFlags$1 = function regexpFlags$1() {
    var that = $f76789f9143a442d$var$anObject$2(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $f76789f9143a442d$var$fails$4 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$global$3 = $f76789f9143a442d$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $f76789f9143a442d$var$$RegExp$2 = $f76789f9143a442d$var$global$3.RegExp;
var $f76789f9143a442d$var$UNSUPPORTED_Y$2 = $f76789f9143a442d$var$fails$4(function() {
    var re = $f76789f9143a442d$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $f76789f9143a442d$var$MISSED_STICKY = $f76789f9143a442d$var$UNSUPPORTED_Y$2 || $f76789f9143a442d$var$fails$4(function() {
    return !$f76789f9143a442d$var$$RegExp$2("a", "y").sticky;
});
var $f76789f9143a442d$var$BROKEN_CARET = $f76789f9143a442d$var$UNSUPPORTED_Y$2 || $f76789f9143a442d$var$fails$4(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $f76789f9143a442d$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $f76789f9143a442d$var$regexpStickyHelpers = {
    BROKEN_CARET: $f76789f9143a442d$var$BROKEN_CARET,
    MISSED_STICKY: $f76789f9143a442d$var$MISSED_STICKY,
    UNSUPPORTED_Y: $f76789f9143a442d$var$UNSUPPORTED_Y$2
};
var $f76789f9143a442d$var$fails$3 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$global$2 = $f76789f9143a442d$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $f76789f9143a442d$var$$RegExp$1 = $f76789f9143a442d$var$global$2.RegExp;
var $f76789f9143a442d$var$regexpUnsupportedDotAll = $f76789f9143a442d$var$fails$3(function() {
    var re = $f76789f9143a442d$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $f76789f9143a442d$var$fails$2 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$global$1 = $f76789f9143a442d$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $f76789f9143a442d$var$$RegExp = $f76789f9143a442d$var$global$1.RegExp;
var $f76789f9143a442d$var$regexpUnsupportedNcg = $f76789f9143a442d$var$fails$2(function() {
    var re = $f76789f9143a442d$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $f76789f9143a442d$var$call$2 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$uncurryThis$3 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$toString$2 = $f76789f9143a442d$var$toString$4;
var $f76789f9143a442d$var$regexpFlags = $f76789f9143a442d$var$regexpFlags$1;
var $f76789f9143a442d$var$stickyHelpers$1 = $f76789f9143a442d$var$regexpStickyHelpers;
var $f76789f9143a442d$var$shared = $f76789f9143a442d$var$shared$4.exports;
var $f76789f9143a442d$var$create = $f76789f9143a442d$var$objectCreate;
var $f76789f9143a442d$var$getInternalState = $f76789f9143a442d$var$internalState.get;
var $f76789f9143a442d$var$UNSUPPORTED_DOT_ALL = $f76789f9143a442d$var$regexpUnsupportedDotAll;
var $f76789f9143a442d$var$UNSUPPORTED_NCG = $f76789f9143a442d$var$regexpUnsupportedNcg;
var $f76789f9143a442d$var$nativeReplace = $f76789f9143a442d$var$shared("native-string-replace", String.prototype.replace);
var $f76789f9143a442d$var$nativeExec = RegExp.prototype.exec;
var $f76789f9143a442d$var$patchedExec = $f76789f9143a442d$var$nativeExec;
var $f76789f9143a442d$var$charAt$2 = $f76789f9143a442d$var$uncurryThis$3("".charAt);
var $f76789f9143a442d$var$indexOf = $f76789f9143a442d$var$uncurryThis$3("".indexOf);
var $f76789f9143a442d$var$replace = $f76789f9143a442d$var$uncurryThis$3("".replace);
var $f76789f9143a442d$var$stringSlice$2 = $f76789f9143a442d$var$uncurryThis$3("".slice);
var $f76789f9143a442d$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $f76789f9143a442d$var$call$2($f76789f9143a442d$var$nativeExec, re1, "a");
    $f76789f9143a442d$var$call$2($f76789f9143a442d$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $f76789f9143a442d$var$UNSUPPORTED_Y$1 = $f76789f9143a442d$var$stickyHelpers$1.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $f76789f9143a442d$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $f76789f9143a442d$var$PATCH = $f76789f9143a442d$var$UPDATES_LAST_INDEX_WRONG || $f76789f9143a442d$var$NPCG_INCLUDED || $f76789f9143a442d$var$UNSUPPORTED_Y$1 || $f76789f9143a442d$var$UNSUPPORTED_DOT_ALL || $f76789f9143a442d$var$UNSUPPORTED_NCG;
if ($f76789f9143a442d$var$PATCH) $f76789f9143a442d$var$patchedExec = function exec(string) {
    var re = this;
    var state = $f76789f9143a442d$var$getInternalState(re);
    var str = $f76789f9143a442d$var$toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $f76789f9143a442d$var$call$2($f76789f9143a442d$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $f76789f9143a442d$var$UNSUPPORTED_Y$1 && re.sticky;
    var flags = $f76789f9143a442d$var$call$2($f76789f9143a442d$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $f76789f9143a442d$var$replace(flags, "y", "");
        if ($f76789f9143a442d$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $f76789f9143a442d$var$stringSlice$2(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $f76789f9143a442d$var$charAt$2(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($f76789f9143a442d$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($f76789f9143a442d$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $f76789f9143a442d$var$call$2($f76789f9143a442d$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $f76789f9143a442d$var$stringSlice$2(match.input, charsAdded);
            match[0] = $f76789f9143a442d$var$stringSlice$2(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($f76789f9143a442d$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($f76789f9143a442d$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $f76789f9143a442d$var$call$2($f76789f9143a442d$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $f76789f9143a442d$var$create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $f76789f9143a442d$var$regexpExec$3 = $f76789f9143a442d$var$patchedExec;
var $f76789f9143a442d$var$$ = $f76789f9143a442d$var$_export;
var $f76789f9143a442d$var$exec$1 = $f76789f9143a442d$var$regexpExec$3;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$f76789f9143a442d$var$$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $f76789f9143a442d$var$exec$1
}, {
    exec: $f76789f9143a442d$var$exec$1
});
/* eslint-disable no-useless-escape */ // https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts
var $f76789f9143a442d$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $f76789f9143a442d$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $f76789f9143a442d$var$SEARCHBOX_UA_REGEX
    ]
];
var $f76789f9143a442d$var$matchUserAgent = function(ua) {
    return ua !== "" && $f76789f9143a442d$var$userAgentRules.reduce(function(matched, param) {
        var _param = (0, $8GFUW._)(param, 2), browser = _param[0], regex = _param[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
};
var $f76789f9143a442d$export$3ef098392766df13 = function(supportedBrowser) {
    if (typeof navigator === "undefined") return false;
    var matchedRule = $f76789f9143a442d$var$matchUserAgent(navigator.userAgent);
    if (!matchedRule) return false;
    var _matchedRule = (0, $8GFUW._)(matchedRule, 1), name = _matchedRule[0];
    if (name === "searchbot") return false;
    return !!supportedBrowser.find(function(item) {
        return item === name;
    });
};
// TODO: Remove from `core-js@4` since it's moved to entry points
var $f76789f9143a442d$var$uncurryThis$2 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$defineBuiltIn = $f76789f9143a442d$var$defineBuiltIn$6;
var $f76789f9143a442d$var$regexpExec$2 = $f76789f9143a442d$var$regexpExec$3;
var $f76789f9143a442d$var$fails$1 = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$wellKnownSymbol = $f76789f9143a442d$var$wellKnownSymbol$h;
var $f76789f9143a442d$var$createNonEnumerableProperty = $f76789f9143a442d$var$createNonEnumerableProperty$5;
var $f76789f9143a442d$var$SPECIES = $f76789f9143a442d$var$wellKnownSymbol("species");
var $f76789f9143a442d$var$RegExpPrototype = RegExp.prototype;
var $f76789f9143a442d$var$fixRegexpWellKnownSymbolLogic = function fixRegexpWellKnownSymbolLogic(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $f76789f9143a442d$var$wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !$f76789f9143a442d$var$fails$1(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$f76789f9143a442d$var$fails$1(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$f76789f9143a442d$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $f76789f9143a442d$var$uncurryThis$2(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $f76789f9143a442d$var$uncurryThis$2(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $f76789f9143a442d$var$regexpExec$2 || $exec === $f76789f9143a442d$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $f76789f9143a442d$var$defineBuiltIn(String.prototype, KEY, methods[0]);
        $f76789f9143a442d$var$defineBuiltIn($f76789f9143a442d$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $f76789f9143a442d$var$createNonEnumerableProperty($f76789f9143a442d$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $f76789f9143a442d$var$uncurryThis$1 = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$toIntegerOrInfinity = $f76789f9143a442d$var$toIntegerOrInfinity$3;
var $f76789f9143a442d$var$toString$1 = $f76789f9143a442d$var$toString$4;
var $f76789f9143a442d$var$requireObjectCoercible$1 = $f76789f9143a442d$var$requireObjectCoercible$5;
var $f76789f9143a442d$var$charAt$1 = $f76789f9143a442d$var$uncurryThis$1("".charAt);
var $f76789f9143a442d$var$charCodeAt = $f76789f9143a442d$var$uncurryThis$1("".charCodeAt);
var $f76789f9143a442d$var$stringSlice$1 = $f76789f9143a442d$var$uncurryThis$1("".slice);
var $f76789f9143a442d$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $f76789f9143a442d$var$toString$1($f76789f9143a442d$var$requireObjectCoercible$1($this));
        var position = $f76789f9143a442d$var$toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $f76789f9143a442d$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $f76789f9143a442d$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $f76789f9143a442d$var$charAt$1(S, position) : first : CONVERT_TO_STRING ? $f76789f9143a442d$var$stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $f76789f9143a442d$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $f76789f9143a442d$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $f76789f9143a442d$var$createMethod(true)
};
var $f76789f9143a442d$var$charAt = $f76789f9143a442d$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $f76789f9143a442d$var$advanceStringIndex$1 = function advanceStringIndex$1(S, index, unicode) {
    return index + (unicode ? $f76789f9143a442d$var$charAt(S, index).length : 1);
};
var $f76789f9143a442d$var$toPropertyKey = $f76789f9143a442d$var$toPropertyKey$3;
var $f76789f9143a442d$var$definePropertyModule = $f76789f9143a442d$var$objectDefineProperty;
var $f76789f9143a442d$var$createPropertyDescriptor = $f76789f9143a442d$var$createPropertyDescriptor$4;
var $f76789f9143a442d$var$createProperty$1 = function createProperty$1(object, key, value) {
    var propertyKey = $f76789f9143a442d$var$toPropertyKey(key);
    if (propertyKey in object) $f76789f9143a442d$var$definePropertyModule.f(object, propertyKey, $f76789f9143a442d$var$createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
};
var $f76789f9143a442d$var$toAbsoluteIndex = $f76789f9143a442d$var$toAbsoluteIndex$2;
var $f76789f9143a442d$var$lengthOfArrayLike = $f76789f9143a442d$var$lengthOfArrayLike$4;
var $f76789f9143a442d$var$createProperty = $f76789f9143a442d$var$createProperty$1;
var $f76789f9143a442d$var$$Array = Array;
var $f76789f9143a442d$var$max = Math.max;
var $f76789f9143a442d$var$arraySliceSimple = function arraySliceSimple(O, start, end) {
    var length = $f76789f9143a442d$var$lengthOfArrayLike(O);
    var k = $f76789f9143a442d$var$toAbsoluteIndex(start, length);
    var fin = $f76789f9143a442d$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $f76789f9143a442d$var$$Array($f76789f9143a442d$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$f76789f9143a442d$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $f76789f9143a442d$var$call$1 = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$anObject$1 = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$isCallable = $f76789f9143a442d$var$isCallable$l;
var $f76789f9143a442d$var$classof = $f76789f9143a442d$var$classofRaw$1;
var $f76789f9143a442d$var$regexpExec$1 = $f76789f9143a442d$var$regexpExec$3;
var $f76789f9143a442d$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $f76789f9143a442d$var$regexpExecAbstract = function regexpExecAbstract(R, S) {
    var exec = R.exec;
    if ($f76789f9143a442d$var$isCallable(exec)) {
        var result = $f76789f9143a442d$var$call$1(exec, R, S);
        if (result !== null) $f76789f9143a442d$var$anObject$1(result);
        return result;
    }
    if ($f76789f9143a442d$var$classof(R) === "RegExp") return $f76789f9143a442d$var$call$1($f76789f9143a442d$var$regexpExec$1, R, S);
    throw $f76789f9143a442d$var$$TypeError("RegExp#exec called on incompatible receiver");
};
var $f76789f9143a442d$var$apply = $f76789f9143a442d$var$functionApply;
var $f76789f9143a442d$var$call = $f76789f9143a442d$var$functionCall;
var $f76789f9143a442d$var$uncurryThis = $f76789f9143a442d$var$functionUncurryThis;
var $f76789f9143a442d$var$fixRegExpWellKnownSymbolLogic = $f76789f9143a442d$var$fixRegexpWellKnownSymbolLogic;
var $f76789f9143a442d$var$isRegExp = $f76789f9143a442d$var$isRegexp;
var $f76789f9143a442d$var$anObject = $f76789f9143a442d$var$anObject$d;
var $f76789f9143a442d$var$requireObjectCoercible = $f76789f9143a442d$var$requireObjectCoercible$5;
var $f76789f9143a442d$var$speciesConstructor = $f76789f9143a442d$var$speciesConstructor$2;
var $f76789f9143a442d$var$advanceStringIndex = $f76789f9143a442d$var$advanceStringIndex$1;
var $f76789f9143a442d$var$toLength = $f76789f9143a442d$var$toLength$2;
var $f76789f9143a442d$var$toString = $f76789f9143a442d$var$toString$4;
var $f76789f9143a442d$var$getMethod = $f76789f9143a442d$var$getMethod$4;
var $f76789f9143a442d$var$arraySlice = $f76789f9143a442d$var$arraySliceSimple;
var $f76789f9143a442d$var$callRegExpExec = $f76789f9143a442d$var$regexpExecAbstract;
var $f76789f9143a442d$var$regexpExec = $f76789f9143a442d$var$regexpExec$3;
var $f76789f9143a442d$var$stickyHelpers = $f76789f9143a442d$var$regexpStickyHelpers;
var $f76789f9143a442d$var$fails = $f76789f9143a442d$var$fails$k;
var $f76789f9143a442d$var$UNSUPPORTED_Y = $f76789f9143a442d$var$stickyHelpers.UNSUPPORTED_Y;
var $f76789f9143a442d$var$MAX_UINT32 = 0xFFFFFFFF;
var $f76789f9143a442d$var$min = Math.min;
var $f76789f9143a442d$var$$push = [].push;
var $f76789f9143a442d$var$exec = $f76789f9143a442d$var$uncurryThis(/./.exec);
var $f76789f9143a442d$var$push = $f76789f9143a442d$var$uncurryThis($f76789f9143a442d$var$$push);
var $f76789f9143a442d$var$stringSlice = $f76789f9143a442d$var$uncurryThis("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $f76789f9143a442d$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$f76789f9143a442d$var$fails(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$f76789f9143a442d$var$fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
        var string = $f76789f9143a442d$var$toString($f76789f9143a442d$var$requireObjectCoercible(this));
        var lim = limit === undefined ? $f76789f9143a442d$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$f76789f9143a442d$var$isRegExp(separator)) return $f76789f9143a442d$var$call(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $f76789f9143a442d$var$call($f76789f9143a442d$var$regexpExec, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $f76789f9143a442d$var$push(output, $f76789f9143a442d$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $f76789f9143a442d$var$apply($f76789f9143a442d$var$$push, output, $f76789f9143a442d$var$arraySlice(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$f76789f9143a442d$var$exec(separatorCopy, "")) $f76789f9143a442d$var$push(output, "");
        } else $f76789f9143a442d$var$push(output, $f76789f9143a442d$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $f76789f9143a442d$var$arraySlice(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function internalSplit(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $f76789f9143a442d$var$call(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $f76789f9143a442d$var$requireObjectCoercible(this);
            var splitter = separator == undefined ? undefined : $f76789f9143a442d$var$getMethod(separator, SPLIT);
            return splitter ? $f76789f9143a442d$var$call(splitter, separator, O, limit) : $f76789f9143a442d$var$call(internalSplit, $f76789f9143a442d$var$toString(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $f76789f9143a442d$var$anObject(this);
            var S = $f76789f9143a442d$var$toString(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $f76789f9143a442d$var$speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($f76789f9143a442d$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($f76789f9143a442d$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $f76789f9143a442d$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $f76789f9143a442d$var$callRegExpExec(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $f76789f9143a442d$var$UNSUPPORTED_Y ? 0 : q;
                var z = $f76789f9143a442d$var$callRegExpExec(splitter, $f76789f9143a442d$var$UNSUPPORTED_Y ? $f76789f9143a442d$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $f76789f9143a442d$var$min($f76789f9143a442d$var$toLength(splitter.lastIndex + ($f76789f9143a442d$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $f76789f9143a442d$var$advanceStringIndex(S, q, unicodeMatching);
                else {
                    $f76789f9143a442d$var$push(A, $f76789f9143a442d$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $f76789f9143a442d$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $f76789f9143a442d$var$push(A, $f76789f9143a442d$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$f76789f9143a442d$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $f76789f9143a442d$var$UNSUPPORTED_Y);
var $f76789f9143a442d$var$modal$b = {
    wallet: {
        connectYourWallet: "Connect Your Wallet",
        whatIsAWallet: "What is a Wallet?",
        secureAndManage: "Secure & Manage Your Digital Assets",
        safelyStore: "Safely store and transfer your crypto and NFTs.",
        logInToAny: "Log In to Any NEAR App",
        noNeedToCreate: "No need to create new accounts or credentials. Connect your wallet and you are good to go!",
        getAWallet: "Get a Wallet",
        useAWallet: "Use a wallet to secure and manage your NEAR assets, and to log in to any NEAR app without the need for usernames and passwords.",
        connectionFailed: "Connection Failed",
        connectionSuccessful: "Connection Successful",
        connected: "Connected",
        connectingTo: "Connecting to",
        connectingMessage: {
            injected: "Confirm the connection in the extension window",
            browser: "Confirm the connection in the wallet after redirect",
            hardware: "Confirm the connection in the ledger device",
            bridge: "Confirm the connection in the wallet"
        }
    },
    ledger: {
        connectWithLedger: "Connect with Ledger",
        makeSureYourLedger: "Make sure your Ledger is connected securely, and that the NEAR app is open on your device",
        "continue": "Continue",
        specifyHDPath: "Specify HD Path",
        enterYourPreferredHDPath: "Enter your preferred HD path, then scan for any active accounts.",
        scan: "Scan",
        retry: "Retry",
        ledgerIsNotAvailable: "Ledger is not available",
        accessDeniedToUseLedgerDevice: "Access denied to use Ledger device",
        noAccountsFound: "No Accounts Found",
        selectYourAccounts: "Select Your Accounts",
        connecting1Account: "Connecting 1 Account",
        cantFindAnyAccount: "Can't find any account associated with this Ledger. Please create a new NEAR account on",
        orConnectAnAnotherLedger: "or connect an another Ledger.",
        connecting: "Connecting",
        ofAccounts: "of Accounts",
        failedToAutomatically: "Failed to automatically find account id. Provide it manually:",
        overviewTheListOfAuthorized: "Overview the list of authorized account(s), complete sign in by clicking the button below.",
        finish: "Finish"
    },
    install: {
        youllNeedToInstall: "You'll need to install",
        toContinueAfterInstalling: "to continue. After installing",
        refreshThePage: "refresh the page.",
        open: "Open"
    },
    qr: {
        copiedToClipboard: "Copied to clipboard",
        failedToCopy: "Failed to copy to clipboard",
        scanWithYourMobile: "Scan with Your Mobile Device",
        copyToClipboard: " Copy to clipboard",
        preferTheOfficial: "Prefer the official dialogue of",
        open: "Open"
    },
    exportAccounts: {
        chooseAWallet: "Choose a Wallet",
        transferYourAccounts: "Transfer Your Accounts",
        selectAWallet: "Select a wallet that fits your needs and supports your connected accounts.",
        selectYourAccounts: "Select Your Accounts",
        afterDecide: "After you decide on a wallet, you can select which accounts you want to transfer.",
        disclaimer: "You won’t be able to transfer accounts that have never been funded or used on NEAR.",
        warning: "does not support account export at this time. Please select another wallet.",
        walletTypes: {
            hardware: "Hardware Wallet",
            browser: "Browser Wallet",
            injected: "Wallet Extension",
            bridge: "Bridge Wallet",
            mobile: "Mobile Wallet"
        },
        selectAccounts: {
            title: "Select Accounts to Transfer",
            button: "Get Passphrase",
            deselectAll: "Deselect All",
            selectAll: "Select All",
            unavailable: "Transfer Unavailable",
            error: "Account does not exist",
            warningLedger: "Ledger support required",
            noBalance: "Account not funded"
        },
        getPassphrase: {
            title: "Copy Temporary Password",
            desc: "You’ll need to enter this password when you begin exporting your accounts to a different wallet.",
            button: "Continue",
            label: "Click to Copy",
            checkLabel: "I copied or wrote down the password"
        },
        complete: {
            title: "Complete the Transfer",
            descOne: "You will now be redirected to the wallet you selected to complete the transfer.",
            descTwo: "Once import part of process is completed from selected wallet, press button to complete the transfer process.",
            button: "Complete"
        }
    }
};
var $f76789f9143a442d$var$component$1 = {
    clickToCopy: {
        label: "Copied",
        tooltip: "Click to copy"
    }
};
var $f76789f9143a442d$var$en = {
    modal: $f76789f9143a442d$var$modal$b,
    component: $f76789f9143a442d$var$component$1
};
var $f76789f9143a442d$var$modal$a = {
    wallet: {
        connectYourWallet: "Conecta Tu Billetera",
        whatIsAWallet: "\xbfQue es una Billetera?",
        secureAndManage: "Resguarda y Administrar Tus Activos Digitales",
        safelyStore: "Almacena de forma segura y transfiere tus cryptos y NFT's",
        logInToAny: "Inicie sesi\xf3n en Cualquier Aplicacion NEAR",
        noNeedToCreate: "No es necesario crear nuevas cuentas o credenciales, \xa1Conecta tu billetera y listo!",
        getAWallet: "Obten una Billetera",
        useAWallet: "Usa tu Billetera para resguardar y administrar tus activos en NEAR, e Iniciar sesi\xf3n en cualquier aplicacion NEAR sin la necesidad de nombres de usuarios y contrase\xf1as",
        connectionFailed: "Conexi\xf3n Fallida",
        connectionSuccessful: "Conexi\xf3n Existosa",
        connected: "Conectado",
        connectingTo: "Conectando a ",
        connectingMessage: {
            injected: "Confirme la conexi\xf3n en la ventana de extensi\xf3n",
            browser: "Confirme la conexi\xf3n en la billetera despu\xe9s de la redirecci\xf3n",
            hardware: "Confirme la conexi\xf3n en el dispositivo de libro mayor",
            bridge: "Confirmar la conexi\xf3n en la billetera"
        }
    },
    ledger: {
        connectWithLedger: "Conectar con Ledger",
        makeSureYourLedger: "Aseg\xfarese de que su ledger est\xe1 conectada de forma segura y que la aplicacion NEAR est\xe9 abierta en su dispositivo",
        "continue": "Continuar",
        specifyHDPath: "Especifique la ruta HD",
        enterYourPreferredHDPath: "Ingrese su ruta HD prerida,y luego busque cualquier cuenta activa.",
        scan: "Escanear",
        retry: "Reintentar",
        ledgerIsNotAvailable: "El Ledger no est\xe1 disponible",
        accessDeniedToUseLedgerDevice: "Acceso denegado para usar el dispositivo ledger",
        noAccountsFound: "No se encontraron cuentas",
        selectYourAccounts: "Selecciona tus cuentas",
        connecting1Account: "Conectando a 1 cuenta",
        cantFindAnyAccount: "No se pudo encontrar ninguna cuenta asociada con este ledger,Por favor crea una nueva cuenta en NEAR",
        orConnectAnAnotherLedger: "o conecta otro ledger",
        connecting: "Conectando",
        ofAccounts: "de Cuentas",
        failedToAutomatically: "No se pudo encontrar automaticamente el id de la cuenta,Ingresalo manualmente:",
        overviewTheListOfAuthorized: "Revise la lista de las cuentas autorizadas,Complete el inicio de sesi\xf3n haciedo click a countinuacion.",
        finish: "Finalizar"
    },
    install: {
        youllNeedToInstall: "Tendr\xe1s que instalar",
        toContinueAfterInstalling: "Para continuar, Despues de instalar",
        refreshThePage: "Recarga la pagina",
        open: "Abrir"
    },
    qr: {
        copiedToClipboard: "Copiado al Portapapeles",
        failedToCopy: "Fall\xf3 la copia al Portapapeles",
        scanWithYourMobile: "Busca con tu dispositivo movil",
        copyToClipboard: " Copiar al Portapapeles",
        preferTheOfficial: "\xbfPrefires el di\xe1logo oficial de",
        open: "Abrir"
    }
};
var $f76789f9143a442d$var$es = {
    modal: $f76789f9143a442d$var$modal$a
};
var $f76789f9143a442d$var$modal$9 = {
    wallet: {
        connectYourWallet: "连接你的钱包",
        whatIsAWallet: "什么是钱包？",
        secureAndManage: "保护和管理你的数字资产",
        safelyStore: "安全存储和转移你的加密货币和NFT",
        logInToAny: "登录任何 NEAR 应用",
        noNeedToCreate: "不需要创建新账户或密码。连接你的钱包，即可开始使用！",
        getAWallet: "获取新账户",
        useAWallet: "使用钱包来保护和管理你的 NEAR 资产，无需用户名和密码即可登录任何 NEAR 应用",
        connectionFailed: "连接失败",
        connectionSuccessful: "连接成功",
        connected: "已连接",
        connectingTo: "正在连接"
    },
    ledger: {
        connectWithLedger: "连接 Ledger",
        makeSureYourLedger: "确保你的 Ledger 已经安全连接，并且 NEAR 应用已经在你设备上打开",
        "continue": "继续",
        specifyHDPath: "指定 HD 路径",
        enterYourPreferredHDPath: "输入你偏好的 HD 路径，然后为任意活跃账户扫码",
        scan: "扫码",
        retry: "重试",
        ledgerIsNotAvailable: "Ledger 不可用",
        accessDeniedToUseLedgerDevice: "访问 Ledger 设备被拒绝",
        noAccountsFound: "没有找到账户",
        selectYourAccounts: "选择你的账户",
        connecting1Account: "正在连接1个账户",
        cantFindAnyAccount: "没有找到任何与这个 Ledger 相关联的账户。请创建新账户于",
        "orConnectAnAnotherLedger.": "或连接另一个 Ledger",
        connecting: "正在连接",
        ofAccounts: "个账户",
        failedToAutomatically: "无法自动找到账户ID，请主动提供：",
        overviewTheListOfAuthorized: "请查看已授权的账户列表，点击以下按钮完成登录",
        finish: "完成"
    },
    install: {
        youllNeedToInstall: "你将需要安装",
        toContinueAfterInstalling: "以继续。安装完",
        refreshThePage: "请刷新页面",
        open: "打开"
    },
    qr: {
        copiedToClipboard: "复制到了剪贴板",
        failedToCopy: "复制到剪贴板失败",
        scanWithYourMobile: "用你的移动设备扫码",
        copyToClipboard: " 复制到剪贴板",
        preferTheOfficial: "希望使用官方对话框于",
        open: "打开"
    }
};
var $f76789f9143a442d$var$zh = {
    modal: $f76789f9143a442d$var$modal$9
};
var $f76789f9143a442d$var$modal$8 = {
    wallet: {
        connectYourWallet: "Свържете вашия Портфейл",
        whatIsAWallet: "Какво е Портфейл?",
        secureAndManage: "Защитете и управлявайте дигиталните си активи",
        safelyStore: "Съхранявайте и прехвърляйте безопасно вашите крипто и NFT.",
        logInToAny: "Използвайте всяко приложение на NEAR",
        noNeedToCreate: "Няма нужда да създавате нови профили. Свържете портфейла си и сте готови!",
        getAWallet: "Създайте Портфейл",
        useAWallet: "Използвайте портфейла, за да защитите и управлявате активите си на NEAR както и да използвате всяко приложение на NEAR без нужда от потребителски имена и пароли.",
        connectionFailed: "Свързването неуспешно",
        connectionSuccessful: "Свързването успешно",
        connected: "Свързан",
        connectingTo: "Свързване към",
        connectingMessage: {
            injected: "Потвърдете свързването в прозореца на разширението",
            browser: "Потвърдете свързването в портфейла след пренасочването",
            hardware: "Потвърдете свързването в хардуерния портфейл",
            bridge: "Потвърдете връзката в портфейла"
        }
    },
    ledger: {
        connectWithLedger: "Свържете се с Ledger",
        makeSureYourLedger: "Уверете се, че вашият Ledger е свързан и че приложението NEAR е отворено нa него.",
        "continue": "Продължете",
        specifyHDPath: "Посочете HD път",
        enterYourPreferredHDPath: "Въведете предпочитания HD път, след което сканирайте за активни акаунти.",
        scan: "Сканирайте",
        retry: "Опитайте отново",
        ledgerIsNotAvailable: "Ledger устройството не е достъпно",
        accessDeniedToUseLedgerDevice: "Достъпът за използване на Ledger е отказан",
        noAccountsFound: "Няма намерени профили",
        selectYourAccounts: "Изберете вашите профили",
        connecting1Account: "Свързване на 1 профил",
        cantFindAnyAccount: "Няма намерени профили, съврзани с този Ledger. Моля, създайте нов NEAR профил на",
        orConnectAnAnotherLedger: "или свържете друг Ledger.",
        connecting: "Свързване",
        ofAccounts: "от профили",
        failedToAutomatically: "Автоматичното намиране на профила не бе успешно. Въведете го ръчно:",
        overviewTheListOfAuthorized: "Прегледайте списъка с упълномощени профили, завършете влизането, като щракнете върху бутона по-долу..",
        finish: "Завършете"
    },
    install: {
        youllNeedToInstall: "Ще трябва да инсталирате",
        toContinueAfterInstalling: "за да продължите. След инсталиране",
        refreshThePage: "презаредете страницата.",
        open: "Отворете"
    },
    qr: {
        copiedToClipboard: "Копирано в клипборда",
        failedToCopy: "Неуспешно копиране в клипборда",
        scanWithYourMobile: " Сканирайте с мобилното си устройство",
        copyToClipboard: " Копирайте в клипборда",
        preferTheOfficial: "Предпочитан език за кореспонденция",
        open: "Отворете"
    }
};
var $f76789f9143a442d$var$bg = {
    modal: $f76789f9143a442d$var$modal$8
};
var $f76789f9143a442d$var$modal$7 = {
    wallet: {
        connectYourWallet: "지갑 연결하기",
        whatIsAWallet: "지갑은 무슨 역할을 하나요?",
        secureAndManage: "당신의 디지털 자산을 보호하고 관리합니다.",
        safelyStore: "암호화폐와 NFT를 안전하게 저장하고 전송할 수 있습니다.",
        logInToAny: "NEAR App에 로그인합니다.",
        noNeedToCreate: "새로운 계정이나 비밀번호를 만들 필요 없이 지갑을 연결한 후 바로 사용할 수 있습니다.",
        getAWallet: "지갑 가져오기",
        useAWallet: "지갑을 사용하여 NEAR 자산을 보호\xb7관리하고, 아이디와 비밀번호 없이 NEAR 앱에 로그인할 수 있습니다.",
        connectionFailed: "연결 실패",
        connectionSuccessful: "연결 성공",
        connected: "Connected",
        connectingTo: "연결 중: ",
        connectingMessage: {
            injected: "익스텐션 창에서 연결을 확인하세요",
            browser: "리다이렉트 된 지갑에서 연결을 확인하세요",
            hardware: "Ledger 기기에서 연결을 확인하세요",
            bridge: "지갑에서 연결 확인"
        }
    },
    ledger: {
        connectWithLedger: "Ledger 연결하기",
        makeSureYourLedger: "Ledger가 안전하게 연결되어 있고, NEAR 앱이 열려 있는 지 확인하세요",
        "continue": "계속하기",
        specifyHDPath: "HD Path 지정하기",
        enterYourPreferredHDPath: "원하는 HD Path를 선택하고, 활성화된 계정이 있는 지 검색하세요",
        scan: "검색",
        retry: "다시 시도",
        ledgerIsNotAvailable: "Ledger를 사용할 수 없습니다",
        accessDeniedToUseLedgerDevice: "Ledger 기기 접근 권한이 거부되었습니다",
        noAccountsFound: "계정을 찾을 수 없습니다",
        selectYourAccounts: "계정 선택하기",
        connecting1Account: "하나의 계정에 연결",
        cantFindAnyAccount: "Ledger와 연결된 계정을 찾을 수 없습니다. 새로운 계정을 생성하거나 ",
        orConnectAnAnotherLedger: "다른 Ledger를 연결하세요",
        connecting: "계정 연결하기: ",
        ofAccounts: "개 계정을 찾았습니다",
        failedToAutomatically: "계정 ID를 찾지 못했습니다. 수동으로 입력해주세요.",
        overviewTheListOfAuthorized: "인증된 계정 목록을 확인한 후 아래 버튼을 클릭하여 로그인을 완료하세요",
        finish: "완료"
    },
    install: {
        youllNeedToInstall: "다음 확장 프로그램을 설치해주세요:",
        toContinueAfterInstalling: ". 설치 완료 후 페이지 새로 고침이 필요합니다. ",
        refreshThePage: "새로 고침",
        open: "Open"
    },
    qr: {
        copiedToClipboard: "클립보드에 복사 완료",
        failedToCopy: "클립보드에 복사 실패",
        scanWithYourMobile: "모바일 장치를 사용하여 스캔해주세요",
        copyToClipboard: " 클립보드에 복사하기",
        preferTheOfficial: "다음 프로그램에서 제공하는 공식 프로세스를 선호하십니까: ",
        open: "Open"
    }
};
var $f76789f9143a442d$var$ko = {
    modal: $f76789f9143a442d$var$modal$7
};
var $f76789f9143a442d$var$modal$6 = {
    wallet: {
        connectYourWallet: "Kết nối v\xed của bạn",
        whatIsAWallet: "V\xed l\xe0 g\xec?",
        secureAndManage: "Bảo mật & Quản l\xfd t\xe0i sản số của bạn",
        safelyStore: "Lưu trữ v\xe0 chuyển tiền điện tử v\xe0 NFT của bạn một c\xe1ch an to\xe0n.",
        logInToAny: "Đăng nhập v\xe0o bất kỳ ứng dụng tr\xean NEAR",
        noNeedToCreate: "Kh\xf4ng cần tạo t\xe0i khoản hoặc th\xf4ng tin đăng nhập mới. Kết nối v\xed của bạn v\xe0 bắt đầu!",
        getAWallet: "Tạo V\xed",
        useAWallet: "Sử dụng v\xed để bảo mật v\xe0 quản l\xfd t\xe0i sản tr\xean NEAR của bạn v\xe0 đăng nhập v\xe0o bất kỳ ứng dụng NEAR n\xe0o, kh\xf4ng cần t\xean người d\xf9ng v\xe0 mật khẩu.",
        connectionFailed: "Kết nối thất bại",
        connectionSuccessful: "Kết nối th\xe0nh c\xf4ng",
        connected: "Đ\xe3 kết nối",
        connectingTo: "Đang kết nối tới",
        connectingMessage: {
            injected: "X\xe1c nhận kết nối trong cửa sổ tiện \xedch mở rộng",
            browser: "X\xe1c nhận kết nối trong v\xed sau khi được chuyển hướng",
            hardware: "X\xe1c nhận kết nối với v\xed lạnh",
            bridge: "X\xe1c nhận kết nối trong v\xed"
        }
    },
    ledger: {
        connectWithLedger: "Kết nối v\xed Ledger",
        makeSureYourLedger: "Đảm bảo Ledger của bạn được kết nối an to\xe0n v\xe0 ứng dụng NEAR đang mở sẵn tr\xean thiết bị",
        "continue": "Tiếp tục",
        specifyHDPath: "Chỉ định HD Path",
        enterYourPreferredHDPath: "Nhập HD Path của bạn, sau đ\xf3 qu\xe9t t\xecm c\xe1c t\xe0i khoản hoạt động",
        scan: "Qu\xe9t",
        retry: "Thử lại",
        ledgerIsNotAvailable: "Ledger kh\xf4ng khả dụng",
        accessDeniedToUseLedgerDevice: "Truy cập Ledger bị từ chối",
        noAccountsFound: "Kh\xf4ng t\xecm thấy t\xe0i khoản",
        selectYourAccounts: "Chọn t\xe0i khoản của bạn",
        connecting1Account: "Đang kết nối 1 t\xe0i khoản",
        cantFindAnyAccount: "Kh\xf4ng thể t\xecm thấy bất kỳ t\xe0i khoản n\xe0o được li\xean kết với Ledger n\xe0y. Vui l\xf2ng tạo một t\xe0i khoản NEAR mới",
        orConnectAnAnotherLedger: "hoặc kết nối với v\xed Ledger kh\xe1c.",
        connecting: "Đang kết nối",
        ofAccounts: "của t\xe0i khoản",
        failedToAutomatically: "Kh\xf4ng thể tự động t\xecm id t\xe0i khoản. Nhập thủ c\xf4ng:",
        overviewTheListOfAuthorized: "Tổng quan danh s\xe1ch c\xe1c t\xe0i khoản được ủy quyền, ho\xe0n tất đăng nhập bằng c\xe1ch bấm v\xe0o n\xfat b\xean dưới.",
        finish: "Ho\xe0n th\xe0nh"
    },
    install: {
        youllNeedToInstall: "Bạn sẽ cần c\xe0i đặt",
        toContinueAfterInstalling: "để bắt đầu. Sau khi c\xe0i đặt xong",
        refreshThePage: "Tải lại trang.",
        open: "Mở"
    },
    qr: {
        copiedToClipboard: "Đ\xe3 sao ch\xe9p v\xe0o bảng ghi tạm",
        failedToCopy: "Sao ch\xe9p v\xe0o bảng ghi tạm thất bại",
        scanWithYourMobile: "Qu\xe9t với điện thoại của bạn",
        copyToClipboard: " Sao ch\xe9p v\xe0o bảng ghi tạm",
        preferTheOfficial: "Dialogue ch\xednh thức của",
        open: "Mở"
    },
    exportAccounts: {
        chooseAWallet: "Chọn v\xed",
        transferYourAccounts: "Chuyển t\xe0i khoản",
        selectAWallet: "Chọn v\xed ph\xf9 hợp với nhu cầu của bạn, v\xed được chọn cần hỗ trợ c\xe1c t\xe0i khoản đang sử dụng.",
        selectYourAccounts: "Chọn t\xe0i khoản",
        afterDecide: "Sau khi chọn được t\xe0i khoản bạn c\xf3 chuyển.",
        disclaimer: "Bạn kh\xf4ng thể chuyển t\xe0i khoản nếu t\xe0i khoản đ\xf3 chưa được nhận tiền hoặc chưa ph\xe1t sinh giao dịch tr\xean NEAR.",
        warning: "kh\xf4ng hỗ trợ xuất t\xe0i khoản. Vui l\xf2ng chọn v\xed kh\xe1c.",
        walletTypes: {
            hardware: "V\xed lạnh",
            browser: "V\xed tr\xecnh duyệt",
            injected: "V\xed tiện \xedch mở rộng",
            bridge: "V\xed Cầu",
            mobile: "V\xed Mobile"
        },
        selectAccounts: {
            title: "Chọn t\xe0i khoản để chuyển",
            button: "Lấy cụm mật khẩu",
            deselectAll: "Bỏ chọn tất cả",
            selectAll: "Chọn tất cả",
            unavailable: "Chuyển kh\xf4ng khả dụng",
            error: "T\xe0i khoản kh\xf4ng tồn tại",
            warningLedger: "Y\xeau cầu hỗ trợ Ledger",
            noBalance: "T\xe0i khoản trống"
        },
        getPassphrase: {
            title: "Sao ch\xe9p mật khẩu tạm thời",
            desc: "Bạn sẽ cần nhập mật khẩu khi bắt đầu xuất c\xe1c khoản tới v\xed kh\xe1c.",
            button: "Tiếp tục",
            label: "Bấm để sao ch\xe9p",
            checkLabel: "T\xf4i đ\xe3 ch\xe9p hoặc ghi lại mật khẩu"
        },
        complete: {
            title: "Ho\xe0n th\xe0nh chuyển",
            descOne: "Bạn sẽ được chuyển hướng tới t\xe0i khoản đ\xe3 chọn để ho\xe0n tất qu\xe1 tr\xecnh.",
            descTwo: "Sau khi nhập, nhấn n\xfat để ho\xe0n tất quy tr\xecnh chuyển.",
            button: "Ho\xe0n th\xe0nh"
        }
    }
};
var $f76789f9143a442d$var$component = {
    clickToCopy: {
        label: "Đ\xe3 sao ch\xe9p",
        tooltip: "Bấm để sao ch\xe9p"
    }
};
var $f76789f9143a442d$var$vi = {
    modal: $f76789f9143a442d$var$modal$6,
    component: $f76789f9143a442d$var$component
};
var $f76789f9143a442d$var$modal$5 = {
    wallet: {
        connectYourWallet: "अपना वॉलेट (Wallet) कनेक्ट करें।",
        whatIsAWallet: "वॉलेट क्या है?",
        secureAndManage: "सुरक्षित और प्रबंधित करें।",
        safelyStore: "अपनी क्रिप्टोकरेंसी और एनएफटी को सुरक्षित रूप से स्टोर और ट्रांसफर करें।",
        logInToAny: "NEAR पर किसी भी ऐप में साइन इन करें।",
        noNeedToCreate: "नए खाते या लॉगिन बनाने की आवश्यकता नहीं है। अपना वॉलेट(NEAR Wallet)कनेक्ट करें और आरंभ करें।",
        getAWallet: "एक वॉलेट बनाएँ।",
        useAWallet: "अपनी NEAR संपत्तियों को सुरक्षित और प्रबंधित करने के लिए वॉलेट का उपयोग करें और किसी भी NEAR ऐप (app) में लॉग इन करें, किसी उपयोगकर्ता (user) नाम और पासवर्ड की आवश्यकता नहीं है।",
        connectionFailed: "कनेक्शन विफल|",
        connectionSuccessful: "कनेक्शन सफल|",
        connected: "वॉलेट जुड़ गया|",
        connectingTo: "वॉलेट जुड़ रहा हे|",
        connectingMessage: {
            injected: "एक्सटेंशन विंडो में कनेक्शन की पुष्टि करें|",
            browser: "रीडायरेक्ट होने के बाद वॉलेट में कनेक्शन की पुष्टि करें|",
            hardware: "कोल्ड वॉलेट के साथ कनेक्शन की पुष्टि करें|"
        }
    },
    ledger: {
        connectWithLedger: "लेजर(Ledger)वॉलेट कनेक्ट करें|",
        makeSureYourLedger: "सुनिश्चित करें कि आपका लेजर सुरक्षित रूप से जुड़ा हुआ है और NEAR ऐप आपके डिवाइस (Device)पर पहले से ही खुला है|",
        "continue": "जारी रखे|",
        specifyHDPath: "हार्ड डिस्क(Hard Disk)पथ(Path)निर्धारित करे|",
        enterYourPreferredHDPath: "अपना एचडी पथ दर्ज करें, फिर सक्रिय खातों के लिए स्कैन करें|",
        scan: "स्कैन करे|",
        retry: "दोबारा प्रयास करे|",
        ledgerIsNotAvailable: "लेजर उपलब्ध नहीं है|",
        accessDeniedToUseLedgerDevice: "लेजर डिवाइस का उपयोग करने के लिए प्रवेश निषेध|",
        noAccountsFound: "खाता नहीं मिला|",
        selectYourAccounts: "अपने खाते चुनें|",
        connecting1Account: "एक खाता कनेक्ट हो रहा है|",
        cantFindAnyAccount: "इस लेजर से जुड़ा कोई खाता नहीं मिला। कृपया एक नया NEAR खाता बनाएँ|",
        orConnectAnAnotherLedger: "अथवा दूसरे लेजर वॉलेट से कनेक्ट करें।",
        connecting: "जुड़ रहा हे|",
        ofAccounts: "खाता अब जुड़ा नहीं हे|",
        failedToAutomatically: "खाता आईडी स्वचालित रूप से खोजने में असमर्थ। मैन्युअल (Manuall) रूप से कोशिश करें|",
        overviewTheListOfAuthorized: "अवलोकन अधिकृत की सूची, नीचे दिए गए बटन पर क्लिक करके लॉगिन पूरा करें।",
        finish: "समाप्त|"
    },
    install: {
        youllNeedToInstall: "आपको इंस्टॉल करना होगा|",
        toContinueAfterInstalling: "इंस्टॉल करने के बाद जारी रखे|",
        refreshThePage: "पुन: लोड करें।",
        open: "खोले|"
    },
    qr: {
        copiedToClipboard: "क्लिपबोर्ड(Clipboard)पर कॉपी किया गया|",
        failedToCopy: "क्लिपबोर्ड पर कॉपी करना विफल रहा|",
        scanWithYourMobile: "अपने फोन (Mobile)से स्कैन करें|",
        copyToClipboard: " क्लिपबोर्ड पर कॉपी करें|",
        preferTheOfficial: "आधिकारिक संवाद को प्राथमिकता दें|",
        open: "खोले|"
    }
};
var $f76789f9143a442d$var$hi = {
    modal: $f76789f9143a442d$var$modal$5
};
var $f76789f9143a442d$var$modal$4 = {
    wallet: {
        connectYourWallet: "صل محفظتك",
        whatIsAWallet: "ما هي المحفظة؟",
        secureAndManage: "تأمين وإدارة الممتلكات الرقمية الخاصة بك",
        safelyStore: "قم بتخزين و ارسال عملاتك و أصولك الرقمية بأمان",
        logInToAny: "سجل الدخول إلى أي تطبيق يستخدم نير",
        noNeedToCreate: ".لا داعي لإنشاء حساب جديد. فقط قم بتوصيل محفظتك وانطلق",
        getAWallet: "احصل على محفظة",
        useAWallet: "استخدم محفظة لتأمين وإدارة أصول نير الخاصة بك، وادخل لأي تطبيق يستخدم نير دون الحاجة إلى اسم المستخدم وكلمةالمرور",
        connectionFailed: "اتصال فاشل",
        connectionSuccessful: "اتصال ناجح",
        connected: "متصل",
        connectingTo: "جاري الاتصال ب",
        connectingMessage: {
            injected: "وافق على الاتصال في نافذة الإضافة",
            browser: "وافق على الاتصال في المحفظة بعد إعادة توجيه",
            hardware: "وافق على الاتصال في جهاز ليدجر",
            bridge: "وافق على الاتصال في المحفظة"
        }
    },
    ledger: {
        connectWithLedger: "اتصل مع ليدجر",
        makeSureYourLedger: "تأكد أن ليدجر متصل بأمان, و أن تطبيق نير مفتوح في جهازك",
        "continue": "تابع",
        specifyHDPath: "حدد مسار الحساب",
        enterYourPreferredHDPath: "أدخل مسار الحساب المفضل، ثم ابحث عن كل الحسابات النشطة",
        scan: "مسح",
        retry: "أعد المحاولة",
        ledgerIsNotAvailable: "ليدجر غير متوفر",
        accessDeniedToUseLedgerDevice: "تم رفض الاتصال بليدجر",
        noAccountsFound: "لم يتم العثور على أي حسابات",
        selectYourAccounts: "حدد حساباتك",
        connecting1Account: "جاري الاتصال بحساب واحد",
        cantFindAnyAccount: "لا يمكن العثور على أي حساب مرتبط بهذا ليدجر الرجاء إنشاء حساب نير جديد على",
        orConnectAnAnotherLedger: "او اربط جهاز ليدجر آخر",
        connecting: "جاري الاتصال",
        ofAccounts: "من الحسابات",
        failedToAutomatically: "فشل في الاتصال بالحساب تلقائيا. يرجى الاتصال بالحساب يدويا",
        overviewTheListOfAuthorized: "لائحة الحسابات المصرح بها, أكمل تسجيل الدخول بالنقر على الزر أدناه",
        finish: "إنهاء"
    },
    install: {
        youllNeedToInstall: "ستحتاج لتثبيت",
        toContinueAfterInstalling: "للاستكمال. بعد التثبيت",
        refreshThePage: "قم بتحديث الصفحة",
        open: "افتح"
    },
    qr: {
        copiedToClipboard: "تم النسخ",
        failedToCopy: "فشل النسخ",
        scanWithYourMobile: "امسح بجهازك المحمول",
        copyToClipboard: "نسخ",
        preferTheOfficial: "تفضل الحوار الرسمي ل",
        open: "فتح"
    }
};
var $f76789f9143a442d$var$ar = {
    modal: $f76789f9143a442d$var$modal$4
};
var $f76789f9143a442d$var$modal$3 = {
    wallet: {
        connectYourWallet: "Spojite crypto novčanik!",
        whatIsAWallet: "Što je to crypto novčanik?",
        secureAndManage: "Osigurajte i upravljajte svojom digitalnom imovinom.",
        safelyStore: "Sigurno pohranite i prebacite svoj crypto i NFT-eve.",
        logInToAny: " Prijavite se u bilo koju NEAR aplikaciju",
        noNeedToCreate: "Nema potrebe za stvaranjem novih naloga ili korisničkih podataka. Spojite svoj crypto novčanik i spremni ste!",
        getAWallet: "Otvorite crypto novčanik",
        useAWallet: "Koristite crypto novčanik da biste osigurali i upravljali svojom NEAR imovinom, te se prijavite u bilo koju NEAR aplikaciju bez korisničkog imena i lozinke.",
        connectionFailed: "Neuspješno povezivanje.",
        connectionSuccessful: "Uspješno povezivanje.",
        connected: "Povezano.",
        connectingTo: "Povezivanje u tijeku",
        connectingMessage: {
            injected: "Potvrdite vezu u eksternom prozoru",
            browser: "Nakon redirekcije, potvrdite vezu u novčaniku",
            hardware: "Potvrdite vezu sa novčanikom",
            bridge: "Potvrdite vezu u novčaniku"
        }
    },
    ledger: {
        connectWithLedger: "Povežite se hardverskim novčanikom",
        makeSureYourLedger: "Osigurajte sigurnu vezu s hardverskim novčanikom, te da je NEAR aplikacija otvorena na vašem uređaju",
        "continue": "Nastavite",
        specifyHDPath: "Specificirajte HD putanju",
        enterYourPreferredHDPath: "Upišite preferiranu HD putanju, zatim skenirajte aktivne naloge",
        scan: "Skenirajte",
        retry: "Pokušajte ponovno",
        ledgerIsNotAvailable: "Hardverski novčanik nije dostupan.",
        accessDeniedToUseLedgerDevice: "Odbijen pristup za korištenjem hardverskog novčanika",
        noAccountsFound: "Nalozi nisu pronađeni",
        selectYourAccounts: "Odaberite svoje naloge",
        connecting1Account: "Povezivanje 1 naloga",
        cantFindAnyAccount: "Nije moguće pronaći niti jedan nalog povezan s ovim hardverskim novčanikom. Molimo vas, kreirajte novi NEAR nalog",
        orConnectAnAnotherLedger: "Ili povežite drugi hardverski novčanik.",
        connecting: "Povezivanje",
        ofAccounts: "naloga",
        failedToAutomatically: "Neuspješno automatsko pronalaženje ID naloga. Unesite ručno:",
        overviewTheListOfAuthorized: "Pregledajte popis odobrenih naloga, završite prijavu pritiskom na niže prikazani gumb.",
        finish: "Završite"
    },
    install: {
        youllNeedToInstall: " Potrebno je instalirati modal",
        toContinueAfterInstalling: "za nastavak. Nakon instalacije",
        refreshThePage: "osvježite stranicu.",
        open: "Otvorite QR modal"
    },
    qr: {
        copiedToClipboard: "Kopirano u međuspremnik",
        failedToCopy: "Neupsješno kopiranje u međuspremnik",
        scanWithYourMobile: "Skenirajte svojim mobilnim uređajem",
        copyToClipboard: " Kopirajte u međuspremnik",
        preferTheOfficial: "Odaberite službeni dijalog",
        open: "Otvorite"
    },
    exportAccounts: {
        chooseAWallet: "Odaberi Wallet",
        transferYourAccounts: "Prenesi svoje naloge",
        selectAWallet: "Odaberite wallet koji odgovara vašim potrebama i podržava vaše povezane naloge.",
        selectYourAccounts: "Odaberi svoje naloge",
        afterDecide: "Nakon što odlučite koji wallet koristite, možete odabrati koje račune želite prebaciti.",
        disclaimer: "Nećete moći prebaciti naloge koji nisu nikada bili korišteni na NEAR-u.",
        warning: "ne podržava izvoz naloga u ovom trenutku. Molimo odaberite drugi wallet.",
        walletTypes: {
            hardware: "Hardware Wallet",
            browser: "Browser Wallet",
            injected: "Wallet Extension",
            bridge: "Bridge Wallet",
            mobile: "Mobile Wallet"
        },
        selectAccounts: {
            title: "Odaberi naloge za prijenos",
            button: "Generiraj lozinku",
            deselectAll: "Makni odabir sa svih",
            selectAll: "Odaberi sve",
            unavailable: "Prijenos nije dostupan",
            error: "Nalog ne postoji",
            warningLedger: "Potrebna ledger podrška",
            noBalance: "Nalog nema sredstava"
        },
        getPassphrase: {
            title: "Kopiraj privremenu lozinku",
            desc: "Bit će potrebno unijeti ovu lozinku na početku izvoza naloga na drugi wallet.",
            button: "Nastavi",
            label: "Klikni za kopiju",
            checkLabel: "Kopirao sam ili zapisao lozinku"
        },
        complete: {
            title: "Završi prijenos",
            descOne: "You will now be redirected to the wallet you selected to complete the transfer.",
            descTwo: "Kada je unos s odabranog walleta završen, pritisnite gumb da biste završili prijenos.",
            button: "Završi"
        }
    }
};
var $f76789f9143a442d$var$hr = {
    modal: $f76789f9143a442d$var$modal$3
};
var $f76789f9143a442d$var$modal$2 = {
    wallet: {
        connectYourWallet: "Поврзете го вашиот новчаник!",
        whatIsAWallet: "Што е новчаник?",
        secureAndManage: "Заштитете ги и управувајте со вашите дигитални средства.",
        safelyStore: "Безбедно складирајте и извршувајте трансакции со вашите крипто и NFT.",
        logInToAny: "Најавете се на која било NEAR апликација",
        noNeedToCreate: "Нема потреба да креирате нови сметки или ингеренции. Поврзете го вашиот паричник и сте подготвени!",
        getAWallet: "Направете новчаник",
        useAWallet: "Користете паричник за да ги заштитите и управувате вашите NEAR средства и да се најавите на која било NEAR апликација без потреба од кориснички имиња и лозинки.",
        connectionFailed: "Поврзувањето не беше успешно.",
        connectionSuccessful: "Успешно поврзување.",
        connected: "Поврзано.",
        connectingTo: "Поврзување со",
        connectingMessage: {
            injected: "Потврдете го поврзувањето во екстерниот прозорец",
            browser: "По преусмерувањето, потврдете го поврзувањето од новчаниокт",
            hardware: "Потврдете го поврзувањето со ладен новчаник",
            bridge: "Потврдете ја врската во новчаникот"
        }
    },
    ledger: {
        connectWithLedger: "Поврзете се со Леџер",
        makeSureYourLedger: "Осигурајте се дека вашиот Леџер е поврзан безбедно, и дека NEAR апликацијата е отворена на вашиот уред",
        "continue": "Продолжете",
        specifyHDPath: "Наведете ХД локација",
        enterYourPreferredHDPath: "Внесете ја вашата преферирана ХД локација, а потоа скенирајте да ги најдете активните сметки.",
        scan: "Скенирајте",
        retry: "Обидете се повторно",
        ledgerIsNotAvailable: "Леџерот не е достапен.",
        accessDeniedToUseLedgerDevice: "Пристапот за користење на Леџер уред е одбиен",
        noAccountsFound: "Нема најдени сметки",
        selectYourAccounts: "Изберете ги вашите сметки",
        connecting1Account: "Поврзување на една сметка",
        cantFindAnyAccount: "Не се најдени сметки поврзани со овој Леџер. Ве молиме креирајте нова NEAR сметка ",
        orConnectAnAnotherLedger: "или поврзете друг Леџер.",
        connecting: "Поврзување",
        ofAccounts: "на сметки",
        failedToAutomatically: "Неуспешно автоматско барање на ИД на сметката. Внесете го рачно:",
        overviewTheListOfAuthorized: "Преглед на листата на овластени сметки, завршете се најавата со кликнување на копчето подолу.",
        finish: "Завршете"
    },
    install: {
        youllNeedToInstall: "Треба да инсталирате",
        toContinueAfterInstalling: "за да продолжите. По инсталирањето",
        refreshThePage: "Освежете ја страната.",
        open: "Отворете"
    },
    qr: {
        copiedToClipboard: "Копирано на клипбордот",
        failedToCopy: "Неуспешно копирање на клипборд",
        scanWithYourMobile: "Скенирајте со вашиот телефонски уред",
        copyToClipboard: "Копирајте на клипборд",
        preferTheOfficial: "Преферирајте официјален диалог на",
        open: "Отворете"
    },
    exportAccounts: {
        chooseAWallet: "Одберете паричник",
        transferYourAccounts: "Префрлете ги вашите кориснички сметки",
        selectAWallet: "Изберетен новчаник кој ги задоволува вашите баранња и ги поддржува вашите поврзани кориснички сметки.",
        selectYourAccounts: "Изберете ги вашите кориснички сметки",
        afterDecide: "Одкако ќе изберете новчаник, можете да изберете кои кориснички сметки сакате да ги префрлите.",
        disclaimer: "Не можете да прфрлате кориснички сметки кои никогаш не биле надополнати или користени на NEAR.",
        warning: "не поддржува извезување на кориснички сметки во овој момент. Ве молиме изберете друг новчаник.",
        walletTypes: {
            hardware: "Хардверски новчаник",
            browser: "Новчаник на интернет прелистувач",
            injected: "Екстензија за новчаник",
            bridge: "Bridge новчаник",
            mobile: "Мобилен новчаник"
        },
        selectAccounts: {
            title: "Изберете ги корисничките сметки за да ги префрлите.",
            button: "Добијте лозинка",
            deselectAll: "Отселектирајте се",
            selectAll: "Изберете се",
            unavailable: "Трансферот е недостапен",
            error: "Корисничката сметка не постои",
            warningLedger: "Потребна е поддршка од Леџер",
            noBalance: "Сметката не е финансирана"
        },
        getPassphrase: {
            title: "Копирајте ја привремената лозинка",
            desc: "Ќе треба да ја внесете оваа лозинка кога ќе започнете да ги извезувате вашите сметки на друг новчаник.",
            button: "Продолжете",
            label: "Кликнете за да копирате",
            checkLabel: "Ја копирав или запишав лозинката"
        },
        complete: {
            title: "Завршете го преносот",
            descOne: "Сега ќе бидете пренасочени на избраниот новчаник за завршување на преносот.",
            descTwo: "Откако ќе заврши увозот од избраниот новчаник, притиснете го копчето за да го завршите преносот.",
            button: "Завршете"
        }
    }
};
var $f76789f9143a442d$var$mk = {
    modal: $f76789f9143a442d$var$modal$2
};
var $f76789f9143a442d$var$modal$1 = {
    wallet: {
        connectYourWallet: "Povežite svojo denarnico!",
        whatIsAWallet: "Kaj je denarnica?",
        secureAndManage: "Zavarujte in upravljajte svoja digitalna sredstva.",
        safelyStore: "Varno shranjujte in prenašajte svoje kriptovalute in NFTje.",
        logInToAny: "Prijavite se v katero koli aplikacijo na NEAR",
        noNeedToCreate: "Ni vam treba ustvarjati novih računov. Povežite svojo denarnico in začnite!",
        getAWallet: "Ustvarite denarnico",
        useAWallet: "Uporabite denarnico, da bi zavarovali in upravljali s svoja NEAR digitalna sredstva, in se prijavite v katero koli aplikacijo ekosistema NEAR",
        connectionFailed: "Povezava ni bila uspešna.",
        connectionSuccessful: "Povezava je bila uspešna.",
        connected: "Vaša denarnica je povezana.",
        connectingTo: "Povezovanje z",
        connectingMessage: {
            injected: "Potrdite povezavo v oknu razširitve",
            browser: "Po preusmeritvi potrdite povezavo v denarnici",
            hardware: "Potrdite povezavo s hladno denarnico",
            bridge: "Potrdite povezavo v denarnici"
        }
    },
    ledger: {
        connectWithLedger: "Povežite se z Ledger",
        makeSureYourLedger: "Prepričajte se, da je vaš Ledger varno povezan in da je aplikacija NEAR odprta v vaši napravi",
        "continue": "Nadaljuj",
        specifyHDPath: "Določite HD pot",
        enterYourPreferredHDPath: "Vnesite želeno HD pot, nato poiščite vse aktivne račune.",
        scan: "Skenirajte",
        retry: "Poskusite znova",
        ledgerIsNotAvailable: "Ledger ni na voljo",
        accessDeniedToUseLedgerDevice: "Dostop za uporabo naprave Ledger zavrnjen",
        noAccountsFound: "Ni najdenih računov",
        selectYourAccounts: "Izberite Vaši računi",
        connecting1Account: "Povezovanje enega računa",
        cantFindAnyAccount: "Ni mogoče najti nobenega računa, povezanega s tem Ledgerjem. Ustvarite nov NEAR račun ",
        orConnectAnAnotherLedger: "ali povežite drug Ledger..",
        connecting: "Povezovanje",
        ofAccounts: "računov",
        failedToAutomatically: "ID-ja računa ni bilo mogoče samodejno najti. Zagotovite ga ročno:",
        overviewTheListOfAuthorized: "Oglejte si seznam pooblaščenih računov, dokončajte prijavo s klikom na spodnji gumb.",
        finish: "Končajte"
    },
    install: {
        youllNeedToInstall: "Morali ga boste namestiti",
        toContinueAfterInstalling: "nadaljevati. Po namestitvi",
        refreshThePage: "Osvežite stran.",
        open: "Odprite"
    },
    qr: {
        copiedToClipboard: "Kopirano v podložni mapi",
        failedToCopy: "Kopiranje v podložni mapi ni uspelo",
        scanWithYourMobile: "Skenirajte s svojo mobilno napravo",
        copyToClipboard: " Kopirajte v podložni mapi",
        preferTheOfficial: "Preferirajte uradno pogovorno okno",
        open: "Odprite"
    },
    exportAccounts: {
        chooseAWallet: "Izberite denarnico",
        transferYourAccounts: "Prenesite svoje račune",
        selectAWallet: "Izberite denarnico, ki ustreza vašim potrebam in podpira vaše povezane račune.",
        selectYourAccounts: "Izberite vaši računi",
        afterDecide: "Ko se odločite za denarnico, lahko izberete, katere račune želite prenesti.",
        disclaimer: "Ne boste mogli prenesti Računov, ki nikoli niso bili financirani ali uporabljeni na NEAR.",
        warning: "trenutno ne podpira izvoza računa. Izberite drugo denarnico",
        walletTypes: {
            hardware: "Hladna denarnica",
            browser: "Denarnica brskalnika",
            injected: "Razširitev za denarnico",
            bridge: "Bridge denarnica",
            mobile: "Mobilna denarnica"
        },
        selectAccounts: {
            title: "Izberite računi za prenos.",
            button: "Pridobite geslo",
            deselectAll: "Prekliči izbiro vseh",
            selectAll: "Izberi vse",
            unavailable: "Prenos ni na voljo",
            error: "Račun ne obstaja",
            warningLedger: "Potrebna je podpora za Ledger",
            noBalance: "Račun ni financiran"
        },
        getPassphrase: {
            title: "Kopiraj začasno geslo",
            desc: "To geslo boste morali vnesti, ko boste začeli izvažati svoje račune v drugo denarnico.",
            button: "Nadaljujte",
            label: "Kliknite za kopiranje",
            checkLabel: "Geslo sem kopiral ali zapisal"
        },
        complete: {
            title: "Dokončajte prenos",
            descOne: "Zdaj boste preusmerjeni v denarnico, ki ste jo izbrali za dokončanje prenosa.",
            descTwo: "Ko je uvozni del postopka končan iz izbrane denarnice, pritisnite gumb za dokončanje postopka prenosa.",
            button: "Končajte"
        }
    }
};
var $f76789f9143a442d$var$sl = {
    modal: $f76789f9143a442d$var$modal$1
};
var $f76789f9143a442d$var$modal = {
    wallet: {
        connectYourWallet: "Повежите свој новчаник!",
        whatIsAWallet: "Шта је новчаник?",
        secureAndManage: "Обезбедите и управљајте својом дигиталном имовином.",
        safelyStore: "Безбедно чувајте и преносите своје криптовалуте и NFT.",
        logInToAny: "Пријавите се на било коју апликацију NEAR",
        noNeedToCreate: "Нема потребе да креирате нове налоге или акредитиве. Повежите новчаник и спремни стe!",
        getAWallet: "Набавите новчаник",
        useAWallet: "Користите новчаник да обезбедите и управљате својим NEAR средствима и да се пријавите у било коју апликацију NEAR без потребе за корисничким именима и лозинкама.",
        connectionFailed: "Веза није успостављена.",
        connectionSuccessful: "Веза је успела.",
        connected: "Повезан.",
        connectingTo: "Повезивање на",
        connectingMessage: {
            injected: "Потврдите везу у спољном прозору",
            browser: "Након преусмеравања, потврдите везу у новчанику",
            hardware: "Потврдите везу са хладним новчаником",
            bridge: "Потврдите везу са новчаником"
        }
    },
    ledger: {
        connectWithLedger: "Повежите се са Ledger",
        makeSureYourLedger: "Уверите се да је ваш Ledger безбедно повезан и да је апликација NEAR отворена на вашем уређају",
        "continue": "Настави",
        specifyHDPath: "Наведите ХД путању",
        enterYourPreferredHDPath: "Унесите жељену жељену ХД путању, а затим скенирајте све активне налоге.",
        scan: "Скенирајте",
        retry: "Покушај поново",
        ledgerIsNotAvailable: "Ledger није доступан.",
        accessDeniedToUseLedgerDevice: "Приступ је одбијен за коришћење Ledger уређаја",
        noAccountsFound: "Наlози нису пронађени",
        selectYourAccounts: "Изаберите Ваш наlог",
        connecting1Account: "Повезати 1 наlог",
        cantFindAnyAccount: "Није могуће пронаћи ниједан наlог повезан са овим Ledger-ом. Направите нови NEAR наlог",
        orConnectAnAnotherLedger: "или повежите други Ledger.",
        connecting: "Повезивање",
        ofAccounts: "наlога",
        failedToAutomatically: "Аутоматско проналажење ID-a наlога није успело. Наведите га ручно:",
        overviewTheListOfAuthorized: "Прегледајте листу овлашћених рачуна, завршите пријаву кликом на дугме испод.",
        finish: "Заврши"
    },
    install: {
        youllNeedToInstall: "Мораћете да инсталирате",
        toContinueAfterInstalling: "за наставак. Након инсталирања",
        refreshThePage: "поново учитати страницу.",
        open: "Отвори"
    },
    qr: {
        copiedToClipboard: "Копирано у међуспремник",
        failedToCopy: "Копирање у међуспремник није успело",
        scanWithYourMobile: "Скенирајте помоћу мобилног уређаја",
        copyToClipboard: " Копирај у међуспремник",
        preferTheOfficial: "Преферирате званични дијалог од",
        open: "Отвори"
    },
    exportAccounts: {
        chooseAWallet: "Изаберите новчаник",
        transferYourAccounts: "Пренесите своје налоге",
        selectAWallet: "Изаберите новчаник који одговара вашим потребама и који подржава ваше повезане налоге.",
        selectYourAccounts: "Изаберите ваше налоге",
        afterDecide: "Након што се одлучите за новчаник, можете изабрати које налоге желите да пренесете.",
        disclaimer: "Нећете моћи да пренесете налоге који никада нису били финансирани или коришћени на  NEAR.",
        warning: "тренутно не подржава извоз налога. Изаберите други новчаник.",
        walletTypes: {
            hardware: "Хардверски новчаник",
            browser: "Новчаник претраживача,",
            injected: "Додатак за новчаник,",
            bridge: "Bridge новчаник",
            mobile: "Мобилни новчаник"
        },
        selectAccounts: {
            title: "Изаберите налоге за пренос.",
            button: "Добијте приступну фразу",
            deselectAll: "Поништите избор",
            selectAll: "Изаберите све",
            unavailable: "Трансфер није доступан",
            error: "Налог не постоји",
            warningLedger: "Потребна подршка за Ledger",
            noBalance: "Налог није финансиран"
        },
        getPassphrase: {
            title: "Копирај привремену лозинку",
            desc: "Мораћете да унесете ову лозинку када почнете да извозите своје налоге у други новчаник.",
            button: "Наставите",
            label: "Кликните да бисте копирали",
            checkLabel: "Копирао сам или записао лозинку"
        },
        complete: {
            title: "Довршите трансфер",
            descOne: "Сада ћете бити преусмерени на новчаник који сте изабрали да завршите трансфер.",
            descTwo: "Када се део процеса увоза заврши из изабраног новчаника, притисните дугме да завршите процес преноса.",
            button: "Завршите"
        }
    }
};
var $f76789f9143a442d$var$sr = {
    modal: $f76789f9143a442d$var$modal
};
var $f76789f9143a442d$var$getLanguage = function(languageCode) {
    switch(languageCode){
        case "en":
            return $f76789f9143a442d$var$en;
        case "es":
            return $f76789f9143a442d$var$es;
        case "zh":
            return $f76789f9143a442d$var$zh;
        case "bg":
            return $f76789f9143a442d$var$bg;
        case "ko":
            return $f76789f9143a442d$var$ko;
        case "vi":
            return $f76789f9143a442d$var$vi;
        case "hi":
            return $f76789f9143a442d$var$hi;
        case "ar":
            return $f76789f9143a442d$var$ar;
        case "hr":
            return $f76789f9143a442d$var$hr;
        case "mk":
            return $f76789f9143a442d$var$mk;
        case "sl":
            return $f76789f9143a442d$var$sl;
        case "sr":
            return $f76789f9143a442d$var$sr;
        default:
            return $f76789f9143a442d$var$en;
    }
};
var $f76789f9143a442d$var$chosenLang;
var $f76789f9143a442d$export$b162ef060a488de1 = function(langCode) {
    $f76789f9143a442d$var$chosenLang = langCode;
}; // (i.e en-CA returns just en)
var $f76789f9143a442d$var$shortenLanguageCode = function(lang) {
    return lang.indexOf("-") !== -1 ? lang.split("-")[0] : lang.split("_")[0];
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $f76789f9143a442d$var$findObjectPropByStringPath = function(obj, prop) {
    if (!obj) return "";
    var _index = prop.indexOf(".");
    if (_index > -1) {
        var currentProp = prop.substring(0, _index);
        var nextProp = prop.substring(_index + 1);
        return $f76789f9143a442d$var$findObjectPropByStringPath(obj[currentProp], nextProp);
    }
    return obj[prop];
};
var $f76789f9143a442d$export$d73ee8ef04f5226a = function(path) {
    var browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
    browserLang = browserLang || window.navigator.language;
    var languageCode = $f76789f9143a442d$var$shortenLanguageCode($f76789f9143a442d$var$chosenLang || browserLang);
    var selectedLanguage = $f76789f9143a442d$var$getLanguage(languageCode);
    var text = $f76789f9143a442d$var$findObjectPropByStringPath(selectedLanguage, path);
    return text && typeof text === "string" ? text : path;
};


var $bd06a26ec61d7200$exports = {};

$parcel$export($bd06a26ec61d7200$exports, "create", function () { return $bd06a26ec61d7200$export$185802fd694ee1f5; }, function (v) { return $bd06a26ec61d7200$export$185802fd694ee1f5 = v; });
$parcel$export($bd06a26ec61d7200$exports, "toCanvas", function () { return $bd06a26ec61d7200$export$f87f6982d1fd4f81; }, function (v) { return $bd06a26ec61d7200$export$f87f6982d1fd4f81 = v; });
$parcel$export($bd06a26ec61d7200$exports, "toDataURL", function () { return $bd06a26ec61d7200$export$723e4939e5a27c8; }, function (v) { return $bd06a26ec61d7200$export$723e4939e5a27c8 = v; });
$parcel$export($bd06a26ec61d7200$exports, "toString", function () { return $bd06a26ec61d7200$export$f84e8e69fd4488a5; }, function (v) { return $bd06a26ec61d7200$export$f84e8e69fd4488a5 = v; });
var $bd06a26ec61d7200$export$185802fd694ee1f5;
var $bd06a26ec61d7200$export$f87f6982d1fd4f81;
var $bd06a26ec61d7200$export$723e4939e5a27c8;
// only svg for now.
var $bd06a26ec61d7200$export$f84e8e69fd4488a5;
var $b73a36ac15193987$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$b73a36ac15193987$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $3319eb7ae8834973$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $91b70b00ef4849e5$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $91b70b00ef4849e5$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $91b70b00ef4849e5$export$ed1d66da50968976;
var $91b70b00ef4849e5$export$6733b14783f975c2;
var $91b70b00ef4849e5$export$ce5b1274f8597fa0;
var $91b70b00ef4849e5$export$43dd553ecded716d;
var $91b70b00ef4849e5$var$toSJISFunction;
var $91b70b00ef4849e5$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$91b70b00ef4849e5$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$91b70b00ef4849e5$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $91b70b00ef4849e5$var$CODEWORDS_COUNT[version];
};
$91b70b00ef4849e5$export$ed1d66da50968976 = function(data) {
    var digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$91b70b00ef4849e5$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $91b70b00ef4849e5$var$toSJISFunction = f;
};
$91b70b00ef4849e5$export$ce5b1274f8597fa0 = function() {
    return typeof $91b70b00ef4849e5$var$toSJISFunction !== "undefined";
};
$91b70b00ef4849e5$export$43dd553ecded716d = function toSJIS(kanji) {
    return $91b70b00ef4849e5$var$toSJISFunction(kanji);
};


var $f2d93ad39ba01363$export$61196ced6d74a310;
var $f2d93ad39ba01363$export$3a1a48c8f6ef640e;
var $f2d93ad39ba01363$export$3722cfe417b6ed86;
var $f2d93ad39ba01363$export$7f8ddf7c7c20b3cd;
var $f2d93ad39ba01363$export$1ea939691cdc45b8;
var $f2d93ad39ba01363$export$6788812c4e6611e6;
$f2d93ad39ba01363$export$61196ced6d74a310 = {
    bit: 1
};
$f2d93ad39ba01363$export$3a1a48c8f6ef640e = {
    bit: 0
};
$f2d93ad39ba01363$export$3722cfe417b6ed86 = {
    bit: 3
};
$f2d93ad39ba01363$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $f2d93ad39ba01363$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $f2d93ad39ba01363$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $f2d93ad39ba01363$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $f2d93ad39ba01363$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $f2d93ad39ba01363$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$f2d93ad39ba01363$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$f2d93ad39ba01363$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($f2d93ad39ba01363$export$1ea939691cdc45b8(value)) return value;
    try {
        return $f2d93ad39ba01363$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $5b576ab2f91c3645$exports = {};
function $5b576ab2f91c3645$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$5b576ab2f91c3645$var$BitBuffer.prototype = {
    get: function get(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function put(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function getLengthInBits() {
        return this.length;
    },
    putBit: function putBit(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$5b576ab2f91c3645$exports = $5b576ab2f91c3645$var$BitBuffer;


var $6f7e62055eb89743$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $6f7e62055eb89743$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $6f7e62055eb89743$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    var index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $6f7e62055eb89743$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $6f7e62055eb89743$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $6f7e62055eb89743$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$6f7e62055eb89743$exports = $6f7e62055eb89743$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $e590660599ef74da$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $e590660599ef74da$export$c39457c570f2b189;

var $e590660599ef74da$require$getSymbolSize = $91b70b00ef4849e5$export$8d4a06d3facd414b;
$e590660599ef74da$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    var posCount = Math.floor(version / 7) + 2;
    var size = $e590660599ef74da$require$getSymbolSize(version);
    var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    var positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(var i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$e590660599ef74da$export$c39457c570f2b189 = function getPositions(version) {
    var coords = [];
    var pos = $e590660599ef74da$export$cb05537eb8e57a83(version);
    var posLength = pos.length;
    for(var i = 0; i < posLength; i++)for(var j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $4e4647eb2501fb02$export$c39457c570f2b189;

var $4e4647eb2501fb02$require$getSymbolSize = $91b70b00ef4849e5$export$8d4a06d3facd414b;
var $4e4647eb2501fb02$var$FINDER_PATTERN_SIZE = 7;
$4e4647eb2501fb02$export$c39457c570f2b189 = function getPositions(version) {
    var size = $4e4647eb2501fb02$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $4e4647eb2501fb02$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $4e4647eb2501fb02$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $3e4d8fba3b31e16e$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $3e4d8fba3b31e16e$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $3e4d8fba3b31e16e$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $3e4d8fba3b31e16e$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $3e4d8fba3b31e16e$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $3e4d8fba3b31e16e$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $3e4d8fba3b31e16e$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $3e4d8fba3b31e16e$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $3e4d8fba3b31e16e$export$fe9625aaceb0e563;
$3e4d8fba3b31e16e$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ var $3e4d8fba3b31e16e$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$3e4d8fba3b31e16e$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$3e4d8fba3b31e16e$export$6788812c4e6611e6 = function from(value) {
    return $3e4d8fba3b31e16e$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$3e4d8fba3b31e16e$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    var size = data.size;
    var points = 0;
    var sameCountCol = 0;
    var sameCountRow = 0;
    var lastCol = null;
    var lastRow = null;
    for(var row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(var col = 0; col < size; col++){
            var module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $3e4d8fba3b31e16e$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $3e4d8fba3b31e16e$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $3e4d8fba3b31e16e$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $3e4d8fba3b31e16e$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$3e4d8fba3b31e16e$export$9a9385107a518e46 = function getPenaltyN2(data) {
    var size = data.size;
    var points = 0;
    for(var row = 0; row < size - 1; row++)for(var col = 0; col < size - 1; col++){
        var last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $3e4d8fba3b31e16e$var$PenaltyScores.N2;
};
$3e4d8fba3b31e16e$export$ade754353f0dc75e = function getPenaltyN3(data) {
    var size = data.size;
    var points = 0;
    var bitsCol = 0;
    var bitsRow = 0;
    for(var row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(var col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $3e4d8fba3b31e16e$var$PenaltyScores.N3;
};
$3e4d8fba3b31e16e$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    var darkCount = 0;
    var modulesCount = data.data.length;
    for(var i = 0; i < modulesCount; i++)darkCount += data.data[i];
    var k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $3e4d8fba3b31e16e$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $3e4d8fba3b31e16e$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $3e4d8fba3b31e16e$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$3e4d8fba3b31e16e$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    var size = data.size;
    for(var col = 0; col < size; col++)for(var row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $3e4d8fba3b31e16e$var$getMaskAt(pattern, row, col));
    }
};
$3e4d8fba3b31e16e$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    var numPatterns = Object.keys($3e4d8fba3b31e16e$export$7ed115685df827af).length;
    var bestPattern = 0;
    var lowerPenalty = Infinity;
    for(var p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $3e4d8fba3b31e16e$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        var penalty = $3e4d8fba3b31e16e$export$a5fd3a02c14d0b3e(data) + $3e4d8fba3b31e16e$export$9a9385107a518e46(data) + $3e4d8fba3b31e16e$export$ade754353f0dc75e(data) + $3e4d8fba3b31e16e$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $3e4d8fba3b31e16e$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $888305abe744009c$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $888305abe744009c$export$683d1b3e8a1a8438;

var $888305abe744009c$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
var $888305abe744009c$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$888305abe744009c$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $f2d93ad39ba01363$export$61196ced6d74a310:
            return $888305abe744009c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $f2d93ad39ba01363$export$3a1a48c8f6ef640e:
            return $888305abe744009c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $f2d93ad39ba01363$export$3722cfe417b6ed86:
            return $888305abe744009c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $f2d93ad39ba01363$export$7f8ddf7c7c20b3cd:
            return $888305abe744009c$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$888305abe744009c$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $f2d93ad39ba01363$export$61196ced6d74a310:
            return $888305abe744009c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $f2d93ad39ba01363$export$3a1a48c8f6ef640e:
            return $888305abe744009c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $f2d93ad39ba01363$export$3722cfe417b6ed86:
            return $888305abe744009c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $f2d93ad39ba01363$export$7f8ddf7c7c20b3cd:
            return $888305abe744009c$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $11c1a4bb9250d739$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $df172abafacec8fc$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $df172abafacec8fc$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $df172abafacec8fc$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $4748d83c25e429b5$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $4748d83c25e429b5$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $4748d83c25e429b5$export$6e3a27864ab166fe;
var $4748d83c25e429b5$var$EXP_TABLE = new Uint8Array(512);
var $4748d83c25e429b5$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    var x = 1;
    for(var i = 0; i < 255; i++){
        $4748d83c25e429b5$var$EXP_TABLE[i] = x;
        $4748d83c25e429b5$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(var i1 = 255; i1 < 512; i1++)$4748d83c25e429b5$var$EXP_TABLE[i1] = $4748d83c25e429b5$var$EXP_TABLE[i1 - 255];
})();
$4748d83c25e429b5$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $4748d83c25e429b5$var$LOG_TABLE[n];
};
$4748d83c25e429b5$export$b310ec824aaee37f = function exp(n) {
    return $4748d83c25e429b5$var$EXP_TABLE[n];
};
$4748d83c25e429b5$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $4748d83c25e429b5$var$EXP_TABLE[$4748d83c25e429b5$var$LOG_TABLE[x] + $4748d83c25e429b5$var$LOG_TABLE[y]];
};


$df172abafacec8fc$export$6e3a27864ab166fe = function mul(p1, p2) {
    var coeff = new Uint8Array(p1.length + p2.length - 1);
    for(var i = 0; i < p1.length; i++)for(var j = 0; j < p2.length; j++)coeff[i + j] ^= $4748d83c25e429b5$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$df172abafacec8fc$export$842a2cf37af977e1 = function mod(divident, divisor) {
    var result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        var coeff = result[0];
        for(var i = 0; i < divisor.length; i++)result[i] ^= $4748d83c25e429b5$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        var offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$df172abafacec8fc$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    var poly = new Uint8Array([
        1
    ]);
    for(var i = 0; i < degree; i++)poly = $df172abafacec8fc$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $4748d83c25e429b5$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $11c1a4bb9250d739$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $11c1a4bb9250d739$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $df172abafacec8fc$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $11c1a4bb9250d739$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    var paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    var remainder = $df172abafacec8fc$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    var start = this.degree - remainder.length;
    if (start > 0) {
        var buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$11c1a4bb9250d739$exports = $11c1a4bb9250d739$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $3c55842392f94f78$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $3c55842392f94f78$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $3c55842392f94f78$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $3c55842392f94f78$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $6ecff0b042f3add8$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $6ecff0b042f3add8$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $6ecff0b042f3add8$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $6ecff0b042f3add8$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $6ecff0b042f3add8$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $6ecff0b042f3add8$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $6ecff0b042f3add8$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $6ecff0b042f3add8$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $6ecff0b042f3add8$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $6ecff0b042f3add8$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $9fe02221267fe1d5$export$1ea939691cdc45b8;
$9fe02221267fe1d5$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $bfa5338121561471$export$a4d452c2363c8e12;
var $bfa5338121561471$export$9df7c29d562bab83;
var $bfa5338121561471$export$8f4bf8f7eb581284;
var $bfa5338121561471$export$4d318981b5a83836;
var $bfa5338121561471$export$376a9ed239d6c1c8;
var $bfa5338121561471$export$175f16aef75a4569;
var $bfa5338121561471$export$50b7f9bf92c74274;
var $bfa5338121561471$export$4ba5f52893b4ac97;
var $bfa5338121561471$var$numeric = "[0-9]+";
var $bfa5338121561471$var$alphanumeric = "[A-Z $%*+\\-./:]+";
var $bfa5338121561471$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$bfa5338121561471$var$kanji = $bfa5338121561471$var$kanji.replace(/u/g, "\\u");
var $bfa5338121561471$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $bfa5338121561471$var$kanji + ")(?:.|[\r\n]))+";
$bfa5338121561471$export$a4d452c2363c8e12 = new RegExp($bfa5338121561471$var$kanji, "g");
$bfa5338121561471$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$bfa5338121561471$export$8f4bf8f7eb581284 = new RegExp($bfa5338121561471$var$byte, "g");
$bfa5338121561471$export$4d318981b5a83836 = new RegExp($bfa5338121561471$var$numeric, "g");
$bfa5338121561471$export$376a9ed239d6c1c8 = new RegExp($bfa5338121561471$var$alphanumeric, "g");
var $bfa5338121561471$var$TEST_KANJI = new RegExp("^" + $bfa5338121561471$var$kanji + "$");
var $bfa5338121561471$var$TEST_NUMERIC = new RegExp("^" + $bfa5338121561471$var$numeric + "$");
var $bfa5338121561471$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$bfa5338121561471$export$175f16aef75a4569 = function testKanji(str) {
    return $bfa5338121561471$var$TEST_KANJI.test(str);
};
$bfa5338121561471$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $bfa5338121561471$var$TEST_NUMERIC.test(str);
};
$bfa5338121561471$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $bfa5338121561471$var$TEST_ALPHANUMERIC.test(str);
};


$6ecff0b042f3add8$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$6ecff0b042f3add8$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$6ecff0b042f3add8$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$6ecff0b042f3add8$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$6ecff0b042f3add8$export$bb410559a65d3418 = {
    bit: -1
};
$6ecff0b042f3add8$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$9fe02221267fe1d5$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$6ecff0b042f3add8$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($bfa5338121561471$export$50b7f9bf92c74274(dataStr)) return $6ecff0b042f3add8$export$4d318981b5a83836;
    else if ($bfa5338121561471$export$4ba5f52893b4ac97(dataStr)) return $6ecff0b042f3add8$export$376a9ed239d6c1c8;
    else if ($bfa5338121561471$export$175f16aef75a4569(dataStr)) return $6ecff0b042f3add8$export$a4d452c2363c8e12;
    else return $6ecff0b042f3add8$export$8f4bf8f7eb581284;
};
$6ecff0b042f3add8$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$6ecff0b042f3add8$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $6ecff0b042f3add8$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $6ecff0b042f3add8$export$4d318981b5a83836;
        case "alphanumeric":
            return $6ecff0b042f3add8$export$376a9ed239d6c1c8;
        case "kanji":
            return $6ecff0b042f3add8$export$a4d452c2363c8e12;
        case "byte":
            return $6ecff0b042f3add8$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$6ecff0b042f3add8$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($6ecff0b042f3add8$export$1ea939691cdc45b8(value)) return value;
    try {
        return $6ecff0b042f3add8$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
var $3c55842392f94f78$var$G18 = 7973;
var $3c55842392f94f78$var$G18_BCH = $91b70b00ef4849e5$export$ed1d66da50968976($3c55842392f94f78$var$G18);
function $3c55842392f94f78$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $3c55842392f94f78$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $3c55842392f94f78$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $6ecff0b042f3add8$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $3c55842392f94f78$var$getTotalBitsFromDataArray(segments, version) {
    var totalBits = 0;
    segments.forEach(function(data) {
        var reservedBits = $3c55842392f94f78$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $3c55842392f94f78$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        var length = $3c55842392f94f78$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $3c55842392f94f78$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $6ecff0b042f3add8$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$3c55842392f94f78$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($9fe02221267fe1d5$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$3c55842392f94f78$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$9fe02221267fe1d5$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $6ecff0b042f3add8$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = $91b70b00ef4849e5$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    var ecTotalCodewords = $888305abe744009c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $6ecff0b042f3add8$export$bb410559a65d3418) return dataTotalCodewordsBits;
    var usableBits = dataTotalCodewordsBits - $3c55842392f94f78$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $6ecff0b042f3add8$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $6ecff0b042f3add8$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $6ecff0b042f3add8$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $6ecff0b042f3add8$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$3c55842392f94f78$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    var seg;
    var ecl = $f2d93ad39ba01363$export$6788812c4e6611e6(errorCorrectionLevel, $f2d93ad39ba01363$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $3c55842392f94f78$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $3c55842392f94f78$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$3c55842392f94f78$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$9fe02221267fe1d5$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    var d = version << 12;
    while($91b70b00ef4849e5$export$ed1d66da50968976(d) - $3c55842392f94f78$var$G18_BCH >= 0)d ^= $3c55842392f94f78$var$G18 << $91b70b00ef4849e5$export$ed1d66da50968976(d) - $3c55842392f94f78$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $9d060ba00c05a6bf$export$eee5438974ef6f0e;

var $9d060ba00c05a6bf$var$G15 = 1335;
var $9d060ba00c05a6bf$var$G15_MASK = 21522;
var $9d060ba00c05a6bf$var$G15_BCH = $91b70b00ef4849e5$export$ed1d66da50968976($9d060ba00c05a6bf$var$G15);
$9d060ba00c05a6bf$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    var data = errorCorrectionLevel.bit << 3 | mask;
    var d = data << 10;
    while($91b70b00ef4849e5$export$ed1d66da50968976(d) - $9d060ba00c05a6bf$var$G15_BCH >= 0)d ^= $9d060ba00c05a6bf$var$G15 << $91b70b00ef4849e5$export$ed1d66da50968976(d) - $9d060ba00c05a6bf$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $9d060ba00c05a6bf$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $1ee923f113ae2d07$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $1ee923f113ae2d07$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $1ee923f113ae2d07$export$89ab1afb9839589b;

var $b75db9eb8aec2f26$exports = {};

function $b75db9eb8aec2f26$var$NumericData(data) {
    this.mode = $6ecff0b042f3add8$export$4d318981b5a83836;
    this.data = data.toString();
}
$b75db9eb8aec2f26$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$b75db9eb8aec2f26$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b75db9eb8aec2f26$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $b75db9eb8aec2f26$var$NumericData.getBitsLength(this.data.length);
};
$b75db9eb8aec2f26$var$NumericData.prototype.write = function write(bitBuffer) {
    var i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    var remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$b75db9eb8aec2f26$exports = $b75db9eb8aec2f26$var$NumericData;


var $23b6d5fc178f337b$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ var $23b6d5fc178f337b$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $23b6d5fc178f337b$var$AlphanumericData(data) {
    this.mode = $6ecff0b042f3add8$export$376a9ed239d6c1c8;
    this.data = data;
}
$23b6d5fc178f337b$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$23b6d5fc178f337b$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$23b6d5fc178f337b$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $23b6d5fc178f337b$var$AlphanumericData.getBitsLength(this.data.length);
};
$23b6d5fc178f337b$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    var i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        var value = $23b6d5fc178f337b$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $23b6d5fc178f337b$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($23b6d5fc178f337b$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$23b6d5fc178f337b$exports = $23b6d5fc178f337b$var$AlphanumericData;


var $bf0e06203fbe6852$exports = {};
var $e858a8014643be2a$exports = {};
"use strict";
$e858a8014643be2a$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $bf0e06203fbe6852$var$ByteData(data) {
    this.mode = $6ecff0b042f3add8$export$8f4bf8f7eb581284;
    if (typeof data === "string") data = $e858a8014643be2a$exports(data);
    this.data = new Uint8Array(data);
}
$bf0e06203fbe6852$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$bf0e06203fbe6852$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$bf0e06203fbe6852$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $bf0e06203fbe6852$var$ByteData.getBitsLength(this.data.length);
};
$bf0e06203fbe6852$var$ByteData.prototype.write = function(bitBuffer) {
    for(var i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$bf0e06203fbe6852$exports = $bf0e06203fbe6852$var$ByteData;


var $9f94fe19841bb1c9$exports = {};


function $9f94fe19841bb1c9$var$KanjiData(data) {
    this.mode = $6ecff0b042f3add8$export$a4d452c2363c8e12;
    this.data = data;
}
$9f94fe19841bb1c9$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$9f94fe19841bb1c9$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9f94fe19841bb1c9$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $9f94fe19841bb1c9$var$KanjiData.getBitsLength(this.data.length);
};
$9f94fe19841bb1c9$var$KanjiData.prototype.write = function(bitBuffer) {
    var i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        var value = $91b70b00ef4849e5$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$9f94fe19841bb1c9$exports = $9f94fe19841bb1c9$var$KanjiData;




var $f0929c065f9fbe3e$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $f0929c065f9fbe3e$var$dijkstra = {
    single_source_shortest_paths: function single_source_shortest_paths(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $f0929c065f9fbe3e$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function extract_shortest_path_from_predecessor_list(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function find_path(graph, s, d) {
        var predecessors = $f0929c065f9fbe3e$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $f0929c065f9fbe3e$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function make(opts) {
            var T = $f0929c065f9fbe3e$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function default_sorter(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function push(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function pop() {
            return this.queue.shift();
        },
        empty: function empty() {
            return this.queue.length === 0;
        }
    }
};
$f0929c065f9fbe3e$exports = $f0929c065f9fbe3e$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $1ee923f113ae2d07$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $1ee923f113ae2d07$var$getSegments(regex, mode, str) {
    var segments = [];
    var result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $1ee923f113ae2d07$var$getSegmentsFromString(dataStr) {
    var numSegs = $1ee923f113ae2d07$var$getSegments($bfa5338121561471$export$4d318981b5a83836, $6ecff0b042f3add8$export$4d318981b5a83836, dataStr);
    var alphaNumSegs = $1ee923f113ae2d07$var$getSegments($bfa5338121561471$export$376a9ed239d6c1c8, $6ecff0b042f3add8$export$376a9ed239d6c1c8, dataStr);
    var byteSegs;
    var kanjiSegs;
    if ($91b70b00ef4849e5$export$ce5b1274f8597fa0()) {
        byteSegs = $1ee923f113ae2d07$var$getSegments($bfa5338121561471$export$8f4bf8f7eb581284, $6ecff0b042f3add8$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $1ee923f113ae2d07$var$getSegments($bfa5338121561471$export$a4d452c2363c8e12, $6ecff0b042f3add8$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $1ee923f113ae2d07$var$getSegments($bfa5338121561471$export$9df7c29d562bab83, $6ecff0b042f3add8$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $1ee923f113ae2d07$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $6ecff0b042f3add8$export$4d318981b5a83836:
            return $b75db9eb8aec2f26$exports.getBitsLength(length);
        case $6ecff0b042f3add8$export$376a9ed239d6c1c8:
            return $23b6d5fc178f337b$exports.getBitsLength(length);
        case $6ecff0b042f3add8$export$a4d452c2363c8e12:
            return $9f94fe19841bb1c9$exports.getBitsLength(length);
        case $6ecff0b042f3add8$export$8f4bf8f7eb581284:
            return $bf0e06203fbe6852$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $1ee923f113ae2d07$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $1ee923f113ae2d07$var$buildNodes(segs) {
    var nodes = [];
    for(var i = 0; i < segs.length; i++){
        var seg = segs[i];
        switch(seg.mode){
            case $6ecff0b042f3add8$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $6ecff0b042f3add8$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $6ecff0b042f3add8$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $6ecff0b042f3add8$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $6ecff0b042f3add8$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $6ecff0b042f3add8$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $6ecff0b042f3add8$export$8f4bf8f7eb581284,
                        length: $1ee923f113ae2d07$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $6ecff0b042f3add8$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $6ecff0b042f3add8$export$8f4bf8f7eb581284,
                        length: $1ee923f113ae2d07$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $1ee923f113ae2d07$var$buildGraph(nodes, version) {
    var table = {};
    var graph = {
        start: {}
    };
    var prevNodeIds = [
        "start"
    ];
    for(var i = 0; i < nodes.length; i++){
        var nodeGroup = nodes[i];
        var currentNodeIds = [];
        for(var j = 0; j < nodeGroup.length; j++){
            var node = nodeGroup[j];
            var key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(var n = 0; n < prevNodeIds.length; n++){
                var prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $1ee923f113ae2d07$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $1ee923f113ae2d07$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $1ee923f113ae2d07$var$getSegmentBitsLength(node.length, node.mode) + 4 + $6ecff0b042f3add8$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(var n1 = 0; n1 < prevNodeIds.length; n1++)graph[prevNodeIds[n1]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $1ee923f113ae2d07$var$buildSingleSegment(data, modesHint) {
    var mode;
    var bestMode = $6ecff0b042f3add8$export$1bd4c93ffb42e55e(data);
    mode = $6ecff0b042f3add8$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $6ecff0b042f3add8$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $6ecff0b042f3add8$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $6ecff0b042f3add8$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $6ecff0b042f3add8$export$a4d452c2363c8e12 && !$91b70b00ef4849e5$export$ce5b1274f8597fa0()) mode = $6ecff0b042f3add8$export$8f4bf8f7eb581284;
    switch(mode){
        case $6ecff0b042f3add8$export$4d318981b5a83836:
            return new $b75db9eb8aec2f26$exports(data);
        case $6ecff0b042f3add8$export$376a9ed239d6c1c8:
            return new $23b6d5fc178f337b$exports(data);
        case $6ecff0b042f3add8$export$a4d452c2363c8e12:
            return new $9f94fe19841bb1c9$exports(data);
        case $6ecff0b042f3add8$export$8f4bf8f7eb581284:
            return new $bf0e06203fbe6852$exports(data);
    }
}
$1ee923f113ae2d07$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($1ee923f113ae2d07$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($1ee923f113ae2d07$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$1ee923f113ae2d07$export$3004f64547af360e = function fromString(data, version) {
    var segs = $1ee923f113ae2d07$var$getSegmentsFromString(data, $91b70b00ef4849e5$export$ce5b1274f8597fa0());
    var nodes = $1ee923f113ae2d07$var$buildNodes(segs);
    var graph = $1ee923f113ae2d07$var$buildGraph(nodes, version);
    var path = $f0929c065f9fbe3e$exports.find_path(graph.map, "start", "end");
    var optimizedSegs = [];
    for(var i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $1ee923f113ae2d07$export$571d59b505e6bb4e($1ee923f113ae2d07$var$mergeSegments(optimizedSegs));
};
$1ee923f113ae2d07$export$89ab1afb9839589b = function rawSplit(data) {
    return $1ee923f113ae2d07$export$571d59b505e6bb4e($1ee923f113ae2d07$var$getSegmentsFromString(data, $91b70b00ef4849e5$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $3319eb7ae8834973$var$setupFinderPattern(matrix, version) {
    var size = matrix.size;
    var pos = $4e4647eb2501fb02$export$c39457c570f2b189(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $3319eb7ae8834973$var$setupTimingPattern(matrix) {
    var size = matrix.size;
    for(var r = 8; r < size - 8; r++){
        var value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $3319eb7ae8834973$var$setupAlignmentPattern(matrix, version) {
    var pos = $e590660599ef74da$export$c39457c570f2b189(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $3319eb7ae8834973$var$setupVersionInfo(matrix, version) {
    var size = matrix.size;
    var bits = $3c55842392f94f78$export$eee5438974ef6f0e(version);
    var row, col, mod;
    for(var i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $3319eb7ae8834973$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    var size = matrix.size;
    var bits = $9d060ba00c05a6bf$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    var i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $3319eb7ae8834973$var$setupData(matrix, data) {
    var size = matrix.size;
    var inc = -1;
    var row = size - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $3319eb7ae8834973$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    var buffer = new $5b576ab2f91c3645$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $6ecff0b042f3add8$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    var totalCodewords = $91b70b00ef4849e5$export$b05dac13c7a35c32(version);
    var ecTotalCodewords = $888305abe744009c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(var i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $3319eb7ae8834973$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $3319eb7ae8834973$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = $91b70b00ef4849e5$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    var ecTotalCodewords = $888305abe744009c$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    var ecTotalBlocks = $888305abe744009c$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    var blocksInGroup2 = totalCodewords % ecTotalBlocks;
    var blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    var rs = new $11c1a4bb9250d739$exports(ecCount);
    var offset = 0;
    var dcData = new Array(ecTotalBlocks);
    var ecData = new Array(ecTotalBlocks);
    var maxDataSize = 0;
    var buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(var b = 0; b < ecTotalBlocks; b++){
        var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    var data = new Uint8Array(totalCodewords);
    var index = 0;
    var i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $3319eb7ae8834973$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    var segments;
    if (Array.isArray(data)) segments = $1ee923f113ae2d07$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        var estimatedVersion = version;
        if (!estimatedVersion) {
            var rawSegments = $1ee923f113ae2d07$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $3c55842392f94f78$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $1ee923f113ae2d07$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    var bestVersion = $3c55842392f94f78$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    var dataBits = $3319eb7ae8834973$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    var moduleCount = $91b70b00ef4849e5$export$8d4a06d3facd414b(version);
    var modules = new $6f7e62055eb89743$exports(moduleCount);
    // Add function modules
    $3319eb7ae8834973$var$setupFinderPattern(modules, version);
    $3319eb7ae8834973$var$setupTimingPattern(modules);
    $3319eb7ae8834973$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $3319eb7ae8834973$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $3319eb7ae8834973$var$setupVersionInfo(modules, version);
    // Add data codewords
    $3319eb7ae8834973$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $3e4d8fba3b31e16e$export$fe9625aaceb0e563(modules, $3319eb7ae8834973$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $3e4d8fba3b31e16e$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $3319eb7ae8834973$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$3319eb7ae8834973$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    var errorCorrectionLevel = $f2d93ad39ba01363$export$3a1a48c8f6ef640e;
    var version;
    var mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $f2d93ad39ba01363$export$6788812c4e6611e6(options.errorCorrectionLevel, $f2d93ad39ba01363$export$3a1a48c8f6ef640e);
        version = $3c55842392f94f78$export$6788812c4e6611e6(options.version);
        mask = $3e4d8fba3b31e16e$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $91b70b00ef4849e5$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $3319eb7ae8834973$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $3c8dbc96f8b07302$export$b3890eb0ae9dca99;
var $3c8dbc96f8b07302$export$c3e5526bbaf70a25;
var $fc7f8ccb258fa49c$export$d2312e68e1f5ad00;
var $fc7f8ccb258fa49c$export$5cdac61cf538712e;
var $fc7f8ccb258fa49c$export$c3a1a1f268a8142b;
var $fc7f8ccb258fa49c$export$83136f57c739c5f3;
function $fc7f8ccb258fa49c$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    var hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    var hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$fc7f8ccb258fa49c$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    var margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    var width = options.width && options.width >= 21 ? options.width : undefined;
    var scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $fc7f8ccb258fa49c$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $fc7f8ccb258fa49c$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$fc7f8ccb258fa49c$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$fc7f8ccb258fa49c$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    var scale = $fc7f8ccb258fa49c$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$fc7f8ccb258fa49c$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    var size = qr.modules.size;
    var data = qr.modules.data;
    var scale = $fc7f8ccb258fa49c$export$5cdac61cf538712e(size, opts);
    var symbolSize = Math.floor((size + opts.margin * 2) * scale);
    var scaledMargin = opts.margin * scale;
    var palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(var i = 0; i < symbolSize; i++)for(var j = 0; j < symbolSize; j++){
        var posDst = (i * symbolSize + j) * 4;
        var pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            var iSrc = Math.floor((i - scaledMargin) / scale);
            var jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $3c8dbc96f8b07302$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $3c8dbc96f8b07302$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$3c8dbc96f8b07302$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    var opts = options;
    var canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $3c8dbc96f8b07302$var$getCanvasElement();
    opts = $fc7f8ccb258fa49c$export$d2312e68e1f5ad00(opts);
    var size = $fc7f8ccb258fa49c$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    var ctx = canvasEl.getContext("2d");
    var image = ctx.createImageData(size, size);
    $fc7f8ccb258fa49c$export$83136f57c739c5f3(image.data, qrData, opts);
    $3c8dbc96f8b07302$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$3c8dbc96f8b07302$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    var opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    var canvasEl = $3c8dbc96f8b07302$export$b3890eb0ae9dca99(qrData, canvas, opts);
    var type = opts.type || "image/png";
    var rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $8c2640b5edd73b30$export$b3890eb0ae9dca99;

function $8c2640b5edd73b30$var$getColorAttrib(color, attrib) {
    var alpha = color.a / 255;
    var str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $8c2640b5edd73b30$var$svgCmd(cmd, x, y) {
    var str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $8c2640b5edd73b30$var$qrToPath(data, size, margin) {
    var path = "";
    var moveBy = 0;
    var newRow = false;
    var lineLength = 0;
    for(var i = 0; i < data.length; i++){
        var col = Math.floor(i % size);
        var row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $8c2640b5edd73b30$var$svgCmd("M", col + margin, 0.5 + row + margin) : $8c2640b5edd73b30$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $8c2640b5edd73b30$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$8c2640b5edd73b30$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    var opts = $fc7f8ccb258fa49c$export$d2312e68e1f5ad00(options);
    var size = qrData.modules.size;
    var data = qrData.modules.data;
    var qrcodesize = size + opts.margin * 2;
    var bg = !opts.color.light.a ? "" : "<path " + $8c2640b5edd73b30$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    var path = "<path " + $8c2640b5edd73b30$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $8c2640b5edd73b30$var$qrToPath(data, size, opts.margin) + '"/>';
    var viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    var width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $bd06a26ec61d7200$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    var args = [].slice.call(arguments, 1);
    var argsNum = args.length;
    var isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$b73a36ac15193987$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                var data = $3319eb7ae8834973$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        var data = $3319eb7ae8834973$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$bd06a26ec61d7200$export$185802fd694ee1f5 = $3319eb7ae8834973$export$185802fd694ee1f5;
$bd06a26ec61d7200$export$f87f6982d1fd4f81 = $bd06a26ec61d7200$var$renderCanvas.bind(null, $3c8dbc96f8b07302$export$b3890eb0ae9dca99);
$bd06a26ec61d7200$export$723e4939e5a27c8 = $bd06a26ec61d7200$var$renderCanvas.bind(null, $3c8dbc96f8b07302$export$c3e5526bbaf70a25);
$bd06a26ec61d7200$export$f84e8e69fd4488a5 = $bd06a26ec61d7200$var$renderCanvas.bind(null, function(data, _, opts) {
    return $8c2640b5edd73b30$export$b3890eb0ae9dca99(data, opts);
});


var $0f23d1886f02ec64$exports = {};
"use strict";
var $ad8f2a4aa380ad99$exports = {};
$ad8f2a4aa380ad99$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $0f23d1886f02ec64$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $0f23d1886f02ec64$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $0f23d1886f02ec64$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $0f23d1886f02ec64$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $ad8f2a4aa380ad99$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var _$format = $0f23d1886f02ec64$var$clipboardToIE11Formatting[options.format] || $0f23d1886f02ec64$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(_$format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $0f23d1886f02ec64$var$format("message" in options ? options.message : $0f23d1886f02ec64$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$0f23d1886f02ec64$exports = $0f23d1886f02ec64$var$copy;


var $2e1e297565bb5552$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $2e1e297565bb5552$var$fails$h = function fails$h(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $2e1e297565bb5552$var$fails$g = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$functionBindNative = !$2e1e297565bb5552$var$fails$g(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $2e1e297565bb5552$var$NATIVE_BIND$3 = $2e1e297565bb5552$var$functionBindNative;
var $2e1e297565bb5552$var$FunctionPrototype$2 = Function.prototype;
var $2e1e297565bb5552$var$bind$5 = $2e1e297565bb5552$var$FunctionPrototype$2.bind;
var $2e1e297565bb5552$var$call$f = $2e1e297565bb5552$var$FunctionPrototype$2.call;
var $2e1e297565bb5552$var$uncurryThis$h = $2e1e297565bb5552$var$NATIVE_BIND$3 && $2e1e297565bb5552$var$bind$5.bind($2e1e297565bb5552$var$call$f, $2e1e297565bb5552$var$call$f);
var $2e1e297565bb5552$var$functionUncurryThis = $2e1e297565bb5552$var$NATIVE_BIND$3 ? function functionUncurryThis(fn) {
    return fn && $2e1e297565bb5552$var$uncurryThis$h(fn);
} : function(fn) {
    return fn && function() {
        return $2e1e297565bb5552$var$call$f.apply(fn, arguments);
    };
};
var $2e1e297565bb5552$var$uncurryThis$g = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$toString$5 = $2e1e297565bb5552$var$uncurryThis$g({}.toString);
var $2e1e297565bb5552$var$stringSlice$1 = $2e1e297565bb5552$var$uncurryThis$g("".slice);
var $2e1e297565bb5552$var$classofRaw$1 = function classofRaw$1(it) {
    return $2e1e297565bb5552$var$stringSlice$1($2e1e297565bb5552$var$toString$5(it), 8, -1);
};
var $2e1e297565bb5552$var$uncurryThis$f = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$fails$f = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$classof$6 = $2e1e297565bb5552$var$classofRaw$1;
var $2e1e297565bb5552$var$$Object$4 = Object;
var $2e1e297565bb5552$var$split = $2e1e297565bb5552$var$uncurryThis$f("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $2e1e297565bb5552$var$indexedObject = $2e1e297565bb5552$var$fails$f(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$2e1e297565bb5552$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function indexedObject(it) {
    return $2e1e297565bb5552$var$classof$6(it) == "String" ? $2e1e297565bb5552$var$split(it, "") : $2e1e297565bb5552$var$$Object$4(it);
} : $2e1e297565bb5552$var$$Object$4;
var $2e1e297565bb5552$var$$TypeError$e = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $2e1e297565bb5552$var$requireObjectCoercible$3 = function requireObjectCoercible$3(it) {
    if (it == undefined) throw $2e1e297565bb5552$var$$TypeError$e("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $2e1e297565bb5552$var$IndexedObject$2 = $2e1e297565bb5552$var$indexedObject;
var $2e1e297565bb5552$var$requireObjectCoercible$2 = $2e1e297565bb5552$var$requireObjectCoercible$3;
var $2e1e297565bb5552$var$toIndexedObject$5 = function toIndexedObject$5(it) {
    return $2e1e297565bb5552$var$IndexedObject$2($2e1e297565bb5552$var$requireObjectCoercible$2(it));
};
var $2e1e297565bb5552$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $2e1e297565bb5552$var$global$k = // eslint-disable-next-line es-x/no-global-this -- safe
$2e1e297565bb5552$var$check(typeof globalThis == "object" && globalThis) || $2e1e297565bb5552$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$2e1e297565bb5552$var$check(typeof self == "object" && self) || $2e1e297565bb5552$var$check(typeof $2e1e297565bb5552$var$commonjsGlobal == "object" && $2e1e297565bb5552$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $2e1e297565bb5552$var$shared$3 = {
    exports: {}
};
var $2e1e297565bb5552$var$global$j = $2e1e297565bb5552$var$global$k;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $2e1e297565bb5552$var$defineProperty$6 = Object.defineProperty;
var $2e1e297565bb5552$var$defineGlobalProperty$3 = function defineGlobalProperty$3(key, value) {
    try {
        $2e1e297565bb5552$var$defineProperty$6($2e1e297565bb5552$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $2e1e297565bb5552$var$global$j[key] = value;
    }
    return value;
};
var $2e1e297565bb5552$var$global$i = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$defineGlobalProperty$2 = $2e1e297565bb5552$var$defineGlobalProperty$3;
var $2e1e297565bb5552$var$SHARED = "__core-js_shared__";
var $2e1e297565bb5552$var$store$3 = $2e1e297565bb5552$var$global$i[$2e1e297565bb5552$var$SHARED] || $2e1e297565bb5552$var$defineGlobalProperty$2($2e1e297565bb5552$var$SHARED, {});
var $2e1e297565bb5552$var$sharedStore = $2e1e297565bb5552$var$store$3;
var $2e1e297565bb5552$var$store$2 = $2e1e297565bb5552$var$sharedStore;
($2e1e297565bb5552$var$shared$3.exports = function(key, value) {
    return $2e1e297565bb5552$var$store$2[key] || ($2e1e297565bb5552$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $2e1e297565bb5552$var$requireObjectCoercible$1 = $2e1e297565bb5552$var$requireObjectCoercible$3;
var $2e1e297565bb5552$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $2e1e297565bb5552$var$toObject$5 = function toObject$5(argument) {
    return $2e1e297565bb5552$var$$Object$3($2e1e297565bb5552$var$requireObjectCoercible$1(argument));
};
var $2e1e297565bb5552$var$uncurryThis$e = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$toObject$4 = $2e1e297565bb5552$var$toObject$5;
var $2e1e297565bb5552$var$hasOwnProperty = $2e1e297565bb5552$var$uncurryThis$e({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $2e1e297565bb5552$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $2e1e297565bb5552$var$hasOwnProperty($2e1e297565bb5552$var$toObject$4(it), key);
};
var $2e1e297565bb5552$var$uncurryThis$d = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$id = 0;
var $2e1e297565bb5552$var$postfix = Math.random();
var $2e1e297565bb5552$var$toString$4 = $2e1e297565bb5552$var$uncurryThis$d(1.0.toString);
var $2e1e297565bb5552$var$uid$2 = function uid$2(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $2e1e297565bb5552$var$toString$4(++$2e1e297565bb5552$var$id + $2e1e297565bb5552$var$postfix, 36);
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $2e1e297565bb5552$var$isCallable$l = function isCallable$l(argument) {
    return typeof argument == "function";
};
var $2e1e297565bb5552$var$global$h = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$isCallable$k = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$aFunction = function aFunction(argument) {
    return $2e1e297565bb5552$var$isCallable$k(argument) ? argument : undefined;
};
var $2e1e297565bb5552$var$getBuiltIn$8 = function getBuiltIn$8(namespace, method) {
    return arguments.length < 2 ? $2e1e297565bb5552$var$aFunction($2e1e297565bb5552$var$global$h[namespace]) : $2e1e297565bb5552$var$global$h[namespace] && $2e1e297565bb5552$var$global$h[namespace][method];
};
var $2e1e297565bb5552$var$getBuiltIn$7 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$engineUserAgent = $2e1e297565bb5552$var$getBuiltIn$7("navigator", "userAgent") || "";
var $2e1e297565bb5552$var$global$g = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$userAgent$5 = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$process$3 = $2e1e297565bb5552$var$global$g.process;
var $2e1e297565bb5552$var$Deno$1 = $2e1e297565bb5552$var$global$g.Deno;
var $2e1e297565bb5552$var$versions = $2e1e297565bb5552$var$process$3 && $2e1e297565bb5552$var$process$3.versions || $2e1e297565bb5552$var$Deno$1 && $2e1e297565bb5552$var$Deno$1.version;
var $2e1e297565bb5552$var$v8 = $2e1e297565bb5552$var$versions && $2e1e297565bb5552$var$versions.v8;
var $2e1e297565bb5552$var$match, $2e1e297565bb5552$var$version;
if ($2e1e297565bb5552$var$v8) {
    $2e1e297565bb5552$var$match = $2e1e297565bb5552$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $2e1e297565bb5552$var$version = $2e1e297565bb5552$var$match[0] > 0 && $2e1e297565bb5552$var$match[0] < 4 ? 1 : +($2e1e297565bb5552$var$match[0] + $2e1e297565bb5552$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$2e1e297565bb5552$var$version && $2e1e297565bb5552$var$userAgent$5) {
    $2e1e297565bb5552$var$match = $2e1e297565bb5552$var$userAgent$5.match(/Edge\/(\d+)/);
    if (!$2e1e297565bb5552$var$match || $2e1e297565bb5552$var$match[1] >= 74) {
        $2e1e297565bb5552$var$match = $2e1e297565bb5552$var$userAgent$5.match(/Chrome\/(\d+)/);
        if ($2e1e297565bb5552$var$match) $2e1e297565bb5552$var$version = +$2e1e297565bb5552$var$match[1];
    }
}
var $2e1e297565bb5552$var$engineV8Version = $2e1e297565bb5552$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $2e1e297565bb5552$var$V8_VERSION$1 = $2e1e297565bb5552$var$engineV8Version;
var $2e1e297565bb5552$var$fails$e = $2e1e297565bb5552$var$fails$h;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $2e1e297565bb5552$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$2e1e297565bb5552$var$fails$e(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $2e1e297565bb5552$var$V8_VERSION$1 && $2e1e297565bb5552$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $2e1e297565bb5552$var$NATIVE_SYMBOL$2 = $2e1e297565bb5552$var$nativeSymbol;
var $2e1e297565bb5552$var$useSymbolAsUid = $2e1e297565bb5552$var$NATIVE_SYMBOL$2 && !Symbol.sham && (0, $1ObTH._)(Symbol.iterator) == "symbol";
var $2e1e297565bb5552$var$global$f = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$shared$2 = $2e1e297565bb5552$var$shared$3.exports;
var $2e1e297565bb5552$var$hasOwn$b = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$uid$1 = $2e1e297565bb5552$var$uid$2;
var $2e1e297565bb5552$var$NATIVE_SYMBOL$1 = $2e1e297565bb5552$var$nativeSymbol;
var $2e1e297565bb5552$var$USE_SYMBOL_AS_UID$1 = $2e1e297565bb5552$var$useSymbolAsUid;
var $2e1e297565bb5552$var$WellKnownSymbolsStore = $2e1e297565bb5552$var$shared$2("wks");
var $2e1e297565bb5552$var$Symbol$1 = $2e1e297565bb5552$var$global$f.Symbol;
var $2e1e297565bb5552$var$symbolFor = $2e1e297565bb5552$var$Symbol$1 && $2e1e297565bb5552$var$Symbol$1["for"];
var $2e1e297565bb5552$var$createWellKnownSymbol = $2e1e297565bb5552$var$USE_SYMBOL_AS_UID$1 ? $2e1e297565bb5552$var$Symbol$1 : $2e1e297565bb5552$var$Symbol$1 && $2e1e297565bb5552$var$Symbol$1.withoutSetter || $2e1e297565bb5552$var$uid$1;
var $2e1e297565bb5552$var$wellKnownSymbol$g = function wellKnownSymbol$g(name) {
    if (!$2e1e297565bb5552$var$hasOwn$b($2e1e297565bb5552$var$WellKnownSymbolsStore, name) || !($2e1e297565bb5552$var$NATIVE_SYMBOL$1 || typeof $2e1e297565bb5552$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($2e1e297565bb5552$var$NATIVE_SYMBOL$1 && $2e1e297565bb5552$var$hasOwn$b($2e1e297565bb5552$var$Symbol$1, name)) $2e1e297565bb5552$var$WellKnownSymbolsStore[name] = $2e1e297565bb5552$var$Symbol$1[name];
        else if ($2e1e297565bb5552$var$USE_SYMBOL_AS_UID$1 && $2e1e297565bb5552$var$symbolFor) $2e1e297565bb5552$var$WellKnownSymbolsStore[name] = $2e1e297565bb5552$var$symbolFor(description);
        else $2e1e297565bb5552$var$WellKnownSymbolsStore[name] = $2e1e297565bb5552$var$createWellKnownSymbol(description);
    }
    return $2e1e297565bb5552$var$WellKnownSymbolsStore[name];
};
var $2e1e297565bb5552$var$isCallable$j = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$isObject$8 = function isObject$8(it) {
    return typeof it == "object" ? it !== null : $2e1e297565bb5552$var$isCallable$j(it);
};
var $2e1e297565bb5552$var$isObject$7 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$$String$3 = String;
var $2e1e297565bb5552$var$$TypeError$d = TypeError;
// `Assert: Type(argument) is Object`
var $2e1e297565bb5552$var$anObject$c = function anObject$c(argument) {
    if ($2e1e297565bb5552$var$isObject$7(argument)) return argument;
    throw $2e1e297565bb5552$var$$TypeError$d($2e1e297565bb5552$var$$String$3(argument) + " is not an object");
};
var $2e1e297565bb5552$var$objectDefineProperties = {};
var $2e1e297565bb5552$var$fails$d = $2e1e297565bb5552$var$fails$h;
// Detect IE8's incomplete defineProperty implementation
var $2e1e297565bb5552$var$descriptors = !$2e1e297565bb5552$var$fails$d(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});
var $2e1e297565bb5552$var$DESCRIPTORS$b = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$fails$c = $2e1e297565bb5552$var$fails$h;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $2e1e297565bb5552$var$v8PrototypeDefineBug = $2e1e297565bb5552$var$DESCRIPTORS$b && $2e1e297565bb5552$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $2e1e297565bb5552$var$objectDefineProperty = {};
var $2e1e297565bb5552$var$global$e = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$isObject$6 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$document$3 = $2e1e297565bb5552$var$global$e.document;
// typeof document.createElement is 'object' in old IE
var $2e1e297565bb5552$var$EXISTS$1 = $2e1e297565bb5552$var$isObject$6($2e1e297565bb5552$var$document$3) && $2e1e297565bb5552$var$isObject$6($2e1e297565bb5552$var$document$3.createElement);
var $2e1e297565bb5552$var$documentCreateElement$2 = function documentCreateElement$2(it) {
    return $2e1e297565bb5552$var$EXISTS$1 ? $2e1e297565bb5552$var$document$3.createElement(it) : {};
};
var $2e1e297565bb5552$var$DESCRIPTORS$a = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$fails$b = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$createElement$1 = $2e1e297565bb5552$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $2e1e297565bb5552$var$ie8DomDefine = !$2e1e297565bb5552$var$DESCRIPTORS$a && !$2e1e297565bb5552$var$fails$b(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($2e1e297565bb5552$var$createElement$1("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});
var $2e1e297565bb5552$var$NATIVE_BIND$2 = $2e1e297565bb5552$var$functionBindNative;
var $2e1e297565bb5552$var$call$e = Function.prototype.call;
var $2e1e297565bb5552$var$functionCall = $2e1e297565bb5552$var$NATIVE_BIND$2 ? $2e1e297565bb5552$var$call$e.bind($2e1e297565bb5552$var$call$e) : function functionCall() {
    return $2e1e297565bb5552$var$call$e.apply($2e1e297565bb5552$var$call$e, arguments);
};
var $2e1e297565bb5552$var$uncurryThis$c = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$objectIsPrototypeOf = $2e1e297565bb5552$var$uncurryThis$c({}.isPrototypeOf);
var $2e1e297565bb5552$var$getBuiltIn$6 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$isCallable$i = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$isPrototypeOf$4 = $2e1e297565bb5552$var$objectIsPrototypeOf;
var $2e1e297565bb5552$var$USE_SYMBOL_AS_UID = $2e1e297565bb5552$var$useSymbolAsUid;
var $2e1e297565bb5552$var$$Object$2 = Object;
var $2e1e297565bb5552$var$isSymbol$2 = $2e1e297565bb5552$var$USE_SYMBOL_AS_UID ? function isSymbol$2(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $1ObTH._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $2e1e297565bb5552$var$getBuiltIn$6("Symbol");
    return $2e1e297565bb5552$var$isCallable$i($Symbol) && $2e1e297565bb5552$var$isPrototypeOf$4($Symbol.prototype, $2e1e297565bb5552$var$$Object$2(it));
};
var $2e1e297565bb5552$var$$String$2 = String;
var $2e1e297565bb5552$var$tryToString$5 = function tryToString$5(argument) {
    try {
        return $2e1e297565bb5552$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $2e1e297565bb5552$var$isCallable$h = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$tryToString$4 = $2e1e297565bb5552$var$tryToString$5;
var $2e1e297565bb5552$var$$TypeError$c = TypeError;
// `Assert: IsCallable(argument) is true`
var $2e1e297565bb5552$var$aCallable$9 = function aCallable$9(argument) {
    if ($2e1e297565bb5552$var$isCallable$h(argument)) return argument;
    throw $2e1e297565bb5552$var$$TypeError$c($2e1e297565bb5552$var$tryToString$4(argument) + " is not a function");
};
var $2e1e297565bb5552$var$aCallable$8 = $2e1e297565bb5552$var$aCallable$9;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $2e1e297565bb5552$var$getMethod$3 = function getMethod$3(V, P) {
    var func = V[P];
    return func == null ? undefined : $2e1e297565bb5552$var$aCallable$8(func);
};
var $2e1e297565bb5552$var$call$d = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$isCallable$g = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$isObject$5 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$$TypeError$b = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $2e1e297565bb5552$var$ordinaryToPrimitive$1 = function ordinaryToPrimitive$1(input, pref) {
    var fn, val;
    if (pref === "string" && $2e1e297565bb5552$var$isCallable$g(fn = input.toString) && !$2e1e297565bb5552$var$isObject$5(val = $2e1e297565bb5552$var$call$d(fn, input))) return val;
    if ($2e1e297565bb5552$var$isCallable$g(fn = input.valueOf) && !$2e1e297565bb5552$var$isObject$5(val = $2e1e297565bb5552$var$call$d(fn, input))) return val;
    if (pref !== "string" && $2e1e297565bb5552$var$isCallable$g(fn = input.toString) && !$2e1e297565bb5552$var$isObject$5(val = $2e1e297565bb5552$var$call$d(fn, input))) return val;
    throw $2e1e297565bb5552$var$$TypeError$b("Can't convert object to primitive value");
};
var $2e1e297565bb5552$var$call$c = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$isObject$4 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$isSymbol$1 = $2e1e297565bb5552$var$isSymbol$2;
var $2e1e297565bb5552$var$getMethod$2 = $2e1e297565bb5552$var$getMethod$3;
var $2e1e297565bb5552$var$ordinaryToPrimitive = $2e1e297565bb5552$var$ordinaryToPrimitive$1;
var $2e1e297565bb5552$var$wellKnownSymbol$f = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$$TypeError$a = TypeError;
var $2e1e297565bb5552$var$TO_PRIMITIVE = $2e1e297565bb5552$var$wellKnownSymbol$f("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $2e1e297565bb5552$var$toPrimitive$1 = function toPrimitive$1(input, pref) {
    if (!$2e1e297565bb5552$var$isObject$4(input) || $2e1e297565bb5552$var$isSymbol$1(input)) return input;
    var exoticToPrim = $2e1e297565bb5552$var$getMethod$2(input, $2e1e297565bb5552$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $2e1e297565bb5552$var$call$c(exoticToPrim, input, pref);
        if (!$2e1e297565bb5552$var$isObject$4(result) || $2e1e297565bb5552$var$isSymbol$1(result)) return result;
        throw $2e1e297565bb5552$var$$TypeError$a("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $2e1e297565bb5552$var$ordinaryToPrimitive(input, pref);
};
var $2e1e297565bb5552$var$toPrimitive = $2e1e297565bb5552$var$toPrimitive$1;
var $2e1e297565bb5552$var$isSymbol = $2e1e297565bb5552$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $2e1e297565bb5552$var$toPropertyKey$3 = function toPropertyKey$3(argument) {
    var key = $2e1e297565bb5552$var$toPrimitive(argument, "string");
    return $2e1e297565bb5552$var$isSymbol(key) ? key : key + "";
};
var $2e1e297565bb5552$var$DESCRIPTORS$9 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$IE8_DOM_DEFINE$1 = $2e1e297565bb5552$var$ie8DomDefine;
var $2e1e297565bb5552$var$V8_PROTOTYPE_DEFINE_BUG$1 = $2e1e297565bb5552$var$v8PrototypeDefineBug;
var $2e1e297565bb5552$var$anObject$b = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$toPropertyKey$2 = $2e1e297565bb5552$var$toPropertyKey$3;
var $2e1e297565bb5552$var$$TypeError$9 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $2e1e297565bb5552$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $2e1e297565bb5552$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $2e1e297565bb5552$var$ENUMERABLE = "enumerable";
var $2e1e297565bb5552$var$CONFIGURABLE$1 = "configurable";
var $2e1e297565bb5552$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$2e1e297565bb5552$var$objectDefineProperty.f = $2e1e297565bb5552$var$DESCRIPTORS$9 ? $2e1e297565bb5552$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $2e1e297565bb5552$var$anObject$b(O);
    P = $2e1e297565bb5552$var$toPropertyKey$2(P);
    $2e1e297565bb5552$var$anObject$b(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $2e1e297565bb5552$var$WRITABLE in Attributes && !Attributes[$2e1e297565bb5552$var$WRITABLE]) {
        var current = $2e1e297565bb5552$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$2e1e297565bb5552$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2e1e297565bb5552$var$CONFIGURABLE$1 in Attributes ? Attributes[$2e1e297565bb5552$var$CONFIGURABLE$1] : current[$2e1e297565bb5552$var$CONFIGURABLE$1],
                enumerable: $2e1e297565bb5552$var$ENUMERABLE in Attributes ? Attributes[$2e1e297565bb5552$var$ENUMERABLE] : current[$2e1e297565bb5552$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2e1e297565bb5552$var$$defineProperty(O, P, Attributes);
} : $2e1e297565bb5552$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $2e1e297565bb5552$var$anObject$b(O);
    P = $2e1e297565bb5552$var$toPropertyKey$2(P);
    $2e1e297565bb5552$var$anObject$b(Attributes);
    if ($2e1e297565bb5552$var$IE8_DOM_DEFINE$1) try {
        return $2e1e297565bb5552$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $2e1e297565bb5552$var$$TypeError$9("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $2e1e297565bb5552$var$ceil = Math.ceil;
var $2e1e297565bb5552$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $2e1e297565bb5552$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $2e1e297565bb5552$var$floor$1 : $2e1e297565bb5552$var$ceil)(n);
};
var $2e1e297565bb5552$var$trunc = $2e1e297565bb5552$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $2e1e297565bb5552$var$toIntegerOrInfinity$2 = function toIntegerOrInfinity$2(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $2e1e297565bb5552$var$trunc(number);
};
var $2e1e297565bb5552$var$toIntegerOrInfinity$1 = $2e1e297565bb5552$var$toIntegerOrInfinity$2;
var $2e1e297565bb5552$var$max$1 = Math.max;
var $2e1e297565bb5552$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $2e1e297565bb5552$var$toAbsoluteIndex$2 = function toAbsoluteIndex$2(index, length) {
    var integer = $2e1e297565bb5552$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $2e1e297565bb5552$var$max$1(integer + length, 0) : $2e1e297565bb5552$var$min$1(integer, length);
};
var $2e1e297565bb5552$var$toIntegerOrInfinity = $2e1e297565bb5552$var$toIntegerOrInfinity$2;
var $2e1e297565bb5552$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $2e1e297565bb5552$var$toLength$1 = function toLength$1(argument) {
    return argument > 0 ? $2e1e297565bb5552$var$min($2e1e297565bb5552$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $2e1e297565bb5552$var$toLength = $2e1e297565bb5552$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $2e1e297565bb5552$var$lengthOfArrayLike$5 = function lengthOfArrayLike$5(obj) {
    return $2e1e297565bb5552$var$toLength(obj.length);
};
var $2e1e297565bb5552$var$toIndexedObject$4 = $2e1e297565bb5552$var$toIndexedObject$5;
var $2e1e297565bb5552$var$toAbsoluteIndex$1 = $2e1e297565bb5552$var$toAbsoluteIndex$2;
var $2e1e297565bb5552$var$lengthOfArrayLike$4 = $2e1e297565bb5552$var$lengthOfArrayLike$5;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $2e1e297565bb5552$var$createMethod$1 = function createMethod$1(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2e1e297565bb5552$var$toIndexedObject$4($this);
        var length = $2e1e297565bb5552$var$lengthOfArrayLike$4(O);
        var index = $2e1e297565bb5552$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $2e1e297565bb5552$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $2e1e297565bb5552$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $2e1e297565bb5552$var$createMethod$1(false)
};
var $2e1e297565bb5552$var$hiddenKeys$4 = {};
var $2e1e297565bb5552$var$uncurryThis$b = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$hasOwn$a = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$toIndexedObject$3 = $2e1e297565bb5552$var$toIndexedObject$5;
var $2e1e297565bb5552$var$indexOf = $2e1e297565bb5552$var$arrayIncludes.indexOf;
var $2e1e297565bb5552$var$hiddenKeys$3 = $2e1e297565bb5552$var$hiddenKeys$4;
var $2e1e297565bb5552$var$push$1 = $2e1e297565bb5552$var$uncurryThis$b([].push);
var $2e1e297565bb5552$var$objectKeysInternal = function objectKeysInternal(object, names) {
    var O = $2e1e297565bb5552$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$2e1e297565bb5552$var$hasOwn$a($2e1e297565bb5552$var$hiddenKeys$3, key) && $2e1e297565bb5552$var$hasOwn$a(O, key) && $2e1e297565bb5552$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($2e1e297565bb5552$var$hasOwn$a(O, key = names[i++])) ~$2e1e297565bb5552$var$indexOf(result, key) || $2e1e297565bb5552$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $2e1e297565bb5552$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $2e1e297565bb5552$var$internalObjectKeys$1 = $2e1e297565bb5552$var$objectKeysInternal;
var $2e1e297565bb5552$var$enumBugKeys$2 = $2e1e297565bb5552$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $2e1e297565bb5552$var$objectKeys$2 = Object.keys || function keys(O) {
    return $2e1e297565bb5552$var$internalObjectKeys$1(O, $2e1e297565bb5552$var$enumBugKeys$2);
};
var $2e1e297565bb5552$var$DESCRIPTORS$8 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$V8_PROTOTYPE_DEFINE_BUG = $2e1e297565bb5552$var$v8PrototypeDefineBug;
var $2e1e297565bb5552$var$definePropertyModule$5 = $2e1e297565bb5552$var$objectDefineProperty;
var $2e1e297565bb5552$var$anObject$a = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$toIndexedObject$2 = $2e1e297565bb5552$var$toIndexedObject$5;
var $2e1e297565bb5552$var$objectKeys$1 = $2e1e297565bb5552$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$2e1e297565bb5552$var$objectDefineProperties.f = $2e1e297565bb5552$var$DESCRIPTORS$8 && !$2e1e297565bb5552$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $2e1e297565bb5552$var$anObject$a(O);
    var props = $2e1e297565bb5552$var$toIndexedObject$2(Properties);
    var keys = $2e1e297565bb5552$var$objectKeys$1(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$2e1e297565bb5552$var$definePropertyModule$5.f(O, key = keys[index++], props[key]);
    return O;
};
var $2e1e297565bb5552$var$getBuiltIn$5 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$html$2 = $2e1e297565bb5552$var$getBuiltIn$5("document", "documentElement");
var $2e1e297565bb5552$var$shared$1 = $2e1e297565bb5552$var$shared$3.exports;
var $2e1e297565bb5552$var$uid = $2e1e297565bb5552$var$uid$2;
var $2e1e297565bb5552$var$keys = $2e1e297565bb5552$var$shared$1("keys");
var $2e1e297565bb5552$var$sharedKey$3 = function sharedKey$3(key) {
    return $2e1e297565bb5552$var$keys[key] || ($2e1e297565bb5552$var$keys[key] = $2e1e297565bb5552$var$uid(key));
};
/* global ActiveXObject -- old IE, WSH */ var $2e1e297565bb5552$var$anObject$9 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$definePropertiesModule = $2e1e297565bb5552$var$objectDefineProperties;
var $2e1e297565bb5552$var$enumBugKeys$1 = $2e1e297565bb5552$var$enumBugKeys$3;
var $2e1e297565bb5552$var$hiddenKeys$2 = $2e1e297565bb5552$var$hiddenKeys$4;
var $2e1e297565bb5552$var$html$1 = $2e1e297565bb5552$var$html$2;
var $2e1e297565bb5552$var$documentCreateElement$1 = $2e1e297565bb5552$var$documentCreateElement$2;
var $2e1e297565bb5552$var$sharedKey$2 = $2e1e297565bb5552$var$sharedKey$3;
var $2e1e297565bb5552$var$GT = ">";
var $2e1e297565bb5552$var$LT = "<";
var $2e1e297565bb5552$var$PROTOTYPE = "prototype";
var $2e1e297565bb5552$var$SCRIPT = "script";
var $2e1e297565bb5552$var$IE_PROTO$1 = $2e1e297565bb5552$var$sharedKey$2("IE_PROTO");
var $2e1e297565bb5552$var$EmptyConstructor = function EmptyConstructor() {};
var $2e1e297565bb5552$var$scriptTag = function scriptTag(content) {
    return $2e1e297565bb5552$var$LT + $2e1e297565bb5552$var$SCRIPT + $2e1e297565bb5552$var$GT + content + $2e1e297565bb5552$var$LT + "/" + $2e1e297565bb5552$var$SCRIPT + $2e1e297565bb5552$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $2e1e297565bb5552$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($2e1e297565bb5552$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $2e1e297565bb5552$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $2e1e297565bb5552$var$documentCreateElement$1("iframe");
    var JS = "java" + $2e1e297565bb5552$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $2e1e297565bb5552$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($2e1e297565bb5552$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $2e1e297565bb5552$var$activeXDocument;
var $2e1e297565bb5552$var$NullProtoObject = function NullProtoObject1() {
    try {
        $2e1e297565bb5552$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $2e1e297565bb5552$var$NullProtoObject = typeof document != "undefined" ? document.domain && $2e1e297565bb5552$var$activeXDocument ? $2e1e297565bb5552$var$NullProtoObjectViaActiveX($2e1e297565bb5552$var$activeXDocument) // old IE
     : $2e1e297565bb5552$var$NullProtoObjectViaIFrame() : $2e1e297565bb5552$var$NullProtoObjectViaActiveX($2e1e297565bb5552$var$activeXDocument); // WSH
    var length = $2e1e297565bb5552$var$enumBugKeys$1.length;
    while(length--)delete $2e1e297565bb5552$var$NullProtoObject[$2e1e297565bb5552$var$PROTOTYPE][$2e1e297565bb5552$var$enumBugKeys$1[length]];
    return $2e1e297565bb5552$var$NullProtoObject();
};
$2e1e297565bb5552$var$hiddenKeys$2[$2e1e297565bb5552$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $2e1e297565bb5552$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $2e1e297565bb5552$var$EmptyConstructor[$2e1e297565bb5552$var$PROTOTYPE] = $2e1e297565bb5552$var$anObject$9(O);
        result = new $2e1e297565bb5552$var$EmptyConstructor();
        $2e1e297565bb5552$var$EmptyConstructor[$2e1e297565bb5552$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$2e1e297565bb5552$var$IE_PROTO$1] = O;
    } else result = $2e1e297565bb5552$var$NullProtoObject();
    return Properties === undefined ? result : $2e1e297565bb5552$var$definePropertiesModule.f(result, Properties);
};
var $2e1e297565bb5552$var$wellKnownSymbol$e = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$create$1 = $2e1e297565bb5552$var$objectCreate;
var $2e1e297565bb5552$var$defineProperty$5 = $2e1e297565bb5552$var$objectDefineProperty.f;
var $2e1e297565bb5552$var$UNSCOPABLES = $2e1e297565bb5552$var$wellKnownSymbol$e("unscopables");
var $2e1e297565bb5552$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($2e1e297565bb5552$var$ArrayPrototype$1[$2e1e297565bb5552$var$UNSCOPABLES] == undefined) $2e1e297565bb5552$var$defineProperty$5($2e1e297565bb5552$var$ArrayPrototype$1, $2e1e297565bb5552$var$UNSCOPABLES, {
    configurable: true,
    value: $2e1e297565bb5552$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $2e1e297565bb5552$var$addToUnscopables$2 = function addToUnscopables$2(key) {
    $2e1e297565bb5552$var$ArrayPrototype$1[$2e1e297565bb5552$var$UNSCOPABLES][key] = true;
};
var $2e1e297565bb5552$var$iterators = {};
var $2e1e297565bb5552$var$uncurryThis$a = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$isCallable$f = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$store$1 = $2e1e297565bb5552$var$sharedStore;
var $2e1e297565bb5552$var$functionToString = $2e1e297565bb5552$var$uncurryThis$a(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$2e1e297565bb5552$var$isCallable$f($2e1e297565bb5552$var$store$1.inspectSource)) $2e1e297565bb5552$var$store$1.inspectSource = function(it) {
    return $2e1e297565bb5552$var$functionToString(it);
};
var $2e1e297565bb5552$var$inspectSource$4 = $2e1e297565bb5552$var$store$1.inspectSource;
var $2e1e297565bb5552$var$global$d = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$isCallable$e = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$inspectSource$3 = $2e1e297565bb5552$var$inspectSource$4;
var $2e1e297565bb5552$var$WeakMap$1 = $2e1e297565bb5552$var$global$d.WeakMap;
var $2e1e297565bb5552$var$nativeWeakMap = $2e1e297565bb5552$var$isCallable$e($2e1e297565bb5552$var$WeakMap$1) && /native code/.test($2e1e297565bb5552$var$inspectSource$3($2e1e297565bb5552$var$WeakMap$1));
var $2e1e297565bb5552$var$createPropertyDescriptor$4 = function createPropertyDescriptor$4(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $2e1e297565bb5552$var$DESCRIPTORS$7 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$definePropertyModule$4 = $2e1e297565bb5552$var$objectDefineProperty;
var $2e1e297565bb5552$var$createPropertyDescriptor$3 = $2e1e297565bb5552$var$createPropertyDescriptor$4;
var $2e1e297565bb5552$var$createNonEnumerableProperty$4 = $2e1e297565bb5552$var$DESCRIPTORS$7 ? function createNonEnumerableProperty$4(object, key, value) {
    return $2e1e297565bb5552$var$definePropertyModule$4.f(object, key, $2e1e297565bb5552$var$createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $2e1e297565bb5552$var$NATIVE_WEAK_MAP = $2e1e297565bb5552$var$nativeWeakMap;
var $2e1e297565bb5552$var$global$c = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$uncurryThis$9 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$isObject$3 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$createNonEnumerableProperty$3 = $2e1e297565bb5552$var$createNonEnumerableProperty$4;
var $2e1e297565bb5552$var$hasOwn$9 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$shared = $2e1e297565bb5552$var$sharedStore;
var $2e1e297565bb5552$var$sharedKey$1 = $2e1e297565bb5552$var$sharedKey$3;
var $2e1e297565bb5552$var$hiddenKeys$1 = $2e1e297565bb5552$var$hiddenKeys$4;
var $2e1e297565bb5552$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $2e1e297565bb5552$var$TypeError$2 = $2e1e297565bb5552$var$global$c.TypeError;
var $2e1e297565bb5552$var$WeakMap = $2e1e297565bb5552$var$global$c.WeakMap;
var $2e1e297565bb5552$var$set$1, $2e1e297565bb5552$var$get, $2e1e297565bb5552$var$has;
var $2e1e297565bb5552$var$enforce = function enforce(it) {
    return $2e1e297565bb5552$var$has(it) ? $2e1e297565bb5552$var$get(it) : $2e1e297565bb5552$var$set$1(it, {});
};
var $2e1e297565bb5552$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$2e1e297565bb5552$var$isObject$3(it) || (state = $2e1e297565bb5552$var$get(it)).type !== TYPE) throw $2e1e297565bb5552$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($2e1e297565bb5552$var$NATIVE_WEAK_MAP || $2e1e297565bb5552$var$shared.state) {
    var $2e1e297565bb5552$var$store = $2e1e297565bb5552$var$shared.state || ($2e1e297565bb5552$var$shared.state = new $2e1e297565bb5552$var$WeakMap());
    var $2e1e297565bb5552$var$wmget = $2e1e297565bb5552$var$uncurryThis$9($2e1e297565bb5552$var$store.get);
    var $2e1e297565bb5552$var$wmhas = $2e1e297565bb5552$var$uncurryThis$9($2e1e297565bb5552$var$store.has);
    var $2e1e297565bb5552$var$wmset = $2e1e297565bb5552$var$uncurryThis$9($2e1e297565bb5552$var$store.set);
    $2e1e297565bb5552$var$set$1 = function set$1(it, metadata) {
        if ($2e1e297565bb5552$var$wmhas($2e1e297565bb5552$var$store, it)) throw new $2e1e297565bb5552$var$TypeError$2($2e1e297565bb5552$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $2e1e297565bb5552$var$wmset($2e1e297565bb5552$var$store, it, metadata);
        return metadata;
    };
    $2e1e297565bb5552$var$get = function get(it) {
        return $2e1e297565bb5552$var$wmget($2e1e297565bb5552$var$store, it) || {};
    };
    $2e1e297565bb5552$var$has = function has(it) {
        return $2e1e297565bb5552$var$wmhas($2e1e297565bb5552$var$store, it);
    };
} else {
    var $2e1e297565bb5552$var$STATE = $2e1e297565bb5552$var$sharedKey$1("state");
    $2e1e297565bb5552$var$hiddenKeys$1[$2e1e297565bb5552$var$STATE] = true;
    $2e1e297565bb5552$var$set$1 = function set$1(it, metadata) {
        if ($2e1e297565bb5552$var$hasOwn$9(it, $2e1e297565bb5552$var$STATE)) throw new $2e1e297565bb5552$var$TypeError$2($2e1e297565bb5552$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $2e1e297565bb5552$var$createNonEnumerableProperty$3(it, $2e1e297565bb5552$var$STATE, metadata);
        return metadata;
    };
    $2e1e297565bb5552$var$get = function get(it) {
        return $2e1e297565bb5552$var$hasOwn$9(it, $2e1e297565bb5552$var$STATE) ? it[$2e1e297565bb5552$var$STATE] : {};
    };
    $2e1e297565bb5552$var$has = function has(it) {
        return $2e1e297565bb5552$var$hasOwn$9(it, $2e1e297565bb5552$var$STATE);
    };
}
var $2e1e297565bb5552$var$internalState = {
    set: $2e1e297565bb5552$var$set$1,
    get: $2e1e297565bb5552$var$get,
    has: $2e1e297565bb5552$var$has,
    enforce: $2e1e297565bb5552$var$enforce,
    getterFor: $2e1e297565bb5552$var$getterFor
};
var $2e1e297565bb5552$var$objectGetOwnPropertyDescriptor = {};
var $2e1e297565bb5552$var$objectPropertyIsEnumerable = {};
var $2e1e297565bb5552$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $2e1e297565bb5552$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $2e1e297565bb5552$var$NASHORN_BUG = $2e1e297565bb5552$var$getOwnPropertyDescriptor$2 && !$2e1e297565bb5552$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$2e1e297565bb5552$var$objectPropertyIsEnumerable.f = $2e1e297565bb5552$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $2e1e297565bb5552$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $2e1e297565bb5552$var$$propertyIsEnumerable;
var $2e1e297565bb5552$var$DESCRIPTORS$6 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$call$b = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$propertyIsEnumerableModule$1 = $2e1e297565bb5552$var$objectPropertyIsEnumerable;
var $2e1e297565bb5552$var$createPropertyDescriptor$2 = $2e1e297565bb5552$var$createPropertyDescriptor$4;
var $2e1e297565bb5552$var$toIndexedObject$1 = $2e1e297565bb5552$var$toIndexedObject$5;
var $2e1e297565bb5552$var$toPropertyKey$1 = $2e1e297565bb5552$var$toPropertyKey$3;
var $2e1e297565bb5552$var$hasOwn$8 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$IE8_DOM_DEFINE = $2e1e297565bb5552$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $2e1e297565bb5552$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$2e1e297565bb5552$var$objectGetOwnPropertyDescriptor.f = $2e1e297565bb5552$var$DESCRIPTORS$6 ? $2e1e297565bb5552$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $2e1e297565bb5552$var$toIndexedObject$1(O);
    P = $2e1e297565bb5552$var$toPropertyKey$1(P);
    if ($2e1e297565bb5552$var$IE8_DOM_DEFINE) try {
        return $2e1e297565bb5552$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($2e1e297565bb5552$var$hasOwn$8(O, P)) return $2e1e297565bb5552$var$createPropertyDescriptor$2(!$2e1e297565bb5552$var$call$b($2e1e297565bb5552$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $2e1e297565bb5552$var$makeBuiltIn$2 = {
    exports: {}
};
var $2e1e297565bb5552$var$DESCRIPTORS$5 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$hasOwn$7 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $2e1e297565bb5552$var$getDescriptor = $2e1e297565bb5552$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $2e1e297565bb5552$var$EXISTS = $2e1e297565bb5552$var$hasOwn$7($2e1e297565bb5552$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $2e1e297565bb5552$var$PROPER = $2e1e297565bb5552$var$EXISTS && (function something() {}).name === "something";
var $2e1e297565bb5552$var$CONFIGURABLE = $2e1e297565bb5552$var$EXISTS && (!$2e1e297565bb5552$var$DESCRIPTORS$5 || $2e1e297565bb5552$var$DESCRIPTORS$5 && $2e1e297565bb5552$var$getDescriptor($2e1e297565bb5552$var$FunctionPrototype$1, "name").configurable);
var $2e1e297565bb5552$var$functionName = {
    EXISTS: $2e1e297565bb5552$var$EXISTS,
    PROPER: $2e1e297565bb5552$var$PROPER,
    CONFIGURABLE: $2e1e297565bb5552$var$CONFIGURABLE
};
var $2e1e297565bb5552$var$fails$a = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$isCallable$d = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$hasOwn$6 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$DESCRIPTORS$4 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$CONFIGURABLE_FUNCTION_NAME$1 = $2e1e297565bb5552$var$functionName.CONFIGURABLE;
var $2e1e297565bb5552$var$inspectSource$2 = $2e1e297565bb5552$var$inspectSource$4;
var $2e1e297565bb5552$var$InternalStateModule$2 = $2e1e297565bb5552$var$internalState;
var $2e1e297565bb5552$var$enforceInternalState = $2e1e297565bb5552$var$InternalStateModule$2.enforce;
var $2e1e297565bb5552$var$getInternalState$1 = $2e1e297565bb5552$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $2e1e297565bb5552$var$defineProperty$4 = Object.defineProperty;
var $2e1e297565bb5552$var$CONFIGURABLE_LENGTH = $2e1e297565bb5552$var$DESCRIPTORS$4 && !$2e1e297565bb5552$var$fails$a(function() {
    return $2e1e297565bb5552$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $2e1e297565bb5552$var$TEMPLATE = String(String).split("String");
var $2e1e297565bb5552$var$makeBuiltIn$1 = $2e1e297565bb5552$var$makeBuiltIn$2.exports = function makeBuiltIn$1(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$2e1e297565bb5552$var$hasOwn$6(value, "name") || $2e1e297565bb5552$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($2e1e297565bb5552$var$DESCRIPTORS$4) $2e1e297565bb5552$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($2e1e297565bb5552$var$CONFIGURABLE_LENGTH && options && $2e1e297565bb5552$var$hasOwn$6(options, "arity") && value.length !== options.arity) $2e1e297565bb5552$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $2e1e297565bb5552$var$hasOwn$6(options, "constructor") && options.constructor) {
            if ($2e1e297565bb5552$var$DESCRIPTORS$4) $2e1e297565bb5552$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $2e1e297565bb5552$var$enforceInternalState(value);
    if (!$2e1e297565bb5552$var$hasOwn$6(state, "source")) state.source = $2e1e297565bb5552$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $2e1e297565bb5552$var$makeBuiltIn$1(function toString() {
    return $2e1e297565bb5552$var$isCallable$d(this) && $2e1e297565bb5552$var$getInternalState$1(this).source || $2e1e297565bb5552$var$inspectSource$2(this);
}, "toString");
var $2e1e297565bb5552$var$isCallable$c = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$definePropertyModule$3 = $2e1e297565bb5552$var$objectDefineProperty;
var $2e1e297565bb5552$var$makeBuiltIn = $2e1e297565bb5552$var$makeBuiltIn$2.exports;
var $2e1e297565bb5552$var$defineGlobalProperty$1 = $2e1e297565bb5552$var$defineGlobalProperty$3;
var $2e1e297565bb5552$var$defineBuiltIn$6 = function defineBuiltIn$6(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($2e1e297565bb5552$var$isCallable$c(value)) $2e1e297565bb5552$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $2e1e297565bb5552$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2e1e297565bb5552$var$definePropertyModule$3.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $2e1e297565bb5552$var$objectGetOwnPropertyNames = {};
var $2e1e297565bb5552$var$internalObjectKeys = $2e1e297565bb5552$var$objectKeysInternal;
var $2e1e297565bb5552$var$enumBugKeys = $2e1e297565bb5552$var$enumBugKeys$3;
var $2e1e297565bb5552$var$hiddenKeys = $2e1e297565bb5552$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$2e1e297565bb5552$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $2e1e297565bb5552$var$internalObjectKeys(O, $2e1e297565bb5552$var$hiddenKeys);
};
var $2e1e297565bb5552$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$2e1e297565bb5552$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $2e1e297565bb5552$var$getBuiltIn$4 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$uncurryThis$8 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$getOwnPropertyNamesModule = $2e1e297565bb5552$var$objectGetOwnPropertyNames;
var $2e1e297565bb5552$var$getOwnPropertySymbolsModule$1 = $2e1e297565bb5552$var$objectGetOwnPropertySymbols;
var $2e1e297565bb5552$var$anObject$8 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$concat$1 = $2e1e297565bb5552$var$uncurryThis$8([].concat);
// all object keys, includes non-enumerable and symbols
var $2e1e297565bb5552$var$ownKeys$1 = $2e1e297565bb5552$var$getBuiltIn$4("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $2e1e297565bb5552$var$getOwnPropertyNamesModule.f($2e1e297565bb5552$var$anObject$8(it));
    var getOwnPropertySymbols = $2e1e297565bb5552$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $2e1e297565bb5552$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $2e1e297565bb5552$var$hasOwn$5 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$ownKeys = $2e1e297565bb5552$var$ownKeys$1;
var $2e1e297565bb5552$var$getOwnPropertyDescriptorModule = $2e1e297565bb5552$var$objectGetOwnPropertyDescriptor;
var $2e1e297565bb5552$var$definePropertyModule$2 = $2e1e297565bb5552$var$objectDefineProperty;
var $2e1e297565bb5552$var$copyConstructorProperties$2 = function copyConstructorProperties$2(target, source, exceptions) {
    var keys = $2e1e297565bb5552$var$ownKeys(source);
    var defineProperty = $2e1e297565bb5552$var$definePropertyModule$2.f;
    var getOwnPropertyDescriptor = $2e1e297565bb5552$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$2e1e297565bb5552$var$hasOwn$5(target, key) && !(exceptions && $2e1e297565bb5552$var$hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $2e1e297565bb5552$var$fails$9 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$isCallable$b = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$replacement = /#|\.prototype\./;
var $2e1e297565bb5552$var$isForced$2 = function isForced$2(feature, detection) {
    var value = $2e1e297565bb5552$var$data[$2e1e297565bb5552$var$normalize(feature)];
    return value == $2e1e297565bb5552$var$POLYFILL ? true : value == $2e1e297565bb5552$var$NATIVE ? false : $2e1e297565bb5552$var$isCallable$b(detection) ? $2e1e297565bb5552$var$fails$9(detection) : !!detection;
};
var $2e1e297565bb5552$var$normalize = $2e1e297565bb5552$var$isForced$2.normalize = function normalize(string) {
    return String(string).replace($2e1e297565bb5552$var$replacement, ".").toLowerCase();
};
var $2e1e297565bb5552$var$data = $2e1e297565bb5552$var$isForced$2.data = {};
var $2e1e297565bb5552$var$NATIVE = $2e1e297565bb5552$var$isForced$2.NATIVE = "N";
var $2e1e297565bb5552$var$POLYFILL = $2e1e297565bb5552$var$isForced$2.POLYFILL = "P";
var $2e1e297565bb5552$var$isForced_1 = $2e1e297565bb5552$var$isForced$2;
var $2e1e297565bb5552$var$global$b = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$getOwnPropertyDescriptor$1 = $2e1e297565bb5552$var$objectGetOwnPropertyDescriptor.f;
var $2e1e297565bb5552$var$createNonEnumerableProperty$2 = $2e1e297565bb5552$var$createNonEnumerableProperty$4;
var $2e1e297565bb5552$var$defineBuiltIn$5 = $2e1e297565bb5552$var$defineBuiltIn$6;
var $2e1e297565bb5552$var$defineGlobalProperty = $2e1e297565bb5552$var$defineGlobalProperty$3;
var $2e1e297565bb5552$var$copyConstructorProperties$1 = $2e1e297565bb5552$var$copyConstructorProperties$2;
var $2e1e297565bb5552$var$isForced$1 = $2e1e297565bb5552$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $2e1e297565bb5552$var$_export = function _export(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $2e1e297565bb5552$var$global$b;
    else if (STATIC) target = $2e1e297565bb5552$var$global$b[TARGET] || $2e1e297565bb5552$var$defineGlobalProperty(TARGET, {});
    else target = ($2e1e297565bb5552$var$global$b[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $2e1e297565bb5552$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $2e1e297565bb5552$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $1ObTH._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $1ObTH._)(targetProperty))) continue;
            $2e1e297565bb5552$var$copyConstructorProperties$1(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $2e1e297565bb5552$var$createNonEnumerableProperty$2(sourceProperty, "sham", true);
        $2e1e297565bb5552$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $2e1e297565bb5552$var$fails$8 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$correctPrototypeGetter = !$2e1e297565bb5552$var$fails$8(function() {
    var F = function F() {};
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $2e1e297565bb5552$var$hasOwn$4 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$isCallable$a = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$toObject$3 = $2e1e297565bb5552$var$toObject$5;
var $2e1e297565bb5552$var$sharedKey = $2e1e297565bb5552$var$sharedKey$3;
var $2e1e297565bb5552$var$CORRECT_PROTOTYPE_GETTER = $2e1e297565bb5552$var$correctPrototypeGetter;
var $2e1e297565bb5552$var$IE_PROTO = $2e1e297565bb5552$var$sharedKey("IE_PROTO");
var $2e1e297565bb5552$var$$Object$1 = Object;
var $2e1e297565bb5552$var$ObjectPrototype = $2e1e297565bb5552$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $2e1e297565bb5552$var$objectGetPrototypeOf = $2e1e297565bb5552$var$CORRECT_PROTOTYPE_GETTER ? $2e1e297565bb5552$var$$Object$1.getPrototypeOf : function objectGetPrototypeOf(O) {
    var object = $2e1e297565bb5552$var$toObject$3(O);
    if ($2e1e297565bb5552$var$hasOwn$4(object, $2e1e297565bb5552$var$IE_PROTO)) return object[$2e1e297565bb5552$var$IE_PROTO];
    var constructor = object.constructor;
    if ($2e1e297565bb5552$var$isCallable$a(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $2e1e297565bb5552$var$$Object$1 ? $2e1e297565bb5552$var$ObjectPrototype : null;
};
var $2e1e297565bb5552$var$fails$7 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$isCallable$9 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$getPrototypeOf$1 = $2e1e297565bb5552$var$objectGetPrototypeOf;
var $2e1e297565bb5552$var$defineBuiltIn$4 = $2e1e297565bb5552$var$defineBuiltIn$6;
var $2e1e297565bb5552$var$wellKnownSymbol$d = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$ITERATOR$5 = $2e1e297565bb5552$var$wellKnownSymbol$d("iterator");
var $2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $2e1e297565bb5552$var$IteratorPrototype$2, $2e1e297565bb5552$var$PrototypeOfArrayIteratorPrototype, $2e1e297565bb5552$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $2e1e297565bb5552$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $2e1e297565bb5552$var$arrayIterator)) $2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $2e1e297565bb5552$var$PrototypeOfArrayIteratorPrototype = $2e1e297565bb5552$var$getPrototypeOf$1($2e1e297565bb5552$var$getPrototypeOf$1($2e1e297565bb5552$var$arrayIterator));
        if ($2e1e297565bb5552$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $2e1e297565bb5552$var$IteratorPrototype$2 = $2e1e297565bb5552$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $2e1e297565bb5552$var$NEW_ITERATOR_PROTOTYPE = $2e1e297565bb5552$var$IteratorPrototype$2 == undefined || $2e1e297565bb5552$var$fails$7(function() {
    var test = {};
    // FF44- legacy iterators case
    return $2e1e297565bb5552$var$IteratorPrototype$2[$2e1e297565bb5552$var$ITERATOR$5].call(test) !== test;
});
if ($2e1e297565bb5552$var$NEW_ITERATOR_PROTOTYPE) $2e1e297565bb5552$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$2e1e297565bb5552$var$isCallable$9($2e1e297565bb5552$var$IteratorPrototype$2[$2e1e297565bb5552$var$ITERATOR$5])) $2e1e297565bb5552$var$defineBuiltIn$4($2e1e297565bb5552$var$IteratorPrototype$2, $2e1e297565bb5552$var$ITERATOR$5, function() {
    return this;
});
var $2e1e297565bb5552$var$iteratorsCore = {
    IteratorPrototype: $2e1e297565bb5552$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS$1
};
var $2e1e297565bb5552$var$defineProperty$3 = $2e1e297565bb5552$var$objectDefineProperty.f;
var $2e1e297565bb5552$var$hasOwn$3 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$wellKnownSymbol$c = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$TO_STRING_TAG$3 = $2e1e297565bb5552$var$wellKnownSymbol$c("toStringTag");
var $2e1e297565bb5552$var$setToStringTag$3 = function setToStringTag$3(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$2e1e297565bb5552$var$hasOwn$3(target, $2e1e297565bb5552$var$TO_STRING_TAG$3)) $2e1e297565bb5552$var$defineProperty$3(target, $2e1e297565bb5552$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $2e1e297565bb5552$var$IteratorPrototype$1 = $2e1e297565bb5552$var$iteratorsCore.IteratorPrototype;
var $2e1e297565bb5552$var$create = $2e1e297565bb5552$var$objectCreate;
var $2e1e297565bb5552$var$createPropertyDescriptor$1 = $2e1e297565bb5552$var$createPropertyDescriptor$4;
var $2e1e297565bb5552$var$setToStringTag$2 = $2e1e297565bb5552$var$setToStringTag$3;
var $2e1e297565bb5552$var$Iterators$4 = $2e1e297565bb5552$var$iterators;
var $2e1e297565bb5552$var$returnThis$1 = function returnThis$1() {
    return this;
};
var $2e1e297565bb5552$var$createIteratorConstructor$1 = function createIteratorConstructor$1(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $2e1e297565bb5552$var$create($2e1e297565bb5552$var$IteratorPrototype$1, {
        next: $2e1e297565bb5552$var$createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
    });
    $2e1e297565bb5552$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $2e1e297565bb5552$var$Iterators$4[TO_STRING_TAG] = $2e1e297565bb5552$var$returnThis$1;
    return IteratorConstructor;
};
var $2e1e297565bb5552$var$isCallable$8 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$$String$1 = String;
var $2e1e297565bb5552$var$$TypeError$8 = TypeError;
var $2e1e297565bb5552$var$aPossiblePrototype$1 = function aPossiblePrototype$1(argument) {
    if (typeof argument == "object" || $2e1e297565bb5552$var$isCallable$8(argument)) return argument;
    throw $2e1e297565bb5552$var$$TypeError$8("Can't set " + $2e1e297565bb5552$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $2e1e297565bb5552$var$uncurryThis$7 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$anObject$7 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$aPossiblePrototype = $2e1e297565bb5552$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $2e1e297565bb5552$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $2e1e297565bb5552$var$uncurryThis$7(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $2e1e297565bb5552$var$anObject$7(O);
        $2e1e297565bb5552$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $2e1e297565bb5552$var$$$c = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$call$a = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$FunctionName = $2e1e297565bb5552$var$functionName;
var $2e1e297565bb5552$var$isCallable$7 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$createIteratorConstructor = $2e1e297565bb5552$var$createIteratorConstructor$1;
var $2e1e297565bb5552$var$getPrototypeOf = $2e1e297565bb5552$var$objectGetPrototypeOf;
var $2e1e297565bb5552$var$setPrototypeOf$1 = $2e1e297565bb5552$var$objectSetPrototypeOf;
var $2e1e297565bb5552$var$setToStringTag$1 = $2e1e297565bb5552$var$setToStringTag$3;
var $2e1e297565bb5552$var$createNonEnumerableProperty$1 = $2e1e297565bb5552$var$createNonEnumerableProperty$4;
var $2e1e297565bb5552$var$defineBuiltIn$3 = $2e1e297565bb5552$var$defineBuiltIn$6;
var $2e1e297565bb5552$var$wellKnownSymbol$b = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$Iterators$3 = $2e1e297565bb5552$var$iterators;
var $2e1e297565bb5552$var$IteratorsCore = $2e1e297565bb5552$var$iteratorsCore;
var $2e1e297565bb5552$var$PROPER_FUNCTION_NAME$1 = $2e1e297565bb5552$var$FunctionName.PROPER;
var $2e1e297565bb5552$var$CONFIGURABLE_FUNCTION_NAME = $2e1e297565bb5552$var$FunctionName.CONFIGURABLE;
var $2e1e297565bb5552$var$IteratorPrototype = $2e1e297565bb5552$var$IteratorsCore.IteratorPrototype;
var $2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS = $2e1e297565bb5552$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $2e1e297565bb5552$var$ITERATOR$4 = $2e1e297565bb5552$var$wellKnownSymbol$b("iterator");
var $2e1e297565bb5552$var$KEYS = "keys";
var $2e1e297565bb5552$var$VALUES = "values";
var $2e1e297565bb5552$var$ENTRIES = "entries";
var $2e1e297565bb5552$var$returnThis = function returnThis() {
    return this;
};
var $2e1e297565bb5552$var$defineIterator$1 = function defineIterator$1(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2e1e297565bb5552$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $2e1e297565bb5552$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $2e1e297565bb5552$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $2e1e297565bb5552$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$2e1e297565bb5552$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $2e1e297565bb5552$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($2e1e297565bb5552$var$getPrototypeOf(CurrentIteratorPrototype) !== $2e1e297565bb5552$var$IteratorPrototype) {
                if ($2e1e297565bb5552$var$setPrototypeOf$1) $2e1e297565bb5552$var$setPrototypeOf$1(CurrentIteratorPrototype, $2e1e297565bb5552$var$IteratorPrototype);
                else if (!$2e1e297565bb5552$var$isCallable$7(CurrentIteratorPrototype[$2e1e297565bb5552$var$ITERATOR$4])) $2e1e297565bb5552$var$defineBuiltIn$3(CurrentIteratorPrototype, $2e1e297565bb5552$var$ITERATOR$4, $2e1e297565bb5552$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $2e1e297565bb5552$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($2e1e297565bb5552$var$PROPER_FUNCTION_NAME$1 && DEFAULT == $2e1e297565bb5552$var$VALUES && nativeIterator && nativeIterator.name !== $2e1e297565bb5552$var$VALUES) {
        if ($2e1e297565bb5552$var$CONFIGURABLE_FUNCTION_NAME) $2e1e297565bb5552$var$createNonEnumerableProperty$1(IterablePrototype, "name", $2e1e297565bb5552$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $2e1e297565bb5552$var$call$a(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($2e1e297565bb5552$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($2e1e297565bb5552$var$KEYS),
            entries: getIterationMethod($2e1e297565bb5552$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $2e1e297565bb5552$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $2e1e297565bb5552$var$$$c({
            target: NAME,
            proto: true,
            forced: $2e1e297565bb5552$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$2e1e297565bb5552$var$ITERATOR$4] !== defaultIterator) $2e1e297565bb5552$var$defineBuiltIn$3(IterablePrototype, $2e1e297565bb5552$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $2e1e297565bb5552$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $2e1e297565bb5552$var$toIndexedObject = $2e1e297565bb5552$var$toIndexedObject$5;
var $2e1e297565bb5552$var$addToUnscopables$1 = $2e1e297565bb5552$var$addToUnscopables$2;
var $2e1e297565bb5552$var$Iterators$2 = $2e1e297565bb5552$var$iterators;
var $2e1e297565bb5552$var$InternalStateModule$1 = $2e1e297565bb5552$var$internalState;
var $2e1e297565bb5552$var$defineProperty$2 = $2e1e297565bb5552$var$objectDefineProperty.f;
var $2e1e297565bb5552$var$defineIterator = $2e1e297565bb5552$var$defineIterator$1;
var $2e1e297565bb5552$var$DESCRIPTORS$3 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$ARRAY_ITERATOR = "Array Iterator";
var $2e1e297565bb5552$var$setInternalState$1 = $2e1e297565bb5552$var$InternalStateModule$1.set;
var $2e1e297565bb5552$var$getInternalState = $2e1e297565bb5552$var$InternalStateModule$1.getterFor($2e1e297565bb5552$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $2e1e297565bb5552$var$es_array_iterator = $2e1e297565bb5552$var$defineIterator(Array, "Array", function(iterated, kind) {
    $2e1e297565bb5552$var$setInternalState$1(this, {
        type: $2e1e297565bb5552$var$ARRAY_ITERATOR,
        target: $2e1e297565bb5552$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $2e1e297565bb5552$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $2e1e297565bb5552$var$values = $2e1e297565bb5552$var$Iterators$2.Arguments = $2e1e297565bb5552$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$2e1e297565bb5552$var$addToUnscopables$1("keys");
$2e1e297565bb5552$var$addToUnscopables$1("values");
$2e1e297565bb5552$var$addToUnscopables$1("entries");
// V8 ~ Chrome 45- bug
if ($2e1e297565bb5552$var$DESCRIPTORS$3 && $2e1e297565bb5552$var$values.name !== "values") try {
    $2e1e297565bb5552$var$defineProperty$2($2e1e297565bb5552$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $2e1e297565bb5552$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $2e1e297565bb5552$var$documentCreateElement = $2e1e297565bb5552$var$documentCreateElement$2;
var $2e1e297565bb5552$var$classList = $2e1e297565bb5552$var$documentCreateElement("span").classList;
var $2e1e297565bb5552$var$DOMTokenListPrototype$1 = $2e1e297565bb5552$var$classList && $2e1e297565bb5552$var$classList.constructor && $2e1e297565bb5552$var$classList.constructor.prototype;
var $2e1e297565bb5552$var$domTokenListPrototype = $2e1e297565bb5552$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $2e1e297565bb5552$var$DOMTokenListPrototype$1;
var $2e1e297565bb5552$var$global$a = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$DOMIterables = $2e1e297565bb5552$var$domIterables;
var $2e1e297565bb5552$var$DOMTokenListPrototype = $2e1e297565bb5552$var$domTokenListPrototype;
var $2e1e297565bb5552$var$ArrayIteratorMethods = $2e1e297565bb5552$var$es_array_iterator;
var $2e1e297565bb5552$var$createNonEnumerableProperty = $2e1e297565bb5552$var$createNonEnumerableProperty$4;
var $2e1e297565bb5552$var$wellKnownSymbol$a = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$ITERATOR$3 = $2e1e297565bb5552$var$wellKnownSymbol$a("iterator");
var $2e1e297565bb5552$var$TO_STRING_TAG$2 = $2e1e297565bb5552$var$wellKnownSymbol$a("toStringTag");
var $2e1e297565bb5552$var$ArrayValues = $2e1e297565bb5552$var$ArrayIteratorMethods.values;
var $2e1e297565bb5552$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$2e1e297565bb5552$var$ITERATOR$3] !== $2e1e297565bb5552$var$ArrayValues) try {
            $2e1e297565bb5552$var$createNonEnumerableProperty(CollectionPrototype, $2e1e297565bb5552$var$ITERATOR$3, $2e1e297565bb5552$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$2e1e297565bb5552$var$ITERATOR$3] = $2e1e297565bb5552$var$ArrayValues;
        }
        if (!CollectionPrototype[$2e1e297565bb5552$var$TO_STRING_TAG$2]) $2e1e297565bb5552$var$createNonEnumerableProperty(CollectionPrototype, $2e1e297565bb5552$var$TO_STRING_TAG$2, COLLECTION_NAME);
        if ($2e1e297565bb5552$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $2e1e297565bb5552$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $2e1e297565bb5552$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $2e1e297565bb5552$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $2e1e297565bb5552$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $2e1e297565bb5552$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $2e1e297565bb5552$var$COLLECTION_NAME in $2e1e297565bb5552$var$DOMIterables)$2e1e297565bb5552$var$handlePrototype($2e1e297565bb5552$var$global$a[$2e1e297565bb5552$var$COLLECTION_NAME] && $2e1e297565bb5552$var$global$a[$2e1e297565bb5552$var$COLLECTION_NAME].prototype, $2e1e297565bb5552$var$COLLECTION_NAME);
$2e1e297565bb5552$var$handlePrototype($2e1e297565bb5552$var$DOMTokenListPrototype, "DOMTokenList");
var $2e1e297565bb5552$var$DESCRIPTORS$2 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$uncurryThis$6 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$call$9 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$fails$6 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$objectKeys = $2e1e297565bb5552$var$objectKeys$2;
var $2e1e297565bb5552$var$getOwnPropertySymbolsModule = $2e1e297565bb5552$var$objectGetOwnPropertySymbols;
var $2e1e297565bb5552$var$propertyIsEnumerableModule = $2e1e297565bb5552$var$objectPropertyIsEnumerable;
var $2e1e297565bb5552$var$toObject$2 = $2e1e297565bb5552$var$toObject$5;
var $2e1e297565bb5552$var$IndexedObject$1 = $2e1e297565bb5552$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $2e1e297565bb5552$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $2e1e297565bb5552$var$defineProperty$1 = Object.defineProperty;
var $2e1e297565bb5552$var$concat = $2e1e297565bb5552$var$uncurryThis$6([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $2e1e297565bb5552$var$objectAssign = !$2e1e297565bb5552$var$$assign || $2e1e297565bb5552$var$fails$6(function() {
    // should have correct order of operations (Edge bug)
    if ($2e1e297565bb5552$var$DESCRIPTORS$2 && $2e1e297565bb5552$var$$assign({
        b: 1
    }, $2e1e297565bb5552$var$$assign($2e1e297565bb5552$var$defineProperty$1({}, "a", {
        enumerable: true,
        get: function get() {
            $2e1e297565bb5552$var$defineProperty$1(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $2e1e297565bb5552$var$$assign({}, A)[symbol] != 7 || $2e1e297565bb5552$var$objectKeys($2e1e297565bb5552$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $2e1e297565bb5552$var$toObject$2(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $2e1e297565bb5552$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $2e1e297565bb5552$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $2e1e297565bb5552$var$IndexedObject$1(arguments[index++]);
        var keys = getOwnPropertySymbols ? $2e1e297565bb5552$var$concat($2e1e297565bb5552$var$objectKeys(S), getOwnPropertySymbols(S)) : $2e1e297565bb5552$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2e1e297565bb5552$var$DESCRIPTORS$2 || $2e1e297565bb5552$var$call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $2e1e297565bb5552$var$$assign;
var $2e1e297565bb5552$var$$$b = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$assign = $2e1e297565bb5552$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$2e1e297565bb5552$var$$$b({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $2e1e297565bb5552$var$assign
}, {
    assign: $2e1e297565bb5552$var$assign
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $2e1e297565bb5552$var$__awaiter(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $2e1e297565bb5552$var$CloseButton = function(param) {
    var onClick = param.onClick;
    return (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
        onClick: onClick,
        className: "close-button"
    }, {
        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            fill: "#C1C1C1"
        }, {
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                })
            ]
        }))
    }));
};
var $2e1e297565bb5552$var$ModalHeader = function(param) {
    var title = param.title, onCloseModal = param.onCloseModal;
    var additionalClasses = title === "Get a Wallet" ? " -open" : "";
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
        className: "nws-modal-header"
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("h3", Object.assign({
                className: "middleTitle ".concat(additionalClasses)
            }, {
                children: title
            })),
            (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$CloseButton, {
                onClick: onCloseModal
            })
        ]
    }));
};
var $2e1e297565bb5552$var$BackArrow = function(param) {
    var onClick = param.onClick;
    return (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
        onClick: onClick,
        className: "back-button"
    }, {
        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", Object.assign({
            width: "8",
            height: "14",
            viewBox: "0 0 8 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, {
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M7 13L1 7L7 1",
                stroke: "#6494EE",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }))
    }));
};
var $2e1e297565bb5552$var$WalletNetworkChanged = function(param) {
    var selector = param.selector, onBack = param.onBack, onCloseModal = param.onCloseModal;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6cds3.Fragment), {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$BackArrow, {
                        onClick: onBack
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                        title: "You Must Change the Network",
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "switch-network-message-wrapper"
            }, {
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                "We've detected that you need to change your wallet's network to",
                                (0, $fba0f23e9e6a11bb$exports.jsx)("strong", Object.assign({
                                    className: "network-id"
                                }, {
                                    children: " ".concat(selector.options.network.networkId)
                                })),
                                " ",
                                "for this dApp."
                            ]
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            children: "Some wallets may not support changing networks. If you can not change networks you may consider switching to another wallet."
                        })
                    ]
                }))
            }))
        ]
    });
};
var $2e1e297565bb5552$var$tryToString$3 = $2e1e297565bb5552$var$tryToString$5;
var $2e1e297565bb5552$var$$TypeError$7 = TypeError;
var $2e1e297565bb5552$var$deletePropertyOrThrow$1 = function deletePropertyOrThrow$1(O, P) {
    if (!delete O[P]) throw $2e1e297565bb5552$var$$TypeError$7("Cannot delete property " + $2e1e297565bb5552$var$tryToString$3(P) + " of " + $2e1e297565bb5552$var$tryToString$3(O));
};
var $2e1e297565bb5552$var$wellKnownSymbol$9 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$TO_STRING_TAG$1 = $2e1e297565bb5552$var$wellKnownSymbol$9("toStringTag");
var $2e1e297565bb5552$var$test$1 = {};
$2e1e297565bb5552$var$test$1[$2e1e297565bb5552$var$TO_STRING_TAG$1] = "z";
var $2e1e297565bb5552$var$toStringTagSupport = String($2e1e297565bb5552$var$test$1) === "[object z]";
var $2e1e297565bb5552$var$TO_STRING_TAG_SUPPORT = $2e1e297565bb5552$var$toStringTagSupport;
var $2e1e297565bb5552$var$isCallable$6 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$classofRaw = $2e1e297565bb5552$var$classofRaw$1;
var $2e1e297565bb5552$var$wellKnownSymbol$8 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$TO_STRING_TAG = $2e1e297565bb5552$var$wellKnownSymbol$8("toStringTag");
var $2e1e297565bb5552$var$$Object = Object;
// ES3 wrong here
var $2e1e297565bb5552$var$CORRECT_ARGUMENTS = $2e1e297565bb5552$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $2e1e297565bb5552$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $2e1e297565bb5552$var$classof$5 = $2e1e297565bb5552$var$TO_STRING_TAG_SUPPORT ? $2e1e297565bb5552$var$classofRaw : function classof$5(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $2e1e297565bb5552$var$tryGet(O = $2e1e297565bb5552$var$$Object(it), $2e1e297565bb5552$var$TO_STRING_TAG)) == "string" ? tag : $2e1e297565bb5552$var$CORRECT_ARGUMENTS ? $2e1e297565bb5552$var$classofRaw(O) : (result = $2e1e297565bb5552$var$classofRaw(O)) == "Object" && $2e1e297565bb5552$var$isCallable$6(O.callee) ? "Arguments" : result;
};
var $2e1e297565bb5552$var$classof$4 = $2e1e297565bb5552$var$classof$5;
var $2e1e297565bb5552$var$$String = String;
var $2e1e297565bb5552$var$toString$3 = function toString$3(argument) {
    if ($2e1e297565bb5552$var$classof$4(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $2e1e297565bb5552$var$$String(argument);
};
var $2e1e297565bb5552$var$toPropertyKey = $2e1e297565bb5552$var$toPropertyKey$3;
var $2e1e297565bb5552$var$definePropertyModule$1 = $2e1e297565bb5552$var$objectDefineProperty;
var $2e1e297565bb5552$var$createPropertyDescriptor = $2e1e297565bb5552$var$createPropertyDescriptor$4;
var $2e1e297565bb5552$var$createProperty$1 = function createProperty$1(object, key, value) {
    var propertyKey = $2e1e297565bb5552$var$toPropertyKey(key);
    if (propertyKey in object) $2e1e297565bb5552$var$definePropertyModule$1.f(object, propertyKey, $2e1e297565bb5552$var$createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
};
var $2e1e297565bb5552$var$toAbsoluteIndex = $2e1e297565bb5552$var$toAbsoluteIndex$2;
var $2e1e297565bb5552$var$lengthOfArrayLike$3 = $2e1e297565bb5552$var$lengthOfArrayLike$5;
var $2e1e297565bb5552$var$createProperty = $2e1e297565bb5552$var$createProperty$1;
var $2e1e297565bb5552$var$$Array = Array;
var $2e1e297565bb5552$var$max = Math.max;
var $2e1e297565bb5552$var$arraySliceSimple = function arraySliceSimple(O, start, end) {
    var length = $2e1e297565bb5552$var$lengthOfArrayLike$3(O);
    var k = $2e1e297565bb5552$var$toAbsoluteIndex(start, length);
    var fin = $2e1e297565bb5552$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $2e1e297565bb5552$var$$Array($2e1e297565bb5552$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$2e1e297565bb5552$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $2e1e297565bb5552$var$arraySlice$2 = $2e1e297565bb5552$var$arraySliceSimple;
var $2e1e297565bb5552$var$floor = Math.floor;
var $2e1e297565bb5552$var$mergeSort = function mergeSort1(array, comparefn) {
    var length = array.length;
    var middle = $2e1e297565bb5552$var$floor(length / 2);
    return length < 8 ? $2e1e297565bb5552$var$insertionSort(array, comparefn) : $2e1e297565bb5552$var$merge(array, $2e1e297565bb5552$var$mergeSort($2e1e297565bb5552$var$arraySlice$2(array, 0, middle), comparefn), $2e1e297565bb5552$var$mergeSort($2e1e297565bb5552$var$arraySlice$2(array, middle), comparefn), comparefn);
};
var $2e1e297565bb5552$var$insertionSort = function insertionSort(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $2e1e297565bb5552$var$merge = function merge(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $2e1e297565bb5552$var$arraySort = $2e1e297565bb5552$var$mergeSort;
var $2e1e297565bb5552$var$fails$5 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$arrayMethodIsStrict$2 = function arrayMethodIsStrict$2(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $2e1e297565bb5552$var$fails$5(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $2e1e297565bb5552$var$userAgent$4 = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$firefox = $2e1e297565bb5552$var$userAgent$4.match(/firefox\/(\d+)/i);
var $2e1e297565bb5552$var$engineFfVersion = !!$2e1e297565bb5552$var$firefox && +$2e1e297565bb5552$var$firefox[1];
var $2e1e297565bb5552$var$UA = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$engineIsIeOrEdge = /MSIE|Trident/.test($2e1e297565bb5552$var$UA);
var $2e1e297565bb5552$var$userAgent$3 = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$webkit = $2e1e297565bb5552$var$userAgent$3.match(/AppleWebKit\/(\d+)\./);
var $2e1e297565bb5552$var$engineWebkitVersion = !!$2e1e297565bb5552$var$webkit && +$2e1e297565bb5552$var$webkit[1];
var $2e1e297565bb5552$var$$$a = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$uncurryThis$5 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$aCallable$7 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$toObject$1 = $2e1e297565bb5552$var$toObject$5;
var $2e1e297565bb5552$var$lengthOfArrayLike$2 = $2e1e297565bb5552$var$lengthOfArrayLike$5;
var $2e1e297565bb5552$var$deletePropertyOrThrow = $2e1e297565bb5552$var$deletePropertyOrThrow$1;
var $2e1e297565bb5552$var$toString$2 = $2e1e297565bb5552$var$toString$3;
var $2e1e297565bb5552$var$fails$4 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$internalSort = $2e1e297565bb5552$var$arraySort;
var $2e1e297565bb5552$var$arrayMethodIsStrict$1 = $2e1e297565bb5552$var$arrayMethodIsStrict$2;
var $2e1e297565bb5552$var$FF = $2e1e297565bb5552$var$engineFfVersion;
var $2e1e297565bb5552$var$IE_OR_EDGE = $2e1e297565bb5552$var$engineIsIeOrEdge;
var $2e1e297565bb5552$var$V8 = $2e1e297565bb5552$var$engineV8Version;
var $2e1e297565bb5552$var$WEBKIT = $2e1e297565bb5552$var$engineWebkitVersion;
var $2e1e297565bb5552$var$test = [];
var $2e1e297565bb5552$var$un$Sort = $2e1e297565bb5552$var$uncurryThis$5($2e1e297565bb5552$var$test.sort);
var $2e1e297565bb5552$var$push = $2e1e297565bb5552$var$uncurryThis$5($2e1e297565bb5552$var$test.push);
// IE8-
var $2e1e297565bb5552$var$FAILS_ON_UNDEFINED = $2e1e297565bb5552$var$fails$4(function() {
    $2e1e297565bb5552$var$test.sort(undefined);
});
// V8 bug
var $2e1e297565bb5552$var$FAILS_ON_NULL = $2e1e297565bb5552$var$fails$4(function() {
    $2e1e297565bb5552$var$test.sort(null);
});
// Old WebKit
var $2e1e297565bb5552$var$STRICT_METHOD$1 = $2e1e297565bb5552$var$arrayMethodIsStrict$1("sort");
var $2e1e297565bb5552$var$STABLE_SORT = !$2e1e297565bb5552$var$fails$4(function() {
    // feature detection can be too slow, so check engines versions
    if ($2e1e297565bb5552$var$V8) return $2e1e297565bb5552$var$V8 < 70;
    if ($2e1e297565bb5552$var$FF && $2e1e297565bb5552$var$FF > 3) return;
    if ($2e1e297565bb5552$var$IE_OR_EDGE) return true;
    if ($2e1e297565bb5552$var$WEBKIT) return $2e1e297565bb5552$var$WEBKIT < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$2e1e297565bb5552$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $2e1e297565bb5552$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $2e1e297565bb5552$var$test.length; index++){
        chr = $2e1e297565bb5552$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $2e1e297565bb5552$var$FORCED = $2e1e297565bb5552$var$FAILS_ON_UNDEFINED || !$2e1e297565bb5552$var$FAILS_ON_NULL || !$2e1e297565bb5552$var$STRICT_METHOD$1 || !$2e1e297565bb5552$var$STABLE_SORT;
var $2e1e297565bb5552$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $2e1e297565bb5552$var$toString$2(x) > $2e1e297565bb5552$var$toString$2(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$2e1e297565bb5552$var$$$a({
    target: "Array",
    proto: true,
    forced: $2e1e297565bb5552$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $2e1e297565bb5552$var$aCallable$7(comparefn);
        var array = $2e1e297565bb5552$var$toObject$1(this);
        if ($2e1e297565bb5552$var$STABLE_SORT) return comparefn === undefined ? $2e1e297565bb5552$var$un$Sort(array) : $2e1e297565bb5552$var$un$Sort(array, comparefn);
        var items = [];
        var arrayLength = $2e1e297565bb5552$var$lengthOfArrayLike$2(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $2e1e297565bb5552$var$push(items, array[index]);
        $2e1e297565bb5552$var$internalSort(items, $2e1e297565bb5552$var$getSortCompare(comparefn));
        itemsLength = items.length;
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$2e1e297565bb5552$var$deletePropertyOrThrow(array, index++);
        return array;
    }
});
var $2e1e297565bb5552$var$$$9 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$$includes = $2e1e297565bb5552$var$arrayIncludes.includes;
var $2e1e297565bb5552$var$fails$3 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$addToUnscopables = $2e1e297565bb5552$var$addToUnscopables$2;
// FF99+ bug
var $2e1e297565bb5552$var$BROKEN_ON_SPARSE = $2e1e297565bb5552$var$fails$3(function() {
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$2e1e297565bb5552$var$$$9({
    target: "Array",
    proto: true,
    forced: $2e1e297565bb5552$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $2e1e297565bb5552$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$2e1e297565bb5552$var$addToUnscopables("includes");
var $2e1e297565bb5552$var$isObject$2 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$classof$3 = $2e1e297565bb5552$var$classofRaw$1;
var $2e1e297565bb5552$var$wellKnownSymbol$7 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$MATCH$1 = $2e1e297565bb5552$var$wellKnownSymbol$7("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $2e1e297565bb5552$var$isRegexp = function isRegexp(it) {
    var isRegExp;
    return $2e1e297565bb5552$var$isObject$2(it) && ((isRegExp = it[$2e1e297565bb5552$var$MATCH$1]) !== undefined ? !!isRegExp : $2e1e297565bb5552$var$classof$3(it) == "RegExp");
};
var $2e1e297565bb5552$var$isRegExp = $2e1e297565bb5552$var$isRegexp;
var $2e1e297565bb5552$var$$TypeError$6 = TypeError;
var $2e1e297565bb5552$var$notARegexp = function notARegexp(it) {
    if ($2e1e297565bb5552$var$isRegExp(it)) throw $2e1e297565bb5552$var$$TypeError$6("The method doesn't accept regular expressions");
    return it;
};
var $2e1e297565bb5552$var$wellKnownSymbol$6 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$MATCH = $2e1e297565bb5552$var$wellKnownSymbol$6("match");
var $2e1e297565bb5552$var$correctIsRegexpLogic = function correctIsRegexpLogic(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$2e1e297565bb5552$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $2e1e297565bb5552$var$$$8 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$uncurryThis$4 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$notARegExp = $2e1e297565bb5552$var$notARegexp;
var $2e1e297565bb5552$var$requireObjectCoercible = $2e1e297565bb5552$var$requireObjectCoercible$3;
var $2e1e297565bb5552$var$toString$1 = $2e1e297565bb5552$var$toString$3;
var $2e1e297565bb5552$var$correctIsRegExpLogic = $2e1e297565bb5552$var$correctIsRegexpLogic;
var $2e1e297565bb5552$var$stringIndexOf = $2e1e297565bb5552$var$uncurryThis$4("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$2e1e297565bb5552$var$$$8({
    target: "String",
    proto: true,
    forced: !$2e1e297565bb5552$var$correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$2e1e297565bb5552$var$stringIndexOf($2e1e297565bb5552$var$toString$1($2e1e297565bb5552$var$requireObjectCoercible(this)), $2e1e297565bb5552$var$toString$1($2e1e297565bb5552$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $2e1e297565bb5552$var$aCallable$6 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$toObject = $2e1e297565bb5552$var$toObject$5;
var $2e1e297565bb5552$var$IndexedObject = $2e1e297565bb5552$var$indexedObject;
var $2e1e297565bb5552$var$lengthOfArrayLike$1 = $2e1e297565bb5552$var$lengthOfArrayLike$5;
var $2e1e297565bb5552$var$$TypeError$5 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $2e1e297565bb5552$var$createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $2e1e297565bb5552$var$aCallable$6(callbackfn);
        var O = $2e1e297565bb5552$var$toObject(that);
        var _$self = $2e1e297565bb5552$var$IndexedObject(O);
        var length = $2e1e297565bb5552$var$lengthOfArrayLike$1(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in _$self) {
                memo = _$self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $2e1e297565bb5552$var$$TypeError$5("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in _$self) memo = callbackfn(memo, _$self[index], index, O);
        return memo;
    };
};
var $2e1e297565bb5552$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $2e1e297565bb5552$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $2e1e297565bb5552$var$createMethod(true)
};
var $2e1e297565bb5552$var$classof$2 = $2e1e297565bb5552$var$classofRaw$1;
var $2e1e297565bb5552$var$global$9 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$engineIsNode = $2e1e297565bb5552$var$classof$2($2e1e297565bb5552$var$global$9.process) == "process";
var $2e1e297565bb5552$var$$$7 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$$reduce = $2e1e297565bb5552$var$arrayReduce.left;
var $2e1e297565bb5552$var$arrayMethodIsStrict = $2e1e297565bb5552$var$arrayMethodIsStrict$2;
var $2e1e297565bb5552$var$CHROME_VERSION = $2e1e297565bb5552$var$engineV8Version;
var $2e1e297565bb5552$var$IS_NODE$3 = $2e1e297565bb5552$var$engineIsNode;
var $2e1e297565bb5552$var$STRICT_METHOD = $2e1e297565bb5552$var$arrayMethodIsStrict("reduce");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $2e1e297565bb5552$var$CHROME_BUG = !$2e1e297565bb5552$var$IS_NODE$3 && $2e1e297565bb5552$var$CHROME_VERSION > 79 && $2e1e297565bb5552$var$CHROME_VERSION < 83;
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$2e1e297565bb5552$var$$$7({
    target: "Array",
    proto: true,
    forced: !$2e1e297565bb5552$var$STRICT_METHOD || $2e1e297565bb5552$var$CHROME_BUG
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $2e1e297565bb5552$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $2e1e297565bb5552$var$$$6 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$DESCRIPTORS$1 = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$global$8 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$uncurryThis$3 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$hasOwn$2 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$isCallable$5 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$isPrototypeOf$3 = $2e1e297565bb5552$var$objectIsPrototypeOf;
var $2e1e297565bb5552$var$toString = $2e1e297565bb5552$var$toString$3;
var $2e1e297565bb5552$var$defineProperty = $2e1e297565bb5552$var$objectDefineProperty.f;
var $2e1e297565bb5552$var$copyConstructorProperties = $2e1e297565bb5552$var$copyConstructorProperties$2;
var $2e1e297565bb5552$var$NativeSymbol = $2e1e297565bb5552$var$global$8.Symbol;
var $2e1e297565bb5552$var$SymbolPrototype = $2e1e297565bb5552$var$NativeSymbol && $2e1e297565bb5552$var$NativeSymbol.prototype;
if ($2e1e297565bb5552$var$DESCRIPTORS$1 && $2e1e297565bb5552$var$isCallable$5($2e1e297565bb5552$var$NativeSymbol) && (!("description" in $2e1e297565bb5552$var$SymbolPrototype) || // Safari 12 bug
$2e1e297565bb5552$var$NativeSymbol().description !== undefined)) {
    var $2e1e297565bb5552$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $2e1e297565bb5552$var$SymbolWrapper = function Symbol1() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $2e1e297565bb5552$var$toString(arguments[0]);
        var result = $2e1e297565bb5552$var$isPrototypeOf$3($2e1e297565bb5552$var$SymbolPrototype, this) ? new $2e1e297565bb5552$var$NativeSymbol(description) : description === undefined ? $2e1e297565bb5552$var$NativeSymbol() : $2e1e297565bb5552$var$NativeSymbol(description);
        if (description === "") $2e1e297565bb5552$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $2e1e297565bb5552$var$copyConstructorProperties($2e1e297565bb5552$var$SymbolWrapper, $2e1e297565bb5552$var$NativeSymbol);
    $2e1e297565bb5552$var$SymbolWrapper.prototype = $2e1e297565bb5552$var$SymbolPrototype;
    $2e1e297565bb5552$var$SymbolPrototype.constructor = $2e1e297565bb5552$var$SymbolWrapper;
    var $2e1e297565bb5552$var$NATIVE_SYMBOL = String($2e1e297565bb5552$var$NativeSymbol("test")) == "Symbol(test)";
    var $2e1e297565bb5552$var$symbolToString = $2e1e297565bb5552$var$uncurryThis$3($2e1e297565bb5552$var$SymbolPrototype.toString);
    var $2e1e297565bb5552$var$symbolValueOf = $2e1e297565bb5552$var$uncurryThis$3($2e1e297565bb5552$var$SymbolPrototype.valueOf);
    var $2e1e297565bb5552$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $2e1e297565bb5552$var$replace = $2e1e297565bb5552$var$uncurryThis$3("".replace);
    var $2e1e297565bb5552$var$stringSlice = $2e1e297565bb5552$var$uncurryThis$3("".slice);
    $2e1e297565bb5552$var$defineProperty($2e1e297565bb5552$var$SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = $2e1e297565bb5552$var$symbolValueOf(this);
            var string = $2e1e297565bb5552$var$symbolToString(symbol);
            if ($2e1e297565bb5552$var$hasOwn$2($2e1e297565bb5552$var$EmptyStringDescriptionStore, symbol)) return "";
            var desc = $2e1e297565bb5552$var$NATIVE_SYMBOL ? $2e1e297565bb5552$var$stringSlice(string, 7, -1) : $2e1e297565bb5552$var$replace(string, $2e1e297565bb5552$var$regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $2e1e297565bb5552$var$$$6({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $2e1e297565bb5552$var$SymbolWrapper
    });
}
var $2e1e297565bb5552$var$WalletOptions = function(param) {
    var selector = param.selector, handleWalletClick = param.handleWalletClick;
    var renderOptionsList = function renderOptionsList(modulesToRender) {
        return modulesToRender.reduce(function(result, module, index) {
            var selectedWalletId = selector.store.getState().selectedWalletId;
            var _module_metadata = module.metadata, name = _module_metadata.name, description = _module_metadata.description, iconUrl = _module_metadata.iconUrl, deprecated = _module_metadata.deprecated;
            var selected = module.id === selectedWalletId;
            result.push((0, $fba0f23e9e6a11bb$exports.jsxs)("li", Object.assign({
                tabIndex: 0,
                className: "single-wallet ".concat(activeWalletId === module.id ? "selected-wallet" : "", " ").concat(selected ? "connected-wallet" : "", " ").concat(deprecated ? "deprecated-wallet" : "", " sidebar ").concat(module.id),
                onClick: function() {
                    if (module.id === modulesToRender[index].id) setActiveWalletId(module.id);
                    return handleWalletClick(module);
                }
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "icon"
                    }, {
                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: iconUrl,
                            alt: name
                        })
                    })),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "content"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "title"
                            }, {
                                children: name
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "description"
                            }, {
                                children: description
                            }))
                        ]
                    })),
                    deprecated && (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "warning-triangle"
                    }, {
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                        }, {
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M4.95215 16.3536L10.2152 5.85657C10.9531 4.38481 13.0538 4.38519 13.7912 5.85723L19.0494 16.3543C19.7156 17.6841 18.7486 19.25 17.2612 19.25H6.74001C5.25228 19.25 4.28535 17.6835 4.95215 16.3536Z",
                                    stroke: "#E6B73E",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M12 10V12",
                                    stroke: "#E6B73E",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z",
                                    stroke: "#E6B73E"
                                })
                            ]
                        }))
                    }))
                ]
            }), module.id));
            return result;
        }, []);
    };
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), modules = _useState[0], setModules = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), recentModules = _useState1[0], setRecentModules = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), moreModules = _useState2[0], setMoreModules = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), activeWalletId = _useState3[0], setActiveWalletId = _useState3[1];
    (0, $6cds3.useEffect)(function() {
        var subscription = selector.store.observable.subscribe(function(state) {
            var selectedWalletId = selector.store.getState().selectedWalletId;
            if (selectedWalletId) setActiveWalletId(selectedWalletId);
            var wallets = state.modules.filter(function(module) {
                return !(module.type === "instant-link" && selectedWalletId !== module.id);
            });
            if (selector.options.optimizeWalletOrder) {
                state.modules.sort(function(current, next) {
                    if (current.metadata.deprecated === next.metadata.deprecated) return 0;
                    return current.metadata.deprecated ? 1 : -1;
                });
                state.modules.sort(function(current, next) {
                    if (next.metadata.available === current.metadata.available) return 0;
                    return next.metadata.available ? 1 : -1;
                });
                var moreWallets = [];
                var recentlySignedInWallets = [];
                wallets.forEach(function(module) {
                    if (selector.store.getState().recentlySignedInWallets.includes(module.id)) recentlySignedInWallets.push(module);
                    else moreWallets.push(module);
                });
                setRecentModules(recentlySignedInWallets);
                setMoreModules(moreWallets);
            }
            if (selector.options.randomizeWalletOrder) setModules(wallets.sort(function() {
                return Math.random() - 0.5;
            }));
            else setModules(wallets);
        });
        return function() {
            return subscription.unsubscribe();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        children: selector.options.optimizeWalletOrder && selector.store.getState().recentlySignedInWallets.length > 0 ? (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
            className: "wallet-options-wrapper"
        }, {
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "options-list-section"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "options-list-section-header"
                        }, {
                            children: "Recent"
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "options-list more-options-list-content"
                        }, {
                            children: renderOptionsList(recentModules)
                        }))
                    ]
                })),
                (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "options-list-section"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "options-list-section-header"
                        }, {
                            children: "More"
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "options-list more-options-list-content"
                        }, {
                            children: renderOptionsList(moreModules)
                        }))
                    ]
                }))
            ]
        })) : (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
            className: "wallet-options-wrapper"
        }, {
            children: (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "options-list"
            }, {
                children: renderOptionsList(modules)
            }))
        }))
    });
};
var $2e1e297565bb5552$var$ConnectionResult = function(param) {
    var module = param.module, message = param.message, err = param.err, onRetry = param.onRetry;
    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
        className: "connection connecting-details"
    }, {
        children: err ? (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
            className: "error-wrapper"
        }, {
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "error"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                            width: "21",
                            height: "20",
                            viewBox: "0 0 21 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                        }, {
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M10.5001 18.3333C15.1025 18.3333 18.8334 14.6023 18.8334 9.99996C18.8334 5.39759 15.1025 1.66663 10.5001 1.66663C5.89771 1.66663 2.16675 5.39759 2.16675 9.99996C2.16675 14.6023 5.89771 18.3333 10.5001 18.3333Z",
                                    stroke: "#CE5A6F",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M13 7.5L8 12.5",
                                    stroke: "#CE5A6F",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M8 7.5L13 12.5",
                                    stroke: "#CE5A6F",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })),
                        (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.connectionFailed")
                    ]
                })),
                (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    children: message
                }),
                (module === null || module === void 0 ? void 0 : module.metadata.available) && (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                    onClick: onRetry
                }, {
                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.retry")
                }))
            ]
        })) : (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
            className: "success"
        }, {
            children: [
                (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                    width: "21",
                    height: "20",
                    viewBox: "0 0 21 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M18.8333 9.2333V9.99997C18.8323 11.797 18.2504 13.5455 17.1744 14.9848C16.0984 16.4241 14.586 17.477 12.8628 17.9866C11.1395 18.4961 9.29768 18.4349 7.61202 17.8121C5.92636 17.1894 4.48717 16.0384 3.50909 14.5309C2.53101 13.0233 2.06645 11.24 2.18469 9.4469C2.30293 7.65377 2.99763 5.94691 4.16519 4.58086C5.33275 3.21482 6.91061 2.26279 8.66345 1.86676C10.4163 1.47073 12.2502 1.65192 13.8916 2.3833",
                            stroke: "#4FD98F",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                            d: "M18.8333 3.33337L10.5 11.675L8 9.17504",
                            stroke: "#4FD98F",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })),
                (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.connectionSuccessful")
            ]
        }))
    }));
};
var $2e1e297565bb5552$var$AlertMessage = function(param) {
    var message = param.message, module = param.module, onBack = param.onBack, onCloseModal = param.onCloseModal;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6cds3.Fragment), {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                title: "",
                onCloseModal: onCloseModal
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "alert-message connecting-wrapper connecting-wrapper-err"
            }, {
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                src: module === null || module === void 0 ? void 0 : module.metadata.iconUrl,
                                alt: module === null || module === void 0 ? void 0 : module.metadata.name
                            })
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: module === null || module === void 0 ? void 0 : module.metadata.name
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ConnectionResult, {
                            module: module,
                            message: message,
                            err: message !== null,
                            onRetry: function() {
                                onBack(true);
                            }
                        })
                    ]
                }))
            }))
        ]
    });
};
var $2e1e297565bb5552$var$getBuiltIn$3 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$definePropertyModule = $2e1e297565bb5552$var$objectDefineProperty;
var $2e1e297565bb5552$var$wellKnownSymbol$5 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$DESCRIPTORS = $2e1e297565bb5552$var$descriptors;
var $2e1e297565bb5552$var$SPECIES$2 = $2e1e297565bb5552$var$wellKnownSymbol$5("species");
var $2e1e297565bb5552$var$setSpecies$1 = function setSpecies$1(CONSTRUCTOR_NAME) {
    var Constructor = $2e1e297565bb5552$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $2e1e297565bb5552$var$definePropertyModule.f;
    if ($2e1e297565bb5552$var$DESCRIPTORS && Constructor && !Constructor[$2e1e297565bb5552$var$SPECIES$2]) defineProperty(Constructor, $2e1e297565bb5552$var$SPECIES$2, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};
var $2e1e297565bb5552$var$isPrototypeOf$2 = $2e1e297565bb5552$var$objectIsPrototypeOf;
var $2e1e297565bb5552$var$$TypeError$4 = TypeError;
var $2e1e297565bb5552$var$anInstance$1 = function anInstance$1(it, Prototype) {
    if ($2e1e297565bb5552$var$isPrototypeOf$2(Prototype, it)) return it;
    throw $2e1e297565bb5552$var$$TypeError$4("Incorrect invocation");
};
var $2e1e297565bb5552$var$uncurryThis$2 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$fails$2 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$isCallable$4 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$classof$1 = $2e1e297565bb5552$var$classof$5;
var $2e1e297565bb5552$var$getBuiltIn$2 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$inspectSource$1 = $2e1e297565bb5552$var$inspectSource$4;
var $2e1e297565bb5552$var$noop = function noop() {};
var $2e1e297565bb5552$var$empty = [];
var $2e1e297565bb5552$var$construct = $2e1e297565bb5552$var$getBuiltIn$2("Reflect", "construct");
var $2e1e297565bb5552$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $2e1e297565bb5552$var$exec = $2e1e297565bb5552$var$uncurryThis$2($2e1e297565bb5552$var$constructorRegExp.exec);
var $2e1e297565bb5552$var$INCORRECT_TO_STRING = !$2e1e297565bb5552$var$constructorRegExp.exec($2e1e297565bb5552$var$noop);
var $2e1e297565bb5552$var$isConstructorModern = function isConstructor(argument) {
    if (!$2e1e297565bb5552$var$isCallable$4(argument)) return false;
    try {
        $2e1e297565bb5552$var$construct($2e1e297565bb5552$var$noop, $2e1e297565bb5552$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $2e1e297565bb5552$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$2e1e297565bb5552$var$isCallable$4(argument)) return false;
    switch($2e1e297565bb5552$var$classof$1(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $2e1e297565bb5552$var$INCORRECT_TO_STRING || !!$2e1e297565bb5552$var$exec($2e1e297565bb5552$var$constructorRegExp, $2e1e297565bb5552$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$2e1e297565bb5552$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $2e1e297565bb5552$var$isConstructor$1 = !$2e1e297565bb5552$var$construct || $2e1e297565bb5552$var$fails$2(function() {
    var called;
    return $2e1e297565bb5552$var$isConstructorModern($2e1e297565bb5552$var$isConstructorModern.call) || !$2e1e297565bb5552$var$isConstructorModern(Object) || !$2e1e297565bb5552$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $2e1e297565bb5552$var$isConstructorLegacy : $2e1e297565bb5552$var$isConstructorModern;
var $2e1e297565bb5552$var$isConstructor = $2e1e297565bb5552$var$isConstructor$1;
var $2e1e297565bb5552$var$tryToString$2 = $2e1e297565bb5552$var$tryToString$5;
var $2e1e297565bb5552$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $2e1e297565bb5552$var$aConstructor$1 = function aConstructor$1(argument) {
    if ($2e1e297565bb5552$var$isConstructor(argument)) return argument;
    throw $2e1e297565bb5552$var$$TypeError$3($2e1e297565bb5552$var$tryToString$2(argument) + " is not a constructor");
};
var $2e1e297565bb5552$var$anObject$6 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$aConstructor = $2e1e297565bb5552$var$aConstructor$1;
var $2e1e297565bb5552$var$wellKnownSymbol$4 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$SPECIES$1 = $2e1e297565bb5552$var$wellKnownSymbol$4("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $2e1e297565bb5552$var$speciesConstructor$1 = function speciesConstructor$1(O, defaultConstructor) {
    var C = $2e1e297565bb5552$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $2e1e297565bb5552$var$anObject$6(C)[$2e1e297565bb5552$var$SPECIES$1]) == undefined ? defaultConstructor : $2e1e297565bb5552$var$aConstructor(S);
};
var $2e1e297565bb5552$var$NATIVE_BIND$1 = $2e1e297565bb5552$var$functionBindNative;
var $2e1e297565bb5552$var$FunctionPrototype = Function.prototype;
var $2e1e297565bb5552$var$apply$1 = $2e1e297565bb5552$var$FunctionPrototype.apply;
var $2e1e297565bb5552$var$call$8 = $2e1e297565bb5552$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $2e1e297565bb5552$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($2e1e297565bb5552$var$NATIVE_BIND$1 ? $2e1e297565bb5552$var$call$8.bind($2e1e297565bb5552$var$apply$1) : function() {
    return $2e1e297565bb5552$var$call$8.apply($2e1e297565bb5552$var$apply$1, arguments);
});
var $2e1e297565bb5552$var$uncurryThis$1 = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$aCallable$5 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$NATIVE_BIND = $2e1e297565bb5552$var$functionBindNative;
var $2e1e297565bb5552$var$bind$4 = $2e1e297565bb5552$var$uncurryThis$1($2e1e297565bb5552$var$uncurryThis$1.bind);
// optional / simple context binding
var $2e1e297565bb5552$var$functionBindContext = function functionBindContext(fn, that) {
    $2e1e297565bb5552$var$aCallable$5(fn);
    return that === undefined ? fn : $2e1e297565bb5552$var$NATIVE_BIND ? $2e1e297565bb5552$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $2e1e297565bb5552$var$uncurryThis = $2e1e297565bb5552$var$functionUncurryThis;
var $2e1e297565bb5552$var$arraySlice$1 = $2e1e297565bb5552$var$uncurryThis([].slice);
var $2e1e297565bb5552$var$$TypeError$2 = TypeError;
var $2e1e297565bb5552$var$validateArgumentsLength$1 = function validateArgumentsLength$1(passed, required) {
    if (passed < required) throw $2e1e297565bb5552$var$$TypeError$2("Not enough arguments");
    return passed;
};
var $2e1e297565bb5552$var$userAgent$2 = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($2e1e297565bb5552$var$userAgent$2);
var $2e1e297565bb5552$var$global$7 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$apply = $2e1e297565bb5552$var$functionApply;
var $2e1e297565bb5552$var$bind$3 = $2e1e297565bb5552$var$functionBindContext;
var $2e1e297565bb5552$var$isCallable$3 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$hasOwn$1 = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$fails$1 = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$html = $2e1e297565bb5552$var$html$2;
var $2e1e297565bb5552$var$arraySlice = $2e1e297565bb5552$var$arraySlice$1;
var $2e1e297565bb5552$var$createElement = $2e1e297565bb5552$var$documentCreateElement$2;
var $2e1e297565bb5552$var$validateArgumentsLength = $2e1e297565bb5552$var$validateArgumentsLength$1;
var $2e1e297565bb5552$var$IS_IOS$1 = $2e1e297565bb5552$var$engineIsIos;
var $2e1e297565bb5552$var$IS_NODE$2 = $2e1e297565bb5552$var$engineIsNode;
var $2e1e297565bb5552$var$set = $2e1e297565bb5552$var$global$7.setImmediate;
var $2e1e297565bb5552$var$clear = $2e1e297565bb5552$var$global$7.clearImmediate;
var $2e1e297565bb5552$var$process$2 = $2e1e297565bb5552$var$global$7.process;
var $2e1e297565bb5552$var$Dispatch = $2e1e297565bb5552$var$global$7.Dispatch;
var $2e1e297565bb5552$var$Function$1 = $2e1e297565bb5552$var$global$7.Function;
var $2e1e297565bb5552$var$MessageChannel = $2e1e297565bb5552$var$global$7.MessageChannel;
var $2e1e297565bb5552$var$String$1 = $2e1e297565bb5552$var$global$7.String;
var $2e1e297565bb5552$var$counter = 0;
var $2e1e297565bb5552$var$queue$1 = {};
var $2e1e297565bb5552$var$ONREADYSTATECHANGE = "onreadystatechange";
var $2e1e297565bb5552$var$location, $2e1e297565bb5552$var$defer, $2e1e297565bb5552$var$channel, $2e1e297565bb5552$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $2e1e297565bb5552$var$location = $2e1e297565bb5552$var$global$7.location;
} catch (error) {}
var $2e1e297565bb5552$var$run = function run(id) {
    if ($2e1e297565bb5552$var$hasOwn$1($2e1e297565bb5552$var$queue$1, id)) {
        var fn = $2e1e297565bb5552$var$queue$1[id];
        delete $2e1e297565bb5552$var$queue$1[id];
        fn();
    }
};
var $2e1e297565bb5552$var$runner = function runner(id) {
    return function() {
        $2e1e297565bb5552$var$run(id);
    };
};
var $2e1e297565bb5552$var$listener = function listener(event) {
    $2e1e297565bb5552$var$run(event.data);
};
var $2e1e297565bb5552$var$post = function post(id) {
    // old engines have not location.origin
    $2e1e297565bb5552$var$global$7.postMessage($2e1e297565bb5552$var$String$1(id), $2e1e297565bb5552$var$location.protocol + "//" + $2e1e297565bb5552$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$2e1e297565bb5552$var$set || !$2e1e297565bb5552$var$clear) {
    $2e1e297565bb5552$var$set = function setImmediate(handler) {
        $2e1e297565bb5552$var$validateArgumentsLength(arguments.length, 1);
        var fn = $2e1e297565bb5552$var$isCallable$3(handler) ? handler : $2e1e297565bb5552$var$Function$1(handler);
        var args = $2e1e297565bb5552$var$arraySlice(arguments, 1);
        $2e1e297565bb5552$var$queue$1[++$2e1e297565bb5552$var$counter] = function() {
            $2e1e297565bb5552$var$apply(fn, undefined, args);
        };
        $2e1e297565bb5552$var$defer($2e1e297565bb5552$var$counter);
        return $2e1e297565bb5552$var$counter;
    };
    $2e1e297565bb5552$var$clear = function clearImmediate(id) {
        delete $2e1e297565bb5552$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($2e1e297565bb5552$var$IS_NODE$2) $2e1e297565bb5552$var$defer = function defer(id) {
        $2e1e297565bb5552$var$process$2.nextTick($2e1e297565bb5552$var$runner(id));
    };
    else if ($2e1e297565bb5552$var$Dispatch && $2e1e297565bb5552$var$Dispatch.now) $2e1e297565bb5552$var$defer = function defer(id) {
        $2e1e297565bb5552$var$Dispatch.now($2e1e297565bb5552$var$runner(id));
    };
    else if ($2e1e297565bb5552$var$MessageChannel && !$2e1e297565bb5552$var$IS_IOS$1) {
        $2e1e297565bb5552$var$channel = new $2e1e297565bb5552$var$MessageChannel();
        $2e1e297565bb5552$var$port = $2e1e297565bb5552$var$channel.port2;
        $2e1e297565bb5552$var$channel.port1.onmessage = $2e1e297565bb5552$var$listener;
        $2e1e297565bb5552$var$defer = $2e1e297565bb5552$var$bind$3($2e1e297565bb5552$var$port.postMessage, $2e1e297565bb5552$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($2e1e297565bb5552$var$global$7.addEventListener && $2e1e297565bb5552$var$isCallable$3($2e1e297565bb5552$var$global$7.postMessage) && !$2e1e297565bb5552$var$global$7.importScripts && $2e1e297565bb5552$var$location && $2e1e297565bb5552$var$location.protocol !== "file:" && !$2e1e297565bb5552$var$fails$1($2e1e297565bb5552$var$post)) {
        $2e1e297565bb5552$var$defer = $2e1e297565bb5552$var$post;
        $2e1e297565bb5552$var$global$7.addEventListener("message", $2e1e297565bb5552$var$listener, false);
    // IE8-
    } else if ($2e1e297565bb5552$var$ONREADYSTATECHANGE in $2e1e297565bb5552$var$createElement("script")) $2e1e297565bb5552$var$defer = function defer(id) {
        $2e1e297565bb5552$var$html.appendChild($2e1e297565bb5552$var$createElement("script"))[$2e1e297565bb5552$var$ONREADYSTATECHANGE] = function() {
            $2e1e297565bb5552$var$html.removeChild(this);
            $2e1e297565bb5552$var$run(id);
        };
    };
    else $2e1e297565bb5552$var$defer = function defer(id) {
        setTimeout($2e1e297565bb5552$var$runner(id), 0);
    };
}
var $2e1e297565bb5552$var$task$1 = {
    set: $2e1e297565bb5552$var$set,
    clear: $2e1e297565bb5552$var$clear
};
var $2e1e297565bb5552$var$userAgent$1 = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$global$6 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($2e1e297565bb5552$var$userAgent$1) && $2e1e297565bb5552$var$global$6.Pebble !== undefined;
var $2e1e297565bb5552$var$userAgent = $2e1e297565bb5552$var$engineUserAgent;
var $2e1e297565bb5552$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($2e1e297565bb5552$var$userAgent);
var $2e1e297565bb5552$var$global$5 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$bind$2 = $2e1e297565bb5552$var$functionBindContext;
var $2e1e297565bb5552$var$getOwnPropertyDescriptor = $2e1e297565bb5552$var$objectGetOwnPropertyDescriptor.f;
var $2e1e297565bb5552$var$macrotask = $2e1e297565bb5552$var$task$1.set;
var $2e1e297565bb5552$var$IS_IOS = $2e1e297565bb5552$var$engineIsIos;
var $2e1e297565bb5552$var$IS_IOS_PEBBLE = $2e1e297565bb5552$var$engineIsIosPebble;
var $2e1e297565bb5552$var$IS_WEBOS_WEBKIT = $2e1e297565bb5552$var$engineIsWebosWebkit;
var $2e1e297565bb5552$var$IS_NODE$1 = $2e1e297565bb5552$var$engineIsNode;
var $2e1e297565bb5552$var$MutationObserver = $2e1e297565bb5552$var$global$5.MutationObserver || $2e1e297565bb5552$var$global$5.WebKitMutationObserver;
var $2e1e297565bb5552$var$document$2 = $2e1e297565bb5552$var$global$5.document;
var $2e1e297565bb5552$var$process$1 = $2e1e297565bb5552$var$global$5.process;
var $2e1e297565bb5552$var$Promise$1 = $2e1e297565bb5552$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $2e1e297565bb5552$var$queueMicrotaskDescriptor = $2e1e297565bb5552$var$getOwnPropertyDescriptor($2e1e297565bb5552$var$global$5, "queueMicrotask");
var $2e1e297565bb5552$var$queueMicrotask = $2e1e297565bb5552$var$queueMicrotaskDescriptor && $2e1e297565bb5552$var$queueMicrotaskDescriptor.value;
var $2e1e297565bb5552$var$flush, $2e1e297565bb5552$var$head, $2e1e297565bb5552$var$last, $2e1e297565bb5552$var$notify$1, $2e1e297565bb5552$var$toggle, $2e1e297565bb5552$var$node, $2e1e297565bb5552$var$promise, $2e1e297565bb5552$var$then;
// modern engines have queueMicrotask method
if (!$2e1e297565bb5552$var$queueMicrotask) {
    $2e1e297565bb5552$var$flush = function flush() {
        var parent, fn;
        if ($2e1e297565bb5552$var$IS_NODE$1 && (parent = $2e1e297565bb5552$var$process$1.domain)) parent.exit();
        while($2e1e297565bb5552$var$head){
            fn = $2e1e297565bb5552$var$head.fn;
            $2e1e297565bb5552$var$head = $2e1e297565bb5552$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($2e1e297565bb5552$var$head) $2e1e297565bb5552$var$notify$1();
                else $2e1e297565bb5552$var$last = undefined;
                throw error;
            }
        }
        $2e1e297565bb5552$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$2e1e297565bb5552$var$IS_IOS && !$2e1e297565bb5552$var$IS_NODE$1 && !$2e1e297565bb5552$var$IS_WEBOS_WEBKIT && $2e1e297565bb5552$var$MutationObserver && $2e1e297565bb5552$var$document$2) {
        $2e1e297565bb5552$var$toggle = true;
        $2e1e297565bb5552$var$node = $2e1e297565bb5552$var$document$2.createTextNode("");
        new $2e1e297565bb5552$var$MutationObserver($2e1e297565bb5552$var$flush).observe($2e1e297565bb5552$var$node, {
            characterData: true
        });
        $2e1e297565bb5552$var$notify$1 = function notify$1() {
            $2e1e297565bb5552$var$node.data = $2e1e297565bb5552$var$toggle = !$2e1e297565bb5552$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$2e1e297565bb5552$var$IS_IOS_PEBBLE && $2e1e297565bb5552$var$Promise$1 && $2e1e297565bb5552$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $2e1e297565bb5552$var$promise = $2e1e297565bb5552$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $2e1e297565bb5552$var$promise.constructor = $2e1e297565bb5552$var$Promise$1;
        $2e1e297565bb5552$var$then = $2e1e297565bb5552$var$bind$2($2e1e297565bb5552$var$promise.then, $2e1e297565bb5552$var$promise);
        $2e1e297565bb5552$var$notify$1 = function notify$1() {
            $2e1e297565bb5552$var$then($2e1e297565bb5552$var$flush);
        };
    // Node.js without promises
    } else if ($2e1e297565bb5552$var$IS_NODE$1) $2e1e297565bb5552$var$notify$1 = function notify$1() {
        $2e1e297565bb5552$var$process$1.nextTick($2e1e297565bb5552$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $2e1e297565bb5552$var$macrotask = $2e1e297565bb5552$var$bind$2($2e1e297565bb5552$var$macrotask, $2e1e297565bb5552$var$global$5);
        $2e1e297565bb5552$var$notify$1 = function notify$1() {
            $2e1e297565bb5552$var$macrotask($2e1e297565bb5552$var$flush);
        };
    }
}
var $2e1e297565bb5552$var$microtask$1 = $2e1e297565bb5552$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($2e1e297565bb5552$var$last) $2e1e297565bb5552$var$last.next = task;
    if (!$2e1e297565bb5552$var$head) {
        $2e1e297565bb5552$var$head = task;
        $2e1e297565bb5552$var$notify$1();
    }
    $2e1e297565bb5552$var$last = task;
};
var $2e1e297565bb5552$var$global$4 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$hostReportErrors$1 = function hostReportErrors$1(a, b) {
    var console = $2e1e297565bb5552$var$global$4.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $2e1e297565bb5552$var$perform$3 = function perform$3(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $2e1e297565bb5552$var$Queue$1 = function Queue$1() {
    this.head = null;
    this.tail = null;
};
$2e1e297565bb5552$var$Queue$1.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $2e1e297565bb5552$var$queue = $2e1e297565bb5552$var$Queue$1;
var $2e1e297565bb5552$var$global$3 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$promiseNativeConstructor = $2e1e297565bb5552$var$global$3.Promise;
var $2e1e297565bb5552$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $2e1e297565bb5552$var$global$2 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$NativePromiseConstructor$3 = $2e1e297565bb5552$var$promiseNativeConstructor;
var $2e1e297565bb5552$var$isCallable$2 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$isForced = $2e1e297565bb5552$var$isForced_1;
var $2e1e297565bb5552$var$inspectSource = $2e1e297565bb5552$var$inspectSource$4;
var $2e1e297565bb5552$var$wellKnownSymbol$3 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$IS_BROWSER = $2e1e297565bb5552$var$engineIsBrowser;
var $2e1e297565bb5552$var$V8_VERSION = $2e1e297565bb5552$var$engineV8Version;
$2e1e297565bb5552$var$NativePromiseConstructor$3 && $2e1e297565bb5552$var$NativePromiseConstructor$3.prototype;
var $2e1e297565bb5552$var$SPECIES = $2e1e297565bb5552$var$wellKnownSymbol$3("species");
var $2e1e297565bb5552$var$SUBCLASSING = false;
var $2e1e297565bb5552$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $2e1e297565bb5552$var$isCallable$2($2e1e297565bb5552$var$global$2.PromiseRejectionEvent);
var $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$5 = $2e1e297565bb5552$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $2e1e297565bb5552$var$inspectSource($2e1e297565bb5552$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($2e1e297565bb5552$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $2e1e297565bb5552$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($2e1e297565bb5552$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $2e1e297565bb5552$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function FakePromise(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$2e1e297565bb5552$var$SPECIES] = FakePromise;
    $2e1e297565bb5552$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$2e1e297565bb5552$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $2e1e297565bb5552$var$IS_BROWSER && !$2e1e297565bb5552$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $2e1e297565bb5552$var$promiseConstructorDetection = {
    CONSTRUCTOR: $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $2e1e297565bb5552$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $2e1e297565bb5552$var$SUBCLASSING
};
var $2e1e297565bb5552$var$newPromiseCapability$2 = {};
var $2e1e297565bb5552$var$aCallable$4 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $2e1e297565bb5552$var$aCallable$4(resolve);
    this.reject = $2e1e297565bb5552$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$2e1e297565bb5552$var$newPromiseCapability$2.f = function(C) {
    return new $2e1e297565bb5552$var$PromiseCapability(C);
};
var $2e1e297565bb5552$var$$$5 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$IS_NODE = $2e1e297565bb5552$var$engineIsNode;
var $2e1e297565bb5552$var$global$1 = $2e1e297565bb5552$var$global$k;
var $2e1e297565bb5552$var$call$7 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$defineBuiltIn$2 = $2e1e297565bb5552$var$defineBuiltIn$6;
var $2e1e297565bb5552$var$setPrototypeOf = $2e1e297565bb5552$var$objectSetPrototypeOf;
var $2e1e297565bb5552$var$setToStringTag = $2e1e297565bb5552$var$setToStringTag$3;
var $2e1e297565bb5552$var$setSpecies = $2e1e297565bb5552$var$setSpecies$1;
var $2e1e297565bb5552$var$aCallable$3 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$isCallable$1 = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$isObject$1 = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$anInstance = $2e1e297565bb5552$var$anInstance$1;
var $2e1e297565bb5552$var$speciesConstructor = $2e1e297565bb5552$var$speciesConstructor$1;
var $2e1e297565bb5552$var$task = $2e1e297565bb5552$var$task$1.set;
var $2e1e297565bb5552$var$microtask = $2e1e297565bb5552$var$microtask$1;
var $2e1e297565bb5552$var$hostReportErrors = $2e1e297565bb5552$var$hostReportErrors$1;
var $2e1e297565bb5552$var$perform$2 = $2e1e297565bb5552$var$perform$3;
var $2e1e297565bb5552$var$Queue = $2e1e297565bb5552$var$queue;
var $2e1e297565bb5552$var$InternalStateModule = $2e1e297565bb5552$var$internalState;
var $2e1e297565bb5552$var$NativePromiseConstructor$2 = $2e1e297565bb5552$var$promiseNativeConstructor;
var $2e1e297565bb5552$var$PromiseConstructorDetection = $2e1e297565bb5552$var$promiseConstructorDetection;
var $2e1e297565bb5552$var$newPromiseCapabilityModule$3 = $2e1e297565bb5552$var$newPromiseCapability$2;
var $2e1e297565bb5552$var$PROMISE = "Promise";
var $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$4 = $2e1e297565bb5552$var$PromiseConstructorDetection.CONSTRUCTOR;
var $2e1e297565bb5552$var$NATIVE_PROMISE_REJECTION_EVENT = $2e1e297565bb5552$var$PromiseConstructorDetection.REJECTION_EVENT;
var $2e1e297565bb5552$var$NATIVE_PROMISE_SUBCLASSING = $2e1e297565bb5552$var$PromiseConstructorDetection.SUBCLASSING;
var $2e1e297565bb5552$var$getInternalPromiseState = $2e1e297565bb5552$var$InternalStateModule.getterFor($2e1e297565bb5552$var$PROMISE);
var $2e1e297565bb5552$var$setInternalState = $2e1e297565bb5552$var$InternalStateModule.set;
var $2e1e297565bb5552$var$NativePromisePrototype$1 = $2e1e297565bb5552$var$NativePromiseConstructor$2 && $2e1e297565bb5552$var$NativePromiseConstructor$2.prototype;
var $2e1e297565bb5552$var$PromiseConstructor = $2e1e297565bb5552$var$NativePromiseConstructor$2;
var $2e1e297565bb5552$var$PromisePrototype = $2e1e297565bb5552$var$NativePromisePrototype$1;
var $2e1e297565bb5552$var$TypeError$1 = $2e1e297565bb5552$var$global$1.TypeError;
var $2e1e297565bb5552$var$document$1 = $2e1e297565bb5552$var$global$1.document;
var $2e1e297565bb5552$var$process = $2e1e297565bb5552$var$global$1.process;
var $2e1e297565bb5552$var$newPromiseCapability$1 = $2e1e297565bb5552$var$newPromiseCapabilityModule$3.f;
var $2e1e297565bb5552$var$newGenericPromiseCapability = $2e1e297565bb5552$var$newPromiseCapability$1;
var $2e1e297565bb5552$var$DISPATCH_EVENT = !!($2e1e297565bb5552$var$document$1 && $2e1e297565bb5552$var$document$1.createEvent && $2e1e297565bb5552$var$global$1.dispatchEvent);
var $2e1e297565bb5552$var$UNHANDLED_REJECTION = "unhandledrejection";
var $2e1e297565bb5552$var$REJECTION_HANDLED = "rejectionhandled";
var $2e1e297565bb5552$var$PENDING = 0;
var $2e1e297565bb5552$var$FULFILLED = 1;
var $2e1e297565bb5552$var$REJECTED = 2;
var $2e1e297565bb5552$var$HANDLED = 1;
var $2e1e297565bb5552$var$UNHANDLED = 2;
var $2e1e297565bb5552$var$Internal, $2e1e297565bb5552$var$OwnPromiseCapability, $2e1e297565bb5552$var$PromiseWrapper, $2e1e297565bb5552$var$nativeThen;
// helpers
var $2e1e297565bb5552$var$isThenable = function isThenable(it) {
    var then;
    return $2e1e297565bb5552$var$isObject$1(it) && $2e1e297565bb5552$var$isCallable$1(then = it.then) ? then : false;
};
var $2e1e297565bb5552$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state == $2e1e297565bb5552$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $2e1e297565bb5552$var$UNHANDLED) $2e1e297565bb5552$var$onHandleUnhandled(state);
                state.rejection = $2e1e297565bb5552$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($2e1e297565bb5552$var$TypeError$1("Promise-chain cycle"));
            else if (then = $2e1e297565bb5552$var$isThenable(result)) $2e1e297565bb5552$var$call$7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $2e1e297565bb5552$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $2e1e297565bb5552$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$2e1e297565bb5552$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $2e1e297565bb5552$var$onUnhandled(state);
    });
};
var $2e1e297565bb5552$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($2e1e297565bb5552$var$DISPATCH_EVENT) {
        event = $2e1e297565bb5552$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $2e1e297565bb5552$var$global$1.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$2e1e297565bb5552$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $2e1e297565bb5552$var$global$1["on" + name])) handler(event);
    else if (name === $2e1e297565bb5552$var$UNHANDLED_REJECTION) $2e1e297565bb5552$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $2e1e297565bb5552$var$onUnhandled = function onUnhandled(state) {
    $2e1e297565bb5552$var$call$7($2e1e297565bb5552$var$task, $2e1e297565bb5552$var$global$1, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $2e1e297565bb5552$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $2e1e297565bb5552$var$perform$2(function() {
                if ($2e1e297565bb5552$var$IS_NODE) $2e1e297565bb5552$var$process.emit("unhandledRejection", value, promise);
                else $2e1e297565bb5552$var$dispatchEvent($2e1e297565bb5552$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $2e1e297565bb5552$var$IS_NODE || $2e1e297565bb5552$var$isUnhandled(state) ? $2e1e297565bb5552$var$UNHANDLED : $2e1e297565bb5552$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $2e1e297565bb5552$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $2e1e297565bb5552$var$HANDLED && !state.parent;
};
var $2e1e297565bb5552$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $2e1e297565bb5552$var$call$7($2e1e297565bb5552$var$task, $2e1e297565bb5552$var$global$1, function() {
        var promise = state.facade;
        if ($2e1e297565bb5552$var$IS_NODE) $2e1e297565bb5552$var$process.emit("rejectionHandled", promise);
        else $2e1e297565bb5552$var$dispatchEvent($2e1e297565bb5552$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $2e1e297565bb5552$var$bind$1 = function bind$1(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $2e1e297565bb5552$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $2e1e297565bb5552$var$REJECTED;
    $2e1e297565bb5552$var$notify(state, true);
};
var $2e1e297565bb5552$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $2e1e297565bb5552$var$TypeError$1("Promise can't be resolved itself");
        var then = $2e1e297565bb5552$var$isThenable(value);
        if (then) $2e1e297565bb5552$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $2e1e297565bb5552$var$call$7(then, value, $2e1e297565bb5552$var$bind$1($2e1e297565bb5552$var$internalResolve, wrapper, state), $2e1e297565bb5552$var$bind$1($2e1e297565bb5552$var$internalReject, wrapper, state));
            } catch (error) {
                $2e1e297565bb5552$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $2e1e297565bb5552$var$FULFILLED;
            $2e1e297565bb5552$var$notify(state, false);
        }
    } catch (error) {
        $2e1e297565bb5552$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $2e1e297565bb5552$var$PromiseConstructor = function Promise1(executor) {
        $2e1e297565bb5552$var$anInstance(this, $2e1e297565bb5552$var$PromisePrototype);
        $2e1e297565bb5552$var$aCallable$3(executor);
        $2e1e297565bb5552$var$call$7($2e1e297565bb5552$var$Internal, this);
        var state = $2e1e297565bb5552$var$getInternalPromiseState(this);
        try {
            executor($2e1e297565bb5552$var$bind$1($2e1e297565bb5552$var$internalResolve, state), $2e1e297565bb5552$var$bind$1($2e1e297565bb5552$var$internalReject, state));
        } catch (error) {
            $2e1e297565bb5552$var$internalReject(state, error);
        }
    };
    $2e1e297565bb5552$var$PromisePrototype = $2e1e297565bb5552$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $2e1e297565bb5552$var$Internal = function Promise1(executor) {
        $2e1e297565bb5552$var$setInternalState(this, {
            type: $2e1e297565bb5552$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $2e1e297565bb5552$var$Queue(),
            rejection: false,
            state: $2e1e297565bb5552$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $2e1e297565bb5552$var$Internal.prototype = $2e1e297565bb5552$var$defineBuiltIn$2($2e1e297565bb5552$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $2e1e297565bb5552$var$getInternalPromiseState(this);
        var reaction = $2e1e297565bb5552$var$newPromiseCapability$1($2e1e297565bb5552$var$speciesConstructor(this, $2e1e297565bb5552$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $2e1e297565bb5552$var$isCallable$1(onFulfilled) ? onFulfilled : true;
        reaction.fail = $2e1e297565bb5552$var$isCallable$1(onRejected) && onRejected;
        reaction.domain = $2e1e297565bb5552$var$IS_NODE ? $2e1e297565bb5552$var$process.domain : undefined;
        if (state.state == $2e1e297565bb5552$var$PENDING) state.reactions.add(reaction);
        else $2e1e297565bb5552$var$microtask(function() {
            $2e1e297565bb5552$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $2e1e297565bb5552$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $2e1e297565bb5552$var$Internal();
        var state = $2e1e297565bb5552$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $2e1e297565bb5552$var$bind$1($2e1e297565bb5552$var$internalResolve, state);
        this.reject = $2e1e297565bb5552$var$bind$1($2e1e297565bb5552$var$internalReject, state);
    };
    $2e1e297565bb5552$var$newPromiseCapabilityModule$3.f = $2e1e297565bb5552$var$newPromiseCapability$1 = function newPromiseCapability$1(C) {
        return C === $2e1e297565bb5552$var$PromiseConstructor || C === $2e1e297565bb5552$var$PromiseWrapper ? new $2e1e297565bb5552$var$OwnPromiseCapability(C) : $2e1e297565bb5552$var$newGenericPromiseCapability(C);
    };
    if ($2e1e297565bb5552$var$isCallable$1($2e1e297565bb5552$var$NativePromiseConstructor$2) && $2e1e297565bb5552$var$NativePromisePrototype$1 !== Object.prototype) {
        $2e1e297565bb5552$var$nativeThen = $2e1e297565bb5552$var$NativePromisePrototype$1.then;
        if (!$2e1e297565bb5552$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $2e1e297565bb5552$var$defineBuiltIn$2($2e1e297565bb5552$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $2e1e297565bb5552$var$PromiseConstructor(function(resolve, reject) {
                $2e1e297565bb5552$var$call$7($2e1e297565bb5552$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $2e1e297565bb5552$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($2e1e297565bb5552$var$setPrototypeOf) $2e1e297565bb5552$var$setPrototypeOf($2e1e297565bb5552$var$NativePromisePrototype$1, $2e1e297565bb5552$var$PromisePrototype);
    }
}
$2e1e297565bb5552$var$$$5({
    global: true,
    constructor: true,
    wrap: true,
    forced: $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $2e1e297565bb5552$var$PromiseConstructor
});
$2e1e297565bb5552$var$setToStringTag($2e1e297565bb5552$var$PromiseConstructor, $2e1e297565bb5552$var$PROMISE, false);
$2e1e297565bb5552$var$setSpecies($2e1e297565bb5552$var$PROMISE);
var $2e1e297565bb5552$var$wellKnownSymbol$2 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$Iterators$1 = $2e1e297565bb5552$var$iterators;
var $2e1e297565bb5552$var$ITERATOR$2 = $2e1e297565bb5552$var$wellKnownSymbol$2("iterator");
var $2e1e297565bb5552$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $2e1e297565bb5552$var$isArrayIteratorMethod$1 = function isArrayIteratorMethod$1(it) {
    return it !== undefined && ($2e1e297565bb5552$var$Iterators$1.Array === it || $2e1e297565bb5552$var$ArrayPrototype[$2e1e297565bb5552$var$ITERATOR$2] === it);
};
var $2e1e297565bb5552$var$classof = $2e1e297565bb5552$var$classof$5;
var $2e1e297565bb5552$var$getMethod$1 = $2e1e297565bb5552$var$getMethod$3;
var $2e1e297565bb5552$var$Iterators = $2e1e297565bb5552$var$iterators;
var $2e1e297565bb5552$var$wellKnownSymbol$1 = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$ITERATOR$1 = $2e1e297565bb5552$var$wellKnownSymbol$1("iterator");
var $2e1e297565bb5552$var$getIteratorMethod$2 = function getIteratorMethod$2(it) {
    if (it != undefined) return $2e1e297565bb5552$var$getMethod$1(it, $2e1e297565bb5552$var$ITERATOR$1) || $2e1e297565bb5552$var$getMethod$1(it, "@@iterator") || $2e1e297565bb5552$var$Iterators[$2e1e297565bb5552$var$classof(it)];
};
var $2e1e297565bb5552$var$call$6 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$aCallable$2 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$anObject$5 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$tryToString$1 = $2e1e297565bb5552$var$tryToString$5;
var $2e1e297565bb5552$var$getIteratorMethod$1 = $2e1e297565bb5552$var$getIteratorMethod$2;
var $2e1e297565bb5552$var$$TypeError$1 = TypeError;
var $2e1e297565bb5552$var$getIterator$1 = function getIterator$1(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $2e1e297565bb5552$var$getIteratorMethod$1(argument) : usingIterator;
    if ($2e1e297565bb5552$var$aCallable$2(iteratorMethod)) return $2e1e297565bb5552$var$anObject$5($2e1e297565bb5552$var$call$6(iteratorMethod, argument));
    throw $2e1e297565bb5552$var$$TypeError$1($2e1e297565bb5552$var$tryToString$1(argument) + " is not iterable");
};
var $2e1e297565bb5552$var$call$5 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$anObject$4 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$getMethod = $2e1e297565bb5552$var$getMethod$3;
var $2e1e297565bb5552$var$iteratorClose$1 = function iteratorClose$1(iterator, kind, value) {
    var innerResult, innerError;
    $2e1e297565bb5552$var$anObject$4(iterator);
    try {
        innerResult = $2e1e297565bb5552$var$getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $2e1e297565bb5552$var$call$5(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $2e1e297565bb5552$var$anObject$4(innerResult);
    return value;
};
var $2e1e297565bb5552$var$bind = $2e1e297565bb5552$var$functionBindContext;
var $2e1e297565bb5552$var$call$4 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$anObject$3 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$tryToString = $2e1e297565bb5552$var$tryToString$5;
var $2e1e297565bb5552$var$isArrayIteratorMethod = $2e1e297565bb5552$var$isArrayIteratorMethod$1;
var $2e1e297565bb5552$var$lengthOfArrayLike = $2e1e297565bb5552$var$lengthOfArrayLike$5;
var $2e1e297565bb5552$var$isPrototypeOf$1 = $2e1e297565bb5552$var$objectIsPrototypeOf;
var $2e1e297565bb5552$var$getIterator = $2e1e297565bb5552$var$getIterator$1;
var $2e1e297565bb5552$var$getIteratorMethod = $2e1e297565bb5552$var$getIteratorMethod$2;
var $2e1e297565bb5552$var$iteratorClose = $2e1e297565bb5552$var$iteratorClose$1;
var $2e1e297565bb5552$var$$TypeError = TypeError;
var $2e1e297565bb5552$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $2e1e297565bb5552$var$ResultPrototype = $2e1e297565bb5552$var$Result.prototype;
var $2e1e297565bb5552$var$iterate$2 = function iterate$2(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $2e1e297565bb5552$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $2e1e297565bb5552$var$iteratorClose(iterator, "normal", condition);
        return new $2e1e297565bb5552$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $2e1e297565bb5552$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $2e1e297565bb5552$var$getIteratorMethod(iterable);
        if (!iterFn) throw $2e1e297565bb5552$var$$TypeError($2e1e297565bb5552$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($2e1e297565bb5552$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $2e1e297565bb5552$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $2e1e297565bb5552$var$isPrototypeOf$1($2e1e297565bb5552$var$ResultPrototype, result)) return result;
            }
            return new $2e1e297565bb5552$var$Result(false);
        }
        iterator = $2e1e297565bb5552$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $2e1e297565bb5552$var$call$4(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $2e1e297565bb5552$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $2e1e297565bb5552$var$isPrototypeOf$1($2e1e297565bb5552$var$ResultPrototype, result)) return result;
    }
    return new $2e1e297565bb5552$var$Result(false);
};
var $2e1e297565bb5552$var$wellKnownSymbol = $2e1e297565bb5552$var$wellKnownSymbol$g;
var $2e1e297565bb5552$var$ITERATOR = $2e1e297565bb5552$var$wellKnownSymbol("iterator");
var $2e1e297565bb5552$var$SAFE_CLOSING = false;
try {
    var $2e1e297565bb5552$var$called = 0;
    var $2e1e297565bb5552$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$2e1e297565bb5552$var$called++
            };
        },
        "return": function() {
            $2e1e297565bb5552$var$SAFE_CLOSING = true;
        }
    };
    $2e1e297565bb5552$var$iteratorWithReturn[$2e1e297565bb5552$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($2e1e297565bb5552$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $2e1e297565bb5552$var$checkCorrectnessOfIteration$1 = function checkCorrectnessOfIteration$1(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$2e1e297565bb5552$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$2e1e297565bb5552$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $2e1e297565bb5552$var$NativePromiseConstructor$1 = $2e1e297565bb5552$var$promiseNativeConstructor;
var $2e1e297565bb5552$var$checkCorrectnessOfIteration = $2e1e297565bb5552$var$checkCorrectnessOfIteration$1;
var $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$3 = $2e1e297565bb5552$var$promiseConstructorDetection.CONSTRUCTOR;
var $2e1e297565bb5552$var$promiseStaticsIncorrectIteration = $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$2e1e297565bb5552$var$checkCorrectnessOfIteration(function(iterable) {
    $2e1e297565bb5552$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $2e1e297565bb5552$var$$$4 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$call$3 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$aCallable$1 = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$newPromiseCapabilityModule$2 = $2e1e297565bb5552$var$newPromiseCapability$2;
var $2e1e297565bb5552$var$perform$1 = $2e1e297565bb5552$var$perform$3;
var $2e1e297565bb5552$var$iterate$1 = $2e1e297565bb5552$var$iterate$2;
var $2e1e297565bb5552$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $2e1e297565bb5552$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$2e1e297565bb5552$var$$$4({
    target: "Promise",
    stat: true,
    forced: $2e1e297565bb5552$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $2e1e297565bb5552$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $2e1e297565bb5552$var$perform$1(function() {
            var $promiseResolve = $2e1e297565bb5552$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $2e1e297565bb5552$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $2e1e297565bb5552$var$call$3($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $2e1e297565bb5552$var$$$3 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$2 = $2e1e297565bb5552$var$promiseConstructorDetection.CONSTRUCTOR;
var $2e1e297565bb5552$var$NativePromiseConstructor = $2e1e297565bb5552$var$promiseNativeConstructor;
var $2e1e297565bb5552$var$getBuiltIn$1 = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$isCallable = $2e1e297565bb5552$var$isCallable$l;
var $2e1e297565bb5552$var$defineBuiltIn$1 = $2e1e297565bb5552$var$defineBuiltIn$6;
var $2e1e297565bb5552$var$NativePromisePrototype = $2e1e297565bb5552$var$NativePromiseConstructor && $2e1e297565bb5552$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$2e1e297565bb5552$var$$$3({
    target: "Promise",
    proto: true,
    forced: $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($2e1e297565bb5552$var$isCallable($2e1e297565bb5552$var$NativePromiseConstructor)) {
    var $2e1e297565bb5552$var$method = $2e1e297565bb5552$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($2e1e297565bb5552$var$NativePromisePrototype["catch"] !== $2e1e297565bb5552$var$method) $2e1e297565bb5552$var$defineBuiltIn$1($2e1e297565bb5552$var$NativePromisePrototype, "catch", $2e1e297565bb5552$var$method, {
        unsafe: true
    });
}
var $2e1e297565bb5552$var$$$2 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$call$2 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$aCallable = $2e1e297565bb5552$var$aCallable$9;
var $2e1e297565bb5552$var$newPromiseCapabilityModule$1 = $2e1e297565bb5552$var$newPromiseCapability$2;
var $2e1e297565bb5552$var$perform = $2e1e297565bb5552$var$perform$3;
var $2e1e297565bb5552$var$iterate = $2e1e297565bb5552$var$iterate$2;
var $2e1e297565bb5552$var$PROMISE_STATICS_INCORRECT_ITERATION = $2e1e297565bb5552$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$2e1e297565bb5552$var$$$2({
    target: "Promise",
    stat: true,
    forced: $2e1e297565bb5552$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $2e1e297565bb5552$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $2e1e297565bb5552$var$perform(function() {
            var $promiseResolve = $2e1e297565bb5552$var$aCallable(C.resolve);
            $2e1e297565bb5552$var$iterate(iterable, function(promise) {
                $2e1e297565bb5552$var$call$2($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $2e1e297565bb5552$var$$$1 = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$call$1 = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$newPromiseCapabilityModule = $2e1e297565bb5552$var$newPromiseCapability$2;
var $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$1 = $2e1e297565bb5552$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$2e1e297565bb5552$var$$$1({
    target: "Promise",
    stat: true,
    forced: $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $2e1e297565bb5552$var$newPromiseCapabilityModule.f(this);
        $2e1e297565bb5552$var$call$1(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $2e1e297565bb5552$var$anObject$2 = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$isObject = $2e1e297565bb5552$var$isObject$8;
var $2e1e297565bb5552$var$newPromiseCapability = $2e1e297565bb5552$var$newPromiseCapability$2;
var $2e1e297565bb5552$var$promiseResolve$1 = function promiseResolve$1(C, x) {
    $2e1e297565bb5552$var$anObject$2(C);
    if ($2e1e297565bb5552$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $2e1e297565bb5552$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $2e1e297565bb5552$var$$ = $2e1e297565bb5552$var$_export;
var $2e1e297565bb5552$var$getBuiltIn = $2e1e297565bb5552$var$getBuiltIn$8;
var $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR = $2e1e297565bb5552$var$promiseConstructorDetection.CONSTRUCTOR;
var $2e1e297565bb5552$var$promiseResolve = $2e1e297565bb5552$var$promiseResolve$1;
$2e1e297565bb5552$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$2e1e297565bb5552$var$$({
    target: "Promise",
    stat: true,
    forced: $2e1e297565bb5552$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $2e1e297565bb5552$var$promiseResolve(this, x);
    }
});
var $2e1e297565bb5552$var$HardwareWalletAccountsForm = function(param) {
    var accounts = param.accounts, onSelectedChanged = param.onSelectedChanged, onSubmit = param.onSubmit, onChangeRoute = param.onChangeRoute;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
        className: "choose-ledger-account-form-wrapper"
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "We found ",
                    accounts.length,
                    " accounts on your device. Select the account(s) you wish to connect."
                ]
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "button-wrapper"
            }, {
                children: (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                    onClick: function() {
                        onChangeRoute("SpecifyHDPath");
                    }
                }, {
                    children: "HD.../0"
                }))
            })),
            (0, $fba0f23e9e6a11bb$exports.jsx)("form", Object.assign({
                className: "form",
                onSubmit: function(e) {
                    onSubmit(accounts, e);
                }
            }, {
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "nws-form-control"
                        }, {
                            children: accounts.map(function(account, index) {
                                return (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                    className: "account"
                                }, {
                                    children: [
                                        (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            onChange: function(e) {
                                                onSelectedChanged(index, e.target.checked);
                                            },
                                            checked: account.selected,
                                            type: "checkbox",
                                            id: account.accountId,
                                            name: account.accountId,
                                            value: account.accountId
                                        }),
                                        (0, $fba0f23e9e6a11bb$exports.jsxs)("label", Object.assign({
                                            htmlFor: account.accountId
                                        }, {
                                            children: [
                                                " ",
                                                account.accountId
                                            ]
                                        })),
                                        (0, $fba0f23e9e6a11bb$exports.jsx)("br", {})
                                    ]
                                }), index);
                            })
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "action-buttons"
                        }, {
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                type: "submit",
                                disabled: !accounts.some(function(x) {
                                    return x.selected;
                                })
                            }, {
                                children: "Connect"
                            }))
                        }))
                    ]
                })
            }))
        ]
    }));
};
var $2e1e297565bb5552$var$img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR3SURBVHgBpVZ9aJVVGH+e55z33bi7zY9hMz+yMAeNoEIq6A9ZRKQWEsQNFIIpsf5Y9E+GsD9iBEEDMUkDa6ShRKKZYIWiRkaKaUGUGCKOTGMF84PNO99773vOefq9720yK5ZzD/dwPt/nd37P17lEk5Qnuz9roUkKT7T5bNe+QjTNLCHv24h1Xgh+OmtwQYPH2jUXwlnW9NRooqePfLS6MmmQ59cdeEGJlkJZA5MGVecoAwghBYZTVY9ftuaDSy8x8w9fbFl95JZAXuw9dmelkvRAyXxS7wMFryG4bIyWZiqzPgMhaFfGfn3NY3AZG9sPf/Dy8HidZvxkZc/h1pqnPlKey6yspMqUd9jVAEYY6RCGDQTwjGDwGTgAlbwRijV1C9vanz577tT+6r+YrOz5rlXFrQ/qZ+FbDxCfXS5oOgxln4v473f3rbgwdn7FK5/MCaH2eAg6X8g3K2iBMTiBkNJVKbod+ze9mgPZsY/UaicYzCE1HgpZc558olCTjTvWLxv9p1n3bV45iO7T5zq3TU9j9xTOLwQ5D9t48aEYrtGj2P/2BpNS78nZJoRdlDsYd8vphz273lqyhW5Rnlnz3hOe6SEwghvxPUMTVfYe2rpuUOqOkZeIxdSbsSJ8eTIAmXy5tftrMPkzi0C4B2ZDNHp+INvLQURkhYiJ6gDGko376DbEJ8k3mcnYBSeSM2ptL/XGsurNnxfnDIQNwCKADO1845Ef6Tbk0M51g4joMgncDyBmkrtsNEMQovcDxGYsGL2yDNAUxPv0VySs4yxhfeYbabJg0Awg+ILylEB6nKMpSOp0WCR1+QSuD4ELljNDEfyRrdXPCU1BTEgD7pyOzVmC2iBm0KgYAMCEeXovoClIjdKiVdQ3FYbzmatxWRqMPcNsDHyfNWskWk5TkJhNEwVyxA6hLL5clLJsW7voFxa6LiR5CCOeWzo3XFxKtyEdy3tnp7VahAoDp6PEVGvJye09l3P7K9k9WQijXBv4B6WG+0pvD0ybFEBHZ6OPh+/OGaBsIvNRAGp/ZHv1jJeon+omszBkFsr3FhsLB7rev3JLQKVSyfjmaW2BJSavDlqR7c5VrR+4AbLttbkXMehH7gjA8gZiD/tq+Or/ABZ3dUW/J62LcPUGcrW8pKSVFAg6cHz3O0l25qZHa/XGwWPg9aAwwzdZAaDX+7tbNsMYf5+bpaUS0dDQEF8rtsUxCbI5e5KRzGhBMiqNxllKju7d8NOYXjseRBytQngcVDL3wD9H+7vf3YS7mnnzqrZpwSxrwkh04cpM5NTMyJdHbIgaESyxJ6tZ5cDbw3qd0tqVCp25Se/4yYdr5/zm/ehjwvpxZHgN0Wlub0/Yt7awdykqRYFHy6NUQVrBd4o6p6ngrVL2Bo8ksuJqoXzq9Ln9m6rj9U74b6Wjo8OeP082aY5NUxRsYzwDkeFsU+MdUU3U4PG0QtbahqhadDMuHTy4fvS/9EwIUpdeuW/ZiShOipFxURRbNdWETFMRZrCFlEZGkuPHdycTafgLExNiI6YfUpcAAAAASUVORK5CYII=";
var $2e1e297565bb5552$var$WalletConnecting = function(param) {
    var wallet = param.wallet, onCloseModal = param.onCloseModal;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6cds3.Fragment), {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                title: "",
                onCloseModal: onCloseModal
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "connecting-wrapper"
            }, {
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                src: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.iconUrl,
                                alt: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name
                            })
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                            className: "connecting-details"
                        }, {
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                    className: "spinner"
                                }, {
                                    children: (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        src: $2e1e297565bb5552$var$img,
                                        alt: "loading-icon"
                                    })
                                })),
                                (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                    children: [
                                        (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.connectingTo"),
                                        " ",
                                        wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name,
                                        "..."
                                    ]
                                })
                            ]
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                            className: "connecting-message"
                        }, {
                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.connectingMessage.".concat(wallet === null || wallet === void 0 ? void 0 : wallet.type))
                            })
                        }))
                    ]
                }))
            }))
        ]
    });
};
var $2e1e297565bb5552$var$LedgerDeviceIcon = function() {
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
        width: "317",
        height: "157",
        viewBox: "0 0 317 157",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M249.99 16.0994C270.063 -0.864155 289.788 1.58873 301.497 10.7365C307.402 15.3499 311.278 21.6575 312.267 28.1258C313.247 34.5412 311.413 41.2233 305.692 46.8044C297.366 54.9273 286.343 55.3362 273.015 51.5109C261.654 48.25 249.058 42.0377 235.726 35.4627L235.726 35.4626L235.717 35.458C233.367 34.2992 230.995 33.129 228.602 31.9618C212.742 24.2253 196.067 16.6575 179.842 13.8595C163.538 11.0479 147.552 13.0313 133.266 24.522C128.032 28.732 123.478 35.2086 121.716 44.8205C119.961 54.3947 120.992 66.9771 126.703 83.4311C135.432 108.583 132.899 126.677 123.575 138.063C114.217 149.491 97.5614 154.733 76.7887 153.121C55.0043 151.43 29.0621 142.206 3.29867 125.227L0.887817 127.942C27.2472 145.405 53.9251 154.952 76.5105 156.705C97.9028 158.365 115.96 153.035 126.356 140.341C136.785 127.606 139.045 108.029 130.099 82.2524C124.521 66.1801 123.642 54.2493 125.252 45.4687C126.854 36.7258 130.94 31.006 135.519 27.3232C148.794 16.6458 163.649 14.715 179.231 17.4021C194.891 20.1027 211.146 27.4463 227.026 35.1928C229.381 36.3415 231.729 37.5001 234.066 38.6531L234.073 38.6568C247.382 45.223 260.324 51.608 272.024 54.9662C285.819 58.9258 298.493 58.8501 308.202 49.3776C314.764 42.9759 316.974 35.1288 315.82 27.5826C314.675 20.0893 310.237 13.0029 303.71 7.90363C290.555 -2.37382 268.938 -4.62038 247.67 13.3537L249.99 16.0994Z",
                fill: "url(#paint0_linear_3_672)"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M260.264 17.8767L177.605 89.4649L157.679 73.9664L239.23 3.85423L260.264 17.8767Z",
                fill: "#6A7075"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M205.939 54.4577L199.764 50.2636L233.316 20.9053L239.907 25.8395L205.939 54.4577Z",
                fill: "#494E52"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M260.264 17.8757L177.605 89.4639L182.033 98.3202L264.323 26.363L260.264 17.8757Z",
                fill: "#494E52"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M177.236 89.4646L181.295 98.3209L165.059 85.7745L170.963 85.0365L177.236 89.4646Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M93.4708 99.6384L91.9948 110.13L174.653 92.894L164.69 85.7749L93.4708 99.6384Z",
                fill: "#DCDADA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M93.1157 104.323L94.314 100.129L165.613 86.3483L169.208 89.344L93.1157 104.323Z",
                fill: "#C1C1C1"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M94.2086 99.7963L86.0903 101.272L92.3635 110.129L94.2086 99.7963Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M86.0903 100.907L89.0027 74.1304L178.455 55.2416C184.695 53.9962 195.766 54.7675 197.177 63.7058C198.284 70.717 195.506 73.9943 191.628 77.3592C188.495 80.0671 180.152 82.4646 178.343 82.8944C178.293 82.9064 178.241 82.9188 178.186 82.9319C177.38 83.1245 176.007 83.4525 170.644 84.5088C169.085 84.8158 167.382 85.1501 165.557 85.5078L164.933 85.63C146.312 89.2764 115.528 95.2297 93.9844 99.3849C91.1808 99.9257 88.5337 100.436 86.0903 100.907ZM185.076 75.554C190.748 73.3535 193.99 68.0745 192.318 63.7631C190.645 59.4517 184.691 57.7405 179.019 59.941C173.347 62.1416 170.105 67.4206 171.778 71.732C173.45 76.0434 179.404 77.7546 185.076 75.554Z",
                fill: "#F4F1E8"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M199.764 50.3994L196.768 48.3043L232.194 18.0454L233.316 21.6403L199.764 50.3994Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M239.968 25.9943L232.588 20.4592V17.5071L241.813 24.5183L239.968 25.9943Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("ellipse", {
                cx: "182.084",
                cy: "68.0811",
                rx: "10.242",
                ry: "7.46772",
                transform: "rotate(-23.7949 182.084 68.0811)",
                fill: "#494E52"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("ellipse", {
                cx: "182.084",
                cy: "68.0816",
                rx: "6.68462",
                ry: "4.87394",
                transform: "rotate(-23.7949 182.084 68.0816)",
                fill: "#494E52"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M238.725 2.93094L260.368 17.2564L264.865 26.4556L181.615 99.0341L175.16 94.311L92.0028 110.947L85.3267 101.399L88.3269 73.8157L178.118 54.8553L238.725 2.93094ZM178.599 56.2622L89.6786 75.0388L86.9321 100.29C89.0979 99.8725 91.4124 99.4263 93.8446 98.9572C115.388 94.8019 146.171 88.8488 164.791 85.2026L165.415 85.0804C167.24 84.7228 168.943 84.3885 170.501 84.0816C175.853 83.0275 177.219 82.701 178.015 82.5107C178.07 82.4976 178.122 82.4852 178.173 82.4732C179.048 82.2652 181.558 81.5669 184.235 80.5851C186.742 79.6655 189.286 78.5354 190.802 77.3758L191.151 77.0922L191.644 76.6595C193.341 75.147 194.723 73.6739 195.61 71.871C196.571 69.916 196.982 67.5029 196.448 64.1178C195.8 60.0131 192.959 57.7574 189.408 56.6566C185.833 55.5483 181.637 55.6566 178.603 56.2615C178.601 56.2617 178.6 56.262 178.599 56.2622ZM192.631 77.7565L259.555 18.9531L263.042 26.0869L181.808 96.9078L178.132 89.5713L191.724 78.529C191.859 78.4249 191.988 78.32 192.11 78.2144L192.111 78.2136C192.286 78.0617 192.46 77.9094 192.631 77.7565ZM185.491 81.6908C185.24 81.7868 184.99 81.8802 184.743 81.9709C182.013 82.9723 179.447 83.6875 178.514 83.9093C178.463 83.9213 178.411 83.9338 178.356 83.9468C177.635 84.1192 176.472 84.3971 172.491 85.1919L177.172 88.4492L185.491 81.6908ZM176.631 89.8707L170.479 85.5903C169.306 85.8213 168.054 86.0673 166.731 86.3265L175.769 92.9276L179.548 95.6924L176.631 89.8707ZM164.758 86.7132C146.252 90.3362 116.027 96.1817 94.6324 100.308L93.2258 109.197L173.543 93.1293L164.758 86.7132ZM91.888 108.207L93.0909 100.606C91.0848 100.993 89.1642 101.363 87.3471 101.713L91.888 108.207ZM258.581 17.8436L197.306 71.6841C198.142 69.5779 198.41 67.0795 197.906 63.8876C197.143 59.0539 193.743 56.4549 189.845 55.2467C186.921 54.3402 183.662 54.1916 180.861 54.449L238.84 4.77668L258.581 17.8436ZM232.505 16.82L243.089 24.5643L205.915 56.5106L196.042 48.0665L232.505 16.82ZM232.118 19.096L198.312 48.0654L199.744 49.29L232.584 20.9424L232.118 19.096ZM233.456 22.1396L200.878 50.2604L205.913 54.5664L239.041 26.0969L233.456 22.1396ZM240.195 25.1054L240.717 24.6571L233.759 19.5663L234.06 20.7586L240.195 25.1054Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M190.194 69.9744C191.32 68.1409 191.576 66.2271 190.942 64.5937C190.308 62.9603 188.829 61.7198 186.761 61.1254C184.691 60.5307 182.116 60.6196 179.553 61.6139C176.991 62.6081 175.029 64.2794 173.902 66.1141C172.776 67.9477 172.52 69.8614 173.154 71.4948C173.788 73.1282 175.267 74.3687 177.335 74.9631C179.405 75.5578 181.98 75.4689 184.543 74.4746C187.105 73.4804 189.067 71.8091 190.194 69.9744ZM185.077 75.8508C190.749 73.6502 193.991 68.3712 192.318 64.0598C190.645 59.7484 184.691 58.0372 179.019 60.2378C173.347 62.4383 170.105 67.7173 171.778 72.0287C173.451 76.3401 179.405 78.0513 185.077 75.8508Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M187.391 69.169C188.127 67.9713 188.266 66.7721 187.881 65.7812C187.497 64.7903 186.586 63.9984 185.235 63.6102C183.883 63.2216 182.173 63.2741 180.456 63.9404C178.738 64.6068 177.441 65.7208 176.705 66.9196C175.969 68.1172 175.83 69.3165 176.215 70.3074C176.599 71.2983 177.511 72.0901 178.861 72.4783C180.214 72.8669 181.923 72.8144 183.64 72.1481C185.358 71.4818 186.655 70.3678 187.391 69.169ZM184.174 73.5242C188.156 71.9795 190.432 68.2738 189.257 65.2473C188.083 62.2208 183.904 61.0196 179.922 62.5643C175.94 64.1091 173.665 67.8148 174.839 70.8412C176.013 73.8677 180.193 75.0689 184.174 73.5242Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M240.499 41.2441C239.744 40.3649 239.844 39.04 240.724 38.285L249.781 30.5067C250.66 29.7516 251.985 29.8523 252.74 30.7315V30.7315C253.495 31.6108 253.395 32.9356 252.516 33.6907L243.458 41.469C242.579 42.224 241.254 42.1234 240.499 41.2441V41.2441Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M250.743 31.6265L241.685 39.4048C241.424 39.6287 241.395 40.0217 241.619 40.2825C241.842 40.5433 242.235 40.5731 242.496 40.3492L251.554 32.5709C251.815 32.3469 251.845 31.954 251.621 31.6932C251.397 31.4324 251.004 31.4025 250.743 31.6265ZM240.724 38.285C239.844 39.04 239.744 40.3649 240.499 41.2441C241.254 42.1234 242.579 42.224 243.458 41.469L252.516 33.6907C253.395 32.9356 253.495 31.6108 252.74 30.7315C251.985 29.8523 250.66 29.7516 249.781 30.5067L240.724 38.285Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M205.779 71.4647C205.005 70.5642 205.108 69.2073 206.009 68.4339L214.989 60.7218C215.89 59.9485 217.247 60.0516 218.02 60.9521V60.9521C218.793 61.8526 218.69 63.2095 217.79 63.9829L208.809 71.695C207.909 72.4683 206.552 72.3652 205.779 71.4647V71.4647Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M215.951 61.8416L206.97 69.5537C206.688 69.796 206.656 70.221 206.898 70.5031C207.141 70.7851 207.566 70.8174 207.848 70.5752L216.828 62.863C217.11 62.6208 217.143 62.1958 216.9 61.9137C216.658 61.6317 216.233 61.5994 215.951 61.8416ZM206.009 68.4339C205.108 69.2073 205.005 70.5642 205.779 71.4647C206.552 72.3652 207.909 72.4683 208.809 71.695L217.79 63.9829C218.69 63.2095 218.793 61.8526 218.02 60.9521C217.247 60.0516 215.89 59.9485 214.989 60.7218L206.009 68.4339Z",
                fill: "black"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "141.356",
                cy: "19.525",
                r: "10.1855",
                fill: "#FE89B4"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("ellipse", {
                cx: "139.062",
                cy: "14.7094",
                rx: "2.42519",
                ry: "1.94015",
                transform: "rotate(-34.544 139.062 14.7094)",
                fill: "#FDF7FF"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                cx: "252.489",
                cy: "79.7577",
                r: "7.78893",
                fill: "#EC5236"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("ellipse", {
                cx: "250.434",
                cy: "76.3701",
                rx: "2.61272",
                ry: "2.09018",
                transform: "rotate(-34.544 250.434 76.3701)",
                fill: "#EDB69D"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.436 79.9254C100.461 79.6567 100.732 79.3897 101.042 79.329L106.657 78.2299C107.587 78.0478 108.281 78.5536 108.207 79.3596L107.759 84.2243C107.734 84.493 107.463 84.76 107.153 84.8207L100.416 86.1396C100.106 86.2003 99.8742 86.0317 99.899 85.7631L100.436 79.9254Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.8553 81.7775C95.9294 80.9715 96.7437 80.1704 97.6739 79.9883L98.7968 79.7685C99.1069 79.7078 99.3382 79.8764 99.3135 80.1451L99.1344 82.091C99.1096 82.3597 98.8382 82.6267 98.5282 82.6874L96.2824 83.127C95.9723 83.1877 95.741 83.0191 95.7657 82.7505L95.8553 81.7775Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.5865 84.6965C95.6112 84.4278 95.8826 84.1608 96.1927 84.1001L98.4385 83.6605C98.7486 83.5998 98.9799 83.7684 98.9552 84.037L98.7761 85.9829C98.7513 86.2516 98.4799 86.5186 98.1699 86.5793L95.9241 87.019C95.614 87.0797 95.3827 86.9111 95.4074 86.6424L95.5865 84.6965Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.2282 88.5884C95.2529 88.3197 95.5244 88.0527 95.8344 87.992L98.0802 87.5524C98.3903 87.4917 98.6216 87.6603 98.5969 87.929L98.4178 89.8749C98.3931 90.1435 98.1216 90.4105 97.8116 90.4712L96.6887 90.6911C95.7584 90.8732 95.0645 90.3674 95.1387 89.5614L95.2282 88.5884Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M99.7197 87.709C99.7444 87.4403 100.016 87.1733 100.326 87.1126L102.572 86.673C102.882 86.6123 103.113 86.7809 103.088 87.0496L102.909 88.9955C102.885 89.2641 102.613 89.5312 102.303 89.5919L100.057 90.0315C99.7472 90.0922 99.5159 89.9236 99.5406 89.6549L99.7197 87.709Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.211 86.8298C104.236 86.5611 104.507 86.2941 104.817 86.2334L107.063 85.7938C107.373 85.7331 107.605 85.9017 107.58 86.1704L107.49 87.1433C107.416 87.9493 106.602 88.7504 105.672 88.9325L104.549 89.1523C104.239 89.213 104.007 89.0444 104.032 88.7757L104.211 86.8298Z",
                fill: "#B3AAAA"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("defs", {
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("linearGradient", Object.assign({
                    id: "paint0_linear_3_672",
                    x1: "-44.5195",
                    y1: "122.42",
                    x2: "263.357",
                    y2: "-8.65023",
                    gradientUnits: "userSpaceOnUse"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                            offset: "0.110697",
                            stopColor: "#232323"
                        }),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#3D3D3D"
                        })
                    ]
                }))
            })
        ]
    }));
};
var $2e1e297565bb5552$var$DEFAULT_DERIVATION_PATH = "44'/397'/0'/0'/1'";
var $2e1e297565bb5552$var$DerivationPath = function(param) {
    var selector = param.selector, options = param.options, onBack = param.onBack, onConnected = param.onConnected, params = param.params, onError = param.onError, onCloseModal = param.onCloseModal;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)("EnterDerivationPath"), 2), route = _useState[0], setRoute = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)($2e1e297565bb5552$var$DEFAULT_DERIVATION_PATH), 2), derivationPath = _useState1[0], setDerivationPath = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(1), 2), customDerivationPath = _useState2[0], setCustomDerivationPath = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), accounts = _useState3[0], setAccounts = _useState3[1];
    var _useState4 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), selectedAccounts = _useState4[0], setSelectedAccounts = _useState4[1];
    var _useState5 = (0, $8GFUW._)((0, $6cds3.useState)(), 2), hardwareWallet = _useState5[0], setHardwareWallet = _useState5[1];
    var _useState6 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), customAccountId = _useState6[0], setCustomAccountId = _useState6[1];
    var _useState7 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), connecting = _useState7[0], setConnecting = _useState7[1];
    var initalHeaderTitle = (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.connectWithLedger");
    var _useState8 = (0, $8GFUW._)((0, $6cds3.useState)(initalHeaderTitle), 2), headerTitle = _useState8[0], setHeaderTitle = _useState8[1];
    var getAccountIds = function(publicKey) {
        return $2e1e297565bb5552$var$__awaiter(void 0, void 0, void 0, function() {
            var response, accountIds;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(selector.options.network.indexerUrl, "/publicKey/ed25519:").concat(publicKey, "/accounts"))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) throw new Error("Failed to get account id from public key");
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        accountIds = _state.sent();
                        if (!Array.isArray(accountIds) || !accountIds.length) return [
                            2,
                            []
                        ];
                        return [
                            2,
                            accountIds
                        ];
                }
            });
        });
    };
    var resolveAccounts = function(wallet) {
        return $2e1e297565bb5552$var$__awaiter(void 0, void 0, void 0, function() {
            var publicKey, accountIds, e;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            wallet.getPublicKey(derivationPath)
                        ];
                    case 1:
                        publicKey = _state.sent();
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getAccountIds(publicKey)
                        ];
                    case 3:
                        accountIds = _state.sent();
                        return [
                            2,
                            accountIds.map(function(accountId, index) {
                                return {
                                    derivationPath: derivationPath,
                                    publicKey: publicKey,
                                    accountId: accountId,
                                    selected: index === 0
                                };
                            })
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var handleValidateAccount = function() {
        return $2e1e297565bb5552$var$__awaiter(void 0, void 0, void 0, function() {
            var wallet, resolvedAccounts, noAccounts, multipleAccounts, err, message;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            selector.wallet(params.walletId)
                        ];
                    case 1:
                        wallet = _state.sent();
                        if (wallet.type !== "hardware") return [
                            2
                        ];
                        setConnecting(true);
                        setHardwareWallet(wallet);
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            resolveAccounts(wallet)
                        ];
                    case 3:
                        resolvedAccounts = _state.sent();
                        if (!resolvedAccounts) {
                            setRoute("AddCustomAccountId");
                            return [
                                2
                            ];
                        }
                        noAccounts = resolvedAccounts.length === 0;
                        multipleAccounts = resolvedAccounts.length > 1;
                        if (noAccounts) {
                            setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.noAccountsFound"));
                            setRoute("NoAccountsFound");
                            return [
                                2
                            ];
                        }
                        setAccounts(resolvedAccounts);
                        if (!multipleAccounts) {
                            setSelectedAccounts(resolvedAccounts);
                            setRoute("OverviewAccounts");
                        } else {
                            setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.selectYourAccounts"));
                            setRoute("ChooseAccount");
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        err = _state.sent();
                        setConnecting(false);
                        message = err instanceof Error ? err.message : "Something went wrong";
                        onError(message, wallet);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setConnecting(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var handleAddCustomAccountId = function() {
        return $2e1e297565bb5552$var$__awaiter(void 0, void 0, void 0, function() {
            var publicKey, accountList, err, message;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setConnecting(true);
                        return [
                            4,
                            hardwareWallet.getPublicKey(derivationPath)
                        ];
                    case 1:
                        publicKey = _state.sent();
                        accountList = [
                            {
                                derivationPath: derivationPath,
                                publicKey: publicKey,
                                accountId: customAccountId,
                                selected: true
                            }
                        ];
                        setAccounts(accountList);
                        setSelectedAccounts(accountList);
                        setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.connecting1Account"));
                        setRoute("OverviewAccounts");
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        setConnecting(false);
                        message = err instanceof Error ? err.message : "Something went wrong";
                        onError(message, hardwareWallet);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setConnecting(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var handleSignIn = function() {
        var mapAccounts = selectedAccounts.map(function(account) {
            return {
                derivationPath: account.derivationPath,
                publicKey: account.publicKey,
                accountId: account.accountId
            };
        });
        return hardwareWallet.signIn({
            contractId: options.contractId,
            methodNames: options.methodNames,
            accounts: mapAccounts
        }).then(function() {
            return onConnected();
        }).catch(function(err) {
            onError("Error: ".concat(err.message), hardwareWallet);
        });
    };
    var handleOnBackButtonClick = function() {
        if (route === "SpecifyHDPath" || route === "NoAccountsFound" || route === "ChooseAccount") {
            setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.connectWithLedger"));
            setRoute("EnterDerivationPath");
        }
        if (route === "OverviewAccounts") {
            setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.selectYourAccounts"));
            setRoute("ChooseAccount");
        }
    };
    if (connecting) return (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
        className: "derivation-path-wrapper"
    }, {
        children: (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletConnecting, {
            wallet: hardwareWallet,
            onBack: function() {
                setConnecting(false);
            },
            onCloseModal: onCloseModal
        })
    }));
    return (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6cds3.Fragment), {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (route === "SpecifyHDPath" || route === "NoAccountsFound" || route === "ChooseAccount" || route === "OverviewAccounts") && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$BackArrow, {
                        onClick: handleOnBackButtonClick
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                        title: headerTitle,
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "derivation-path-wrapper"
            }, {
                children: [
                    route === "EnterDerivationPath" && (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "enter-derivation-path"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "ledger-image"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$LedgerDeviceIcon, {})
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                className: "ledger-description"
                            }, {
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.makeSureYourLedger")
                                    }),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("p", Object.assign({
                                        className: "specify-path",
                                        onClick: function() {
                                            setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath"));
                                            setRoute("SpecifyHDPath");
                                        }
                                    }, {
                                        children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath")
                                    }))
                                ]
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleValidateAccount
                                }, {
                                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.continue")
                                }))
                            }))
                        ]
                    })),
                    route === "SpecifyHDPath" && (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "specify-path-wrapper"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                className: "change-path-wrapper"
                            }, {
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                        className: "display-path"
                                    }, {
                                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            children: derivationPath.slice(0, -2)
                                        })
                                    })),
                                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                        className: "change-path"
                                    }, {
                                        children: [
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                                className: "path-value"
                                            }, {
                                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    children: customDerivationPath
                                                })
                                            })),
                                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                                className: "buttons-wrapper"
                                            }, {
                                                children: [
                                                    (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                                        onClick: function() {
                                                            var newValue = customDerivationPath + 1;
                                                            var path = derivationPath.slice(0, -2);
                                                            setDerivationPath("".concat(path).concat(newValue, "'"));
                                                            setCustomDerivationPath(newValue);
                                                        }
                                                    }, {
                                                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", Object.assign({
                                                            width: "10",
                                                            height: "7",
                                                            viewBox: "0 0 10 7",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg"
                                                        }, {
                                                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                                d: "M9 5.4762L5 1.4762L1 5.4762",
                                                                stroke: "#4F7CD1",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }))
                                                    })),
                                                    (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                                        onClick: function() {
                                                            var newValue = customDerivationPath - 1;
                                                            if (newValue < 0) return;
                                                            var path = derivationPath.slice(0, -2);
                                                            setDerivationPath("".concat(path).concat(newValue, "'"));
                                                            setCustomDerivationPath(newValue);
                                                        }
                                                    }, {
                                                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", Object.assign({
                                                            width: "10",
                                                            height: "7",
                                                            viewBox: "0 0 10 7",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg"
                                                        }, {
                                                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                                d: "M1 1.52382L5 5.52382L9 1.52382",
                                                                stroke: "#4F7CD1",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }))
                                                    }))
                                                ]
                                            }))
                                        ]
                                    }))
                                ]
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", Object.assign({
                                className: "path-description"
                            }, {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.enterYourPreferredHDPath")
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", Object.assign({
                                className: "what-link"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("a", Object.assign({
                                    href: "https://www.ledger.com/academy/crypto/what-are-hierarchical-deterministic-hd-wallets",
                                    target: "_blank"
                                }, {
                                    children: "What's this?"
                                }))
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleValidateAccount
                                }, {
                                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.scan")
                                }))
                            }))
                        ]
                    })),
                    route === "NoAccountsFound" && (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "no-accounts-found-wrapper"
                    }, {
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.cantFindAnyAccount"),
                                " ",
                                (0, $fba0f23e9e6a11bb$exports.jsx)("a", Object.assign({
                                    href: "https://".concat(selector.options.network.networkId === "testnet" ? "testnet" : "app", ".mynearwallet.com/create"),
                                    target: "_blank"
                                }, {
                                    children: "MyNearWallet"
                                })),
                                " ",
                                (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.orConnectAnAnotherLedger")
                            ]
                        })
                    })),
                    route === "ChooseAccount" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$HardwareWalletAccountsForm, {
                        accounts: accounts,
                        onSelectedChanged: function(index, selected) {
                            setAccounts(function(prevAccounts) {
                                var updateAccounts = prevAccounts.map(function(account, idx) {
                                    var selectedValue = index === idx ? selected : account.selected;
                                    return Object.assign(Object.assign({}, account), {
                                        selected: selectedValue
                                    });
                                });
                                return (0, $fLnyw._)(updateAccounts);
                            });
                        },
                        onSubmit: function(acc, e) {
                            e.preventDefault();
                            var selectedAcc = acc.filter(function(account) {
                                return account.selected;
                            });
                            setSelectedAccounts(selectedAcc);
                            var numberOfAccounts = selectedAcc.length;
                            setHeaderTitle("".concat((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.connecting"), " ").concat(numberOfAccounts, " ").concat((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.ofAccounts")));
                            setRoute("OverviewAccounts");
                        },
                        onChangeRoute: function(newRoute) {
                            if (newRoute === "SpecifyHDPath") setHeaderTitle((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath"));
                            setRoute(newRoute);
                        }
                    }),
                    route === "AddCustomAccountId" && (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "enter-custom-account"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.failedToAutomatically")
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "input-wrapper"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Account ID",
                                    value: customAccountId,
                                    onChange: function(e) {
                                        setCustomAccountId(e.target.value);
                                    }
                                })
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleAddCustomAccountId
                                }, {
                                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("ledger.Continue")
                                }))
                            }))
                        ]
                    })),
                    route === "OverviewAccounts" && (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "overview-wrapper"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.overviewTheListOfAuthorized")
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "accounts"
                            }, {
                                children: selectedAccounts.map(function(account, index) {
                                    return (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                            className: "account"
                                        }, {
                                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                children: account.accountId
                                            })
                                        }))
                                    }, account.accountId);
                                })
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleSignIn,
                                    disabled: accounts.length === 0
                                }, {
                                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.ledger.finish")
                                }))
                            }))
                        ]
                    }))
                ]
            }))
        ]
    });
};
var $2e1e297565bb5552$var$WalletNotInstalled = function(param) {
    var module = param.module, onBack = param.onBack, onCloseModal = param.onCloseModal;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6cds3.Fragment), {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$BackArrow, {
                        onClick: onBack
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                        title: "",
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "wallet-not-installed-wrapper"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "wallet-data"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "wallet-icon-box ".concat(module.id)
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: module.metadata.iconUrl,
                                    alt: module.metadata.name
                                })
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: module.metadata.name
                            })
                        ]
                    })),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.install.youllNeedToInstall"),
                            " ",
                            module.metadata.name,
                            " ",
                            (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.install.toContinueAfterInstalling"),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("span", Object.assign({
                                className: "refresh-link",
                                onClick: function() {
                                    return window.location.reload();
                                }
                            }, {
                                children: [
                                    " ",
                                    (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.install.refreshThePage")
                                ]
                            }))
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "action-buttons"
                    }, {
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("button", Object.assign({
                            className: "middleButton",
                            onClick: function() {
                                if (module.type !== "injected") return;
                                window.open(module.metadata.downloadUrl, "_blank");
                            }
                        }, {
                            children: [
                                (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.install.open"),
                                " ",
                                module.metadata.name
                            ]
                        }))
                    }))
                ]
            }))
        ]
    });
};
var $2e1e297565bb5552$var$WalletHome = function(param) {
    var selector = param.selector, onCloseModal = param.onCloseModal;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), modules = _useState[0], setModules = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)("WalletInfo"), 2), route = _useState1[0], setRoute = _useState1[1];
    (0, $6cds3.useEffect)(function() {
        var subscription = selector.store.observable.subscribe(function(state) {
            var filterByType = function(item) {
                return item.type !== "bridge" && item.type !== "hardware";
            };
            var filteredModules = state.modules.filter(filterByType);
            setModules(filteredModules);
        });
        return function() {
            return subscription.unsubscribe();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var goToWallet = function(module) {
        var networkId = selector.options.network.networkId;
        var url = "";
        if (module.type === "injected") url = module.metadata.downloadUrl;
         // TODO: improve links to wallets other than injected type.
        if (module.id === "my-near-wallet") {
            var subdomain = networkId === "testnet" ? "testnet" : "app";
            url = "https://".concat(subdomain, ".mynearwallet.com");
        }
        if (module.id === "opto-wallet") {
            var subdomain1 = networkId === "testnet" ? "app.testnet" : "app";
            url = "https://".concat(subdomain1, ".optowallet.com");
        }
        if (module.id === "near-wallet") {
            var subdomain2 = networkId === "testnet" ? "testnet." : "";
            url = "https://wallet.".concat(subdomain2, "near.org");
        }
        if (module.id === "here-wallet") url = "https://herewallet.app/";
        if (url === "" && module.type === "bridge" || module.type === "hardware") return;
        window.open(url, "_blank");
    };
    var getTypeNameAndIcon = function(walletId, type) {
        switch(type){
            case "injected":
                if (walletId === "nearfi") return {
                    typeFullName: "Wallet Extension",
                    qrIcon: true
                };
                if (walletId === "here-wallet") return {
                    typeFullName: "Mobile Wallet",
                    qrIcon: true
                };
                return {
                    typeFullName: "Wallet Extension",
                    qrIcon: false
                };
            case "browser":
                if (walletId === "here-wallet") return {
                    typeFullName: "Web Wallet",
                    qrIcon: true
                };
                return {
                    typeFullName: "Web Wallet",
                    qrIcon: false
                };
            default:
                return {
                    typeFullName: "Web Wallet",
                    qrIcon: false
                };
        }
    };
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
        className: "wallet-home-wrapper"
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    route === "GetWallets" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$BackArrow, {
                        onClick: function() {
                            setRoute("WalletInfo");
                        }
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                        title: route === "GetWallets" ? (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.getAWallet") : (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.whatIsAWallet"),
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            route === "GetWallets" && (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "get-wallet-wrapper"
            }, {
                children: modules.map(function(module) {
                    var _module_metadata = module.metadata, iconUrl = _module_metadata.iconUrl, name = _module_metadata.name;
                    var type = module.type, id = module.id;
                    var _getTypeNameAndIcon = getTypeNameAndIcon(id, type), typeFullName = _getTypeNameAndIcon.typeFullName, qrIcon = _getTypeNameAndIcon.qrIcon;
                    return (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        tabIndex: 0,
                        className: "single-wallet-get ".concat(module.id),
                        onClick: function() {
                            goToWallet(module);
                        }
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                className: "small-icon"
                            }, {
                                children: [
                                    qrIcon && (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                                        width: "18",
                                        height: "16",
                                        viewBox: "0 0 18 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, {
                                        children: [
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M7.22224 1.33334H1.44446V6.66668H7.22224V1.33334Z",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M15.8889 1.33334H10.1111V6.66668H15.8889V1.33334Z",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M7.22224 9.33334H1.44446V14.6667H7.22224V9.33334Z",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M10.1111 13.1429V14.6667H15.8889M10.1111 9.33334V10.8572H12.5873V9.33334H15.8889V12.381",
                                                stroke: "#4C5155",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                                                x: "3.61108",
                                                y: "3.33334",
                                                width: "1.44444",
                                                height: "1.33333",
                                                fill: "#4C5155"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                                                x: "3.61108",
                                                y: "11.3333",
                                                width: "1.44444",
                                                height: "1.33333",
                                                fill: "#4C5155"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                                                x: "12.2778",
                                                y: "3.33334",
                                                width: "1.44445",
                                                height: "1.33333",
                                                fill: "#4C5155"
                                            })
                                        ]
                                    })),
                                    !qrIcon && (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                                        width: "18",
                                        height: "16",
                                        viewBox: "0 0 18 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, {
                                        children: [
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M13 8.66667V12.6667C13 13.0203 12.8478 13.3594 12.577 13.6095C12.3061 13.8595 11.9387 14 11.5556 14H3.61113C3.22804 14 2.86064 13.8595 2.58975 13.6095C2.31887 13.3594 2.16669 13.0203 2.16669 12.6667V5.33333C2.16669 4.97971 2.31887 4.64057 2.58975 4.39052C2.86064 4.14048 3.22804 4 3.61113 4H7.94447",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M10.8333 2H15.1666V6",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M7.22223 9.33333L15.1667 2",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "icon"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: iconUrl,
                                    alt: name
                                })
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                className: "content"
                            }, {
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                        className: "title"
                                    }, {
                                        children: name
                                    })),
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                        className: "type"
                                    }, {
                                        children: typeFullName
                                    }))
                                ]
                            }))
                        ]
                    }), module.id);
                })
            })),
            route === "WalletInfo" && (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "wallet-info-wrapper what-wallet-hide"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                className: "wallet-what"
                            }, {
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                        className: "icon-side"
                                    }, {
                                        children: (0, $fba0f23e9e6a11bb$exports.jsx)("svg", Object.assign({
                                            width: "40",
                                            height: "40",
                                            viewBox: "0 0 40 40",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, {
                                            children: (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                d: "M33.5 1.83325L30.1666 5.16658M17.4818 17.8514C19.1406 19.5103 20.1666 21.8019 20.1666 24.3333C20.1666 29.3959 16.0626 33.4999 11 33.4999C5.93735 33.4999 1.8333 29.3959 1.8333 24.3333C1.8333 19.2706 5.93735 15.1666 11 15.1666C13.5313 15.1666 15.8229 16.1926 17.4818 17.8514ZM17.4818 17.8514L24.3333 10.9999M24.3333 10.9999L29.3333 15.9999L35.1666 10.1666L30.1666 5.16658M24.3333 10.9999L30.1666 5.16658",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }))
                                    })),
                                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                        className: "content-side"
                                    }, {
                                        children: [
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.secureAndManage")
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.safelyStore")
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                className: "wallet-what"
                            }, {
                                children: [
                                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                        className: "icon-side"
                                    }, {
                                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                                            width: "40",
                                            height: "41",
                                            viewBox: "0 0 40 41",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, {
                                            children: [
                                                (0, $fba0f23e9e6a11bb$exports.jsx)("circle", {
                                                    cx: "28.3333",
                                                    cy: "23.8333",
                                                    r: "1.66667",
                                                    fill: "currentColor"
                                                }),
                                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                    d: "M35 12.1667H7C5.89543 12.1667 5 11.2712 5 10.1667V7.5C5 6.39543 5.89543 5.5 7 5.5H31.6667",
                                                    stroke: "currentColor",
                                                    strokeWidth: "3",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                                    d: "M35 12.1667V35.5H7C5.89543 35.5 5 34.6046 5 33.5V8.83334",
                                                    stroke: "currentColor",
                                                    strokeWidth: "3",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }))
                                    })),
                                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                                        className: "content-side"
                                    }, {
                                        children: [
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.logInToAny")
                                            }),
                                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.noNeedToCreate")
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "button-spacing"
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                onClick: function() {
                                    setRoute("GetWallets");
                                }
                            }, {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.getAWallet")
                            }))
                        ]
                    })),
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "what-wallet-mobile"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.useAWallet")
                            }),
                            (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                onClick: function() {
                                    setRoute("GetWallets");
                                }
                            }, {
                                children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.getAWallet")
                            }))
                        ]
                    })),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "lang-selector-wrapper"
                    }, {
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("select", Object.assign({
                            className: "lang-selector",
                            name: "lang"
                        }, {
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("option", Object.assign({
                                    value: "en"
                                }, {
                                    children: "English"
                                })),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("option", Object.assign({
                                    value: "es"
                                }, {
                                    children: "Spanish"
                                }))
                            ]
                        }))
                    }))
                ]
            })
        ]
    }));
};
var $2e1e297565bb5552$var$WalletConnected = function(param) {
    var module = param.module, onCloseModal = param.onCloseModal;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $6cds3.Fragment), {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("h3", Object.assign({
                        className: "middleTitle"
                    }, {
                        children: ""
                    })),
                    (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$CloseButton, {
                        onClick: onCloseModal
                    })
                ]
            })),
            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                className: "connecting-wrapper"
            }, {
                children: (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "green-dot"
                                }),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: module === null || module === void 0 ? void 0 : module.metadata.iconUrl,
                                    alt: module === null || module === void 0 ? void 0 : module.metadata.name
                                })
                            ]
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: module === null || module === void 0 ? void 0 : module.metadata.name
                        })),
                        (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                            className: "wallet-connected-success"
                        }, {
                            children: [
                                (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
                                    width: "21",
                                    height: "20",
                                    viewBox: "0 0 21 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                }, {
                                    children: [
                                        (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                            d: "M18.8333 9.2333V9.99997C18.8323 11.797 18.2504 13.5455 17.1744 14.9848C16.0984 16.4241 14.586 17.477 12.8628 17.9866C11.1395 18.4961 9.29768 18.4349 7.61202 17.8121C5.92636 17.1894 4.48717 16.0384 3.50909 14.5309C2.53101 13.0233 2.06645 11.24 2.18469 9.4469C2.30293 7.65377 2.99763 5.94691 4.16519 4.58086C5.33275 3.21482 6.91061 2.26279 8.66345 1.86676C10.4163 1.47073 12.2502 1.65192 13.8916 2.3833",
                                            stroke: "#4FD98F",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                            d: "M18.8333 3.33337L10.5 11.675L8 9.17504",
                                            stroke: "#4FD98F",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })),
                                (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.connectionSuccessful")
                                })
                            ]
                        }))
                    ]
                }))
            }))
        ]
    });
};
var $2e1e297565bb5552$var$anObject$1 = $2e1e297565bb5552$var$anObject$c;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $2e1e297565bb5552$var$regexpFlags = function regexpFlags() {
    var that = $2e1e297565bb5552$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $2e1e297565bb5552$var$call = $2e1e297565bb5552$var$functionCall;
var $2e1e297565bb5552$var$hasOwn = $2e1e297565bb5552$var$hasOwnProperty_1;
var $2e1e297565bb5552$var$isPrototypeOf = $2e1e297565bb5552$var$objectIsPrototypeOf;
var $2e1e297565bb5552$var$regExpFlags = $2e1e297565bb5552$var$regexpFlags;
var $2e1e297565bb5552$var$RegExpPrototype$1 = RegExp.prototype;
var $2e1e297565bb5552$var$regexpGetFlags = function regexpGetFlags(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $2e1e297565bb5552$var$RegExpPrototype$1) && !$2e1e297565bb5552$var$hasOwn(R, "flags") && $2e1e297565bb5552$var$isPrototypeOf($2e1e297565bb5552$var$RegExpPrototype$1, R) ? $2e1e297565bb5552$var$call($2e1e297565bb5552$var$regExpFlags, R) : flags;
};
var $2e1e297565bb5552$var$PROPER_FUNCTION_NAME = $2e1e297565bb5552$var$functionName.PROPER;
var $2e1e297565bb5552$var$defineBuiltIn = $2e1e297565bb5552$var$defineBuiltIn$6;
var $2e1e297565bb5552$var$anObject = $2e1e297565bb5552$var$anObject$c;
var $2e1e297565bb5552$var$$toString = $2e1e297565bb5552$var$toString$3;
var $2e1e297565bb5552$var$fails = $2e1e297565bb5552$var$fails$h;
var $2e1e297565bb5552$var$getRegExpFlags = $2e1e297565bb5552$var$regexpGetFlags;
var $2e1e297565bb5552$var$TO_STRING = "toString";
var $2e1e297565bb5552$var$RegExpPrototype = RegExp.prototype;
var $2e1e297565bb5552$var$n$ToString = $2e1e297565bb5552$var$RegExpPrototype[$2e1e297565bb5552$var$TO_STRING];
var $2e1e297565bb5552$var$NOT_GENERIC = $2e1e297565bb5552$var$fails(function() {
    return $2e1e297565bb5552$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $2e1e297565bb5552$var$INCORRECT_NAME = $2e1e297565bb5552$var$PROPER_FUNCTION_NAME && $2e1e297565bb5552$var$n$ToString.name != $2e1e297565bb5552$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($2e1e297565bb5552$var$NOT_GENERIC || $2e1e297565bb5552$var$INCORRECT_NAME) $2e1e297565bb5552$var$defineBuiltIn(RegExp.prototype, $2e1e297565bb5552$var$TO_STRING, function toString() {
    var R = $2e1e297565bb5552$var$anObject(this);
    var pattern = $2e1e297565bb5552$var$$toString(R.source);
    var flags = $2e1e297565bb5552$var$$toString($2e1e297565bb5552$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
var $2e1e297565bb5552$var$CopyIcon = function() {
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M6.5 15.25a1.75 1.75 0 0 1-1.75-1.75V6.75a2 2 0 0 1 2-2h6.75c.966 0 1.75.784 1.75 1.75",
                stroke: "#4F7CD1",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M8.75 10.75a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-6.5Z",
                stroke: "#4F7CD1",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
function $2e1e297565bb5552$var$formatQRCodeImage(data) {
    return $2e1e297565bb5552$var$__awaiter(this, void 0, void 0, function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, (/*@__PURE__*/$parcel$interopDefault($bd06a26ec61d7200$exports))).toString(data, {
                            margin: 0,
                            type: "svg"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
var $2e1e297565bb5552$var$ScanQRCode = function(param) {
    var wallet = param.wallet, uri = param.uri, onCloseModal = param.onCloseModal, handleOpenDefaultModal = param.handleOpenDefaultModal;
    var _React_useState = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(""), 2), notification = _React_useState[0], setNotification = _React_useState[1];
    var _React_useState1 = (0, $8GFUW._)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(""), 2), svg = _React_useState1[0], setSvg = _React_useState1[1];
    var copyToClipboard = function() {
        if (!uri) return;
        var success = (0, (/*@__PURE__*/$parcel$interopDefault($0f23d1886f02ec64$exports)))(uri);
        if (success) {
            setNotification((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.qr.copiedToClipboard"));
            setTimeout(function() {
                return setNotification("");
            }, 1200);
        } else {
            setNotification((0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.qr.failedToCopy"));
            setTimeout(function() {
                return setNotification("");
            }, 1200);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(function() {
        (function() {
            return $2e1e297565bb5552$var$__awaiter(void 0, void 0, void 0, function() {
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!uri) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                $2e1e297565bb5552$var$formatQRCodeImage(uri)
                            ];
                        case 1:
                            setSvg.apply(void 0, [
                                _state.sent()
                            ]);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        })();
    }, [
        uri
    ]);
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("section", Object.assign({
        className: "scan-qr-code"
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ModalHeader, {
                title: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.qr.scanWithYourMobile"),
                onCloseModal: onCloseModal
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("section", Object.assign({
                className: "qr-code"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: svg
                        }
                    }),
                    notification ? (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "notification"
                    }, {
                        children: notification
                    })) : (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "copy-btn",
                        onClick: copyToClipboard
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$CopyIcon, {}),
                            (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.qr.copyToClipboard")
                        ]
                    }))
                ]
            })),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("footer", Object.assign({
                className: "footer"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.qr.preferTheOfficial"),
                            " ",
                            wallet.metadata.name,
                            "?"
                        ]
                    }),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("button", Object.assign({
                        className: "btn",
                        onClick: handleOpenDefaultModal
                    }, {
                        children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.qr.open")
                    }))
                ]
            }))
        ]
    }));
};
var $2e1e297565bb5552$var$getThemeClass = function(theme) {
    switch(theme){
        case "dark":
            return "dark-theme";
        case "light":
            return "light-theme";
        default:
            return "";
    }
};
var $2e1e297565bb5552$var$Modal = function(param) {
    var selector = param.selector, options = param.options, visible = param.visible, hide = param.hide, emitter = param.emitter;
    var _a, _b, _c;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)({
        name: "WalletHome"
    }), 2), route = _useState[0], setRoute = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(null), 2), alertMessage = _useState1[0], setAlertMessage = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(), 2), selectedWallet = _useState2[0], setSelectedWallet = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(), 2), bridgeWalletUri = _useState3[0], setBridgeWalletUri = _useState3[1];
    (0, $6cds3.useEffect)(function() {
        setRoute({
            name: "WalletHome"
        });
        (0, $f76789f9143a442d$export$b162ef060a488de1)(selector.options.languageCode);
        var _selector_store_getState = selector.store.getState(), selectedWalletId = _selector_store_getState.selectedWalletId, modules = _selector_store_getState.modules;
        if (selectedWalletId) {
            var module = modules.find(function(m) {
                return m.id === selectedWalletId;
            });
            setSelectedWallet(module);
            setRoute({
                name: "WalletConnected",
                params: {
                    module: module
                }
            });
        }
        setBridgeWalletUri(""); // eslint-disable-next-line
    }, [
        visible
    ]);
    (0, $6cds3.useEffect)(function() {
        var subscription = selector.on("networkChanged", function(param) {
            var networkId = param.networkId;
            // Switched back to the correct network.
            if (networkId === selector.options.network.networkId) return handleDismissClick({});
            setRoute({
                name: "WalletNetworkChanged"
            });
        });
        return function() {
            return subscription.remove();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleDismissClick = (0, $6cds3.useCallback)(function(param) {
        var hideReason = param.hideReason;
        setAlertMessage(null);
        setRoute({
            name: "WalletHome"
        });
        if (hideReason === "user-triggered") emitter.emit("onHide", {
            hideReason: hideReason
        });
        if (hideReason === "wallet-navigation") emitter.emit("onHide", {
            hideReason: hideReason
        });
        hide();
    }, [
        hide,
        emitter
    ]);
    (0, $6cds3.useEffect)(function() {
        var close = function(e) {
            if (e.key === "Escape") handleDismissClick({
                hideReason: "user-triggered"
            });
        };
        window.addEventListener("keydown", close);
        return function() {
            return window.removeEventListener("keydown", close);
        };
    }, [
        handleDismissClick
    ]);
    var handleWalletClick = function(module, qrCodeModal) {
        return $2e1e297565bb5552$var$__awaiter(void 0, void 0, void 0, function() {
            var selectedWalletId, _module_metadata, deprecated, available, wallet, subscription, err, name, message;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectedWallet(module);
                        selectedWalletId = selector.store.getState().selectedWalletId;
                        if (selectedWalletId === module.id) {
                            setRoute({
                                name: "WalletConnected",
                                params: {
                                    module: module
                                }
                            });
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            ,
                            9
                        ]);
                        _module_metadata = module.metadata, deprecated = _module_metadata.deprecated, available = _module_metadata.available;
                        if (module.type === "injected" && !available) {
                            setRoute({
                                name: "WalletNotInstalled",
                                params: {
                                    module: module
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            module.wallet()
                        ];
                    case 2:
                        wallet = _state.sent();
                        if (deprecated) {
                            setAlertMessage("".concat(module.metadata.name, " is deprecated. Please select another wallet."));
                            setRoute({
                                name: "AlertMessage",
                                params: {
                                    module: module
                                }
                            });
                            return [
                                2
                            ];
                        }
                        if (wallet.type === "hardware") {
                            setRoute({
                                name: "DerivationPath",
                                params: {
                                    walletId: wallet.id || "ledger"
                                }
                            });
                            return [
                                2
                            ];
                        }
                        setRoute({
                            name: "WalletConnecting",
                            params: {
                                wallet: wallet
                            }
                        });
                        if (!(wallet.type === "bridge")) return [
                            3,
                            4
                        ];
                        subscription = selector.on("uriChanged", function(param) {
                            var uri = param.uri;
                            setBridgeWalletUri(uri);
                            setRoute({
                                name: "ScanQRCode",
                                params: {
                                    uri: uri,
                                    wallet: wallet
                                }
                            });
                        });
                        return [
                            4,
                            wallet.signIn({
                                contractId: options.contractId,
                                methodNames: options.methodNames,
                                qrCodeModal: qrCodeModal
                            })
                        ];
                    case 3:
                        _state.sent();
                        subscription.remove();
                        handleDismissClick({
                            hideReason: "wallet-navigation"
                        });
                        return [
                            2
                        ];
                    case 4:
                        if (!(wallet.type === "browser")) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            wallet.signIn({
                                contractId: options.contractId,
                                methodNames: options.methodNames,
                                successUrl: wallet.metadata.successUrl,
                                failureUrl: wallet.metadata.failureUrl
                            })
                        ];
                    case 5:
                        _state.sent();
                        handleDismissClick({
                            hideReason: "wallet-navigation"
                        });
                        return [
                            2
                        ];
                    case 6:
                        return [
                            4,
                            wallet.signIn({
                                contractId: options.contractId,
                                methodNames: options.methodNames
                            })
                        ];
                    case 7:
                        _state.sent();
                        handleDismissClick({
                            hideReason: "wallet-navigation"
                        });
                        return [
                            3,
                            9
                        ];
                    case 8:
                        err = _state.sent();
                        name = module.metadata.name;
                        message = err instanceof Error ? err.message : "Something went wrong";
                        setAlertMessage("Failed to sign in with ".concat(name, ": ").concat(message));
                        setRoute({
                            name: "AlertMessage",
                            params: {
                                module: module
                            }
                        });
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
    };
    if (!visible) return null;
    return (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
        className: "nws-modal-wrapper ".concat($2e1e297565bb5552$var$getThemeClass(options === null || options === void 0 ? void 0 : options.theme), " ").concat(visible ? "open" : "")
    }, {
        children: [
            (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "nws-modal-overlay",
                onClick: function() {
                    handleDismissClick({
                        hideReason: "user-triggered"
                    });
                }
            }),
            (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                className: "nws-modal"
            }, {
                children: [
                    (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                        className: "modal-left"
                    }, {
                        children: [
                            (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                                className: "modal-left-title"
                            }, {
                                children: (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                    children: (0, $f76789f9143a442d$export$d73ee8ef04f5226a)("modal.wallet.connectYourWallet")
                                })
                            })),
                            (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletOptions, {
                                handleWalletClick: function(module) {
                                    handleWalletClick(module, false);
                                },
                                selector: selector
                            })
                        ]
                    })),
                    (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({
                        className: "modal-right"
                    }, {
                        children: (0, $fba0f23e9e6a11bb$exports.jsxs)("div", Object.assign({
                            className: "nws-modal-body"
                        }, {
                            children: [
                                route.name === "AlertMessage" && alertMessage && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$AlertMessage, {
                                    message: alertMessage,
                                    module: (_a = route.params) === null || _a === void 0 ? void 0 : _a.module,
                                    onBack: function(retry) {
                                        if (retry) handleWalletClick(selectedWallet, false);
                                        setAlertMessage(null);
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "DerivationPath" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$DerivationPath, {
                                    selector: selector,
                                    options: options,
                                    onConnected: function() {
                                        handleDismissClick({
                                            hideReason: "wallet-navigation"
                                        });
                                    },
                                    params: route.params,
                                    onBack: function() {
                                        return setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onError: function(message, wallet) {
                                        var modules = selector.store.getState().modules;
                                        var findModule = modules.find(function(module) {
                                            return module.id === wallet.id;
                                        });
                                        setAlertMessage(message);
                                        setRoute({
                                            name: "AlertMessage",
                                            params: {
                                                module: findModule
                                            }
                                        });
                                    },
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "WalletNetworkChanged" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletNetworkChanged, {
                                    selector: selector,
                                    onBack: function() {
                                        return setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "WalletNotInstalled" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletNotInstalled, {
                                    module: (_b = route.params) === null || _b === void 0 ? void 0 : _b.module,
                                    onBack: function() {
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "WalletConnecting" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletConnecting, {
                                    wallet: (_c = route.params) === null || _c === void 0 ? void 0 : _c.wallet,
                                    onBack: function() {
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "WalletHome" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletHome, {
                                    selector: selector,
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "WalletConnected" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$WalletConnected, {
                                    module: selectedWallet,
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    }
                                }),
                                route.name === "ScanQRCode" && (0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$ScanQRCode, {
                                    handleOpenDefaultModal: function() {
                                        handleWalletClick(selectedWallet, true);
                                    },
                                    onCloseModal: function() {
                                        return handleDismissClick({
                                            hideReason: "user-triggered"
                                        });
                                    },
                                    uri: bridgeWalletUri,
                                    wallet: selectedWallet
                                })
                            ]
                        }))
                    }))
                ]
            }))
        ]
    }));
};
var $2e1e297565bb5552$var$MODAL_ELEMENT_ID = "near-wallet-selector-modal";
var $2e1e297565bb5552$var$modalInstance = null;
var $2e1e297565bb5552$export$60f0f9f4cfa9469a = function(selector, options) {
    var el = document.createElement("div");
    el.id = $2e1e297565bb5552$var$MODAL_ELEMENT_ID;
    if (!document.getElementById($2e1e297565bb5552$var$MODAL_ELEMENT_ID)) document.body.appendChild(el);
    var container = document.getElementById($2e1e297565bb5552$var$MODAL_ELEMENT_ID);
    var root = (0, $64d0b1ebdd6bcffe$export$882461b6382ed46c)(container);
    var emitter = new (0, $f76789f9143a442d$export$4fae95256245c8c0)();
    var render = function() {
        var visible = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        root.render((0, $fba0f23e9e6a11bb$exports.jsx)($2e1e297565bb5552$var$Modal, {
            selector: selector,
            options: options,
            visible: visible,
            hide: function() {
                return render(false);
            },
            emitter: emitter
        }));
    };
    if (!$2e1e297565bb5552$var$modalInstance) $2e1e297565bb5552$var$modalInstance = {
        show: function() {
            render(true);
        },
        hide: function() {
            render(false);
        },
        on: function(eventName, callback) {
            return emitter.on(eventName, callback);
        },
        off: function(eventName, callback) {
            emitter.off(eventName, callback);
        }
    };
    return $2e1e297565bb5552$var$modalInstance;
};




var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");


var $8GFUW = parcelRequire("8GFUW");

var $1ObTH = parcelRequire("1ObTH");

var $7UAGh = parcelRequire("7UAGh");

var $jlWHo = parcelRequire("jlWHo");

var $74570f29af5dbce2$var$transactions = $c1be85fca55b560a$exports.transactions, $74570f29af5dbce2$var$utils = $c1be85fca55b560a$exports.utils;
var $74570f29af5dbce2$var$getAccessKey = function(permission) {
    if (permission === "FullAccess") return $74570f29af5dbce2$var$transactions.fullAccessKey();
    var receiverId = permission.receiverId, _permission_methodNames = permission.methodNames, methodNames = _permission_methodNames === void 0 ? [] : _permission_methodNames;
    var allowance = permission.allowance ? new (0, $jlWHo.BN)(permission.allowance) : undefined;
    return $74570f29af5dbce2$var$transactions.functionCallAccessKey(receiverId, methodNames, allowance);
};
var $74570f29af5dbce2$export$309c7a02b0b0bc62 = function(action) {
    switch(action.type){
        case "CreateAccount":
            return $74570f29af5dbce2$var$transactions.createAccount();
        case "DeployContract":
            {
                var code = action.params.code;
                return $74570f29af5dbce2$var$transactions.deployContract(code);
            }
        case "FunctionCall":
            {
                var _action_params = action.params, methodName = _action_params.methodName, args = _action_params.args, gas = _action_params.gas, deposit = _action_params.deposit;
                return $74570f29af5dbce2$var$transactions.functionCall(methodName, args, new (0, $jlWHo.BN)(gas), new (0, $jlWHo.BN)(deposit));
            }
        case "Transfer":
            {
                var deposit1 = action.params.deposit;
                return $74570f29af5dbce2$var$transactions.transfer(new (0, $jlWHo.BN)(deposit1));
            }
        case "Stake":
            {
                var _action_params1 = action.params, stake = _action_params1.stake, publicKey = _action_params1.publicKey;
                return $74570f29af5dbce2$var$transactions.stake(new (0, $jlWHo.BN)(stake), $74570f29af5dbce2$var$utils.PublicKey.from(publicKey));
            }
        case "AddKey":
            {
                var _action_params2 = action.params, publicKey1 = _action_params2.publicKey, accessKey = _action_params2.accessKey;
                return $74570f29af5dbce2$var$transactions.addKey($74570f29af5dbce2$var$utils.PublicKey.from(publicKey1), $74570f29af5dbce2$var$getAccessKey(accessKey.permission));
            }
        case "DeleteKey":
            {
                var publicKey2 = action.params.publicKey;
                return $74570f29af5dbce2$var$transactions.deleteKey($74570f29af5dbce2$var$utils.PublicKey.from(publicKey2));
            }
        case "DeleteAccount":
            {
                var beneficiaryId = action.params.beneficiaryId;
                return $74570f29af5dbce2$var$transactions.deleteAccount(beneficiaryId);
            }
        default:
            throw new Error("Invalid action type");
    }
};
var $74570f29af5dbce2$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $74570f29af5dbce2$var$fails$d = function fails$d(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $74570f29af5dbce2$var$fails$c = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$functionBindNative = !$74570f29af5dbce2$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $74570f29af5dbce2$var$NATIVE_BIND$3 = $74570f29af5dbce2$var$functionBindNative;
var $74570f29af5dbce2$var$FunctionPrototype$2 = Function.prototype;
var $74570f29af5dbce2$var$bind$5 = $74570f29af5dbce2$var$FunctionPrototype$2.bind;
var $74570f29af5dbce2$var$call$e = $74570f29af5dbce2$var$FunctionPrototype$2.call;
var $74570f29af5dbce2$var$uncurryThis$d = $74570f29af5dbce2$var$NATIVE_BIND$3 && $74570f29af5dbce2$var$bind$5.bind($74570f29af5dbce2$var$call$e, $74570f29af5dbce2$var$call$e);
var $74570f29af5dbce2$var$functionUncurryThis = $74570f29af5dbce2$var$NATIVE_BIND$3 ? function functionUncurryThis(fn) {
    return fn && $74570f29af5dbce2$var$uncurryThis$d(fn);
} : function(fn) {
    return fn && function() {
        return $74570f29af5dbce2$var$call$e.apply(fn, arguments);
    };
};
var $74570f29af5dbce2$var$uncurryThis$c = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$toString$2 = $74570f29af5dbce2$var$uncurryThis$c({}.toString);
var $74570f29af5dbce2$var$stringSlice = $74570f29af5dbce2$var$uncurryThis$c("".slice);
var $74570f29af5dbce2$var$classofRaw$1 = function classofRaw$1(it) {
    return $74570f29af5dbce2$var$stringSlice($74570f29af5dbce2$var$toString$2(it), 8, -1);
};
var $74570f29af5dbce2$var$uncurryThis$b = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$fails$b = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$classof$5 = $74570f29af5dbce2$var$classofRaw$1;
var $74570f29af5dbce2$var$$Object$4 = Object;
var $74570f29af5dbce2$var$split = $74570f29af5dbce2$var$uncurryThis$b("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $74570f29af5dbce2$var$indexedObject = $74570f29af5dbce2$var$fails$b(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$74570f29af5dbce2$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function indexedObject(it) {
    return $74570f29af5dbce2$var$classof$5(it) == "String" ? $74570f29af5dbce2$var$split(it, "") : $74570f29af5dbce2$var$$Object$4(it);
} : $74570f29af5dbce2$var$$Object$4;
var $74570f29af5dbce2$var$$TypeError$b = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $74570f29af5dbce2$var$requireObjectCoercible$2 = function requireObjectCoercible$2(it) {
    if (it == undefined) throw $74570f29af5dbce2$var$$TypeError$b("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $74570f29af5dbce2$var$IndexedObject = $74570f29af5dbce2$var$indexedObject;
var $74570f29af5dbce2$var$requireObjectCoercible$1 = $74570f29af5dbce2$var$requireObjectCoercible$2;
var $74570f29af5dbce2$var$toIndexedObject$5 = function toIndexedObject$5(it) {
    return $74570f29af5dbce2$var$IndexedObject($74570f29af5dbce2$var$requireObjectCoercible$1(it));
};
var $74570f29af5dbce2$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $74570f29af5dbce2$var$global$j = // eslint-disable-next-line es-x/no-global-this -- safe
$74570f29af5dbce2$var$check(typeof globalThis == "object" && globalThis) || $74570f29af5dbce2$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$74570f29af5dbce2$var$check(typeof self == "object" && self) || $74570f29af5dbce2$var$check(typeof $74570f29af5dbce2$var$commonjsGlobal == "object" && $74570f29af5dbce2$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $74570f29af5dbce2$var$shared$3 = {
    exports: {}
};
var $74570f29af5dbce2$var$global$i = $74570f29af5dbce2$var$global$j;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $74570f29af5dbce2$var$defineProperty$4 = Object.defineProperty;
var $74570f29af5dbce2$var$defineGlobalProperty$3 = function defineGlobalProperty$3(key, value) {
    try {
        $74570f29af5dbce2$var$defineProperty$4($74570f29af5dbce2$var$global$i, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $74570f29af5dbce2$var$global$i[key] = value;
    }
    return value;
};
var $74570f29af5dbce2$var$global$h = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$defineGlobalProperty$2 = $74570f29af5dbce2$var$defineGlobalProperty$3;
var $74570f29af5dbce2$var$SHARED = "__core-js_shared__";
var $74570f29af5dbce2$var$store$3 = $74570f29af5dbce2$var$global$h[$74570f29af5dbce2$var$SHARED] || $74570f29af5dbce2$var$defineGlobalProperty$2($74570f29af5dbce2$var$SHARED, {});
var $74570f29af5dbce2$var$sharedStore = $74570f29af5dbce2$var$store$3;
var $74570f29af5dbce2$var$store$2 = $74570f29af5dbce2$var$sharedStore;
($74570f29af5dbce2$var$shared$3.exports = function(key, value) {
    return $74570f29af5dbce2$var$store$2[key] || ($74570f29af5dbce2$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $74570f29af5dbce2$var$requireObjectCoercible = $74570f29af5dbce2$var$requireObjectCoercible$2;
var $74570f29af5dbce2$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $74570f29af5dbce2$var$toObject$2 = function toObject$2(argument) {
    return $74570f29af5dbce2$var$$Object$3($74570f29af5dbce2$var$requireObjectCoercible(argument));
};
var $74570f29af5dbce2$var$uncurryThis$a = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$toObject$1 = $74570f29af5dbce2$var$toObject$2;
var $74570f29af5dbce2$var$hasOwnProperty = $74570f29af5dbce2$var$uncurryThis$a({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $74570f29af5dbce2$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $74570f29af5dbce2$var$hasOwnProperty($74570f29af5dbce2$var$toObject$1(it), key);
};
var $74570f29af5dbce2$var$uncurryThis$9 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$id = 0;
var $74570f29af5dbce2$var$postfix = Math.random();
var $74570f29af5dbce2$var$toString$1 = $74570f29af5dbce2$var$uncurryThis$9(1.0.toString);
var $74570f29af5dbce2$var$uid$2 = function uid$2(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $74570f29af5dbce2$var$toString$1(++$74570f29af5dbce2$var$id + $74570f29af5dbce2$var$postfix, 36);
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $74570f29af5dbce2$var$isCallable$k = function isCallable$k(argument) {
    return typeof argument == "function";
};
var $74570f29af5dbce2$var$global$g = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$isCallable$j = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$aFunction = function aFunction(argument) {
    return $74570f29af5dbce2$var$isCallable$j(argument) ? argument : undefined;
};
var $74570f29af5dbce2$var$getBuiltIn$8 = function getBuiltIn$8(namespace, method) {
    return arguments.length < 2 ? $74570f29af5dbce2$var$aFunction($74570f29af5dbce2$var$global$g[namespace]) : $74570f29af5dbce2$var$global$g[namespace] && $74570f29af5dbce2$var$global$g[namespace][method];
};
var $74570f29af5dbce2$var$getBuiltIn$7 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$engineUserAgent = $74570f29af5dbce2$var$getBuiltIn$7("navigator", "userAgent") || "";
var $74570f29af5dbce2$var$global$f = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$userAgent$3 = $74570f29af5dbce2$var$engineUserAgent;
var $74570f29af5dbce2$var$process$3 = $74570f29af5dbce2$var$global$f.process;
var $74570f29af5dbce2$var$Deno$1 = $74570f29af5dbce2$var$global$f.Deno;
var $74570f29af5dbce2$var$versions = $74570f29af5dbce2$var$process$3 && $74570f29af5dbce2$var$process$3.versions || $74570f29af5dbce2$var$Deno$1 && $74570f29af5dbce2$var$Deno$1.version;
var $74570f29af5dbce2$var$v8 = $74570f29af5dbce2$var$versions && $74570f29af5dbce2$var$versions.v8;
var $74570f29af5dbce2$var$match, $74570f29af5dbce2$var$version;
if ($74570f29af5dbce2$var$v8) {
    $74570f29af5dbce2$var$match = $74570f29af5dbce2$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $74570f29af5dbce2$var$version = $74570f29af5dbce2$var$match[0] > 0 && $74570f29af5dbce2$var$match[0] < 4 ? 1 : +($74570f29af5dbce2$var$match[0] + $74570f29af5dbce2$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$74570f29af5dbce2$var$version && $74570f29af5dbce2$var$userAgent$3) {
    $74570f29af5dbce2$var$match = $74570f29af5dbce2$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$74570f29af5dbce2$var$match || $74570f29af5dbce2$var$match[1] >= 74) {
        $74570f29af5dbce2$var$match = $74570f29af5dbce2$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($74570f29af5dbce2$var$match) $74570f29af5dbce2$var$version = +$74570f29af5dbce2$var$match[1];
    }
}
var $74570f29af5dbce2$var$engineV8Version = $74570f29af5dbce2$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $74570f29af5dbce2$var$V8_VERSION$1 = $74570f29af5dbce2$var$engineV8Version;
var $74570f29af5dbce2$var$fails$a = $74570f29af5dbce2$var$fails$d;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $74570f29af5dbce2$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$74570f29af5dbce2$var$fails$a(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $74570f29af5dbce2$var$V8_VERSION$1 && $74570f29af5dbce2$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $74570f29af5dbce2$var$NATIVE_SYMBOL$1 = $74570f29af5dbce2$var$nativeSymbol;
var $74570f29af5dbce2$var$useSymbolAsUid = $74570f29af5dbce2$var$NATIVE_SYMBOL$1 && !Symbol.sham && (0, $1ObTH._)(Symbol.iterator) == "symbol";
var $74570f29af5dbce2$var$global$e = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$shared$2 = $74570f29af5dbce2$var$shared$3.exports;
var $74570f29af5dbce2$var$hasOwn$a = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$uid$1 = $74570f29af5dbce2$var$uid$2;
var $74570f29af5dbce2$var$NATIVE_SYMBOL = $74570f29af5dbce2$var$nativeSymbol;
var $74570f29af5dbce2$var$USE_SYMBOL_AS_UID$1 = $74570f29af5dbce2$var$useSymbolAsUid;
var $74570f29af5dbce2$var$WellKnownSymbolsStore = $74570f29af5dbce2$var$shared$2("wks");
var $74570f29af5dbce2$var$Symbol$1 = $74570f29af5dbce2$var$global$e.Symbol;
var $74570f29af5dbce2$var$symbolFor = $74570f29af5dbce2$var$Symbol$1 && $74570f29af5dbce2$var$Symbol$1["for"];
var $74570f29af5dbce2$var$createWellKnownSymbol = $74570f29af5dbce2$var$USE_SYMBOL_AS_UID$1 ? $74570f29af5dbce2$var$Symbol$1 : $74570f29af5dbce2$var$Symbol$1 && $74570f29af5dbce2$var$Symbol$1.withoutSetter || $74570f29af5dbce2$var$uid$1;
var $74570f29af5dbce2$var$wellKnownSymbol$e = function wellKnownSymbol$e(name) {
    if (!$74570f29af5dbce2$var$hasOwn$a($74570f29af5dbce2$var$WellKnownSymbolsStore, name) || !($74570f29af5dbce2$var$NATIVE_SYMBOL || typeof $74570f29af5dbce2$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($74570f29af5dbce2$var$NATIVE_SYMBOL && $74570f29af5dbce2$var$hasOwn$a($74570f29af5dbce2$var$Symbol$1, name)) $74570f29af5dbce2$var$WellKnownSymbolsStore[name] = $74570f29af5dbce2$var$Symbol$1[name];
        else if ($74570f29af5dbce2$var$USE_SYMBOL_AS_UID$1 && $74570f29af5dbce2$var$symbolFor) $74570f29af5dbce2$var$WellKnownSymbolsStore[name] = $74570f29af5dbce2$var$symbolFor(description);
        else $74570f29af5dbce2$var$WellKnownSymbolsStore[name] = $74570f29af5dbce2$var$createWellKnownSymbol(description);
    }
    return $74570f29af5dbce2$var$WellKnownSymbolsStore[name];
};
var $74570f29af5dbce2$var$isCallable$i = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$isObject$7 = function isObject$7(it) {
    return typeof it == "object" ? it !== null : $74570f29af5dbce2$var$isCallable$i(it);
};
var $74570f29af5dbce2$var$isObject$6 = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$$String$3 = String;
var $74570f29af5dbce2$var$$TypeError$a = TypeError;
// `Assert: Type(argument) is Object`
var $74570f29af5dbce2$var$anObject$c = function anObject$c(argument) {
    if ($74570f29af5dbce2$var$isObject$6(argument)) return argument;
    throw $74570f29af5dbce2$var$$TypeError$a($74570f29af5dbce2$var$$String$3(argument) + " is not an object");
};
var $74570f29af5dbce2$var$objectDefineProperties = {};
var $74570f29af5dbce2$var$fails$9 = $74570f29af5dbce2$var$fails$d;
// Detect IE8's incomplete defineProperty implementation
var $74570f29af5dbce2$var$descriptors = !$74570f29af5dbce2$var$fails$9(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});
var $74570f29af5dbce2$var$DESCRIPTORS$9 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$fails$8 = $74570f29af5dbce2$var$fails$d;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $74570f29af5dbce2$var$v8PrototypeDefineBug = $74570f29af5dbce2$var$DESCRIPTORS$9 && $74570f29af5dbce2$var$fails$8(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $74570f29af5dbce2$var$objectDefineProperty = {};
var $74570f29af5dbce2$var$global$d = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$isObject$5 = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$document$3 = $74570f29af5dbce2$var$global$d.document;
// typeof document.createElement is 'object' in old IE
var $74570f29af5dbce2$var$EXISTS$1 = $74570f29af5dbce2$var$isObject$5($74570f29af5dbce2$var$document$3) && $74570f29af5dbce2$var$isObject$5($74570f29af5dbce2$var$document$3.createElement);
var $74570f29af5dbce2$var$documentCreateElement$2 = function documentCreateElement$2(it) {
    return $74570f29af5dbce2$var$EXISTS$1 ? $74570f29af5dbce2$var$document$3.createElement(it) : {};
};
var $74570f29af5dbce2$var$DESCRIPTORS$8 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$fails$7 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$createElement$1 = $74570f29af5dbce2$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $74570f29af5dbce2$var$ie8DomDefine = !$74570f29af5dbce2$var$DESCRIPTORS$8 && !$74570f29af5dbce2$var$fails$7(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($74570f29af5dbce2$var$createElement$1("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});
var $74570f29af5dbce2$var$NATIVE_BIND$2 = $74570f29af5dbce2$var$functionBindNative;
var $74570f29af5dbce2$var$call$d = Function.prototype.call;
var $74570f29af5dbce2$var$functionCall = $74570f29af5dbce2$var$NATIVE_BIND$2 ? $74570f29af5dbce2$var$call$d.bind($74570f29af5dbce2$var$call$d) : function functionCall() {
    return $74570f29af5dbce2$var$call$d.apply($74570f29af5dbce2$var$call$d, arguments);
};
var $74570f29af5dbce2$var$uncurryThis$8 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$objectIsPrototypeOf = $74570f29af5dbce2$var$uncurryThis$8({}.isPrototypeOf);
var $74570f29af5dbce2$var$getBuiltIn$6 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$isCallable$h = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$isPrototypeOf$3 = $74570f29af5dbce2$var$objectIsPrototypeOf;
var $74570f29af5dbce2$var$USE_SYMBOL_AS_UID = $74570f29af5dbce2$var$useSymbolAsUid;
var $74570f29af5dbce2$var$$Object$2 = Object;
var $74570f29af5dbce2$var$isSymbol$2 = $74570f29af5dbce2$var$USE_SYMBOL_AS_UID ? function isSymbol$2(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $1ObTH._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $74570f29af5dbce2$var$getBuiltIn$6("Symbol");
    return $74570f29af5dbce2$var$isCallable$h($Symbol) && $74570f29af5dbce2$var$isPrototypeOf$3($Symbol.prototype, $74570f29af5dbce2$var$$Object$2(it));
};
var $74570f29af5dbce2$var$$String$2 = String;
var $74570f29af5dbce2$var$tryToString$4 = function tryToString$4(argument) {
    try {
        return $74570f29af5dbce2$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $74570f29af5dbce2$var$isCallable$g = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$tryToString$3 = $74570f29af5dbce2$var$tryToString$4;
var $74570f29af5dbce2$var$$TypeError$9 = TypeError;
// `Assert: IsCallable(argument) is true`
var $74570f29af5dbce2$var$aCallable$7 = function aCallable$7(argument) {
    if ($74570f29af5dbce2$var$isCallable$g(argument)) return argument;
    throw $74570f29af5dbce2$var$$TypeError$9($74570f29af5dbce2$var$tryToString$3(argument) + " is not a function");
};
var $74570f29af5dbce2$var$aCallable$6 = $74570f29af5dbce2$var$aCallable$7;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $74570f29af5dbce2$var$getMethod$3 = function getMethod$3(V, P) {
    var func = V[P];
    return func == null ? undefined : $74570f29af5dbce2$var$aCallable$6(func);
};
var $74570f29af5dbce2$var$call$c = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$isCallable$f = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$isObject$4 = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$$TypeError$8 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $74570f29af5dbce2$var$ordinaryToPrimitive$1 = function ordinaryToPrimitive$1(input, pref) {
    var fn, val;
    if (pref === "string" && $74570f29af5dbce2$var$isCallable$f(fn = input.toString) && !$74570f29af5dbce2$var$isObject$4(val = $74570f29af5dbce2$var$call$c(fn, input))) return val;
    if ($74570f29af5dbce2$var$isCallable$f(fn = input.valueOf) && !$74570f29af5dbce2$var$isObject$4(val = $74570f29af5dbce2$var$call$c(fn, input))) return val;
    if (pref !== "string" && $74570f29af5dbce2$var$isCallable$f(fn = input.toString) && !$74570f29af5dbce2$var$isObject$4(val = $74570f29af5dbce2$var$call$c(fn, input))) return val;
    throw $74570f29af5dbce2$var$$TypeError$8("Can't convert object to primitive value");
};
var $74570f29af5dbce2$var$call$b = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$isObject$3 = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$isSymbol$1 = $74570f29af5dbce2$var$isSymbol$2;
var $74570f29af5dbce2$var$getMethod$2 = $74570f29af5dbce2$var$getMethod$3;
var $74570f29af5dbce2$var$ordinaryToPrimitive = $74570f29af5dbce2$var$ordinaryToPrimitive$1;
var $74570f29af5dbce2$var$wellKnownSymbol$d = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$$TypeError$7 = TypeError;
var $74570f29af5dbce2$var$TO_PRIMITIVE = $74570f29af5dbce2$var$wellKnownSymbol$d("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $74570f29af5dbce2$var$toPrimitive$1 = function toPrimitive$1(input, pref) {
    if (!$74570f29af5dbce2$var$isObject$3(input) || $74570f29af5dbce2$var$isSymbol$1(input)) return input;
    var exoticToPrim = $74570f29af5dbce2$var$getMethod$2(input, $74570f29af5dbce2$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $74570f29af5dbce2$var$call$b(exoticToPrim, input, pref);
        if (!$74570f29af5dbce2$var$isObject$3(result) || $74570f29af5dbce2$var$isSymbol$1(result)) return result;
        throw $74570f29af5dbce2$var$$TypeError$7("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $74570f29af5dbce2$var$ordinaryToPrimitive(input, pref);
};
var $74570f29af5dbce2$var$toPrimitive = $74570f29af5dbce2$var$toPrimitive$1;
var $74570f29af5dbce2$var$isSymbol = $74570f29af5dbce2$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $74570f29af5dbce2$var$toPropertyKey$2 = function toPropertyKey$2(argument) {
    var key = $74570f29af5dbce2$var$toPrimitive(argument, "string");
    return $74570f29af5dbce2$var$isSymbol(key) ? key : key + "";
};
var $74570f29af5dbce2$var$DESCRIPTORS$7 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$IE8_DOM_DEFINE$1 = $74570f29af5dbce2$var$ie8DomDefine;
var $74570f29af5dbce2$var$V8_PROTOTYPE_DEFINE_BUG$1 = $74570f29af5dbce2$var$v8PrototypeDefineBug;
var $74570f29af5dbce2$var$anObject$b = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$toPropertyKey$1 = $74570f29af5dbce2$var$toPropertyKey$2;
var $74570f29af5dbce2$var$$TypeError$6 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $74570f29af5dbce2$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $74570f29af5dbce2$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $74570f29af5dbce2$var$ENUMERABLE = "enumerable";
var $74570f29af5dbce2$var$CONFIGURABLE$1 = "configurable";
var $74570f29af5dbce2$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$74570f29af5dbce2$var$objectDefineProperty.f = $74570f29af5dbce2$var$DESCRIPTORS$7 ? $74570f29af5dbce2$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $74570f29af5dbce2$var$anObject$b(O);
    P = $74570f29af5dbce2$var$toPropertyKey$1(P);
    $74570f29af5dbce2$var$anObject$b(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $74570f29af5dbce2$var$WRITABLE in Attributes && !Attributes[$74570f29af5dbce2$var$WRITABLE]) {
        var current = $74570f29af5dbce2$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$74570f29af5dbce2$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $74570f29af5dbce2$var$CONFIGURABLE$1 in Attributes ? Attributes[$74570f29af5dbce2$var$CONFIGURABLE$1] : current[$74570f29af5dbce2$var$CONFIGURABLE$1],
                enumerable: $74570f29af5dbce2$var$ENUMERABLE in Attributes ? Attributes[$74570f29af5dbce2$var$ENUMERABLE] : current[$74570f29af5dbce2$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $74570f29af5dbce2$var$$defineProperty(O, P, Attributes);
} : $74570f29af5dbce2$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $74570f29af5dbce2$var$anObject$b(O);
    P = $74570f29af5dbce2$var$toPropertyKey$1(P);
    $74570f29af5dbce2$var$anObject$b(Attributes);
    if ($74570f29af5dbce2$var$IE8_DOM_DEFINE$1) try {
        return $74570f29af5dbce2$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $74570f29af5dbce2$var$$TypeError$6("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $74570f29af5dbce2$var$ceil = Math.ceil;
var $74570f29af5dbce2$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $74570f29af5dbce2$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $74570f29af5dbce2$var$floor : $74570f29af5dbce2$var$ceil)(n);
};
var $74570f29af5dbce2$var$trunc = $74570f29af5dbce2$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $74570f29af5dbce2$var$toIntegerOrInfinity$2 = function toIntegerOrInfinity$2(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $74570f29af5dbce2$var$trunc(number);
};
var $74570f29af5dbce2$var$toIntegerOrInfinity$1 = $74570f29af5dbce2$var$toIntegerOrInfinity$2;
var $74570f29af5dbce2$var$max = Math.max;
var $74570f29af5dbce2$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $74570f29af5dbce2$var$toAbsoluteIndex$1 = function toAbsoluteIndex$1(index, length) {
    var integer = $74570f29af5dbce2$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $74570f29af5dbce2$var$max(integer + length, 0) : $74570f29af5dbce2$var$min$1(integer, length);
};
var $74570f29af5dbce2$var$toIntegerOrInfinity = $74570f29af5dbce2$var$toIntegerOrInfinity$2;
var $74570f29af5dbce2$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $74570f29af5dbce2$var$toLength$1 = function toLength$1(argument) {
    return argument > 0 ? $74570f29af5dbce2$var$min($74570f29af5dbce2$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $74570f29af5dbce2$var$toLength = $74570f29af5dbce2$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $74570f29af5dbce2$var$lengthOfArrayLike$2 = function lengthOfArrayLike$2(obj) {
    return $74570f29af5dbce2$var$toLength(obj.length);
};
var $74570f29af5dbce2$var$toIndexedObject$4 = $74570f29af5dbce2$var$toIndexedObject$5;
var $74570f29af5dbce2$var$toAbsoluteIndex = $74570f29af5dbce2$var$toAbsoluteIndex$1;
var $74570f29af5dbce2$var$lengthOfArrayLike$1 = $74570f29af5dbce2$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $74570f29af5dbce2$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $74570f29af5dbce2$var$toIndexedObject$4($this);
        var length = $74570f29af5dbce2$var$lengthOfArrayLike$1(O);
        var index = $74570f29af5dbce2$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $74570f29af5dbce2$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $74570f29af5dbce2$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $74570f29af5dbce2$var$createMethod(false)
};
var $74570f29af5dbce2$var$hiddenKeys$4 = {};
var $74570f29af5dbce2$var$uncurryThis$7 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$hasOwn$9 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$toIndexedObject$3 = $74570f29af5dbce2$var$toIndexedObject$5;
var $74570f29af5dbce2$var$indexOf = $74570f29af5dbce2$var$arrayIncludes.indexOf;
var $74570f29af5dbce2$var$hiddenKeys$3 = $74570f29af5dbce2$var$hiddenKeys$4;
var $74570f29af5dbce2$var$push = $74570f29af5dbce2$var$uncurryThis$7([].push);
var $74570f29af5dbce2$var$objectKeysInternal = function objectKeysInternal(object, names) {
    var O = $74570f29af5dbce2$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$74570f29af5dbce2$var$hasOwn$9($74570f29af5dbce2$var$hiddenKeys$3, key) && $74570f29af5dbce2$var$hasOwn$9(O, key) && $74570f29af5dbce2$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($74570f29af5dbce2$var$hasOwn$9(O, key = names[i++])) ~$74570f29af5dbce2$var$indexOf(result, key) || $74570f29af5dbce2$var$push(result, key);
    return result;
};
// IE8- don't enum bug keys
var $74570f29af5dbce2$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $74570f29af5dbce2$var$internalObjectKeys$1 = $74570f29af5dbce2$var$objectKeysInternal;
var $74570f29af5dbce2$var$enumBugKeys$2 = $74570f29af5dbce2$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $74570f29af5dbce2$var$objectKeys$1 = Object.keys || function keys(O) {
    return $74570f29af5dbce2$var$internalObjectKeys$1(O, $74570f29af5dbce2$var$enumBugKeys$2);
};
var $74570f29af5dbce2$var$DESCRIPTORS$6 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$V8_PROTOTYPE_DEFINE_BUG = $74570f29af5dbce2$var$v8PrototypeDefineBug;
var $74570f29af5dbce2$var$definePropertyModule$4 = $74570f29af5dbce2$var$objectDefineProperty;
var $74570f29af5dbce2$var$anObject$a = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$toIndexedObject$2 = $74570f29af5dbce2$var$toIndexedObject$5;
var $74570f29af5dbce2$var$objectKeys = $74570f29af5dbce2$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$74570f29af5dbce2$var$objectDefineProperties.f = $74570f29af5dbce2$var$DESCRIPTORS$6 && !$74570f29af5dbce2$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $74570f29af5dbce2$var$anObject$a(O);
    var props = $74570f29af5dbce2$var$toIndexedObject$2(Properties);
    var keys = $74570f29af5dbce2$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$74570f29af5dbce2$var$definePropertyModule$4.f(O, key = keys[index++], props[key]);
    return O;
};
var $74570f29af5dbce2$var$getBuiltIn$5 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$html$2 = $74570f29af5dbce2$var$getBuiltIn$5("document", "documentElement");
var $74570f29af5dbce2$var$shared$1 = $74570f29af5dbce2$var$shared$3.exports;
var $74570f29af5dbce2$var$uid = $74570f29af5dbce2$var$uid$2;
var $74570f29af5dbce2$var$keys = $74570f29af5dbce2$var$shared$1("keys");
var $74570f29af5dbce2$var$sharedKey$3 = function sharedKey$3(key) {
    return $74570f29af5dbce2$var$keys[key] || ($74570f29af5dbce2$var$keys[key] = $74570f29af5dbce2$var$uid(key));
};
/* global ActiveXObject -- old IE, WSH */ var $74570f29af5dbce2$var$anObject$9 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$definePropertiesModule = $74570f29af5dbce2$var$objectDefineProperties;
var $74570f29af5dbce2$var$enumBugKeys$1 = $74570f29af5dbce2$var$enumBugKeys$3;
var $74570f29af5dbce2$var$hiddenKeys$2 = $74570f29af5dbce2$var$hiddenKeys$4;
var $74570f29af5dbce2$var$html$1 = $74570f29af5dbce2$var$html$2;
var $74570f29af5dbce2$var$documentCreateElement$1 = $74570f29af5dbce2$var$documentCreateElement$2;
var $74570f29af5dbce2$var$sharedKey$2 = $74570f29af5dbce2$var$sharedKey$3;
var $74570f29af5dbce2$var$GT = ">";
var $74570f29af5dbce2$var$LT = "<";
var $74570f29af5dbce2$var$PROTOTYPE = "prototype";
var $74570f29af5dbce2$var$SCRIPT = "script";
var $74570f29af5dbce2$var$IE_PROTO$1 = $74570f29af5dbce2$var$sharedKey$2("IE_PROTO");
var $74570f29af5dbce2$var$EmptyConstructor = function EmptyConstructor() {};
var $74570f29af5dbce2$var$scriptTag = function scriptTag(content) {
    return $74570f29af5dbce2$var$LT + $74570f29af5dbce2$var$SCRIPT + $74570f29af5dbce2$var$GT + content + $74570f29af5dbce2$var$LT + "/" + $74570f29af5dbce2$var$SCRIPT + $74570f29af5dbce2$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $74570f29af5dbce2$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($74570f29af5dbce2$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $74570f29af5dbce2$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $74570f29af5dbce2$var$documentCreateElement$1("iframe");
    var JS = "java" + $74570f29af5dbce2$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $74570f29af5dbce2$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($74570f29af5dbce2$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $74570f29af5dbce2$var$activeXDocument;
var $74570f29af5dbce2$var$NullProtoObject = function NullProtoObject1() {
    try {
        $74570f29af5dbce2$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $74570f29af5dbce2$var$NullProtoObject = typeof document != "undefined" ? document.domain && $74570f29af5dbce2$var$activeXDocument ? $74570f29af5dbce2$var$NullProtoObjectViaActiveX($74570f29af5dbce2$var$activeXDocument) // old IE
     : $74570f29af5dbce2$var$NullProtoObjectViaIFrame() : $74570f29af5dbce2$var$NullProtoObjectViaActiveX($74570f29af5dbce2$var$activeXDocument); // WSH
    var length = $74570f29af5dbce2$var$enumBugKeys$1.length;
    while(length--)delete $74570f29af5dbce2$var$NullProtoObject[$74570f29af5dbce2$var$PROTOTYPE][$74570f29af5dbce2$var$enumBugKeys$1[length]];
    return $74570f29af5dbce2$var$NullProtoObject();
};
$74570f29af5dbce2$var$hiddenKeys$2[$74570f29af5dbce2$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $74570f29af5dbce2$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $74570f29af5dbce2$var$EmptyConstructor[$74570f29af5dbce2$var$PROTOTYPE] = $74570f29af5dbce2$var$anObject$9(O);
        result = new $74570f29af5dbce2$var$EmptyConstructor();
        $74570f29af5dbce2$var$EmptyConstructor[$74570f29af5dbce2$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$74570f29af5dbce2$var$IE_PROTO$1] = O;
    } else result = $74570f29af5dbce2$var$NullProtoObject();
    return Properties === undefined ? result : $74570f29af5dbce2$var$definePropertiesModule.f(result, Properties);
};
var $74570f29af5dbce2$var$wellKnownSymbol$c = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$create$1 = $74570f29af5dbce2$var$objectCreate;
var $74570f29af5dbce2$var$defineProperty$3 = $74570f29af5dbce2$var$objectDefineProperty.f;
var $74570f29af5dbce2$var$UNSCOPABLES = $74570f29af5dbce2$var$wellKnownSymbol$c("unscopables");
var $74570f29af5dbce2$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($74570f29af5dbce2$var$ArrayPrototype$1[$74570f29af5dbce2$var$UNSCOPABLES] == undefined) $74570f29af5dbce2$var$defineProperty$3($74570f29af5dbce2$var$ArrayPrototype$1, $74570f29af5dbce2$var$UNSCOPABLES, {
    configurable: true,
    value: $74570f29af5dbce2$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $74570f29af5dbce2$var$addToUnscopables$1 = function addToUnscopables$1(key) {
    $74570f29af5dbce2$var$ArrayPrototype$1[$74570f29af5dbce2$var$UNSCOPABLES][key] = true;
};
var $74570f29af5dbce2$var$iterators = {};
var $74570f29af5dbce2$var$uncurryThis$6 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$isCallable$e = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$store$1 = $74570f29af5dbce2$var$sharedStore;
var $74570f29af5dbce2$var$functionToString = $74570f29af5dbce2$var$uncurryThis$6(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$74570f29af5dbce2$var$isCallable$e($74570f29af5dbce2$var$store$1.inspectSource)) $74570f29af5dbce2$var$store$1.inspectSource = function(it) {
    return $74570f29af5dbce2$var$functionToString(it);
};
var $74570f29af5dbce2$var$inspectSource$4 = $74570f29af5dbce2$var$store$1.inspectSource;
var $74570f29af5dbce2$var$global$c = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$isCallable$d = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$inspectSource$3 = $74570f29af5dbce2$var$inspectSource$4;
var $74570f29af5dbce2$var$WeakMap$1 = $74570f29af5dbce2$var$global$c.WeakMap;
var $74570f29af5dbce2$var$nativeWeakMap = $74570f29af5dbce2$var$isCallable$d($74570f29af5dbce2$var$WeakMap$1) && /native code/.test($74570f29af5dbce2$var$inspectSource$3($74570f29af5dbce2$var$WeakMap$1));
var $74570f29af5dbce2$var$createPropertyDescriptor$3 = function createPropertyDescriptor$3(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $74570f29af5dbce2$var$DESCRIPTORS$5 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$definePropertyModule$3 = $74570f29af5dbce2$var$objectDefineProperty;
var $74570f29af5dbce2$var$createPropertyDescriptor$2 = $74570f29af5dbce2$var$createPropertyDescriptor$3;
var $74570f29af5dbce2$var$createNonEnumerableProperty$4 = $74570f29af5dbce2$var$DESCRIPTORS$5 ? function createNonEnumerableProperty$4(object, key, value) {
    return $74570f29af5dbce2$var$definePropertyModule$3.f(object, key, $74570f29af5dbce2$var$createPropertyDescriptor$2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $74570f29af5dbce2$var$NATIVE_WEAK_MAP = $74570f29af5dbce2$var$nativeWeakMap;
var $74570f29af5dbce2$var$global$b = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$uncurryThis$5 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$isObject$2 = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$createNonEnumerableProperty$3 = $74570f29af5dbce2$var$createNonEnumerableProperty$4;
var $74570f29af5dbce2$var$hasOwn$8 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$shared = $74570f29af5dbce2$var$sharedStore;
var $74570f29af5dbce2$var$sharedKey$1 = $74570f29af5dbce2$var$sharedKey$3;
var $74570f29af5dbce2$var$hiddenKeys$1 = $74570f29af5dbce2$var$hiddenKeys$4;
var $74570f29af5dbce2$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $74570f29af5dbce2$var$TypeError$2 = $74570f29af5dbce2$var$global$b.TypeError;
var $74570f29af5dbce2$var$WeakMap = $74570f29af5dbce2$var$global$b.WeakMap;
var $74570f29af5dbce2$var$set$1, $74570f29af5dbce2$var$get, $74570f29af5dbce2$var$has;
var $74570f29af5dbce2$var$enforce = function enforce(it) {
    return $74570f29af5dbce2$var$has(it) ? $74570f29af5dbce2$var$get(it) : $74570f29af5dbce2$var$set$1(it, {});
};
var $74570f29af5dbce2$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$74570f29af5dbce2$var$isObject$2(it) || (state = $74570f29af5dbce2$var$get(it)).type !== TYPE) throw $74570f29af5dbce2$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($74570f29af5dbce2$var$NATIVE_WEAK_MAP || $74570f29af5dbce2$var$shared.state) {
    var $74570f29af5dbce2$var$store = $74570f29af5dbce2$var$shared.state || ($74570f29af5dbce2$var$shared.state = new $74570f29af5dbce2$var$WeakMap());
    var $74570f29af5dbce2$var$wmget = $74570f29af5dbce2$var$uncurryThis$5($74570f29af5dbce2$var$store.get);
    var $74570f29af5dbce2$var$wmhas = $74570f29af5dbce2$var$uncurryThis$5($74570f29af5dbce2$var$store.has);
    var $74570f29af5dbce2$var$wmset = $74570f29af5dbce2$var$uncurryThis$5($74570f29af5dbce2$var$store.set);
    $74570f29af5dbce2$var$set$1 = function set$1(it, metadata) {
        if ($74570f29af5dbce2$var$wmhas($74570f29af5dbce2$var$store, it)) throw new $74570f29af5dbce2$var$TypeError$2($74570f29af5dbce2$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $74570f29af5dbce2$var$wmset($74570f29af5dbce2$var$store, it, metadata);
        return metadata;
    };
    $74570f29af5dbce2$var$get = function get(it) {
        return $74570f29af5dbce2$var$wmget($74570f29af5dbce2$var$store, it) || {};
    };
    $74570f29af5dbce2$var$has = function has(it) {
        return $74570f29af5dbce2$var$wmhas($74570f29af5dbce2$var$store, it);
    };
} else {
    var $74570f29af5dbce2$var$STATE = $74570f29af5dbce2$var$sharedKey$1("state");
    $74570f29af5dbce2$var$hiddenKeys$1[$74570f29af5dbce2$var$STATE] = true;
    $74570f29af5dbce2$var$set$1 = function set$1(it, metadata) {
        if ($74570f29af5dbce2$var$hasOwn$8(it, $74570f29af5dbce2$var$STATE)) throw new $74570f29af5dbce2$var$TypeError$2($74570f29af5dbce2$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $74570f29af5dbce2$var$createNonEnumerableProperty$3(it, $74570f29af5dbce2$var$STATE, metadata);
        return metadata;
    };
    $74570f29af5dbce2$var$get = function get(it) {
        return $74570f29af5dbce2$var$hasOwn$8(it, $74570f29af5dbce2$var$STATE) ? it[$74570f29af5dbce2$var$STATE] : {};
    };
    $74570f29af5dbce2$var$has = function has(it) {
        return $74570f29af5dbce2$var$hasOwn$8(it, $74570f29af5dbce2$var$STATE);
    };
}
var $74570f29af5dbce2$var$internalState = {
    set: $74570f29af5dbce2$var$set$1,
    get: $74570f29af5dbce2$var$get,
    has: $74570f29af5dbce2$var$has,
    enforce: $74570f29af5dbce2$var$enforce,
    getterFor: $74570f29af5dbce2$var$getterFor
};
var $74570f29af5dbce2$var$objectGetOwnPropertyDescriptor = {};
var $74570f29af5dbce2$var$objectPropertyIsEnumerable = {};
var $74570f29af5dbce2$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $74570f29af5dbce2$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $74570f29af5dbce2$var$NASHORN_BUG = $74570f29af5dbce2$var$getOwnPropertyDescriptor$2 && !$74570f29af5dbce2$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$74570f29af5dbce2$var$objectPropertyIsEnumerable.f = $74570f29af5dbce2$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $74570f29af5dbce2$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $74570f29af5dbce2$var$$propertyIsEnumerable;
var $74570f29af5dbce2$var$DESCRIPTORS$4 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$call$a = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$propertyIsEnumerableModule = $74570f29af5dbce2$var$objectPropertyIsEnumerable;
var $74570f29af5dbce2$var$createPropertyDescriptor$1 = $74570f29af5dbce2$var$createPropertyDescriptor$3;
var $74570f29af5dbce2$var$toIndexedObject$1 = $74570f29af5dbce2$var$toIndexedObject$5;
var $74570f29af5dbce2$var$toPropertyKey = $74570f29af5dbce2$var$toPropertyKey$2;
var $74570f29af5dbce2$var$hasOwn$7 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$IE8_DOM_DEFINE = $74570f29af5dbce2$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $74570f29af5dbce2$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$74570f29af5dbce2$var$objectGetOwnPropertyDescriptor.f = $74570f29af5dbce2$var$DESCRIPTORS$4 ? $74570f29af5dbce2$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $74570f29af5dbce2$var$toIndexedObject$1(O);
    P = $74570f29af5dbce2$var$toPropertyKey(P);
    if ($74570f29af5dbce2$var$IE8_DOM_DEFINE) try {
        return $74570f29af5dbce2$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($74570f29af5dbce2$var$hasOwn$7(O, P)) return $74570f29af5dbce2$var$createPropertyDescriptor$1(!$74570f29af5dbce2$var$call$a($74570f29af5dbce2$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $74570f29af5dbce2$var$makeBuiltIn$2 = {
    exports: {}
};
var $74570f29af5dbce2$var$DESCRIPTORS$3 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$hasOwn$6 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $74570f29af5dbce2$var$getDescriptor = $74570f29af5dbce2$var$DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;
var $74570f29af5dbce2$var$EXISTS = $74570f29af5dbce2$var$hasOwn$6($74570f29af5dbce2$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $74570f29af5dbce2$var$PROPER = $74570f29af5dbce2$var$EXISTS && (function something() {}).name === "something";
var $74570f29af5dbce2$var$CONFIGURABLE = $74570f29af5dbce2$var$EXISTS && (!$74570f29af5dbce2$var$DESCRIPTORS$3 || $74570f29af5dbce2$var$DESCRIPTORS$3 && $74570f29af5dbce2$var$getDescriptor($74570f29af5dbce2$var$FunctionPrototype$1, "name").configurable);
var $74570f29af5dbce2$var$functionName = {
    EXISTS: $74570f29af5dbce2$var$EXISTS,
    PROPER: $74570f29af5dbce2$var$PROPER,
    CONFIGURABLE: $74570f29af5dbce2$var$CONFIGURABLE
};
var $74570f29af5dbce2$var$fails$6 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$isCallable$c = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$hasOwn$5 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$DESCRIPTORS$2 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$CONFIGURABLE_FUNCTION_NAME$1 = $74570f29af5dbce2$var$functionName.CONFIGURABLE;
var $74570f29af5dbce2$var$inspectSource$2 = $74570f29af5dbce2$var$inspectSource$4;
var $74570f29af5dbce2$var$InternalStateModule$2 = $74570f29af5dbce2$var$internalState;
var $74570f29af5dbce2$var$enforceInternalState = $74570f29af5dbce2$var$InternalStateModule$2.enforce;
var $74570f29af5dbce2$var$getInternalState$1 = $74570f29af5dbce2$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $74570f29af5dbce2$var$defineProperty$2 = Object.defineProperty;
var $74570f29af5dbce2$var$CONFIGURABLE_LENGTH = $74570f29af5dbce2$var$DESCRIPTORS$2 && !$74570f29af5dbce2$var$fails$6(function() {
    return $74570f29af5dbce2$var$defineProperty$2(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $74570f29af5dbce2$var$TEMPLATE = String(String).split("String");
var $74570f29af5dbce2$var$makeBuiltIn$1 = $74570f29af5dbce2$var$makeBuiltIn$2.exports = function makeBuiltIn$1(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$74570f29af5dbce2$var$hasOwn$5(value, "name") || $74570f29af5dbce2$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($74570f29af5dbce2$var$DESCRIPTORS$2) $74570f29af5dbce2$var$defineProperty$2(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($74570f29af5dbce2$var$CONFIGURABLE_LENGTH && options && $74570f29af5dbce2$var$hasOwn$5(options, "arity") && value.length !== options.arity) $74570f29af5dbce2$var$defineProperty$2(value, "length", {
        value: options.arity
    });
    try {
        if (options && $74570f29af5dbce2$var$hasOwn$5(options, "constructor") && options.constructor) {
            if ($74570f29af5dbce2$var$DESCRIPTORS$2) $74570f29af5dbce2$var$defineProperty$2(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $74570f29af5dbce2$var$enforceInternalState(value);
    if (!$74570f29af5dbce2$var$hasOwn$5(state, "source")) state.source = $74570f29af5dbce2$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $74570f29af5dbce2$var$makeBuiltIn$1(function toString() {
    return $74570f29af5dbce2$var$isCallable$c(this) && $74570f29af5dbce2$var$getInternalState$1(this).source || $74570f29af5dbce2$var$inspectSource$2(this);
}, "toString");
var $74570f29af5dbce2$var$isCallable$b = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$definePropertyModule$2 = $74570f29af5dbce2$var$objectDefineProperty;
var $74570f29af5dbce2$var$makeBuiltIn = $74570f29af5dbce2$var$makeBuiltIn$2.exports;
var $74570f29af5dbce2$var$defineGlobalProperty$1 = $74570f29af5dbce2$var$defineGlobalProperty$3;
var $74570f29af5dbce2$var$defineBuiltIn$6 = function defineBuiltIn$6(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($74570f29af5dbce2$var$isCallable$b(value)) $74570f29af5dbce2$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $74570f29af5dbce2$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $74570f29af5dbce2$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $74570f29af5dbce2$var$objectGetOwnPropertyNames = {};
var $74570f29af5dbce2$var$internalObjectKeys = $74570f29af5dbce2$var$objectKeysInternal;
var $74570f29af5dbce2$var$enumBugKeys = $74570f29af5dbce2$var$enumBugKeys$3;
var $74570f29af5dbce2$var$hiddenKeys = $74570f29af5dbce2$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$74570f29af5dbce2$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $74570f29af5dbce2$var$internalObjectKeys(O, $74570f29af5dbce2$var$hiddenKeys);
};
var $74570f29af5dbce2$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$74570f29af5dbce2$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $74570f29af5dbce2$var$getBuiltIn$4 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$uncurryThis$4 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$getOwnPropertyNamesModule = $74570f29af5dbce2$var$objectGetOwnPropertyNames;
var $74570f29af5dbce2$var$getOwnPropertySymbolsModule = $74570f29af5dbce2$var$objectGetOwnPropertySymbols;
var $74570f29af5dbce2$var$anObject$8 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$concat = $74570f29af5dbce2$var$uncurryThis$4([].concat);
// all object keys, includes non-enumerable and symbols
var $74570f29af5dbce2$var$ownKeys$1 = $74570f29af5dbce2$var$getBuiltIn$4("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $74570f29af5dbce2$var$getOwnPropertyNamesModule.f($74570f29af5dbce2$var$anObject$8(it));
    var getOwnPropertySymbols = $74570f29af5dbce2$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $74570f29af5dbce2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $74570f29af5dbce2$var$hasOwn$4 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$ownKeys = $74570f29af5dbce2$var$ownKeys$1;
var $74570f29af5dbce2$var$getOwnPropertyDescriptorModule = $74570f29af5dbce2$var$objectGetOwnPropertyDescriptor;
var $74570f29af5dbce2$var$definePropertyModule$1 = $74570f29af5dbce2$var$objectDefineProperty;
var $74570f29af5dbce2$var$copyConstructorProperties$1 = function copyConstructorProperties$1(target, source, exceptions) {
    var keys = $74570f29af5dbce2$var$ownKeys(source);
    var defineProperty = $74570f29af5dbce2$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $74570f29af5dbce2$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$74570f29af5dbce2$var$hasOwn$4(target, key) && !(exceptions && $74570f29af5dbce2$var$hasOwn$4(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $74570f29af5dbce2$var$fails$5 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$isCallable$a = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$replacement = /#|\.prototype\./;
var $74570f29af5dbce2$var$isForced$2 = function isForced$2(feature, detection) {
    var value = $74570f29af5dbce2$var$data[$74570f29af5dbce2$var$normalize(feature)];
    return value == $74570f29af5dbce2$var$POLYFILL ? true : value == $74570f29af5dbce2$var$NATIVE ? false : $74570f29af5dbce2$var$isCallable$a(detection) ? $74570f29af5dbce2$var$fails$5(detection) : !!detection;
};
var $74570f29af5dbce2$var$normalize = $74570f29af5dbce2$var$isForced$2.normalize = function normalize(string) {
    return String(string).replace($74570f29af5dbce2$var$replacement, ".").toLowerCase();
};
var $74570f29af5dbce2$var$data = $74570f29af5dbce2$var$isForced$2.data = {};
var $74570f29af5dbce2$var$NATIVE = $74570f29af5dbce2$var$isForced$2.NATIVE = "N";
var $74570f29af5dbce2$var$POLYFILL = $74570f29af5dbce2$var$isForced$2.POLYFILL = "P";
var $74570f29af5dbce2$var$isForced_1 = $74570f29af5dbce2$var$isForced$2;
var $74570f29af5dbce2$var$global$a = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$getOwnPropertyDescriptor$1 = $74570f29af5dbce2$var$objectGetOwnPropertyDescriptor.f;
var $74570f29af5dbce2$var$createNonEnumerableProperty$2 = $74570f29af5dbce2$var$createNonEnumerableProperty$4;
var $74570f29af5dbce2$var$defineBuiltIn$5 = $74570f29af5dbce2$var$defineBuiltIn$6;
var $74570f29af5dbce2$var$defineGlobalProperty = $74570f29af5dbce2$var$defineGlobalProperty$3;
var $74570f29af5dbce2$var$copyConstructorProperties = $74570f29af5dbce2$var$copyConstructorProperties$1;
var $74570f29af5dbce2$var$isForced$1 = $74570f29af5dbce2$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $74570f29af5dbce2$var$_export = function _export(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $74570f29af5dbce2$var$global$a;
    else if (STATIC) target = $74570f29af5dbce2$var$global$a[TARGET] || $74570f29af5dbce2$var$defineGlobalProperty(TARGET, {});
    else target = ($74570f29af5dbce2$var$global$a[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $74570f29af5dbce2$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $74570f29af5dbce2$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $1ObTH._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $1ObTH._)(targetProperty))) continue;
            $74570f29af5dbce2$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $74570f29af5dbce2$var$createNonEnumerableProperty$2(sourceProperty, "sham", true);
        $74570f29af5dbce2$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $74570f29af5dbce2$var$fails$4 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$correctPrototypeGetter = !$74570f29af5dbce2$var$fails$4(function() {
    var F = function F() {};
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $74570f29af5dbce2$var$hasOwn$3 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$isCallable$9 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$toObject = $74570f29af5dbce2$var$toObject$2;
var $74570f29af5dbce2$var$sharedKey = $74570f29af5dbce2$var$sharedKey$3;
var $74570f29af5dbce2$var$CORRECT_PROTOTYPE_GETTER = $74570f29af5dbce2$var$correctPrototypeGetter;
var $74570f29af5dbce2$var$IE_PROTO = $74570f29af5dbce2$var$sharedKey("IE_PROTO");
var $74570f29af5dbce2$var$$Object$1 = Object;
var $74570f29af5dbce2$var$ObjectPrototype = $74570f29af5dbce2$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $74570f29af5dbce2$var$objectGetPrototypeOf = $74570f29af5dbce2$var$CORRECT_PROTOTYPE_GETTER ? $74570f29af5dbce2$var$$Object$1.getPrototypeOf : function objectGetPrototypeOf(O) {
    var object = $74570f29af5dbce2$var$toObject(O);
    if ($74570f29af5dbce2$var$hasOwn$3(object, $74570f29af5dbce2$var$IE_PROTO)) return object[$74570f29af5dbce2$var$IE_PROTO];
    var constructor = object.constructor;
    if ($74570f29af5dbce2$var$isCallable$9(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $74570f29af5dbce2$var$$Object$1 ? $74570f29af5dbce2$var$ObjectPrototype : null;
};
var $74570f29af5dbce2$var$fails$3 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$isCallable$8 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$getPrototypeOf$1 = $74570f29af5dbce2$var$objectGetPrototypeOf;
var $74570f29af5dbce2$var$defineBuiltIn$4 = $74570f29af5dbce2$var$defineBuiltIn$6;
var $74570f29af5dbce2$var$wellKnownSymbol$b = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$ITERATOR$5 = $74570f29af5dbce2$var$wellKnownSymbol$b("iterator");
var $74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $74570f29af5dbce2$var$IteratorPrototype$2, $74570f29af5dbce2$var$PrototypeOfArrayIteratorPrototype, $74570f29af5dbce2$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $74570f29af5dbce2$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $74570f29af5dbce2$var$arrayIterator)) $74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $74570f29af5dbce2$var$PrototypeOfArrayIteratorPrototype = $74570f29af5dbce2$var$getPrototypeOf$1($74570f29af5dbce2$var$getPrototypeOf$1($74570f29af5dbce2$var$arrayIterator));
        if ($74570f29af5dbce2$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $74570f29af5dbce2$var$IteratorPrototype$2 = $74570f29af5dbce2$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $74570f29af5dbce2$var$NEW_ITERATOR_PROTOTYPE = $74570f29af5dbce2$var$IteratorPrototype$2 == undefined || $74570f29af5dbce2$var$fails$3(function() {
    var test = {};
    // FF44- legacy iterators case
    return $74570f29af5dbce2$var$IteratorPrototype$2[$74570f29af5dbce2$var$ITERATOR$5].call(test) !== test;
});
if ($74570f29af5dbce2$var$NEW_ITERATOR_PROTOTYPE) $74570f29af5dbce2$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$74570f29af5dbce2$var$isCallable$8($74570f29af5dbce2$var$IteratorPrototype$2[$74570f29af5dbce2$var$ITERATOR$5])) $74570f29af5dbce2$var$defineBuiltIn$4($74570f29af5dbce2$var$IteratorPrototype$2, $74570f29af5dbce2$var$ITERATOR$5, function() {
    return this;
});
var $74570f29af5dbce2$var$iteratorsCore = {
    IteratorPrototype: $74570f29af5dbce2$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS$1
};
var $74570f29af5dbce2$var$defineProperty$1 = $74570f29af5dbce2$var$objectDefineProperty.f;
var $74570f29af5dbce2$var$hasOwn$2 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$wellKnownSymbol$a = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$TO_STRING_TAG$3 = $74570f29af5dbce2$var$wellKnownSymbol$a("toStringTag");
var $74570f29af5dbce2$var$setToStringTag$3 = function setToStringTag$3(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$74570f29af5dbce2$var$hasOwn$2(target, $74570f29af5dbce2$var$TO_STRING_TAG$3)) $74570f29af5dbce2$var$defineProperty$1(target, $74570f29af5dbce2$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $74570f29af5dbce2$var$IteratorPrototype$1 = $74570f29af5dbce2$var$iteratorsCore.IteratorPrototype;
var $74570f29af5dbce2$var$create = $74570f29af5dbce2$var$objectCreate;
var $74570f29af5dbce2$var$createPropertyDescriptor = $74570f29af5dbce2$var$createPropertyDescriptor$3;
var $74570f29af5dbce2$var$setToStringTag$2 = $74570f29af5dbce2$var$setToStringTag$3;
var $74570f29af5dbce2$var$Iterators$4 = $74570f29af5dbce2$var$iterators;
var $74570f29af5dbce2$var$returnThis$1 = function returnThis$1() {
    return this;
};
var $74570f29af5dbce2$var$createIteratorConstructor$1 = function createIteratorConstructor$1(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $74570f29af5dbce2$var$create($74570f29af5dbce2$var$IteratorPrototype$1, {
        next: $74570f29af5dbce2$var$createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    $74570f29af5dbce2$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $74570f29af5dbce2$var$Iterators$4[TO_STRING_TAG] = $74570f29af5dbce2$var$returnThis$1;
    return IteratorConstructor;
};
var $74570f29af5dbce2$var$isCallable$7 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$$String$1 = String;
var $74570f29af5dbce2$var$$TypeError$5 = TypeError;
var $74570f29af5dbce2$var$aPossiblePrototype$1 = function aPossiblePrototype$1(argument) {
    if (typeof argument == "object" || $74570f29af5dbce2$var$isCallable$7(argument)) return argument;
    throw $74570f29af5dbce2$var$$TypeError$5("Can't set " + $74570f29af5dbce2$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $74570f29af5dbce2$var$uncurryThis$3 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$anObject$7 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$aPossiblePrototype = $74570f29af5dbce2$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $74570f29af5dbce2$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $74570f29af5dbce2$var$uncurryThis$3(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $74570f29af5dbce2$var$anObject$7(O);
        $74570f29af5dbce2$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $74570f29af5dbce2$var$$$6 = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$call$9 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$FunctionName = $74570f29af5dbce2$var$functionName;
var $74570f29af5dbce2$var$isCallable$6 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$createIteratorConstructor = $74570f29af5dbce2$var$createIteratorConstructor$1;
var $74570f29af5dbce2$var$getPrototypeOf = $74570f29af5dbce2$var$objectGetPrototypeOf;
var $74570f29af5dbce2$var$setPrototypeOf$1 = $74570f29af5dbce2$var$objectSetPrototypeOf;
var $74570f29af5dbce2$var$setToStringTag$1 = $74570f29af5dbce2$var$setToStringTag$3;
var $74570f29af5dbce2$var$createNonEnumerableProperty$1 = $74570f29af5dbce2$var$createNonEnumerableProperty$4;
var $74570f29af5dbce2$var$defineBuiltIn$3 = $74570f29af5dbce2$var$defineBuiltIn$6;
var $74570f29af5dbce2$var$wellKnownSymbol$9 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$Iterators$3 = $74570f29af5dbce2$var$iterators;
var $74570f29af5dbce2$var$IteratorsCore = $74570f29af5dbce2$var$iteratorsCore;
var $74570f29af5dbce2$var$PROPER_FUNCTION_NAME$1 = $74570f29af5dbce2$var$FunctionName.PROPER;
var $74570f29af5dbce2$var$CONFIGURABLE_FUNCTION_NAME = $74570f29af5dbce2$var$FunctionName.CONFIGURABLE;
var $74570f29af5dbce2$var$IteratorPrototype = $74570f29af5dbce2$var$IteratorsCore.IteratorPrototype;
var $74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS = $74570f29af5dbce2$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $74570f29af5dbce2$var$ITERATOR$4 = $74570f29af5dbce2$var$wellKnownSymbol$9("iterator");
var $74570f29af5dbce2$var$KEYS = "keys";
var $74570f29af5dbce2$var$VALUES = "values";
var $74570f29af5dbce2$var$ENTRIES = "entries";
var $74570f29af5dbce2$var$returnThis = function returnThis() {
    return this;
};
var $74570f29af5dbce2$var$defineIterator$1 = function defineIterator$1(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $74570f29af5dbce2$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $74570f29af5dbce2$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $74570f29af5dbce2$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $74570f29af5dbce2$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$74570f29af5dbce2$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $74570f29af5dbce2$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($74570f29af5dbce2$var$getPrototypeOf(CurrentIteratorPrototype) !== $74570f29af5dbce2$var$IteratorPrototype) {
                if ($74570f29af5dbce2$var$setPrototypeOf$1) $74570f29af5dbce2$var$setPrototypeOf$1(CurrentIteratorPrototype, $74570f29af5dbce2$var$IteratorPrototype);
                else if (!$74570f29af5dbce2$var$isCallable$6(CurrentIteratorPrototype[$74570f29af5dbce2$var$ITERATOR$4])) $74570f29af5dbce2$var$defineBuiltIn$3(CurrentIteratorPrototype, $74570f29af5dbce2$var$ITERATOR$4, $74570f29af5dbce2$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $74570f29af5dbce2$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($74570f29af5dbce2$var$PROPER_FUNCTION_NAME$1 && DEFAULT == $74570f29af5dbce2$var$VALUES && nativeIterator && nativeIterator.name !== $74570f29af5dbce2$var$VALUES) {
        if ($74570f29af5dbce2$var$CONFIGURABLE_FUNCTION_NAME) $74570f29af5dbce2$var$createNonEnumerableProperty$1(IterablePrototype, "name", $74570f29af5dbce2$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $74570f29af5dbce2$var$call$9(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($74570f29af5dbce2$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($74570f29af5dbce2$var$KEYS),
            entries: getIterationMethod($74570f29af5dbce2$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $74570f29af5dbce2$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $74570f29af5dbce2$var$$$6({
            target: NAME,
            proto: true,
            forced: $74570f29af5dbce2$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$74570f29af5dbce2$var$ITERATOR$4] !== defaultIterator) $74570f29af5dbce2$var$defineBuiltIn$3(IterablePrototype, $74570f29af5dbce2$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $74570f29af5dbce2$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $74570f29af5dbce2$var$toIndexedObject = $74570f29af5dbce2$var$toIndexedObject$5;
var $74570f29af5dbce2$var$addToUnscopables = $74570f29af5dbce2$var$addToUnscopables$1;
var $74570f29af5dbce2$var$Iterators$2 = $74570f29af5dbce2$var$iterators;
var $74570f29af5dbce2$var$InternalStateModule$1 = $74570f29af5dbce2$var$internalState;
var $74570f29af5dbce2$var$defineProperty = $74570f29af5dbce2$var$objectDefineProperty.f;
var $74570f29af5dbce2$var$defineIterator = $74570f29af5dbce2$var$defineIterator$1;
var $74570f29af5dbce2$var$DESCRIPTORS$1 = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$ARRAY_ITERATOR = "Array Iterator";
var $74570f29af5dbce2$var$setInternalState$1 = $74570f29af5dbce2$var$InternalStateModule$1.set;
var $74570f29af5dbce2$var$getInternalState = $74570f29af5dbce2$var$InternalStateModule$1.getterFor($74570f29af5dbce2$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $74570f29af5dbce2$var$es_array_iterator = $74570f29af5dbce2$var$defineIterator(Array, "Array", function(iterated, kind) {
    $74570f29af5dbce2$var$setInternalState$1(this, {
        type: $74570f29af5dbce2$var$ARRAY_ITERATOR,
        target: $74570f29af5dbce2$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $74570f29af5dbce2$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $74570f29af5dbce2$var$values = $74570f29af5dbce2$var$Iterators$2.Arguments = $74570f29af5dbce2$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$74570f29af5dbce2$var$addToUnscopables("keys");
$74570f29af5dbce2$var$addToUnscopables("values");
$74570f29af5dbce2$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($74570f29af5dbce2$var$DESCRIPTORS$1 && $74570f29af5dbce2$var$values.name !== "values") try {
    $74570f29af5dbce2$var$defineProperty($74570f29af5dbce2$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $74570f29af5dbce2$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $74570f29af5dbce2$var$documentCreateElement = $74570f29af5dbce2$var$documentCreateElement$2;
var $74570f29af5dbce2$var$classList = $74570f29af5dbce2$var$documentCreateElement("span").classList;
var $74570f29af5dbce2$var$DOMTokenListPrototype$1 = $74570f29af5dbce2$var$classList && $74570f29af5dbce2$var$classList.constructor && $74570f29af5dbce2$var$classList.constructor.prototype;
var $74570f29af5dbce2$var$domTokenListPrototype = $74570f29af5dbce2$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $74570f29af5dbce2$var$DOMTokenListPrototype$1;
var $74570f29af5dbce2$var$global$9 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$DOMIterables = $74570f29af5dbce2$var$domIterables;
var $74570f29af5dbce2$var$DOMTokenListPrototype = $74570f29af5dbce2$var$domTokenListPrototype;
var $74570f29af5dbce2$var$ArrayIteratorMethods = $74570f29af5dbce2$var$es_array_iterator;
var $74570f29af5dbce2$var$createNonEnumerableProperty = $74570f29af5dbce2$var$createNonEnumerableProperty$4;
var $74570f29af5dbce2$var$wellKnownSymbol$8 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$ITERATOR$3 = $74570f29af5dbce2$var$wellKnownSymbol$8("iterator");
var $74570f29af5dbce2$var$TO_STRING_TAG$2 = $74570f29af5dbce2$var$wellKnownSymbol$8("toStringTag");
var $74570f29af5dbce2$var$ArrayValues = $74570f29af5dbce2$var$ArrayIteratorMethods.values;
var $74570f29af5dbce2$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$74570f29af5dbce2$var$ITERATOR$3] !== $74570f29af5dbce2$var$ArrayValues) try {
            $74570f29af5dbce2$var$createNonEnumerableProperty(CollectionPrototype, $74570f29af5dbce2$var$ITERATOR$3, $74570f29af5dbce2$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$74570f29af5dbce2$var$ITERATOR$3] = $74570f29af5dbce2$var$ArrayValues;
        }
        if (!CollectionPrototype[$74570f29af5dbce2$var$TO_STRING_TAG$2]) $74570f29af5dbce2$var$createNonEnumerableProperty(CollectionPrototype, $74570f29af5dbce2$var$TO_STRING_TAG$2, COLLECTION_NAME);
        if ($74570f29af5dbce2$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $74570f29af5dbce2$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $74570f29af5dbce2$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $74570f29af5dbce2$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $74570f29af5dbce2$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $74570f29af5dbce2$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $74570f29af5dbce2$var$COLLECTION_NAME in $74570f29af5dbce2$var$DOMIterables)$74570f29af5dbce2$var$handlePrototype($74570f29af5dbce2$var$global$9[$74570f29af5dbce2$var$COLLECTION_NAME] && $74570f29af5dbce2$var$global$9[$74570f29af5dbce2$var$COLLECTION_NAME].prototype, $74570f29af5dbce2$var$COLLECTION_NAME);
$74570f29af5dbce2$var$handlePrototype($74570f29af5dbce2$var$DOMTokenListPrototype, "DOMTokenList");
var $74570f29af5dbce2$var$classof$4 = $74570f29af5dbce2$var$classofRaw$1;
var $74570f29af5dbce2$var$global$8 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$engineIsNode = $74570f29af5dbce2$var$classof$4($74570f29af5dbce2$var$global$8.process) == "process";
var $74570f29af5dbce2$var$getBuiltIn$3 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$definePropertyModule = $74570f29af5dbce2$var$objectDefineProperty;
var $74570f29af5dbce2$var$wellKnownSymbol$7 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$DESCRIPTORS = $74570f29af5dbce2$var$descriptors;
var $74570f29af5dbce2$var$SPECIES$2 = $74570f29af5dbce2$var$wellKnownSymbol$7("species");
var $74570f29af5dbce2$var$setSpecies$1 = function setSpecies$1(CONSTRUCTOR_NAME) {
    var Constructor = $74570f29af5dbce2$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $74570f29af5dbce2$var$definePropertyModule.f;
    if ($74570f29af5dbce2$var$DESCRIPTORS && Constructor && !Constructor[$74570f29af5dbce2$var$SPECIES$2]) defineProperty(Constructor, $74570f29af5dbce2$var$SPECIES$2, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};
var $74570f29af5dbce2$var$isPrototypeOf$2 = $74570f29af5dbce2$var$objectIsPrototypeOf;
var $74570f29af5dbce2$var$$TypeError$4 = TypeError;
var $74570f29af5dbce2$var$anInstance$1 = function anInstance$1(it, Prototype) {
    if ($74570f29af5dbce2$var$isPrototypeOf$2(Prototype, it)) return it;
    throw $74570f29af5dbce2$var$$TypeError$4("Incorrect invocation");
};
var $74570f29af5dbce2$var$wellKnownSymbol$6 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$TO_STRING_TAG$1 = $74570f29af5dbce2$var$wellKnownSymbol$6("toStringTag");
var $74570f29af5dbce2$var$test = {};
$74570f29af5dbce2$var$test[$74570f29af5dbce2$var$TO_STRING_TAG$1] = "z";
var $74570f29af5dbce2$var$toStringTagSupport = String($74570f29af5dbce2$var$test) === "[object z]";
var $74570f29af5dbce2$var$TO_STRING_TAG_SUPPORT = $74570f29af5dbce2$var$toStringTagSupport;
var $74570f29af5dbce2$var$isCallable$5 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$classofRaw = $74570f29af5dbce2$var$classofRaw$1;
var $74570f29af5dbce2$var$wellKnownSymbol$5 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$TO_STRING_TAG = $74570f29af5dbce2$var$wellKnownSymbol$5("toStringTag");
var $74570f29af5dbce2$var$$Object = Object;
// ES3 wrong here
var $74570f29af5dbce2$var$CORRECT_ARGUMENTS = $74570f29af5dbce2$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $74570f29af5dbce2$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $74570f29af5dbce2$var$classof$3 = $74570f29af5dbce2$var$TO_STRING_TAG_SUPPORT ? $74570f29af5dbce2$var$classofRaw : function classof$3(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $74570f29af5dbce2$var$tryGet(O = $74570f29af5dbce2$var$$Object(it), $74570f29af5dbce2$var$TO_STRING_TAG)) == "string" ? tag : $74570f29af5dbce2$var$CORRECT_ARGUMENTS ? $74570f29af5dbce2$var$classofRaw(O) : (result = $74570f29af5dbce2$var$classofRaw(O)) == "Object" && $74570f29af5dbce2$var$isCallable$5(O.callee) ? "Arguments" : result;
};
var $74570f29af5dbce2$var$uncurryThis$2 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$fails$2 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$isCallable$4 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$classof$2 = $74570f29af5dbce2$var$classof$3;
var $74570f29af5dbce2$var$getBuiltIn$2 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$inspectSource$1 = $74570f29af5dbce2$var$inspectSource$4;
var $74570f29af5dbce2$var$noop = function noop() {};
var $74570f29af5dbce2$var$empty = [];
var $74570f29af5dbce2$var$construct = $74570f29af5dbce2$var$getBuiltIn$2("Reflect", "construct");
var $74570f29af5dbce2$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $74570f29af5dbce2$var$exec = $74570f29af5dbce2$var$uncurryThis$2($74570f29af5dbce2$var$constructorRegExp.exec);
var $74570f29af5dbce2$var$INCORRECT_TO_STRING = !$74570f29af5dbce2$var$constructorRegExp.exec($74570f29af5dbce2$var$noop);
var $74570f29af5dbce2$var$isConstructorModern = function isConstructor(argument) {
    if (!$74570f29af5dbce2$var$isCallable$4(argument)) return false;
    try {
        $74570f29af5dbce2$var$construct($74570f29af5dbce2$var$noop, $74570f29af5dbce2$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $74570f29af5dbce2$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$74570f29af5dbce2$var$isCallable$4(argument)) return false;
    switch($74570f29af5dbce2$var$classof$2(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $74570f29af5dbce2$var$INCORRECT_TO_STRING || !!$74570f29af5dbce2$var$exec($74570f29af5dbce2$var$constructorRegExp, $74570f29af5dbce2$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$74570f29af5dbce2$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $74570f29af5dbce2$var$isConstructor$1 = !$74570f29af5dbce2$var$construct || $74570f29af5dbce2$var$fails$2(function() {
    var called;
    return $74570f29af5dbce2$var$isConstructorModern($74570f29af5dbce2$var$isConstructorModern.call) || !$74570f29af5dbce2$var$isConstructorModern(Object) || !$74570f29af5dbce2$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $74570f29af5dbce2$var$isConstructorLegacy : $74570f29af5dbce2$var$isConstructorModern;
var $74570f29af5dbce2$var$isConstructor = $74570f29af5dbce2$var$isConstructor$1;
var $74570f29af5dbce2$var$tryToString$2 = $74570f29af5dbce2$var$tryToString$4;
var $74570f29af5dbce2$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $74570f29af5dbce2$var$aConstructor$1 = function aConstructor$1(argument) {
    if ($74570f29af5dbce2$var$isConstructor(argument)) return argument;
    throw $74570f29af5dbce2$var$$TypeError$3($74570f29af5dbce2$var$tryToString$2(argument) + " is not a constructor");
};
var $74570f29af5dbce2$var$anObject$6 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$aConstructor = $74570f29af5dbce2$var$aConstructor$1;
var $74570f29af5dbce2$var$wellKnownSymbol$4 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$SPECIES$1 = $74570f29af5dbce2$var$wellKnownSymbol$4("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $74570f29af5dbce2$var$speciesConstructor$1 = function speciesConstructor$1(O, defaultConstructor) {
    var C = $74570f29af5dbce2$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $74570f29af5dbce2$var$anObject$6(C)[$74570f29af5dbce2$var$SPECIES$1]) == undefined ? defaultConstructor : $74570f29af5dbce2$var$aConstructor(S);
};
var $74570f29af5dbce2$var$NATIVE_BIND$1 = $74570f29af5dbce2$var$functionBindNative;
var $74570f29af5dbce2$var$FunctionPrototype = Function.prototype;
var $74570f29af5dbce2$var$apply$1 = $74570f29af5dbce2$var$FunctionPrototype.apply;
var $74570f29af5dbce2$var$call$8 = $74570f29af5dbce2$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $74570f29af5dbce2$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($74570f29af5dbce2$var$NATIVE_BIND$1 ? $74570f29af5dbce2$var$call$8.bind($74570f29af5dbce2$var$apply$1) : function() {
    return $74570f29af5dbce2$var$call$8.apply($74570f29af5dbce2$var$apply$1, arguments);
});
var $74570f29af5dbce2$var$uncurryThis$1 = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$aCallable$5 = $74570f29af5dbce2$var$aCallable$7;
var $74570f29af5dbce2$var$NATIVE_BIND = $74570f29af5dbce2$var$functionBindNative;
var $74570f29af5dbce2$var$bind$4 = $74570f29af5dbce2$var$uncurryThis$1($74570f29af5dbce2$var$uncurryThis$1.bind);
// optional / simple context binding
var $74570f29af5dbce2$var$functionBindContext = function functionBindContext(fn, that) {
    $74570f29af5dbce2$var$aCallable$5(fn);
    return that === undefined ? fn : $74570f29af5dbce2$var$NATIVE_BIND ? $74570f29af5dbce2$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $74570f29af5dbce2$var$uncurryThis = $74570f29af5dbce2$var$functionUncurryThis;
var $74570f29af5dbce2$var$arraySlice$1 = $74570f29af5dbce2$var$uncurryThis([].slice);
var $74570f29af5dbce2$var$$TypeError$2 = TypeError;
var $74570f29af5dbce2$var$validateArgumentsLength$1 = function validateArgumentsLength$1(passed, required) {
    if (passed < required) throw $74570f29af5dbce2$var$$TypeError$2("Not enough arguments");
    return passed;
};
var $74570f29af5dbce2$var$userAgent$2 = $74570f29af5dbce2$var$engineUserAgent;
var $74570f29af5dbce2$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($74570f29af5dbce2$var$userAgent$2);
var $74570f29af5dbce2$var$global$7 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$apply = $74570f29af5dbce2$var$functionApply;
var $74570f29af5dbce2$var$bind$3 = $74570f29af5dbce2$var$functionBindContext;
var $74570f29af5dbce2$var$isCallable$3 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$hasOwn$1 = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$fails$1 = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$html = $74570f29af5dbce2$var$html$2;
var $74570f29af5dbce2$var$arraySlice = $74570f29af5dbce2$var$arraySlice$1;
var $74570f29af5dbce2$var$createElement = $74570f29af5dbce2$var$documentCreateElement$2;
var $74570f29af5dbce2$var$validateArgumentsLength = $74570f29af5dbce2$var$validateArgumentsLength$1;
var $74570f29af5dbce2$var$IS_IOS$1 = $74570f29af5dbce2$var$engineIsIos;
var $74570f29af5dbce2$var$IS_NODE$2 = $74570f29af5dbce2$var$engineIsNode;
var $74570f29af5dbce2$var$set = $74570f29af5dbce2$var$global$7.setImmediate;
var $74570f29af5dbce2$var$clear = $74570f29af5dbce2$var$global$7.clearImmediate;
var $74570f29af5dbce2$var$process$2 = $74570f29af5dbce2$var$global$7.process;
var $74570f29af5dbce2$var$Dispatch = $74570f29af5dbce2$var$global$7.Dispatch;
var $74570f29af5dbce2$var$Function$1 = $74570f29af5dbce2$var$global$7.Function;
var $74570f29af5dbce2$var$MessageChannel = $74570f29af5dbce2$var$global$7.MessageChannel;
var $74570f29af5dbce2$var$String$1 = $74570f29af5dbce2$var$global$7.String;
var $74570f29af5dbce2$var$counter = 0;
var $74570f29af5dbce2$var$queue$1 = {};
var $74570f29af5dbce2$var$ONREADYSTATECHANGE = "onreadystatechange";
var $74570f29af5dbce2$var$location, $74570f29af5dbce2$var$defer, $74570f29af5dbce2$var$channel, $74570f29af5dbce2$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $74570f29af5dbce2$var$location = $74570f29af5dbce2$var$global$7.location;
} catch (error) {}
var $74570f29af5dbce2$var$run = function run(id) {
    if ($74570f29af5dbce2$var$hasOwn$1($74570f29af5dbce2$var$queue$1, id)) {
        var fn = $74570f29af5dbce2$var$queue$1[id];
        delete $74570f29af5dbce2$var$queue$1[id];
        fn();
    }
};
var $74570f29af5dbce2$var$runner = function runner(id) {
    return function() {
        $74570f29af5dbce2$var$run(id);
    };
};
var $74570f29af5dbce2$var$listener = function listener(event) {
    $74570f29af5dbce2$var$run(event.data);
};
var $74570f29af5dbce2$var$post = function post(id) {
    // old engines have not location.origin
    $74570f29af5dbce2$var$global$7.postMessage($74570f29af5dbce2$var$String$1(id), $74570f29af5dbce2$var$location.protocol + "//" + $74570f29af5dbce2$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$74570f29af5dbce2$var$set || !$74570f29af5dbce2$var$clear) {
    $74570f29af5dbce2$var$set = function setImmediate(handler) {
        $74570f29af5dbce2$var$validateArgumentsLength(arguments.length, 1);
        var fn = $74570f29af5dbce2$var$isCallable$3(handler) ? handler : $74570f29af5dbce2$var$Function$1(handler);
        var args = $74570f29af5dbce2$var$arraySlice(arguments, 1);
        $74570f29af5dbce2$var$queue$1[++$74570f29af5dbce2$var$counter] = function() {
            $74570f29af5dbce2$var$apply(fn, undefined, args);
        };
        $74570f29af5dbce2$var$defer($74570f29af5dbce2$var$counter);
        return $74570f29af5dbce2$var$counter;
    };
    $74570f29af5dbce2$var$clear = function clearImmediate(id) {
        delete $74570f29af5dbce2$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($74570f29af5dbce2$var$IS_NODE$2) $74570f29af5dbce2$var$defer = function defer(id) {
        $74570f29af5dbce2$var$process$2.nextTick($74570f29af5dbce2$var$runner(id));
    };
    else if ($74570f29af5dbce2$var$Dispatch && $74570f29af5dbce2$var$Dispatch.now) $74570f29af5dbce2$var$defer = function defer(id) {
        $74570f29af5dbce2$var$Dispatch.now($74570f29af5dbce2$var$runner(id));
    };
    else if ($74570f29af5dbce2$var$MessageChannel && !$74570f29af5dbce2$var$IS_IOS$1) {
        $74570f29af5dbce2$var$channel = new $74570f29af5dbce2$var$MessageChannel();
        $74570f29af5dbce2$var$port = $74570f29af5dbce2$var$channel.port2;
        $74570f29af5dbce2$var$channel.port1.onmessage = $74570f29af5dbce2$var$listener;
        $74570f29af5dbce2$var$defer = $74570f29af5dbce2$var$bind$3($74570f29af5dbce2$var$port.postMessage, $74570f29af5dbce2$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($74570f29af5dbce2$var$global$7.addEventListener && $74570f29af5dbce2$var$isCallable$3($74570f29af5dbce2$var$global$7.postMessage) && !$74570f29af5dbce2$var$global$7.importScripts && $74570f29af5dbce2$var$location && $74570f29af5dbce2$var$location.protocol !== "file:" && !$74570f29af5dbce2$var$fails$1($74570f29af5dbce2$var$post)) {
        $74570f29af5dbce2$var$defer = $74570f29af5dbce2$var$post;
        $74570f29af5dbce2$var$global$7.addEventListener("message", $74570f29af5dbce2$var$listener, false);
    // IE8-
    } else if ($74570f29af5dbce2$var$ONREADYSTATECHANGE in $74570f29af5dbce2$var$createElement("script")) $74570f29af5dbce2$var$defer = function defer(id) {
        $74570f29af5dbce2$var$html.appendChild($74570f29af5dbce2$var$createElement("script"))[$74570f29af5dbce2$var$ONREADYSTATECHANGE] = function() {
            $74570f29af5dbce2$var$html.removeChild(this);
            $74570f29af5dbce2$var$run(id);
        };
    };
    else $74570f29af5dbce2$var$defer = function defer(id) {
        setTimeout($74570f29af5dbce2$var$runner(id), 0);
    };
}
var $74570f29af5dbce2$var$task$1 = {
    set: $74570f29af5dbce2$var$set,
    clear: $74570f29af5dbce2$var$clear
};
var $74570f29af5dbce2$var$userAgent$1 = $74570f29af5dbce2$var$engineUserAgent;
var $74570f29af5dbce2$var$global$6 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($74570f29af5dbce2$var$userAgent$1) && $74570f29af5dbce2$var$global$6.Pebble !== undefined;
var $74570f29af5dbce2$var$userAgent = $74570f29af5dbce2$var$engineUserAgent;
var $74570f29af5dbce2$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($74570f29af5dbce2$var$userAgent);
var $74570f29af5dbce2$var$global$5 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$bind$2 = $74570f29af5dbce2$var$functionBindContext;
var $74570f29af5dbce2$var$getOwnPropertyDescriptor = $74570f29af5dbce2$var$objectGetOwnPropertyDescriptor.f;
var $74570f29af5dbce2$var$macrotask = $74570f29af5dbce2$var$task$1.set;
var $74570f29af5dbce2$var$IS_IOS = $74570f29af5dbce2$var$engineIsIos;
var $74570f29af5dbce2$var$IS_IOS_PEBBLE = $74570f29af5dbce2$var$engineIsIosPebble;
var $74570f29af5dbce2$var$IS_WEBOS_WEBKIT = $74570f29af5dbce2$var$engineIsWebosWebkit;
var $74570f29af5dbce2$var$IS_NODE$1 = $74570f29af5dbce2$var$engineIsNode;
var $74570f29af5dbce2$var$MutationObserver = $74570f29af5dbce2$var$global$5.MutationObserver || $74570f29af5dbce2$var$global$5.WebKitMutationObserver;
var $74570f29af5dbce2$var$document$2 = $74570f29af5dbce2$var$global$5.document;
var $74570f29af5dbce2$var$process$1 = $74570f29af5dbce2$var$global$5.process;
var $74570f29af5dbce2$var$Promise$1 = $74570f29af5dbce2$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $74570f29af5dbce2$var$queueMicrotaskDescriptor = $74570f29af5dbce2$var$getOwnPropertyDescriptor($74570f29af5dbce2$var$global$5, "queueMicrotask");
var $74570f29af5dbce2$var$queueMicrotask = $74570f29af5dbce2$var$queueMicrotaskDescriptor && $74570f29af5dbce2$var$queueMicrotaskDescriptor.value;
var $74570f29af5dbce2$var$flush, $74570f29af5dbce2$var$head, $74570f29af5dbce2$var$last, $74570f29af5dbce2$var$notify$1, $74570f29af5dbce2$var$toggle, $74570f29af5dbce2$var$node, $74570f29af5dbce2$var$promise, $74570f29af5dbce2$var$then;
// modern engines have queueMicrotask method
if (!$74570f29af5dbce2$var$queueMicrotask) {
    $74570f29af5dbce2$var$flush = function flush() {
        var parent, fn;
        if ($74570f29af5dbce2$var$IS_NODE$1 && (parent = $74570f29af5dbce2$var$process$1.domain)) parent.exit();
        while($74570f29af5dbce2$var$head){
            fn = $74570f29af5dbce2$var$head.fn;
            $74570f29af5dbce2$var$head = $74570f29af5dbce2$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($74570f29af5dbce2$var$head) $74570f29af5dbce2$var$notify$1();
                else $74570f29af5dbce2$var$last = undefined;
                throw error;
            }
        }
        $74570f29af5dbce2$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$74570f29af5dbce2$var$IS_IOS && !$74570f29af5dbce2$var$IS_NODE$1 && !$74570f29af5dbce2$var$IS_WEBOS_WEBKIT && $74570f29af5dbce2$var$MutationObserver && $74570f29af5dbce2$var$document$2) {
        $74570f29af5dbce2$var$toggle = true;
        $74570f29af5dbce2$var$node = $74570f29af5dbce2$var$document$2.createTextNode("");
        new $74570f29af5dbce2$var$MutationObserver($74570f29af5dbce2$var$flush).observe($74570f29af5dbce2$var$node, {
            characterData: true
        });
        $74570f29af5dbce2$var$notify$1 = function notify$1() {
            $74570f29af5dbce2$var$node.data = $74570f29af5dbce2$var$toggle = !$74570f29af5dbce2$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$74570f29af5dbce2$var$IS_IOS_PEBBLE && $74570f29af5dbce2$var$Promise$1 && $74570f29af5dbce2$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $74570f29af5dbce2$var$promise = $74570f29af5dbce2$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $74570f29af5dbce2$var$promise.constructor = $74570f29af5dbce2$var$Promise$1;
        $74570f29af5dbce2$var$then = $74570f29af5dbce2$var$bind$2($74570f29af5dbce2$var$promise.then, $74570f29af5dbce2$var$promise);
        $74570f29af5dbce2$var$notify$1 = function notify$1() {
            $74570f29af5dbce2$var$then($74570f29af5dbce2$var$flush);
        };
    // Node.js without promises
    } else if ($74570f29af5dbce2$var$IS_NODE$1) $74570f29af5dbce2$var$notify$1 = function notify$1() {
        $74570f29af5dbce2$var$process$1.nextTick($74570f29af5dbce2$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $74570f29af5dbce2$var$macrotask = $74570f29af5dbce2$var$bind$2($74570f29af5dbce2$var$macrotask, $74570f29af5dbce2$var$global$5);
        $74570f29af5dbce2$var$notify$1 = function notify$1() {
            $74570f29af5dbce2$var$macrotask($74570f29af5dbce2$var$flush);
        };
    }
}
var $74570f29af5dbce2$var$microtask$1 = $74570f29af5dbce2$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($74570f29af5dbce2$var$last) $74570f29af5dbce2$var$last.next = task;
    if (!$74570f29af5dbce2$var$head) {
        $74570f29af5dbce2$var$head = task;
        $74570f29af5dbce2$var$notify$1();
    }
    $74570f29af5dbce2$var$last = task;
};
var $74570f29af5dbce2$var$global$4 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$hostReportErrors$1 = function hostReportErrors$1(a, b) {
    var console = $74570f29af5dbce2$var$global$4.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $74570f29af5dbce2$var$perform$3 = function perform$3(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $74570f29af5dbce2$var$Queue$1 = function Queue$1() {
    this.head = null;
    this.tail = null;
};
$74570f29af5dbce2$var$Queue$1.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $74570f29af5dbce2$var$queue = $74570f29af5dbce2$var$Queue$1;
var $74570f29af5dbce2$var$global$3 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$promiseNativeConstructor = $74570f29af5dbce2$var$global$3.Promise;
var $74570f29af5dbce2$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $74570f29af5dbce2$var$global$2 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$NativePromiseConstructor$3 = $74570f29af5dbce2$var$promiseNativeConstructor;
var $74570f29af5dbce2$var$isCallable$2 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$isForced = $74570f29af5dbce2$var$isForced_1;
var $74570f29af5dbce2$var$inspectSource = $74570f29af5dbce2$var$inspectSource$4;
var $74570f29af5dbce2$var$wellKnownSymbol$3 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$IS_BROWSER = $74570f29af5dbce2$var$engineIsBrowser;
var $74570f29af5dbce2$var$V8_VERSION = $74570f29af5dbce2$var$engineV8Version;
$74570f29af5dbce2$var$NativePromiseConstructor$3 && $74570f29af5dbce2$var$NativePromiseConstructor$3.prototype;
var $74570f29af5dbce2$var$SPECIES = $74570f29af5dbce2$var$wellKnownSymbol$3("species");
var $74570f29af5dbce2$var$SUBCLASSING = false;
var $74570f29af5dbce2$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $74570f29af5dbce2$var$isCallable$2($74570f29af5dbce2$var$global$2.PromiseRejectionEvent);
var $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$5 = $74570f29af5dbce2$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $74570f29af5dbce2$var$inspectSource($74570f29af5dbce2$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($74570f29af5dbce2$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $74570f29af5dbce2$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($74570f29af5dbce2$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $74570f29af5dbce2$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function FakePromise(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$74570f29af5dbce2$var$SPECIES] = FakePromise;
    $74570f29af5dbce2$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$74570f29af5dbce2$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $74570f29af5dbce2$var$IS_BROWSER && !$74570f29af5dbce2$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $74570f29af5dbce2$var$promiseConstructorDetection = {
    CONSTRUCTOR: $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $74570f29af5dbce2$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $74570f29af5dbce2$var$SUBCLASSING
};
var $74570f29af5dbce2$var$newPromiseCapability$2 = {};
var $74570f29af5dbce2$var$aCallable$4 = $74570f29af5dbce2$var$aCallable$7;
var $74570f29af5dbce2$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $74570f29af5dbce2$var$aCallable$4(resolve);
    this.reject = $74570f29af5dbce2$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$74570f29af5dbce2$var$newPromiseCapability$2.f = function(C) {
    return new $74570f29af5dbce2$var$PromiseCapability(C);
};
var $74570f29af5dbce2$var$$$5 = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$IS_NODE = $74570f29af5dbce2$var$engineIsNode;
var $74570f29af5dbce2$var$global$1 = $74570f29af5dbce2$var$global$j;
var $74570f29af5dbce2$var$call$7 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$defineBuiltIn$2 = $74570f29af5dbce2$var$defineBuiltIn$6;
var $74570f29af5dbce2$var$setPrototypeOf = $74570f29af5dbce2$var$objectSetPrototypeOf;
var $74570f29af5dbce2$var$setToStringTag = $74570f29af5dbce2$var$setToStringTag$3;
var $74570f29af5dbce2$var$setSpecies = $74570f29af5dbce2$var$setSpecies$1;
var $74570f29af5dbce2$var$aCallable$3 = $74570f29af5dbce2$var$aCallable$7;
var $74570f29af5dbce2$var$isCallable$1 = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$isObject$1 = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$anInstance = $74570f29af5dbce2$var$anInstance$1;
var $74570f29af5dbce2$var$speciesConstructor = $74570f29af5dbce2$var$speciesConstructor$1;
var $74570f29af5dbce2$var$task = $74570f29af5dbce2$var$task$1.set;
var $74570f29af5dbce2$var$microtask = $74570f29af5dbce2$var$microtask$1;
var $74570f29af5dbce2$var$hostReportErrors = $74570f29af5dbce2$var$hostReportErrors$1;
var $74570f29af5dbce2$var$perform$2 = $74570f29af5dbce2$var$perform$3;
var $74570f29af5dbce2$var$Queue = $74570f29af5dbce2$var$queue;
var $74570f29af5dbce2$var$InternalStateModule = $74570f29af5dbce2$var$internalState;
var $74570f29af5dbce2$var$NativePromiseConstructor$2 = $74570f29af5dbce2$var$promiseNativeConstructor;
var $74570f29af5dbce2$var$PromiseConstructorDetection = $74570f29af5dbce2$var$promiseConstructorDetection;
var $74570f29af5dbce2$var$newPromiseCapabilityModule$3 = $74570f29af5dbce2$var$newPromiseCapability$2;
var $74570f29af5dbce2$var$PROMISE = "Promise";
var $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$4 = $74570f29af5dbce2$var$PromiseConstructorDetection.CONSTRUCTOR;
var $74570f29af5dbce2$var$NATIVE_PROMISE_REJECTION_EVENT = $74570f29af5dbce2$var$PromiseConstructorDetection.REJECTION_EVENT;
var $74570f29af5dbce2$var$NATIVE_PROMISE_SUBCLASSING = $74570f29af5dbce2$var$PromiseConstructorDetection.SUBCLASSING;
var $74570f29af5dbce2$var$getInternalPromiseState = $74570f29af5dbce2$var$InternalStateModule.getterFor($74570f29af5dbce2$var$PROMISE);
var $74570f29af5dbce2$var$setInternalState = $74570f29af5dbce2$var$InternalStateModule.set;
var $74570f29af5dbce2$var$NativePromisePrototype$1 = $74570f29af5dbce2$var$NativePromiseConstructor$2 && $74570f29af5dbce2$var$NativePromiseConstructor$2.prototype;
var $74570f29af5dbce2$var$PromiseConstructor = $74570f29af5dbce2$var$NativePromiseConstructor$2;
var $74570f29af5dbce2$var$PromisePrototype = $74570f29af5dbce2$var$NativePromisePrototype$1;
var $74570f29af5dbce2$var$TypeError$1 = $74570f29af5dbce2$var$global$1.TypeError;
var $74570f29af5dbce2$var$document$1 = $74570f29af5dbce2$var$global$1.document;
var $74570f29af5dbce2$var$process = $74570f29af5dbce2$var$global$1.process;
var $74570f29af5dbce2$var$newPromiseCapability$1 = $74570f29af5dbce2$var$newPromiseCapabilityModule$3.f;
var $74570f29af5dbce2$var$newGenericPromiseCapability = $74570f29af5dbce2$var$newPromiseCapability$1;
var $74570f29af5dbce2$var$DISPATCH_EVENT = !!($74570f29af5dbce2$var$document$1 && $74570f29af5dbce2$var$document$1.createEvent && $74570f29af5dbce2$var$global$1.dispatchEvent);
var $74570f29af5dbce2$var$UNHANDLED_REJECTION = "unhandledrejection";
var $74570f29af5dbce2$var$REJECTION_HANDLED = "rejectionhandled";
var $74570f29af5dbce2$var$PENDING = 0;
var $74570f29af5dbce2$var$FULFILLED = 1;
var $74570f29af5dbce2$var$REJECTED = 2;
var $74570f29af5dbce2$var$HANDLED = 1;
var $74570f29af5dbce2$var$UNHANDLED = 2;
var $74570f29af5dbce2$var$Internal, $74570f29af5dbce2$var$OwnPromiseCapability, $74570f29af5dbce2$var$PromiseWrapper, $74570f29af5dbce2$var$nativeThen;
// helpers
var $74570f29af5dbce2$var$isThenable = function isThenable(it) {
    var then;
    return $74570f29af5dbce2$var$isObject$1(it) && $74570f29af5dbce2$var$isCallable$1(then = it.then) ? then : false;
};
var $74570f29af5dbce2$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state == $74570f29af5dbce2$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $74570f29af5dbce2$var$UNHANDLED) $74570f29af5dbce2$var$onHandleUnhandled(state);
                state.rejection = $74570f29af5dbce2$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($74570f29af5dbce2$var$TypeError$1("Promise-chain cycle"));
            else if (then = $74570f29af5dbce2$var$isThenable(result)) $74570f29af5dbce2$var$call$7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $74570f29af5dbce2$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $74570f29af5dbce2$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$74570f29af5dbce2$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $74570f29af5dbce2$var$onUnhandled(state);
    });
};
var $74570f29af5dbce2$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($74570f29af5dbce2$var$DISPATCH_EVENT) {
        event = $74570f29af5dbce2$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $74570f29af5dbce2$var$global$1.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$74570f29af5dbce2$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $74570f29af5dbce2$var$global$1["on" + name])) handler(event);
    else if (name === $74570f29af5dbce2$var$UNHANDLED_REJECTION) $74570f29af5dbce2$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $74570f29af5dbce2$var$onUnhandled = function onUnhandled(state) {
    $74570f29af5dbce2$var$call$7($74570f29af5dbce2$var$task, $74570f29af5dbce2$var$global$1, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $74570f29af5dbce2$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $74570f29af5dbce2$var$perform$2(function() {
                if ($74570f29af5dbce2$var$IS_NODE) $74570f29af5dbce2$var$process.emit("unhandledRejection", value, promise);
                else $74570f29af5dbce2$var$dispatchEvent($74570f29af5dbce2$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $74570f29af5dbce2$var$IS_NODE || $74570f29af5dbce2$var$isUnhandled(state) ? $74570f29af5dbce2$var$UNHANDLED : $74570f29af5dbce2$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $74570f29af5dbce2$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $74570f29af5dbce2$var$HANDLED && !state.parent;
};
var $74570f29af5dbce2$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $74570f29af5dbce2$var$call$7($74570f29af5dbce2$var$task, $74570f29af5dbce2$var$global$1, function() {
        var promise = state.facade;
        if ($74570f29af5dbce2$var$IS_NODE) $74570f29af5dbce2$var$process.emit("rejectionHandled", promise);
        else $74570f29af5dbce2$var$dispatchEvent($74570f29af5dbce2$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $74570f29af5dbce2$var$bind$1 = function bind$1(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $74570f29af5dbce2$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $74570f29af5dbce2$var$REJECTED;
    $74570f29af5dbce2$var$notify(state, true);
};
var $74570f29af5dbce2$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $74570f29af5dbce2$var$TypeError$1("Promise can't be resolved itself");
        var then = $74570f29af5dbce2$var$isThenable(value);
        if (then) $74570f29af5dbce2$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $74570f29af5dbce2$var$call$7(then, value, $74570f29af5dbce2$var$bind$1($74570f29af5dbce2$var$internalResolve, wrapper, state), $74570f29af5dbce2$var$bind$1($74570f29af5dbce2$var$internalReject, wrapper, state));
            } catch (error) {
                $74570f29af5dbce2$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $74570f29af5dbce2$var$FULFILLED;
            $74570f29af5dbce2$var$notify(state, false);
        }
    } catch (error) {
        $74570f29af5dbce2$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $74570f29af5dbce2$var$PromiseConstructor = function Promise1(executor) {
        $74570f29af5dbce2$var$anInstance(this, $74570f29af5dbce2$var$PromisePrototype);
        $74570f29af5dbce2$var$aCallable$3(executor);
        $74570f29af5dbce2$var$call$7($74570f29af5dbce2$var$Internal, this);
        var state = $74570f29af5dbce2$var$getInternalPromiseState(this);
        try {
            executor($74570f29af5dbce2$var$bind$1($74570f29af5dbce2$var$internalResolve, state), $74570f29af5dbce2$var$bind$1($74570f29af5dbce2$var$internalReject, state));
        } catch (error) {
            $74570f29af5dbce2$var$internalReject(state, error);
        }
    };
    $74570f29af5dbce2$var$PromisePrototype = $74570f29af5dbce2$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $74570f29af5dbce2$var$Internal = function Promise1(executor) {
        $74570f29af5dbce2$var$setInternalState(this, {
            type: $74570f29af5dbce2$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $74570f29af5dbce2$var$Queue(),
            rejection: false,
            state: $74570f29af5dbce2$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $74570f29af5dbce2$var$Internal.prototype = $74570f29af5dbce2$var$defineBuiltIn$2($74570f29af5dbce2$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $74570f29af5dbce2$var$getInternalPromiseState(this);
        var reaction = $74570f29af5dbce2$var$newPromiseCapability$1($74570f29af5dbce2$var$speciesConstructor(this, $74570f29af5dbce2$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $74570f29af5dbce2$var$isCallable$1(onFulfilled) ? onFulfilled : true;
        reaction.fail = $74570f29af5dbce2$var$isCallable$1(onRejected) && onRejected;
        reaction.domain = $74570f29af5dbce2$var$IS_NODE ? $74570f29af5dbce2$var$process.domain : undefined;
        if (state.state == $74570f29af5dbce2$var$PENDING) state.reactions.add(reaction);
        else $74570f29af5dbce2$var$microtask(function() {
            $74570f29af5dbce2$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $74570f29af5dbce2$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $74570f29af5dbce2$var$Internal();
        var state = $74570f29af5dbce2$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $74570f29af5dbce2$var$bind$1($74570f29af5dbce2$var$internalResolve, state);
        this.reject = $74570f29af5dbce2$var$bind$1($74570f29af5dbce2$var$internalReject, state);
    };
    $74570f29af5dbce2$var$newPromiseCapabilityModule$3.f = $74570f29af5dbce2$var$newPromiseCapability$1 = function newPromiseCapability$1(C) {
        return C === $74570f29af5dbce2$var$PromiseConstructor || C === $74570f29af5dbce2$var$PromiseWrapper ? new $74570f29af5dbce2$var$OwnPromiseCapability(C) : $74570f29af5dbce2$var$newGenericPromiseCapability(C);
    };
    if ($74570f29af5dbce2$var$isCallable$1($74570f29af5dbce2$var$NativePromiseConstructor$2) && $74570f29af5dbce2$var$NativePromisePrototype$1 !== Object.prototype) {
        $74570f29af5dbce2$var$nativeThen = $74570f29af5dbce2$var$NativePromisePrototype$1.then;
        if (!$74570f29af5dbce2$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $74570f29af5dbce2$var$defineBuiltIn$2($74570f29af5dbce2$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $74570f29af5dbce2$var$PromiseConstructor(function(resolve, reject) {
                $74570f29af5dbce2$var$call$7($74570f29af5dbce2$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $74570f29af5dbce2$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($74570f29af5dbce2$var$setPrototypeOf) $74570f29af5dbce2$var$setPrototypeOf($74570f29af5dbce2$var$NativePromisePrototype$1, $74570f29af5dbce2$var$PromisePrototype);
    }
}
$74570f29af5dbce2$var$$$5({
    global: true,
    constructor: true,
    wrap: true,
    forced: $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $74570f29af5dbce2$var$PromiseConstructor
});
$74570f29af5dbce2$var$setToStringTag($74570f29af5dbce2$var$PromiseConstructor, $74570f29af5dbce2$var$PROMISE, false);
$74570f29af5dbce2$var$setSpecies($74570f29af5dbce2$var$PROMISE);
var $74570f29af5dbce2$var$wellKnownSymbol$2 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$Iterators$1 = $74570f29af5dbce2$var$iterators;
var $74570f29af5dbce2$var$ITERATOR$2 = $74570f29af5dbce2$var$wellKnownSymbol$2("iterator");
var $74570f29af5dbce2$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $74570f29af5dbce2$var$isArrayIteratorMethod$1 = function isArrayIteratorMethod$1(it) {
    return it !== undefined && ($74570f29af5dbce2$var$Iterators$1.Array === it || $74570f29af5dbce2$var$ArrayPrototype[$74570f29af5dbce2$var$ITERATOR$2] === it);
};
var $74570f29af5dbce2$var$classof$1 = $74570f29af5dbce2$var$classof$3;
var $74570f29af5dbce2$var$getMethod$1 = $74570f29af5dbce2$var$getMethod$3;
var $74570f29af5dbce2$var$Iterators = $74570f29af5dbce2$var$iterators;
var $74570f29af5dbce2$var$wellKnownSymbol$1 = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$ITERATOR$1 = $74570f29af5dbce2$var$wellKnownSymbol$1("iterator");
var $74570f29af5dbce2$var$getIteratorMethod$2 = function getIteratorMethod$2(it) {
    if (it != undefined) return $74570f29af5dbce2$var$getMethod$1(it, $74570f29af5dbce2$var$ITERATOR$1) || $74570f29af5dbce2$var$getMethod$1(it, "@@iterator") || $74570f29af5dbce2$var$Iterators[$74570f29af5dbce2$var$classof$1(it)];
};
var $74570f29af5dbce2$var$call$6 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$aCallable$2 = $74570f29af5dbce2$var$aCallable$7;
var $74570f29af5dbce2$var$anObject$5 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$tryToString$1 = $74570f29af5dbce2$var$tryToString$4;
var $74570f29af5dbce2$var$getIteratorMethod$1 = $74570f29af5dbce2$var$getIteratorMethod$2;
var $74570f29af5dbce2$var$$TypeError$1 = TypeError;
var $74570f29af5dbce2$var$getIterator$1 = function getIterator$1(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $74570f29af5dbce2$var$getIteratorMethod$1(argument) : usingIterator;
    if ($74570f29af5dbce2$var$aCallable$2(iteratorMethod)) return $74570f29af5dbce2$var$anObject$5($74570f29af5dbce2$var$call$6(iteratorMethod, argument));
    throw $74570f29af5dbce2$var$$TypeError$1($74570f29af5dbce2$var$tryToString$1(argument) + " is not iterable");
};
var $74570f29af5dbce2$var$call$5 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$anObject$4 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$getMethod = $74570f29af5dbce2$var$getMethod$3;
var $74570f29af5dbce2$var$iteratorClose$1 = function iteratorClose$1(iterator, kind, value) {
    var innerResult, innerError;
    $74570f29af5dbce2$var$anObject$4(iterator);
    try {
        innerResult = $74570f29af5dbce2$var$getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $74570f29af5dbce2$var$call$5(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $74570f29af5dbce2$var$anObject$4(innerResult);
    return value;
};
var $74570f29af5dbce2$var$bind = $74570f29af5dbce2$var$functionBindContext;
var $74570f29af5dbce2$var$call$4 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$anObject$3 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$tryToString = $74570f29af5dbce2$var$tryToString$4;
var $74570f29af5dbce2$var$isArrayIteratorMethod = $74570f29af5dbce2$var$isArrayIteratorMethod$1;
var $74570f29af5dbce2$var$lengthOfArrayLike = $74570f29af5dbce2$var$lengthOfArrayLike$2;
var $74570f29af5dbce2$var$isPrototypeOf$1 = $74570f29af5dbce2$var$objectIsPrototypeOf;
var $74570f29af5dbce2$var$getIterator = $74570f29af5dbce2$var$getIterator$1;
var $74570f29af5dbce2$var$getIteratorMethod = $74570f29af5dbce2$var$getIteratorMethod$2;
var $74570f29af5dbce2$var$iteratorClose = $74570f29af5dbce2$var$iteratorClose$1;
var $74570f29af5dbce2$var$$TypeError = TypeError;
var $74570f29af5dbce2$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $74570f29af5dbce2$var$ResultPrototype = $74570f29af5dbce2$var$Result.prototype;
var $74570f29af5dbce2$var$iterate$2 = function iterate$2(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $74570f29af5dbce2$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $74570f29af5dbce2$var$iteratorClose(iterator, "normal", condition);
        return new $74570f29af5dbce2$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $74570f29af5dbce2$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $74570f29af5dbce2$var$getIteratorMethod(iterable);
        if (!iterFn) throw $74570f29af5dbce2$var$$TypeError($74570f29af5dbce2$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($74570f29af5dbce2$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $74570f29af5dbce2$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $74570f29af5dbce2$var$isPrototypeOf$1($74570f29af5dbce2$var$ResultPrototype, result)) return result;
            }
            return new $74570f29af5dbce2$var$Result(false);
        }
        iterator = $74570f29af5dbce2$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $74570f29af5dbce2$var$call$4(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $74570f29af5dbce2$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $74570f29af5dbce2$var$isPrototypeOf$1($74570f29af5dbce2$var$ResultPrototype, result)) return result;
    }
    return new $74570f29af5dbce2$var$Result(false);
};
var $74570f29af5dbce2$var$wellKnownSymbol = $74570f29af5dbce2$var$wellKnownSymbol$e;
var $74570f29af5dbce2$var$ITERATOR = $74570f29af5dbce2$var$wellKnownSymbol("iterator");
var $74570f29af5dbce2$var$SAFE_CLOSING = false;
try {
    var $74570f29af5dbce2$var$called = 0;
    var $74570f29af5dbce2$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$74570f29af5dbce2$var$called++
            };
        },
        "return": function() {
            $74570f29af5dbce2$var$SAFE_CLOSING = true;
        }
    };
    $74570f29af5dbce2$var$iteratorWithReturn[$74570f29af5dbce2$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($74570f29af5dbce2$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $74570f29af5dbce2$var$checkCorrectnessOfIteration$1 = function checkCorrectnessOfIteration$1(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$74570f29af5dbce2$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$74570f29af5dbce2$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $74570f29af5dbce2$var$NativePromiseConstructor$1 = $74570f29af5dbce2$var$promiseNativeConstructor;
var $74570f29af5dbce2$var$checkCorrectnessOfIteration = $74570f29af5dbce2$var$checkCorrectnessOfIteration$1;
var $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$3 = $74570f29af5dbce2$var$promiseConstructorDetection.CONSTRUCTOR;
var $74570f29af5dbce2$var$promiseStaticsIncorrectIteration = $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$74570f29af5dbce2$var$checkCorrectnessOfIteration(function(iterable) {
    $74570f29af5dbce2$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $74570f29af5dbce2$var$$$4 = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$call$3 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$aCallable$1 = $74570f29af5dbce2$var$aCallable$7;
var $74570f29af5dbce2$var$newPromiseCapabilityModule$2 = $74570f29af5dbce2$var$newPromiseCapability$2;
var $74570f29af5dbce2$var$perform$1 = $74570f29af5dbce2$var$perform$3;
var $74570f29af5dbce2$var$iterate$1 = $74570f29af5dbce2$var$iterate$2;
var $74570f29af5dbce2$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $74570f29af5dbce2$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$74570f29af5dbce2$var$$$4({
    target: "Promise",
    stat: true,
    forced: $74570f29af5dbce2$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $74570f29af5dbce2$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $74570f29af5dbce2$var$perform$1(function() {
            var $promiseResolve = $74570f29af5dbce2$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $74570f29af5dbce2$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $74570f29af5dbce2$var$call$3($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $74570f29af5dbce2$var$$$3 = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$2 = $74570f29af5dbce2$var$promiseConstructorDetection.CONSTRUCTOR;
var $74570f29af5dbce2$var$NativePromiseConstructor = $74570f29af5dbce2$var$promiseNativeConstructor;
var $74570f29af5dbce2$var$getBuiltIn$1 = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$isCallable = $74570f29af5dbce2$var$isCallable$k;
var $74570f29af5dbce2$var$defineBuiltIn$1 = $74570f29af5dbce2$var$defineBuiltIn$6;
var $74570f29af5dbce2$var$NativePromisePrototype = $74570f29af5dbce2$var$NativePromiseConstructor && $74570f29af5dbce2$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$74570f29af5dbce2$var$$$3({
    target: "Promise",
    proto: true,
    forced: $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($74570f29af5dbce2$var$isCallable($74570f29af5dbce2$var$NativePromiseConstructor)) {
    var $74570f29af5dbce2$var$method = $74570f29af5dbce2$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($74570f29af5dbce2$var$NativePromisePrototype["catch"] !== $74570f29af5dbce2$var$method) $74570f29af5dbce2$var$defineBuiltIn$1($74570f29af5dbce2$var$NativePromisePrototype, "catch", $74570f29af5dbce2$var$method, {
        unsafe: true
    });
}
var $74570f29af5dbce2$var$$$2 = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$call$2 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$aCallable = $74570f29af5dbce2$var$aCallable$7;
var $74570f29af5dbce2$var$newPromiseCapabilityModule$1 = $74570f29af5dbce2$var$newPromiseCapability$2;
var $74570f29af5dbce2$var$perform = $74570f29af5dbce2$var$perform$3;
var $74570f29af5dbce2$var$iterate = $74570f29af5dbce2$var$iterate$2;
var $74570f29af5dbce2$var$PROMISE_STATICS_INCORRECT_ITERATION = $74570f29af5dbce2$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$74570f29af5dbce2$var$$$2({
    target: "Promise",
    stat: true,
    forced: $74570f29af5dbce2$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $74570f29af5dbce2$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $74570f29af5dbce2$var$perform(function() {
            var $promiseResolve = $74570f29af5dbce2$var$aCallable(C.resolve);
            $74570f29af5dbce2$var$iterate(iterable, function(promise) {
                $74570f29af5dbce2$var$call$2($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $74570f29af5dbce2$var$$$1 = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$call$1 = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$newPromiseCapabilityModule = $74570f29af5dbce2$var$newPromiseCapability$2;
var $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$1 = $74570f29af5dbce2$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$74570f29af5dbce2$var$$$1({
    target: "Promise",
    stat: true,
    forced: $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $74570f29af5dbce2$var$newPromiseCapabilityModule.f(this);
        $74570f29af5dbce2$var$call$1(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $74570f29af5dbce2$var$anObject$2 = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$isObject = $74570f29af5dbce2$var$isObject$7;
var $74570f29af5dbce2$var$newPromiseCapability = $74570f29af5dbce2$var$newPromiseCapability$2;
var $74570f29af5dbce2$var$promiseResolve$1 = function promiseResolve$1(C, x) {
    $74570f29af5dbce2$var$anObject$2(C);
    if ($74570f29af5dbce2$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $74570f29af5dbce2$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $74570f29af5dbce2$var$$ = $74570f29af5dbce2$var$_export;
var $74570f29af5dbce2$var$getBuiltIn = $74570f29af5dbce2$var$getBuiltIn$8;
var $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR = $74570f29af5dbce2$var$promiseConstructorDetection.CONSTRUCTOR;
var $74570f29af5dbce2$var$promiseResolve = $74570f29af5dbce2$var$promiseResolve$1;
$74570f29af5dbce2$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$74570f29af5dbce2$var$$({
    target: "Promise",
    stat: true,
    forced: $74570f29af5dbce2$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $74570f29af5dbce2$var$promiseResolve(this, x);
    }
});
var $74570f29af5dbce2$var$classof = $74570f29af5dbce2$var$classof$3;
var $74570f29af5dbce2$var$$String = String;
var $74570f29af5dbce2$var$toString = function toString(argument) {
    if ($74570f29af5dbce2$var$classof(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $74570f29af5dbce2$var$$String(argument);
};
var $74570f29af5dbce2$var$anObject$1 = $74570f29af5dbce2$var$anObject$c;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $74570f29af5dbce2$var$regexpFlags = function regexpFlags() {
    var that = $74570f29af5dbce2$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $74570f29af5dbce2$var$call = $74570f29af5dbce2$var$functionCall;
var $74570f29af5dbce2$var$hasOwn = $74570f29af5dbce2$var$hasOwnProperty_1;
var $74570f29af5dbce2$var$isPrototypeOf = $74570f29af5dbce2$var$objectIsPrototypeOf;
var $74570f29af5dbce2$var$regExpFlags = $74570f29af5dbce2$var$regexpFlags;
var $74570f29af5dbce2$var$RegExpPrototype$1 = RegExp.prototype;
var $74570f29af5dbce2$var$regexpGetFlags = function regexpGetFlags(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $74570f29af5dbce2$var$RegExpPrototype$1) && !$74570f29af5dbce2$var$hasOwn(R, "flags") && $74570f29af5dbce2$var$isPrototypeOf($74570f29af5dbce2$var$RegExpPrototype$1, R) ? $74570f29af5dbce2$var$call($74570f29af5dbce2$var$regExpFlags, R) : flags;
};
var $74570f29af5dbce2$var$PROPER_FUNCTION_NAME = $74570f29af5dbce2$var$functionName.PROPER;
var $74570f29af5dbce2$var$defineBuiltIn = $74570f29af5dbce2$var$defineBuiltIn$6;
var $74570f29af5dbce2$var$anObject = $74570f29af5dbce2$var$anObject$c;
var $74570f29af5dbce2$var$$toString = $74570f29af5dbce2$var$toString;
var $74570f29af5dbce2$var$fails = $74570f29af5dbce2$var$fails$d;
var $74570f29af5dbce2$var$getRegExpFlags = $74570f29af5dbce2$var$regexpGetFlags;
var $74570f29af5dbce2$var$TO_STRING = "toString";
var $74570f29af5dbce2$var$RegExpPrototype = RegExp.prototype;
var $74570f29af5dbce2$var$n$ToString = $74570f29af5dbce2$var$RegExpPrototype[$74570f29af5dbce2$var$TO_STRING];
var $74570f29af5dbce2$var$NOT_GENERIC = $74570f29af5dbce2$var$fails(function() {
    return $74570f29af5dbce2$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $74570f29af5dbce2$var$INCORRECT_NAME = $74570f29af5dbce2$var$PROPER_FUNCTION_NAME && $74570f29af5dbce2$var$n$ToString.name != $74570f29af5dbce2$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($74570f29af5dbce2$var$NOT_GENERIC || $74570f29af5dbce2$var$INCORRECT_NAME) $74570f29af5dbce2$var$defineBuiltIn(RegExp.prototype, $74570f29af5dbce2$var$TO_STRING, function toString() {
    var R = $74570f29af5dbce2$var$anObject(this);
    var pattern = $74570f29af5dbce2$var$$toString(R.source);
    var flags = $74570f29af5dbce2$var$$toString($74570f29af5dbce2$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $74570f29af5dbce2$var$__awaiter(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $74570f29af5dbce2$export$6a7fdf2f99a9cf08 = function(transactions, signer, network) {
    return $74570f29af5dbce2$var$__awaiter(void 0, void 0, void 0, function() {
        var provider, signedTransactions, i, publicKey, _ref, block, accessKey, actions, transaction, response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = new $c1be85fca55b560a$exports.providers.JsonRpcProvider({
                        url: network.nodeUrl
                    });
                    signedTransactions = [];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < transactions.length)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        signer.getPublicKey(transactions[i].signerId, network.networkId)
                    ];
                case 2:
                    publicKey = _state.sent();
                    return [
                        4,
                        Promise.all([
                            provider.block({
                                finality: "final"
                            }),
                            provider.query({
                                request_type: "view_access_key",
                                finality: "final",
                                account_id: transactions[i].signerId,
                                public_key: publicKey.toString()
                            })
                        ])
                    ];
                case 3:
                    _ref = (0, $8GFUW._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), block = _ref[0], accessKey = _ref[1];
                    actions = transactions[i].actions.map(function(action) {
                        return $74570f29af5dbce2$export$309c7a02b0b0bc62(action);
                    });
                    transaction = $c1be85fca55b560a$exports.transactions.createTransaction(transactions[i].signerId, $c1be85fca55b560a$exports.utils.PublicKey.from(publicKey.toString()), transactions[i].receiverId, accessKey.nonce + i + 1, actions, $c1be85fca55b560a$exports.utils.serialize.base_decode(block.header.hash));
                    return [
                        4,
                        $c1be85fca55b560a$exports.transactions.signTransaction(transaction, signer, transactions[i].signerId, network.networkId)
                    ];
                case 4:
                    response = _state.sent();
                    signedTransactions.push(response[1]);
                    _state.label = 5;
                case 5:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 6:
                    return [
                        2,
                        signedTransactions
                    ];
            }
        });
    });
};


var $113e8451bf5a2260$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $113e8451bf5a2260$var$check = function check(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $113e8451bf5a2260$var$global$m = // eslint-disable-next-line es-x/no-global-this -- safe
$113e8451bf5a2260$var$check(typeof globalThis == "object" && globalThis) || $113e8451bf5a2260$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$113e8451bf5a2260$var$check(typeof self == "object" && self) || $113e8451bf5a2260$var$check(typeof $113e8451bf5a2260$var$commonjsGlobal == "object" && $113e8451bf5a2260$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $113e8451bf5a2260$var$objectGetOwnPropertyDescriptor = {};
var $113e8451bf5a2260$var$fails$j = function fails$j(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $113e8451bf5a2260$var$fails$i = $113e8451bf5a2260$var$fails$j;
// Detect IE8's incomplete defineProperty implementation
var $113e8451bf5a2260$var$descriptors = !$113e8451bf5a2260$var$fails$i(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] != 7;
});
var $113e8451bf5a2260$var$fails$h = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$functionBindNative = !$113e8451bf5a2260$var$fails$h(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $113e8451bf5a2260$var$NATIVE_BIND$3 = $113e8451bf5a2260$var$functionBindNative;
var $113e8451bf5a2260$var$call$i = Function.prototype.call;
var $113e8451bf5a2260$var$functionCall = $113e8451bf5a2260$var$NATIVE_BIND$3 ? $113e8451bf5a2260$var$call$i.bind($113e8451bf5a2260$var$call$i) : function functionCall() {
    return $113e8451bf5a2260$var$call$i.apply($113e8451bf5a2260$var$call$i, arguments);
};
var $113e8451bf5a2260$var$objectPropertyIsEnumerable = {};
var $113e8451bf5a2260$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $113e8451bf5a2260$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $113e8451bf5a2260$var$NASHORN_BUG = $113e8451bf5a2260$var$getOwnPropertyDescriptor$2 && !$113e8451bf5a2260$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$113e8451bf5a2260$var$objectPropertyIsEnumerable.f = $113e8451bf5a2260$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $113e8451bf5a2260$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $113e8451bf5a2260$var$$propertyIsEnumerable;
var $113e8451bf5a2260$var$createPropertyDescriptor$3 = function createPropertyDescriptor$3(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $113e8451bf5a2260$var$NATIVE_BIND$2 = $113e8451bf5a2260$var$functionBindNative;
var $113e8451bf5a2260$var$FunctionPrototype$2 = Function.prototype;
var $113e8451bf5a2260$var$bind$5 = $113e8451bf5a2260$var$FunctionPrototype$2.bind;
var $113e8451bf5a2260$var$call$h = $113e8451bf5a2260$var$FunctionPrototype$2.call;
var $113e8451bf5a2260$var$uncurryThis$j = $113e8451bf5a2260$var$NATIVE_BIND$2 && $113e8451bf5a2260$var$bind$5.bind($113e8451bf5a2260$var$call$h, $113e8451bf5a2260$var$call$h);
var $113e8451bf5a2260$var$functionUncurryThis = $113e8451bf5a2260$var$NATIVE_BIND$2 ? function functionUncurryThis(fn) {
    return fn && $113e8451bf5a2260$var$uncurryThis$j(fn);
} : function(fn) {
    return fn && function() {
        return $113e8451bf5a2260$var$call$h.apply(fn, arguments);
    };
};
var $113e8451bf5a2260$var$uncurryThis$i = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$toString$5 = $113e8451bf5a2260$var$uncurryThis$i({}.toString);
var $113e8451bf5a2260$var$stringSlice$4 = $113e8451bf5a2260$var$uncurryThis$i("".slice);
var $113e8451bf5a2260$var$classofRaw$1 = function classofRaw$1(it) {
    return $113e8451bf5a2260$var$stringSlice$4($113e8451bf5a2260$var$toString$5(it), 8, -1);
};
var $113e8451bf5a2260$var$uncurryThis$h = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$fails$g = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$classof$6 = $113e8451bf5a2260$var$classofRaw$1;
var $113e8451bf5a2260$var$$Object$4 = Object;
var $113e8451bf5a2260$var$split = $113e8451bf5a2260$var$uncurryThis$h("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $113e8451bf5a2260$var$indexedObject = $113e8451bf5a2260$var$fails$g(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$113e8451bf5a2260$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function indexedObject(it) {
    return $113e8451bf5a2260$var$classof$6(it) == "String" ? $113e8451bf5a2260$var$split(it, "") : $113e8451bf5a2260$var$$Object$4(it);
} : $113e8451bf5a2260$var$$Object$4;
var $113e8451bf5a2260$var$$TypeError$c = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $113e8451bf5a2260$var$requireObjectCoercible$4 = function requireObjectCoercible$4(it) {
    if (it == undefined) throw $113e8451bf5a2260$var$$TypeError$c("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $113e8451bf5a2260$var$IndexedObject$1 = $113e8451bf5a2260$var$indexedObject;
var $113e8451bf5a2260$var$requireObjectCoercible$3 = $113e8451bf5a2260$var$requireObjectCoercible$4;
var $113e8451bf5a2260$var$toIndexedObject$5 = function toIndexedObject$5(it) {
    return $113e8451bf5a2260$var$IndexedObject$1($113e8451bf5a2260$var$requireObjectCoercible$3(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $113e8451bf5a2260$var$isCallable$m = function isCallable$m(argument) {
    return typeof argument == "function";
};
var $113e8451bf5a2260$var$isCallable$l = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$isObject$7 = function isObject$7(it) {
    return typeof it == "object" ? it !== null : $113e8451bf5a2260$var$isCallable$l(it);
};
var $113e8451bf5a2260$var$global$l = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$isCallable$k = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$aFunction = function aFunction(argument) {
    return $113e8451bf5a2260$var$isCallable$k(argument) ? argument : undefined;
};
var $113e8451bf5a2260$var$getBuiltIn$8 = function getBuiltIn$8(namespace, method) {
    return arguments.length < 2 ? $113e8451bf5a2260$var$aFunction($113e8451bf5a2260$var$global$l[namespace]) : $113e8451bf5a2260$var$global$l[namespace] && $113e8451bf5a2260$var$global$l[namespace][method];
};
var $113e8451bf5a2260$var$uncurryThis$g = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$objectIsPrototypeOf = $113e8451bf5a2260$var$uncurryThis$g({}.isPrototypeOf);
var $113e8451bf5a2260$var$getBuiltIn$7 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$engineUserAgent = $113e8451bf5a2260$var$getBuiltIn$7("navigator", "userAgent") || "";
var $113e8451bf5a2260$var$global$k = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$userAgent$3 = $113e8451bf5a2260$var$engineUserAgent;
var $113e8451bf5a2260$var$process$3 = $113e8451bf5a2260$var$global$k.process;
var $113e8451bf5a2260$var$Deno$1 = $113e8451bf5a2260$var$global$k.Deno;
var $113e8451bf5a2260$var$versions = $113e8451bf5a2260$var$process$3 && $113e8451bf5a2260$var$process$3.versions || $113e8451bf5a2260$var$Deno$1 && $113e8451bf5a2260$var$Deno$1.version;
var $113e8451bf5a2260$var$v8 = $113e8451bf5a2260$var$versions && $113e8451bf5a2260$var$versions.v8;
var $113e8451bf5a2260$var$match, $113e8451bf5a2260$var$version;
if ($113e8451bf5a2260$var$v8) {
    $113e8451bf5a2260$var$match = $113e8451bf5a2260$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $113e8451bf5a2260$var$version = $113e8451bf5a2260$var$match[0] > 0 && $113e8451bf5a2260$var$match[0] < 4 ? 1 : +($113e8451bf5a2260$var$match[0] + $113e8451bf5a2260$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$113e8451bf5a2260$var$version && $113e8451bf5a2260$var$userAgent$3) {
    $113e8451bf5a2260$var$match = $113e8451bf5a2260$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$113e8451bf5a2260$var$match || $113e8451bf5a2260$var$match[1] >= 74) {
        $113e8451bf5a2260$var$match = $113e8451bf5a2260$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($113e8451bf5a2260$var$match) $113e8451bf5a2260$var$version = +$113e8451bf5a2260$var$match[1];
    }
}
var $113e8451bf5a2260$var$engineV8Version = $113e8451bf5a2260$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $113e8451bf5a2260$var$V8_VERSION$1 = $113e8451bf5a2260$var$engineV8Version;
var $113e8451bf5a2260$var$fails$f = $113e8451bf5a2260$var$fails$j;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $113e8451bf5a2260$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$113e8451bf5a2260$var$fails$f(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $113e8451bf5a2260$var$V8_VERSION$1 && $113e8451bf5a2260$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $113e8451bf5a2260$var$NATIVE_SYMBOL$1 = $113e8451bf5a2260$var$nativeSymbol;
var $113e8451bf5a2260$var$useSymbolAsUid = $113e8451bf5a2260$var$NATIVE_SYMBOL$1 && !Symbol.sham && (0, $1ObTH._)(Symbol.iterator) == "symbol";
var $113e8451bf5a2260$var$getBuiltIn$6 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$isCallable$j = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$isPrototypeOf$3 = $113e8451bf5a2260$var$objectIsPrototypeOf;
var $113e8451bf5a2260$var$USE_SYMBOL_AS_UID$1 = $113e8451bf5a2260$var$useSymbolAsUid;
var $113e8451bf5a2260$var$$Object$3 = Object;
var $113e8451bf5a2260$var$isSymbol$2 = $113e8451bf5a2260$var$USE_SYMBOL_AS_UID$1 ? function isSymbol$2(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $1ObTH._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $113e8451bf5a2260$var$getBuiltIn$6("Symbol");
    return $113e8451bf5a2260$var$isCallable$j($Symbol) && $113e8451bf5a2260$var$isPrototypeOf$3($Symbol.prototype, $113e8451bf5a2260$var$$Object$3(it));
};
var $113e8451bf5a2260$var$$String$3 = String;
var $113e8451bf5a2260$var$tryToString$4 = function tryToString$4(argument) {
    try {
        return $113e8451bf5a2260$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $113e8451bf5a2260$var$isCallable$i = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$tryToString$3 = $113e8451bf5a2260$var$tryToString$4;
var $113e8451bf5a2260$var$$TypeError$b = TypeError;
// `Assert: IsCallable(argument) is true`
var $113e8451bf5a2260$var$aCallable$7 = function aCallable$7(argument) {
    if ($113e8451bf5a2260$var$isCallable$i(argument)) return argument;
    throw $113e8451bf5a2260$var$$TypeError$b($113e8451bf5a2260$var$tryToString$3(argument) + " is not a function");
};
var $113e8451bf5a2260$var$aCallable$6 = $113e8451bf5a2260$var$aCallable$7;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $113e8451bf5a2260$var$getMethod$4 = function getMethod$4(V, P) {
    var func = V[P];
    return func == null ? undefined : $113e8451bf5a2260$var$aCallable$6(func);
};
var $113e8451bf5a2260$var$call$g = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$isCallable$h = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$isObject$6 = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$$TypeError$a = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $113e8451bf5a2260$var$ordinaryToPrimitive$1 = function ordinaryToPrimitive$1(input, pref) {
    var fn, val;
    if (pref === "string" && $113e8451bf5a2260$var$isCallable$h(fn = input.toString) && !$113e8451bf5a2260$var$isObject$6(val = $113e8451bf5a2260$var$call$g(fn, input))) return val;
    if ($113e8451bf5a2260$var$isCallable$h(fn = input.valueOf) && !$113e8451bf5a2260$var$isObject$6(val = $113e8451bf5a2260$var$call$g(fn, input))) return val;
    if (pref !== "string" && $113e8451bf5a2260$var$isCallable$h(fn = input.toString) && !$113e8451bf5a2260$var$isObject$6(val = $113e8451bf5a2260$var$call$g(fn, input))) return val;
    throw $113e8451bf5a2260$var$$TypeError$a("Can't convert object to primitive value");
};
var $113e8451bf5a2260$var$shared$4 = {
    exports: {}
};
var $113e8451bf5a2260$var$global$j = $113e8451bf5a2260$var$global$m;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $113e8451bf5a2260$var$defineProperty$5 = Object.defineProperty;
var $113e8451bf5a2260$var$defineGlobalProperty$3 = function defineGlobalProperty$3(key, value) {
    try {
        $113e8451bf5a2260$var$defineProperty$5($113e8451bf5a2260$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $113e8451bf5a2260$var$global$j[key] = value;
    }
    return value;
};
var $113e8451bf5a2260$var$global$i = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$defineGlobalProperty$2 = $113e8451bf5a2260$var$defineGlobalProperty$3;
var $113e8451bf5a2260$var$SHARED = "__core-js_shared__";
var $113e8451bf5a2260$var$store$3 = $113e8451bf5a2260$var$global$i[$113e8451bf5a2260$var$SHARED] || $113e8451bf5a2260$var$defineGlobalProperty$2($113e8451bf5a2260$var$SHARED, {});
var $113e8451bf5a2260$var$sharedStore = $113e8451bf5a2260$var$store$3;
var $113e8451bf5a2260$var$store$2 = $113e8451bf5a2260$var$sharedStore;
($113e8451bf5a2260$var$shared$4.exports = function(key, value) {
    return $113e8451bf5a2260$var$store$2[key] || ($113e8451bf5a2260$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $113e8451bf5a2260$var$requireObjectCoercible$2 = $113e8451bf5a2260$var$requireObjectCoercible$4;
var $113e8451bf5a2260$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $113e8451bf5a2260$var$toObject$4 = function toObject$4(argument) {
    return $113e8451bf5a2260$var$$Object$2($113e8451bf5a2260$var$requireObjectCoercible$2(argument));
};
var $113e8451bf5a2260$var$uncurryThis$f = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$toObject$3 = $113e8451bf5a2260$var$toObject$4;
var $113e8451bf5a2260$var$hasOwnProperty = $113e8451bf5a2260$var$uncurryThis$f({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $113e8451bf5a2260$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $113e8451bf5a2260$var$hasOwnProperty($113e8451bf5a2260$var$toObject$3(it), key);
};
var $113e8451bf5a2260$var$uncurryThis$e = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$id = 0;
var $113e8451bf5a2260$var$postfix = Math.random();
var $113e8451bf5a2260$var$toString$4 = $113e8451bf5a2260$var$uncurryThis$e(1.0.toString);
var $113e8451bf5a2260$var$uid$2 = function uid$2(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $113e8451bf5a2260$var$toString$4(++$113e8451bf5a2260$var$id + $113e8451bf5a2260$var$postfix, 36);
};
var $113e8451bf5a2260$var$global$h = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$shared$3 = $113e8451bf5a2260$var$shared$4.exports;
var $113e8451bf5a2260$var$hasOwn$a = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$uid$1 = $113e8451bf5a2260$var$uid$2;
var $113e8451bf5a2260$var$NATIVE_SYMBOL = $113e8451bf5a2260$var$nativeSymbol;
var $113e8451bf5a2260$var$USE_SYMBOL_AS_UID = $113e8451bf5a2260$var$useSymbolAsUid;
var $113e8451bf5a2260$var$WellKnownSymbolsStore = $113e8451bf5a2260$var$shared$3("wks");
var $113e8451bf5a2260$var$Symbol$1 = $113e8451bf5a2260$var$global$h.Symbol;
var $113e8451bf5a2260$var$symbolFor = $113e8451bf5a2260$var$Symbol$1 && $113e8451bf5a2260$var$Symbol$1["for"];
var $113e8451bf5a2260$var$createWellKnownSymbol = $113e8451bf5a2260$var$USE_SYMBOL_AS_UID ? $113e8451bf5a2260$var$Symbol$1 : $113e8451bf5a2260$var$Symbol$1 && $113e8451bf5a2260$var$Symbol$1.withoutSetter || $113e8451bf5a2260$var$uid$1;
var $113e8451bf5a2260$var$wellKnownSymbol$g = function wellKnownSymbol$g(name) {
    if (!$113e8451bf5a2260$var$hasOwn$a($113e8451bf5a2260$var$WellKnownSymbolsStore, name) || !($113e8451bf5a2260$var$NATIVE_SYMBOL || typeof $113e8451bf5a2260$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($113e8451bf5a2260$var$NATIVE_SYMBOL && $113e8451bf5a2260$var$hasOwn$a($113e8451bf5a2260$var$Symbol$1, name)) $113e8451bf5a2260$var$WellKnownSymbolsStore[name] = $113e8451bf5a2260$var$Symbol$1[name];
        else if ($113e8451bf5a2260$var$USE_SYMBOL_AS_UID && $113e8451bf5a2260$var$symbolFor) $113e8451bf5a2260$var$WellKnownSymbolsStore[name] = $113e8451bf5a2260$var$symbolFor(description);
        else $113e8451bf5a2260$var$WellKnownSymbolsStore[name] = $113e8451bf5a2260$var$createWellKnownSymbol(description);
    }
    return $113e8451bf5a2260$var$WellKnownSymbolsStore[name];
};
var $113e8451bf5a2260$var$call$f = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$isObject$5 = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$isSymbol$1 = $113e8451bf5a2260$var$isSymbol$2;
var $113e8451bf5a2260$var$getMethod$3 = $113e8451bf5a2260$var$getMethod$4;
var $113e8451bf5a2260$var$ordinaryToPrimitive = $113e8451bf5a2260$var$ordinaryToPrimitive$1;
var $113e8451bf5a2260$var$wellKnownSymbol$f = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$$TypeError$9 = TypeError;
var $113e8451bf5a2260$var$TO_PRIMITIVE = $113e8451bf5a2260$var$wellKnownSymbol$f("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $113e8451bf5a2260$var$toPrimitive$1 = function toPrimitive$1(input, pref) {
    if (!$113e8451bf5a2260$var$isObject$5(input) || $113e8451bf5a2260$var$isSymbol$1(input)) return input;
    var exoticToPrim = $113e8451bf5a2260$var$getMethod$3(input, $113e8451bf5a2260$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $113e8451bf5a2260$var$call$f(exoticToPrim, input, pref);
        if (!$113e8451bf5a2260$var$isObject$5(result) || $113e8451bf5a2260$var$isSymbol$1(result)) return result;
        throw $113e8451bf5a2260$var$$TypeError$9("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $113e8451bf5a2260$var$ordinaryToPrimitive(input, pref);
};
var $113e8451bf5a2260$var$toPrimitive = $113e8451bf5a2260$var$toPrimitive$1;
var $113e8451bf5a2260$var$isSymbol = $113e8451bf5a2260$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $113e8451bf5a2260$var$toPropertyKey$2 = function toPropertyKey$2(argument) {
    var key = $113e8451bf5a2260$var$toPrimitive(argument, "string");
    return $113e8451bf5a2260$var$isSymbol(key) ? key : key + "";
};
var $113e8451bf5a2260$var$global$g = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$isObject$4 = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$document$3 = $113e8451bf5a2260$var$global$g.document;
// typeof document.createElement is 'object' in old IE
var $113e8451bf5a2260$var$EXISTS$1 = $113e8451bf5a2260$var$isObject$4($113e8451bf5a2260$var$document$3) && $113e8451bf5a2260$var$isObject$4($113e8451bf5a2260$var$document$3.createElement);
var $113e8451bf5a2260$var$documentCreateElement$2 = function documentCreateElement$2(it) {
    return $113e8451bf5a2260$var$EXISTS$1 ? $113e8451bf5a2260$var$document$3.createElement(it) : {};
};
var $113e8451bf5a2260$var$DESCRIPTORS$a = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$fails$e = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$createElement$1 = $113e8451bf5a2260$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $113e8451bf5a2260$var$ie8DomDefine = !$113e8451bf5a2260$var$DESCRIPTORS$a && !$113e8451bf5a2260$var$fails$e(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($113e8451bf5a2260$var$createElement$1("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});
var $113e8451bf5a2260$var$DESCRIPTORS$9 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$call$e = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$propertyIsEnumerableModule$1 = $113e8451bf5a2260$var$objectPropertyIsEnumerable;
var $113e8451bf5a2260$var$createPropertyDescriptor$2 = $113e8451bf5a2260$var$createPropertyDescriptor$3;
var $113e8451bf5a2260$var$toIndexedObject$4 = $113e8451bf5a2260$var$toIndexedObject$5;
var $113e8451bf5a2260$var$toPropertyKey$1 = $113e8451bf5a2260$var$toPropertyKey$2;
var $113e8451bf5a2260$var$hasOwn$9 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$IE8_DOM_DEFINE$1 = $113e8451bf5a2260$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $113e8451bf5a2260$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$113e8451bf5a2260$var$objectGetOwnPropertyDescriptor.f = $113e8451bf5a2260$var$DESCRIPTORS$9 ? $113e8451bf5a2260$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $113e8451bf5a2260$var$toIndexedObject$4(O);
    P = $113e8451bf5a2260$var$toPropertyKey$1(P);
    if ($113e8451bf5a2260$var$IE8_DOM_DEFINE$1) try {
        return $113e8451bf5a2260$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($113e8451bf5a2260$var$hasOwn$9(O, P)) return $113e8451bf5a2260$var$createPropertyDescriptor$2(!$113e8451bf5a2260$var$call$e($113e8451bf5a2260$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $113e8451bf5a2260$var$objectDefineProperty = {};
var $113e8451bf5a2260$var$DESCRIPTORS$8 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$fails$d = $113e8451bf5a2260$var$fails$j;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $113e8451bf5a2260$var$v8PrototypeDefineBug = $113e8451bf5a2260$var$DESCRIPTORS$8 && $113e8451bf5a2260$var$fails$d(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $113e8451bf5a2260$var$isObject$3 = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$$String$2 = String;
var $113e8451bf5a2260$var$$TypeError$8 = TypeError;
// `Assert: Type(argument) is Object`
var $113e8451bf5a2260$var$anObject$e = function anObject$e(argument) {
    if ($113e8451bf5a2260$var$isObject$3(argument)) return argument;
    throw $113e8451bf5a2260$var$$TypeError$8($113e8451bf5a2260$var$$String$2(argument) + " is not an object");
};
var $113e8451bf5a2260$var$DESCRIPTORS$7 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$IE8_DOM_DEFINE = $113e8451bf5a2260$var$ie8DomDefine;
var $113e8451bf5a2260$var$V8_PROTOTYPE_DEFINE_BUG$1 = $113e8451bf5a2260$var$v8PrototypeDefineBug;
var $113e8451bf5a2260$var$anObject$d = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$toPropertyKey = $113e8451bf5a2260$var$toPropertyKey$2;
var $113e8451bf5a2260$var$$TypeError$7 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $113e8451bf5a2260$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $113e8451bf5a2260$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $113e8451bf5a2260$var$ENUMERABLE = "enumerable";
var $113e8451bf5a2260$var$CONFIGURABLE$1 = "configurable";
var $113e8451bf5a2260$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$113e8451bf5a2260$var$objectDefineProperty.f = $113e8451bf5a2260$var$DESCRIPTORS$7 ? $113e8451bf5a2260$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $113e8451bf5a2260$var$anObject$d(O);
    P = $113e8451bf5a2260$var$toPropertyKey(P);
    $113e8451bf5a2260$var$anObject$d(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $113e8451bf5a2260$var$WRITABLE in Attributes && !Attributes[$113e8451bf5a2260$var$WRITABLE]) {
        var current = $113e8451bf5a2260$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$113e8451bf5a2260$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $113e8451bf5a2260$var$CONFIGURABLE$1 in Attributes ? Attributes[$113e8451bf5a2260$var$CONFIGURABLE$1] : current[$113e8451bf5a2260$var$CONFIGURABLE$1],
                enumerable: $113e8451bf5a2260$var$ENUMERABLE in Attributes ? Attributes[$113e8451bf5a2260$var$ENUMERABLE] : current[$113e8451bf5a2260$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $113e8451bf5a2260$var$$defineProperty(O, P, Attributes);
} : $113e8451bf5a2260$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $113e8451bf5a2260$var$anObject$d(O);
    P = $113e8451bf5a2260$var$toPropertyKey(P);
    $113e8451bf5a2260$var$anObject$d(Attributes);
    if ($113e8451bf5a2260$var$IE8_DOM_DEFINE) try {
        return $113e8451bf5a2260$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $113e8451bf5a2260$var$$TypeError$7("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $113e8451bf5a2260$var$DESCRIPTORS$6 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$definePropertyModule$4 = $113e8451bf5a2260$var$objectDefineProperty;
var $113e8451bf5a2260$var$createPropertyDescriptor$1 = $113e8451bf5a2260$var$createPropertyDescriptor$3;
var $113e8451bf5a2260$var$createNonEnumerableProperty$5 = $113e8451bf5a2260$var$DESCRIPTORS$6 ? function createNonEnumerableProperty$5(object, key, value) {
    return $113e8451bf5a2260$var$definePropertyModule$4.f(object, key, $113e8451bf5a2260$var$createPropertyDescriptor$1(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $113e8451bf5a2260$var$makeBuiltIn$2 = {
    exports: {}
};
var $113e8451bf5a2260$var$DESCRIPTORS$5 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$hasOwn$8 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $113e8451bf5a2260$var$getDescriptor = $113e8451bf5a2260$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $113e8451bf5a2260$var$EXISTS = $113e8451bf5a2260$var$hasOwn$8($113e8451bf5a2260$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $113e8451bf5a2260$var$PROPER = $113e8451bf5a2260$var$EXISTS && (function something() {}).name === "something";
var $113e8451bf5a2260$var$CONFIGURABLE = $113e8451bf5a2260$var$EXISTS && (!$113e8451bf5a2260$var$DESCRIPTORS$5 || $113e8451bf5a2260$var$DESCRIPTORS$5 && $113e8451bf5a2260$var$getDescriptor($113e8451bf5a2260$var$FunctionPrototype$1, "name").configurable);
var $113e8451bf5a2260$var$functionName = {
    EXISTS: $113e8451bf5a2260$var$EXISTS,
    PROPER: $113e8451bf5a2260$var$PROPER,
    CONFIGURABLE: $113e8451bf5a2260$var$CONFIGURABLE
};
var $113e8451bf5a2260$var$uncurryThis$d = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$isCallable$g = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$store$1 = $113e8451bf5a2260$var$sharedStore;
var $113e8451bf5a2260$var$functionToString = $113e8451bf5a2260$var$uncurryThis$d(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$113e8451bf5a2260$var$isCallable$g($113e8451bf5a2260$var$store$1.inspectSource)) $113e8451bf5a2260$var$store$1.inspectSource = function(it) {
    return $113e8451bf5a2260$var$functionToString(it);
};
var $113e8451bf5a2260$var$inspectSource$4 = $113e8451bf5a2260$var$store$1.inspectSource;
var $113e8451bf5a2260$var$global$f = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$isCallable$f = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$inspectSource$3 = $113e8451bf5a2260$var$inspectSource$4;
var $113e8451bf5a2260$var$WeakMap$1 = $113e8451bf5a2260$var$global$f.WeakMap;
var $113e8451bf5a2260$var$nativeWeakMap = $113e8451bf5a2260$var$isCallable$f($113e8451bf5a2260$var$WeakMap$1) && /native code/.test($113e8451bf5a2260$var$inspectSource$3($113e8451bf5a2260$var$WeakMap$1));
var $113e8451bf5a2260$var$shared$2 = $113e8451bf5a2260$var$shared$4.exports;
var $113e8451bf5a2260$var$uid = $113e8451bf5a2260$var$uid$2;
var $113e8451bf5a2260$var$keys = $113e8451bf5a2260$var$shared$2("keys");
var $113e8451bf5a2260$var$sharedKey$3 = function sharedKey$3(key) {
    return $113e8451bf5a2260$var$keys[key] || ($113e8451bf5a2260$var$keys[key] = $113e8451bf5a2260$var$uid(key));
};
var $113e8451bf5a2260$var$hiddenKeys$4 = {};
var $113e8451bf5a2260$var$NATIVE_WEAK_MAP = $113e8451bf5a2260$var$nativeWeakMap;
var $113e8451bf5a2260$var$global$e = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$uncurryThis$c = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$isObject$2 = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$createNonEnumerableProperty$4 = $113e8451bf5a2260$var$createNonEnumerableProperty$5;
var $113e8451bf5a2260$var$hasOwn$7 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$shared$1 = $113e8451bf5a2260$var$sharedStore;
var $113e8451bf5a2260$var$sharedKey$2 = $113e8451bf5a2260$var$sharedKey$3;
var $113e8451bf5a2260$var$hiddenKeys$3 = $113e8451bf5a2260$var$hiddenKeys$4;
var $113e8451bf5a2260$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $113e8451bf5a2260$var$TypeError$2 = $113e8451bf5a2260$var$global$e.TypeError;
var $113e8451bf5a2260$var$WeakMap = $113e8451bf5a2260$var$global$e.WeakMap;
var $113e8451bf5a2260$var$set$1, $113e8451bf5a2260$var$get, $113e8451bf5a2260$var$has;
var $113e8451bf5a2260$var$enforce = function enforce(it) {
    return $113e8451bf5a2260$var$has(it) ? $113e8451bf5a2260$var$get(it) : $113e8451bf5a2260$var$set$1(it, {});
};
var $113e8451bf5a2260$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$113e8451bf5a2260$var$isObject$2(it) || (state = $113e8451bf5a2260$var$get(it)).type !== TYPE) throw $113e8451bf5a2260$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($113e8451bf5a2260$var$NATIVE_WEAK_MAP || $113e8451bf5a2260$var$shared$1.state) {
    var $113e8451bf5a2260$var$store = $113e8451bf5a2260$var$shared$1.state || ($113e8451bf5a2260$var$shared$1.state = new $113e8451bf5a2260$var$WeakMap());
    var $113e8451bf5a2260$var$wmget = $113e8451bf5a2260$var$uncurryThis$c($113e8451bf5a2260$var$store.get);
    var $113e8451bf5a2260$var$wmhas = $113e8451bf5a2260$var$uncurryThis$c($113e8451bf5a2260$var$store.has);
    var $113e8451bf5a2260$var$wmset = $113e8451bf5a2260$var$uncurryThis$c($113e8451bf5a2260$var$store.set);
    $113e8451bf5a2260$var$set$1 = function set$1(it, metadata) {
        if ($113e8451bf5a2260$var$wmhas($113e8451bf5a2260$var$store, it)) throw new $113e8451bf5a2260$var$TypeError$2($113e8451bf5a2260$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $113e8451bf5a2260$var$wmset($113e8451bf5a2260$var$store, it, metadata);
        return metadata;
    };
    $113e8451bf5a2260$var$get = function get(it) {
        return $113e8451bf5a2260$var$wmget($113e8451bf5a2260$var$store, it) || {};
    };
    $113e8451bf5a2260$var$has = function has(it) {
        return $113e8451bf5a2260$var$wmhas($113e8451bf5a2260$var$store, it);
    };
} else {
    var $113e8451bf5a2260$var$STATE = $113e8451bf5a2260$var$sharedKey$2("state");
    $113e8451bf5a2260$var$hiddenKeys$3[$113e8451bf5a2260$var$STATE] = true;
    $113e8451bf5a2260$var$set$1 = function set$1(it, metadata) {
        if ($113e8451bf5a2260$var$hasOwn$7(it, $113e8451bf5a2260$var$STATE)) throw new $113e8451bf5a2260$var$TypeError$2($113e8451bf5a2260$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $113e8451bf5a2260$var$createNonEnumerableProperty$4(it, $113e8451bf5a2260$var$STATE, metadata);
        return metadata;
    };
    $113e8451bf5a2260$var$get = function get(it) {
        return $113e8451bf5a2260$var$hasOwn$7(it, $113e8451bf5a2260$var$STATE) ? it[$113e8451bf5a2260$var$STATE] : {};
    };
    $113e8451bf5a2260$var$has = function has(it) {
        return $113e8451bf5a2260$var$hasOwn$7(it, $113e8451bf5a2260$var$STATE);
    };
}
var $113e8451bf5a2260$var$internalState = {
    set: $113e8451bf5a2260$var$set$1,
    get: $113e8451bf5a2260$var$get,
    has: $113e8451bf5a2260$var$has,
    enforce: $113e8451bf5a2260$var$enforce,
    getterFor: $113e8451bf5a2260$var$getterFor
};
var $113e8451bf5a2260$var$fails$c = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$isCallable$e = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$hasOwn$6 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$DESCRIPTORS$4 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$CONFIGURABLE_FUNCTION_NAME$1 = $113e8451bf5a2260$var$functionName.CONFIGURABLE;
var $113e8451bf5a2260$var$inspectSource$2 = $113e8451bf5a2260$var$inspectSource$4;
var $113e8451bf5a2260$var$InternalStateModule$2 = $113e8451bf5a2260$var$internalState;
var $113e8451bf5a2260$var$enforceInternalState = $113e8451bf5a2260$var$InternalStateModule$2.enforce;
var $113e8451bf5a2260$var$getInternalState$2 = $113e8451bf5a2260$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $113e8451bf5a2260$var$defineProperty$4 = Object.defineProperty;
var $113e8451bf5a2260$var$CONFIGURABLE_LENGTH = $113e8451bf5a2260$var$DESCRIPTORS$4 && !$113e8451bf5a2260$var$fails$c(function() {
    return $113e8451bf5a2260$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $113e8451bf5a2260$var$TEMPLATE = String(String).split("String");
var $113e8451bf5a2260$var$makeBuiltIn$1 = $113e8451bf5a2260$var$makeBuiltIn$2.exports = function makeBuiltIn$1(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$113e8451bf5a2260$var$hasOwn$6(value, "name") || $113e8451bf5a2260$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($113e8451bf5a2260$var$DESCRIPTORS$4) $113e8451bf5a2260$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($113e8451bf5a2260$var$CONFIGURABLE_LENGTH && options && $113e8451bf5a2260$var$hasOwn$6(options, "arity") && value.length !== options.arity) $113e8451bf5a2260$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $113e8451bf5a2260$var$hasOwn$6(options, "constructor") && options.constructor) {
            if ($113e8451bf5a2260$var$DESCRIPTORS$4) $113e8451bf5a2260$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $113e8451bf5a2260$var$enforceInternalState(value);
    if (!$113e8451bf5a2260$var$hasOwn$6(state, "source")) state.source = $113e8451bf5a2260$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $113e8451bf5a2260$var$makeBuiltIn$1(function toString() {
    return $113e8451bf5a2260$var$isCallable$e(this) && $113e8451bf5a2260$var$getInternalState$2(this).source || $113e8451bf5a2260$var$inspectSource$2(this);
}, "toString");
var $113e8451bf5a2260$var$isCallable$d = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$definePropertyModule$3 = $113e8451bf5a2260$var$objectDefineProperty;
var $113e8451bf5a2260$var$makeBuiltIn = $113e8451bf5a2260$var$makeBuiltIn$2.exports;
var $113e8451bf5a2260$var$defineGlobalProperty$1 = $113e8451bf5a2260$var$defineGlobalProperty$3;
var $113e8451bf5a2260$var$defineBuiltIn$7 = function defineBuiltIn$7(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($113e8451bf5a2260$var$isCallable$d(value)) $113e8451bf5a2260$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $113e8451bf5a2260$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $113e8451bf5a2260$var$definePropertyModule$3.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $113e8451bf5a2260$var$objectGetOwnPropertyNames = {};
var $113e8451bf5a2260$var$ceil = Math.ceil;
var $113e8451bf5a2260$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $113e8451bf5a2260$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $113e8451bf5a2260$var$floor$1 : $113e8451bf5a2260$var$ceil)(n);
};
var $113e8451bf5a2260$var$trunc = $113e8451bf5a2260$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $113e8451bf5a2260$var$toIntegerOrInfinity$4 = function toIntegerOrInfinity$4(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $113e8451bf5a2260$var$trunc(number);
};
var $113e8451bf5a2260$var$toIntegerOrInfinity$3 = $113e8451bf5a2260$var$toIntegerOrInfinity$4;
var $113e8451bf5a2260$var$max$1 = Math.max;
var $113e8451bf5a2260$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $113e8451bf5a2260$var$toAbsoluteIndex$1 = function toAbsoluteIndex$1(index, length) {
    var integer = $113e8451bf5a2260$var$toIntegerOrInfinity$3(index);
    return integer < 0 ? $113e8451bf5a2260$var$max$1(integer + length, 0) : $113e8451bf5a2260$var$min$2(integer, length);
};
var $113e8451bf5a2260$var$toIntegerOrInfinity$2 = $113e8451bf5a2260$var$toIntegerOrInfinity$4;
var $113e8451bf5a2260$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $113e8451bf5a2260$var$toLength$2 = function toLength$2(argument) {
    return argument > 0 ? $113e8451bf5a2260$var$min$1($113e8451bf5a2260$var$toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $113e8451bf5a2260$var$toLength$1 = $113e8451bf5a2260$var$toLength$2;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $113e8451bf5a2260$var$lengthOfArrayLike$2 = function lengthOfArrayLike$2(obj) {
    return $113e8451bf5a2260$var$toLength$1(obj.length);
};
var $113e8451bf5a2260$var$toIndexedObject$3 = $113e8451bf5a2260$var$toIndexedObject$5;
var $113e8451bf5a2260$var$toAbsoluteIndex = $113e8451bf5a2260$var$toAbsoluteIndex$1;
var $113e8451bf5a2260$var$lengthOfArrayLike$1 = $113e8451bf5a2260$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $113e8451bf5a2260$var$createMethod$1 = function createMethod$1(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $113e8451bf5a2260$var$toIndexedObject$3($this);
        var length = $113e8451bf5a2260$var$lengthOfArrayLike$1(O);
        var index = $113e8451bf5a2260$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $113e8451bf5a2260$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $113e8451bf5a2260$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $113e8451bf5a2260$var$createMethod$1(false)
};
var $113e8451bf5a2260$var$uncurryThis$b = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$hasOwn$5 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$toIndexedObject$2 = $113e8451bf5a2260$var$toIndexedObject$5;
var $113e8451bf5a2260$var$indexOf$1 = $113e8451bf5a2260$var$arrayIncludes.indexOf;
var $113e8451bf5a2260$var$hiddenKeys$2 = $113e8451bf5a2260$var$hiddenKeys$4;
var $113e8451bf5a2260$var$push$1 = $113e8451bf5a2260$var$uncurryThis$b([].push);
var $113e8451bf5a2260$var$objectKeysInternal = function objectKeysInternal(object, names) {
    var O = $113e8451bf5a2260$var$toIndexedObject$2(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$113e8451bf5a2260$var$hasOwn$5($113e8451bf5a2260$var$hiddenKeys$2, key) && $113e8451bf5a2260$var$hasOwn$5(O, key) && $113e8451bf5a2260$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($113e8451bf5a2260$var$hasOwn$5(O, key = names[i++])) ~$113e8451bf5a2260$var$indexOf$1(result, key) || $113e8451bf5a2260$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $113e8451bf5a2260$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $113e8451bf5a2260$var$internalObjectKeys$1 = $113e8451bf5a2260$var$objectKeysInternal;
var $113e8451bf5a2260$var$enumBugKeys$2 = $113e8451bf5a2260$var$enumBugKeys$3;
var $113e8451bf5a2260$var$hiddenKeys$1 = $113e8451bf5a2260$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$113e8451bf5a2260$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $113e8451bf5a2260$var$internalObjectKeys$1(O, $113e8451bf5a2260$var$hiddenKeys$1);
};
var $113e8451bf5a2260$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$113e8451bf5a2260$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $113e8451bf5a2260$var$getBuiltIn$5 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$uncurryThis$a = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$getOwnPropertyNamesModule = $113e8451bf5a2260$var$objectGetOwnPropertyNames;
var $113e8451bf5a2260$var$getOwnPropertySymbolsModule$1 = $113e8451bf5a2260$var$objectGetOwnPropertySymbols;
var $113e8451bf5a2260$var$anObject$c = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$concat$2 = $113e8451bf5a2260$var$uncurryThis$a([].concat);
// all object keys, includes non-enumerable and symbols
var $113e8451bf5a2260$var$ownKeys$1 = $113e8451bf5a2260$var$getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $113e8451bf5a2260$var$getOwnPropertyNamesModule.f($113e8451bf5a2260$var$anObject$c(it));
    var getOwnPropertySymbols = $113e8451bf5a2260$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $113e8451bf5a2260$var$concat$2(keys, getOwnPropertySymbols(it)) : keys;
};
var $113e8451bf5a2260$var$hasOwn$4 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$ownKeys = $113e8451bf5a2260$var$ownKeys$1;
var $113e8451bf5a2260$var$getOwnPropertyDescriptorModule = $113e8451bf5a2260$var$objectGetOwnPropertyDescriptor;
var $113e8451bf5a2260$var$definePropertyModule$2 = $113e8451bf5a2260$var$objectDefineProperty;
var $113e8451bf5a2260$var$copyConstructorProperties$1 = function copyConstructorProperties$1(target, source, exceptions) {
    var keys = $113e8451bf5a2260$var$ownKeys(source);
    var defineProperty = $113e8451bf5a2260$var$definePropertyModule$2.f;
    var getOwnPropertyDescriptor = $113e8451bf5a2260$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$113e8451bf5a2260$var$hasOwn$4(target, key) && !(exceptions && $113e8451bf5a2260$var$hasOwn$4(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $113e8451bf5a2260$var$fails$b = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$isCallable$c = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$replacement = /#|\.prototype\./;
var $113e8451bf5a2260$var$isForced$2 = function isForced$2(feature, detection) {
    var value = $113e8451bf5a2260$var$data[$113e8451bf5a2260$var$normalize(feature)];
    return value == $113e8451bf5a2260$var$POLYFILL ? true : value == $113e8451bf5a2260$var$NATIVE ? false : $113e8451bf5a2260$var$isCallable$c(detection) ? $113e8451bf5a2260$var$fails$b(detection) : !!detection;
};
var $113e8451bf5a2260$var$normalize = $113e8451bf5a2260$var$isForced$2.normalize = function normalize(string) {
    return String(string).replace($113e8451bf5a2260$var$replacement, ".").toLowerCase();
};
var $113e8451bf5a2260$var$data = $113e8451bf5a2260$var$isForced$2.data = {};
var $113e8451bf5a2260$var$NATIVE = $113e8451bf5a2260$var$isForced$2.NATIVE = "N";
var $113e8451bf5a2260$var$POLYFILL = $113e8451bf5a2260$var$isForced$2.POLYFILL = "P";
var $113e8451bf5a2260$var$isForced_1 = $113e8451bf5a2260$var$isForced$2;
var $113e8451bf5a2260$var$global$d = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$getOwnPropertyDescriptor$1 = $113e8451bf5a2260$var$objectGetOwnPropertyDescriptor.f;
var $113e8451bf5a2260$var$createNonEnumerableProperty$3 = $113e8451bf5a2260$var$createNonEnumerableProperty$5;
var $113e8451bf5a2260$var$defineBuiltIn$6 = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$defineGlobalProperty = $113e8451bf5a2260$var$defineGlobalProperty$3;
var $113e8451bf5a2260$var$copyConstructorProperties = $113e8451bf5a2260$var$copyConstructorProperties$1;
var $113e8451bf5a2260$var$isForced$1 = $113e8451bf5a2260$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $113e8451bf5a2260$var$_export = function _export(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $113e8451bf5a2260$var$global$d;
    else if (STATIC) target = $113e8451bf5a2260$var$global$d[TARGET] || $113e8451bf5a2260$var$defineGlobalProperty(TARGET, {});
    else target = ($113e8451bf5a2260$var$global$d[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $113e8451bf5a2260$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $113e8451bf5a2260$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $1ObTH._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $1ObTH._)(targetProperty))) continue;
            $113e8451bf5a2260$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $113e8451bf5a2260$var$createNonEnumerableProperty$3(sourceProperty, "sham", true);
        $113e8451bf5a2260$var$defineBuiltIn$6(target, key, sourceProperty, options);
    }
};
var $113e8451bf5a2260$var$internalObjectKeys = $113e8451bf5a2260$var$objectKeysInternal;
var $113e8451bf5a2260$var$enumBugKeys$1 = $113e8451bf5a2260$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $113e8451bf5a2260$var$objectKeys$2 = Object.keys || function keys(O) {
    return $113e8451bf5a2260$var$internalObjectKeys(O, $113e8451bf5a2260$var$enumBugKeys$1);
};
var $113e8451bf5a2260$var$DESCRIPTORS$3 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$uncurryThis$9 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$call$d = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$fails$a = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$objectKeys$1 = $113e8451bf5a2260$var$objectKeys$2;
var $113e8451bf5a2260$var$getOwnPropertySymbolsModule = $113e8451bf5a2260$var$objectGetOwnPropertySymbols;
var $113e8451bf5a2260$var$propertyIsEnumerableModule = $113e8451bf5a2260$var$objectPropertyIsEnumerable;
var $113e8451bf5a2260$var$toObject$2 = $113e8451bf5a2260$var$toObject$4;
var $113e8451bf5a2260$var$IndexedObject = $113e8451bf5a2260$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $113e8451bf5a2260$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $113e8451bf5a2260$var$defineProperty$3 = Object.defineProperty;
var $113e8451bf5a2260$var$concat$1 = $113e8451bf5a2260$var$uncurryThis$9([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $113e8451bf5a2260$var$objectAssign = !$113e8451bf5a2260$var$$assign || $113e8451bf5a2260$var$fails$a(function() {
    // should have correct order of operations (Edge bug)
    if ($113e8451bf5a2260$var$DESCRIPTORS$3 && $113e8451bf5a2260$var$$assign({
        b: 1
    }, $113e8451bf5a2260$var$$assign($113e8451bf5a2260$var$defineProperty$3({}, "a", {
        enumerable: true,
        get: function get() {
            $113e8451bf5a2260$var$defineProperty$3(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $113e8451bf5a2260$var$$assign({}, A)[symbol] != 7 || $113e8451bf5a2260$var$objectKeys$1($113e8451bf5a2260$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $113e8451bf5a2260$var$toObject$2(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $113e8451bf5a2260$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $113e8451bf5a2260$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $113e8451bf5a2260$var$IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? $113e8451bf5a2260$var$concat$1($113e8451bf5a2260$var$objectKeys$1(S), getOwnPropertySymbols(S)) : $113e8451bf5a2260$var$objectKeys$1(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$113e8451bf5a2260$var$DESCRIPTORS$3 || $113e8451bf5a2260$var$call$d(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $113e8451bf5a2260$var$$assign;
var $113e8451bf5a2260$var$$$8 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$assign = $113e8451bf5a2260$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$113e8451bf5a2260$var$$$8({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $113e8451bf5a2260$var$assign
}, {
    assign: $113e8451bf5a2260$var$assign
});
var $113e8451bf5a2260$var$wellKnownSymbol$e = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$TO_STRING_TAG$3 = $113e8451bf5a2260$var$wellKnownSymbol$e("toStringTag");
var $113e8451bf5a2260$var$test = {};
$113e8451bf5a2260$var$test[$113e8451bf5a2260$var$TO_STRING_TAG$3] = "z";
var $113e8451bf5a2260$var$toStringTagSupport = String($113e8451bf5a2260$var$test) === "[object z]";
var $113e8451bf5a2260$var$TO_STRING_TAG_SUPPORT = $113e8451bf5a2260$var$toStringTagSupport;
var $113e8451bf5a2260$var$isCallable$b = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$classofRaw = $113e8451bf5a2260$var$classofRaw$1;
var $113e8451bf5a2260$var$wellKnownSymbol$d = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$TO_STRING_TAG$2 = $113e8451bf5a2260$var$wellKnownSymbol$d("toStringTag");
var $113e8451bf5a2260$var$$Object$1 = Object;
// ES3 wrong here
var $113e8451bf5a2260$var$CORRECT_ARGUMENTS = $113e8451bf5a2260$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $113e8451bf5a2260$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $113e8451bf5a2260$var$classof$5 = $113e8451bf5a2260$var$TO_STRING_TAG_SUPPORT ? $113e8451bf5a2260$var$classofRaw : function classof$5(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $113e8451bf5a2260$var$tryGet(O = $113e8451bf5a2260$var$$Object$1(it), $113e8451bf5a2260$var$TO_STRING_TAG$2)) == "string" ? tag : $113e8451bf5a2260$var$CORRECT_ARGUMENTS ? $113e8451bf5a2260$var$classofRaw(O) : (result = $113e8451bf5a2260$var$classofRaw(O)) == "Object" && $113e8451bf5a2260$var$isCallable$b(O.callee) ? "Arguments" : result;
};
var $113e8451bf5a2260$var$classof$4 = $113e8451bf5a2260$var$classof$5;
var $113e8451bf5a2260$var$$String$1 = String;
var $113e8451bf5a2260$var$toString$3 = function toString$3(argument) {
    if ($113e8451bf5a2260$var$classof$4(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $113e8451bf5a2260$var$$String$1(argument);
};
var $113e8451bf5a2260$var$anObject$b = $113e8451bf5a2260$var$anObject$e;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $113e8451bf5a2260$var$regexpFlags$1 = function regexpFlags$1() {
    var that = $113e8451bf5a2260$var$anObject$b(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $113e8451bf5a2260$var$call$c = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$hasOwn$3 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$isPrototypeOf$2 = $113e8451bf5a2260$var$objectIsPrototypeOf;
var $113e8451bf5a2260$var$regExpFlags = $113e8451bf5a2260$var$regexpFlags$1;
var $113e8451bf5a2260$var$RegExpPrototype$2 = RegExp.prototype;
var $113e8451bf5a2260$var$regexpGetFlags = function regexpGetFlags(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $113e8451bf5a2260$var$RegExpPrototype$2) && !$113e8451bf5a2260$var$hasOwn$3(R, "flags") && $113e8451bf5a2260$var$isPrototypeOf$2($113e8451bf5a2260$var$RegExpPrototype$2, R) ? $113e8451bf5a2260$var$call$c($113e8451bf5a2260$var$regExpFlags, R) : flags;
};
var $113e8451bf5a2260$var$PROPER_FUNCTION_NAME$1 = $113e8451bf5a2260$var$functionName.PROPER;
var $113e8451bf5a2260$var$defineBuiltIn$5 = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$anObject$a = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$$toString = $113e8451bf5a2260$var$toString$3;
var $113e8451bf5a2260$var$fails$9 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$getRegExpFlags = $113e8451bf5a2260$var$regexpGetFlags;
var $113e8451bf5a2260$var$TO_STRING = "toString";
var $113e8451bf5a2260$var$RegExpPrototype$1 = RegExp.prototype;
var $113e8451bf5a2260$var$n$ToString = $113e8451bf5a2260$var$RegExpPrototype$1[$113e8451bf5a2260$var$TO_STRING];
var $113e8451bf5a2260$var$NOT_GENERIC = $113e8451bf5a2260$var$fails$9(function() {
    return $113e8451bf5a2260$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $113e8451bf5a2260$var$INCORRECT_NAME = $113e8451bf5a2260$var$PROPER_FUNCTION_NAME$1 && $113e8451bf5a2260$var$n$ToString.name != $113e8451bf5a2260$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($113e8451bf5a2260$var$NOT_GENERIC || $113e8451bf5a2260$var$INCORRECT_NAME) $113e8451bf5a2260$var$defineBuiltIn$5(RegExp.prototype, $113e8451bf5a2260$var$TO_STRING, function toString() {
    var R = $113e8451bf5a2260$var$anObject$a(this);
    var pattern = $113e8451bf5a2260$var$$toString(R.source);
    var flags = $113e8451bf5a2260$var$$toString($113e8451bf5a2260$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
var $113e8451bf5a2260$var$objectDefineProperties = {};
var $113e8451bf5a2260$var$DESCRIPTORS$2 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$V8_PROTOTYPE_DEFINE_BUG = $113e8451bf5a2260$var$v8PrototypeDefineBug;
var $113e8451bf5a2260$var$definePropertyModule$1 = $113e8451bf5a2260$var$objectDefineProperty;
var $113e8451bf5a2260$var$anObject$9 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$toIndexedObject$1 = $113e8451bf5a2260$var$toIndexedObject$5;
var $113e8451bf5a2260$var$objectKeys = $113e8451bf5a2260$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$113e8451bf5a2260$var$objectDefineProperties.f = $113e8451bf5a2260$var$DESCRIPTORS$2 && !$113e8451bf5a2260$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $113e8451bf5a2260$var$anObject$9(O);
    var props = $113e8451bf5a2260$var$toIndexedObject$1(Properties);
    var keys = $113e8451bf5a2260$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$113e8451bf5a2260$var$definePropertyModule$1.f(O, key = keys[index++], props[key]);
    return O;
};
var $113e8451bf5a2260$var$getBuiltIn$4 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$html$2 = $113e8451bf5a2260$var$getBuiltIn$4("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $113e8451bf5a2260$var$anObject$8 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$definePropertiesModule = $113e8451bf5a2260$var$objectDefineProperties;
var $113e8451bf5a2260$var$enumBugKeys = $113e8451bf5a2260$var$enumBugKeys$3;
var $113e8451bf5a2260$var$hiddenKeys = $113e8451bf5a2260$var$hiddenKeys$4;
var $113e8451bf5a2260$var$html$1 = $113e8451bf5a2260$var$html$2;
var $113e8451bf5a2260$var$documentCreateElement$1 = $113e8451bf5a2260$var$documentCreateElement$2;
var $113e8451bf5a2260$var$sharedKey$1 = $113e8451bf5a2260$var$sharedKey$3;
var $113e8451bf5a2260$var$GT = ">";
var $113e8451bf5a2260$var$LT = "<";
var $113e8451bf5a2260$var$PROTOTYPE = "prototype";
var $113e8451bf5a2260$var$SCRIPT = "script";
var $113e8451bf5a2260$var$IE_PROTO$1 = $113e8451bf5a2260$var$sharedKey$1("IE_PROTO");
var $113e8451bf5a2260$var$EmptyConstructor = function EmptyConstructor() {};
var $113e8451bf5a2260$var$scriptTag = function scriptTag(content) {
    return $113e8451bf5a2260$var$LT + $113e8451bf5a2260$var$SCRIPT + $113e8451bf5a2260$var$GT + content + $113e8451bf5a2260$var$LT + "/" + $113e8451bf5a2260$var$SCRIPT + $113e8451bf5a2260$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $113e8451bf5a2260$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($113e8451bf5a2260$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $113e8451bf5a2260$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $113e8451bf5a2260$var$documentCreateElement$1("iframe");
    var JS = "java" + $113e8451bf5a2260$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $113e8451bf5a2260$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($113e8451bf5a2260$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $113e8451bf5a2260$var$activeXDocument;
var $113e8451bf5a2260$var$NullProtoObject = function NullProtoObject1() {
    try {
        $113e8451bf5a2260$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $113e8451bf5a2260$var$NullProtoObject = typeof document != "undefined" ? document.domain && $113e8451bf5a2260$var$activeXDocument ? $113e8451bf5a2260$var$NullProtoObjectViaActiveX($113e8451bf5a2260$var$activeXDocument) // old IE
     : $113e8451bf5a2260$var$NullProtoObjectViaIFrame() : $113e8451bf5a2260$var$NullProtoObjectViaActiveX($113e8451bf5a2260$var$activeXDocument); // WSH
    var length = $113e8451bf5a2260$var$enumBugKeys.length;
    while(length--)delete $113e8451bf5a2260$var$NullProtoObject[$113e8451bf5a2260$var$PROTOTYPE][$113e8451bf5a2260$var$enumBugKeys[length]];
    return $113e8451bf5a2260$var$NullProtoObject();
};
$113e8451bf5a2260$var$hiddenKeys[$113e8451bf5a2260$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $113e8451bf5a2260$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $113e8451bf5a2260$var$EmptyConstructor[$113e8451bf5a2260$var$PROTOTYPE] = $113e8451bf5a2260$var$anObject$8(O);
        result = new $113e8451bf5a2260$var$EmptyConstructor();
        $113e8451bf5a2260$var$EmptyConstructor[$113e8451bf5a2260$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$113e8451bf5a2260$var$IE_PROTO$1] = O;
    } else result = $113e8451bf5a2260$var$NullProtoObject();
    return Properties === undefined ? result : $113e8451bf5a2260$var$definePropertiesModule.f(result, Properties);
};
var $113e8451bf5a2260$var$wellKnownSymbol$c = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$create$2 = $113e8451bf5a2260$var$objectCreate;
var $113e8451bf5a2260$var$defineProperty$2 = $113e8451bf5a2260$var$objectDefineProperty.f;
var $113e8451bf5a2260$var$UNSCOPABLES = $113e8451bf5a2260$var$wellKnownSymbol$c("unscopables");
var $113e8451bf5a2260$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($113e8451bf5a2260$var$ArrayPrototype$1[$113e8451bf5a2260$var$UNSCOPABLES] == undefined) $113e8451bf5a2260$var$defineProperty$2($113e8451bf5a2260$var$ArrayPrototype$1, $113e8451bf5a2260$var$UNSCOPABLES, {
    configurable: true,
    value: $113e8451bf5a2260$var$create$2(null)
});
// add a key to Array.prototype[@@unscopables]
var $113e8451bf5a2260$var$addToUnscopables$1 = function addToUnscopables$1(key) {
    $113e8451bf5a2260$var$ArrayPrototype$1[$113e8451bf5a2260$var$UNSCOPABLES][key] = true;
};
var $113e8451bf5a2260$var$iterators = {};
var $113e8451bf5a2260$var$fails$8 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$correctPrototypeGetter = !$113e8451bf5a2260$var$fails$8(function() {
    var F = function F() {};
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $113e8451bf5a2260$var$hasOwn$2 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$isCallable$a = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$toObject$1 = $113e8451bf5a2260$var$toObject$4;
var $113e8451bf5a2260$var$sharedKey = $113e8451bf5a2260$var$sharedKey$3;
var $113e8451bf5a2260$var$CORRECT_PROTOTYPE_GETTER = $113e8451bf5a2260$var$correctPrototypeGetter;
var $113e8451bf5a2260$var$IE_PROTO = $113e8451bf5a2260$var$sharedKey("IE_PROTO");
var $113e8451bf5a2260$var$$Object = Object;
var $113e8451bf5a2260$var$ObjectPrototype = $113e8451bf5a2260$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $113e8451bf5a2260$var$objectGetPrototypeOf = $113e8451bf5a2260$var$CORRECT_PROTOTYPE_GETTER ? $113e8451bf5a2260$var$$Object.getPrototypeOf : function objectGetPrototypeOf(O) {
    var object = $113e8451bf5a2260$var$toObject$1(O);
    if ($113e8451bf5a2260$var$hasOwn$2(object, $113e8451bf5a2260$var$IE_PROTO)) return object[$113e8451bf5a2260$var$IE_PROTO];
    var constructor = object.constructor;
    if ($113e8451bf5a2260$var$isCallable$a(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $113e8451bf5a2260$var$$Object ? $113e8451bf5a2260$var$ObjectPrototype : null;
};
var $113e8451bf5a2260$var$fails$7 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$isCallable$9 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$getPrototypeOf$1 = $113e8451bf5a2260$var$objectGetPrototypeOf;
var $113e8451bf5a2260$var$defineBuiltIn$4 = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$wellKnownSymbol$b = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$ITERATOR$5 = $113e8451bf5a2260$var$wellKnownSymbol$b("iterator");
var $113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $113e8451bf5a2260$var$IteratorPrototype$2, $113e8451bf5a2260$var$PrototypeOfArrayIteratorPrototype, $113e8451bf5a2260$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $113e8451bf5a2260$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $113e8451bf5a2260$var$arrayIterator)) $113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $113e8451bf5a2260$var$PrototypeOfArrayIteratorPrototype = $113e8451bf5a2260$var$getPrototypeOf$1($113e8451bf5a2260$var$getPrototypeOf$1($113e8451bf5a2260$var$arrayIterator));
        if ($113e8451bf5a2260$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $113e8451bf5a2260$var$IteratorPrototype$2 = $113e8451bf5a2260$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $113e8451bf5a2260$var$NEW_ITERATOR_PROTOTYPE = $113e8451bf5a2260$var$IteratorPrototype$2 == undefined || $113e8451bf5a2260$var$fails$7(function() {
    var test = {};
    // FF44- legacy iterators case
    return $113e8451bf5a2260$var$IteratorPrototype$2[$113e8451bf5a2260$var$ITERATOR$5].call(test) !== test;
});
if ($113e8451bf5a2260$var$NEW_ITERATOR_PROTOTYPE) $113e8451bf5a2260$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$113e8451bf5a2260$var$isCallable$9($113e8451bf5a2260$var$IteratorPrototype$2[$113e8451bf5a2260$var$ITERATOR$5])) $113e8451bf5a2260$var$defineBuiltIn$4($113e8451bf5a2260$var$IteratorPrototype$2, $113e8451bf5a2260$var$ITERATOR$5, function() {
    return this;
});
var $113e8451bf5a2260$var$iteratorsCore = {
    IteratorPrototype: $113e8451bf5a2260$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS$1
};
var $113e8451bf5a2260$var$defineProperty$1 = $113e8451bf5a2260$var$objectDefineProperty.f;
var $113e8451bf5a2260$var$hasOwn$1 = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$wellKnownSymbol$a = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$TO_STRING_TAG$1 = $113e8451bf5a2260$var$wellKnownSymbol$a("toStringTag");
var $113e8451bf5a2260$var$setToStringTag$3 = function setToStringTag$3(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$113e8451bf5a2260$var$hasOwn$1(target, $113e8451bf5a2260$var$TO_STRING_TAG$1)) $113e8451bf5a2260$var$defineProperty$1(target, $113e8451bf5a2260$var$TO_STRING_TAG$1, {
        configurable: true,
        value: TAG
    });
};
var $113e8451bf5a2260$var$IteratorPrototype$1 = $113e8451bf5a2260$var$iteratorsCore.IteratorPrototype;
var $113e8451bf5a2260$var$create$1 = $113e8451bf5a2260$var$objectCreate;
var $113e8451bf5a2260$var$createPropertyDescriptor = $113e8451bf5a2260$var$createPropertyDescriptor$3;
var $113e8451bf5a2260$var$setToStringTag$2 = $113e8451bf5a2260$var$setToStringTag$3;
var $113e8451bf5a2260$var$Iterators$4 = $113e8451bf5a2260$var$iterators;
var $113e8451bf5a2260$var$returnThis$1 = function returnThis$1() {
    return this;
};
var $113e8451bf5a2260$var$createIteratorConstructor$1 = function createIteratorConstructor$1(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $113e8451bf5a2260$var$create$1($113e8451bf5a2260$var$IteratorPrototype$1, {
        next: $113e8451bf5a2260$var$createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    $113e8451bf5a2260$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $113e8451bf5a2260$var$Iterators$4[TO_STRING_TAG] = $113e8451bf5a2260$var$returnThis$1;
    return IteratorConstructor;
};
var $113e8451bf5a2260$var$isCallable$8 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$$String = String;
var $113e8451bf5a2260$var$$TypeError$6 = TypeError;
var $113e8451bf5a2260$var$aPossiblePrototype$1 = function aPossiblePrototype$1(argument) {
    if (typeof argument == "object" || $113e8451bf5a2260$var$isCallable$8(argument)) return argument;
    throw $113e8451bf5a2260$var$$TypeError$6("Can't set " + $113e8451bf5a2260$var$$String(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $113e8451bf5a2260$var$uncurryThis$8 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$anObject$7 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$aPossiblePrototype = $113e8451bf5a2260$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $113e8451bf5a2260$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $113e8451bf5a2260$var$uncurryThis$8(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $113e8451bf5a2260$var$anObject$7(O);
        $113e8451bf5a2260$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $113e8451bf5a2260$var$$$7 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$call$b = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$FunctionName = $113e8451bf5a2260$var$functionName;
var $113e8451bf5a2260$var$isCallable$7 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$createIteratorConstructor = $113e8451bf5a2260$var$createIteratorConstructor$1;
var $113e8451bf5a2260$var$getPrototypeOf = $113e8451bf5a2260$var$objectGetPrototypeOf;
var $113e8451bf5a2260$var$setPrototypeOf$1 = $113e8451bf5a2260$var$objectSetPrototypeOf;
var $113e8451bf5a2260$var$setToStringTag$1 = $113e8451bf5a2260$var$setToStringTag$3;
var $113e8451bf5a2260$var$createNonEnumerableProperty$2 = $113e8451bf5a2260$var$createNonEnumerableProperty$5;
var $113e8451bf5a2260$var$defineBuiltIn$3 = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$wellKnownSymbol$9 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$Iterators$3 = $113e8451bf5a2260$var$iterators;
var $113e8451bf5a2260$var$IteratorsCore = $113e8451bf5a2260$var$iteratorsCore;
var $113e8451bf5a2260$var$PROPER_FUNCTION_NAME = $113e8451bf5a2260$var$FunctionName.PROPER;
var $113e8451bf5a2260$var$CONFIGURABLE_FUNCTION_NAME = $113e8451bf5a2260$var$FunctionName.CONFIGURABLE;
var $113e8451bf5a2260$var$IteratorPrototype = $113e8451bf5a2260$var$IteratorsCore.IteratorPrototype;
var $113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS = $113e8451bf5a2260$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $113e8451bf5a2260$var$ITERATOR$4 = $113e8451bf5a2260$var$wellKnownSymbol$9("iterator");
var $113e8451bf5a2260$var$KEYS = "keys";
var $113e8451bf5a2260$var$VALUES = "values";
var $113e8451bf5a2260$var$ENTRIES = "entries";
var $113e8451bf5a2260$var$returnThis = function returnThis() {
    return this;
};
var $113e8451bf5a2260$var$defineIterator$1 = function defineIterator$1(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $113e8451bf5a2260$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $113e8451bf5a2260$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $113e8451bf5a2260$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $113e8451bf5a2260$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$113e8451bf5a2260$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $113e8451bf5a2260$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($113e8451bf5a2260$var$getPrototypeOf(CurrentIteratorPrototype) !== $113e8451bf5a2260$var$IteratorPrototype) {
                if ($113e8451bf5a2260$var$setPrototypeOf$1) $113e8451bf5a2260$var$setPrototypeOf$1(CurrentIteratorPrototype, $113e8451bf5a2260$var$IteratorPrototype);
                else if (!$113e8451bf5a2260$var$isCallable$7(CurrentIteratorPrototype[$113e8451bf5a2260$var$ITERATOR$4])) $113e8451bf5a2260$var$defineBuiltIn$3(CurrentIteratorPrototype, $113e8451bf5a2260$var$ITERATOR$4, $113e8451bf5a2260$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $113e8451bf5a2260$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($113e8451bf5a2260$var$PROPER_FUNCTION_NAME && DEFAULT == $113e8451bf5a2260$var$VALUES && nativeIterator && nativeIterator.name !== $113e8451bf5a2260$var$VALUES) {
        if ($113e8451bf5a2260$var$CONFIGURABLE_FUNCTION_NAME) $113e8451bf5a2260$var$createNonEnumerableProperty$2(IterablePrototype, "name", $113e8451bf5a2260$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $113e8451bf5a2260$var$call$b(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($113e8451bf5a2260$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($113e8451bf5a2260$var$KEYS),
            entries: getIterationMethod($113e8451bf5a2260$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $113e8451bf5a2260$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $113e8451bf5a2260$var$$$7({
            target: NAME,
            proto: true,
            forced: $113e8451bf5a2260$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$113e8451bf5a2260$var$ITERATOR$4] !== defaultIterator) $113e8451bf5a2260$var$defineBuiltIn$3(IterablePrototype, $113e8451bf5a2260$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $113e8451bf5a2260$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $113e8451bf5a2260$var$toIndexedObject = $113e8451bf5a2260$var$toIndexedObject$5;
var $113e8451bf5a2260$var$addToUnscopables = $113e8451bf5a2260$var$addToUnscopables$1;
var $113e8451bf5a2260$var$Iterators$2 = $113e8451bf5a2260$var$iterators;
var $113e8451bf5a2260$var$InternalStateModule$1 = $113e8451bf5a2260$var$internalState;
var $113e8451bf5a2260$var$defineProperty = $113e8451bf5a2260$var$objectDefineProperty.f;
var $113e8451bf5a2260$var$defineIterator = $113e8451bf5a2260$var$defineIterator$1;
var $113e8451bf5a2260$var$DESCRIPTORS$1 = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$ARRAY_ITERATOR = "Array Iterator";
var $113e8451bf5a2260$var$setInternalState$1 = $113e8451bf5a2260$var$InternalStateModule$1.set;
var $113e8451bf5a2260$var$getInternalState$1 = $113e8451bf5a2260$var$InternalStateModule$1.getterFor($113e8451bf5a2260$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $113e8451bf5a2260$var$es_array_iterator = $113e8451bf5a2260$var$defineIterator(Array, "Array", function(iterated, kind) {
    $113e8451bf5a2260$var$setInternalState$1(this, {
        type: $113e8451bf5a2260$var$ARRAY_ITERATOR,
        target: $113e8451bf5a2260$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $113e8451bf5a2260$var$getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $113e8451bf5a2260$var$values = $113e8451bf5a2260$var$Iterators$2.Arguments = $113e8451bf5a2260$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$113e8451bf5a2260$var$addToUnscopables("keys");
$113e8451bf5a2260$var$addToUnscopables("values");
$113e8451bf5a2260$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($113e8451bf5a2260$var$DESCRIPTORS$1 && $113e8451bf5a2260$var$values.name !== "values") try {
    $113e8451bf5a2260$var$defineProperty($113e8451bf5a2260$var$values, "name", {
        value: "values"
    });
} catch (error) {}
var $113e8451bf5a2260$var$classof$3 = $113e8451bf5a2260$var$classofRaw$1;
var $113e8451bf5a2260$var$global$c = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$engineIsNode = $113e8451bf5a2260$var$classof$3($113e8451bf5a2260$var$global$c.process) == "process";
var $113e8451bf5a2260$var$getBuiltIn$3 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$definePropertyModule = $113e8451bf5a2260$var$objectDefineProperty;
var $113e8451bf5a2260$var$wellKnownSymbol$8 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$DESCRIPTORS = $113e8451bf5a2260$var$descriptors;
var $113e8451bf5a2260$var$SPECIES$3 = $113e8451bf5a2260$var$wellKnownSymbol$8("species");
var $113e8451bf5a2260$var$setSpecies$1 = function setSpecies$1(CONSTRUCTOR_NAME) {
    var Constructor = $113e8451bf5a2260$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $113e8451bf5a2260$var$definePropertyModule.f;
    if ($113e8451bf5a2260$var$DESCRIPTORS && Constructor && !Constructor[$113e8451bf5a2260$var$SPECIES$3]) defineProperty(Constructor, $113e8451bf5a2260$var$SPECIES$3, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};
var $113e8451bf5a2260$var$isPrototypeOf$1 = $113e8451bf5a2260$var$objectIsPrototypeOf;
var $113e8451bf5a2260$var$$TypeError$5 = TypeError;
var $113e8451bf5a2260$var$anInstance$1 = function anInstance$1(it, Prototype) {
    if ($113e8451bf5a2260$var$isPrototypeOf$1(Prototype, it)) return it;
    throw $113e8451bf5a2260$var$$TypeError$5("Incorrect invocation");
};
var $113e8451bf5a2260$var$uncurryThis$7 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$fails$6 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$isCallable$6 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$classof$2 = $113e8451bf5a2260$var$classof$5;
var $113e8451bf5a2260$var$getBuiltIn$2 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$inspectSource$1 = $113e8451bf5a2260$var$inspectSource$4;
var $113e8451bf5a2260$var$noop = function noop() {};
var $113e8451bf5a2260$var$empty = [];
var $113e8451bf5a2260$var$construct = $113e8451bf5a2260$var$getBuiltIn$2("Reflect", "construct");
var $113e8451bf5a2260$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $113e8451bf5a2260$var$exec$1 = $113e8451bf5a2260$var$uncurryThis$7($113e8451bf5a2260$var$constructorRegExp.exec);
var $113e8451bf5a2260$var$INCORRECT_TO_STRING = !$113e8451bf5a2260$var$constructorRegExp.exec($113e8451bf5a2260$var$noop);
var $113e8451bf5a2260$var$isConstructorModern = function isConstructor(argument) {
    if (!$113e8451bf5a2260$var$isCallable$6(argument)) return false;
    try {
        $113e8451bf5a2260$var$construct($113e8451bf5a2260$var$noop, $113e8451bf5a2260$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $113e8451bf5a2260$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$113e8451bf5a2260$var$isCallable$6(argument)) return false;
    switch($113e8451bf5a2260$var$classof$2(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $113e8451bf5a2260$var$INCORRECT_TO_STRING || !!$113e8451bf5a2260$var$exec$1($113e8451bf5a2260$var$constructorRegExp, $113e8451bf5a2260$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$113e8451bf5a2260$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $113e8451bf5a2260$var$isConstructor$1 = !$113e8451bf5a2260$var$construct || $113e8451bf5a2260$var$fails$6(function() {
    var called;
    return $113e8451bf5a2260$var$isConstructorModern($113e8451bf5a2260$var$isConstructorModern.call) || !$113e8451bf5a2260$var$isConstructorModern(Object) || !$113e8451bf5a2260$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $113e8451bf5a2260$var$isConstructorLegacy : $113e8451bf5a2260$var$isConstructorModern;
var $113e8451bf5a2260$var$isConstructor = $113e8451bf5a2260$var$isConstructor$1;
var $113e8451bf5a2260$var$tryToString$2 = $113e8451bf5a2260$var$tryToString$4;
var $113e8451bf5a2260$var$$TypeError$4 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $113e8451bf5a2260$var$aConstructor$1 = function aConstructor$1(argument) {
    if ($113e8451bf5a2260$var$isConstructor(argument)) return argument;
    throw $113e8451bf5a2260$var$$TypeError$4($113e8451bf5a2260$var$tryToString$2(argument) + " is not a constructor");
};
var $113e8451bf5a2260$var$anObject$6 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$aConstructor = $113e8451bf5a2260$var$aConstructor$1;
var $113e8451bf5a2260$var$wellKnownSymbol$7 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$SPECIES$2 = $113e8451bf5a2260$var$wellKnownSymbol$7("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $113e8451bf5a2260$var$speciesConstructor$1 = function speciesConstructor$1(O, defaultConstructor) {
    var C = $113e8451bf5a2260$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $113e8451bf5a2260$var$anObject$6(C)[$113e8451bf5a2260$var$SPECIES$2]) == undefined ? defaultConstructor : $113e8451bf5a2260$var$aConstructor(S);
};
var $113e8451bf5a2260$var$NATIVE_BIND$1 = $113e8451bf5a2260$var$functionBindNative;
var $113e8451bf5a2260$var$FunctionPrototype = Function.prototype;
var $113e8451bf5a2260$var$apply$2 = $113e8451bf5a2260$var$FunctionPrototype.apply;
var $113e8451bf5a2260$var$call$a = $113e8451bf5a2260$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $113e8451bf5a2260$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($113e8451bf5a2260$var$NATIVE_BIND$1 ? $113e8451bf5a2260$var$call$a.bind($113e8451bf5a2260$var$apply$2) : function() {
    return $113e8451bf5a2260$var$call$a.apply($113e8451bf5a2260$var$apply$2, arguments);
});
var $113e8451bf5a2260$var$uncurryThis$6 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$aCallable$5 = $113e8451bf5a2260$var$aCallable$7;
var $113e8451bf5a2260$var$NATIVE_BIND = $113e8451bf5a2260$var$functionBindNative;
var $113e8451bf5a2260$var$bind$4 = $113e8451bf5a2260$var$uncurryThis$6($113e8451bf5a2260$var$uncurryThis$6.bind);
// optional / simple context binding
var $113e8451bf5a2260$var$functionBindContext = function functionBindContext(fn, that) {
    $113e8451bf5a2260$var$aCallable$5(fn);
    return that === undefined ? fn : $113e8451bf5a2260$var$NATIVE_BIND ? $113e8451bf5a2260$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $113e8451bf5a2260$var$uncurryThis$5 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$arraySlice$1 = $113e8451bf5a2260$var$uncurryThis$5([].slice);
var $113e8451bf5a2260$var$$TypeError$3 = TypeError;
var $113e8451bf5a2260$var$validateArgumentsLength$1 = function validateArgumentsLength$1(passed, required) {
    if (passed < required) throw $113e8451bf5a2260$var$$TypeError$3("Not enough arguments");
    return passed;
};
var $113e8451bf5a2260$var$userAgent$2 = $113e8451bf5a2260$var$engineUserAgent;
var $113e8451bf5a2260$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($113e8451bf5a2260$var$userAgent$2);
var $113e8451bf5a2260$var$global$b = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$apply$1 = $113e8451bf5a2260$var$functionApply;
var $113e8451bf5a2260$var$bind$3 = $113e8451bf5a2260$var$functionBindContext;
var $113e8451bf5a2260$var$isCallable$5 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$hasOwn = $113e8451bf5a2260$var$hasOwnProperty_1;
var $113e8451bf5a2260$var$fails$5 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$html = $113e8451bf5a2260$var$html$2;
var $113e8451bf5a2260$var$arraySlice = $113e8451bf5a2260$var$arraySlice$1;
var $113e8451bf5a2260$var$createElement = $113e8451bf5a2260$var$documentCreateElement$2;
var $113e8451bf5a2260$var$validateArgumentsLength = $113e8451bf5a2260$var$validateArgumentsLength$1;
var $113e8451bf5a2260$var$IS_IOS$1 = $113e8451bf5a2260$var$engineIsIos;
var $113e8451bf5a2260$var$IS_NODE$2 = $113e8451bf5a2260$var$engineIsNode;
var $113e8451bf5a2260$var$set = $113e8451bf5a2260$var$global$b.setImmediate;
var $113e8451bf5a2260$var$clear = $113e8451bf5a2260$var$global$b.clearImmediate;
var $113e8451bf5a2260$var$process$2 = $113e8451bf5a2260$var$global$b.process;
var $113e8451bf5a2260$var$Dispatch = $113e8451bf5a2260$var$global$b.Dispatch;
var $113e8451bf5a2260$var$Function$1 = $113e8451bf5a2260$var$global$b.Function;
var $113e8451bf5a2260$var$MessageChannel = $113e8451bf5a2260$var$global$b.MessageChannel;
var $113e8451bf5a2260$var$String$1 = $113e8451bf5a2260$var$global$b.String;
var $113e8451bf5a2260$var$counter = 0;
var $113e8451bf5a2260$var$queue$1 = {};
var $113e8451bf5a2260$var$ONREADYSTATECHANGE = "onreadystatechange";
var $113e8451bf5a2260$var$location, $113e8451bf5a2260$var$defer, $113e8451bf5a2260$var$channel, $113e8451bf5a2260$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $113e8451bf5a2260$var$location = $113e8451bf5a2260$var$global$b.location;
} catch (error) {}
var $113e8451bf5a2260$var$run = function run(id) {
    if ($113e8451bf5a2260$var$hasOwn($113e8451bf5a2260$var$queue$1, id)) {
        var fn = $113e8451bf5a2260$var$queue$1[id];
        delete $113e8451bf5a2260$var$queue$1[id];
        fn();
    }
};
var $113e8451bf5a2260$var$runner = function runner(id) {
    return function() {
        $113e8451bf5a2260$var$run(id);
    };
};
var $113e8451bf5a2260$var$listener = function listener(event) {
    $113e8451bf5a2260$var$run(event.data);
};
var $113e8451bf5a2260$var$post = function post(id) {
    // old engines have not location.origin
    $113e8451bf5a2260$var$global$b.postMessage($113e8451bf5a2260$var$String$1(id), $113e8451bf5a2260$var$location.protocol + "//" + $113e8451bf5a2260$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$113e8451bf5a2260$var$set || !$113e8451bf5a2260$var$clear) {
    $113e8451bf5a2260$var$set = function setImmediate(handler) {
        $113e8451bf5a2260$var$validateArgumentsLength(arguments.length, 1);
        var fn = $113e8451bf5a2260$var$isCallable$5(handler) ? handler : $113e8451bf5a2260$var$Function$1(handler);
        var args = $113e8451bf5a2260$var$arraySlice(arguments, 1);
        $113e8451bf5a2260$var$queue$1[++$113e8451bf5a2260$var$counter] = function() {
            $113e8451bf5a2260$var$apply$1(fn, undefined, args);
        };
        $113e8451bf5a2260$var$defer($113e8451bf5a2260$var$counter);
        return $113e8451bf5a2260$var$counter;
    };
    $113e8451bf5a2260$var$clear = function clearImmediate(id) {
        delete $113e8451bf5a2260$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($113e8451bf5a2260$var$IS_NODE$2) $113e8451bf5a2260$var$defer = function defer(id) {
        $113e8451bf5a2260$var$process$2.nextTick($113e8451bf5a2260$var$runner(id));
    };
    else if ($113e8451bf5a2260$var$Dispatch && $113e8451bf5a2260$var$Dispatch.now) $113e8451bf5a2260$var$defer = function defer(id) {
        $113e8451bf5a2260$var$Dispatch.now($113e8451bf5a2260$var$runner(id));
    };
    else if ($113e8451bf5a2260$var$MessageChannel && !$113e8451bf5a2260$var$IS_IOS$1) {
        $113e8451bf5a2260$var$channel = new $113e8451bf5a2260$var$MessageChannel();
        $113e8451bf5a2260$var$port = $113e8451bf5a2260$var$channel.port2;
        $113e8451bf5a2260$var$channel.port1.onmessage = $113e8451bf5a2260$var$listener;
        $113e8451bf5a2260$var$defer = $113e8451bf5a2260$var$bind$3($113e8451bf5a2260$var$port.postMessage, $113e8451bf5a2260$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($113e8451bf5a2260$var$global$b.addEventListener && $113e8451bf5a2260$var$isCallable$5($113e8451bf5a2260$var$global$b.postMessage) && !$113e8451bf5a2260$var$global$b.importScripts && $113e8451bf5a2260$var$location && $113e8451bf5a2260$var$location.protocol !== "file:" && !$113e8451bf5a2260$var$fails$5($113e8451bf5a2260$var$post)) {
        $113e8451bf5a2260$var$defer = $113e8451bf5a2260$var$post;
        $113e8451bf5a2260$var$global$b.addEventListener("message", $113e8451bf5a2260$var$listener, false);
    // IE8-
    } else if ($113e8451bf5a2260$var$ONREADYSTATECHANGE in $113e8451bf5a2260$var$createElement("script")) $113e8451bf5a2260$var$defer = function defer(id) {
        $113e8451bf5a2260$var$html.appendChild($113e8451bf5a2260$var$createElement("script"))[$113e8451bf5a2260$var$ONREADYSTATECHANGE] = function() {
            $113e8451bf5a2260$var$html.removeChild(this);
            $113e8451bf5a2260$var$run(id);
        };
    };
    else $113e8451bf5a2260$var$defer = function defer(id) {
        setTimeout($113e8451bf5a2260$var$runner(id), 0);
    };
}
var $113e8451bf5a2260$var$task$1 = {
    set: $113e8451bf5a2260$var$set,
    clear: $113e8451bf5a2260$var$clear
};
var $113e8451bf5a2260$var$userAgent$1 = $113e8451bf5a2260$var$engineUserAgent;
var $113e8451bf5a2260$var$global$a = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($113e8451bf5a2260$var$userAgent$1) && $113e8451bf5a2260$var$global$a.Pebble !== undefined;
var $113e8451bf5a2260$var$userAgent = $113e8451bf5a2260$var$engineUserAgent;
var $113e8451bf5a2260$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($113e8451bf5a2260$var$userAgent);
var $113e8451bf5a2260$var$global$9 = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$bind$2 = $113e8451bf5a2260$var$functionBindContext;
var $113e8451bf5a2260$var$getOwnPropertyDescriptor = $113e8451bf5a2260$var$objectGetOwnPropertyDescriptor.f;
var $113e8451bf5a2260$var$macrotask = $113e8451bf5a2260$var$task$1.set;
var $113e8451bf5a2260$var$IS_IOS = $113e8451bf5a2260$var$engineIsIos;
var $113e8451bf5a2260$var$IS_IOS_PEBBLE = $113e8451bf5a2260$var$engineIsIosPebble;
var $113e8451bf5a2260$var$IS_WEBOS_WEBKIT = $113e8451bf5a2260$var$engineIsWebosWebkit;
var $113e8451bf5a2260$var$IS_NODE$1 = $113e8451bf5a2260$var$engineIsNode;
var $113e8451bf5a2260$var$MutationObserver = $113e8451bf5a2260$var$global$9.MutationObserver || $113e8451bf5a2260$var$global$9.WebKitMutationObserver;
var $113e8451bf5a2260$var$document$2 = $113e8451bf5a2260$var$global$9.document;
var $113e8451bf5a2260$var$process$1 = $113e8451bf5a2260$var$global$9.process;
var $113e8451bf5a2260$var$Promise$1 = $113e8451bf5a2260$var$global$9.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $113e8451bf5a2260$var$queueMicrotaskDescriptor = $113e8451bf5a2260$var$getOwnPropertyDescriptor($113e8451bf5a2260$var$global$9, "queueMicrotask");
var $113e8451bf5a2260$var$queueMicrotask = $113e8451bf5a2260$var$queueMicrotaskDescriptor && $113e8451bf5a2260$var$queueMicrotaskDescriptor.value;
var $113e8451bf5a2260$var$flush, $113e8451bf5a2260$var$head, $113e8451bf5a2260$var$last, $113e8451bf5a2260$var$notify$1, $113e8451bf5a2260$var$toggle, $113e8451bf5a2260$var$node, $113e8451bf5a2260$var$promise, $113e8451bf5a2260$var$then;
// modern engines have queueMicrotask method
if (!$113e8451bf5a2260$var$queueMicrotask) {
    $113e8451bf5a2260$var$flush = function flush() {
        var parent, fn;
        if ($113e8451bf5a2260$var$IS_NODE$1 && (parent = $113e8451bf5a2260$var$process$1.domain)) parent.exit();
        while($113e8451bf5a2260$var$head){
            fn = $113e8451bf5a2260$var$head.fn;
            $113e8451bf5a2260$var$head = $113e8451bf5a2260$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($113e8451bf5a2260$var$head) $113e8451bf5a2260$var$notify$1();
                else $113e8451bf5a2260$var$last = undefined;
                throw error;
            }
        }
        $113e8451bf5a2260$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$113e8451bf5a2260$var$IS_IOS && !$113e8451bf5a2260$var$IS_NODE$1 && !$113e8451bf5a2260$var$IS_WEBOS_WEBKIT && $113e8451bf5a2260$var$MutationObserver && $113e8451bf5a2260$var$document$2) {
        $113e8451bf5a2260$var$toggle = true;
        $113e8451bf5a2260$var$node = $113e8451bf5a2260$var$document$2.createTextNode("");
        new $113e8451bf5a2260$var$MutationObserver($113e8451bf5a2260$var$flush).observe($113e8451bf5a2260$var$node, {
            characterData: true
        });
        $113e8451bf5a2260$var$notify$1 = function notify$1() {
            $113e8451bf5a2260$var$node.data = $113e8451bf5a2260$var$toggle = !$113e8451bf5a2260$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$113e8451bf5a2260$var$IS_IOS_PEBBLE && $113e8451bf5a2260$var$Promise$1 && $113e8451bf5a2260$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $113e8451bf5a2260$var$promise = $113e8451bf5a2260$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $113e8451bf5a2260$var$promise.constructor = $113e8451bf5a2260$var$Promise$1;
        $113e8451bf5a2260$var$then = $113e8451bf5a2260$var$bind$2($113e8451bf5a2260$var$promise.then, $113e8451bf5a2260$var$promise);
        $113e8451bf5a2260$var$notify$1 = function notify$1() {
            $113e8451bf5a2260$var$then($113e8451bf5a2260$var$flush);
        };
    // Node.js without promises
    } else if ($113e8451bf5a2260$var$IS_NODE$1) $113e8451bf5a2260$var$notify$1 = function notify$1() {
        $113e8451bf5a2260$var$process$1.nextTick($113e8451bf5a2260$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $113e8451bf5a2260$var$macrotask = $113e8451bf5a2260$var$bind$2($113e8451bf5a2260$var$macrotask, $113e8451bf5a2260$var$global$9);
        $113e8451bf5a2260$var$notify$1 = function notify$1() {
            $113e8451bf5a2260$var$macrotask($113e8451bf5a2260$var$flush);
        };
    }
}
var $113e8451bf5a2260$var$microtask$1 = $113e8451bf5a2260$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($113e8451bf5a2260$var$last) $113e8451bf5a2260$var$last.next = task;
    if (!$113e8451bf5a2260$var$head) {
        $113e8451bf5a2260$var$head = task;
        $113e8451bf5a2260$var$notify$1();
    }
    $113e8451bf5a2260$var$last = task;
};
var $113e8451bf5a2260$var$global$8 = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$hostReportErrors$1 = function hostReportErrors$1(a, b) {
    var console = $113e8451bf5a2260$var$global$8.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $113e8451bf5a2260$var$perform$3 = function perform$3(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $113e8451bf5a2260$var$Queue$1 = function Queue$1() {
    this.head = null;
    this.tail = null;
};
$113e8451bf5a2260$var$Queue$1.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $113e8451bf5a2260$var$queue = $113e8451bf5a2260$var$Queue$1;
var $113e8451bf5a2260$var$global$7 = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$promiseNativeConstructor = $113e8451bf5a2260$var$global$7.Promise;
var $113e8451bf5a2260$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $113e8451bf5a2260$var$global$6 = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$NativePromiseConstructor$3 = $113e8451bf5a2260$var$promiseNativeConstructor;
var $113e8451bf5a2260$var$isCallable$4 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$isForced = $113e8451bf5a2260$var$isForced_1;
var $113e8451bf5a2260$var$inspectSource = $113e8451bf5a2260$var$inspectSource$4;
var $113e8451bf5a2260$var$wellKnownSymbol$6 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$IS_BROWSER = $113e8451bf5a2260$var$engineIsBrowser;
var $113e8451bf5a2260$var$V8_VERSION = $113e8451bf5a2260$var$engineV8Version;
$113e8451bf5a2260$var$NativePromiseConstructor$3 && $113e8451bf5a2260$var$NativePromiseConstructor$3.prototype;
var $113e8451bf5a2260$var$SPECIES$1 = $113e8451bf5a2260$var$wellKnownSymbol$6("species");
var $113e8451bf5a2260$var$SUBCLASSING = false;
var $113e8451bf5a2260$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $113e8451bf5a2260$var$isCallable$4($113e8451bf5a2260$var$global$6.PromiseRejectionEvent);
var $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$5 = $113e8451bf5a2260$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $113e8451bf5a2260$var$inspectSource($113e8451bf5a2260$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($113e8451bf5a2260$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $113e8451bf5a2260$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($113e8451bf5a2260$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $113e8451bf5a2260$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function FakePromise(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$113e8451bf5a2260$var$SPECIES$1] = FakePromise;
    $113e8451bf5a2260$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$113e8451bf5a2260$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $113e8451bf5a2260$var$IS_BROWSER && !$113e8451bf5a2260$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $113e8451bf5a2260$var$promiseConstructorDetection = {
    CONSTRUCTOR: $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $113e8451bf5a2260$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $113e8451bf5a2260$var$SUBCLASSING
};
var $113e8451bf5a2260$var$newPromiseCapability$2 = {};
var $113e8451bf5a2260$var$aCallable$4 = $113e8451bf5a2260$var$aCallable$7;
var $113e8451bf5a2260$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $113e8451bf5a2260$var$aCallable$4(resolve);
    this.reject = $113e8451bf5a2260$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$113e8451bf5a2260$var$newPromiseCapability$2.f = function(C) {
    return new $113e8451bf5a2260$var$PromiseCapability(C);
};
var $113e8451bf5a2260$var$$$6 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$IS_NODE = $113e8451bf5a2260$var$engineIsNode;
var $113e8451bf5a2260$var$global$5 = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$call$9 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$defineBuiltIn$2 = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$setPrototypeOf = $113e8451bf5a2260$var$objectSetPrototypeOf;
var $113e8451bf5a2260$var$setToStringTag = $113e8451bf5a2260$var$setToStringTag$3;
var $113e8451bf5a2260$var$setSpecies = $113e8451bf5a2260$var$setSpecies$1;
var $113e8451bf5a2260$var$aCallable$3 = $113e8451bf5a2260$var$aCallable$7;
var $113e8451bf5a2260$var$isCallable$3 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$isObject$1 = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$anInstance = $113e8451bf5a2260$var$anInstance$1;
var $113e8451bf5a2260$var$speciesConstructor = $113e8451bf5a2260$var$speciesConstructor$1;
var $113e8451bf5a2260$var$task = $113e8451bf5a2260$var$task$1.set;
var $113e8451bf5a2260$var$microtask = $113e8451bf5a2260$var$microtask$1;
var $113e8451bf5a2260$var$hostReportErrors = $113e8451bf5a2260$var$hostReportErrors$1;
var $113e8451bf5a2260$var$perform$2 = $113e8451bf5a2260$var$perform$3;
var $113e8451bf5a2260$var$Queue = $113e8451bf5a2260$var$queue;
var $113e8451bf5a2260$var$InternalStateModule = $113e8451bf5a2260$var$internalState;
var $113e8451bf5a2260$var$NativePromiseConstructor$2 = $113e8451bf5a2260$var$promiseNativeConstructor;
var $113e8451bf5a2260$var$PromiseConstructorDetection = $113e8451bf5a2260$var$promiseConstructorDetection;
var $113e8451bf5a2260$var$newPromiseCapabilityModule$3 = $113e8451bf5a2260$var$newPromiseCapability$2;
var $113e8451bf5a2260$var$PROMISE = "Promise";
var $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$4 = $113e8451bf5a2260$var$PromiseConstructorDetection.CONSTRUCTOR;
var $113e8451bf5a2260$var$NATIVE_PROMISE_REJECTION_EVENT = $113e8451bf5a2260$var$PromiseConstructorDetection.REJECTION_EVENT;
var $113e8451bf5a2260$var$NATIVE_PROMISE_SUBCLASSING = $113e8451bf5a2260$var$PromiseConstructorDetection.SUBCLASSING;
var $113e8451bf5a2260$var$getInternalPromiseState = $113e8451bf5a2260$var$InternalStateModule.getterFor($113e8451bf5a2260$var$PROMISE);
var $113e8451bf5a2260$var$setInternalState = $113e8451bf5a2260$var$InternalStateModule.set;
var $113e8451bf5a2260$var$NativePromisePrototype$1 = $113e8451bf5a2260$var$NativePromiseConstructor$2 && $113e8451bf5a2260$var$NativePromiseConstructor$2.prototype;
var $113e8451bf5a2260$var$PromiseConstructor = $113e8451bf5a2260$var$NativePromiseConstructor$2;
var $113e8451bf5a2260$var$PromisePrototype = $113e8451bf5a2260$var$NativePromisePrototype$1;
var $113e8451bf5a2260$var$TypeError$1 = $113e8451bf5a2260$var$global$5.TypeError;
var $113e8451bf5a2260$var$document$1 = $113e8451bf5a2260$var$global$5.document;
var $113e8451bf5a2260$var$process = $113e8451bf5a2260$var$global$5.process;
var $113e8451bf5a2260$var$newPromiseCapability$1 = $113e8451bf5a2260$var$newPromiseCapabilityModule$3.f;
var $113e8451bf5a2260$var$newGenericPromiseCapability = $113e8451bf5a2260$var$newPromiseCapability$1;
var $113e8451bf5a2260$var$DISPATCH_EVENT = !!($113e8451bf5a2260$var$document$1 && $113e8451bf5a2260$var$document$1.createEvent && $113e8451bf5a2260$var$global$5.dispatchEvent);
var $113e8451bf5a2260$var$UNHANDLED_REJECTION = "unhandledrejection";
var $113e8451bf5a2260$var$REJECTION_HANDLED = "rejectionhandled";
var $113e8451bf5a2260$var$PENDING = 0;
var $113e8451bf5a2260$var$FULFILLED = 1;
var $113e8451bf5a2260$var$REJECTED = 2;
var $113e8451bf5a2260$var$HANDLED = 1;
var $113e8451bf5a2260$var$UNHANDLED = 2;
var $113e8451bf5a2260$var$Internal, $113e8451bf5a2260$var$OwnPromiseCapability, $113e8451bf5a2260$var$PromiseWrapper, $113e8451bf5a2260$var$nativeThen;
// helpers
var $113e8451bf5a2260$var$isThenable = function isThenable(it) {
    var then;
    return $113e8451bf5a2260$var$isObject$1(it) && $113e8451bf5a2260$var$isCallable$3(then = it.then) ? then : false;
};
var $113e8451bf5a2260$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state == $113e8451bf5a2260$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $113e8451bf5a2260$var$UNHANDLED) $113e8451bf5a2260$var$onHandleUnhandled(state);
                state.rejection = $113e8451bf5a2260$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($113e8451bf5a2260$var$TypeError$1("Promise-chain cycle"));
            else if (then = $113e8451bf5a2260$var$isThenable(result)) $113e8451bf5a2260$var$call$9(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $113e8451bf5a2260$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $113e8451bf5a2260$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$113e8451bf5a2260$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $113e8451bf5a2260$var$onUnhandled(state);
    });
};
var $113e8451bf5a2260$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($113e8451bf5a2260$var$DISPATCH_EVENT) {
        event = $113e8451bf5a2260$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $113e8451bf5a2260$var$global$5.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$113e8451bf5a2260$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $113e8451bf5a2260$var$global$5["on" + name])) handler(event);
    else if (name === $113e8451bf5a2260$var$UNHANDLED_REJECTION) $113e8451bf5a2260$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $113e8451bf5a2260$var$onUnhandled = function onUnhandled(state) {
    $113e8451bf5a2260$var$call$9($113e8451bf5a2260$var$task, $113e8451bf5a2260$var$global$5, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $113e8451bf5a2260$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $113e8451bf5a2260$var$perform$2(function() {
                if ($113e8451bf5a2260$var$IS_NODE) $113e8451bf5a2260$var$process.emit("unhandledRejection", value, promise);
                else $113e8451bf5a2260$var$dispatchEvent($113e8451bf5a2260$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $113e8451bf5a2260$var$IS_NODE || $113e8451bf5a2260$var$isUnhandled(state) ? $113e8451bf5a2260$var$UNHANDLED : $113e8451bf5a2260$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $113e8451bf5a2260$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $113e8451bf5a2260$var$HANDLED && !state.parent;
};
var $113e8451bf5a2260$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $113e8451bf5a2260$var$call$9($113e8451bf5a2260$var$task, $113e8451bf5a2260$var$global$5, function() {
        var promise = state.facade;
        if ($113e8451bf5a2260$var$IS_NODE) $113e8451bf5a2260$var$process.emit("rejectionHandled", promise);
        else $113e8451bf5a2260$var$dispatchEvent($113e8451bf5a2260$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $113e8451bf5a2260$var$bind$1 = function bind$1(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $113e8451bf5a2260$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $113e8451bf5a2260$var$REJECTED;
    $113e8451bf5a2260$var$notify(state, true);
};
var $113e8451bf5a2260$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $113e8451bf5a2260$var$TypeError$1("Promise can't be resolved itself");
        var then = $113e8451bf5a2260$var$isThenable(value);
        if (then) $113e8451bf5a2260$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $113e8451bf5a2260$var$call$9(then, value, $113e8451bf5a2260$var$bind$1($113e8451bf5a2260$var$internalResolve, wrapper, state), $113e8451bf5a2260$var$bind$1($113e8451bf5a2260$var$internalReject, wrapper, state));
            } catch (error) {
                $113e8451bf5a2260$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $113e8451bf5a2260$var$FULFILLED;
            $113e8451bf5a2260$var$notify(state, false);
        }
    } catch (error) {
        $113e8451bf5a2260$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $113e8451bf5a2260$var$PromiseConstructor = function Promise1(executor) {
        $113e8451bf5a2260$var$anInstance(this, $113e8451bf5a2260$var$PromisePrototype);
        $113e8451bf5a2260$var$aCallable$3(executor);
        $113e8451bf5a2260$var$call$9($113e8451bf5a2260$var$Internal, this);
        var state = $113e8451bf5a2260$var$getInternalPromiseState(this);
        try {
            executor($113e8451bf5a2260$var$bind$1($113e8451bf5a2260$var$internalResolve, state), $113e8451bf5a2260$var$bind$1($113e8451bf5a2260$var$internalReject, state));
        } catch (error) {
            $113e8451bf5a2260$var$internalReject(state, error);
        }
    };
    $113e8451bf5a2260$var$PromisePrototype = $113e8451bf5a2260$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $113e8451bf5a2260$var$Internal = function Promise1(executor) {
        $113e8451bf5a2260$var$setInternalState(this, {
            type: $113e8451bf5a2260$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $113e8451bf5a2260$var$Queue(),
            rejection: false,
            state: $113e8451bf5a2260$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $113e8451bf5a2260$var$Internal.prototype = $113e8451bf5a2260$var$defineBuiltIn$2($113e8451bf5a2260$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $113e8451bf5a2260$var$getInternalPromiseState(this);
        var reaction = $113e8451bf5a2260$var$newPromiseCapability$1($113e8451bf5a2260$var$speciesConstructor(this, $113e8451bf5a2260$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $113e8451bf5a2260$var$isCallable$3(onFulfilled) ? onFulfilled : true;
        reaction.fail = $113e8451bf5a2260$var$isCallable$3(onRejected) && onRejected;
        reaction.domain = $113e8451bf5a2260$var$IS_NODE ? $113e8451bf5a2260$var$process.domain : undefined;
        if (state.state == $113e8451bf5a2260$var$PENDING) state.reactions.add(reaction);
        else $113e8451bf5a2260$var$microtask(function() {
            $113e8451bf5a2260$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $113e8451bf5a2260$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $113e8451bf5a2260$var$Internal();
        var state = $113e8451bf5a2260$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $113e8451bf5a2260$var$bind$1($113e8451bf5a2260$var$internalResolve, state);
        this.reject = $113e8451bf5a2260$var$bind$1($113e8451bf5a2260$var$internalReject, state);
    };
    $113e8451bf5a2260$var$newPromiseCapabilityModule$3.f = $113e8451bf5a2260$var$newPromiseCapability$1 = function newPromiseCapability$1(C) {
        return C === $113e8451bf5a2260$var$PromiseConstructor || C === $113e8451bf5a2260$var$PromiseWrapper ? new $113e8451bf5a2260$var$OwnPromiseCapability(C) : $113e8451bf5a2260$var$newGenericPromiseCapability(C);
    };
    if ($113e8451bf5a2260$var$isCallable$3($113e8451bf5a2260$var$NativePromiseConstructor$2) && $113e8451bf5a2260$var$NativePromisePrototype$1 !== Object.prototype) {
        $113e8451bf5a2260$var$nativeThen = $113e8451bf5a2260$var$NativePromisePrototype$1.then;
        if (!$113e8451bf5a2260$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $113e8451bf5a2260$var$defineBuiltIn$2($113e8451bf5a2260$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $113e8451bf5a2260$var$PromiseConstructor(function(resolve, reject) {
                $113e8451bf5a2260$var$call$9($113e8451bf5a2260$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $113e8451bf5a2260$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($113e8451bf5a2260$var$setPrototypeOf) $113e8451bf5a2260$var$setPrototypeOf($113e8451bf5a2260$var$NativePromisePrototype$1, $113e8451bf5a2260$var$PromisePrototype);
    }
}
$113e8451bf5a2260$var$$$6({
    global: true,
    constructor: true,
    wrap: true,
    forced: $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $113e8451bf5a2260$var$PromiseConstructor
});
$113e8451bf5a2260$var$setToStringTag($113e8451bf5a2260$var$PromiseConstructor, $113e8451bf5a2260$var$PROMISE, false);
$113e8451bf5a2260$var$setSpecies($113e8451bf5a2260$var$PROMISE);
var $113e8451bf5a2260$var$wellKnownSymbol$5 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$Iterators$1 = $113e8451bf5a2260$var$iterators;
var $113e8451bf5a2260$var$ITERATOR$3 = $113e8451bf5a2260$var$wellKnownSymbol$5("iterator");
var $113e8451bf5a2260$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $113e8451bf5a2260$var$isArrayIteratorMethod$1 = function isArrayIteratorMethod$1(it) {
    return it !== undefined && ($113e8451bf5a2260$var$Iterators$1.Array === it || $113e8451bf5a2260$var$ArrayPrototype[$113e8451bf5a2260$var$ITERATOR$3] === it);
};
var $113e8451bf5a2260$var$classof$1 = $113e8451bf5a2260$var$classof$5;
var $113e8451bf5a2260$var$getMethod$2 = $113e8451bf5a2260$var$getMethod$4;
var $113e8451bf5a2260$var$Iterators = $113e8451bf5a2260$var$iterators;
var $113e8451bf5a2260$var$wellKnownSymbol$4 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$ITERATOR$2 = $113e8451bf5a2260$var$wellKnownSymbol$4("iterator");
var $113e8451bf5a2260$var$getIteratorMethod$2 = function getIteratorMethod$2(it) {
    if (it != undefined) return $113e8451bf5a2260$var$getMethod$2(it, $113e8451bf5a2260$var$ITERATOR$2) || $113e8451bf5a2260$var$getMethod$2(it, "@@iterator") || $113e8451bf5a2260$var$Iterators[$113e8451bf5a2260$var$classof$1(it)];
};
var $113e8451bf5a2260$var$call$8 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$aCallable$2 = $113e8451bf5a2260$var$aCallable$7;
var $113e8451bf5a2260$var$anObject$5 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$tryToString$1 = $113e8451bf5a2260$var$tryToString$4;
var $113e8451bf5a2260$var$getIteratorMethod$1 = $113e8451bf5a2260$var$getIteratorMethod$2;
var $113e8451bf5a2260$var$$TypeError$2 = TypeError;
var $113e8451bf5a2260$var$getIterator$1 = function getIterator$1(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $113e8451bf5a2260$var$getIteratorMethod$1(argument) : usingIterator;
    if ($113e8451bf5a2260$var$aCallable$2(iteratorMethod)) return $113e8451bf5a2260$var$anObject$5($113e8451bf5a2260$var$call$8(iteratorMethod, argument));
    throw $113e8451bf5a2260$var$$TypeError$2($113e8451bf5a2260$var$tryToString$1(argument) + " is not iterable");
};
var $113e8451bf5a2260$var$call$7 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$anObject$4 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$getMethod$1 = $113e8451bf5a2260$var$getMethod$4;
var $113e8451bf5a2260$var$iteratorClose$1 = function iteratorClose$1(iterator, kind, value) {
    var innerResult, innerError;
    $113e8451bf5a2260$var$anObject$4(iterator);
    try {
        innerResult = $113e8451bf5a2260$var$getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $113e8451bf5a2260$var$call$7(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $113e8451bf5a2260$var$anObject$4(innerResult);
    return value;
};
var $113e8451bf5a2260$var$bind = $113e8451bf5a2260$var$functionBindContext;
var $113e8451bf5a2260$var$call$6 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$anObject$3 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$tryToString = $113e8451bf5a2260$var$tryToString$4;
var $113e8451bf5a2260$var$isArrayIteratorMethod = $113e8451bf5a2260$var$isArrayIteratorMethod$1;
var $113e8451bf5a2260$var$lengthOfArrayLike = $113e8451bf5a2260$var$lengthOfArrayLike$2;
var $113e8451bf5a2260$var$isPrototypeOf = $113e8451bf5a2260$var$objectIsPrototypeOf;
var $113e8451bf5a2260$var$getIterator = $113e8451bf5a2260$var$getIterator$1;
var $113e8451bf5a2260$var$getIteratorMethod = $113e8451bf5a2260$var$getIteratorMethod$2;
var $113e8451bf5a2260$var$iteratorClose = $113e8451bf5a2260$var$iteratorClose$1;
var $113e8451bf5a2260$var$$TypeError$1 = TypeError;
var $113e8451bf5a2260$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $113e8451bf5a2260$var$ResultPrototype = $113e8451bf5a2260$var$Result.prototype;
var $113e8451bf5a2260$var$iterate$2 = function iterate$2(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $113e8451bf5a2260$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $113e8451bf5a2260$var$iteratorClose(iterator, "normal", condition);
        return new $113e8451bf5a2260$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $113e8451bf5a2260$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $113e8451bf5a2260$var$getIteratorMethod(iterable);
        if (!iterFn) throw $113e8451bf5a2260$var$$TypeError$1($113e8451bf5a2260$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($113e8451bf5a2260$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $113e8451bf5a2260$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $113e8451bf5a2260$var$isPrototypeOf($113e8451bf5a2260$var$ResultPrototype, result)) return result;
            }
            return new $113e8451bf5a2260$var$Result(false);
        }
        iterator = $113e8451bf5a2260$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $113e8451bf5a2260$var$call$6(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $113e8451bf5a2260$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $113e8451bf5a2260$var$isPrototypeOf($113e8451bf5a2260$var$ResultPrototype, result)) return result;
    }
    return new $113e8451bf5a2260$var$Result(false);
};
var $113e8451bf5a2260$var$wellKnownSymbol$3 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$ITERATOR$1 = $113e8451bf5a2260$var$wellKnownSymbol$3("iterator");
var $113e8451bf5a2260$var$SAFE_CLOSING = false;
try {
    var $113e8451bf5a2260$var$called = 0;
    var $113e8451bf5a2260$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$113e8451bf5a2260$var$called++
            };
        },
        "return": function() {
            $113e8451bf5a2260$var$SAFE_CLOSING = true;
        }
    };
    $113e8451bf5a2260$var$iteratorWithReturn[$113e8451bf5a2260$var$ITERATOR$1] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($113e8451bf5a2260$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $113e8451bf5a2260$var$checkCorrectnessOfIteration$1 = function checkCorrectnessOfIteration$1(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$113e8451bf5a2260$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$113e8451bf5a2260$var$ITERATOR$1] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $113e8451bf5a2260$var$NativePromiseConstructor$1 = $113e8451bf5a2260$var$promiseNativeConstructor;
var $113e8451bf5a2260$var$checkCorrectnessOfIteration = $113e8451bf5a2260$var$checkCorrectnessOfIteration$1;
var $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$3 = $113e8451bf5a2260$var$promiseConstructorDetection.CONSTRUCTOR;
var $113e8451bf5a2260$var$promiseStaticsIncorrectIteration = $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$113e8451bf5a2260$var$checkCorrectnessOfIteration(function(iterable) {
    $113e8451bf5a2260$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $113e8451bf5a2260$var$$$5 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$call$5 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$aCallable$1 = $113e8451bf5a2260$var$aCallable$7;
var $113e8451bf5a2260$var$newPromiseCapabilityModule$2 = $113e8451bf5a2260$var$newPromiseCapability$2;
var $113e8451bf5a2260$var$perform$1 = $113e8451bf5a2260$var$perform$3;
var $113e8451bf5a2260$var$iterate$1 = $113e8451bf5a2260$var$iterate$2;
var $113e8451bf5a2260$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $113e8451bf5a2260$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$113e8451bf5a2260$var$$$5({
    target: "Promise",
    stat: true,
    forced: $113e8451bf5a2260$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $113e8451bf5a2260$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $113e8451bf5a2260$var$perform$1(function() {
            var $promiseResolve = $113e8451bf5a2260$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $113e8451bf5a2260$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $113e8451bf5a2260$var$call$5($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $113e8451bf5a2260$var$$$4 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$2 = $113e8451bf5a2260$var$promiseConstructorDetection.CONSTRUCTOR;
var $113e8451bf5a2260$var$NativePromiseConstructor = $113e8451bf5a2260$var$promiseNativeConstructor;
var $113e8451bf5a2260$var$getBuiltIn$1 = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$isCallable$2 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$defineBuiltIn$1 = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$NativePromisePrototype = $113e8451bf5a2260$var$NativePromiseConstructor && $113e8451bf5a2260$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$113e8451bf5a2260$var$$$4({
    target: "Promise",
    proto: true,
    forced: $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($113e8451bf5a2260$var$isCallable$2($113e8451bf5a2260$var$NativePromiseConstructor)) {
    var $113e8451bf5a2260$var$method = $113e8451bf5a2260$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($113e8451bf5a2260$var$NativePromisePrototype["catch"] !== $113e8451bf5a2260$var$method) $113e8451bf5a2260$var$defineBuiltIn$1($113e8451bf5a2260$var$NativePromisePrototype, "catch", $113e8451bf5a2260$var$method, {
        unsafe: true
    });
}
var $113e8451bf5a2260$var$$$3 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$call$4 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$aCallable = $113e8451bf5a2260$var$aCallable$7;
var $113e8451bf5a2260$var$newPromiseCapabilityModule$1 = $113e8451bf5a2260$var$newPromiseCapability$2;
var $113e8451bf5a2260$var$perform = $113e8451bf5a2260$var$perform$3;
var $113e8451bf5a2260$var$iterate = $113e8451bf5a2260$var$iterate$2;
var $113e8451bf5a2260$var$PROMISE_STATICS_INCORRECT_ITERATION = $113e8451bf5a2260$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$113e8451bf5a2260$var$$$3({
    target: "Promise",
    stat: true,
    forced: $113e8451bf5a2260$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $113e8451bf5a2260$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $113e8451bf5a2260$var$perform(function() {
            var $promiseResolve = $113e8451bf5a2260$var$aCallable(C.resolve);
            $113e8451bf5a2260$var$iterate(iterable, function(promise) {
                $113e8451bf5a2260$var$call$4($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $113e8451bf5a2260$var$$$2 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$call$3 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$newPromiseCapabilityModule = $113e8451bf5a2260$var$newPromiseCapability$2;
var $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$1 = $113e8451bf5a2260$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$113e8451bf5a2260$var$$$2({
    target: "Promise",
    stat: true,
    forced: $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $113e8451bf5a2260$var$newPromiseCapabilityModule.f(this);
        $113e8451bf5a2260$var$call$3(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $113e8451bf5a2260$var$anObject$2 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$isObject = $113e8451bf5a2260$var$isObject$7;
var $113e8451bf5a2260$var$newPromiseCapability = $113e8451bf5a2260$var$newPromiseCapability$2;
var $113e8451bf5a2260$var$promiseResolve$1 = function promiseResolve$1(C, x) {
    $113e8451bf5a2260$var$anObject$2(C);
    if ($113e8451bf5a2260$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $113e8451bf5a2260$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $113e8451bf5a2260$var$$$1 = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$getBuiltIn = $113e8451bf5a2260$var$getBuiltIn$8;
var $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR = $113e8451bf5a2260$var$promiseConstructorDetection.CONSTRUCTOR;
var $113e8451bf5a2260$var$promiseResolve = $113e8451bf5a2260$var$promiseResolve$1;
$113e8451bf5a2260$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$113e8451bf5a2260$var$$$1({
    target: "Promise",
    stat: true,
    forced: $113e8451bf5a2260$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $113e8451bf5a2260$var$promiseResolve(this, x);
    }
});
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $113e8451bf5a2260$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $113e8451bf5a2260$var$documentCreateElement = $113e8451bf5a2260$var$documentCreateElement$2;
var $113e8451bf5a2260$var$classList = $113e8451bf5a2260$var$documentCreateElement("span").classList;
var $113e8451bf5a2260$var$DOMTokenListPrototype$1 = $113e8451bf5a2260$var$classList && $113e8451bf5a2260$var$classList.constructor && $113e8451bf5a2260$var$classList.constructor.prototype;
var $113e8451bf5a2260$var$domTokenListPrototype = $113e8451bf5a2260$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $113e8451bf5a2260$var$DOMTokenListPrototype$1;
var $113e8451bf5a2260$var$global$4 = $113e8451bf5a2260$var$global$m;
var $113e8451bf5a2260$var$DOMIterables = $113e8451bf5a2260$var$domIterables;
var $113e8451bf5a2260$var$DOMTokenListPrototype = $113e8451bf5a2260$var$domTokenListPrototype;
var $113e8451bf5a2260$var$ArrayIteratorMethods = $113e8451bf5a2260$var$es_array_iterator;
var $113e8451bf5a2260$var$createNonEnumerableProperty$1 = $113e8451bf5a2260$var$createNonEnumerableProperty$5;
var $113e8451bf5a2260$var$wellKnownSymbol$2 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$ITERATOR = $113e8451bf5a2260$var$wellKnownSymbol$2("iterator");
var $113e8451bf5a2260$var$TO_STRING_TAG = $113e8451bf5a2260$var$wellKnownSymbol$2("toStringTag");
var $113e8451bf5a2260$var$ArrayValues = $113e8451bf5a2260$var$ArrayIteratorMethods.values;
var $113e8451bf5a2260$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$113e8451bf5a2260$var$ITERATOR] !== $113e8451bf5a2260$var$ArrayValues) try {
            $113e8451bf5a2260$var$createNonEnumerableProperty$1(CollectionPrototype, $113e8451bf5a2260$var$ITERATOR, $113e8451bf5a2260$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$113e8451bf5a2260$var$ITERATOR] = $113e8451bf5a2260$var$ArrayValues;
        }
        if (!CollectionPrototype[$113e8451bf5a2260$var$TO_STRING_TAG]) $113e8451bf5a2260$var$createNonEnumerableProperty$1(CollectionPrototype, $113e8451bf5a2260$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($113e8451bf5a2260$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $113e8451bf5a2260$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $113e8451bf5a2260$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $113e8451bf5a2260$var$createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, $113e8451bf5a2260$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $113e8451bf5a2260$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $113e8451bf5a2260$var$COLLECTION_NAME in $113e8451bf5a2260$var$DOMIterables)$113e8451bf5a2260$var$handlePrototype($113e8451bf5a2260$var$global$4[$113e8451bf5a2260$var$COLLECTION_NAME] && $113e8451bf5a2260$var$global$4[$113e8451bf5a2260$var$COLLECTION_NAME].prototype, $113e8451bf5a2260$var$COLLECTION_NAME);
$113e8451bf5a2260$var$handlePrototype($113e8451bf5a2260$var$DOMTokenListPrototype, "DOMTokenList");
var $113e8451bf5a2260$var$fails$4 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$global$3 = $113e8451bf5a2260$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $113e8451bf5a2260$var$$RegExp$2 = $113e8451bf5a2260$var$global$3.RegExp;
var $113e8451bf5a2260$var$UNSUPPORTED_Y$1 = $113e8451bf5a2260$var$fails$4(function() {
    var re = $113e8451bf5a2260$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $113e8451bf5a2260$var$MISSED_STICKY = $113e8451bf5a2260$var$UNSUPPORTED_Y$1 || $113e8451bf5a2260$var$fails$4(function() {
    return !$113e8451bf5a2260$var$$RegExp$2("a", "y").sticky;
});
var $113e8451bf5a2260$var$BROKEN_CARET = $113e8451bf5a2260$var$UNSUPPORTED_Y$1 || $113e8451bf5a2260$var$fails$4(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $113e8451bf5a2260$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $113e8451bf5a2260$var$regexpStickyHelpers = {
    BROKEN_CARET: $113e8451bf5a2260$var$BROKEN_CARET,
    MISSED_STICKY: $113e8451bf5a2260$var$MISSED_STICKY,
    UNSUPPORTED_Y: $113e8451bf5a2260$var$UNSUPPORTED_Y$1
};
var $113e8451bf5a2260$var$fails$3 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$global$2 = $113e8451bf5a2260$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $113e8451bf5a2260$var$$RegExp$1 = $113e8451bf5a2260$var$global$2.RegExp;
var $113e8451bf5a2260$var$regexpUnsupportedDotAll = $113e8451bf5a2260$var$fails$3(function() {
    var re = $113e8451bf5a2260$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $113e8451bf5a2260$var$fails$2 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$global$1 = $113e8451bf5a2260$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $113e8451bf5a2260$var$$RegExp = $113e8451bf5a2260$var$global$1.RegExp;
var $113e8451bf5a2260$var$regexpUnsupportedNcg = $113e8451bf5a2260$var$fails$2(function() {
    var re = $113e8451bf5a2260$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $113e8451bf5a2260$var$call$2 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$uncurryThis$4 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$toString$2 = $113e8451bf5a2260$var$toString$3;
var $113e8451bf5a2260$var$regexpFlags = $113e8451bf5a2260$var$regexpFlags$1;
var $113e8451bf5a2260$var$stickyHelpers = $113e8451bf5a2260$var$regexpStickyHelpers;
var $113e8451bf5a2260$var$shared = $113e8451bf5a2260$var$shared$4.exports;
var $113e8451bf5a2260$var$create = $113e8451bf5a2260$var$objectCreate;
var $113e8451bf5a2260$var$getInternalState = $113e8451bf5a2260$var$internalState.get;
var $113e8451bf5a2260$var$UNSUPPORTED_DOT_ALL = $113e8451bf5a2260$var$regexpUnsupportedDotAll;
var $113e8451bf5a2260$var$UNSUPPORTED_NCG = $113e8451bf5a2260$var$regexpUnsupportedNcg;
var $113e8451bf5a2260$var$nativeReplace = $113e8451bf5a2260$var$shared("native-string-replace", String.prototype.replace);
var $113e8451bf5a2260$var$nativeExec = RegExp.prototype.exec;
var $113e8451bf5a2260$var$patchedExec = $113e8451bf5a2260$var$nativeExec;
var $113e8451bf5a2260$var$charAt$3 = $113e8451bf5a2260$var$uncurryThis$4("".charAt);
var $113e8451bf5a2260$var$indexOf = $113e8451bf5a2260$var$uncurryThis$4("".indexOf);
var $113e8451bf5a2260$var$replace$1 = $113e8451bf5a2260$var$uncurryThis$4("".replace);
var $113e8451bf5a2260$var$stringSlice$3 = $113e8451bf5a2260$var$uncurryThis$4("".slice);
var $113e8451bf5a2260$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $113e8451bf5a2260$var$call$2($113e8451bf5a2260$var$nativeExec, re1, "a");
    $113e8451bf5a2260$var$call$2($113e8451bf5a2260$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $113e8451bf5a2260$var$UNSUPPORTED_Y = $113e8451bf5a2260$var$stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $113e8451bf5a2260$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $113e8451bf5a2260$var$PATCH = $113e8451bf5a2260$var$UPDATES_LAST_INDEX_WRONG || $113e8451bf5a2260$var$NPCG_INCLUDED || $113e8451bf5a2260$var$UNSUPPORTED_Y || $113e8451bf5a2260$var$UNSUPPORTED_DOT_ALL || $113e8451bf5a2260$var$UNSUPPORTED_NCG;
if ($113e8451bf5a2260$var$PATCH) $113e8451bf5a2260$var$patchedExec = function exec(string) {
    var re = this;
    var state = $113e8451bf5a2260$var$getInternalState(re);
    var str = $113e8451bf5a2260$var$toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $113e8451bf5a2260$var$call$2($113e8451bf5a2260$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $113e8451bf5a2260$var$UNSUPPORTED_Y && re.sticky;
    var flags = $113e8451bf5a2260$var$call$2($113e8451bf5a2260$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $113e8451bf5a2260$var$replace$1(flags, "y", "");
        if ($113e8451bf5a2260$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $113e8451bf5a2260$var$stringSlice$3(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $113e8451bf5a2260$var$charAt$3(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($113e8451bf5a2260$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($113e8451bf5a2260$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $113e8451bf5a2260$var$call$2($113e8451bf5a2260$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $113e8451bf5a2260$var$stringSlice$3(match.input, charsAdded);
            match[0] = $113e8451bf5a2260$var$stringSlice$3(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($113e8451bf5a2260$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($113e8451bf5a2260$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $113e8451bf5a2260$var$call$2($113e8451bf5a2260$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $113e8451bf5a2260$var$create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $113e8451bf5a2260$var$regexpExec$2 = $113e8451bf5a2260$var$patchedExec;
var $113e8451bf5a2260$var$$ = $113e8451bf5a2260$var$_export;
var $113e8451bf5a2260$var$exec = $113e8451bf5a2260$var$regexpExec$2;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$113e8451bf5a2260$var$$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $113e8451bf5a2260$var$exec
}, {
    exec: $113e8451bf5a2260$var$exec
});
// TODO: Remove from `core-js@4` since it's moved to entry points
var $113e8451bf5a2260$var$uncurryThis$3 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$defineBuiltIn = $113e8451bf5a2260$var$defineBuiltIn$7;
var $113e8451bf5a2260$var$regexpExec$1 = $113e8451bf5a2260$var$regexpExec$2;
var $113e8451bf5a2260$var$fails$1 = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$wellKnownSymbol$1 = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$createNonEnumerableProperty = $113e8451bf5a2260$var$createNonEnumerableProperty$5;
var $113e8451bf5a2260$var$SPECIES = $113e8451bf5a2260$var$wellKnownSymbol$1("species");
var $113e8451bf5a2260$var$RegExpPrototype = RegExp.prototype;
var $113e8451bf5a2260$var$fixRegexpWellKnownSymbolLogic = function fixRegexpWellKnownSymbolLogic(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $113e8451bf5a2260$var$wellKnownSymbol$1(KEY);
    var DELEGATES_TO_SYMBOL = !$113e8451bf5a2260$var$fails$1(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$113e8451bf5a2260$var$fails$1(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$113e8451bf5a2260$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $113e8451bf5a2260$var$uncurryThis$3(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $113e8451bf5a2260$var$uncurryThis$3(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $113e8451bf5a2260$var$regexpExec$1 || $exec === $113e8451bf5a2260$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $113e8451bf5a2260$var$defineBuiltIn(String.prototype, KEY, methods[0]);
        $113e8451bf5a2260$var$defineBuiltIn($113e8451bf5a2260$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $113e8451bf5a2260$var$createNonEnumerableProperty($113e8451bf5a2260$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $113e8451bf5a2260$var$uncurryThis$2 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$toIntegerOrInfinity$1 = $113e8451bf5a2260$var$toIntegerOrInfinity$4;
var $113e8451bf5a2260$var$toString$1 = $113e8451bf5a2260$var$toString$3;
var $113e8451bf5a2260$var$requireObjectCoercible$1 = $113e8451bf5a2260$var$requireObjectCoercible$4;
var $113e8451bf5a2260$var$charAt$2 = $113e8451bf5a2260$var$uncurryThis$2("".charAt);
var $113e8451bf5a2260$var$charCodeAt = $113e8451bf5a2260$var$uncurryThis$2("".charCodeAt);
var $113e8451bf5a2260$var$stringSlice$2 = $113e8451bf5a2260$var$uncurryThis$2("".slice);
var $113e8451bf5a2260$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $113e8451bf5a2260$var$toString$1($113e8451bf5a2260$var$requireObjectCoercible$1($this));
        var position = $113e8451bf5a2260$var$toIntegerOrInfinity$1(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $113e8451bf5a2260$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $113e8451bf5a2260$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $113e8451bf5a2260$var$charAt$2(S, position) : first : CONVERT_TO_STRING ? $113e8451bf5a2260$var$stringSlice$2(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $113e8451bf5a2260$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $113e8451bf5a2260$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $113e8451bf5a2260$var$createMethod(true)
};
var $113e8451bf5a2260$var$charAt$1 = $113e8451bf5a2260$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $113e8451bf5a2260$var$advanceStringIndex$1 = function advanceStringIndex$1(S, index, unicode) {
    return index + (unicode ? $113e8451bf5a2260$var$charAt$1(S, index).length : 1);
};
var $113e8451bf5a2260$var$uncurryThis$1 = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$toObject = $113e8451bf5a2260$var$toObject$4;
var $113e8451bf5a2260$var$floor = Math.floor;
var $113e8451bf5a2260$var$charAt = $113e8451bf5a2260$var$uncurryThis$1("".charAt);
var $113e8451bf5a2260$var$replace = $113e8451bf5a2260$var$uncurryThis$1("".replace);
var $113e8451bf5a2260$var$stringSlice$1 = $113e8451bf5a2260$var$uncurryThis$1("".slice);
var $113e8451bf5a2260$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $113e8451bf5a2260$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var $113e8451bf5a2260$var$getSubstitution$1 = function getSubstitution$1(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $113e8451bf5a2260$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $113e8451bf5a2260$var$toObject(namedCaptures);
        symbols = $113e8451bf5a2260$var$SUBSTITUTION_SYMBOLS;
    }
    return $113e8451bf5a2260$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($113e8451bf5a2260$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $113e8451bf5a2260$var$stringSlice$1(str, 0, position);
            case "'":
                return $113e8451bf5a2260$var$stringSlice$1(str, tailPos);
            case "<":
                capture = namedCaptures[$113e8451bf5a2260$var$stringSlice$1(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $113e8451bf5a2260$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $113e8451bf5a2260$var$charAt(ch, 1) : captures[f - 1] + $113e8451bf5a2260$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};
var $113e8451bf5a2260$var$call$1 = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$anObject$1 = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$isCallable$1 = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$classof = $113e8451bf5a2260$var$classofRaw$1;
var $113e8451bf5a2260$var$regexpExec = $113e8451bf5a2260$var$regexpExec$2;
var $113e8451bf5a2260$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $113e8451bf5a2260$var$regexpExecAbstract = function regexpExecAbstract(R, S) {
    var exec = R.exec;
    if ($113e8451bf5a2260$var$isCallable$1(exec)) {
        var result = $113e8451bf5a2260$var$call$1(exec, R, S);
        if (result !== null) $113e8451bf5a2260$var$anObject$1(result);
        return result;
    }
    if ($113e8451bf5a2260$var$classof(R) === "RegExp") return $113e8451bf5a2260$var$call$1($113e8451bf5a2260$var$regexpExec, R, S);
    throw $113e8451bf5a2260$var$$TypeError("RegExp#exec called on incompatible receiver");
};
var $113e8451bf5a2260$var$apply = $113e8451bf5a2260$var$functionApply;
var $113e8451bf5a2260$var$call = $113e8451bf5a2260$var$functionCall;
var $113e8451bf5a2260$var$uncurryThis = $113e8451bf5a2260$var$functionUncurryThis;
var $113e8451bf5a2260$var$fixRegExpWellKnownSymbolLogic = $113e8451bf5a2260$var$fixRegexpWellKnownSymbolLogic;
var $113e8451bf5a2260$var$fails = $113e8451bf5a2260$var$fails$j;
var $113e8451bf5a2260$var$anObject = $113e8451bf5a2260$var$anObject$e;
var $113e8451bf5a2260$var$isCallable = $113e8451bf5a2260$var$isCallable$m;
var $113e8451bf5a2260$var$toIntegerOrInfinity = $113e8451bf5a2260$var$toIntegerOrInfinity$4;
var $113e8451bf5a2260$var$toLength = $113e8451bf5a2260$var$toLength$2;
var $113e8451bf5a2260$var$toString = $113e8451bf5a2260$var$toString$3;
var $113e8451bf5a2260$var$requireObjectCoercible = $113e8451bf5a2260$var$requireObjectCoercible$4;
var $113e8451bf5a2260$var$advanceStringIndex = $113e8451bf5a2260$var$advanceStringIndex$1;
var $113e8451bf5a2260$var$getMethod = $113e8451bf5a2260$var$getMethod$4;
var $113e8451bf5a2260$var$getSubstitution = $113e8451bf5a2260$var$getSubstitution$1;
var $113e8451bf5a2260$var$regExpExec = $113e8451bf5a2260$var$regexpExecAbstract;
var $113e8451bf5a2260$var$wellKnownSymbol = $113e8451bf5a2260$var$wellKnownSymbol$g;
var $113e8451bf5a2260$var$REPLACE = $113e8451bf5a2260$var$wellKnownSymbol("replace");
var $113e8451bf5a2260$var$max = Math.max;
var $113e8451bf5a2260$var$min = Math.min;
var $113e8451bf5a2260$var$concat = $113e8451bf5a2260$var$uncurryThis([].concat);
var $113e8451bf5a2260$var$push = $113e8451bf5a2260$var$uncurryThis([].push);
var $113e8451bf5a2260$var$stringIndexOf = $113e8451bf5a2260$var$uncurryThis("".indexOf);
var $113e8451bf5a2260$var$stringSlice = $113e8451bf5a2260$var$uncurryThis("".slice);
var $113e8451bf5a2260$var$maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $113e8451bf5a2260$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $113e8451bf5a2260$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$113e8451bf5a2260$var$REPLACE]) return /./[$113e8451bf5a2260$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $113e8451bf5a2260$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$113e8451bf5a2260$var$fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$113e8451bf5a2260$var$fixRegExpWellKnownSymbolLogic("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $113e8451bf5a2260$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $113e8451bf5a2260$var$requireObjectCoercible(this);
            var replacer = searchValue == undefined ? undefined : $113e8451bf5a2260$var$getMethod(searchValue, $113e8451bf5a2260$var$REPLACE);
            return replacer ? $113e8451bf5a2260$var$call(replacer, searchValue, O, replaceValue) : $113e8451bf5a2260$var$call(nativeReplace, $113e8451bf5a2260$var$toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $113e8451bf5a2260$var$anObject(this);
            var S = $113e8451bf5a2260$var$toString(string);
            if (typeof replaceValue == "string" && $113e8451bf5a2260$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $113e8451bf5a2260$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $113e8451bf5a2260$var$isCallable(replaceValue);
            if (!functionalReplace) replaceValue = $113e8451bf5a2260$var$toString(replaceValue);
            var _$global = rx.global;
            if (_$global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $113e8451bf5a2260$var$regExpExec(rx, S);
                if (result === null) break;
                $113e8451bf5a2260$var$push(results, result);
                if (!_$global) break;
                var matchStr = $113e8451bf5a2260$var$toString(result[0]);
                if (matchStr === "") rx.lastIndex = $113e8451bf5a2260$var$advanceStringIndex(S, $113e8451bf5a2260$var$toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $113e8451bf5a2260$var$toString(result[0]);
                var position = $113e8451bf5a2260$var$max($113e8451bf5a2260$var$min($113e8451bf5a2260$var$toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$113e8451bf5a2260$var$push(captures, $113e8451bf5a2260$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $113e8451bf5a2260$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $113e8451bf5a2260$var$push(replacerArgs, namedCaptures);
                    var replacement = $113e8451bf5a2260$var$toString($113e8451bf5a2260$var$apply(replaceValue, undefined, replacerArgs));
                } else replacement = $113e8451bf5a2260$var$getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $113e8451bf5a2260$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $113e8451bf5a2260$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$113e8451bf5a2260$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$113e8451bf5a2260$var$REPLACE_KEEPS_$0 || $113e8451bf5a2260$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $113e8451bf5a2260$var$__awaiter(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $113e8451bf5a2260$var$icon = "data:image/png;base64,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";
var $113e8451bf5a2260$var$resolveWalletUrl = function(network, walletUrl) {
    if (walletUrl) return walletUrl;
    switch(network.networkId){
        case "mainnet":
            return "https://app.mynearwallet.com";
        case "testnet":
            return "https://testnet.mynearwallet.com";
        default:
            throw new Error("Invalid wallet url");
    }
};
var $113e8451bf5a2260$var$setupWalletState = function(params, network) {
    return $113e8451bf5a2260$var$__awaiter(void 0, void 0, void 0, function() {
        var keyStore, near, wallet;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    keyStore = new $c1be85fca55b560a$exports.keyStores.BrowserLocalStorageKeyStore();
                    return [
                        4,
                        $c1be85fca55b560a$exports.connect(Object.assign(Object.assign({
                            keyStore: keyStore,
                            walletUrl: params.walletUrl
                        }, network), {
                            headers: {}
                        }))
                    ];
                case 1:
                    near = _state.sent();
                    wallet = new $c1be85fca55b560a$exports.WalletConnection(near, "near_app");
                    return [
                        2,
                        {
                            wallet: wallet,
                            keyStore: keyStore
                        }
                    ];
            }
        });
    });
};
var $113e8451bf5a2260$var$MyNearWallet = function(param) {
    var metadata = param.metadata, options = param.options, store = param.store, params = param.params, logger = param.logger;
    return $113e8451bf5a2260$var$__awaiter(void 0, void 0, void 0, function() {
        var _state, getAccounts, transformTransactions;
        return (0, $7UAGh.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    return [
                        4,
                        $113e8451bf5a2260$var$setupWalletState(params, options.network)
                    ];
                case 1:
                    _state = _state1.sent();
                    getAccounts = function() {
                        return $113e8451bf5a2260$var$__awaiter(void 0, void 0, void 0, function() {
                            var accountId, account, publicKey;
                            return (0, $7UAGh.__generator)(this, function(_state1) {
                                switch(_state1.label){
                                    case 0:
                                        accountId = _state.wallet.getAccountId();
                                        account = _state.wallet.account();
                                        if (!accountId || !account) return [
                                            2,
                                            []
                                        ];
                                        return [
                                            4,
                                            account.connection.signer.getPublicKey(account.accountId, options.network.networkId)
                                        ];
                                    case 1:
                                        publicKey = _state1.sent();
                                        return [
                                            2,
                                            [
                                                {
                                                    accountId: accountId,
                                                    publicKey: publicKey ? publicKey.toString() : ""
                                                }
                                            ]
                                        ];
                                }
                            });
                        });
                    };
                    transformTransactions = function(transactions) {
                        return $113e8451bf5a2260$var$__awaiter(void 0, void 0, void 0, function() {
                            var account, _account_connection, networkId, signer, provider, localKey;
                            return (0, $7UAGh.__generator)(this, function(_state1) {
                                switch(_state1.label){
                                    case 0:
                                        account = _state.wallet.account();
                                        _account_connection = account.connection, networkId = _account_connection.networkId, signer = _account_connection.signer, provider = _account_connection.provider;
                                        return [
                                            4,
                                            signer.getPublicKey(account.accountId, networkId)
                                        ];
                                    case 1:
                                        localKey = _state1.sent();
                                        return [
                                            2,
                                            Promise.all(transactions.map(function(transaction, index) {
                                                return $113e8451bf5a2260$var$__awaiter(void 0, void 0, void 0, function() {
                                                    var actions, accessKey, block;
                                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                actions = transaction.actions.map(function(action) {
                                                                    return (0, $74570f29af5dbce2$export$309c7a02b0b0bc62)(action);
                                                                });
                                                                return [
                                                                    4,
                                                                    account.accessKeyForTransaction(transaction.receiverId, actions, localKey)
                                                                ];
                                                            case 1:
                                                                accessKey = _state.sent();
                                                                if (!accessKey) throw new Error("Failed to find matching key for transaction sent to ".concat(transaction.receiverId));
                                                                return [
                                                                    4,
                                                                    provider.block({
                                                                        finality: "final"
                                                                    })
                                                                ];
                                                            case 2:
                                                                block = _state.sent();
                                                                return [
                                                                    2,
                                                                    $c1be85fca55b560a$exports.transactions.createTransaction(account.accountId, $c1be85fca55b560a$exports.utils.PublicKey.from(accessKey.public_key), transaction.receiverId, accessKey.access_key.nonce + index + 1, actions, $c1be85fca55b560a$exports.utils.serialize.base_decode(block.header.hash))
                                                                ];
                                                        }
                                                    });
                                                });
                                            }))
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        2,
                        {
                            signIn: function(param) {
                                var contractId = param.contractId, methodNames = param.methodNames, successUrl = param.successUrl, failureUrl = param.failureUrl;
                                return $113e8451bf5a2260$var$__awaiter(this, void 0, void 0, function() {
                                    var existingAccounts;
                                    return (0, $7UAGh.__generator)(this, function(_state1) {
                                        switch(_state1.label){
                                            case 0:
                                                return [
                                                    4,
                                                    getAccounts()
                                                ];
                                            case 1:
                                                existingAccounts = _state1.sent();
                                                if (existingAccounts.length) return [
                                                    2,
                                                    existingAccounts
                                                ];
                                                return [
                                                    4,
                                                    _state.wallet.requestSignIn({
                                                        contractId: contractId,
                                                        methodNames: methodNames,
                                                        successUrl: successUrl,
                                                        failureUrl: failureUrl
                                                    })
                                                ];
                                            case 2:
                                                _state1.sent();
                                                return [
                                                    2,
                                                    getAccounts()
                                                ];
                                        }
                                    });
                                });
                            },
                            signOut: function() {
                                return $113e8451bf5a2260$var$__awaiter(this, void 0, void 0, function() {
                                    return (0, $7UAGh.__generator)(this, function(_state1) {
                                        if (_state.wallet.isSignedIn()) _state.wallet.signOut();
                                        return [
                                            2
                                        ];
                                    });
                                });
                            },
                            getAccounts: function() {
                                return $113e8451bf5a2260$var$__awaiter(this, void 0, void 0, function() {
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            getAccounts()
                                        ];
                                    });
                                });
                            },
                            verifyOwner: function(param) {
                                var message = param.message, callbackUrl = param.callbackUrl, meta = param.meta;
                                return $113e8451bf5a2260$var$__awaiter(this, void 0, void 0, function() {
                                    var account, locationUrl, url, encodedUrl, extraMeta;
                                    return (0, $7UAGh.__generator)(this, function(_state1) {
                                        logger.log("verifyOwner", {
                                            message: message
                                        });
                                        account = _state.wallet.account();
                                        if (!account) throw new Error("Wallet not signed in");
                                        locationUrl = typeof window !== "undefined" ? window.location.href : "";
                                        url = callbackUrl || locationUrl;
                                        if (!url) throw new Error("The callbackUrl is missing for ".concat(metadata.name));
                                        encodedUrl = encodeURIComponent(url);
                                        extraMeta = meta ? "&meta=".concat(meta) : "";
                                        window.location.replace("".concat(params.walletUrl, "/verify-owner?message=").concat(message, "&callbackUrl=").concat(encodedUrl).concat(extraMeta));
                                        return [
                                            2
                                        ];
                                    });
                                });
                            },
                            signAndSendTransaction: function(param) {
                                var signerId = param.signerId, receiverId = param.receiverId, actions = param.actions, callbackUrl = param.callbackUrl;
                                return $113e8451bf5a2260$var$__awaiter(this, void 0, void 0, function() {
                                    var contract, account;
                                    return (0, $7UAGh.__generator)(this, function(_state1) {
                                        logger.log("signAndSendTransaction", {
                                            signerId: signerId,
                                            receiverId: receiverId,
                                            actions: actions,
                                            callbackUrl: callbackUrl
                                        });
                                        contract = store.getState().contract;
                                        if (!_state.wallet.isSignedIn() || !contract) throw new Error("Wallet not signed in");
                                        account = _state.wallet.account();
                                        return [
                                            2,
                                            account["signAndSendTransaction"]({
                                                receiverId: receiverId || contract.contractId,
                                                actions: actions.map(function(action) {
                                                    return (0, $74570f29af5dbce2$export$309c7a02b0b0bc62)(action);
                                                }),
                                                walletCallbackUrl: callbackUrl
                                            })
                                        ];
                                    });
                                });
                            },
                            signAndSendTransactions: function(param) {
                                var transactions = param.transactions, callbackUrl = param.callbackUrl;
                                return $113e8451bf5a2260$var$__awaiter(this, void 0, void 0, function() {
                                    var _, _1, _tmp;
                                    return (0, $7UAGh.__generator)(this, function(_state1) {
                                        switch(_state1.label){
                                            case 0:
                                                logger.log("signAndSendTransactions", {
                                                    transactions: transactions,
                                                    callbackUrl: callbackUrl
                                                });
                                                if (!_state.wallet.isSignedIn()) throw new Error("Wallet not signed in");
                                                _1 = (_ = _state.wallet).requestSignTransactions;
                                                _tmp = {};
                                                return [
                                                    4,
                                                    transformTransactions(transactions)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _1.apply(_, [
                                                        (_tmp.transactions = _state1.sent(), _tmp.callbackUrl = callbackUrl, _tmp)
                                                    ])
                                                ];
                                        }
                                    });
                                });
                            },
                            buildImportAccountsUrl: function() {
                                return "".concat(params.walletUrl, "/batch-import");
                            }
                        }
                    ];
            }
        });
    });
};
function $113e8451bf5a2260$export$173acaf083c7f609() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, walletUrl = _ref.walletUrl, _ref_iconUrl = _ref.iconUrl, iconUrl = _ref_iconUrl === void 0 ? $113e8451bf5a2260$var$icon : _ref_iconUrl, _ref_deprecated = _ref.deprecated, deprecated = _ref_deprecated === void 0 ? false : _ref_deprecated, _ref_successUrl = _ref.successUrl, successUrl = _ref_successUrl === void 0 ? "" : _ref_successUrl, _ref_failureUrl = _ref.failureUrl, failureUrl = _ref_failureUrl === void 0 ? "" : _ref_failureUrl;
    var _this = this;
    return function() {
        return $113e8451bf5a2260$var$__awaiter(_this, void 0, void 0, function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                return [
                    2,
                    {
                        id: "my-near-wallet",
                        type: "browser",
                        metadata: {
                            name: "MyNearWallet",
                            description: "NEAR wallet to store, buy, send and stake assets for DeFi.",
                            iconUrl: iconUrl,
                            deprecated: deprecated,
                            available: true,
                            successUrl: successUrl,
                            failureUrl: failureUrl
                        },
                        init: function(options) {
                            return $113e8451bf5a2260$var$MyNearWallet(Object.assign(Object.assign({}, options), {
                                params: {
                                    walletUrl: $113e8451bf5a2260$var$resolveWalletUrl(options.options.network, walletUrl)
                                }
                            }));
                        }
                    }
                ];
            });
        });
    };
}



var $gzLuY = parcelRequire("gzLuY");
var $23137f5fd7bede4a$require$Buffer = $gzLuY.Buffer;
var $23137f5fd7bede4a$var$THIRTY_TGAS = "30000000000000";
var $23137f5fd7bede4a$var$NO_DEPOSIT = "0";
var $23137f5fd7bede4a$export$bcca3ea514774656 = /*#__PURE__*/ function() {
    "use strict";
    function Wallet(param) {
        var _param_createAccessKeyFor = param.createAccessKeyFor, createAccessKeyFor = _param_createAccessKeyFor === void 0 ? "" : _param_createAccessKeyFor, _param_network = param.network, network = _param_network === void 0 ? "testnet" : _param_network;
        (0, $978gY._)(this, Wallet);
        // Login to a wallet passing a contractId will create a local
        // key, so the user skips signing non-payable transactions.
        // Omitting the accountId will result in the user being
        // asked to sign all transactions.
        this.createAccessKeyFor = createAccessKeyFor;
        this.network = "testnet";
    }
    (0, $kry2a._)(Wallet, [
        {
            key: "startUp",
            value: // To be called when the website loads
            function startUp() {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var isSignedIn;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $f76789f9143a442d$export$f9bdc9e9de5b988e)({
                                        network: _this.network,
                                        modules: [
                                            (0, $113e8451bf5a2260$export$173acaf083c7f609)()
                                        ]
                                    })
                                ];
                            case 1:
                                _this.walletSelector = _state.sent();
                                isSignedIn = _this.walletSelector.isSignedIn();
                                if (!isSignedIn) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.walletSelector.wallet()
                                ];
                            case 2:
                                _this.wallet = _state.sent();
                                _this.accountId = _this.walletSelector.store.getState().accounts[0].accountId;
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    isSignedIn
                                ];
                        }
                    });
                })();
            }
        },
        {
            // Sign-in method
            key: "signIn",
            value: function signIn() {
                var description = "Please select a wallet to sign in.";
                var modal = (0, $2e1e297565bb5552$export$60f0f9f4cfa9469a)(this.walletSelector, {
                    contractId: this.createAccessKeyFor,
                    description: description
                });
                modal.show();
            }
        },
        {
            // Sign-out method
            key: "signOut",
            value: function signOut() {
                this.wallet.signOut();
                // @ts-ignore
                this.wallet = this.accountId = this.createAccessKeyFor = null;
                window.location.replace(window.location.origin + window.location.pathname);
            }
        },
        {
            key: "viewMethod",
            value: // Make a read-only call to retrieve information from the network
            function viewMethod(param) {
                var contractId = param.contractId, method = param.method, _param_args = param.args, args = _param_args === void 0 ? {} : _param_args;
                var _this = this;
                return (0, $byzP8._)(function() {
                    var network, provider, res;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                network = _this.walletSelector.options.network;
                                provider = new (0, $c1be85fca55b560a$exports.providers).JsonRpcProvider({
                                    url: network.nodeUrl
                                });
                                return [
                                    4,
                                    provider.query({
                                        request_type: "call_function",
                                        account_id: contractId,
                                        method_name: method,
                                        args_base64: $23137f5fd7bede4a$require$Buffer.from(JSON.stringify(args)).toString("base64"),
                                        finality: "optimistic"
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                // @ts-ignore
                                return [
                                    2,
                                    JSON.parse($23137f5fd7bede4a$require$Buffer.from(res.result).toString())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "callMethod",
            value: // Call a method that changes the contract's state
            function callMethod(param) {
                var contractId = param.contractId, method = param.method, _param_args = param.args, args = _param_args === void 0 ? {} : _param_args, _param_gas = param.gas, gas = _param_gas === void 0 ? $23137f5fd7bede4a$var$THIRTY_TGAS : _param_gas, _param_deposit = param.deposit, deposit = _param_deposit === void 0 ? $23137f5fd7bede4a$var$NO_DEPOSIT : _param_deposit;
                var _this = this;
                return (0, $byzP8._)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.wallet.signAndSendTransaction({
                                        signerId: _this.accountId,
                                        receiverId: contractId,
                                        actions: [
                                            {
                                                type: "FunctionCall",
                                                params: {
                                                    methodName: method,
                                                    args: args,
                                                    gas: gas,
                                                    deposit: deposit
                                                }
                                            }
                                        ]
                                    })
                                ];
                            case 1:
                                // Sign a transaction with the "FunctionCall" action
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactionResult",
            value: // Get transaction result from the network
            function getTransactionResult(txhash) {
                var _this = this;
                return (0, $byzP8._)(function() {
                    var network, provider, transaction;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                network = _this.walletSelector.options.network;
                                provider = new (0, $c1be85fca55b560a$exports.providers).JsonRpcProvider({
                                    url: network.nodeUrl
                                });
                                return [
                                    4,
                                    provider.txStatus(txhash, "unnused")
                                ];
                            case 1:
                                transaction = _state.sent();
                                return [
                                    2,
                                    (0, $c1be85fca55b560a$exports.providers).getTransactionLastResult(transaction)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Wallet;
}();


// const CONTRACT_ADDRESS = process.env.CONTRACT_NAME;
var $73c899650c16bd75$var$CONTRACT_ADDRESS = "dev-1688285985299-62443913276139";
// When creating the wallet you can optionally ask to create an access key
// Having the key enables to call non-payable methods without interrupting the user to sign
var $73c899650c16bd75$var$wallet = new (0, $23137f5fd7bede4a$export$bcca3ea514774656)({
    createAccessKeyFor: $73c899650c16bd75$var$CONTRACT_ADDRESS
});
// Setup on page load
window.onload = /*#__PURE__*/ (0, $byzP8._)(function() {
    var isSignedIn;
    return (0, $7UAGh.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    $73c899650c16bd75$var$wallet.startUp()
                ];
            case 1:
                isSignedIn = _state.sent();
                (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $37993afad672ebae$export$2e2bcd8739ae039), {
                    isSignedIn: isSignedIn,
                    wallet: $73c899650c16bd75$var$wallet,
                    contractId: $73c899650c16bd75$var$CONTRACT_ADDRESS
                }), document.getElementById("root"));
                return [
                    2
                ];
        }
    });
});

})();
//# sourceMappingURL=index.8bc6089a.js.map
